/**
 * Store Location Data
 * Auto-generated with geocoded coordinates
 * Contains 2227 store locations
 */

window.storeLocations = [
  {
    "Store Location": "Tractor Supply 11655 AL HWY 157 MOULTON, Alabama 35650",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-974-4009",
    "address": "11655 AL HWY 157, MOULTON, Alabama 35650",
    "city": "MOULTON",
    "state": "Alabama",
    "zip": "35650",
    "lat": 34.4840977,
    "lng": -87.27652130000001
  },
  {
    "Store Location": "Tractor Supply 1177 ANDREWS AVE STE H OZARK, Alabama 36360",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-774-1113",
    "address": "1177 ANDREWS AVE STE H, OZARK, Alabama 36360",
    "city": "OZARK",
    "state": "Alabama",
    "zip": "36360",
    "lat": 31.4480155,
    "lng": -85.65456549999999
  },
  {
    "Store Location": "Tractor Supply 119 ATCHISON DR CHELSEA, Alabama 35043",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-678-4196",
    "address": "119 ATCHISON DR, CHELSEA, Alabama 35043",
    "city": "CHELSEA",
    "state": "Alabama",
    "zip": "35043",
    "lat": 33.3495295,
    "lng": -86.637226
  },
  {
    "Store Location": "Tractor Supply 1305 BOLL WEEVIL CIR ENTERPRISE, Alabama 36330",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-347-4125",
    "address": "1305 BOLL WEEVIL CIR, ENTERPRISE, Alabama 36330",
    "city": "ENTERPRISE",
    "state": "Alabama",
    "zip": "36330",
    "lat": 31.332477,
    "lng": -85.8627431
  },
  {
    "Store Location": "Tractor Supply 1306 GILMER AVE TALLASSEE, Alabama 36078",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-252-0203",
    "address": "1306 GILMER AVE, TALLASSEE, Alabama 36078",
    "city": "TALLASSEE",
    "state": "Alabama",
    "zip": "36078",
    "lat": 32.5520558,
    "lng": -85.91727759999999
  },
  {
    "Store Location": "Tractor Supply 14001 HWY 43 STE 14 RUSSELLVILLE, Alabama 35653",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-332-5550",
    "address": "14001 HWY 43 STE 14, RUSSELLVILLE, Alabama 35653",
    "city": "RUSSELLVILLE",
    "state": "Alabama",
    "zip": "35653",
    "lat": 34.4964142,
    "lng": -87.72545559999999
  },
  {
    "Store Location": "Tractor Supply 1404 HWY 80 WEST DEMOPOLIS, Alabama 36732",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-287-3503",
    "address": "1404 HWY 80 WEST, DEMOPOLIS, Alabama 36732",
    "city": "DEMOPOLIS",
    "state": "Alabama",
    "zip": "36732",
    "lat": 32.4944113,
    "lng": -87.8550522
  },
  {
    "Store Location": "Tractor Supply 1500 MILITARY ST SOUTH STE 1 HAMILTON, Alabama 35570",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-921-1062",
    "address": "1500 MILITARY ST SOUTH STE 1, HAMILTON, Alabama 35570",
    "city": "HAMILTON",
    "state": "Alabama",
    "zip": "35570",
    "lat": 34.1220942,
    "lng": -87.9919322
  },
  {
    "Store Location": "Tractor Supply 1501 HIGHWAY 78 WEST JASPER, Alabama 35501",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-221-2200",
    "address": "1501 HIGHWAY 78 WEST, JASPER, Alabama 35501",
    "city": "JASPER",
    "state": "Alabama",
    "zip": "35501",
    "lat": 33.8482724,
    "lng": -87.2928702
  },
  {
    "Store Location": "Tractor Supply 1501 SOUTH BROAD STE A SCOTTSBORO, Alabama 35768",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-259-1460",
    "address": "1501 SOUTH BROAD STE A, SCOTTSBORO, Alabama 35768",
    "city": "SCOTTSBORO",
    "state": "Alabama",
    "zip": "35768",
    "lat": 34.65434570000001,
    "lng": -86.0333598
  },
  {
    "Store Location": "Tractor Supply 151 INTERSTATE DR GREENVILLE, Alabama 36037",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-382-1137",
    "address": "151 INTERSTATE DR, GREENVILLE, Alabama 36037",
    "city": "GREENVILLE",
    "state": "Alabama",
    "zip": "36037",
    "lat": 31.8545285,
    "lng": -86.63859320000002
  },
  {
    "Store Location": "Tractor Supply 1556 MILL SQ ALEXANDER CITY, Alabama 35010",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-329-9536",
    "address": "1556 MILL SQ ALEXANDER, CITY, Alabama 35010",
    "city": "CITY",
    "state": "Alabama",
    "zip": "35010",
    "lat": 32.9358004,
    "lng": -85.97076349999999
  },
  {
    "Store Location": "Tractor Supply 1608 2ND AVE EAST ONEONTA, Alabama 35121",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-625-5110",
    "address": "1608 2ND AVE EAST, ONEONTA, Alabama 35121",
    "city": "ONEONTA",
    "state": "Alabama",
    "zip": "35121",
    "lat": 33.9637294,
    "lng": -86.4611015
  },
  {
    "Store Location": "Tractor Supply 1616 TEMPLE AVE NORTH FAYETTE, Alabama 35555",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-932-4109",
    "address": "1616 TEMPLE AVE NORTH, FAYETTE, Alabama 35555",
    "city": "FAYETTE",
    "state": "Alabama",
    "zip": "35555",
    "lat": 33.7057956,
    "lng": -87.8239651
  },
  {
    "Store Location": "Tractor Supply 1730 DOUGLAS AVE BREWTON, Alabama 36426",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-809-1838",
    "address": "1730 DOUGLAS AVE, BREWTON, Alabama 36426",
    "city": "BREWTON",
    "state": "Alabama",
    "zip": "36426",
    "lat": 31.136715,
    "lng": -87.06757999999999
  },
  {
    "Store Location": "Tractor Supply 1731 2ND AVE SOUTHWEST CULLMAN, Alabama 35055",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-775-4445",
    "address": "1731 2ND AVE SOUTHWEST, CULLMAN, Alabama 35055",
    "city": "CULLMAN",
    "state": "Alabama",
    "zip": "35055",
    "lat": 34.156659,
    "lng": -86.8336429
  },
  {
    "Store Location": "Tractor Supply 2012 HWY 280-431 NORTH PHENIX CITY, Alabama 36867",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-291-2050",
    "address": "2012 HWY 280-431 NORTH PHENIX, CITY, Alabama 36867",
    "city": "CITY",
    "state": "Alabama",
    "zip": "36867",
    "lat": 32.4802147,
    "lng": -85.02902999999999
  },
  {
    "Store Location": "Tractor Supply 20438 STATE HWY 59 SUMMERDALE, Alabama 36580",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-989-2525",
    "address": "20438 STATE HWY 59, SUMMERDALE, Alabama 36580",
    "city": "SUMMERDALE",
    "state": "Alabama",
    "zip": "36580",
    "lat": 30.5233438,
    "lng": -87.7068922
  },
  {
    "Store Location": "Tractor Supply 2085 US HWY 431 BOAZ, Alabama 35957",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-840-8122",
    "address": "2085 US HWY 431, BOAZ, Alabama 35957",
    "city": "BOAZ",
    "state": "Alabama",
    "zip": "35957",
    "lat": 34.2031662,
    "lng": -86.15209689999999
  },
  {
    "Store Location": "Tractor Supply 232 HAYNES ST TALLADEGA, Alabama 35160",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-315-1946",
    "address": "232 HAYNES ST, TALLADEGA, Alabama 35160",
    "city": "TALLADEGA",
    "state": "Alabama",
    "zip": "35160",
    "lat": 33.4361927,
    "lng": -86.07994479999999
  },
  {
    "Store Location": "Tractor Supply 2600 PEPPERELL PKWY OPELIKA, Alabama 36801",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-737-7775",
    "address": "2600 PEPPERELL PKWY, OPELIKA, Alabama 36801",
    "city": "OPELIKA",
    "state": "Alabama",
    "zip": "36801",
    "lat": 32.6381528,
    "lng": -85.4160342
  },
  {
    "Store Location": "Tractor Supply 2626 DECATUR HWY GARDENDALE, Alabama 35071",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-631-0766",
    "address": "2626 DECATUR HWY, GARDENDALE, Alabama 35071",
    "city": "GARDENDALE",
    "state": "Alabama",
    "zip": "35071",
    "lat": 33.690935,
    "lng": -86.8203082
  },
  {
    "Store Location": "Tractor Supply 2680 US HWY 80 WEST SELMA, Alabama 36701",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-877-1440",
    "address": "2680 US HWY 80 WEST, SELMA, Alabama 36701",
    "city": "SELMA",
    "state": "Alabama",
    "zip": "36701",
    "lat": 32.4349874,
    "lng": -87.06522609999999
  },
  {
    "Store Location": "Tractor Supply 2801 FAIRGROUND RD SW DECATUR, Alabama 35603",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-308-5885",
    "address": "2801 FAIRGROUND RD SW, DECATUR, Alabama 35603",
    "city": "DECATUR",
    "state": "Alabama",
    "zip": "35603",
    "lat": 34.5583549,
    "lng": -87.00795079999999
  },
  {
    "Store Location": "Tractor Supply 2900 EAST MEIGHAN BLVD GADSDEN, Alabama 35903",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-492-2543",
    "address": "2900 EAST MEIGHAN BLVD, GADSDEN, Alabama 35903",
    "city": "GADSDEN",
    "state": "Alabama",
    "zip": "35903",
    "lat": 33.9751885,
    "lng": -85.95017399999999
  },
  {
    "Store Location": "Tractor Supply 3159 HWY 431 ROANOKE, Alabama 36274",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-863-7300",
    "address": "3159 HWY 431, ROANOKE, Alabama 36274",
    "city": "ROANOKE",
    "state": "Alabama",
    "zip": "36274",
    "lat": 32.8365989,
    "lng": -84.8436105
  },
  {
    "Store Location": "Tractor Supply 3240C MEMORIAL PKWY NORTHWEST HUNTSVILLE, Alabama 35810",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-858-9144",
    "address": "3240C MEMORIAL PKWY NORTHWEST, HUNTSVILLE, Alabama 35810",
    "city": "HUNTSVILLE",
    "state": "Alabama",
    "zip": "35810",
    "lat": 34.7671891,
    "lng": -86.5854136
  },
  {
    "Store Location": "Tractor Supply 33891 HWY 43 THOMASVILLE, Alabama 36784",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-636-4425",
    "address": "33891 HWY 43, THOMASVILLE, Alabama 36784",
    "city": "THOMASVILLE",
    "state": "Alabama",
    "zip": "36784",
    "lat": 31.9134859,
    "lng": -87.7358366
  },
  {
    "Store Location": "Tractor Supply 3400 MOODY PKWY MOODY, Alabama 35004",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-640-8000",
    "address": "3400 MOODY PKWY, MOODY, Alabama 35004",
    "city": "MOODY",
    "state": "Alabama",
    "zip": "35004",
    "lat": 33.5998737,
    "lng": -86.4802983
  },
  {
    "Store Location": "Tractor Supply 3775 WEST MAIN ST DOTHAN, Alabama 36305",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-792-8024",
    "address": "3775 WEST MAIN ST, DOTHAN, Alabama 36305",
    "city": "DOTHAN",
    "state": "Alabama",
    "zip": "36305",
    "lat": 31.2312986,
    "lng": -85.4489913
  },
  {
    "Store Location": "Tractor Supply 3791 AL HWY 14 MILLBROOK, Alabama 36054",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-290-0180",
    "address": "3791 AL HWY 14, MILLBROOK, Alabama 36054",
    "city": "MILLBROOK",
    "state": "Alabama",
    "zip": "36054",
    "lat": 32.5191964,
    "lng": -86.3727578
  },
  {
    "Store Location": "Tractor Supply 4633 HWY 25 MONTEVALLO, Alabama 35115",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-665-3247",
    "address": "4633 HWY 25, MONTEVALLO, Alabama 35115",
    "city": "MONTEVALLO",
    "state": "Alabama",
    "zip": "35115",
    "lat": 33.095612,
    "lng": -86.8539655
  },
  {
    "Store Location": "Tractor Supply 465 PIKE ST STE A MONROEVILLE, Alabama 36460",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-743-4969",
    "address": "465 PIKE ST STE A, MONROEVILLE, Alabama 36460",
    "city": "MONROEVILLE",
    "state": "Alabama",
    "zip": "36460",
    "lat": 31.51383299999999,
    "lng": -87.3182302
  },
  {
    "Store Location": "Tractor Supply 5310 TROY HWY MONTGOMERY, Alabama 36116",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-288-1453",
    "address": "5310 TROY HWY, MONTGOMERY, Alabama 36116",
    "city": "MONTGOMERY",
    "state": "Alabama",
    "zip": "36116",
    "lat": 32.3012398,
    "lng": -86.20732319999999
  },
  {
    "Store Location": "Tractor Supply 535 AVALON ST MUSCLE SHOALS, Alabama 35661",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-381-8980",
    "address": "535 AVALON ST MUSCLE, SHOALS, Alabama 35661",
    "city": "SHOALS",
    "state": "Alabama",
    "zip": "35661",
    "lat": 34.7462679,
    "lng": -87.66974859999999
  },
  {
    "Store Location": "Tractor Supply 540 WEST BYP ANDALUSIA, Alabama 36420",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-222-2328",
    "address": "540 WEST BYP, ANDALUSIA, Alabama 36420",
    "city": "ANDALUSIA",
    "state": "Alabama",
    "zip": "36420",
    "lat": 31.3048098,
    "lng": -86.5011549
  },
  {
    "Store Location": "Tractor Supply 5500 MCCLELLAN BLVD ANNISTON, Alabama 36206",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-820-3385",
    "address": "5500 MCCLELLAN BLVD, ANNISTON, Alabama 36206",
    "city": "ANNISTON",
    "state": "Alabama",
    "zip": "36206",
    "lat": 33.7182601,
    "lng": -85.8206646
  },
  {
    "Store Location": "Tractor Supply 5510 MCFARLAND BLVD STE 100 NORTHPORT, Alabama 35476",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-330-2505",
    "address": "5510 MCFARLAND BLVD STE 100, NORTHPORT, Alabama 35476",
    "city": "NORTHPORT",
    "state": "Alabama",
    "zip": "35476",
    "lat": 33.237596,
    "lng": -87.609921
  },
  {
    "Store Location": "Tractor Supply 5531 PROMENADE POINT PARKWAY NW HUNTSVILLE, Alabama 35758",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-721-5565",
    "address": "5531 PROMENADE POINT PARKWAY NW, HUNTSVILLE, Alabama 35758",
    "city": "HUNTSVILLE",
    "state": "Alabama",
    "zip": "35758",
    "lat": 34.7508662,
    "lng": -86.77614860000001
  },
  {
    "Store Location": "Tractor Supply 5618 HWY 90 WEST THEODORE, Alabama 36582",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-653-8311",
    "address": "5618 HWY 90 WEST, THEODORE, Alabama 36582",
    "city": "THEODORE",
    "state": "Alabama",
    "zip": "36582",
    "lat": 30.5713575,
    "lng": -88.1725244
  },
  {
    "Store Location": "Tractor Supply 601 PATRIOT PKWY TUSCALOOSA, Alabama 35405",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-344-6118",
    "address": "601 PATRIOT PKWY, TUSCALOOSA, Alabama 35405",
    "city": "TUSCALOOSA",
    "state": "Alabama",
    "zip": "35405",
    "lat": 33.12675979999999,
    "lng": -87.546826
  },
  {
    "Store Location": "Tractor Supply 601 US HWY 72 WEST ATHENS, Alabama 35611",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-230-6005",
    "address": "601 US HWY 72 WEST, ATHENS, Alabama 35611",
    "city": "ATHENS",
    "state": "Alabama",
    "zip": "35611",
    "lat": 34.7882207,
    "lng": -86.974453
  },
  {
    "Store Location": "Tractor Supply 635 SCHILLINGER RD NORTH MOBILE, Alabama 36608",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-639-3131",
    "address": "635 SCHILLINGER RD NORTH, MOBILE, Alabama 36608",
    "city": "MOBILE",
    "state": "Alabama",
    "zip": "36608",
    "lat": 30.7034272,
    "lng": -88.2265717
  },
  {
    "Store Location": "Tractor Supply 690 ACADEMY DR BESSEMER, Alabama 35022",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-426-9905",
    "address": "690 ACADEMY DR, BESSEMER, Alabama 35022",
    "city": "BESSEMER",
    "state": "Alabama",
    "zip": "35022",
    "lat": 33.3589998,
    "lng": -86.99736349999999
  },
  {
    "Store Location": "Tractor Supply 800 HWY 31 SOUTHWEST STE N HARTSELLE, Alabama 35640",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-751-5917",
    "address": "800 HWY 31 SOUTHWEST STE N, HARTSELLE, Alabama 35640",
    "city": "HARTSELLE",
    "state": "Alabama",
    "zip": "35640",
    "lat": 34.4372966,
    "lng": -86.93788029999999
  },
  {
    "Store Location": "Tractor Supply 803 MARTIN ST SOUTH PELL CITY, Alabama 35128",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-814-0000",
    "address": "803 MARTIN ST SOUTH PELL, CITY, Alabama 35128",
    "city": "CITY",
    "state": "Alabama",
    "zip": "35128",
    "lat": 33.5798359,
    "lng": -86.27759259999999
  },
  {
    "Store Location": "Tractor Supply 811 SOUTH GILMER AVENUE LANETT, Alabama 36863",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-623-0101",
    "address": "811 SOUTH GILMER AVENUE, LANETT, Alabama 36863",
    "city": "LANETT",
    "state": "Alabama",
    "zip": "36863",
    "lat": 32.8611108,
    "lng": -85.1891716
  },
  {
    "Store Location": "Tractor Supply 851 US HIGHWAY 98 DAPHNE, Alabama 36526",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-626-6666",
    "address": "851 US HIGHWAY 98, DAPHNE, Alabama 36526",
    "city": "DAPHNE",
    "state": "Alabama",
    "zip": "36526",
    "lat": 30.588251,
    "lng": -87.89886399999999
  },
  {
    "Store Location": "Tractor Supply 880 CHESNUT BYPASS CENTRE, Alabama 35960",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-447-5525",
    "address": "880 CHESNUT BYPASS, CENTRE, Alabama 35960",
    "city": "CENTRE",
    "state": "Alabama",
    "zip": "35960",
    "lat": 34.1632027,
    "lng": -85.68982779999999
  },
  {
    "Store Location": "Tractor Supply 101 SOUTH POPLAR ST SEARCY, Arkansas 72143",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-279-0077",
    "address": "101 SOUTH POPLAR ST, SEARCY, Arkansas 72143",
    "city": "SEARCY",
    "state": "Arkansas",
    "zip": "72143",
    "lat": 35.2468781,
    "lng": -91.6928888
  },
  {
    "Store Location": "Tractor Supply 1030 SOUTH CONSTITUTION AVE ASHDOWN, Arkansas 71822",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-898-3633",
    "address": "1030 SOUTH CONSTITUTION AVE, ASHDOWN, Arkansas 71822",
    "city": "ASHDOWN",
    "state": "Arkansas",
    "zip": "71822",
    "lat": 33.66168529999999,
    "lng": -94.11739779999999
  },
  {
    "Store Location": "Tractor Supply 10801 COLONEL GLENN SQ LITTLE ROCK, Arkansas 72204",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-954-7451",
    "address": "10801 COLONEL GLENN SQ LITTLE, ROCK, Arkansas 72204",
    "city": "ROCK",
    "state": "Arkansas",
    "zip": "72204",
    "lat": 34.7097111,
    "lng": -92.39700739999999
  },
  {
    "Store Location": "Tractor Supply 150 SANDSTONE DR VAN BUREN, Arkansas 72956",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-471-1684",
    "address": "150 SANDSTONE DR VAN, BUREN, Arkansas 72956",
    "city": "BUREN",
    "state": "Arkansas",
    "zip": "72956",
    "lat": 35.4729993,
    "lng": -94.3580818
  },
  {
    "Store Location": "Tractor Supply 1555 EAST MAIN ST SUITE A BOONEVILLE, Arkansas 72927",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-675-2722",
    "address": "1555 EAST MAIN ST SUITE A, BOONEVILLE, Arkansas 72927",
    "city": "BOONEVILLE",
    "state": "Arkansas",
    "zip": "72927",
    "lat": 35.1431732,
    "lng": -93.90190120000001
  },
  {
    "Store Location": "Tractor Supply 1590 FALLS BLVD NORTH WYNNE, Arkansas 72396",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-238-3848",
    "address": "1590 FALLS BLVD NORTH, WYNNE, Arkansas 72396",
    "city": "WYNNE",
    "state": "Arkansas",
    "zip": "72396",
    "lat": 35.2365426,
    "lng": -90.7832603
  },
  {
    "Store Location": "Tractor Supply 17318 I-30 NORTH BENTON, Arkansas 72019",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-778-2685",
    "address": "17318 I-30 NORTH, BENTON, Arkansas 72019",
    "city": "BENTON",
    "state": "Arkansas",
    "zip": "72019",
    "lat": 34.5814016,
    "lng": -92.581488
  },
  {
    "Store Location": "Tractor Supply 210 HWY 65 SOUTH CLINTON, Arkansas 72031",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-745-8888",
    "address": "210 HWY 65 SOUTH, CLINTON, Arkansas 72031",
    "city": "CLINTON",
    "state": "Arkansas",
    "zip": "72031",
    "lat": 35.590973,
    "lng": -92.45528399999999
  },
  {
    "Store Location": "Tractor Supply 2100 WEST SERVICE RD WEST MEMPHIS, Arkansas 72301",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-735-5841",
    "address": "2100 WEST SERVICE RD WEST, MEMPHIS, Arkansas 72301",
    "city": "MEMPHIS",
    "state": "Arkansas",
    "zip": "72301",
    "lat": 35.1593153,
    "lng": -90.2209699
  },
  {
    "Store Location": "Tractor Supply 215 EAST MAIN ST FARMINGTON, Arkansas 72730",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-267-0520",
    "address": "215 EAST MAIN ST, FARMINGTON, Arkansas 72730",
    "city": "FARMINGTON",
    "state": "Arkansas",
    "zip": "72730",
    "lat": 36.0436833,
    "lng": -94.23074810000001
  },
  {
    "Store Location": "Tractor Supply 215 EAST PAGE AVE MALVERN, Arkansas 72104",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-467-3353",
    "address": "215 EAST PAGE AVE, MALVERN, Arkansas 72104",
    "city": "MALVERN",
    "state": "Arkansas",
    "zip": "72104",
    "lat": 34.3629407,
    "lng": -92.8102488
  },
  {
    "Store Location": "Tractor Supply 2280 SANDERS RD CONWAY, Arkansas 72032",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-764-4900",
    "address": "2280 SANDERS RD, CONWAY, Arkansas 72032",
    "city": "CONWAY",
    "state": "Arkansas",
    "zip": "72032",
    "lat": 35.1080985,
    "lng": -92.43377799999999
  },
  {
    "Store Location": "Tractor Supply 2307 ALBERT PIKE RD HOT SPRINGS, Arkansas 71913",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-767-1220",
    "address": "2307 ALBERT PIKE RD HOT, SPRINGS, Arkansas 71913",
    "city": "SPRINGS",
    "state": "Arkansas",
    "zip": "71913",
    "lat": 34.4912025,
    "lng": -93.1060126
  },
  {
    "Store Location": "Tractor Supply 2307 NORTH HWY 63 STUTTGART, Arkansas 72160",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-672-7226",
    "address": "2307 NORTH HWY 63, STUTTGART, Arkansas 72160",
    "city": "STUTTGART",
    "state": "Arkansas",
    "zip": "72160",
    "lat": 34.5315729,
    "lng": -91.5582806
  },
  {
    "Store Location": "Tractor Supply 2500 MALCOLM AVE STE A NEWPORT, Arkansas 72112",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-217-0331",
    "address": "2500 MALCOLM AVE STE A, NEWPORT, Arkansas 72112",
    "city": "NEWPORT",
    "state": "Arkansas",
    "zip": "72112",
    "lat": 35.6074506,
    "lng": -91.2499237
  },
  {
    "Store Location": "Tractor Supply 2605 RED WOLF BLVD JONESBORO, Arkansas 72401",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-935-4601",
    "address": "2605 RED WOLF BLVD, JONESBORO, Arkansas 72401",
    "city": "JONESBORO",
    "state": "Arkansas",
    "zip": "72401",
    "lat": 35.8132687,
    "lng": -90.66996689999999
  },
  {
    "Store Location": "Tractor Supply 2815 WEST CENTER ST GREENWOOD, Arkansas 72936",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-996-0607",
    "address": "2815 WEST CENTER ST, GREENWOOD, Arkansas 72936",
    "city": "GREENWOOD",
    "state": "Arkansas",
    "zip": "72936",
    "lat": 35.2228696,
    "lng": -94.3027728
  },
  {
    "Store Location": "Tractor Supply 2817 SOUTH WALTON BLVD BENTONVILLE, Arkansas 72712",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-273-9111",
    "address": "2817 SOUTH WALTON BLVD, BENTONVILLE, Arkansas 72712",
    "city": "BENTONVILLE",
    "state": "Arkansas",
    "zip": "72712",
    "lat": 36.34345,
    "lng": -94.2099437
  },
  {
    "Store Location": "Tractor Supply 320 NORTH HAMPTON AVE RUSSELLVILLE, Arkansas 72802",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-890-9800",
    "address": "320 NORTH HAMPTON AVE, RUSSELLVILLE, Arkansas 72802",
    "city": "RUSSELLVILLE",
    "state": "Arkansas",
    "zip": "72802",
    "lat": 35.2812062,
    "lng": -93.0984244
  },
  {
    "Store Location": "Tractor Supply 3239 HARRISON ST BATESVILLE, Arkansas 72501",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-698-0422",
    "address": "3239 HARRISON ST, BATESVILLE, Arkansas 72501",
    "city": "BATESVILLE",
    "state": "Arkansas",
    "zip": "72501",
    "lat": 35.7686979,
    "lng": -91.6115086
  },
  {
    "Store Location": "Tractor Supply 3400 WEST KINGSHIGHWAY PARAGOULD, Arkansas 72450",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-240-8848",
    "address": "3400 WEST KINGSHIGHWAY, PARAGOULD, Arkansas 72450",
    "city": "PARAGOULD",
    "state": "Arkansas",
    "zip": "72450",
    "lat": 36.0584208,
    "lng": -90.53251619999999
  },
  {
    "Store Location": "Tractor Supply 3480 HWY 412 EAST SILOAM SPRINGS, Arkansas 72761",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-524-1811",
    "address": "3480 HWY 412 EAST SILOAM, SPRINGS, Arkansas 72761",
    "city": "SPRINGS",
    "state": "Arkansas",
    "zip": "72761",
    "lat": 36.1798497,
    "lng": -94.5088147
  },
  {
    "Store Location": "Tractor Supply 3900 EAST MAIN ST BLYTHEVILLE, Arkansas 72315",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-762-7787",
    "address": "3900 EAST MAIN ST, BLYTHEVILLE, Arkansas 72315",
    "city": "BLYTHEVILLE",
    "state": "Arkansas",
    "zip": "72315",
    "lat": 35.9302432,
    "lng": -89.86654829999999
  },
  {
    "Store Location": "Tractor Supply 4355 EAST ROBINSON AVE SPRINGDALE, Arkansas 72764",
    "Store Type": "Tractor Supply",
    "Phone Number": "479-750-0950",
    "address": "4355 EAST ROBINSON AVE, SPRINGDALE, Arkansas 72764",
    "city": "SPRINGDALE",
    "state": "Arkansas",
    "zip": "72764",
    "lat": 36.1619564,
    "lng": -94.0828315
  },
  {
    "Store Location": "Tractor Supply 501 SOUTH 7TH STREET HEBER SPRINGS, Arkansas 72543",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-206-0700",
    "address": "501 SOUTH 7TH STREET HEBER, SPRINGS, Arkansas 72543",
    "city": "SPRINGS",
    "state": "Arkansas",
    "zip": "72543",
    "lat": 35.4875238,
    "lng": -92.0357652
  },
  {
    "Store Location": "Tractor Supply 5470 LANDERS RD NORTH LITTLE ROCK, Arkansas 72117",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-945-2906",
    "address": "5470 LANDERS RD NORTH LITTLE, ROCK, Arkansas 72117",
    "city": "ROCK",
    "state": "Arkansas",
    "zip": "72117",
    "lat": 34.8026501,
    "lng": -92.2114467
  },
  {
    "Store Location": "Tractor Supply 619 HWY 62/65 NORTH HARRISON, Arkansas 72601",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-741-0535",
    "address": "619 HWY 62/65 NORTH, HARRISON, Arkansas 72601",
    "city": "HARRISON",
    "state": "Arkansas",
    "zip": "72601",
    "lat": 36.2500185,
    "lng": -93.11595349999999
  },
  {
    "Store Location": "Tractor Supply 6903 SHERIDAN RD WHITE HALL, Arkansas 71602",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-247-7604",
    "address": "6903 SHERIDAN RD WHITE, HALL, Arkansas 71602",
    "city": "HALL",
    "state": "Arkansas",
    "zip": "71602",
    "lat": 34.2555334,
    "lng": -92.08671629999999
  },
  {
    "Store Location": "Tractor Supply 708A EAST COLLIN RAYE DR DE QUEEN, Arkansas 71832",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-642-2147",
    "address": "708A EAST COLLIN RAYE DR DE, QUEEN, Arkansas 71832",
    "city": "QUEEN",
    "state": "Arkansas",
    "zip": "71832",
    "lat": 34.044277,
    "lng": -94.33067299999999
  },
  {
    "Store Location": "Tractor Supply 814 HWY 67 NORTH WALNUT RIDGE, Arkansas 72476",
    "Store Type": "Tractor Supply",
    "Phone Number": "870-886-2828",
    "address": "814 HWY 67 NORTH WALNUT, RIDGE, Arkansas 72476",
    "city": "RIDGE",
    "state": "Arkansas",
    "zip": "72476",
    "lat": 33.1356473,
    "lng": -96.0734819
  },
  {
    "Store Location": "Tractor Supply 906 SOUTH PINE STREET SUITE 4C CABOT, Arkansas 72023",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-605-0213",
    "address": "906 SOUTH PINE STREET SUITE 4C, CABOT, Arkansas 72023",
    "city": "CABOT",
    "state": "Arkansas",
    "zip": "72023",
    "lat": 34.9573514,
    "lng": -92.0097241
  },
  {
    "Store Location": "Tractor Supply 944 HWY 287 MORRILTON, Arkansas 72110",
    "Store Type": "Tractor Supply",
    "Phone Number": "501-477-2220",
    "address": "944 HWY 287, MORRILTON, Arkansas 72110",
    "city": "MORRILTON",
    "state": "Arkansas",
    "zip": "72110",
    "lat": 35.1342547,
    "lng": -92.2667707
  },
  {
    "Store Location": "Tractor Supply 10545 EAST MAIN ST APACHE JUNCTION, Arizona 85120",
    "Store Type": "Tractor Supply",
    "Phone Number": "480-986-0848",
    "address": "10545 EAST MAIN ST APACHE, JUNCTION, Arizona 85120",
    "city": "JUNCTION",
    "state": "Arizona",
    "zip": "85120",
    "lat": 33.4143584,
    "lng": -111.6043111
  },
  {
    "Store Location": "Tractor Supply 10637 EAST SOUTH FRONTAGE RD YUMA, Arizona 85365",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-342-7575",
    "address": "10637 EAST SOUTH FRONTAGE RD, YUMA, Arizona 85365",
    "city": "YUMA",
    "state": "Arizona",
    "zip": "85365",
    "lat": 32.6701155,
    "lng": -114.473489
  },
  {
    "Store Location": "Tractor Supply 1521 NAVAJO BLVD HOLBROOK, Arizona 86025",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-524-1032",
    "address": "1521 NAVAJO BLVD, HOLBROOK, Arizona 86025",
    "city": "HOLBROOK",
    "state": "Arizona",
    "zip": "86025",
    "lat": 34.9189179,
    "lng": -110.1531125
  },
  {
    "Store Location": "Tractor Supply 15884 NORTH ORACLE RD TUCSON, Arizona 85739",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-825-5715",
    "address": "15884 NORTH ORACLE RD, TUCSON, Arizona 85739",
    "city": "TUCSON",
    "state": "Arizona",
    "zip": "85739",
    "lat": 32.4942164,
    "lng": -110.9243019
  },
  {
    "Store Location": "Tractor Supply 17130 EAST SHEA BLVD FOUNTAIN HILLS, Arizona 85268",
    "Store Type": "Tractor Supply",
    "Phone Number": "480-837-2060",
    "address": "17130 EAST SHEA BLVD FOUNTAIN, HILLS, Arizona 85268",
    "city": "HILLS",
    "state": "Arizona",
    "zip": "85268",
    "lat": 33.5708624,
    "lng": -111.7108815
  },
  {
    "Store Location": "Tractor Supply 1715 WEST VALENCIA RD TUCSON, Arizona 85746",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-295-2955",
    "address": "1715 WEST VALENCIA RD, TUCSON, Arizona 85746",
    "city": "TUCSON",
    "state": "Arizona",
    "zip": "85746",
    "lat": 32.1321515,
    "lng": -111.0021703
  },
  {
    "Store Location": "Tractor Supply 1860 WEST WICKENBURG WAY WICKENBURG, Arizona 85390",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-684-8737",
    "address": "1860 WEST WICKENBURG WAY, WICKENBURG, Arizona 85390",
    "city": "WICKENBURG",
    "state": "Arizona",
    "zip": "85390",
    "lat": 33.9631243,
    "lng": -112.7685133
  },
  {
    "Store Location": "Tractor Supply 1988 EAST FLORENCE BLVD CASA GRANDE, Arizona 85122",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-836-7805",
    "address": "1988 EAST FLORENCE BLVD CASA, GRANDE, Arizona 85122",
    "city": "GRANDE",
    "state": "Arizona",
    "zip": "85122",
    "lat": 32.8809431,
    "lng": -111.7018894
  },
  {
    "Store Location": "Tractor Supply 2020 EAST RTE 66 FLAGSTAFF, Arizona 86004",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-774-3622",
    "address": "2020 EAST RTE 66, FLAGSTAFF, Arizona 86004",
    "city": "FLAGSTAFF",
    "state": "Arizona",
    "zip": "86004",
    "lat": 35.2010421,
    "lng": -111.6186186
  },
  {
    "Store Location": "Tractor Supply 215 WEST 9TH ST DOUGLAS, Arizona 85607",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-364-6181",
    "address": "215 WEST 9TH ST, DOUGLAS, Arizona 85607",
    "city": "DOUGLAS",
    "state": "Arizona",
    "zip": "85607",
    "lat": 31.3425067,
    "lng": -109.5672383
  },
  {
    "Store Location": "Tractor Supply 2165 NORTH GRAND AVE NOGALES, Arizona 85621",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-377-2720",
    "address": "2165 NORTH GRAND AVE, NOGALES, Arizona 85621",
    "city": "NOGALES",
    "state": "Arizona",
    "zip": "85621",
    "lat": 31.3718146,
    "lng": -110.9336673
  },
  {
    "Store Location": "Tractor Supply 2221 WEST 32ND ST YUMA, Arizona 85364",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-726-9920",
    "address": "2221 WEST 32ND ST, YUMA, Arizona 85364",
    "city": "YUMA",
    "state": "Arizona",
    "zip": "85364",
    "lat": 32.66823350000001,
    "lng": -114.6468552
  },
  {
    "Store Location": "Tractor Supply 2260 WEST HWY 60 MIAMI, Arizona 85539",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-425-8109",
    "address": "2260 WEST HWY 60, MIAMI, Arizona 85539",
    "city": "MIAMI",
    "state": "Arizona",
    "zip": "85539",
    "lat": 33.4147551,
    "lng": -110.8263298
  },
  {
    "Store Location": "Tractor Supply 2411 WEST US HWY 70 THATCHER, Arizona 85552",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-428-8062",
    "address": "2411 WEST US HWY 70, THATCHER, Arizona 85552",
    "city": "THATCHER",
    "state": "Arizona",
    "zip": "85552",
    "lat": 32.8404481,
    "lng": -109.7403172
  },
  {
    "Store Location": "Tractor Supply 24930 SOUTH ELLSWORTH RD QUEEN CREEK, Arizona 85142",
    "Store Type": "Tractor Supply",
    "Phone Number": "480-888-9559",
    "address": "24930 SOUTH ELLSWORTH RD QUEEN, CREEK, Arizona 85142",
    "city": "CREEK",
    "state": "Arizona",
    "zip": "85142",
    "lat": 33.2220545,
    "lng": -111.6360861
  },
  {
    "Store Location": "Tractor Supply 2555 SOUTH MILLER RD BUCKEYE, Arizona 85326",
    "Store Type": "Tractor Supply",
    "Phone Number": "623-386-3208",
    "address": "2555 SOUTH MILLER RD, BUCKEYE, Arizona 85326",
    "city": "BUCKEYE",
    "state": "Arizona",
    "zip": "85326",
    "lat": 33.4230927,
    "lng": -112.5896747
  },
  {
    "Store Location": "Tractor Supply 25606 SOUTH ARIZONA AVE CHANDLER, Arizona 85248",
    "Store Type": "Tractor Supply",
    "Phone Number": "480-895-7400",
    "address": "25606 SOUTH ARIZONA AVE, CHANDLER, Arizona 85248",
    "city": "CHANDLER",
    "state": "Arizona",
    "zip": "85248",
    "lat": 33.2145817,
    "lng": -111.8423633
  },
  {
    "Store Location": "Tractor Supply 3136-A NORTH STOCKTON HILL RD KINGMAN, Arizona 86401",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-753-1503",
    "address": "3136-A NORTH STOCKTON HILL RD, KINGMAN, Arizona 86401",
    "city": "KINGMAN",
    "state": "Arizona",
    "zip": "86401",
    "lat": 35.21456939999999,
    "lng": -114.0340271
  },
  {
    "Store Location": "Tractor Supply 3200 HWY 95 NORTH LAKE HAVASU CITY, Arizona 86404",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-505-9103",
    "address": "3200 HWY 95 NORTH LAKE HAVASU, CITY, Arizona 86404",
    "city": "CITY",
    "state": "Arizona",
    "zip": "86404",
    "lat": 34.3075895,
    "lng": -114.6523561
  },
  {
    "Store Location": "Tractor Supply 3301 WILLOW CREEK RD PRESCOTT, Arizona 86301",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-778-0942",
    "address": "3301 WILLOW CREEK RD, PRESCOTT, Arizona 86301",
    "city": "PRESCOTT",
    "state": "Arizona",
    "zip": "86301",
    "lat": 34.6063649,
    "lng": -112.4509397
  },
  {
    "Store Location": "Tractor Supply 34350 NORTH CAVE CREEK RD BUILDING A CAVE CREEK, Arizona 85331",
    "Store Type": "Tractor Supply",
    "Phone Number": "480-488-9551",
    "address": "34350 NORTH CAVE CREEK RD BUILDING A CAVE, CREEK, Arizona 85331",
    "city": "CREEK",
    "state": "Arizona",
    "zip": "85331",
    "lat": 33.7968548,
    "lng": -111.9664509
  },
  {
    "Store Location": "Tractor Supply 350 SOUTH OCOTILLO AVE BENSON, Arizona 85602",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-586-4378",
    "address": "350 SOUTH OCOTILLO AVE, BENSON, Arizona 85602",
    "city": "BENSON",
    "state": "Arizona",
    "zip": "85602",
    "lat": 31.9668246,
    "lng": -110.3082613
  },
  {
    "Store Location": "Tractor Supply 3801 SOUTH WHITE MOUNTAIN RD SHOW LOW, Arizona 85901",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-532-5232",
    "address": "3801 SOUTH WHITE MOUNTAIN RD SHOW, LOW, Arizona 85901",
    "city": "LOW",
    "state": "Arizona",
    "zip": "85901",
    "lat": 34.2149001,
    "lng": -110.0274399
  },
  {
    "Store Location": "Tractor Supply 4860 EAST HWY 90 SIERRA VISTA, Arizona 85635",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-458-1545",
    "address": "4860 EAST HWY 90 SIERRA, VISTA, Arizona 85635",
    "city": "VISTA",
    "state": "Arizona",
    "zip": "85635",
    "lat": 31.5537752,
    "lng": -110.2478233
  },
  {
    "Store Location": "Tractor Supply 510 EAST STATE HWY 260 PAYSON, Arizona 85541",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-474-2829",
    "address": "510 EAST STATE HWY 260, PAYSON, Arizona 85541",
    "city": "PAYSON",
    "state": "Arizona",
    "zip": "85541",
    "lat": 34.242238,
    "lng": -111.3156072
  },
  {
    "Store Location": "Tractor Supply 685 WEST STATE RTE 89A COTTONWOOD, Arizona 86326",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-634-0911",
    "address": "685 WEST STATE RTE 89A, COTTONWOOD, Arizona 86326",
    "city": "COTTONWOOD",
    "state": "Arizona",
    "zip": "86326",
    "lat": 34.7371584,
    "lng": -112.0358069
  },
  {
    "Store Location": "Tractor Supply 75 NORTH ABREGO DR GREEN VALLEY, Arizona 85614",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-399-1010",
    "address": "75 NORTH ABREGO DR GREEN, VALLEY, Arizona 85614",
    "city": "VALLEY",
    "state": "Arizona",
    "zip": "85614",
    "lat": 31.8717416,
    "lng": -110.9891305
  },
  {
    "Store Location": "Tractor Supply 7735 NORTH CASA GRANDE HWY TUCSON, Arizona 85743",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-579-4303",
    "address": "7735 NORTH CASA GRANDE HWY, TUCSON, Arizona 85743",
    "city": "TUCSON",
    "state": "Arizona",
    "zip": "85743",
    "lat": 32.3470831,
    "lng": -111.078875
  },
  {
    "Store Location": "Tractor Supply 789 NORTH 99TH AVE TOLLESON, Arizona 85353",
    "Store Type": "Tractor Supply",
    "Phone Number": "623-478-5439",
    "address": "789 NORTH 99TH AVE, TOLLESON, Arizona 85353",
    "city": "TOLLESON",
    "state": "Arizona",
    "zip": "85353",
    "lat": 33.4545259,
    "lng": -112.2712807
  },
  {
    "Store Location": "Tractor Supply 8740 EAST EASTRIDGE DR PRESCOTT VALLEY, Arizona 86314",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-772-5579",
    "address": "8740 EAST EASTRIDGE DR PRESCOTT, VALLEY, Arizona 86314",
    "city": "VALLEY",
    "state": "Arizona",
    "zip": "86314",
    "lat": 34.5835204,
    "lng": -112.3136385
  },
  {
    "Store Location": "Tractor Supply 950 NORTH ARIZONA BLVD COOLIDGE, Arizona 85128",
    "Store Type": "Tractor Supply",
    "Phone Number": "520-723-4445",
    "address": "950 NORTH ARIZONA BLVD, COOLIDGE, Arizona 85128",
    "city": "COOLIDGE",
    "state": "Arizona",
    "zip": "85128",
    "lat": 32.9865865,
    "lng": -111.5256733
  },
  {
    "Store Location": "Tractor Supply 967 HANCOCK RD STE 5 BULLHEAD CITY, Arizona 86442",
    "Store Type": "Tractor Supply",
    "Phone Number": "928-444-1033",
    "address": "967 HANCOCK RD STE 5 BULLHEAD, CITY, Arizona 86442",
    "city": "CITY",
    "state": "Arizona",
    "zip": "86442",
    "lat": 35.1089788,
    "lng": -114.6152025
  },
  {
    "Store Location": "Tractor Supply 1000 AMERICAN WAY WINDSOR, California 95492",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-837-7951",
    "address": "1000 AMERICAN WAY, WINDSOR, California 95492",
    "city": "WINDSOR",
    "state": "California",
    "zip": "95492",
    "lat": 38.5292773,
    "lng": -122.7984874
  },
  {
    "Store Location": "Tractor Supply 1000 RIVER RANCH FORTUNA, California 95540",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-726-7864",
    "address": "1000 RIVER RANCH, FORTUNA, California 95540",
    "city": "FORTUNA",
    "state": "California",
    "zip": "95540",
    "lat": 40.583645,
    "lng": -124.1555834
  },
  {
    "Store Location": "Tractor Supply 10520 TWIN CITIES RD GALT, California 95632",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-745-3175",
    "address": "10520 TWIN CITIES RD, GALT, California 95632",
    "city": "GALT",
    "state": "California",
    "zip": "95632",
    "lat": 38.2903054,
    "lng": -121.3005615
  },
  {
    "Store Location": "Tractor Supply 1060 CALIMESA BLVD CALIMESA, California 92320",
    "Store Type": "Tractor Supply",
    "Phone Number": "909-446-0656",
    "address": "1060 CALIMESA BLVD, CALIMESA, California 92320",
    "city": "CALIMESA",
    "state": "California",
    "zip": "92320",
    "lat": 33.9987041,
    "lng": -117.0609278
  },
  {
    "Store Location": "Tractor Supply 1120 WEST EL MONTE WAY DINUBA, California 93618",
    "Store Type": "Tractor Supply",
    "Phone Number": "559-595-9289",
    "address": "1120 WEST EL MONTE WAY, DINUBA, California 93618",
    "city": "DINUBA",
    "state": "California",
    "zip": "93618",
    "lat": 36.5452195,
    "lng": -119.4077485
  },
  {
    "Store Location": "Tractor Supply 1131 WEST PACHECO BLVD LOS BANOS, California 93635",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-827-0283",
    "address": "1131 WEST PACHECO BLVD LOS, BANOS, California 93635",
    "city": "BANOS",
    "state": "California",
    "zip": "93635",
    "lat": 37.0552273,
    "lng": -120.8704753
  },
  {
    "Store Location": "Tractor Supply 120 TANK FARM RD SAN LUIS OBISPO, California 93401",
    "Store Type": "Tractor Supply",
    "Phone Number": "805-595-1055",
    "address": "120 TANK FARM RD SAN LUIS, OBISPO, California 93401",
    "city": "OBISPO",
    "state": "California",
    "zip": "93401",
    "lat": 35.2473946,
    "lng": -120.6715849
  },
  {
    "Store Location": "Tractor Supply 120 YUBA RIVER COURT GRASS VALLEY, California 95945",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-477-7909",
    "address": "120 YUBA RIVER COURT GRASS, VALLEY, California 95945",
    "city": "VALLEY",
    "state": "California",
    "zip": "95945",
    "lat": 39.24219069999999,
    "lng": -121.0361684
  },
  {
    "Store Location": "Tractor Supply 1248 AIRPORT PARK BLVD UKIAH, California 95482",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-462-3748",
    "address": "1248 AIRPORT PARK BLVD, UKIAH, California 95482",
    "city": "UKIAH",
    "state": "California",
    "zip": "95482",
    "lat": 39.12973789999999,
    "lng": -123.1992351
  },
  {
    "Store Location": "Tractor Supply 12543 MAIN ST HESPERIA, California 92345",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-949-1133",
    "address": "12543 MAIN ST, HESPERIA, California 92345",
    "city": "HESPERIA",
    "state": "California",
    "zip": "92345",
    "lat": 34.4258796,
    "lng": -117.3896743
  },
  {
    "Store Location": "Tractor Supply 1360 BROADWAY PLACERVILLE, California 95667",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-621-9936",
    "address": "1360 BROADWAY, PLACERVILLE, California 95667",
    "city": "PLACERVILLE",
    "state": "California",
    "zip": "95667",
    "lat": 38.7316078,
    "lng": -120.7804633
  },
  {
    "Store Location": "Tractor Supply 1390 EAST MAIN ST WOODLAND, California 95776",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-662-7780",
    "address": "1390 EAST MAIN ST, WOODLAND, California 95776",
    "city": "WOODLAND",
    "state": "California",
    "zip": "95776",
    "lat": 38.6759821,
    "lng": -121.7568565
  },
  {
    "Store Location": "Tractor Supply 14140 OLDE HWY 80 EL CAJON, California 92021",
    "Store Type": "Tractor Supply",
    "Phone Number": "619-561-1230",
    "address": "14140 OLDE HWY 80 EL, CAJON, California 92021",
    "city": "CAJON",
    "state": "California",
    "zip": "92021",
    "lat": 32.844677,
    "lng": -116.878243
  },
  {
    "Store Location": "Tractor Supply 142 ROBS WAY SUSANVILLE, California 96130",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-257-1222",
    "address": "142 ROBS WAY, SUSANVILLE, California 96130",
    "city": "SUSANVILLE",
    "state": "California",
    "zip": "96130",
    "lat": 40.411415,
    "lng": -120.6395664
  },
  {
    "Store Location": "Tractor Supply 1455 SOUTH MAIN ST YREKA, California 96097",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-842-5465",
    "address": "1455 SOUTH MAIN ST, YREKA, California 96097",
    "city": "YREKA",
    "state": "California",
    "zip": "96097",
    "lat": 41.7128381,
    "lng": -122.6421435
  },
  {
    "Store Location": "Tractor Supply 14879 MONO WAY SONORA, California 95370",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-533-4840",
    "address": "14879 MONO WAY, SONORA, California 95370",
    "city": "SONORA",
    "state": "California",
    "zip": "95370",
    "lat": 37.9767093,
    "lng": -120.3174399
  },
  {
    "Store Location": "Tractor Supply 1565 COUNTRY CLUB DR MADERA, California 93638",
    "Store Type": "Tractor Supply",
    "Phone Number": "559-661-4150",
    "address": "1565 COUNTRY CLUB DR, MADERA, California 93638",
    "city": "MADERA",
    "state": "California",
    "zip": "93638",
    "lat": 36.9817881,
    "lng": -120.0731978
  },
  {
    "Store Location": "Tractor Supply 1580 EAST F ST OAKDALE, California 95361",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-845-2402",
    "address": "1580 EAST F ST, OAKDALE, California 95361",
    "city": "OAKDALE",
    "state": "California",
    "zip": "95361",
    "lat": 37.7747659,
    "lng": -120.829705
  },
  {
    "Store Location": "Tractor Supply 15930 DAM RD UNIT C CLEARLAKE, California 95422",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-995-5060",
    "address": "15930 DAM RD UNIT C, CLEARLAKE, California 95422",
    "city": "CLEARLAKE",
    "state": "California",
    "zip": "95422",
    "lat": 38.9294898,
    "lng": -122.6156225
  },
  {
    "Store Location": "Tractor Supply 1625 WEST HAYDEN AVE HANFORD, California 93230",
    "Store Type": "Tractor Supply",
    "Phone Number": "559-589-9827",
    "address": "1625 WEST HAYDEN AVE, HANFORD, California 93230",
    "city": "HANFORD",
    "state": "California",
    "zip": "93230",
    "lat": 36.3150238,
    "lng": -119.6712764
  },
  {
    "Store Location": "Tractor Supply 1630 HERNDON AVE CLOVIS, California 93611",
    "Store Type": "Tractor Supply",
    "Phone Number": "559-298-1496",
    "address": "1630 HERNDON AVE, CLOVIS, California 93611",
    "city": "CLOVIS",
    "state": "California",
    "zip": "93611",
    "lat": 36.83579599999999,
    "lng": -119.6856557
  },
  {
    "Store Location": "Tractor Supply 16904 WEST SIERRA HWY CANYON COUNTRY, California 91351",
    "Store Type": "Tractor Supply",
    "Phone Number": "661-252-1656",
    "address": "16904 WEST SIERRA HWY CANYON, COUNTRY, California 91351",
    "city": "COUNTRY",
    "state": "California",
    "zip": "91351",
    "lat": 34.4408464,
    "lng": -118.4292515
  },
  {
    "Store Location": "Tractor Supply 1700 BELL LN ATWATER, California 95301",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-357-7351",
    "address": "1700 BELL LN, ATWATER, California 95301",
    "city": "ATWATER",
    "state": "California",
    "zip": "95301",
    "lat": 37.3449711,
    "lng": -120.6161242
  },
  {
    "Store Location": "Tractor Supply 17155 VAN BUREN BLVD RIVERSIDE, California 92504",
    "Store Type": "Tractor Supply",
    "Phone Number": "951-780-0830",
    "address": "17155 VAN BUREN BLVD, RIVERSIDE, California 92504",
    "city": "RIVERSIDE",
    "state": "California",
    "zip": "92504",
    "lat": 33.8816103,
    "lng": -117.363369
  },
  {
    "Store Location": "Tractor Supply 1755 WEST HENDERSON AVE PORTERVILLE, California 93257",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7534",
    "address": "1755 WEST HENDERSON AVE, PORTERVILLE, California 93257",
    "city": "PORTERVILLE",
    "state": "California",
    "zip": "93257",
    "lat": 36.0795263,
    "lng": -119.0569707
  },
  {
    "Store Location": "Tractor Supply 18123 COLLIER AVE LAKE ELSINORE, California 92530",
    "Store Type": "Tractor Supply",
    "Phone Number": "951-674-1704",
    "address": "18123 COLLIER AVE LAKE, ELSINORE, California 92530",
    "city": "ELSINORE",
    "state": "California",
    "zip": "92530",
    "lat": 33.6930149,
    "lng": -117.3450563
  },
  {
    "Store Location": "Tractor Supply 1850 BRADSHAW DR EL CENTRO, California 92243",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-312-9734",
    "address": "1850 BRADSHAW DR EL, CENTRO, California 92243",
    "city": "CENTRO",
    "state": "California",
    "zip": "92243",
    "lat": 32.8119044,
    "lng": -115.5758769
  },
  {
    "Store Location": "Tractor Supply 1945 MARX WAY ANDERSON, California 96007",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-378-1012",
    "address": "1945 MARX WAY, ANDERSON, California 96007",
    "city": "ANDERSON",
    "state": "California",
    "zip": "96007",
    "lat": 40.4418656,
    "lng": -122.2921781
  },
  {
    "Store Location": "Tractor Supply 1949 EAST PROSPERITY AVE TULARE, California 93274",
    "Store Type": "Tractor Supply",
    "Phone Number": "559-688-1334",
    "address": "1949 EAST PROSPERITY AVE, TULARE, California 93274",
    "city": "TULARE",
    "state": "California",
    "zip": "93274",
    "lat": 36.2255828,
    "lng": -119.317652
  },
  {
    "Store Location": "Tractor Supply 2000 FEATHER RIVER BLVD OROVILLE, California 95965",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-538-9552",
    "address": "2000 FEATHER RIVER BLVD, OROVILLE, California 95965",
    "city": "OROVILLE",
    "state": "California",
    "zip": "95965",
    "lat": 39.5023923,
    "lng": -121.5728552
  },
  {
    "Store Location": "Tractor Supply 2000 LAKEVILLE HWY STE A PETALUMA, California 94954",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-775-4289",
    "address": "2000 LAKEVILLE HWY STE A, PETALUMA, California 94954",
    "city": "PETALUMA",
    "state": "California",
    "zip": "94954",
    "lat": 38.2329154,
    "lng": -122.6108149
  },
  {
    "Store Location": "Tractor Supply 2000 NORTH 1ST ST DIXON, California 95620",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-693-1738",
    "address": "2000 NORTH 1ST ST, DIXON, California 95620",
    "city": "DIXON",
    "state": "California",
    "zip": "95620",
    "lat": 38.4661507,
    "lng": -121.8207746
  },
  {
    "Store Location": "Tractor Supply 201 NORTH WALNUT RD TURLOCK, California 95380",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-664-0695",
    "address": "201 NORTH WALNUT RD, TURLOCK, California 95380",
    "city": "TURLOCK",
    "state": "California",
    "zip": "95380",
    "lat": 37.4942885,
    "lng": -120.8727906
  },
  {
    "Store Location": "Tractor Supply 203 HUNTER ST RAMONA, California 92065",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-789-7052",
    "address": "203 HUNTER ST, RAMONA, California 92065",
    "city": "RAMONA",
    "state": "California",
    "zip": "92065",
    "lat": 33.029478,
    "lng": -116.8884386
  },
  {
    "Store Location": "Tractor Supply 20340 BEAR VALLEY ROAD APPLE VALLEY, California 92308",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-240-1535",
    "address": "20340 BEAR VALLEY ROAD APPLE, VALLEY, California 92308",
    "city": "VALLEY",
    "state": "California",
    "zip": "92308",
    "lat": 34.4721816,
    "lng": -117.2205431
  },
  {
    "Store Location": "Tractor Supply 2195 HAMNER AVE NORCO, California 92860",
    "Store Type": "Tractor Supply",
    "Phone Number": "951-735-2216",
    "address": "2195 HAMNER AVE, NORCO, California 92860",
    "city": "NORCO",
    "state": "California",
    "zip": "92860",
    "lat": 33.9136457,
    "lng": -117.5592751
  },
  {
    "Store Location": "Tractor Supply 221 EAST HWY 246 UNIT 103 BUELLTON, California 93427",
    "Store Type": "Tractor Supply",
    "Phone Number": "805-686-7901",
    "address": "221 EAST HWY 246 UNIT 103, BUELLTON, California 93427",
    "city": "BUELLTON",
    "state": "California",
    "zip": "93427",
    "lat": 34.61183,
    "lng": -120.18708
  },
  {
    "Store Location": "Tractor Supply 2420 WEST MAIN ST BARSTOW, California 92311",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-255-1391",
    "address": "2420 WEST MAIN ST, BARSTOW, California 92311",
    "city": "BARSTOW",
    "state": "California",
    "zip": "92311",
    "lat": 34.8889782,
    "lng": -117.0656074
  },
  {
    "Store Location": "Tractor Supply 2475 MARTIN LUTHER KING JR PKWY CHICO, California 95928",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-897-0669",
    "address": "2475 MARTIN LUTHER KING JR PKWY, CHICO, California 95928",
    "city": "CHICO",
    "state": "California",
    "zip": "95928",
    "lat": 39.7171104,
    "lng": -121.8068061
  },
  {
    "Store Location": "Tractor Supply 249 SOUTH MAIN ST RED BLUFF, California 96080",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-528-8945",
    "address": "249 SOUTH MAIN ST RED, BLUFF, California 96080",
    "city": "BLUFF",
    "state": "California",
    "zip": "96080",
    "lat": 40.1682661,
    "lng": -122.2302014
  },
  {
    "Store Location": "Tractor Supply 27444 VALLEY CENTER RD VALLEY CENTER, California 92082",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-751-5465",
    "address": "27444 VALLEY CENTER RD VALLEY, CENTER, California 92082",
    "city": "CENTER",
    "state": "California",
    "zip": "92082",
    "lat": 33.20906920000001,
    "lng": -117.0346452
  },
  {
    "Store Location": "Tractor Supply 2749 CALLOWAY DR STE 560 BAKERSFIELD, California 93312",
    "Store Type": "Tractor Supply",
    "Phone Number": "661-589-1504",
    "address": "2749 CALLOWAY DR STE 560, BAKERSFIELD, California 93312",
    "city": "BAKERSFIELD",
    "state": "California",
    "zip": "93312",
    "lat": 35.38585279999999,
    "lng": -119.1117336
  },
  {
    "Store Location": "Tractor Supply 27826 CLINTON KEITH RD MURRIETA, California 92562",
    "Store Type": "Tractor Supply",
    "Phone Number": "951-679-9437",
    "address": "27826 CLINTON KEITH RD, MURRIETA, California 92562",
    "city": "MURRIETA",
    "state": "California",
    "zip": "92562",
    "lat": 33.6020239,
    "lng": -117.1732955
  },
  {
    "Store Location": "Tractor Supply 2800 RIVERSIDE AVE UNIT 103 PASO ROBLES, California 93446",
    "Store Type": "Tractor Supply",
    "Phone Number": "805-226-9040",
    "address": "2800 RIVERSIDE AVE UNIT 103 PASO, ROBLES, California 93446",
    "city": "ROBLES",
    "state": "California",
    "zip": "93446",
    "lat": 35.6439067,
    "lng": -120.6881969
  },
  {
    "Store Location": "Tractor Supply 360 SOUTH CHEROKEE LN LODI, California 95240",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-369-5528",
    "address": "360 SOUTH CHEROKEE LN, LODI, California 95240",
    "city": "LODI",
    "state": "California",
    "zip": "95240",
    "lat": 38.130389,
    "lng": -121.2591196
  },
  {
    "Store Location": "Tractor Supply 3741 WEST FLORIDA AVE HEMET, California 92545",
    "Store Type": "Tractor Supply",
    "Phone Number": "951-658-5566",
    "address": "3741 WEST FLORIDA AVE, HEMET, California 92545",
    "city": "HEMET",
    "state": "California",
    "zip": "92545",
    "lat": 33.7458469,
    "lng": -117.0116862
  },
  {
    "Store Location": "Tractor Supply 3747 EAST PALMDALE BLVD PALMDALE, California 93550",
    "Store Type": "Tractor Supply",
    "Phone Number": "661-575-9575",
    "address": "3747 EAST PALMDALE BLVD, PALMDALE, California 93550",
    "city": "PALMDALE",
    "state": "California",
    "zip": "93550",
    "lat": 34.5810729,
    "lng": -118.0624147
  },
  {
    "Store Location": "Tractor Supply 3950 GRASS VALLEY HWY AUBURN, California 95602",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-889-2032",
    "address": "3950 GRASS VALLEY HWY, AUBURN, California 95602",
    "city": "AUBURN",
    "state": "California",
    "zip": "95602",
    "lat": 38.9561735,
    "lng": -121.0995191
  },
  {
    "Store Location": "Tractor Supply 397 WEST LOS ANGELES AVE MOORPARK, California 93021",
    "Store Type": "Tractor Supply",
    "Phone Number": "805-552-9552",
    "address": "397 WEST LOS ANGELES AVE, MOORPARK, California 93021",
    "city": "MOORPARK",
    "state": "California",
    "zip": "93021",
    "lat": 34.279019,
    "lng": -118.8867856
  },
  {
    "Store Location": "Tractor Supply 407 NORTH MAIN STREET ANGELS CAMP, California 95222",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-736-6727",
    "address": "407 NORTH MAIN STREET ANGELS, CAMP, California 95222",
    "city": "CAMP",
    "state": "California",
    "zip": "95222",
    "lat": 38.0853239,
    "lng": -120.5658358
  },
  {
    "Store Location": "Tractor Supply 418 NAPA JUNCTION RD AMERICAN CANYON, California 94503",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-558-0588",
    "address": "418 NAPA JUNCTION RD AMERICAN, CANYON, California 94503",
    "city": "CANYON",
    "state": "California",
    "zip": "94503",
    "lat": 38.1864351,
    "lng": -122.2540665
  },
  {
    "Store Location": "Tractor Supply 42625 JACKSON STREET UNIT 100 INDIO, California 92203",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-342-2239",
    "address": "42625 JACKSON STREET UNIT 100, INDIO, California 92203",
    "city": "INDIO",
    "state": "California",
    "zip": "92203",
    "lat": 33.7397051,
    "lng": -116.218095
  },
  {
    "Store Location": "Tractor Supply 43483 ANZA RD TEMECULA, California 92592",
    "Store Type": "Tractor Supply",
    "Phone Number": "951-428-3040",
    "address": "43483 ANZA RD, TEMECULA, California 92592",
    "city": "TEMECULA",
    "state": "California",
    "zip": "92592",
    "lat": 33.4912403,
    "lng": -117.0555948
  },
  {
    "Store Location": "Tractor Supply 480 NORTH MILL ST TEHACHAPI, California 93561",
    "Store Type": "Tractor Supply",
    "Phone Number": "661-823-1687",
    "address": "480 NORTH MILL ST, TEHACHAPI, California 93561",
    "city": "TEHACHAPI",
    "state": "California",
    "zip": "93561",
    "lat": 35.1373116,
    "lng": -118.4508128
  },
  {
    "Store Location": "Tractor Supply 5251 MAD RIVER PKWY ARCATA, California 95521",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-822-2787",
    "address": "5251 MAD RIVER PKWY, ARCATA, California 95521",
    "city": "ARCATA",
    "state": "California",
    "zip": "95521",
    "lat": 40.9054557,
    "lng": -124.0807364
  },
  {
    "Store Location": "Tractor Supply 5450 MOUNTAIN VIEW DR REDDING, California 96003",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-242-6773",
    "address": "5450 MOUNTAIN VIEW DR, REDDING, California 96003",
    "city": "REDDING",
    "state": "California",
    "zip": "96003",
    "lat": 40.6228225,
    "lng": -122.364371
  },
  {
    "Store Location": "Tractor Supply 57980 29 PALMS HWY STE A YUCCA VALLEY, California 92284",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-365-4194",
    "address": "57980 29 PALMS HWY STE A YUCCA, VALLEY, California 92284",
    "city": "VALLEY",
    "state": "California",
    "zip": "92284",
    "lat": 34.1294926,
    "lng": -116.399603
  },
  {
    "Store Location": "Tractor Supply 580 AUTO CENTER DR WATSONVILLE, California 95076",
    "Store Type": "Tractor Supply",
    "Phone Number": "831-761-5368",
    "address": "580 AUTO CENTER DR, WATSONVILLE, California 95076",
    "city": "WATSONVILLE",
    "state": "California",
    "zip": "95076",
    "lat": 36.9178766,
    "lng": -121.7684301
  },
  {
    "Store Location": "Tractor Supply 625 M ST CRESCENT CITY, California 95531",
    "Store Type": "Tractor Supply",
    "Phone Number": "707-464-2629",
    "address": "625 M ST CRESCENT, CITY, California 95531",
    "city": "CITY",
    "state": "California",
    "zip": "95531",
    "lat": 41.7573912,
    "lng": -124.1940551
  },
  {
    "Store Location": "Tractor Supply 6710 COLONY ST BAKERSFIELD, California 93307",
    "Store Type": "Tractor Supply",
    "Phone Number": "661-396-9636",
    "address": "6710 COLONY ST, BAKERSFIELD, California 93307",
    "city": "BAKERSFIELD",
    "state": "California",
    "zip": "93307",
    "lat": 35.2946045,
    "lng": -119.0261031
  },
  {
    "Store Location": "Tractor Supply 6710 NORTH BRAWLEY AVE FRESNO, California 93711",
    "Store Type": "Tractor Supply",
    "Phone Number": "559-438-3080",
    "address": "6710 NORTH BRAWLEY AVE, FRESNO, California 93711",
    "city": "FRESNO",
    "state": "California",
    "zip": "93711",
    "lat": 36.8359447,
    "lng": -119.8605922
  },
  {
    "Store Location": "Tractor Supply 6881 CAMERON RD GILROY, California 95020",
    "Store Type": "Tractor Supply",
    "Phone Number": "408-842-1594",
    "address": "6881 CAMERON RD, GILROY, California 95020",
    "city": "GILROY",
    "state": "California",
    "zip": "95020",
    "lat": 37.0024775,
    "lng": -121.5462046
  },
  {
    "Store Location": "Tractor Supply 773 SOUTH STATE HWY 49 JACKSON, California 95642",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-223-1507",
    "address": "773 SOUTH STATE HWY 49, JACKSON, California 95642",
    "city": "JACKSON",
    "state": "California",
    "zip": "95642",
    "lat": 38.3408782,
    "lng": -120.7675127
  },
  {
    "Store Location": "Tractor Supply 811 NORTH HUMBOLDT AVE WILLOWS, California 95988",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-934-3439",
    "address": "811 NORTH HUMBOLDT AVE, WILLOWS, California 95988",
    "city": "WILLOWS",
    "state": "California",
    "zip": "95988",
    "lat": 39.5292053,
    "lng": -122.2134451
  },
  {
    "Store Location": "Tractor Supply 8139 WATT AVE ANTELOPE, California 95843",
    "Store Type": "Tractor Supply",
    "Phone Number": "916-338-3656",
    "address": "8139 WATT AVE, ANTELOPE, California 95843",
    "city": "ANTELOPE",
    "state": "California",
    "zip": "95843",
    "lat": 38.71722159999999,
    "lng": -121.3943621
  },
  {
    "Store Location": "Tractor Supply 860 NORTH JACK TONE RD RIPON, California 95366",
    "Store Type": "Tractor Supply",
    "Phone Number": "209-599-1150",
    "address": "860 NORTH JACK TONE RD, RIPON, California 95366",
    "city": "RIPON",
    "state": "California",
    "zip": "95366",
    "lat": 37.7495038,
    "lng": -121.1414797
  },
  {
    "Store Location": "Tractor Supply 8800 BRENTWOOD BLVD BRENTWOOD, California 94513",
    "Store Type": "Tractor Supply",
    "Phone Number": "925-516-6610",
    "address": "8800 BRENTWOOD BLVD, BRENTWOOD, California 94513",
    "city": "BRENTWOOD",
    "state": "California",
    "zip": "94513",
    "lat": 37.92454590000001,
    "lng": -121.6886373
  },
  {
    "Store Location": "Tractor Supply 911 SOUTH CHINA LAKE BLVD UNIT C RIDGECREST, California 93555",
    "Store Type": "Tractor Supply",
    "Phone Number": "760-371-2599",
    "address": "911 SOUTH CHINA LAKE BLVD UNIT C, RIDGECREST, California 93555",
    "city": "RIDGECREST",
    "state": "California",
    "zip": "93555",
    "lat": 35.606772,
    "lng": -117.672754
  },
  {
    "Store Location": "Tractor Supply 990 THARP RD YUBA CITY, California 95993",
    "Store Type": "Tractor Supply",
    "Phone Number": "530-822-7722",
    "address": "990 THARP RD YUBA, CITY, California 95993",
    "city": "CITY",
    "state": "California",
    "zip": "95993",
    "lat": 39.1408979,
    "lng": -121.6504785
  },
  {
    "Store Location": "Tractor Supply 1125 NORTH MAIN ST GUNNISON, Colorado 81230",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-641-2287",
    "address": "1125 NORTH MAIN ST, GUNNISON, Colorado 81230",
    "city": "GUNNISON",
    "state": "Colorado",
    "zip": "81230",
    "lat": 38.5567704,
    "lng": -106.9282023
  },
  {
    "Store Location": "Tractor Supply 1175 DOMINGUEZ DR DURANGO, Colorado 81303",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-375-6283",
    "address": "1175 DOMINGUEZ DR, DURANGO, Colorado 81303",
    "city": "DURANGO",
    "state": "Colorado",
    "zip": "81303",
    "lat": 37.22817300000001,
    "lng": -107.8643146
  },
  {
    "Store Location": "Tractor Supply 130 HARRISON AVE BUENA VISTA, Colorado 81211",
    "Store Type": "Tractor Supply",
    "Phone Number": "719-395-1936",
    "address": "130 HARRISON AVE BUENA, VISTA, Colorado 81211",
    "city": "VISTA",
    "state": "Colorado",
    "zip": "81211",
    "lat": 38.8507685,
    "lng": -106.1412382
  },
  {
    "Store Location": "Tractor Supply 13778 EAST I 25 FRONTAGE ROAD LONGMONT, Colorado 80504",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-535-4300",
    "address": "13778 EAST I 25 FRONTAGE ROAD, LONGMONT, Colorado 80504",
    "city": "LONGMONT",
    "state": "Colorado",
    "zip": "80504",
    "lat": 40.2010477,
    "lng": -104.9782538
  },
  {
    "Store Location": "Tractor Supply 145 GUNNISON RIVER DR DELTA, Colorado 81416",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-874-2656",
    "address": "145 GUNNISON RIVER DR, DELTA, Colorado 81416",
    "city": "DELTA",
    "state": "Colorado",
    "zip": "81416",
    "lat": 38.74978249999999,
    "lng": -108.0722516
  },
  {
    "Store Location": "Tractor Supply 147 DENVER ST BRIGHTON, Colorado 80601",
    "Store Type": "Tractor Supply",
    "Phone Number": "303-659-6405",
    "address": "147 DENVER ST, BRIGHTON, Colorado 80601",
    "city": "BRIGHTON",
    "state": "Colorado",
    "zip": "80601",
    "lat": 39.9949589,
    "lng": -104.8214175
  },
  {
    "Store Location": "Tractor Supply 16760 LEATHER CHAPS DR MONUMENT, Colorado 80132",
    "Store Type": "Tractor Supply",
    "Phone Number": "719-488-8844",
    "address": "16760 LEATHER CHAPS DR, MONUMENT, Colorado 80132",
    "city": "MONUMENT",
    "state": "Colorado",
    "zip": "80132",
    "lat": 39.0656749,
    "lng": -104.8477898
  },
  {
    "Store Location": "Tractor Supply 1919 EAST MAIN ST CANON CITY, Colorado 81212",
    "Store Type": "Tractor Supply",
    "Phone Number": "719-275-2116",
    "address": "1919 EAST MAIN ST CANON, CITY, Colorado 81212",
    "city": "CITY",
    "state": "Colorado",
    "zip": "81212",
    "lat": 38.4472797,
    "lng": -105.2193386
  },
  {
    "Store Location": "Tractor Supply 200 WEST MARKETPLACE DR BENNETT, Colorado 80102",
    "Store Type": "Tractor Supply",
    "Phone Number": "303-644-5110",
    "address": "200 WEST MARKETPLACE DR, BENNETT, Colorado 80102",
    "city": "BENNETT",
    "state": "Colorado",
    "zip": "80102",
    "lat": 39.7586311,
    "lng": -104.4283959
  },
  {
    "Store Location": "Tractor Supply 225 US HWY 84 PAGOSA SPRINGS, Colorado 81147",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-264-0720",
    "address": "225 US HWY 84 PAGOSA, SPRINGS, Colorado 81147",
    "city": "SPRINGS",
    "state": "Colorado",
    "zip": "81147",
    "lat": 37.266979,
    "lng": -106.9935299
  },
  {
    "Store Location": "Tractor Supply 2449 HWY 6 AND 50 GRAND JUNCTION, Colorado 81505",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-243-3015",
    "address": "2449 HWY 6 AND 50 GRAND, JUNCTION, Colorado 81505",
    "city": "JUNCTION",
    "state": "Colorado",
    "zip": "81505",
    "lat": 41.5092891,
    "lng": -81.6743707
  },
  {
    "Store Location": "Tractor Supply 300 SAVAGE AVE LAMAR, Colorado 81052",
    "Store Type": "Tractor Supply",
    "Phone Number": "719-336-2042",
    "address": "300 SAVAGE AVE, LAMAR, Colorado 81052",
    "city": "LAMAR",
    "state": "Colorado",
    "zip": "81052",
    "lat": 38.0711672,
    "lng": -102.6181452
  },
  {
    "Store Location": "Tractor Supply 3015 SOUTH 23RD AVE GREELEY, Colorado 80631",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-330-3440",
    "address": "3015 SOUTH 23RD AVE, GREELEY, Colorado 80631",
    "city": "GREELEY",
    "state": "Colorado",
    "zip": "80631",
    "lat": 40.3907393,
    "lng": -104.7158787
  },
  {
    "Store Location": "Tractor Supply 33 NORTWEST FRONTAGE RD FORT COLLINS, Colorado 80524",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-221-1104",
    "address": "33 NORTWEST FRONTAGE RD FORT, COLLINS, Colorado 80524",
    "city": "COLLINS",
    "state": "Colorado",
    "zip": "80524",
    "lat": 40.5839875,
    "lng": -105.0028536
  },
  {
    "Store Location": "Tractor Supply 5075 NORTH ELIZABETH STREET PUEBLO, Colorado 81008",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7535",
    "address": "5075 NORTH ELIZABETH STREET, PUEBLO, Colorado 81008",
    "city": "PUEBLO",
    "state": "Colorado",
    "zip": "81008",
    "lat": 38.3262929,
    "lng": -104.6170727
  },
  {
    "Store Location": "Tractor Supply 51027 HWY 6 AND 24 STE 190 GLENWOOD SPRINGS, Colorado 81601",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-945-5444",
    "address": "51027 HWY 6 AND 24 STE 190 GLENWOOD, SPRINGS, Colorado 81601",
    "city": "SPRINGS",
    "state": "Colorado",
    "zip": "81601",
    "lat": 39.5631256,
    "lng": -107.365551
  },
  {
    "Store Location": "Tractor Supply 5428 NORTH GARFIELD AVE LOVELAND, Colorado 80538",
    "Store Type": "Tractor Supply",
    "Phone Number": "970-663-2722",
    "address": "5428 NORTH GARFIELD AVE, LOVELAND, Colorado 80538",
    "city": "LOVELAND",
    "state": "Colorado",
    "zip": "80538",
    "lat": 40.448929,
    "lng": -105.07623
  },
  {
    "Store Location": "Tractor Supply 720 DEL SOL DR ALAMOSA, Colorado 81101",
    "Store Type": "Tractor Supply",
    "Phone Number": "719-589-2490",
    "address": "720 DEL SOL DR, ALAMOSA, Colorado 81101",
    "city": "ALAMOSA",
    "state": "Colorado",
    "zip": "81101",
    "lat": 37.481635,
    "lng": -105.9016825
  },
  {
    "Store Location": "Tractor Supply 801 EAST 8TH AVE YUMA, Colorado 80759",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7531",
    "address": "801 EAST 8TH AVE, YUMA, Colorado 80759",
    "city": "YUMA",
    "state": "Colorado",
    "zip": "80759",
    "lat": 40.1176914,
    "lng": -102.713018
  },
  {
    "Store Location": "Tractor Supply 825 NORTH US HWY 287 LAFAYETTE, Colorado 80026",
    "Store Type": "Tractor Supply",
    "Phone Number": "303-665-3050",
    "address": "825 NORTH US HWY 287, LAFAYETTE, Colorado 80026",
    "city": "LAFAYETTE",
    "state": "Colorado",
    "zip": "80026",
    "lat": 40.0081762,
    "lng": -105.1053199
  },
  {
    "Store Location": "Tractor Supply 919 SPRUCE HAVEN DR WOODLAND PARK, Colorado 80863",
    "Store Type": "Tractor Supply",
    "Phone Number": "719-686-0401",
    "address": "919 SPRUCE HAVEN DR WOODLAND, PARK, Colorado 80863",
    "city": "PARK",
    "state": "Colorado",
    "zip": "80863",
    "lat": 38.9948922,
    "lng": -105.0634957
  },
  {
    "Store Location": "Tractor Supply 959 PLUM CREEK BLVD CASTLE ROCK, Colorado 80104",
    "Store Type": "Tractor Supply",
    "Phone Number": "303-688-3397",
    "address": "959 PLUM CREEK BLVD CASTLE, ROCK, Colorado 80104",
    "city": "ROCK",
    "state": "Colorado",
    "zip": "80104",
    "lat": 39.362841,
    "lng": -104.857877
  },
  {
    "Store Location": "Tractor Supply 116 SOUTH MAIN ST NEWTOWN, Connecticut 6470",
    "Store Type": "Tractor Supply",
    "Phone Number": "203-270-1197",
    "address": "116 SOUTH MAIN ST NEWTOWN, Connecticut 6470,  ",
    "city": "Connecticut 6470",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.3892604,
    "lng": -73.2893294
  },
  {
    "Store Location": "Tractor Supply 1160 NEW HAVEN RD NAUGATUCK, Connecticut 6770",
    "Store Type": "Tractor Supply",
    "Phone Number": "203-720-3776",
    "address": "1160 NEW HAVEN RD NAUGATUCK, Connecticut 6770,  ",
    "city": "Connecticut 6770",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.4695565,
    "lng": -73.02526280000001
  },
  {
    "Store Location": "Tractor Supply 150 NEW LONDON RD COLCHESTER, Connecticut 6415",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-537-0679",
    "address": "150 NEW LONDON RD COLCHESTER, Connecticut 6415,  ",
    "city": "Connecticut 6415",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.558729,
    "lng": -72.3198101
  },
  {
    "Store Location": "Tractor Supply 204 DANBURY RD NEW MILFORD, Connecticut 6776",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-350-3390",
    "address": "204 DANBURY RD NEW MILFORD, Connecticut 6776,  ",
    "city": "Connecticut 6776",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.5466928,
    "lng": -73.4218801
  },
  {
    "Store Location": "Tractor Supply 253 INDIAN RIVER ROAD ORANGE, Connecticut 6477",
    "Store Type": "Tractor Supply",
    "Phone Number": "203-795-0663",
    "address": "253 INDIAN RIVER ROAD ORANGE, Connecticut 6477,  ",
    "city": "Connecticut 6477",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.265438,
    "lng": -72.9980506
  },
  {
    "Store Location": "Tractor Supply 2945 BOSTON POST RD GUILFORD, Connecticut 6437",
    "Store Type": "Tractor Supply",
    "Phone Number": "203-315-0090",
    "address": "2945 BOSTON POST RD GUILFORD, Connecticut 6437,  ",
    "city": "Connecticut 6437",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.3126536,
    "lng": -72.74191739999999
  },
  {
    "Store Location": "Tractor Supply 331 LIBERTY ST PAWCATUCK, Connecticut 6379",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-599-5764",
    "address": "331 LIBERTY ST PAWCATUCK, Connecticut 6379,  ",
    "city": "Connecticut 6379",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.39701,
    "lng": -71.8444985
  },
  {
    "Store Location": "Tractor Supply 361 SCOTT SWAMP RD FARMINGTON, Connecticut 6032",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-676-0295",
    "address": "361 SCOTT SWAMP RD FARMINGTON, Connecticut 6032,  ",
    "city": "Connecticut 6032",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.70101529999999,
    "lng": -72.8879467
  },
  {
    "Store Location": "Tractor Supply 380 NEW HARTFORD RD BARKHAMSTED, Connecticut 6063",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-738-9696",
    "address": "380 NEW HARTFORD RD BARKHAMSTED, Connecticut 6063,  ",
    "city": "Connecticut 6063",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.9116399,
    "lng": -73.04229889999999
  },
  {
    "Store Location": "Tractor Supply 401 MIDDLESEX TPKE OLD SAYBROOK, Connecticut 6475",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-388-9641",
    "address": "401 MIDDLESEX TPKE OLD SAYBROOK, Connecticut 6475,  ",
    "city": "Connecticut 6475",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.3128413,
    "lng": -72.3835253
  },
  {
    "Store Location": "Tractor Supply 404 TALCOTTVILLE RD VERNON, Connecticut 6066",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-872-0839",
    "address": "404 TALCOTTVILLE RD VERNON, Connecticut 6066,  ",
    "city": "Connecticut 6066",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.8439587,
    "lng": -72.4858745
  },
  {
    "Store Location": "Tractor Supply 461 VOLUNTOWN RD STE I GRISWOLD, Connecticut 6351",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-376-0131",
    "address": "461 VOLUNTOWN RD STE I GRISWOLD, Connecticut 6351,  ",
    "city": "Connecticut 6351",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.59139769999999,
    "lng": -71.9721201
  },
  {
    "Store Location": "Tractor Supply 476 BOSTON POST RD NORTH WINDHAM, Connecticut 6256",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-450-1065",
    "address": "476 BOSTON POST RD NORTH WINDHAM, Connecticut 6256,  ",
    "city": "Connecticut 6256",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.7446924,
    "lng": -72.1686684
  },
  {
    "Store Location": "Tractor Supply 54 WEST STAFFORD ROAD STAFFORD SPRINGS, Connecticut 6076",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-684-2626",
    "address": "54 WEST STAFFORD ROAD STAFFORD SPRINGS, Connecticut 6076,  ",
    "city": "Connecticut 6076",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.9648355,
    "lng": -72.32554
  },
  {
    "Store Location": "Tractor Supply 67 PALOMBA DR ENFIELD, Connecticut 6082",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-749-2853",
    "address": "67 PALOMBA DR ENFIELD, Connecticut 6082,  ",
    "city": "Connecticut 6082",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.9902334,
    "lng": -72.56956
  },
  {
    "Store Location": "Tractor Supply 800 N COLONY RD WALLINGFORD, Connecticut 6492",
    "Store Type": "Tractor Supply",
    "Phone Number": "203-265-4484",
    "address": "800 N COLONY RD WALLINGFORD, Connecticut 6492,  ",
    "city": "Connecticut 6492",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.4751941,
    "lng": -72.811776
  },
  {
    "Store Location": "Tractor Supply 815 NEWFIELD ST MIDDLETOWN, Connecticut 6457",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-613-2796",
    "address": "815 NEWFIELD ST MIDDLETOWN, Connecticut 6457,  ",
    "city": "Connecticut 6457",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.5812603,
    "lng": -72.673885
  },
  {
    "Store Location": "Tractor Supply 915 HARTFORD TPKE STE A6 WATERFORD, Connecticut 6385",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-437-4333",
    "address": "915 HARTFORD TPKE STE A6 WATERFORD, Connecticut 6385,  ",
    "city": "Connecticut 6385",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.3832092,
    "lng": -72.1504063
  },
  {
    "Store Location": "Tractor Supply 97 PROVIDENCE PIKE PUTNAM, Connecticut 6260",
    "Store Type": "Tractor Supply",
    "Phone Number": "860-963-7914",
    "address": "97 PROVIDENCE PIKE PUTNAM, Connecticut 6260,  ",
    "city": "Connecticut 6260",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.9248497,
    "lng": -71.87360009999999
  },
  {
    "Store Location": "Tractor Supply 1300 SOUTH DUPONT BLVD SMYRNA, Delaware 19977",
    "Store Type": "Tractor Supply",
    "Phone Number": "302-659-3333",
    "address": "1300 SOUTH DUPONT BLVD, SMYRNA, Delaware 19977",
    "city": "SMYRNA",
    "state": "Delaware",
    "zip": "19977",
    "lat": 39.2859595,
    "lng": -75.5963651
  },
  {
    "Store Location": "Tractor Supply 20952 SUSSEX HWY SEAFORD, Delaware 19973",
    "Store Type": "Tractor Supply",
    "Phone Number": "302-629-3627",
    "address": "20952 SUSSEX HWY, SEAFORD, Delaware 19973",
    "city": "SEAFORD",
    "state": "Delaware",
    "zip": "19973",
    "lat": 38.6886705,
    "lng": -75.5915842
  },
  {
    "Store Location": "Tractor Supply 28668 DUPONT BOULEVARD MILLSBORO, Delaware 19966",
    "Store Type": "Tractor Supply",
    "Phone Number": "302-934-1111",
    "address": "28668 DUPONT BOULEVARD, MILLSBORO, Delaware 19966",
    "city": "MILLSBORO",
    "state": "Delaware",
    "zip": "19966",
    "lat": 38.5755127,
    "lng": -75.2873991
  },
  {
    "Store Location": "Tractor Supply 4089 SOUTH DUPONT HWY DOVER, Delaware 19901",
    "Store Type": "Tractor Supply",
    "Phone Number": "302-698-5690",
    "address": "4089 SOUTH DUPONT HWY, DOVER, Delaware 19901",
    "city": "DOVER",
    "state": "Delaware",
    "zip": "19901",
    "lat": 39.1013495,
    "lng": -75.5417855
  },
  {
    "Store Location": "Tractor Supply 609B NORTH DUPONT BLVD MILFORD, Delaware 19963",
    "Store Type": "Tractor Supply",
    "Phone Number": "302-422-8157",
    "address": "609B NORTH DUPONT BLVD, MILFORD, Delaware 19963",
    "city": "MILFORD",
    "state": "Delaware",
    "zip": "19963",
    "lat": 38.91773999999999,
    "lng": -75.44404
  },
  {
    "Store Location": "Tractor Supply 912 MIDDLETOWN WARWICK RD MIDDLETOWN, Delaware 19709",
    "Store Type": "Tractor Supply",
    "Phone Number": "302-376-5900",
    "address": "912 MIDDLETOWN WARWICK RD, MIDDLETOWN, Delaware 19709",
    "city": "MIDDLETOWN",
    "state": "Delaware",
    "zip": "19709",
    "lat": 39.4366502,
    "lng": -75.7515028
  },
  {
    "Store Location": "Tractor Supply 100 ARDICE AVE STE 1 EUSTIS SQUARE SHOPPING CENTER EUSTIS, Florida 32726",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-357-0152",
    "address": "100 ARDICE AVE STE 1 EUSTIS SQUARE SHOPPING CENTER, EUSTIS, Florida 32726",
    "city": "EUSTIS",
    "state": "Florida",
    "zip": "32726",
    "lat": 28.8280686,
    "lng": -81.6878558
  },
  {
    "Store Location": "Tractor Supply 101 E INTERNATIONAL SPDWY BLVD DELAND, Florida 32724",
    "Store Type": "Tractor Supply",
    "Phone Number": "386-736-1115",
    "address": "101 E INTERNATIONAL SPDWY BLVD, DELAND, Florida 32724",
    "city": "DELAND",
    "state": "Florida",
    "zip": "32724",
    "lat": 29.0564559,
    "lng": -81.30263219999999
  },
  {
    "Store Location": "Tractor Supply 1050 NORTH WILSON AVE BARTOW, Florida 33830",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-519-6708",
    "address": "1050 NORTH WILSON AVE, BARTOW, Florida 33830",
    "city": "BARTOW",
    "state": "Florida",
    "zip": "33830",
    "lat": 27.905135,
    "lng": -81.83844560000001
  },
  {
    "Store Location": "Tractor Supply 10735 CR 512 FELLSMERE, Florida 32958",
    "Store Type": "Tractor Supply",
    "Phone Number": "772-589-5775",
    "address": "10735 CR 512, FELLSMERE, Florida 32958",
    "city": "FELLSMERE",
    "state": "Florida",
    "zip": "32958",
    "lat": 27.7663225,
    "lng": -80.546182
  },
  {
    "Store Location": "Tractor Supply 10749 BIG BEND RD RIVERVIEW, Florida 33579",
    "Store Type": "Tractor Supply",
    "Phone Number": "813-671-8400",
    "address": "10749 BIG BEND RD, RIVERVIEW, Florida 33579",
    "city": "RIVERVIEW",
    "state": "Florida",
    "zip": "33579",
    "lat": 27.7905373,
    "lng": -82.3293257
  },
  {
    "Store Location": "Tractor Supply 1101 HWY 17 SOUTH (SOUTH 6TH AVE) WAUCHULA, Florida 33873",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-773-3456",
    "address": "1101 HWY 17 SOUTH (SOUTH 6TH AVE), WAUCHULA, Florida 33873",
    "city": "WAUCHULA",
    "state": "Florida",
    "zip": "33873",
    "lat": 27.561317,
    "lng": -81.814908
  },
  {
    "Store Location": "Tractor Supply 11242 NORTH WILLIAMS ST DUNNELLON, Florida 34432",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-489-7495",
    "address": "11242 NORTH WILLIAMS ST, DUNNELLON, Florida 34432",
    "city": "DUNNELLON",
    "state": "Florida",
    "zip": "34432",
    "lat": 29.0603818,
    "lng": -82.4560237
  },
  {
    "Store Location": "Tractor Supply 115 NORTH STATE RD 19 PALATKA, Florida 32177",
    "Store Type": "Tractor Supply",
    "Phone Number": "386-325-7556",
    "address": "115 NORTH STATE RD 19, PALATKA, Florida 32177",
    "city": "PALATKA",
    "state": "Florida",
    "zip": "32177",
    "lat": 29.6474503,
    "lng": -81.67401219999999
  },
  {
    "Store Location": "Tractor Supply 1185 KINGS HWY PORT CHARLOTTE, Florida 33980",
    "Store Type": "Tractor Supply",
    "Phone Number": "941-629-5560",
    "address": "1185 KINGS HWY PORT, CHARLOTTE, Florida 33980",
    "city": "CHARLOTTE",
    "state": "Florida",
    "zip": "33980",
    "lat": 27.0113094,
    "lng": -82.0544314
  },
  {
    "Store Location": "Tractor Supply 131 WEST 2ND ST APOPKA, Florida 32703",
    "Store Type": "Tractor Supply",
    "Phone Number": "407-884-8022",
    "address": "131 WEST 2ND ST, APOPKA, Florida 32703",
    "city": "APOPKA",
    "state": "Florida",
    "zip": "32703",
    "lat": 28.67629269999999,
    "lng": -81.5152343
  },
  {
    "Store Location": "Tractor Supply 13235 TAMIAMI TRL EAST NAPLES, Florida 34114",
    "Store Type": "Tractor Supply",
    "Phone Number": "239-774-6927",
    "address": "13235 TAMIAMI TRL EAST, NAPLES, Florida 34114",
    "city": "NAPLES",
    "state": "Florida",
    "zip": "34114",
    "lat": 26.0617126,
    "lng": -81.6949996
  },
  {
    "Store Location": "Tractor Supply 1340 SOUTH 6TH ST MACCLENNY, Florida 32063",
    "Store Type": "Tractor Supply",
    "Phone Number": "904-259-9100",
    "address": "1340 SOUTH 6TH ST, MACCLENNY, Florida 32063",
    "city": "MACCLENNY",
    "state": "Florida",
    "zip": "32063",
    "lat": 30.2658892,
    "lng": -82.1243535
  },
  {
    "Store Location": "Tractor Supply 1371 SOUTH WALNUT ST STE 100A STARKE, Florida 32091",
    "Store Type": "Tractor Supply",
    "Phone Number": "904-368-0051",
    "address": "1371 SOUTH WALNUT ST STE 100A, STARKE, Florida 32091",
    "city": "STARKE",
    "state": "Florida",
    "zip": "32091",
    "lat": 29.9341554,
    "lng": -82.1174652
  },
  {
    "Store Location": "Tractor Supply 14151 WEST NEWBERRY RD NEWBERRY, Florida 32669",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-333-3789",
    "address": "14151 WEST NEWBERRY RD, NEWBERRY, Florida 32669",
    "city": "NEWBERRY",
    "state": "Florida",
    "zip": "32669",
    "lat": 29.6525966,
    "lng": -82.49471760000002
  },
  {
    "Store Location": "Tractor Supply 1450 STATE RD 60 EAST LAKE WALES, Florida 33853",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-679-3163",
    "address": "1450 STATE RD 60 EAST LAKE, WALES, Florida 33853",
    "city": "WALES",
    "state": "Florida",
    "zip": "33853",
    "lat": 27.8933875,
    "lng": -81.5616136
  },
  {
    "Store Location": "Tractor Supply 1455 BLANDING BLVD ORANGE PARK, Florida 32065",
    "Store Type": "Tractor Supply",
    "Phone Number": "904-272-1970",
    "address": "1455 BLANDING BLVD ORANGE, PARK, Florida 32065",
    "city": "PARK",
    "state": "Florida",
    "zip": "32065",
    "lat": 30.117868,
    "lng": -81.8055789
  },
  {
    "Store Location": "Tractor Supply 1530 COUNTY ROAD 210 W SAINT JOHNS, Florida 32259",
    "Store Type": "Tractor Supply",
    "Phone Number": "904-615-5580",
    "address": "1530 COUNTY ROAD 210 W SAINT, JOHNS, Florida 32259",
    "city": "JOHNS",
    "state": "Florida",
    "zip": "32259",
    "lat": 30.0829373,
    "lng": -81.4742318
  },
  {
    "Store Location": "Tractor Supply 15731 SOUTHERN BLVD LOXAHATCHEE, Florida 33470",
    "Store Type": "Tractor Supply",
    "Phone Number": "561-333-2223",
    "address": "15731 SOUTHERN BLVD, LOXAHATCHEE, Florida 33470",
    "city": "LOXAHATCHEE",
    "state": "Florida",
    "zip": "33470",
    "lat": 26.6847299,
    "lng": -80.2937535
  },
  {
    "Store Location": "Tractor Supply 1575 SOUTH JEFFERSON ST MONTICELLO, Florida 32344",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-997-0900",
    "address": "1575 SOUTH JEFFERSON ST, MONTICELLO, Florida 32344",
    "city": "MONTICELLO",
    "state": "Florida",
    "zip": "32344",
    "lat": 30.5268294,
    "lng": -83.8710463
  },
  {
    "Store Location": "Tractor Supply 1610 MAIN ST CHIPLEY, Florida 32428",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-638-8353",
    "address": "1610 MAIN ST, CHIPLEY, Florida 32428",
    "city": "CHIPLEY",
    "state": "Florida",
    "zip": "32428",
    "lat": 30.7541511,
    "lng": -85.5519066
  },
  {
    "Store Location": "Tractor Supply 1673 WEST C 48 BUSHNELL, Florida 33513",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7533",
    "address": "1673 WEST C 48, BUSHNELL, Florida 33513",
    "city": "BUSHNELL",
    "state": "Florida",
    "zip": "33513",
    "lat": 28.6673631,
    "lng": -82.13163329999999
  },
  {
    "Store Location": "Tractor Supply 16849 EAST COLONIAL DR ORLANDO, Florida 32820",
    "Store Type": "Tractor Supply",
    "Phone Number": "407-568-5116",
    "address": "16849 EAST COLONIAL DR, ORLANDO, Florida 32820",
    "city": "ORLANDO",
    "state": "Florida",
    "zip": "32820",
    "lat": 28.5624491,
    "lng": -81.1302082
  },
  {
    "Store Location": "Tractor Supply 1701 EAST OAK ST ARCADIA, Florida 34266",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-993-3745",
    "address": "1701 EAST OAK ST, ARCADIA, Florida 34266",
    "city": "ARCADIA",
    "state": "Florida",
    "zip": "34266",
    "lat": 27.2107681,
    "lng": -81.8399396
  },
  {
    "Store Location": "Tractor Supply 1706 CITRUS BLVD LEESBURG, Florida 34748",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-787-7333",
    "address": "1706 CITRUS BLVD, LEESBURG, Florida 34748",
    "city": "LEESBURG",
    "state": "Florida",
    "zip": "34748",
    "lat": 28.8348276,
    "lng": -81.888159
  },
  {
    "Store Location": "Tractor Supply 1751 SOUTHWEST 134TH ST OCALA, Florida 34473",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-307-9200",
    "address": "1751 SOUTHWEST 134TH ST, OCALA, Florida 34473",
    "city": "OCALA",
    "state": "Florida",
    "zip": "34473",
    "lat": 29.0270786,
    "lng": -82.15522059999999
  },
  {
    "Store Location": "Tractor Supply 1803 JIM REDMAN PKWY PLANT CITY, Florida 33563",
    "Store Type": "Tractor Supply",
    "Phone Number": "813-707-1185",
    "address": "1803 JIM REDMAN PKWY PLANT, CITY, Florida 33563",
    "city": "CITY",
    "state": "Florida",
    "zip": "33563",
    "lat": 27.9919061,
    "lng": -82.1215995
  },
  {
    "Store Location": "Tractor Supply 1840 WEST STATE RD 80 LABELLE, Florida 33935",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-674-1217",
    "address": "1840 WEST STATE RD 80, LABELLE, Florida 33935",
    "city": "LABELLE",
    "state": "Florida",
    "zip": "33935",
    "lat": 26.7425237,
    "lng": -81.4666049
  },
  {
    "Store Location": "Tractor Supply 18741 CORTEZ BLVD BROOKSVILLE, Florida 34601",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-799-2551",
    "address": "18741 CORTEZ BLVD, BROOKSVILLE, Florida 34601",
    "city": "BROOKSVILLE",
    "state": "Florida",
    "zip": "34601",
    "lat": 28.5510419,
    "lng": -82.4194797
  },
  {
    "Store Location": "Tractor Supply 19410 TIMES CIRCLE VENICE, Florida 34292",
    "Store Type": "Tractor Supply",
    "Phone Number": "941-800-3800",
    "address": "19410 TIMES CIRCLE, VENICE, Florida 34292",
    "city": "VENICE",
    "state": "Florida",
    "zip": "34292",
    "lat": 27.1040927,
    "lng": -82.38241959999999
  },
  {
    "Store Location": "Tractor Supply 19962 CENTRAL AVE WEST BLOUNTSTOWN, Florida 32424",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-237-1600",
    "address": "19962 CENTRAL AVE WEST, BLOUNTSTOWN, Florida 32424",
    "city": "BLOUNTSTOWN",
    "state": "Florida",
    "zip": "32424",
    "lat": 30.445022,
    "lng": -85.05670020000001
  },
  {
    "Store Location": "Tractor Supply 207 72ND TRACE NORTHEAST LIVE OAK, Florida 32064",
    "Store Type": "Tractor Supply",
    "Phone Number": "386-362-1515",
    "address": "207 72ND TRACE NORTHEAST LIVE, OAK, Florida 32064",
    "city": "OAK",
    "state": "Florida",
    "zip": "32064",
    "lat": 30.3181629,
    "lng": -82.9682406
  },
  {
    "Store Location": "Tractor Supply 21228 WALMART WAY LUTZ, Florida 33548",
    "Store Type": "Tractor Supply",
    "Phone Number": "813-948-2353",
    "address": "21228 WALMART WAY, LUTZ, Florida 33548",
    "city": "LUTZ",
    "state": "Florida",
    "zip": "33548",
    "lat": 28.1777269,
    "lng": -82.466731
  },
  {
    "Store Location": "Tractor Supply 2202-100 NORTH YOUNG BLVD CHIEFLAND, Florida 32626",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-493-4955",
    "address": "2202-100 NORTH YOUNG BLVD, CHIEFLAND, Florida 32626",
    "city": "CHIEFLAND",
    "state": "Florida",
    "zip": "32626",
    "lat": 29.4997727,
    "lng": -82.8723066
  },
  {
    "Store Location": "Tractor Supply 2395 SOUTH OLGA DR FORT MYERS, Florida 33905",
    "Store Type": "Tractor Supply",
    "Phone Number": "239-690-3002",
    "address": "2395 SOUTH OLGA DR FORT, MYERS, Florida 33905",
    "city": "MYERS",
    "state": "Florida",
    "zip": "33905",
    "lat": 26.7117281,
    "lng": -81.7140325
  },
  {
    "Store Location": "Tractor Supply 2408 CRAWFORDVILLE HWY CRAWFORDVILLE, Florida 32327",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-926-5522",
    "address": "2408 CRAWFORDVILLE HWY, CRAWFORDVILLE, Florida 32327",
    "city": "CRAWFORDVILLE",
    "state": "Florida",
    "zip": "32327",
    "lat": 30.2028203,
    "lng": -84.3692603
  },
  {
    "Store Location": "Tractor Supply 250 BELLE TERRE BLVD PALM COAST, Florida 32164",
    "Store Type": "Tractor Supply",
    "Phone Number": "386-586-2500",
    "address": "250 BELLE TERRE BLVD PALM, COAST, Florida 32164",
    "city": "COAST",
    "state": "Florida",
    "zip": "32164",
    "lat": 29.4742291,
    "lng": -81.2210714
  },
  {
    "Store Location": "Tractor Supply 2500 SOUTH BYRON BUTLER PKWY PERRY, Florida 32348",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-584-3060",
    "address": "2500 SOUTH BYRON BUTLER PKWY, PERRY, Florida 32348",
    "city": "PERRY",
    "state": "Florida",
    "zip": "32348",
    "lat": 30.08896919999999,
    "lng": -83.5731516
  },
  {
    "Store Location": "Tractor Supply 2619 HWY 1 MIMS, Florida 32754",
    "Store Type": "Tractor Supply",
    "Phone Number": "321-269-4215",
    "address": "2619 HWY 1, MIMS, Florida 32754",
    "city": "MIMS",
    "state": "Florida",
    "zip": "32754",
    "lat": 28.6707859,
    "lng": -80.8462656
  },
  {
    "Store Location": "Tractor Supply 2800 HWY 71 MARIANNA, Florida 32446",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-526-4022",
    "address": "2800 HWY 71, MARIANNA, Florida 32446",
    "city": "MARIANNA",
    "state": "Florida",
    "zip": "32446",
    "lat": 30.7677811,
    "lng": -85.2019522
  },
  {
    "Store Location": "Tractor Supply 3 WEST NINE MILE RD STE 16 PENSACOLA, Florida 32534",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-484-0805",
    "address": "3 WEST NINE MILE RD STE 16, PENSACOLA, Florida 32534",
    "city": "PENSACOLA",
    "state": "Florida",
    "zip": "32534",
    "lat": 30.53176239999999,
    "lng": -87.2746842
  },
  {
    "Store Location": "Tractor Supply 320 JAMES LEE BLVD WEST CRESTVIEW, Florida 32536",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-682-0945",
    "address": "320 JAMES LEE BLVD WEST, CRESTVIEW, Florida 32536",
    "city": "CRESTVIEW",
    "state": "Florida",
    "zip": "32536",
    "lat": 30.7642779,
    "lng": -86.5778457
  },
  {
    "Store Location": "Tractor Supply 3300 US HWY 27 SOUTH SEBRING, Florida 33870",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-385-1380",
    "address": "3300 US HWY 27 SOUTH, SEBRING, Florida 33870",
    "city": "SEBRING",
    "state": "Florida",
    "zip": "33870",
    "lat": 27.4693532,
    "lng": -81.4382421
  },
  {
    "Store Location": "Tractor Supply 3345 US 1 SOUTH SAINT AUGUSTINE, Florida 32086",
    "Store Type": "Tractor Supply",
    "Phone Number": "904-797-2970",
    "address": "3345 US 1 SOUTH SAINT, AUGUSTINE, Florida 32086",
    "city": "AUGUSTINE",
    "state": "Florida",
    "zip": "32086",
    "lat": 29.8328948,
    "lng": -81.3235966
  },
  {
    "Store Location": "Tractor Supply 3371 HWY 441 SOUTH OKEECHOBEE, Florida 34974",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-467-7844",
    "address": "3371 HWY 441 SOUTH, OKEECHOBEE, Florida 34974",
    "city": "OKEECHOBEE",
    "state": "Florida",
    "zip": "34974",
    "lat": 27.2131892,
    "lng": -80.8318103
  },
  {
    "Store Location": "Tractor Supply 35874 HWY 27 HAINES CITY, Florida 33844",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-419-2889",
    "address": "35874 HWY 27 HAINES, CITY, Florida 33844",
    "city": "CITY",
    "state": "Florida",
    "zip": "33844",
    "lat": 28.1224117,
    "lng": -81.6416088
  },
  {
    "Store Location": "Tractor Supply 3660 WEST NEWHAVEN AVE MELBOURNE, Florida 32904",
    "Store Type": "Tractor Supply",
    "Phone Number": "321-725-7857",
    "address": "3660 WEST NEWHAVEN AVE, MELBOURNE, Florida 32904",
    "city": "MELBOURNE",
    "state": "Florida",
    "zip": "32904",
    "lat": 28.0802322,
    "lng": -80.68357309999999
  },
  {
    "Store Location": "Tractor Supply 3751 W 1ST ST SANFORD, Florida 32771",
    "Store Type": "Tractor Supply",
    "Phone Number": "407-268-3421",
    "address": "3751 W 1ST ST, SANFORD, Florida 32771",
    "city": "SANFORD",
    "state": "Florida",
    "zip": "32771",
    "lat": 28.81011,
    "lng": -81.3158557
  },
  {
    "Store Location": "Tractor Supply 3826 SOUTH SUNCOAST BLVD HOMOSASSA, Florida 34448",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-621-0583",
    "address": "3826 SOUTH SUNCOAST BLVD, HOMOSASSA, Florida 34448",
    "city": "HOMOSASSA",
    "state": "Florida",
    "zip": "34448",
    "lat": 28.8062027,
    "lng": -82.5785947
  },
  {
    "Store Location": "Tractor Supply 4267 13TH ST SAINT CLOUD, Florida 34769",
    "Store Type": "Tractor Supply",
    "Phone Number": "407-498-0775",
    "address": "4267 13TH ST SAINT, CLOUD, Florida 34769",
    "city": "CLOUD",
    "state": "Florida",
    "zip": "34769",
    "lat": 28.2501127,
    "lng": -81.3157871
  },
  {
    "Store Location": "Tractor Supply 4404 STATE RD 64 EAST BRADENTON, Florida 34208",
    "Store Type": "Tractor Supply",
    "Phone Number": "941-748-2157",
    "address": "4404 STATE RD 64 EAST, BRADENTON, Florida 34208",
    "city": "BRADENTON",
    "state": "Florida",
    "zip": "34208",
    "lat": 27.4968065,
    "lng": -82.507125
  },
  {
    "Store Location": "Tractor Supply 463184 SR 200 YULEE, Florida 32097",
    "Store Type": "Tractor Supply",
    "Phone Number": "904-225-5252",
    "address": "463184 SR 200, YULEE, Florida 32097",
    "city": "YULEE",
    "state": "Florida",
    "zip": "32097",
    "lat": 30.6308562,
    "lng": -81.599285
  },
  {
    "Store Location": "Tractor Supply 4888 OKEECHOBE RD FORT PIERCE, Florida 34947",
    "Store Type": "Tractor Supply",
    "Phone Number": "772-468-4972",
    "address": "4888 OKEECHOBE RD FORT, PIERCE, Florida 34947",
    "city": "PIERCE",
    "state": "Florida",
    "zip": "34947",
    "lat": 27.4223051,
    "lng": -80.3750427
  },
  {
    "Store Location": "Tractor Supply 5359 WEST US HWY 90 LAKE CITY, Florida 32055",
    "Store Type": "Tractor Supply",
    "Phone Number": "386-758-4714",
    "address": "5359 WEST US HWY 90 LAKE, CITY, Florida 32055",
    "city": "CITY",
    "state": "Florida",
    "zip": "32055",
    "lat": 30.1894866,
    "lng": -82.7182753
  },
  {
    "Store Location": "Tractor Supply 5440 NORTHWEST 13TH ST GAINESVILLE, Florida 32653",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-367-4315",
    "address": "5440 NORTHWEST 13TH ST, GAINESVILLE, Florida 32653",
    "city": "GAINESVILLE",
    "state": "Florida",
    "zip": "32653",
    "lat": 29.7042958,
    "lng": -82.3466408
  },
  {
    "Store Location": "Tractor Supply 5743 WEST TENNESSEE ST TALLAHASSEE, Florida 32304",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-574-4961",
    "address": "5743 WEST TENNESSEE ST, TALLAHASSEE, Florida 32304",
    "city": "TALLAHASSEE",
    "state": "Florida",
    "zip": "32304",
    "lat": 30.4553993,
    "lng": -84.3673384
  },
  {
    "Store Location": "Tractor Supply 5881 BAYSHORE RD NORTH FORT MYERS, Florida 33917",
    "Store Type": "Tractor Supply",
    "Phone Number": "239-567-3023",
    "address": "5881 BAYSHORE RD NORTH FORT, MYERS, Florida 33917",
    "city": "MYERS",
    "state": "Florida",
    "zip": "33917",
    "lat": 26.6917208,
    "lng": -81.8607932
  },
  {
    "Store Location": "Tractor Supply 6450 HIGHWAY 22 PANAMA CITY, Florida 32404",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-874-8700",
    "address": "6450 HIGHWAY 22 PANAMA, CITY, Florida 32404",
    "city": "CITY",
    "state": "Florida",
    "zip": "32404",
    "lat": 30.151838,
    "lng": -85.5790293
  },
  {
    "Store Location": "Tractor Supply 653 BEAL PKWY N FORT WALTON BEACH, Florida 32547",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-863-0126",
    "address": "653 BEAL PKWY N FORT WALTON, BEACH, Florida 32547",
    "city": "BEACH",
    "state": "Florida",
    "zip": "32547",
    "lat": 30.4338758,
    "lng": -86.6385305
  },
  {
    "Store Location": "Tractor Supply 6531 CAROLINE ST MILTON, Florida 32570",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-623-3847",
    "address": "6531 CAROLINE ST, MILTON, Florida 32570",
    "city": "MILTON",
    "state": "Florida",
    "zip": "32570",
    "lat": 30.6182645,
    "lng": -87.0486492
  },
  {
    "Store Location": "Tractor Supply 6801 STATE RD 50 GROVELAND, Florida 34736",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-429-2502",
    "address": "6801 STATE RD 50, GROVELAND, Florida 34736",
    "city": "GROVELAND",
    "state": "Florida",
    "zip": "34736",
    "lat": 28.5600357,
    "lng": -81.8565478
  },
  {
    "Store Location": "Tractor Supply 6922 HWY 77 SOUTHPORT, Florida 32409",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-265-0231",
    "address": "6922 HWY 77, SOUTHPORT, Florida 32409",
    "city": "SOUTHPORT",
    "state": "Florida",
    "zip": "32409",
    "lat": 30.276007,
    "lng": -85.63744679999999
  },
  {
    "Store Location": "Tractor Supply 6945 HWY 98 NORTH LAKELAND, Florida 33809",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-815-2010",
    "address": "6945 HWY 98 NORTH, LAKELAND, Florida 33809",
    "city": "LAKELAND",
    "state": "Florida",
    "zip": "33809",
    "lat": 28.1310808,
    "lng": -81.9720124
  },
  {
    "Store Location": "Tractor Supply 7130 FRUITVILLE RD SARASOTA, Florida 34240",
    "Store Type": "Tractor Supply",
    "Phone Number": "941-342-0955",
    "address": "7130 FRUITVILLE RD, SARASOTA, Florida 34240",
    "city": "SARASOTA",
    "state": "Florida",
    "zip": "34240",
    "lat": 27.337106,
    "lng": -82.427667
  },
  {
    "Store Location": "Tractor Supply 7351 NORTH US HWY 441 OCALA, Florida 34475",
    "Store Type": "Tractor Supply",
    "Phone Number": "352-368-9937",
    "address": "7351 NORTH US HWY 441, OCALA, Florida 34475",
    "city": "OCALA",
    "state": "Florida",
    "zip": "34475",
    "lat": 29.2631465,
    "lng": -82.1503817
  },
  {
    "Store Location": "Tractor Supply 7431 GALL BLVD ZEPHYRHILLS, Florida 33541",
    "Store Type": "Tractor Supply",
    "Phone Number": "813-782-6500",
    "address": "7431 GALL BLVD, ZEPHYRHILLS, Florida 33541",
    "city": "ZEPHYRHILLS",
    "state": "Florida",
    "zip": "33541",
    "lat": 28.2658016,
    "lng": -82.19065119999999
  },
  {
    "Store Location": "Tractor Supply 801 DIXON BLVD STE 1100 COCOA, Florida 32922",
    "Store Type": "Tractor Supply",
    "Phone Number": "321-433-1101",
    "address": "801 DIXON BLVD STE 1100, COCOA, Florida 32922",
    "city": "COCOA",
    "state": "Florida",
    "zip": "32922",
    "lat": 28.373981,
    "lng": -80.73810999999999
  },
  {
    "Store Location": "Tractor Supply 8447 STATE RD 54 NEW PORT RICHEY, Florida 34655",
    "Store Type": "Tractor Supply",
    "Phone Number": "727-372-3450",
    "address": "8447 STATE RD 54 NEW PORT, RICHEY, Florida 34655",
    "city": "RICHEY",
    "state": "Florida",
    "zip": "34655",
    "lat": 28.2067696,
    "lng": -82.67490339999999
  },
  {
    "Store Location": "Tractor Supply 890 NORTH STATE RD 415 OSTEEN, Florida 32764",
    "Store Type": "Tractor Supply",
    "Phone Number": "407-268-3844",
    "address": "890 NORTH STATE RD 415, OSTEEN, Florida 32764",
    "city": "OSTEEN",
    "state": "Florida",
    "zip": "32764",
    "lat": 28.899928,
    "lng": -81.1340941
  },
  {
    "Store Location": "Tractor Supply 9025 NEW KINGS RD JACKSONVILLE, Florida 32219",
    "Store Type": "Tractor Supply",
    "Phone Number": "904-768-7499",
    "address": "9025 NEW KINGS RD, JACKSONVILLE, Florida 32219",
    "city": "JACKSONVILLE",
    "state": "Florida",
    "zip": "32219",
    "lat": 30.4146746,
    "lng": -81.7475079
  },
  {
    "Store Location": "Tractor Supply 931 US HWY 331 SOUTH STE C DEFUNIAK SPRINGS, Florida 32435",
    "Store Type": "Tractor Supply",
    "Phone Number": "850-951-1063",
    "address": "931 US HWY 331 SOUTH STE C DEFUNIAK, SPRINGS, Florida 32435",
    "city": "SPRINGS",
    "state": "Florida",
    "zip": "32435",
    "lat": 30.7084885,
    "lng": -86.1208673
  },
  {
    "Store Location": "Tractor Supply 9717 STATE RD 52 HUDSON, Florida 34669",
    "Store Type": "Tractor Supply",
    "Phone Number": "727-697-2972",
    "address": "9717 STATE RD 52, HUDSON, Florida 34669",
    "city": "HUDSON",
    "state": "Florida",
    "zip": "34669",
    "lat": 28.3312976,
    "lng": -82.6537937
  },
  {
    "Store Location": "Tractor Supply 975 WEST SUGARLAND HWY CLEWISTON, Florida 33440",
    "Store Type": "Tractor Supply",
    "Phone Number": "863-983-6926",
    "address": "975 WEST SUGARLAND HWY, CLEWISTON, Florida 33440",
    "city": "CLEWISTON",
    "state": "Florida",
    "zip": "33440",
    "lat": 26.755672,
    "lng": -80.94655999999999
  },
  {
    "Store Location": "Tractor Supply 10 PLAZA DR WINDER, Georgia 30680",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-586-5558",
    "address": "10 PLAZA DR, WINDER, Georgia 30680",
    "city": "WINDER",
    "state": "Georgia",
    "zip": "30680",
    "lat": 33.9917133,
    "lng": -83.75428060000002
  },
  {
    "Store Location": "Tractor Supply 10 RYAN BLVD NORTHEAST CARTERSVILLE, Georgia 30121",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-386-5751",
    "address": "10 RYAN BLVD NORTHEAST, CARTERSVILLE, Georgia 30121",
    "city": "CARTERSVILLE",
    "state": "Georgia",
    "zip": "30121",
    "lat": 34.2104507,
    "lng": -84.79923099999999
  },
  {
    "Store Location": "Tractor Supply 100 PLANTATION WAY LAGRANGE, Georgia 30241",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-884-9799",
    "address": "100 PLANTATION WAY, LAGRANGE, Georgia 30241",
    "city": "LAGRANGE",
    "state": "Georgia",
    "zip": "30241",
    "lat": 33.0396042,
    "lng": -84.98267349999999
  },
  {
    "Store Location": "Tractor Supply 1000A NORTH ST AUGUSTINE RD VALDOSTA, Georgia 31601",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-245-1084",
    "address": "1000A NORTH ST AUGUSTINE RD, VALDOSTA, Georgia 31601",
    "city": "VALDOSTA",
    "state": "Georgia",
    "zip": "31601",
    "lat": 30.8375845,
    "lng": -83.3193136
  },
  {
    "Store Location": "Tractor Supply 101 WEST FORT HOWARD RD RINCON, Georgia 31326",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-826-4800",
    "address": "101 WEST FORT HOWARD RD, RINCON, Georgia 31326",
    "city": "RINCON",
    "state": "Georgia",
    "zip": "31326",
    "lat": 32.2768289,
    "lng": -81.2317466
  },
  {
    "Store Location": "Tractor Supply 10161 LOCHRIDGE BLVD COVINGTON, Georgia 30014",
    "Store Type": "Tractor Supply",
    "Phone Number": "678-342-2177",
    "address": "10161 LOCHRIDGE BLVD, COVINGTON, Georgia 30014",
    "city": "COVINGTON",
    "state": "Georgia",
    "zip": "30014",
    "lat": 33.60442570000001,
    "lng": -83.8295009
  },
  {
    "Store Location": "Tractor Supply 103 TALMADGE DR STE B MOULTRIE, Georgia 31768",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-985-2740",
    "address": "103 TALMADGE DR STE B, MOULTRIE, Georgia 31768",
    "city": "MOULTRIE",
    "state": "Georgia",
    "zip": "31768",
    "lat": 31.1781733,
    "lng": -83.77186239999999
  },
  {
    "Store Location": "Tractor Supply 1075 HWY 19 NORTH THOMASTON, Georgia 30286",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-648-0013",
    "address": "1075 HWY 19 NORTH, THOMASTON, Georgia 30286",
    "city": "THOMASTON",
    "state": "Georgia",
    "zip": "30286",
    "lat": 32.873636,
    "lng": -84.32448579999999
  },
  {
    "Store Location": "Tractor Supply 1137 NORTH FIRST ST JESUP, Georgia 31545",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-427-8834",
    "address": "1137 NORTH FIRST ST, JESUP, Georgia 31545",
    "city": "JESUP",
    "state": "Georgia",
    "zip": "31545",
    "lat": 31.6193554,
    "lng": -81.87321519999999
  },
  {
    "Store Location": "Tractor Supply 115 GREYSTONE POWER BLVD DALLAS, Georgia 30157",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-443-3352",
    "address": "115 GREYSTONE POWER BLVD, DALLAS, Georgia 30157",
    "city": "DALLAS",
    "state": "Georgia",
    "zip": "30157",
    "lat": 33.9014112,
    "lng": -84.8004443
  },
  {
    "Store Location": "Tractor Supply 11788 HWY 27 SUMMERVILLE, Georgia 30747",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-857-3105",
    "address": "11788 HWY 27, SUMMERVILLE, Georgia 30747",
    "city": "SUMMERVILLE",
    "state": "Georgia",
    "zip": "30747",
    "lat": 34.5006223,
    "lng": -85.3293504
  },
  {
    "Store Location": "Tractor Supply 12110 CUMMING HWY CANTON, Georgia 30115",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-205-5227",
    "address": "12110 CUMMING HWY, CANTON, Georgia 30115",
    "city": "CANTON",
    "state": "Georgia",
    "zip": "30115",
    "lat": 34.2412168,
    "lng": -84.2960925
  },
  {
    "Store Location": "Tractor Supply 1235 SAINT PATRICKS DR PERRY, Georgia 31069",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-987-7962",
    "address": "1235 SAINT PATRICKS DR, PERRY, Georgia 31069",
    "city": "PERRY",
    "state": "Georgia",
    "zip": "31069",
    "lat": 32.4755878,
    "lng": -83.7414951
  },
  {
    "Store Location": "Tractor Supply 1246 SOUTH HARRIS ST SANDERSVILLE, Georgia 31082",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-552-2962",
    "address": "1246 SOUTH HARRIS ST, SANDERSVILLE, Georgia 31082",
    "city": "SANDERSVILLE",
    "state": "Georgia",
    "zip": "31082",
    "lat": 32.9542693,
    "lng": -82.81137629999999
  },
  {
    "Store Location": "Tractor Supply 130 EAST MAIN ST STE A FORSYTH, Georgia 31029",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-992-6621",
    "address": "130 EAST MAIN ST STE A, FORSYTH, Georgia 31029",
    "city": "FORSYTH",
    "state": "Georgia",
    "zip": "31029",
    "lat": 33.0346163,
    "lng": -83.93359509999999
  },
  {
    "Store Location": "Tractor Supply 1314 SOUTH MADISON AVE DOUGLAS, Georgia 31533",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-384-4474",
    "address": "1314 SOUTH MADISON AVE, DOUGLAS, Georgia 31533",
    "city": "DOUGLAS",
    "state": "Georgia",
    "zip": "31533",
    "lat": 31.4901274,
    "lng": -82.84794049999999
  },
  {
    "Store Location": "Tractor Supply 1407A EAST 16TH AVE CORDELE, Georgia 31015",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-273-7585",
    "address": "1407A EAST 16TH AVE, CORDELE, Georgia 31015",
    "city": "CORDELE",
    "state": "Georgia",
    "zip": "31015",
    "lat": 31.96174439999999,
    "lng": -83.75935600000001
  },
  {
    "Store Location": "Tractor Supply 1484 ATHENS HWY GRAYSON, Georgia 30017",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-972-9399",
    "address": "1484 ATHENS HWY, GRAYSON, Georgia 30017",
    "city": "GRAYSON",
    "state": "Georgia",
    "zip": "30017",
    "lat": 33.8590342,
    "lng": -83.9765448
  },
  {
    "Store Location": "Tractor Supply 149 SOUTH VIRGINIA AVE TIFTON, Georgia 31794",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-386-5202",
    "address": "149 SOUTH VIRGINIA AVE, TIFTON, Georgia 31794",
    "city": "TIFTON",
    "state": "Georgia",
    "zip": "31794",
    "lat": 31.4544701,
    "lng": -83.52576049999999
  },
  {
    "Store Location": "Tractor Supply 15086 US HWY 19 SOUTH THOMASVILLE, Georgia 31757",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-228-9844",
    "address": "15086 US HWY 19 SOUTH, THOMASVILLE, Georgia 31757",
    "city": "THOMASVILLE",
    "state": "Georgia",
    "zip": "31757",
    "lat": 30.855161,
    "lng": -83.94440689999999
  },
  {
    "Store Location": "Tractor Supply 1515 LUCKY ST GRIFFIN, Georgia 30223",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-227-4490",
    "address": "1515 LUCKY ST, GRIFFIN, Georgia 30223",
    "city": "GRIFFIN",
    "state": "Georgia",
    "zip": "30223",
    "lat": 33.2809555,
    "lng": -84.2899911
  },
  {
    "Store Location": "Tractor Supply 1520 TALLAHASSEE HWY BAINBRIDGE, Georgia 39819",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-246-9190",
    "address": "1520 TALLAHASSEE HWY, BAINBRIDGE, Georgia 39819",
    "city": "BAINBRIDGE",
    "state": "Georgia",
    "zip": "39819",
    "lat": 30.882012,
    "lng": -84.5663974
  },
  {
    "Store Location": "Tractor Supply 1541 ANDERSON HWY STE A HARTWELL, Georgia 30643",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-376-1833",
    "address": "1541 ANDERSON HWY STE A, HARTWELL, Georgia 30643",
    "city": "HARTWELL",
    "state": "Georgia",
    "zip": "30643",
    "lat": 34.35397,
    "lng": -82.90442999999999
  },
  {
    "Store Location": "Tractor Supply 156 MARTIN LUTHER KING JR BLVD MONROE, Georgia 30655",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-207-1670",
    "address": "156 MARTIN LUTHER KING JR BLVD, MONROE, Georgia 30655",
    "city": "MONROE",
    "state": "Georgia",
    "zip": "30655",
    "lat": 33.7940231,
    "lng": -83.74534469999999
  },
  {
    "Store Location": "Tractor Supply 1565 HWY 81 EAST MCDONOUGH, Georgia 30252",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-914-2500",
    "address": "1565 HWY 81 EAST, MCDONOUGH, Georgia 30252",
    "city": "MCDONOUGH",
    "state": "Georgia",
    "zip": "30252",
    "lat": 33.429833,
    "lng": -84.1016444
  },
  {
    "Store Location": "Tractor Supply 1584 BOONE ST KINGSLAND, Georgia 31548",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-882-1810",
    "address": "1584 BOONE ST, KINGSLAND, Georgia 31548",
    "city": "KINGSLAND",
    "state": "Georgia",
    "zip": "31548",
    "lat": 30.782605,
    "lng": -81.6404834
  },
  {
    "Store Location": "Tractor Supply 1600 ROME HWY CEDARTOWN, Georgia 30125",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-748-7774",
    "address": "1600 ROME HWY, CEDARTOWN, Georgia 30125",
    "city": "CEDARTOWN",
    "state": "Georgia",
    "zip": "30125",
    "lat": 34.0468669,
    "lng": -85.23341880000001
  },
  {
    "Store Location": "Tractor Supply 1785 BATTLEFIELD PKWY FORT OGLETHORPE, Georgia 30742",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-861-4536",
    "address": "1785 BATTLEFIELD PKWY FORT, OGLETHORPE, Georgia 30742",
    "city": "OGLETHORPE",
    "state": "Georgia",
    "zip": "30742",
    "lat": 34.9512073,
    "lng": -85.2349672
  },
  {
    "Store Location": "Tractor Supply 1850 NORTH COLUMBIA ST MILLEDGEVILLE, Georgia 31061",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-454-1911",
    "address": "1850 NORTH COLUMBIA ST, MILLEDGEVILLE, Georgia 31061",
    "city": "MILLEDGEVILLE",
    "state": "Georgia",
    "zip": "31061",
    "lat": 33.1031918,
    "lng": -83.25244070000001
  },
  {
    "Store Location": "Tractor Supply 20 COMMERCE DR CHATSWORTH, Georgia 30705",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-695-2136",
    "address": "20 COMMERCE DR, CHATSWORTH, Georgia 30705",
    "city": "CHATSWORTH",
    "state": "Georgia",
    "zip": "30705",
    "lat": 34.782229,
    "lng": -84.8202127
  },
  {
    "Store Location": "Tractor Supply 201 HWY 19 SOUTH AMERICUS, Georgia 31719",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-928-3400",
    "address": "201 HWY 19 SOUTH, AMERICUS, Georgia 31719",
    "city": "AMERICUS",
    "state": "Georgia",
    "zip": "31719",
    "lat": 32.0643846,
    "lng": -84.25146289999999
  },
  {
    "Store Location": "Tractor Supply 2103 MEMORIAL DR STE A WAYCROSS, Georgia 31501",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-285-9188",
    "address": "2103 MEMORIAL DR STE A, WAYCROSS, Georgia 31501",
    "city": "WAYCROSS",
    "state": "Georgia",
    "zip": "31501",
    "lat": 31.2032289,
    "lng": -82.3286567
  },
  {
    "Store Location": "Tractor Supply 2220 EATONTON RD MADISON, Georgia 30650",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-752-1929",
    "address": "2220 EATONTON RD, MADISON, Georgia 30650",
    "city": "MADISON",
    "state": "Georgia",
    "zip": "30650",
    "lat": 33.5468764,
    "lng": -83.4699399
  },
  {
    "Store Location": "Tractor Supply 2250 HOMER RD COMMERCE, Georgia 30529",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-335-0090",
    "address": "2250 HOMER RD, COMMERCE, Georgia 30529",
    "city": "COMMERCE",
    "state": "Georgia",
    "zip": "30529",
    "lat": 34.2361937,
    "lng": -83.45249319999999
  },
  {
    "Store Location": "Tractor Supply 2305 EAST 1ST ST STE 1 VIDALIA, Georgia 30474",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-538-1033",
    "address": "2305 EAST 1ST ST STE 1, VIDALIA, Georgia 30474",
    "city": "VIDALIA",
    "state": "Georgia",
    "zip": "30474",
    "lat": 32.2063966,
    "lng": -82.3829019
  },
  {
    "Store Location": "Tractor Supply 2435 HWY 80 WEST DUBLIN, Georgia 31021",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-272-4997",
    "address": "2435 HWY 80 WEST, DUBLIN, Georgia 31021",
    "city": "DUBLIN",
    "state": "Georgia",
    "zip": "31021",
    "lat": 32.5515476,
    "lng": -82.974893
  },
  {
    "Store Location": "Tractor Supply 2518 CLEVELAND HWY STE 8 DALTON, Georgia 30721",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-428-0035",
    "address": "2518 CLEVELAND HWY STE 8, DALTON, Georgia 30721",
    "city": "DALTON",
    "state": "Georgia",
    "zip": "30721",
    "lat": 34.82131530000001,
    "lng": -84.94362799999999
  },
  {
    "Store Location": "Tractor Supply 262 OCILLA HWY STE 2 FITZGERALD, Georgia 31750",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-423-3762",
    "address": "262 OCILLA HWY STE 2, FITZGERALD, Georgia 31750",
    "city": "FITZGERALD",
    "state": "Georgia",
    "zip": "31750",
    "lat": 31.700699,
    "lng": -83.2486196
  },
  {
    "Store Location": "Tractor Supply 2661 HWY 92 FAIRBURN RD DOUGLASVILLE, Georgia 30135",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-577-6280",
    "address": "2661 HWY 92 FAIRBURN RD, DOUGLASVILLE, Georgia 30135",
    "city": "DOUGLASVILLE",
    "state": "Georgia",
    "zip": "30135",
    "lat": 33.7331438,
    "lng": -84.6709552
  },
  {
    "Store Location": "Tractor Supply 270 BOBBY JONES EXPY STE 190 AUGUSTA, Georgia 30907",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-854-9088",
    "address": "270 BOBBY JONES EXPY STE 190, AUGUSTA, Georgia 30907",
    "city": "AUGUSTA",
    "state": "Georgia",
    "zip": "30907",
    "lat": 33.5048606,
    "lng": -82.0859917
  },
  {
    "Store Location": "Tractor Supply 2761 LEDO RD ALBANY, Georgia 31707",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-420-1487",
    "address": "2761 LEDO RD, ALBANY, Georgia 31707",
    "city": "ALBANY",
    "state": "Georgia",
    "zip": "31707",
    "lat": 31.6233494,
    "lng": -84.2106276
  },
  {
    "Store Location": "Tractor Supply 2860 EAST CHEROKEE DR CANTON, Georgia 30115",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-704-8011",
    "address": "2860 EAST CHEROKEE DR, CANTON, Georgia 30115",
    "city": "CANTON",
    "state": "Georgia",
    "zip": "30115",
    "lat": 34.1734702,
    "lng": -84.4193159
  },
  {
    "Store Location": "Tractor Supply 294 EAST CHURCH ST JASPER, Georgia 30143",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-301-1002",
    "address": "294 EAST CHURCH ST, JASPER, Georgia 30143",
    "city": "JASPER",
    "state": "Georgia",
    "zip": "30143",
    "lat": 34.4666419,
    "lng": -84.42528329999999
  },
  {
    "Store Location": "Tractor Supply 300 HOPKINS CORNER DR WAYNESBORO, Georgia 30830",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-437-1708",
    "address": "300 HOPKINS CORNER DR, WAYNESBORO, Georgia 30830",
    "city": "WAYNESBORO",
    "state": "Georgia",
    "zip": "30830",
    "lat": 33.1064334,
    "lng": -82.0225936
  },
  {
    "Store Location": "Tractor Supply 310 HABERSHAM HILLS CIR CORNELIA, Georgia 30531",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-778-3300",
    "address": "310 HABERSHAM HILLS CIR, CORNELIA, Georgia 30531",
    "city": "CORNELIA",
    "state": "Georgia",
    "zip": "30531",
    "lat": 34.545274,
    "lng": -83.54337
  },
  {
    "Store Location": "Tractor Supply 3640 MUNDY MILL RD STE 170 GAINESVILLE, Georgia 30504",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-287-9686",
    "address": "3640 MUNDY MILL RD STE 170, GAINESVILLE, Georgia 30504",
    "city": "GAINESVILLE",
    "state": "Georgia",
    "zip": "30504",
    "lat": 34.2301892,
    "lng": -83.86535339999999
  },
  {
    "Store Location": "Tractor Supply 375 EAST PARKER ST BAXLEY, Georgia 31513",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-366-7876",
    "address": "375 EAST PARKER ST, BAXLEY, Georgia 31513",
    "city": "BAXLEY",
    "state": "Georgia",
    "zip": "31513",
    "lat": 31.7775355,
    "lng": -82.34209589999999
  },
  {
    "Store Location": "Tractor Supply 400 WEST 4TH STREET ADEL, Georgia 31620 #N/A",
    "Store Type": "Tractor Supply",
    "Phone Number": "Not found",
    "address": "400 WEST 4TH STREET ADEL, Georgia 31620 #N/A,  ",
    "city": "Georgia 31620 #N/A",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 31.1365983,
    "lng": -83.4283827
  },
  {
    "Store Location": "Tractor Supply 420 HWY 411 SOUTHEAST ROME, Georgia 30161",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-291-4450",
    "address": "420 HWY 411 SOUTHEAST, ROME, Georgia 30161",
    "city": "ROME",
    "state": "Georgia",
    "zip": "30161",
    "lat": 34.2179536,
    "lng": -85.14112689999999
  },
  {
    "Store Location": "Tractor Supply 438 NORTHSIDE DR EAST STATESBORO, Georgia 30458",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-489-2411",
    "address": "438 NORTHSIDE DR EAST, STATESBORO, Georgia 30458",
    "city": "STATESBORO",
    "state": "Georgia",
    "zip": "30458",
    "lat": 32.4396433,
    "lng": -81.7618842
  },
  {
    "Store Location": "Tractor Supply 4420 LEXINGTON RD ATHENS, Georgia 30605",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-425-8524",
    "address": "4420 LEXINGTON RD, ATHENS, Georgia 30605",
    "city": "ATHENS",
    "state": "Georgia",
    "zip": "30605",
    "lat": 33.9304553,
    "lng": -83.3085699
  },
  {
    "Store Location": "Tractor Supply 4461 HWY 20 SOUTHEAST CONYERS, Georgia 30013",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-760-7667",
    "address": "4461 HWY 20 SOUTHEAST, CONYERS, Georgia 30013",
    "city": "CONYERS",
    "state": "Georgia",
    "zip": "30013",
    "lat": 33.5699817,
    "lng": -84.0169779
  },
  {
    "Store Location": "Tractor Supply 490 HWY 53 SOUTH EAST CALHOUN, Georgia 30701",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-629-2022",
    "address": "490 HWY 53 SOUTH EAST, CALHOUN, Georgia 30701",
    "city": "CALHOUN",
    "state": "Georgia",
    "zip": "30701",
    "lat": 34.473597,
    "lng": -84.9286632
  },
  {
    "Store Location": "Tractor Supply 502 ASHBURN HIGHWAY SYLVESTER, Georgia 31791",
    "Store Type": "Tractor Supply",
    "Phone Number": "229-777-7733",
    "address": "502 ASHBURN HIGHWAY, SYLVESTER, Georgia 31791",
    "city": "SYLVESTER",
    "state": "Georgia",
    "zip": "31791",
    "lat": 31.5395017,
    "lng": -83.82797049999999
  },
  {
    "Store Location": "Tractor Supply 5301 EISENHOWER PKWY MACON, Georgia 31206",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-405-7566",
    "address": "5301 EISENHOWER PKWY, MACON, Georgia 31206",
    "city": "MACON",
    "state": "Georgia",
    "zip": "31206",
    "lat": 32.8043896,
    "lng": -83.7372624
  },
  {
    "Store Location": "Tractor Supply 5940 NEW JESUP HWY BRUNSWICK, Georgia 31523",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-265-0313",
    "address": "5940 NEW JESUP HWY, BRUNSWICK, Georgia 31523",
    "city": "BRUNSWICK",
    "state": "Georgia",
    "zip": "31523",
    "lat": 31.2381468,
    "lng": -81.5381299
  },
  {
    "Store Location": "Tractor Supply 6010 WATSON BLVD BYRON, Georgia 31008",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-953-3344",
    "address": "6010 WATSON BLVD, BYRON, Georgia 31008",
    "city": "BYRON",
    "state": "Georgia",
    "zip": "31008",
    "lat": 32.6156093,
    "lng": -83.71186259999999
  },
  {
    "Store Location": "Tractor Supply 6713 FLAT ROCK CT STE 100 MIDLAND, Georgia 31820",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-568-6165",
    "address": "6713 FLAT ROCK CT STE 100, MIDLAND, Georgia 31820",
    "city": "MIDLAND",
    "state": "Georgia",
    "zip": "31820",
    "lat": 32.5427972,
    "lng": -84.87202429999999
  },
  {
    "Store Location": "Tractor Supply 676 WASHINGTON RD THOMSON, Georgia 30824",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-595-1151",
    "address": "676 WASHINGTON RD, THOMSON, Georgia 30824",
    "city": "THOMSON",
    "state": "Georgia",
    "zip": "30824",
    "lat": 33.4842812,
    "lng": -82.50310759999999
  },
  {
    "Store Location": "Tractor Supply 684 SOUTH MAIN STREET SWAINSBORO, Georgia 30401",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-237-8878",
    "address": "684 SOUTH MAIN STREET, SWAINSBORO, Georgia 30401",
    "city": "SWAINSBORO",
    "state": "Georgia",
    "zip": "30401",
    "lat": 32.5739215,
    "lng": -82.3176656
  },
  {
    "Store Location": "Tractor Supply 6921 HWY 53 EAST DAWSONVILLE, Georgia 30534",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-265-2430",
    "address": "6921 HWY 53 EAST, DAWSONVILLE, Georgia 30534",
    "city": "DAWSONVILLE",
    "state": "Georgia",
    "zip": "30534",
    "lat": 34.3580372,
    "lng": -84.0307371
  },
  {
    "Store Location": "Tractor Supply 709 1ST AVE EAST ELLIJAY, Georgia 30540",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-635-7946",
    "address": "709 1ST AVE EAST, ELLIJAY, Georgia 30540",
    "city": "ELLIJAY",
    "state": "Georgia",
    "zip": "30540",
    "lat": 34.6775619,
    "lng": -84.4755876
  },
  {
    "Store Location": "Tractor Supply 709 EAST ELBERT ST ELBERTON, Georgia 30635",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-283-4097",
    "address": "709 EAST ELBERT ST, ELBERTON, Georgia 30635",
    "city": "ELBERTON",
    "state": "Georgia",
    "zip": "30635",
    "lat": 34.1018701,
    "lng": -82.84883289999999
  },
  {
    "Store Location": "Tractor Supply 766 WEST OGLETHORPE HWY HINESVILLE, Georgia 31313",
    "Store Type": "Tractor Supply",
    "Phone Number": "912-877-5256",
    "address": "766 WEST OGLETHORPE HWY, HINESVILLE, Georgia 31313",
    "city": "HINESVILLE",
    "state": "Georgia",
    "zip": "31313",
    "lat": 31.8241005,
    "lng": -81.5981103
  },
  {
    "Store Location": "Tractor Supply 868 SOUTH MAIN ST UNIT 100 CLEVELAND, Georgia 30528",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-348-1219",
    "address": "868 SOUTH MAIN ST UNIT 100, CLEVELAND, Georgia 30528",
    "city": "CLEVELAND",
    "state": "Georgia",
    "zip": "30528",
    "lat": 34.58417,
    "lng": -83.76232
  },
  {
    "Store Location": "Tractor Supply 90 MARKETPLACE DR NEWNAN, Georgia 30265",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-251-3439",
    "address": "90 MARKETPLACE DR, NEWNAN, Georgia 30265",
    "city": "NEWNAN",
    "state": "Georgia",
    "zip": "30265",
    "lat": 33.4104963,
    "lng": -84.68901439999999
  },
  {
    "Store Location": "Tractor Supply 912 SOUTH PARK ST CARROLLTON, Georgia 30117",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-832-3536",
    "address": "912 SOUTH PARK ST, CARROLLTON, Georgia 30117",
    "city": "CARROLLTON",
    "state": "Georgia",
    "zip": "30117",
    "lat": 33.5642186,
    "lng": -85.0740012
  },
  {
    "Store Location": "Tractor Supply 939 GLYNN ST NORTH STE B FAYETTEVILLE, Georgia 30214",
    "Store Type": "Tractor Supply",
    "Phone Number": "770-716-1738",
    "address": "939 GLYNN ST NORTH STE B, FAYETTEVILLE, Georgia 30214",
    "city": "FAYETTEVILLE",
    "state": "Georgia",
    "zip": "30214",
    "lat": 33.4648618,
    "lng": -84.4463933
  },
  {
    "Store Location": "Tractor Supply 97 HIGH PARK DR BLUE RIDGE, Georgia 30513",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-946-3020",
    "address": "97 HIGH PARK DR BLUE, RIDGE, Georgia 30513",
    "city": "RIDGE",
    "state": "Georgia",
    "zip": "30513",
    "lat": 34.8835047,
    "lng": -84.2959434
  },
  {
    "Store Location": "Tractor Supply 993 INDIAN DR EASTMAN, Georgia 31023",
    "Store Type": "Tractor Supply",
    "Phone Number": "478-374-5203",
    "address": "993 INDIAN DR, EASTMAN, Georgia 31023",
    "city": "EASTMAN",
    "state": "Georgia",
    "zip": "31023",
    "lat": 32.1810186,
    "lng": -83.1786156
  },
  {
    "Store Location": "Tractor Supply 998 BIG A RD TOCCOA, Georgia 30577",
    "Store Type": "Tractor Supply",
    "Phone Number": "706-886-3153",
    "address": "998 BIG A RD, TOCCOA, Georgia 30577",
    "city": "TOCCOA",
    "state": "Georgia",
    "zip": "30577",
    "lat": 34.5693115,
    "lng": -83.3095795
  },
  {
    "Store Location": "Tractor Supply 1905 4TH ST MASON CITY, Iowa 50401",
    "Store Type": "Tractor Supply",
    "Phone Number": "641-424-2565",
    "address": "1905 4TH ST MASON, CITY, Iowa 50401",
    "city": "CITY",
    "state": "Iowa",
    "zip": "50401",
    "lat": 43.1471697,
    "lng": -93.2301665
  },
  {
    "Store Location": "Tractor Supply 2068 BROOKVILLE RD FAIRFIELD, Iowa 52556",
    "Store Type": "Tractor Supply",
    "Phone Number": "641-472-6535",
    "address": "2068 BROOKVILLE RD, FAIRFIELD, Iowa 52556",
    "city": "FAIRFIELD",
    "state": "Iowa",
    "zip": "52556",
    "lat": 41.0091669,
    "lng": -92.0027314
  },
  {
    "Store Location": "Tractor Supply 2850 NORTH COURT RD OTTUMWA, Iowa 52501",
    "Store Type": "Tractor Supply",
    "Phone Number": "641-682-5459",
    "address": "2850 NORTH COURT RD, OTTUMWA, Iowa 52501",
    "city": "OTTUMWA",
    "state": "Iowa",
    "zip": "52501",
    "lat": 41.0634987,
    "lng": -92.408969
  },
  {
    "Store Location": "Tractor Supply 329 VETERANS MEMORIAL HWY COUNCIL BLUFFS, Iowa 51501",
    "Store Type": "Tractor Supply",
    "Phone Number": "712-366-2451",
    "address": "329 VETERANS MEMORIAL HWY COUNCIL, BLUFFS, Iowa 51501",
    "city": "BLUFFS",
    "state": "Iowa",
    "zip": "51501",
    "lat": 41.2184833,
    "lng": -95.8499461
  },
  {
    "Store Location": "Tractor Supply 4001 ASH ST DE SOTO, Iowa 50069",
    "Store Type": "Tractor Supply",
    "Phone Number": "515-834-2181",
    "address": "4001 ASH ST DE, SOTO, Iowa 50069",
    "city": "SOTO",
    "state": "Iowa",
    "zip": "50069",
    "lat": 41.5398024,
    "lng": -94.00825979999999
  },
  {
    "Store Location": "Tractor Supply 4040 UNIVERSITY AVE WATERLOO, Iowa 50701",
    "Store Type": "Tractor Supply",
    "Phone Number": "319-232-6517",
    "address": "4040 UNIVERSITY AVE, WATERLOO, Iowa 50701",
    "city": "WATERLOO",
    "state": "Iowa",
    "zip": "50701",
    "lat": 42.50604209999999,
    "lng": -92.4055928
  },
  {
    "Store Location": "Tractor Supply 405 SOUTHEAST ORALABOR RD ANKENY, Iowa 50021",
    "Store Type": "Tractor Supply",
    "Phone Number": "515-965-8774",
    "address": "405 SOUTHEAST ORALABOR RD, ANKENY, Iowa 50021",
    "city": "ANKENY",
    "state": "Iowa",
    "zip": "50021",
    "lat": 41.7019554,
    "lng": -93.59438560000001
  },
  {
    "Store Location": "Tractor Supply 612 NEW YORK AVE CRESTON, Iowa 50801",
    "Store Type": "Tractor Supply",
    "Phone Number": "641-782-2201",
    "address": "612 NEW YORK AVE, CRESTON, Iowa 50801",
    "city": "CRESTON",
    "state": "Iowa",
    "zip": "50801",
    "lat": 41.0494251,
    "lng": -94.37661759999999
  },
  {
    "Store Location": "Tractor Supply 6622 SIXTH ST SOUTHWEST CEDAR RAPIDS, Iowa 52404",
    "Store Type": "Tractor Supply",
    "Phone Number": "319-363-2023",
    "address": "6622 SIXTH ST SOUTHWEST CEDAR, RAPIDS, Iowa 52404",
    "city": "RAPIDS",
    "state": "Iowa",
    "zip": "52404",
    "lat": 41.9140383,
    "lng": -91.6772029
  },
  {
    "Store Location": "Tractor Supply 1019 SOUTH WASHINGTON AVE EMMETT, Idaho 83617",
    "Store Type": "Tractor Supply",
    "Phone Number": "208-365-2088",
    "address": "1019 SOUTH WASHINGTON AVE, EMMETT, Idaho 83617",
    "city": "EMMETT",
    "state": "Idaho",
    "zip": "83617",
    "lat": 43.8655337,
    "lng": -116.5010637
  },
  {
    "Store Location": "Tractor Supply 131 WEST NEIDER AVENUE COEUR D ALENE, Idaho 83815",
    "Store Type": "Tractor Supply",
    "Phone Number": "208-665-1417",
    "address": "131 WEST NEIDER AVENUE COEUR D, ALENE, Idaho 83815",
    "city": "ALENE",
    "state": "Idaho",
    "zip": "83815",
    "lat": 47.7088882,
    "lng": -116.788688
  },
  {
    "Store Location": "Tractor Supply 1500 WEST MAIN ST MIDDLETON, Idaho 83644",
    "Store Type": "Tractor Supply",
    "Phone Number": "208-585-9800",
    "address": "1500 WEST MAIN ST, MIDDLETON, Idaho 83644",
    "city": "MIDDLETON",
    "state": "Idaho",
    "zip": "83644",
    "lat": 43.7072532,
    "lng": -116.6455238
  },
  {
    "Store Location": "Tractor Supply 1800 GARRETT WAY STE 35 POCATELLO, Idaho 83201",
    "Store Type": "Tractor Supply",
    "Phone Number": "208-478-6445",
    "address": "1800 GARRETT WAY STE 35, POCATELLO, Idaho 83201",
    "city": "POCATELLO",
    "state": "Idaho",
    "zip": "83201",
    "lat": 42.877193,
    "lng": -112.4577865
  },
  {
    "Store Location": "Tractor Supply 67 SELKIRK WAY OLDTOWN, Idaho 83822",
    "Store Type": "Tractor Supply",
    "Phone Number": "208-437-0110",
    "address": "67 SELKIRK WAY, OLDTOWN, Idaho 83822",
    "city": "OLDTOWN",
    "state": "Idaho",
    "zip": "83822",
    "lat": 48.1881529,
    "lng": -117.0275422
  },
  {
    "Store Location": "Tractor Supply 979 NORTH MERIDIAN RD KUNA, Idaho 83634",
    "Store Type": "Tractor Supply",
    "Phone Number": "208-922-2800",
    "address": "979 NORTH MERIDIAN RD, KUNA, Idaho 83634",
    "city": "KUNA",
    "state": "Idaho",
    "zip": "83634",
    "lat": 43.4976219,
    "lng": -116.3957029
  },
  {
    "Store Location": "Tractor Supply 10 A CLINTON PLAZA CLINTON, Illinois 61727",
    "Store Type": "Tractor Supply",
    "Phone Number": "217-935-8588",
    "address": "10 A CLINTON PLAZA, CLINTON, Illinois 61727",
    "city": "CLINTON",
    "state": "Illinois",
    "zip": "61727",
    "lat": 40.1488702,
    "lng": -88.9764239
  },
  {
    "Store Location": "Tractor Supply 1106 SOUTH VAN BUREN ST NEWTON, Illinois 62448",
    "Store Type": "Tractor Supply",
    "Phone Number": "618-783-0766",
    "address": "1106 SOUTH VAN BUREN ST, NEWTON, Illinois 62448",
    "city": "NEWTON",
    "state": "Illinois",
    "zip": "62448",
    "lat": 38.97905859999999,
    "lng": -88.1598499
  },
  {
    "Store Location": "Tractor Supply 1201 SOUTH DIVISION ST HARVARD, Illinois 60033",
    "Store Type": "Tractor Supply",
    "Phone Number": "815-943-4104",
    "address": "1201 SOUTH DIVISION ST, HARVARD, Illinois 60033",
    "city": "HARVARD",
    "state": "Illinois",
    "zip": "60033",
    "lat": 42.403249,
    "lng": -88.61516259999999
  },
  {
    "Store Location": "Tractor Supply 1325 MAIN ST ANTIOCH, Illinois 60002",
    "Store Type": "Tractor Supply",
    "Phone Number": "847-838-8050",
    "address": "1325 MAIN ST, ANTIOCH, Illinois 60002",
    "city": "ANTIOCH",
    "state": "Illinois",
    "zip": "60002",
    "lat": 42.4662939,
    "lng": -88.0917553
  },
  {
    "Store Location": "Tractor Supply 150 SOUTH KENNEDY DR STE 8A CARPENTERSVILLE, Illinois 60110",
    "Store Type": "Tractor Supply",
    "Phone Number": "847-428-0834",
    "address": "150 SOUTH KENNEDY DR STE 8A, CARPENTERSVILLE, Illinois 60110",
    "city": "CARPENTERSVILLE",
    "state": "Illinois",
    "zip": "60110",
    "lat": 42.1346682,
    "lng": -88.2581403
  },
  {
    "Store Location": "Tractor Supply 1570 EAST STATE RTE 15 BELLEVILLE, Illinois 62221",
    "Store Type": "Tractor Supply",
    "Phone Number": "618-355-9512",
    "address": "1570 EAST STATE RTE 15, BELLEVILLE, Illinois 62221",
    "city": "BELLEVILLE",
    "state": "Illinois",
    "zip": "62221",
    "lat": 38.4750934,
    "lng": -89.92989349999999
  },
  {
    "Store Location": "Tractor Supply 1810 SOUTH GALENA AVE DIXON, Illinois 61021",
    "Store Type": "Tractor Supply",
    "Phone Number": "815-284-0422",
    "address": "1810 SOUTH GALENA AVE, DIXON, Illinois 61021",
    "city": "DIXON",
    "state": "Illinois",
    "zip": "61021",
    "lat": 41.8217191,
    "lng": -89.47254410000001
  },
  {
    "Store Location": "Tractor Supply 18100 WILLIAM RD CARLYLE, Illinois 62231",
    "Store Type": "Tractor Supply",
    "Phone Number": "618-594-8040",
    "address": "18100 WILLIAM RD, CARLYLE, Illinois 62231",
    "city": "CARLYLE",
    "state": "Illinois",
    "zip": "62231",
    "lat": 38.627356,
    "lng": -89.3708781
  },
  {
    "Store Location": "Tractor Supply 2110 NORTH MAIN ST PRINCETON, Illinois 61356",
    "Store Type": "Tractor Supply",
    "Phone Number": "815-875-1176",
    "address": "2110 NORTH MAIN ST, PRINCETON, Illinois 61356",
    "city": "PRINCETON",
    "state": "Illinois",
    "zip": "61356",
    "lat": 41.3956749,
    "lng": -89.46986059999999
  },
  {
    "Store Location": "Tractor Supply 2161 EAST LARAWAY ROAD NEW LENOX, Illinois 60451",
    "Store Type": "Tractor Supply",
    "Phone Number": "815-463-9444",
    "address": "2161 EAST LARAWAY ROAD NEW, LENOX, Illinois 60451",
    "city": "LENOX",
    "state": "Illinois",
    "zip": "60451",
    "lat": 41.48565079999999,
    "lng": -87.9216028
  },
  {
    "Store Location": "Tractor Supply 2238 WESTGATE DR BLOOMINGTON, Illinois 61704",
    "Store Type": "Tractor Supply",
    "Phone Number": "309-829-8511",
    "address": "2238 WESTGATE DR, BLOOMINGTON, Illinois 61704",
    "city": "BLOOMINGTON",
    "state": "Illinois",
    "zip": "61704",
    "lat": 40.4882387,
    "lng": -89.0432754
  },
  {
    "Store Location": "Tractor Supply 2605 WEST MAIN ST SHELBYVILLE, Illinois 62565",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7536",
    "address": "2605 WEST MAIN ST, SHELBYVILLE, Illinois 62565",
    "city": "SHELBYVILLE",
    "state": "Illinois",
    "zip": "62565",
    "lat": 39.406351,
    "lng": -88.8260755
  },
  {
    "Store Location": "Tractor Supply 3001 HOMER ADAMS PKWY ALTON, Illinois 62002",
    "Store Type": "Tractor Supply",
    "Phone Number": "618-433-2905",
    "address": "3001 HOMER ADAMS PKWY, ALTON, Illinois 62002",
    "city": "ALTON",
    "state": "Illinois",
    "zip": "62002",
    "lat": 38.9122455,
    "lng": -90.14026369999999
  },
  {
    "Store Location": "Tractor Supply 3539 VETERANS DR PEKIN, Illinois 61554",
    "Store Type": "Tractor Supply",
    "Phone Number": "309-353-3276",
    "address": "3539 VETERANS DR, PEKIN, Illinois 61554",
    "city": "PEKIN",
    "state": "Illinois",
    "zip": "61554",
    "lat": 40.5394443,
    "lng": -89.60051299999999
  },
  {
    "Store Location": "Tractor Supply 3623 NORTH VERMILION ST DANVILLE, Illinois 61832",
    "Store Type": "Tractor Supply",
    "Phone Number": "217-431-5756",
    "address": "3623 NORTH VERMILION ST, DANVILLE, Illinois 61832",
    "city": "DANVILLE",
    "state": "Illinois",
    "zip": "61832",
    "lat": 40.1868628,
    "lng": -87.6284328
  },
  {
    "Store Location": "Tractor Supply 4241 SCHOONER DR SPRINGFIELD, Illinois 62711",
    "Store Type": "Tractor Supply",
    "Phone Number": "217-787-1031",
    "address": "4241 SCHOONER DR, SPRINGFIELD, Illinois 62711",
    "city": "SPRINGFIELD",
    "state": "Illinois",
    "zip": "62711",
    "lat": 39.737993,
    "lng": -89.6968764
  },
  {
    "Store Location": "Tractor Supply 4813 BROADWAY ST MOUNT VERNON, Illinois 62864",
    "Store Type": "Tractor Supply",
    "Phone Number": "618-242-4633",
    "address": "4813 BROADWAY ST MOUNT, VERNON, Illinois 62864",
    "city": "VERNON",
    "state": "Illinois",
    "zip": "62864",
    "lat": 38.3103992,
    "lng": -88.9655231
  },
  {
    "Store Location": "Tractor Supply 504 RIVERSTONE PARKWAY KANKAKEE, Illinois 60901",
    "Store Type": "Tractor Supply",
    "Phone Number": "815-933-3393",
    "address": "504 RIVERSTONE PARKWAY, KANKAKEE, Illinois 60901",
    "city": "KANKAKEE",
    "state": "Illinois",
    "zip": "60901",
    "lat": 41.0776932,
    "lng": -87.861327
  },
  {
    "Store Location": "Tractor Supply 600-B WEST LIBERTY ST WAUCONDA, Illinois 60084",
    "Store Type": "Tractor Supply",
    "Phone Number": "847-487-9848",
    "address": "600-B WEST LIBERTY ST, WAUCONDA, Illinois 60084",
    "city": "WAUCONDA",
    "state": "Illinois",
    "zip": "60084",
    "lat": 42.2562782,
    "lng": -88.1551076
  },
  {
    "Store Location": "Tractor Supply 601 NORTH COMMERCIAL ST STE 15 HARRISBURG, Illinois 62946",
    "Store Type": "Tractor Supply",
    "Phone Number": "618-252-7402",
    "address": "601 NORTH COMMERCIAL ST STE 15, HARRISBURG, Illinois 62946",
    "city": "HARRISBURG",
    "state": "Illinois",
    "zip": "62946",
    "lat": 37.74458509999999,
    "lng": -88.5274493
  },
  {
    "Store Location": "Tractor Supply 631 WEST CARL SANDBURG DR GALESBURG, Illinois 61401",
    "Store Type": "Tractor Supply",
    "Phone Number": "309-344-5076",
    "address": "631 WEST CARL SANDBURG DR, GALESBURG, Illinois 61401",
    "city": "GALESBURG",
    "state": "Illinois",
    "zip": "61401",
    "lat": 40.9745183,
    "lng": -90.38032899999999
  },
  {
    "Store Location": "Tractor Supply 900 SOUTH MAIN ST EAST PEORIA, Illinois 61611",
    "Store Type": "Tractor Supply",
    "Phone Number": "309-698-8868",
    "address": "900 SOUTH MAIN ST EAST, PEORIA, Illinois 61611",
    "city": "PEORIA",
    "state": "Illinois",
    "zip": "61611",
    "lat": 40.6610811,
    "lng": -89.5899872
  },
  {
    "Store Location": "Tractor Supply 100 CROSS COUNTY PLAZA BATESVILLE, Indiana 47006",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-717-3100",
    "address": "100 CROSS COUNTY PLAZA, BATESVILLE, Indiana 47006",
    "city": "BATESVILLE",
    "state": "Indiana",
    "zip": "47006",
    "lat": 39.30941079999999,
    "lng": -85.2136068
  },
  {
    "Store Location": "Tractor Supply 1232 WEST CLARK ST RENSSELAER, Indiana 47978",
    "Store Type": "Tractor Supply",
    "Phone Number": "219-866-0621",
    "address": "1232 WEST CLARK ST, RENSSELAER, Indiana 47978",
    "city": "RENSSELAER",
    "state": "Indiana",
    "zip": "47978",
    "lat": 40.94193689999999,
    "lng": -87.1704171
  },
  {
    "Store Location": "Tractor Supply 129 NORTH PERRY RD PLAINFIELD, Indiana 46168",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-839-4792",
    "address": "129 NORTH PERRY RD, PLAINFIELD, Indiana 46168",
    "city": "PLAINFIELD",
    "state": "Indiana",
    "zip": "46168",
    "lat": 39.7194414,
    "lng": -86.35795499999999
  },
  {
    "Store Location": "Tractor Supply 1310 PILGRIM LN PLYMOUTH, Indiana 46563",
    "Store Type": "Tractor Supply",
    "Phone Number": "574-936-2435",
    "address": "1310 PILGRIM LN, PLYMOUTH, Indiana 46563",
    "city": "PLYMOUTH",
    "state": "Indiana",
    "zip": "46563",
    "lat": 41.3635418,
    "lng": -86.3236524
  },
  {
    "Store Location": "Tractor Supply 1401 SOUTH HEATON ST KNOX, Indiana 46534",
    "Store Type": "Tractor Supply",
    "Phone Number": "574-772-2869",
    "address": "1401 SOUTH HEATON ST, KNOX, Indiana 46534",
    "city": "KNOX",
    "state": "Indiana",
    "zip": "46534",
    "lat": 41.2852446,
    "lng": -86.6225272
  },
  {
    "Store Location": "Tractor Supply 1460 SOUTH US 31 GREENWOOD, Indiana 46143",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-882-5800",
    "address": "1460 SOUTH US 31, GREENWOOD, Indiana 46143",
    "city": "GREENWOOD",
    "state": "Indiana",
    "zip": "46143",
    "lat": 39.5956508,
    "lng": -86.1051493
  },
  {
    "Store Location": "Tractor Supply 1495 NORTH CASS ST WABASH, Indiana 46992",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-563-2176",
    "address": "1495 NORTH CASS ST, WABASH, Indiana 46992",
    "city": "WABASH",
    "state": "Indiana",
    "zip": "46992",
    "lat": 40.816523,
    "lng": -85.8384657
  },
  {
    "Store Location": "Tractor Supply 1526 NORTH MAIN ST RUSHVILLE, Indiana 46173",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-932-2229",
    "address": "1526 NORTH MAIN ST, RUSHVILLE, Indiana 46173",
    "city": "RUSHVILLE",
    "state": "Indiana",
    "zip": "46173",
    "lat": 39.62413120000001,
    "lng": -85.44347479999999
  },
  {
    "Store Location": "Tractor Supply 1538 EAST MARKET ST NAPPANEE, Indiana 46550",
    "Store Type": "Tractor Supply",
    "Phone Number": "574-773-2525",
    "address": "1538 EAST MARKET ST, NAPPANEE, Indiana 46550",
    "city": "NAPPANEE",
    "state": "Indiana",
    "zip": "46550",
    "lat": 41.4444468,
    "lng": -85.98464489999999
  },
  {
    "Store Location": "Tractor Supply 1540 NORTH MORTON ST FRANKLIN, Indiana 46131",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-346-0015",
    "address": "1540 NORTH MORTON ST, FRANKLIN, Indiana 46131",
    "city": "FRANKLIN",
    "state": "Indiana",
    "zip": "46131",
    "lat": 39.4923514,
    "lng": -86.0665011
  },
  {
    "Store Location": "Tractor Supply 16 RIDGE AVE DANVILLE, Indiana 46122",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-718-8737",
    "address": "16 RIDGE AVE, DANVILLE, Indiana 46122",
    "city": "DANVILLE",
    "state": "Indiana",
    "zip": "46122",
    "lat": 39.7603612,
    "lng": -86.4896691
  },
  {
    "Store Location": "Tractor Supply 1645 NORTH STATE ST GREENFIELD, Indiana 46140",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-468-0980",
    "address": "1645 NORTH STATE ST, GREENFIELD, Indiana 46140",
    "city": "GREENFIELD",
    "state": "Indiana",
    "zip": "46140",
    "lat": 39.8080186,
    "lng": -85.76754559999999
  },
  {
    "Store Location": "Tractor Supply 17500 AUSTRIAN PINE WAY WESTFIELD, Indiana 46074",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-896-1086",
    "address": "17500 AUSTRIAN PINE WAY, WESTFIELD, Indiana 46074",
    "city": "WESTFIELD",
    "state": "Indiana",
    "zip": "46074",
    "lat": 40.0407974,
    "lng": -86.1567699
  },
  {
    "Store Location": "Tractor Supply 1807 NORTH WAYNE ST ANGOLA, Indiana 46703",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-624-3766",
    "address": "1807 NORTH WAYNE ST, ANGOLA, Indiana 46703",
    "city": "ANGOLA",
    "state": "Indiana",
    "zip": "46703",
    "lat": 41.6567049,
    "lng": -85.0014722
  },
  {
    "Store Location": "Tractor Supply 1901 HART ST VINCENNES, Indiana 47591",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-882-1955",
    "address": "1901 HART ST, VINCENNES, Indiana 47591",
    "city": "VINCENNES",
    "state": "Indiana",
    "zip": "47591",
    "lat": 38.6660403,
    "lng": -87.514353
  },
  {
    "Store Location": "Tractor Supply 1935 OLD HWY 135 NORTHWEST CORYDON, Indiana 47112",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-734-0296",
    "address": "1935 OLD HWY 135 NORTHWEST, CORYDON, Indiana 47112",
    "city": "CORYDON",
    "state": "Indiana",
    "zip": "47112",
    "lat": 38.2297014,
    "lng": -86.1335153
  },
  {
    "Store Location": "Tractor Supply 1959 EAST STATE RD 163 CLINTON, Indiana 47842",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-832-3733",
    "address": "1959 EAST STATE RD 163, CLINTON, Indiana 47842",
    "city": "CLINTON",
    "state": "Indiana",
    "zip": "47842",
    "lat": 39.6548387,
    "lng": -87.42836919999999
  },
  {
    "Store Location": "Tractor Supply 2003 EAST TIPTON SEYMOUR, Indiana 47274",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-524-1500",
    "address": "2003 EAST TIPTON, SEYMOUR, Indiana 47274",
    "city": "SEYMOUR",
    "state": "Indiana",
    "zip": "47274",
    "lat": 38.9594801,
    "lng": -85.8556598
  },
  {
    "Store Location": "Tractor Supply 2112 WEST COLISEUM BLVD FORT WAYNE, Indiana 46808",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-484-1596",
    "address": "2112 WEST COLISEUM BLVD FORT, WAYNE, Indiana 46808",
    "city": "WAYNE",
    "state": "Indiana",
    "zip": "46808",
    "lat": 41.118548,
    "lng": -85.1701023
  },
  {
    "Store Location": "Tractor Supply 2202 NORTH PARK RD CONNERSVILLE, Indiana 47331",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-825-4450",
    "address": "2202 NORTH PARK RD, CONNERSVILLE, Indiana 47331",
    "city": "CONNERSVILLE",
    "state": "Indiana",
    "zip": "47331",
    "lat": 39.6605066,
    "lng": -85.1291239
  },
  {
    "Store Location": "Tractor Supply 2214 EAST NATIONAL HWY STE C WASHINGTON, Indiana 47501",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-254-1603",
    "address": "2214 EAST NATIONAL HWY STE C, WASHINGTON, Indiana 47501",
    "city": "WASHINGTON",
    "state": "Indiana",
    "zip": "47501",
    "lat": 38.655224,
    "lng": -87.1446758
  },
  {
    "Store Location": "Tractor Supply 2323 LINCOLNWAY EAST GOSHEN, Indiana 46526",
    "Store Type": "Tractor Supply",
    "Phone Number": "574-533-3703",
    "address": "2323 LINCOLNWAY EAST, GOSHEN, Indiana 46526",
    "city": "GOSHEN",
    "state": "Indiana",
    "zip": "46526",
    "lat": 41.5544589,
    "lng": -85.7891868
  },
  {
    "Store Location": "Tractor Supply 2375 EAST PLEASANT ST RTE 37 SOUTH NOBLESVILLE, Indiana 46060",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-776-1883",
    "address": "2375 EAST PLEASANT ST RTE 37 SOUTH, NOBLESVILLE, Indiana 46060",
    "city": "NOBLESVILLE",
    "state": "Indiana",
    "zip": "46060",
    "lat": 40.0388102,
    "lng": -85.99692449999999
  },
  {
    "Store Location": "Tractor Supply 2423 NORTH LEBANON ST LEBANON, Indiana 46052",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-483-0898",
    "address": "2423 NORTH LEBANON ST, LEBANON, Indiana 46052",
    "city": "LEBANON",
    "state": "Indiana",
    "zip": "46052",
    "lat": 40.0703754,
    "lng": -86.4724049
  },
  {
    "Store Location": "Tractor Supply 25 PUTNAM PLZ GREENCASTLE, Indiana 46135",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-653-2448",
    "address": "25 PUTNAM PLZ, GREENCASTLE, Indiana 46135",
    "city": "GREENCASTLE",
    "state": "Indiana",
    "zip": "46135",
    "lat": 39.6478936,
    "lng": -86.83034880000001
  },
  {
    "Store Location": "Tractor Supply 2500 MORTHLAND DR VALPARAISO, Indiana 46383",
    "Store Type": "Tractor Supply",
    "Phone Number": "219-464-8597",
    "address": "2500 MORTHLAND DR, VALPARAISO, Indiana 46383",
    "city": "VALPARAISO",
    "state": "Indiana",
    "zip": "46383",
    "lat": 41.4551989,
    "lng": -87.0309588
  },
  {
    "Store Location": "Tractor Supply 2653 16TH ST BEDFORD, Indiana 47421",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-277-8310",
    "address": "2653 16TH ST, BEDFORD, Indiana 47421",
    "city": "BEDFORD",
    "state": "Indiana",
    "zip": "47421",
    "lat": 38.8623955,
    "lng": -86.51015559999999
  },
  {
    "Store Location": "Tractor Supply 3000 SOUTH MEMORIAL DR NEW CASTLE, Indiana 47362",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-521-2610",
    "address": "3000 SOUTH MEMORIAL DR NEW, CASTLE, Indiana 47362",
    "city": "CASTLE",
    "state": "Indiana",
    "zip": "47362",
    "lat": 39.9030089,
    "lng": -85.38425769999999
  },
  {
    "Store Location": "Tractor Supply 3294 EAST US 30 WARSAW, Indiana 46580",
    "Store Type": "Tractor Supply",
    "Phone Number": "574-269-2625",
    "address": "3294 EAST US 30, WARSAW, Indiana 46580",
    "city": "WARSAW",
    "state": "Indiana",
    "zip": "46580",
    "lat": 41.2214479,
    "lng": -85.7787367
  },
  {
    "Store Location": "Tractor Supply 330 EAST IRELAND RD MISHAWAKA, Indiana 46544",
    "Store Type": "Tractor Supply",
    "Phone Number": "574-257-0753",
    "address": "330 EAST IRELAND RD, MISHAWAKA, Indiana 46544",
    "city": "MISHAWAKA",
    "state": "Indiana",
    "zip": "46544",
    "lat": 41.630031,
    "lng": -86.1871694
  },
  {
    "Store Location": "Tractor Supply 334 NORTH HALLECK STREET DEMOTTE, Indiana 46310",
    "Store Type": "Tractor Supply",
    "Phone Number": "219-987-3411",
    "address": "334 NORTH HALLECK STREET, DEMOTTE, Indiana 46310",
    "city": "DEMOTTE",
    "state": "Indiana",
    "zip": "46310",
    "lat": 41.2053148,
    "lng": -87.19966699999999
  },
  {
    "Store Location": "Tractor Supply 3416 SOUTH WESTERN AVE MARION, Indiana 46953",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-674-2395",
    "address": "3416 SOUTH WESTERN AVE, MARION, Indiana 46953",
    "city": "MARION",
    "state": "Indiana",
    "zip": "46953",
    "lat": 40.5284594,
    "lng": -85.67477819999999
  },
  {
    "Store Location": "Tractor Supply 3601 EAST MCGALLIARD MUNCIE, Indiana 47303",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-747-0461",
    "address": "3601 EAST MCGALLIARD, MUNCIE, Indiana 47303",
    "city": "MUNCIE",
    "state": "Indiana",
    "zip": "47303",
    "lat": 40.2179612,
    "lng": -85.3441521
  },
  {
    "Store Location": "Tractor Supply 375 OLD HWY RD TELL CITY, Indiana 47586",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-547-7569",
    "address": "375 OLD HWY RD TELL, CITY, Indiana 47586",
    "city": "CITY",
    "state": "Indiana",
    "zip": "47586",
    "lat": 37.930829,
    "lng": -86.7564893
  },
  {
    "Store Location": "Tractor Supply 401 WEST EADS PKWY STE 120 LAWRENCEBURG, Indiana 47025",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-539-3333",
    "address": "401 WEST EADS PKWY STE 120, LAWRENCEBURG, Indiana 47025",
    "city": "LAWRENCEBURG",
    "state": "Indiana",
    "zip": "47025",
    "lat": 39.09594550000001,
    "lng": -84.86421659999999
  },
  {
    "Store Location": "Tractor Supply 405 EAST CLIFTY DR MADISON, Indiana 47250",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-273-7796",
    "address": "405 EAST CLIFTY DR, MADISON, Indiana 47250",
    "city": "MADISON",
    "state": "Indiana",
    "zip": "47250",
    "lat": 38.779423,
    "lng": -85.381192
  },
  {
    "Store Location": "Tractor Supply 435 NORTH TOWN CENTER RD MOORESVILLE, Indiana 46158",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-831-9777",
    "address": "435 NORTH TOWN CENTER RD, MOORESVILLE, Indiana 46158",
    "city": "MOORESVILLE",
    "state": "Indiana",
    "zip": "46158",
    "lat": 39.6181109,
    "lng": -86.3520454
  },
  {
    "Store Location": "Tractor Supply 4471 EAST US HWY 30 MERRILLVILLE, Indiana 46410",
    "Store Type": "Tractor Supply",
    "Phone Number": "219-947-3368",
    "address": "4471 EAST US HWY 30, MERRILLVILLE, Indiana 46410",
    "city": "MERRILLVILLE",
    "state": "Indiana",
    "zip": "46410",
    "lat": 41.4727285,
    "lng": -87.3886022
  },
  {
    "Store Location": "Tractor Supply 4675 NATIONAL RD EAST RICHMOND, Indiana 47374",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-966-2568",
    "address": "4675 NATIONAL RD EAST, RICHMOND, Indiana 47374",
    "city": "RICHMOND",
    "state": "Indiana",
    "zip": "47374",
    "lat": 39.8293209,
    "lng": -84.8376459
  },
  {
    "Store Location": "Tractor Supply 4841 STATE RD 38 EAST LAFAYETTE, Indiana 47905",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-447-9331",
    "address": "4841 STATE RD 38 EAST, LAFAYETTE, Indiana 47905",
    "city": "LAFAYETTE",
    "state": "Indiana",
    "zip": "47905",
    "lat": 40.3773073,
    "lng": -86.8184368
  },
  {
    "Store Location": "Tractor Supply 4931 SOUTH US HWY 41 TERRE HAUTE, Indiana 47802",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-299-2161",
    "address": "4931 SOUTH US HWY 41 TERRE, HAUTE, Indiana 47802",
    "city": "HAUTE",
    "state": "Indiana",
    "zip": "47802",
    "lat": 39.4071716,
    "lng": -87.41060279999999
  },
  {
    "Store Location": "Tractor Supply 5210 MORGAN AVE EVANSVILLE, Indiana 47715",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-477-6497",
    "address": "5210 MORGAN AVE, EVANSVILLE, Indiana 47715",
    "city": "EVANSVILLE",
    "state": "Indiana",
    "zip": "47715",
    "lat": 37.9931611,
    "lng": -87.4872458
  },
  {
    "Store Location": "Tractor Supply 528 NORTH MAIN ST SR9 COLUMBIA CITY, Indiana 46725",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-244-0060",
    "address": "528 NORTH MAIN ST SR9 COLUMBIA, CITY, Indiana 46725",
    "city": "CITY",
    "state": "Indiana",
    "zip": "46725",
    "lat": 41.1658999,
    "lng": -85.4852722
  },
  {
    "Store Location": "Tractor Supply 5790 WEST STATE RD 46 BLOOMINGTON, Indiana 47404",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-876-1108",
    "address": "5790 WEST STATE RD 46, BLOOMINGTON, Indiana 47404",
    "city": "BLOOMINGTON",
    "state": "Indiana",
    "zip": "47404",
    "lat": 39.2257193,
    "lng": -86.6111414
  },
  {
    "Store Location": "Tractor Supply 5808 MEIJER DR FT WAYNE, Indiana 46835",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-209-0150",
    "address": "5808 MEIJER DR FT, WAYNE, Indiana 46835",
    "city": "WAYNE",
    "state": "Indiana",
    "zip": "46835",
    "lat": 41.13482610000001,
    "lng": -85.0146601
  },
  {
    "Store Location": "Tractor Supply 601 SOUTH MAIN ST STE 112 SALEM, Indiana 47167",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-883-3343",
    "address": "601 SOUTH MAIN ST STE 112, SALEM, Indiana 47167",
    "city": "SALEM",
    "state": "Indiana",
    "zip": "47167",
    "lat": 38.5996824,
    "lng": -86.10105469999999
  },
  {
    "Store Location": "Tractor Supply 6818 SOUTH SCATTERFIELD RD ANDERSON, Indiana 46013",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-779-0044",
    "address": "6818 SOUTH SCATTERFIELD RD, ANDERSON, Indiana 46013",
    "city": "ANDERSON",
    "state": "Indiana",
    "zip": "46013",
    "lat": 40.0452758,
    "lng": -85.6489285
  },
  {
    "Store Location": "Tractor Supply 71 PINE LAKE AVE STE B LA PORTE, Indiana 46350",
    "Store Type": "Tractor Supply",
    "Phone Number": "219-326-8741",
    "address": "71 PINE LAKE AVE STE B LA, PORTE, Indiana 46350",
    "city": "PORTE",
    "state": "Indiana",
    "zip": "46350",
    "lat": 41.6156182,
    "lng": -86.7275701
  },
  {
    "Store Location": "Tractor Supply 7409 HWY 311 SELLERSBURG, Indiana 47172",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-246-2351",
    "address": "7409 HWY 311, SELLERSBURG, Indiana 47172",
    "city": "SELLERSBURG",
    "state": "Indiana",
    "zip": "47172",
    "lat": 38.3787376,
    "lng": -85.769744
  },
  {
    "Store Location": "Tractor Supply 8135 BROOKVILLE RD INDIANAPOLIS, Indiana 46239",
    "Store Type": "Tractor Supply",
    "Phone Number": "317-356-0138",
    "address": "8135 BROOKVILLE RD, INDIANAPOLIS, Indiana 46239",
    "city": "INDIANAPOLIS",
    "state": "Indiana",
    "zip": "46239",
    "lat": 39.7481481,
    "lng": -86.02300869999999
  },
  {
    "Store Location": "Tractor Supply 820B WEST MAIN STREET BOONVILLE, Indiana 47601",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-897-1592",
    "address": "820B WEST MAIN STREET, BOONVILLE, Indiana 47601",
    "city": "BOONVILLE",
    "state": "Indiana",
    "zip": "47601",
    "lat": 38.0488144,
    "lng": -87.2840973
  },
  {
    "Store Location": "Tractor Supply 829 SOUTH 13TH ST DECATUR, Indiana 46733",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-728-2181",
    "address": "829 SOUTH 13TH ST, DECATUR, Indiana 46733",
    "city": "DECATUR",
    "state": "Indiana",
    "zip": "46733",
    "lat": 40.8206376,
    "lng": -84.93630329999999
  },
  {
    "Store Location": "Tractor Supply 840 EAST JEFFERSON ST TIPTON, Indiana 46072",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-675-4846",
    "address": "840 EAST JEFFERSON ST, TIPTON, Indiana 46072",
    "city": "TIPTON",
    "state": "Indiana",
    "zip": "46072",
    "lat": 40.2841072,
    "lng": -86.0304111
  },
  {
    "Store Location": "Tractor Supply 889 NORTH GOSPEL ST STE 1 PAOLI, Indiana 47454",
    "Store Type": "Tractor Supply",
    "Phone Number": "812-723-0054",
    "address": "889 NORTH GOSPEL ST STE 1, PAOLI, Indiana 47454",
    "city": "PAOLI",
    "state": "Indiana",
    "zip": "47454",
    "lat": 38.567367,
    "lng": -86.4665864
  },
  {
    "Store Location": "Tractor Supply 905 LINCOLNWAY SOUTH LIGONIER, Indiana 46767",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-894-3096",
    "address": "905 LINCOLNWAY SOUTH, LIGONIER, Indiana 46767",
    "city": "LIGONIER",
    "state": "Indiana",
    "zip": "46767",
    "lat": 41.4576516,
    "lng": -85.5848053
  },
  {
    "Store Location": "Tractor Supply 936 EAST WASHINGTON ST WINCHESTER, Indiana 47394",
    "Store Type": "Tractor Supply",
    "Phone Number": "765-305-0150",
    "address": "936 EAST WASHINGTON ST, WINCHESTER, Indiana 47394",
    "city": "WINCHESTER",
    "state": "Indiana",
    "zip": "47394",
    "lat": 40.170616,
    "lng": -84.96376
  },
  {
    "Store Location": "Tractor Supply 995 EAST NORTH ST KENDALLVILLE, Indiana 46755",
    "Store Type": "Tractor Supply",
    "Phone Number": "260-343-0228",
    "address": "995 EAST NORTH ST, KENDALLVILLE, Indiana 46755",
    "city": "KENDALLVILLE",
    "state": "Indiana",
    "zip": "46755",
    "lat": 41.4529963,
    "lng": -85.251645
  },
  {
    "Store Location": "Tractor Supply 9957 EARL DR SAINT JOHN, Indiana 46373",
    "Store Type": "Tractor Supply",
    "Phone Number": "219-365-0117",
    "address": "9957 EARL DR SAINT, JOHN, Indiana 46373",
    "city": "JOHN",
    "state": "Indiana",
    "zip": "46373",
    "lat": 41.438096,
    "lng": -87.4672849
  },
  {
    "Store Location": "Tractor Supply 10025 SOUTHWEST DIAMOND RD AUGUSTA, Kansas 67010",
    "Store Type": "Tractor Supply",
    "Phone Number": "316-775-6410",
    "address": "10025 SOUTHWEST DIAMOND RD, AUGUSTA, Kansas 67010",
    "city": "AUGUSTA",
    "state": "Kansas",
    "zip": "67010",
    "lat": 37.678705,
    "lng": -97.027368
  },
  {
    "Store Location": "Tractor Supply 1111 NORTH MAIN ST LANSING, Kansas 66043",
    "Store Type": "Tractor Supply",
    "Phone Number": "913-727-1701",
    "address": "1111 NORTH MAIN ST, LANSING, Kansas 66043",
    "city": "LANSING",
    "state": "Kansas",
    "zip": "66043",
    "lat": 39.2665529,
    "lng": -94.90081219999999
  },
  {
    "Store Location": "Tractor Supply 115 WEST 28TH ST PITTSBURG, Kansas 66762",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7541",
    "address": "115 WEST 28TH ST, PITTSBURG, Kansas 66762",
    "city": "PITTSBURG",
    "state": "Kansas",
    "zip": "66762",
    "lat": 37.4344381,
    "lng": -94.7068882
  },
  {
    "Store Location": "Tractor Supply 1203 NORTH LORRAINE ST HUTCHINSON, Kansas 67501",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-663-7607",
    "address": "1203 NORTH LORRAINE ST, HUTCHINSON, Kansas 67501",
    "city": "HUTCHINSON",
    "state": "Kansas",
    "zip": "67501",
    "lat": 38.066414,
    "lng": -97.9048859
  },
  {
    "Store Location": "Tractor Supply 1318 INDUSTRIAL RD EMPORIA, Kansas 66801",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-341-9245",
    "address": "1318 INDUSTRIAL RD, EMPORIA, Kansas 66801",
    "city": "EMPORIA",
    "state": "Kansas",
    "zip": "66801",
    "lat": 38.4137962,
    "lng": -96.2158887
  },
  {
    "Store Location": "Tractor Supply 1330 NORTH MAIN ST MCPHERSON, Kansas 67460",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-245-9900",
    "address": "1330 NORTH MAIN ST, MCPHERSON, Kansas 67460",
    "city": "MCPHERSON",
    "state": "Kansas",
    "zip": "67460",
    "lat": 38.3844062,
    "lng": -97.6652855
  },
  {
    "Store Location": "Tractor Supply 15945 SOUTH US 169 HWY OLATHE, Kansas 66062",
    "Store Type": "Tractor Supply",
    "Phone Number": "913-768-1400",
    "address": "15945 SOUTH US 169 HWY, OLATHE, Kansas 66062",
    "city": "OLATHE",
    "state": "Kansas",
    "zip": "66062",
    "lat": 38.8395727,
    "lng": -94.8150253
  },
  {
    "Store Location": "Tractor Supply 1601 SOUTH SANTA FE AVE CHANUTE, Kansas 66720",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-432-0011",
    "address": "1601 SOUTH SANTA FE AVE, CHANUTE, Kansas 66720",
    "city": "CHANUTE",
    "state": "Kansas",
    "zip": "66720",
    "lat": 37.664654,
    "lng": -95.45379
  },
  {
    "Store Location": "Tractor Supply 1318 INDUSTRIAL RD EMPORIA, Kansas 66801",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-341-9245",
    "address": "1318 INDUSTRIAL RD, EMPORIA, Kansas 66801",
    "city": "EMPORIA",
    "state": "Kansas",
    "zip": "66801",
    "lat": 38.4137962,
    "lng": -96.2158887
  },
  {
    "Store Location": "Tractor Supply 1727 EAST 1ST ST PRATT, Kansas 67124",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-672-1102",
    "address": "1727 EAST 1ST ST, PRATT, Kansas 67124",
    "city": "PRATT",
    "state": "Kansas",
    "zip": "67124",
    "lat": 37.644236,
    "lng": -98.7168892
  },
  {
    "Store Location": "Tractor Supply 209 ARIZONA AVE HOLTON, Kansas 66436",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-364-2288",
    "address": "209 ARIZONA AVE, HOLTON, Kansas 66436",
    "city": "HOLTON",
    "state": "Kansas",
    "zip": "66436",
    "lat": 39.46080000000001,
    "lng": -95.7489937
  },
  {
    "Store Location": "Tractor Supply 235 WEST 48TH STREET HAYS, Kansas 67601",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-650-0555",
    "address": "235 WEST 48TH STREET, HAYS, Kansas 67601",
    "city": "HAYS",
    "state": "Kansas",
    "zip": "67601",
    "lat": 38.9079919,
    "lng": -99.3203415
  },
  {
    "Store Location": "Tractor Supply 2420 FAIRFIELD ST LAWRENCE, Kansas 66046",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-331-2395",
    "address": "2420 FAIRFIELD ST, LAWRENCE, Kansas 66046",
    "city": "LAWRENCE",
    "state": "Kansas",
    "zip": "66046",
    "lat": 38.94063269999999,
    "lng": -95.19868609999999
  },
  {
    "Store Location": "Tractor Supply 2420 SOUTH MAIN ST FORT SCOTT, Kansas 66701",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-223-4900",
    "address": "2420 SOUTH MAIN ST FORT, SCOTT, Kansas 66701",
    "city": "SCOTT",
    "state": "Kansas",
    "zip": "66701",
    "lat": 37.8101029,
    "lng": -94.7067634
  },
  {
    "Store Location": "Tractor Supply 2612 CENTRAL AVE DODGE CITY, Kansas 67801",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-408-9119",
    "address": "2612 CENTRAL AVE DODGE, CITY, Kansas 67801",
    "city": "CITY",
    "state": "Kansas",
    "zip": "67801",
    "lat": 37.7781032,
    "lng": -100.0153131
  },
  {
    "Store Location": "Tractor Supply 3120 RIFFEL DR SALINA, Kansas 67401",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-827-3300",
    "address": "3120 RIFFEL DR, SALINA, Kansas 67401",
    "city": "SALINA",
    "state": "Kansas",
    "zip": "67401",
    "lat": 38.7804189,
    "lng": -97.61397889999999
  },
  {
    "Store Location": "Tractor Supply 3333 EAST MARY ST GARDEN CITY, Kansas 67846",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-272-0333",
    "address": "3333 EAST MARY ST GARDEN, CITY, Kansas 67846",
    "city": "CITY",
    "state": "Kansas",
    "zip": "67846",
    "lat": 37.9900111,
    "lng": -100.8331885
  },
  {
    "Store Location": "Tractor Supply 3709 8TH STREET GREAT BEND, Kansas 67530",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-792-5500",
    "address": "3709 8TH STREET GREAT, BEND, Kansas 67530",
    "city": "BEND",
    "state": "Kansas",
    "zip": "67530",
    "lat": 38.3589358,
    "lng": -98.7896603
  },
  {
    "Store Location": "Tractor Supply 5236 SOUTHWEST TOPEKA BLVD TOPEKA, Kansas 66609",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-862-0216",
    "address": "5236 SOUTHWEST TOPEKA BLVD, TOPEKA, Kansas 66609",
    "city": "TOPEKA",
    "state": "Kansas",
    "zip": "66609",
    "lat": 38.9730494,
    "lng": -95.68629089999999
  },
  {
    "Store Location": "Tractor Supply 710 HWY 24 EAST TOPEKA, Kansas 66608",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-233-4211",
    "address": "710 HWY 24 EAST, TOPEKA, Kansas 66608",
    "city": "TOPEKA",
    "state": "Kansas",
    "zip": "66608",
    "lat": 39.1295209,
    "lng": -95.93956209999999
  },
  {
    "Store Location": "Tractor Supply 715 SOUTHEAST 36TH ST NEWTON, Kansas 67114",
    "Store Type": "Tractor Supply",
    "Phone Number": "316-283-1100",
    "address": "715 SOUTHEAST 36TH ST, NEWTON, Kansas 67114",
    "city": "NEWTON",
    "state": "Kansas",
    "zip": "67114",
    "lat": 37.9982628,
    "lng": -97.3307408
  },
  {
    "Store Location": "Tractor Supply 730 NORTH KANSAS AVE LIBERAL, Kansas 67901",
    "Store Type": "Tractor Supply",
    "Phone Number": "620-624-9000",
    "address": "730 NORTH KANSAS AVE, LIBERAL, Kansas 67901",
    "city": "LIBERAL",
    "state": "Kansas",
    "zip": "67901",
    "lat": 37.04644,
    "lng": -100.92296
  },
  {
    "Store Location": "Tractor Supply 8110 SOUTH PORT RD MANHATTAN, Kansas 66502",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-587-8949",
    "address": "8110 SOUTH PORT RD, MANHATTAN, Kansas 66502",
    "city": "MANHATTAN",
    "state": "Kansas",
    "zip": "66502",
    "lat": 39.193371,
    "lng": -96.52643619999999
  },
  {
    "Store Location": "Tractor Supply 821 W CRAWFORD ST CLAY CENTER, Kansas 67432",
    "Store Type": "Tractor Supply",
    "Phone Number": "785-632-5484",
    "address": "821 W CRAWFORD ST CLAY, CENTER, Kansas 67432",
    "city": "CENTER",
    "state": "Kansas",
    "zip": "67432",
    "lat": 39.3804532,
    "lng": -97.12043899999999
  },
  {
    "Store Location": "Tractor Supply 9425 WEST KELLOGG WICHITA, Kansas 67209",
    "Store Type": "Tractor Supply",
    "Phone Number": "316-721-4797",
    "address": "9425 WEST KELLOGG, WICHITA, Kansas 67209",
    "city": "WICHITA",
    "state": "Kansas",
    "zip": "67209",
    "lat": 37.6666395,
    "lng": -97.45181509999999
  },
  {
    "Store Location": "Tractor Supply 10 COMPREHENSIVE DR HARLAN, Kentucky 40831",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-573-2650",
    "address": "10 COMPREHENSIVE DR, HARLAN, Kentucky 40831",
    "city": "HARLAN",
    "state": "Kentucky",
    "zip": "40831",
    "lat": 36.807815,
    "lng": -83.31148890000001
  },
  {
    "Store Location": "Tractor Supply 100 LONDON SHOPPING CTR LONDON, Kentucky 40741",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-877-5500",
    "address": "100 LONDON SHOPPING CTR, LONDON, Kentucky 40741",
    "city": "LONDON",
    "state": "Kentucky",
    "zip": "40741",
    "lat": 37.1121591,
    "lng": -84.090312
  },
  {
    "Store Location": "Tractor Supply 1005 US HWY 60 EAST MORGANFIELD, Kentucky 42437",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-389-3336",
    "address": "1005 US HWY 60 EAST, MORGANFIELD, Kentucky 42437",
    "city": "MORGANFIELD",
    "state": "Kentucky",
    "zip": "42437",
    "lat": 37.6893168,
    "lng": -87.8969778
  },
  {
    "Store Location": "Tractor Supply 1015 NORTH MAIN NICHOLASVILLE, Kentucky 40356",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-887-9192",
    "address": "1015 NORTH MAIN, NICHOLASVILLE, Kentucky 40356",
    "city": "NICHOLASVILLE",
    "state": "Kentucky",
    "zip": "40356",
    "lat": 37.8997454,
    "lng": -84.5668484
  },
  {
    "Store Location": "Tractor Supply 10710 EAGLE WAY HOPKINSVILLE, Kentucky 42240",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-886-7740",
    "address": "10710 EAGLE WAY, HOPKINSVILLE, Kentucky 42240",
    "city": "HOPKINSVILLE",
    "state": "Kentucky",
    "zip": "42240",
    "lat": 36.8188069,
    "lng": -87.47568389999999
  },
  {
    "Store Location": "Tractor Supply 10713 DIXIE HWY STE 101 LOUISVILLE, Kentucky 40272",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-995-8558",
    "address": "10713 DIXIE HWY STE 101, LOUISVILLE, Kentucky 40272",
    "city": "LOUISVILLE",
    "state": "Kentucky",
    "zip": "40272",
    "lat": 38.0973383,
    "lng": -85.8703625
  },
  {
    "Store Location": "Tractor Supply 1075 SOUTH MAIN ST FRANKLIN, Kentucky 42134",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-586-4333",
    "address": "1075 SOUTH MAIN ST, FRANKLIN, Kentucky 42134",
    "city": "FRANKLIN",
    "state": "Kentucky",
    "zip": "42134",
    "lat": 36.702749,
    "lng": -86.5727048
  },
  {
    "Store Location": "Tractor Supply 111 ARROWHEAD CT FRANKFORT, Kentucky 40601",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-695-7700",
    "address": "111 ARROWHEAD CT, FRANKFORT, Kentucky 40601",
    "city": "FRANKFORT",
    "state": "Kentucky",
    "zip": "40601",
    "lat": 38.1837966,
    "lng": -84.8191088
  },
  {
    "Store Location": "Tractor Supply 1111 PARIS RD MAYFIELD, Kentucky 42066",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-247-4701",
    "address": "1111 PARIS RD, MAYFIELD, Kentucky 42066",
    "city": "MAYFIELD",
    "state": "Kentucky",
    "zip": "42066",
    "lat": 36.723415,
    "lng": -88.6297136
  },
  {
    "Store Location": "Tractor Supply 1125 1125 NORTH MAIN ST STE 1 MONTICELLO, Kentucky 42633",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-348-0444",
    "address": "1125 1125 NORTH MAIN ST STE 1, MONTICELLO, Kentucky 42633",
    "city": "MONTICELLO",
    "state": "Kentucky",
    "zip": "42633",
    "lat": 36.842982,
    "lng": -84.8395704
  },
  {
    "Store Location": "Tractor Supply 11250 PRESTON HWY LOUISVILLE, Kentucky 40229",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-810-9262",
    "address": "11250 PRESTON HWY, LOUISVILLE, Kentucky 40229",
    "city": "LOUISVILLE",
    "state": "Kentucky",
    "zip": "40229",
    "lat": 38.0855317,
    "lng": -85.6702961
  },
  {
    "Store Location": "Tractor Supply 1138 OLD GALLATIN RD SCOTTSVILLE, Kentucky 42164",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-239-1030",
    "address": "1138 OLD GALLATIN RD, SCOTTSVILLE, Kentucky 42164",
    "city": "SCOTTSVILLE",
    "state": "Kentucky",
    "zip": "42164",
    "lat": 36.7428652,
    "lng": -86.2035317
  },
  {
    "Store Location": "Tractor Supply 1150 WEST 9TH ST RUSSELLVILLE, Kentucky 42276",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-726-8988",
    "address": "1150 WEST 9TH ST, RUSSELLVILLE, Kentucky 42276",
    "city": "RUSSELLVILLE",
    "state": "Kentucky",
    "zip": "42276",
    "lat": 36.833767,
    "lng": -86.9059788
  },
  {
    "Store Location": "Tractor Supply 1351 ELIZABETHTOWN RD LEITCHFIELD, Kentucky 42754",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-287-0264",
    "address": "1351 ELIZABETHTOWN RD, LEITCHFIELD, Kentucky 42754",
    "city": "LEITCHFIELD",
    "state": "Kentucky",
    "zip": "42754",
    "lat": 37.4856753,
    "lng": -86.274479
  },
  {
    "Store Location": "Tractor Supply 140 HOME RUN DR MUNFORDVILLE, Kentucky 42765",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-524-0120",
    "address": "140 HOME RUN DR, MUNFORDVILLE, Kentucky 42765",
    "city": "MUNFORDVILLE",
    "state": "Kentucky",
    "zip": "42765",
    "lat": 37.28914839999999,
    "lng": -85.89878829999999
  },
  {
    "Store Location": "Tractor Supply 1418 NORTH MAIN ST WILLIAMSTOWN, Kentucky 41097",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-824-0200",
    "address": "1418 NORTH MAIN ST, WILLIAMSTOWN, Kentucky 41097",
    "city": "WILLIAMSTOWN",
    "state": "Kentucky",
    "zip": "41097",
    "lat": 38.662798,
    "lng": -84.574788
  },
  {
    "Store Location": "Tractor Supply 1451 RING RD ELIZABETHTOWN, Kentucky 42701",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-763-0044",
    "address": "1451 RING RD, ELIZABETHTOWN, Kentucky 42701",
    "city": "ELIZABETHTOWN",
    "state": "Kentucky",
    "zip": "42701",
    "lat": 37.7253376,
    "lng": -85.88938069999999
  },
  {
    "Store Location": "Tractor Supply 1466 HWY 15 NORTH JACKSON, Kentucky 41339",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-666-5439",
    "address": "1466 HWY 15 NORTH, JACKSON, Kentucky 41339",
    "city": "JACKSON",
    "state": "Kentucky",
    "zip": "41339",
    "lat": 37.5578369,
    "lng": -83.37946670000001
  },
  {
    "Store Location": "Tractor Supply 1500 BYPASS RD WINCHESTER, Kentucky 40391",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-744-2929",
    "address": "1500 BYPASS RD, WINCHESTER, Kentucky 40391",
    "city": "WINCHESTER",
    "state": "Kentucky",
    "zip": "40391",
    "lat": 37.9959223,
    "lng": -84.21387879999999
  },
  {
    "Store Location": "Tractor Supply 1504 WEST EVERLY BROTHERS BLVD STE A CENTRAL CITY, Kentucky 42330",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-754-2757",
    "address": "1504 WEST EVERLY BROTHERS BLVD STE A CENTRAL, CITY, Kentucky 42330",
    "city": "CITY",
    "state": "Kentucky",
    "zip": "42330",
    "lat": 37.2752707,
    "lng": -87.13984599999999
  },
  {
    "Store Location": "Tractor Supply 1521 NORTH MAIN ST BEAVER DAM, Kentucky 42320",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-274-6752",
    "address": "1521 NORTH MAIN ST BEAVER, DAM, Kentucky 42320",
    "city": "DAM",
    "state": "Kentucky",
    "zip": "42320",
    "lat": 37.4241786,
    "lng": -86.8793455
  },
  {
    "Store Location": "Tractor Supply 1575 SOUTH US HWY 25E BARBOURVILLE, Kentucky 40906",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-277-0369",
    "address": "1575 SOUTH US HWY 25E, BARBOURVILLE, Kentucky 40906",
    "city": "BARBOURVILLE",
    "state": "Kentucky",
    "zip": "40906",
    "lat": 36.8608971,
    "lng": -83.8447885
  },
  {
    "Store Location": "Tractor Supply 159 PENNY LN WILLIAMSBURG, Kentucky 40769",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-549-1137",
    "address": "159 PENNY LN, WILLIAMSBURG, Kentucky 40769",
    "city": "WILLIAMSBURG",
    "state": "Kentucky",
    "zip": "40769",
    "lat": 36.7250792,
    "lng": -84.1704026
  },
  {
    "Store Location": "Tractor Supply 16230 US HWY 23 LOUISA, Kentucky 41230",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-673-1141",
    "address": "16230 US HWY 23, LOUISA, Kentucky 41230",
    "city": "LOUISA",
    "state": "Kentucky",
    "zip": "41230",
    "lat": 38.1142544,
    "lng": -82.60321189999999
  },
  {
    "Store Location": "Tractor Supply 164 LEE AVE PIKEVILLE, Kentucky 41501",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-433-0890",
    "address": "164 LEE AVE, PIKEVILLE, Kentucky 41501",
    "city": "PIKEVILLE",
    "state": "Kentucky",
    "zip": "41501",
    "lat": 37.500591,
    "lng": -82.53496009999999
  },
  {
    "Store Location": "Tractor Supply 1671 STARLITE DR OWENSBORO, Kentucky 42301",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-683-0700",
    "address": "1671 STARLITE DR, OWENSBORO, Kentucky 42301",
    "city": "OWENSBORO",
    "state": "Kentucky",
    "zip": "42301",
    "lat": 37.7547917,
    "lng": -87.14969409999999
  },
  {
    "Store Location": "Tractor Supply 169 SOUTHSIDE MALL RD SOUTH WILLIAMSON, Kentucky 41503",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-237-0189",
    "address": "169 SOUTHSIDE MALL RD SOUTH, WILLIAMSON, Kentucky 41503",
    "city": "WILLIAMSON",
    "state": "Kentucky",
    "zip": "41503",
    "lat": 37.6527687,
    "lng": -82.2726723
  },
  {
    "Store Location": "Tractor Supply 1738 MAYFIELD HIGHWAY BENTON, Kentucky 42025",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-252-2262",
    "address": "1738 MAYFIELD HIGHWAY, BENTON, Kentucky 42025",
    "city": "BENTON",
    "state": "Kentucky",
    "zip": "42025",
    "lat": 36.8454298,
    "lng": -88.3769384
  },
  {
    "Store Location": "Tractor Supply 2003 PRIEST DR LAGRANGE, Kentucky 40031",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-222-0176",
    "address": "2003 PRIEST DR, LAGRANGE, Kentucky 40031",
    "city": "LAGRANGE",
    "state": "Kentucky",
    "zip": "40031",
    "lat": 38.3905867,
    "lng": -85.3663912
  },
  {
    "Store Location": "Tractor Supply 2030 US HWY 25 EAST MIDDLESBORO, Kentucky 40965",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-246-2345",
    "address": "2030 US HWY 25 EAST, MIDDLESBORO, Kentucky 40965",
    "city": "MIDDLESBORO",
    "state": "Kentucky",
    "zip": "40965",
    "lat": 36.618987,
    "lng": -83.7036927
  },
  {
    "Store Location": "Tractor Supply 2040 BYPASS RD PARIS, Kentucky 40361",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-988-1051",
    "address": "2040 BYPASS RD, PARIS, Kentucky 40361",
    "city": "PARIS",
    "state": "Kentucky",
    "zip": "40361",
    "lat": 38.204974,
    "lng": -84.27326
  },
  {
    "Store Location": "Tractor Supply 230 WEST PARK LAWRENCEBURG, Kentucky 40342",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-839-4401",
    "address": "230 WEST PARK, LAWRENCEBURG, Kentucky 40342",
    "city": "LAWRENCEBURG",
    "state": "Kentucky",
    "zip": "40342",
    "lat": 38.0194244,
    "lng": -84.90749319999999
  },
  {
    "Store Location": "Tractor Supply 235 KENTUCKY HOME SQ BARDSTOWN, Kentucky 40004",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-349-7327",
    "address": "235 KENTUCKY HOME SQ, BARDSTOWN, Kentucky 40004",
    "city": "BARDSTOWN",
    "state": "Kentucky",
    "zip": "40004",
    "lat": 37.8250986,
    "lng": -85.4655167
  },
  {
    "Store Location": "Tractor Supply 250 PINECREST DR MOREHEAD, Kentucky 40351",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-784-1006",
    "address": "250 PINECREST DR, MOREHEAD, Kentucky 40351",
    "city": "MOREHEAD",
    "state": "Kentucky",
    "zip": "40351",
    "lat": 38.1889911,
    "lng": -83.4822746
  },
  {
    "Store Location": "Tractor Supply 2900 SOUTH DANVILLE BYP STE 100 DANVILLE, Kentucky 40422",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-238-0163",
    "address": "2900 SOUTH DANVILLE BYP STE 100, DANVILLE, Kentucky 40422",
    "city": "DANVILLE",
    "state": "Kentucky",
    "zip": "40422",
    "lat": 37.6184022,
    "lng": -84.7786339
  },
  {
    "Store Location": "Tractor Supply 304 COOPER DR BEREA, Kentucky 40403",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-228-0063",
    "address": "304 COOPER DR, BEREA, Kentucky 40403",
    "city": "BEREA",
    "state": "Kentucky",
    "zip": "40403",
    "lat": 37.5982768,
    "lng": -84.3207582
  },
  {
    "Store Location": "Tractor Supply 305 CONNECTOR RD GEORGETOWN, Kentucky 40324",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-868-1040",
    "address": "305 CONNECTOR RD, GEORGETOWN, Kentucky 40324",
    "city": "GEORGETOWN",
    "state": "Kentucky",
    "zip": "40324",
    "lat": 38.224961,
    "lng": -84.5339473
  },
  {
    "Store Location": "Tractor Supply 3130 VILLA PT OWENSBORO, Kentucky 42303",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-926-7920",
    "address": "3130 VILLA PT, OWENSBORO, Kentucky 42303",
    "city": "OWENSBORO",
    "state": "Kentucky",
    "zip": "42303",
    "lat": 37.7524286,
    "lng": -87.0631155
  },
  {
    "Store Location": "Tractor Supply 324 FLOYD DR CARROLLTON, Kentucky 41008",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-732-5550",
    "address": "324 FLOYD DR, CARROLLTON, Kentucky 41008",
    "city": "CARROLLTON",
    "state": "Kentucky",
    "zip": "41008",
    "lat": 38.6594849,
    "lng": -85.13017099999999
  },
  {
    "Store Location": "Tractor Supply 330 VILLAGE LN HAZARD, Kentucky 41701",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-435-1422",
    "address": "330 VILLAGE LN, HAZARD, Kentucky 41701",
    "city": "HAZARD",
    "state": "Kentucky",
    "zip": "41701",
    "lat": 37.2815957,
    "lng": -83.2317797
  },
  {
    "Store Location": "Tractor Supply 3300 VETERANS OUTER LOOP GLASGOW, Kentucky 42141",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-678-8866",
    "address": "3300 VETERANS OUTER LOOP, GLASGOW, Kentucky 42141",
    "city": "GLASGOW",
    "state": "Kentucky",
    "zip": "42141",
    "lat": 37.0209565,
    "lng": -85.9426155
  },
  {
    "Store Location": "Tractor Supply 3639 SOUTH HWY 27 SOMERSET, Kentucky 42501",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-677-2777",
    "address": "3639 SOUTH HWY 27, SOMERSET, Kentucky 42501",
    "city": "SOMERSET",
    "state": "Kentucky",
    "zip": "42501",
    "lat": 37.0434937,
    "lng": -84.62734859999999
  },
  {
    "Store Location": "Tractor Supply 370 STATE HWY 1947 GRAYSON, Kentucky 41143",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-474-0707",
    "address": "370 STATE HWY 1947, GRAYSON, Kentucky 41143",
    "city": "GRAYSON",
    "state": "Kentucky",
    "zip": "41143",
    "lat": 38.3325812,
    "lng": -82.9485023
  },
  {
    "Store Location": "Tractor Supply 399 CAMPBELLSVILLE BYP STE 170 CAMPBELLSVILLE, Kentucky 42718",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-789-0864",
    "address": "399 CAMPBELLSVILLE BYP STE 170, CAMPBELLSVILLE, Kentucky 42718",
    "city": "CAMPBELLSVILLE",
    "state": "Kentucky",
    "zip": "42718",
    "lat": 37.34315360000001,
    "lng": -85.3692502
  },
  {
    "Store Location": "Tractor Supply 445 DIEDERICH BLVD ASHLAND, Kentucky 41101",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-327-5550",
    "address": "445 DIEDERICH BLVD, ASHLAND, Kentucky 41101",
    "city": "ASHLAND",
    "state": "Kentucky",
    "zip": "41101",
    "lat": 38.5034017,
    "lng": -82.6808302
  },
  {
    "Store Location": "Tractor Supply 448 OLD BRUNERSTOWN ROAD SHELBYVILLE, Kentucky 40065",
    "Store Type": "Tractor Supply",
    "Phone Number": "502-633-1523",
    "address": "448 OLD BRUNERSTOWN ROAD, SHELBYVILLE, Kentucky 40065",
    "city": "SHELBYVILLE",
    "state": "Kentucky",
    "zip": "40065",
    "lat": 38.1983649,
    "lng": -85.26996559999999
  },
  {
    "Store Location": "Tractor Supply 500 US HWY 62 WEST STE D PRINCETON, Kentucky 42445",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-365-1166",
    "address": "500 US HWY 62 WEST STE D, PRINCETON, Kentucky 42445",
    "city": "PRINCETON",
    "state": "Kentucky",
    "zip": "42445",
    "lat": 37.1125182,
    "lng": -87.9041337
  },
  {
    "Store Location": "Tractor Supply 501 MARKET SQUARE DR MAYSVILLE, Kentucky 41056",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-759-8500",
    "address": "501 MARKET SQUARE DR, MAYSVILLE, Kentucky 41056",
    "city": "MAYSVILLE",
    "state": "Kentucky",
    "zip": "41056",
    "lat": 38.62789160000001,
    "lng": -83.79483549999999
  },
  {
    "Store Location": "Tractor Supply 507 WEST MAIN ST LEBANON, Kentucky 40033",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-692-1464",
    "address": "507 WEST MAIN ST, LEBANON, Kentucky 40033",
    "city": "LEBANON",
    "state": "Kentucky",
    "zip": "40033",
    "lat": 37.565454,
    "lng": -85.2622832
  },
  {
    "Store Location": "Tractor Supply 5387 SCOTTSVILLE RD BOWLING GREEN, Kentucky 42104",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-842-0648",
    "address": "5387 SCOTTSVILLE RD BOWLING, GREEN, Kentucky 42104",
    "city": "GREEN",
    "state": "Kentucky",
    "zip": "42104",
    "lat": 36.9223848,
    "lng": -86.4108029
  },
  {
    "Store Location": "Tractor Supply 5525 US HWY 60 WEST PADUCAH, Kentucky 42001",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-442-6388",
    "address": "5525 US HWY 60 WEST, PADUCAH, Kentucky 42001",
    "city": "PADUCAH",
    "state": "Kentucky",
    "zip": "42001",
    "lat": 37.0721698,
    "lng": -88.70755559999999
  },
  {
    "Store Location": "Tractor Supply 5895 CENTENNIAL CIR FLORENCE, Kentucky 41042",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-746-1661",
    "address": "5895 CENTENNIAL CIR, FLORENCE, Kentucky 41042",
    "city": "FLORENCE",
    "state": "Kentucky",
    "zip": "41042",
    "lat": 39.0152965,
    "lng": -84.6710222
  },
  {
    "Store Location": "Tractor Supply 610 NORTH 12TH ST MURRAY, Kentucky 42071",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-753-5288",
    "address": "610 NORTH 12TH ST, MURRAY, Kentucky 42071",
    "city": "MURRAY",
    "state": "Kentucky",
    "zip": "42071",
    "lat": 36.6195141,
    "lng": -88.3130729
  },
  {
    "Store Location": "Tractor Supply 671 WOLFORD AVE LIBERTY, Kentucky 42539",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-787-0696",
    "address": "671 WOLFORD AVE, LIBERTY, Kentucky 42539",
    "city": "LIBERTY",
    "state": "Kentucky",
    "zip": "42539",
    "lat": 37.3231901,
    "lng": -84.9278686
  },
  {
    "Store Location": "Tractor Supply 7910 ALEXANDRIA PIKE ALEXANDRIA, Kentucky 41001",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-448-0936",
    "address": "7910 ALEXANDRIA PIKE, ALEXANDRIA, Kentucky 41001",
    "city": "ALEXANDRIA",
    "state": "Kentucky",
    "zip": "41001",
    "lat": 38.9721956,
    "lng": -84.38967219999999
  },
  {
    "Store Location": "Tractor Supply 804 INDIAN MOUND DR MOUNT STERLING, Kentucky 40353",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-497-4336",
    "address": "804 INDIAN MOUND DR MOUNT, STERLING, Kentucky 40353",
    "city": "STERLING",
    "state": "Kentucky",
    "zip": "40353",
    "lat": 38.0629969,
    "lng": -83.95326879999999
  },
  {
    "Store Location": "Tractor Supply 817 JAMESTOWN ST COLUMBIA, Kentucky 42728",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-385-9020",
    "address": "817 JAMESTOWN ST, COLUMBIA, Kentucky 42728",
    "city": "COLUMBIA",
    "state": "Kentucky",
    "zip": "42728",
    "lat": 37.0931677,
    "lng": -85.3019583
  },
  {
    "Store Location": "Tractor Supply 856 EASTERN BYP RICHMOND, Kentucky 40475",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-623-0034",
    "address": "856 EASTERN BYP, RICHMOND, Kentucky 40475",
    "city": "RICHMOND",
    "state": "Kentucky",
    "zip": "40475",
    "lat": 37.7306942,
    "lng": -84.27618799999999
  },
  {
    "Store Location": "Tractor Supply 980 EAST HWY 60 HARDINSBURG, Kentucky 40143",
    "Store Type": "Tractor Supply",
    "Phone Number": "270-756-2636",
    "address": "980 EAST HWY 60, HARDINSBURG, Kentucky 40143",
    "city": "HARDINSBURG",
    "state": "Kentucky",
    "zip": "40143",
    "lat": 37.7604934,
    "lng": -86.4415434
  },
  {
    "Store Location": "Tractor Supply 980 THIRD ST PAINTSVILLE, Kentucky 41240",
    "Store Type": "Tractor Supply",
    "Phone Number": "606-297-5570",
    "address": "980 THIRD ST, PAINTSVILLE, Kentucky 41240",
    "city": "PAINTSVILLE",
    "state": "Kentucky",
    "zip": "41240",
    "lat": 37.8238737,
    "lng": -82.8305702
  },
  {
    "Store Location": "Tractor Supply 994 US HWY 27 SOUTH STE 1 CYNTHIANA, Kentucky 41031",
    "Store Type": "Tractor Supply",
    "Phone Number": "859-234-6694",
    "address": "994 US HWY 27 SOUTH STE 1, CYNTHIANA, Kentucky 41031",
    "city": "CYNTHIANA",
    "state": "Kentucky",
    "zip": "41031",
    "lat": 38.3950708,
    "lng": -84.296859
  },
  {
    "Store Location": "Tractor Supply 10011 MAIN ST ZACHARY, Louisiana 70791",
    "Store Type": "Tractor Supply",
    "Phone Number": "225-658-5881",
    "address": "10011 MAIN ST, ZACHARY, Louisiana 70791",
    "city": "ZACHARY",
    "state": "Louisiana",
    "zip": "70791",
    "lat": 30.6492315,
    "lng": -91.10107359999999
  },
  {
    "Store Location": "Tractor Supply 1002 STERLINGTON HIGHWAY FARMERVILLE, Louisiana 71241",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-368-3383",
    "address": "1002 STERLINGTON HIGHWAY, FARMERVILLE, Louisiana 71241",
    "city": "FARMERVILLE",
    "state": "Louisiana",
    "zip": "71241",
    "lat": 32.768701,
    "lng": -92.391223
  },
  {
    "Store Location": "Tractor Supply 1050 NORTH PINE ST DERIDDER, Louisiana 70634",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-460-7760",
    "address": "1050 NORTH PINE ST, DERIDDER, Louisiana 70634",
    "city": "DERIDDER",
    "state": "Louisiana",
    "zip": "70634",
    "lat": 30.863743,
    "lng": -93.2850806
  },
  {
    "Store Location": "Tractor Supply 1090 HOMER RD MINDEN, Louisiana 71055",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-371-4407",
    "address": "1090 HOMER RD, MINDEN, Louisiana 71055",
    "city": "MINDEN",
    "state": "Louisiana",
    "zip": "71055",
    "lat": 32.6217929,
    "lng": -93.2568697
  },
  {
    "Store Location": "Tractor Supply 11085 HIGHWAY 16 AMITE, Louisiana 70422",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-747-6787",
    "address": "11085 HIGHWAY 16, AMITE, Louisiana 70422",
    "city": "AMITE",
    "state": "Louisiana",
    "zip": "70422",
    "lat": 30.7483072,
    "lng": -90.32326839999999
  },
  {
    "Store Location": "Tractor Supply 1111 BOONE ST STE 2 LEESVILLE, Louisiana 71446",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-238-5153",
    "address": "1111 BOONE ST STE 2, LEESVILLE, Louisiana 71446",
    "city": "LEESVILLE",
    "state": "Louisiana",
    "zip": "71446",
    "lat": 31.122736,
    "lng": -93.271604
  },
  {
    "Store Location": "Tractor Supply 12512 HWY 190 HAMMOND, Louisiana 70401",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-340-2888",
    "address": "12512 HWY 190, HAMMOND, Louisiana 70401",
    "city": "HAMMOND",
    "state": "Louisiana",
    "zip": "70401",
    "lat": 30.5035401,
    "lng": -90.5172266
  },
  {
    "Store Location": "Tractor Supply 1333 ELTON RD JENNINGS, Louisiana 70546",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-824-3434",
    "address": "1333 ELTON RD, JENNINGS, Louisiana 70546",
    "city": "JENNINGS",
    "state": "Louisiana",
    "zip": "70546",
    "lat": 30.2347453,
    "lng": -92.6644183
  },
  {
    "Store Location": "Tractor Supply 1404 REES ST BREAUX BRIDGE, Louisiana 70517",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-332-1919",
    "address": "1404 REES ST BREAUX, BRIDGE, Louisiana 70517",
    "city": "BRIDGE",
    "state": "Louisiana",
    "zip": "70517",
    "lat": 30.2857016,
    "lng": -91.9046575
  },
  {
    "Store Location": "Tractor Supply 155 SAN ANTONIO AVE STE A MANY, Louisiana 71449",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-590-9025",
    "address": "155 SAN ANTONIO AVE STE A, MANY, Louisiana 71449",
    "city": "MANY",
    "state": "Louisiana",
    "zip": "71449",
    "lat": 31.5666095,
    "lng": -93.49252860000001
  },
  {
    "Store Location": "Tractor Supply 1559 HWY 190 EUNICE, Louisiana 70535",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-457-5406",
    "address": "1559 HWY 190, EUNICE, Louisiana 70535",
    "city": "EUNICE",
    "state": "Louisiana",
    "zip": "70535",
    "lat": 30.49578279999999,
    "lng": -92.4468768
  },
  {
    "Store Location": "Tractor Supply 1795 3RD ST SOUTHEAST SPRINGHILL, Louisiana 71075",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-539-9150",
    "address": "1795 3RD ST SOUTHEAST, SPRINGHILL, Louisiana 71075",
    "city": "SPRINGHILL",
    "state": "Louisiana",
    "zip": "71075",
    "lat": 32.9848297,
    "lng": -93.4578781
  },
  {
    "Store Location": "Tractor Supply 1805 WEST COURT ST WINNFIELD, Louisiana 71483",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-628-2697",
    "address": "1805 WEST COURT ST, WINNFIELD, Louisiana 71483",
    "city": "WINNFIELD",
    "state": "Louisiana",
    "zip": "71483",
    "lat": 31.93429739999999,
    "lng": -92.6547667
  },
  {
    "Store Location": "Tractor Supply 181 GRIMSHAW ST RAYVILLE, Louisiana 71269",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-728-3737",
    "address": "181 GRIMSHAW ST, RAYVILLE, Louisiana 71269",
    "city": "RAYVILLE",
    "state": "Louisiana",
    "zip": "71269",
    "lat": 32.4587608,
    "lng": -91.7622011
  },
  {
    "Store Location": "Tractor Supply 181 HWY 171 LAKE CHARLES, Louisiana 70611",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-855-1031",
    "address": "181 HWY 171 LAKE, CHARLES, Louisiana 70611",
    "city": "CHARLES",
    "state": "Louisiana",
    "zip": "70611",
    "lat": 30.2737791,
    "lng": -93.1761431
  },
  {
    "Store Location": "Tractor Supply 1884 COLLINS BLVD COVINGTON, Louisiana 70433",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-892-9552",
    "address": "1884 COLLINS BLVD, COVINGTON, Louisiana 70433",
    "city": "COVINGTON",
    "state": "Louisiana",
    "zip": "70433",
    "lat": 30.4952097,
    "lng": -90.10163639999999
  },
  {
    "Store Location": "Tractor Supply 201 MANE ST WEST MONROE, Louisiana 71292",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-329-1123",
    "address": "201 MANE ST WEST, MONROE, Louisiana 71292",
    "city": "MONROE",
    "state": "Louisiana",
    "zip": "71292",
    "lat": 32.5072063,
    "lng": -92.1731454
  },
  {
    "Store Location": "Tractor Supply 204 ODD FELLOWS RD CROWLEY, Louisiana 70526",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-783-3670",
    "address": "204 ODD FELLOWS RD, CROWLEY, Louisiana 70526",
    "city": "CROWLEY",
    "state": "Louisiana",
    "zip": "70526",
    "lat": 30.2294072,
    "lng": -92.37913019999999
  },
  {
    "Store Location": "Tractor Supply 2050 FALSE RIVER DR STE A NEW ROADS, Louisiana 70760",
    "Store Type": "Tractor Supply",
    "Phone Number": "225-638-7669",
    "address": "2050 FALSE RIVER DR STE A NEW, ROADS, Louisiana 70760",
    "city": "ROADS",
    "state": "Louisiana",
    "zip": "70760",
    "lat": 30.6852456,
    "lng": -91.459707
  },
  {
    "Store Location": "Tractor Supply 2083 GAUSE BLVD WEST SLIDELL, Louisiana 70460",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-643-6434",
    "address": "2083 GAUSE BLVD WEST, SLIDELL, Louisiana 70460",
    "city": "SLIDELL",
    "state": "Louisiana",
    "zip": "70460",
    "lat": 30.3000328,
    "lng": -89.8188535
  },
  {
    "Store Location": "Tractor Supply 2125 WASHINGTON ST FRANKLINTON, Louisiana 70438",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-839-2828",
    "address": "2125 WASHINGTON ST, FRANKLINTON, Louisiana 70438",
    "city": "FRANKLINTON",
    "state": "Louisiana",
    "zip": "70438",
    "lat": 30.8473544,
    "lng": -90.1341456
  },
  {
    "Store Location": "Tractor Supply 2151 AUTOPLEX DR BOSSIER CITY, Louisiana 71111",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-746-1235",
    "address": "2151 AUTOPLEX DR BOSSIER, CITY, Louisiana 71111",
    "city": "CITY",
    "state": "Louisiana",
    "zip": "71111",
    "lat": 32.5611319,
    "lng": -93.7304834
  },
  {
    "Store Location": "Tractor Supply 2152 HIGHWAY 70 DONALDSONVILLE, Louisiana 70346",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7537",
    "address": "2152 HIGHWAY 70, DONALDSONVILLE, Louisiana 70346",
    "city": "DONALDSONVILLE",
    "state": "Louisiana",
    "zip": "70346",
    "lat": 30.0916976,
    "lng": -90.9372064
  },
  {
    "Store Location": "Tractor Supply 225 LAKE RD MANSFIELD, Louisiana 71052",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-872-2171",
    "address": "225 LAKE RD, MANSFIELD, Louisiana 71052",
    "city": "MANSFIELD",
    "state": "Louisiana",
    "zip": "71052",
    "lat": 32.0419452,
    "lng": -93.6944341
  },
  {
    "Store Location": "Tractor Supply 2310 EAST MADISON AVE BASTROP, Louisiana 71220",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-281-1604",
    "address": "2310 EAST MADISON AVE, BASTROP, Louisiana 71220",
    "city": "BASTROP",
    "state": "Louisiana",
    "zip": "71220",
    "lat": 32.775263,
    "lng": -91.8840798
  },
  {
    "Store Location": "Tractor Supply 2335 WEST AIRLINE HWY LAPLACE, Louisiana 70068",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-652-8808",
    "address": "2335 WEST AIRLINE HWY, LAPLACE, Louisiana 70068",
    "city": "LAPLACE",
    "state": "Louisiana",
    "zip": "70068",
    "lat": 30.0752033,
    "lng": -90.51660539999999
  },
  {
    "Store Location": "Tractor Supply 241 ACADIANA PREP CIR OPELOUSAS, Louisiana 70570",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-407-9525",
    "address": "241 ACADIANA PREP CIR, OPELOUSAS, Louisiana 70570",
    "city": "OPELOUSAS",
    "state": "Louisiana",
    "zip": "70570",
    "lat": 30.5377545,
    "lng": -92.05717489999999
  },
  {
    "Store Location": "Tractor Supply 246 FLORIDA AVE SOUTHEAST DENHAM SPRINGS, Louisiana 70726",
    "Store Type": "Tractor Supply",
    "Phone Number": "225-665-9042",
    "address": "246 FLORIDA AVE SOUTHEAST DENHAM, SPRINGS, Louisiana 70726",
    "city": "SPRINGS",
    "state": "Louisiana",
    "zip": "70726",
    "lat": 30.4820454,
    "lng": -90.95304399999999
  },
  {
    "Store Location": "Tractor Supply 2505 ARCHBISHOP HANNAN BLVD MERAUX, Louisiana 70075",
    "Store Type": "Tractor Supply",
    "Phone Number": "504-277-4242",
    "address": "2505 ARCHBISHOP HANNAN BLVD, MERAUX, Louisiana 70075",
    "city": "MERAUX",
    "state": "Louisiana",
    "zip": "70075",
    "lat": 29.9333374,
    "lng": -89.9232511
  },
  {
    "Store Location": "Tractor Supply 2507 NORTH SERVICE RD EAST RUSTON, Louisiana 71270",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-255-9349",
    "address": "2507 NORTH SERVICE RD EAST, RUSTON, Louisiana 71270",
    "city": "RUSTON",
    "state": "Louisiana",
    "zip": "71270",
    "lat": 32.5416955,
    "lng": -92.6057545
  },
  {
    "Store Location": "Tractor Supply 2751 POWER CENTRE PARKWAY LAKE CHARLES, Louisiana 70607",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-477-7676",
    "address": "2751 POWER CENTRE PARKWAY LAKE, CHARLES, Louisiana 70607",
    "city": "CHARLES",
    "state": "Louisiana",
    "zip": "70607",
    "lat": 30.1889446,
    "lng": -93.1766914
  },
  {
    "Store Location": "Tractor Supply 3162 NORTH MACARTHUR DR ALEXANDRIA, Louisiana 71303",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-473-9167",
    "address": "3162 NORTH MACARTHUR DR, ALEXANDRIA, Louisiana 71303",
    "city": "ALEXANDRIA",
    "state": "Louisiana",
    "zip": "71303",
    "lat": 31.3069265,
    "lng": -92.4812501
  },
  {
    "Store Location": "Tractor Supply 320 CUMBERLAND ST BOGALUSA, Louisiana 70427",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-732-3055",
    "address": "320 CUMBERLAND ST, BOGALUSA, Louisiana 70427",
    "city": "BOGALUSA",
    "state": "Louisiana",
    "zip": "70427",
    "lat": 30.7903205,
    "lng": -89.86212859999999
  },
  {
    "Store Location": "Tractor Supply 3282 FRONT ST WINNSBORO, Louisiana 71295",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-435-8618",
    "address": "3282 FRONT ST, WINNSBORO, Louisiana 71295",
    "city": "WINNSBORO",
    "state": "Louisiana",
    "zip": "71295",
    "lat": 32.1841272,
    "lng": -91.7278496
  },
  {
    "Store Location": "Tractor Supply 340 WEST CAL BLVD SULPHUR, Louisiana 70665",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-527-7771",
    "address": "340 WEST CAL BLVD, SULPHUR, Louisiana 70665",
    "city": "SULPHUR",
    "state": "Louisiana",
    "zip": "70665",
    "lat": 30.2118637,
    "lng": -93.3782951
  },
  {
    "Store Location": "Tractor Supply 3410 VETERANS MEMORIAL DR ABBEVILLE, Louisiana 70510",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-893-6195",
    "address": "3410 VETERANS MEMORIAL DR, ABBEVILLE, Louisiana 70510",
    "city": "ABBEVILLE",
    "state": "Louisiana",
    "zip": "70510",
    "lat": 29.96726989999999,
    "lng": -92.0866695
  },
  {
    "Store Location": "Tractor Supply 345 SOUTH DR NATCHITOCHES, Louisiana 71457",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-354-0389",
    "address": "345 SOUTH DR, NATCHITOCHES, Louisiana 71457",
    "city": "NATCHITOCHES",
    "state": "Louisiana",
    "zip": "71457",
    "lat": 31.7431995,
    "lng": -93.0803138
  },
  {
    "Store Location": "Tractor Supply 356 AIRPORT DR JENA, Louisiana 71342",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-992-2100",
    "address": "356 AIRPORT DR, JENA, Louisiana 71342",
    "city": "JENA",
    "state": "Louisiana",
    "zip": "71342",
    "lat": 31.6823476,
    "lng": -92.1378768
  },
  {
    "Store Location": "Tractor Supply 3827 WEST PARK AVE GRAY, Louisiana 70359",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-879-2342",
    "address": "3827 WEST PARK AVE, GRAY, Louisiana 70359",
    "city": "GRAY",
    "state": "Louisiana",
    "zip": "70359",
    "lat": 29.6833335,
    "lng": -90.7830462
  },
  {
    "Store Location": "Tractor Supply 414 WEST HWY 30 GONZALES, Louisiana 70737",
    "Store Type": "Tractor Supply",
    "Phone Number": "225-644-3900",
    "address": "414 WEST HWY 30, GONZALES, Louisiana 70737",
    "city": "GONZALES",
    "state": "Louisiana",
    "zip": "70737",
    "lat": 30.2124204,
    "lng": -90.9239297
  },
  {
    "Store Location": "Tractor Supply 4724 HIGHWAY 1 RACELAND, Louisiana 70394",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-537-5757",
    "address": "4724 HIGHWAY 1, RACELAND, Louisiana 70394",
    "city": "RACELAND",
    "state": "Louisiana",
    "zip": "70394",
    "lat": 29.6986761,
    "lng": -90.55829489999999
  },
  {
    "Store Location": "Tractor Supply 58485 BELLEVIEW RD PLAQUEMINE, Louisiana 70764",
    "Store Type": "Tractor Supply",
    "Phone Number": "225-687-9363",
    "address": "58485 BELLEVIEW RD, PLAQUEMINE, Louisiana 70764",
    "city": "PLAQUEMINE",
    "state": "Louisiana",
    "zip": "70764",
    "lat": 30.2731447,
    "lng": -91.2354943
  },
  {
    "Store Location": "Tractor Supply 651 I 10 NORTH FRONTAGE RD SCOTT, Louisiana 70583",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-233-2221",
    "address": "651 I 10 NORTH FRONTAGE RD, SCOTT, Louisiana 70583",
    "city": "SCOTT",
    "state": "Louisiana",
    "zip": "70583",
    "lat": 30.2504559,
    "lng": -92.1112491
  },
  {
    "Store Location": "Tractor Supply 7327 US HIGHWAY 61 SAINT FRANCISVILLE, Louisiana 70775",
    "Store Type": "Tractor Supply",
    "Phone Number": "225-635-2223",
    "address": "7327 US HIGHWAY 61 SAINT, FRANCISVILLE, Louisiana 70775",
    "city": "FRANCISVILLE",
    "state": "Louisiana",
    "zip": "70775",
    "lat": 30.793273,
    "lng": -91.3820439
  },
  {
    "Store Location": "Tractor Supply 733 HWY 165 SOUTH OAKDALE, Louisiana 71463",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-335-0006",
    "address": "733 HWY 165 SOUTH, OAKDALE, Louisiana 71463",
    "city": "OAKDALE",
    "state": "Louisiana",
    "zip": "71463",
    "lat": 30.808152,
    "lng": -92.6517024
  },
  {
    "Store Location": "Tractor Supply 7686 HWY 1 MANSURA, Louisiana 71350",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-240-8338",
    "address": "7686 HWY 1, MANSURA, Louisiana 71350",
    "city": "MANSURA",
    "state": "Louisiana",
    "zip": "71350",
    "lat": 31.0832707,
    "lng": -92.05676199999999
  },
  {
    "Store Location": "Tractor Supply 773 HIGHWAY 90 EAST MORGAN CITY, Louisiana 70380",
    "Store Type": "Tractor Supply",
    "Phone Number": "985-395-2000",
    "address": "773 HIGHWAY 90 EAST MORGAN, CITY, Louisiana 70380",
    "city": "CITY",
    "state": "Louisiana",
    "zip": "70380",
    "lat": 29.6807388,
    "lng": -91.2754447
  },
  {
    "Store Location": "Tractor Supply 808 HWY 90 EAST NEW IBERIA, Louisiana 70560",
    "Store Type": "Tractor Supply",
    "Phone Number": "337-364-0463",
    "address": "808 HWY 90 EAST NEW, IBERIA, Louisiana 70560",
    "city": "IBERIA",
    "state": "Louisiana",
    "zip": "70560",
    "lat": 29.9714761,
    "lng": -91.8434666
  },
  {
    "Store Location": "Tractor Supply 9620 MANSFIELD RD SHREVEPORT, Louisiana 71118",
    "Store Type": "Tractor Supply",
    "Phone Number": "318-682-3882",
    "address": "9620 MANSFIELD RD, SHREVEPORT, Louisiana 71118",
    "city": "SHREVEPORT",
    "state": "Louisiana",
    "zip": "71118",
    "lat": 32.3861887,
    "lng": -93.81882759999999
  },
  {
    "Store Location": "Tractor Supply 1313 MAIN ST MILLIS, Massachusetts 2054",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-376-5550",
    "address": "1313 MAIN ST MILLIS, Massachusetts 2054,  ",
    "city": "Massachusetts 2054",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.161283,
    "lng": -71.3774504
  },
  {
    "Store Location": "Tractor Supply 1445 MAIN ST LEICESTER, Massachusetts 1524",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-892-8334",
    "address": "1445 MAIN ST LEICESTER, Massachusetts 1524,  ",
    "city": "Massachusetts 1524",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.2395402,
    "lng": -71.8564289
  },
  {
    "Store Location": "Tractor Supply 168 MILK ST STE 5 WESTBOROUGH, Massachusetts 1581",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-366-0333",
    "address": "168 MILK ST STE 5 WESTBOROUGH, Massachusetts 1581,  ",
    "city": "Massachusetts 1581",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.28141309999999,
    "lng": -71.633312
  },
  {
    "Store Location": "Tractor Supply 178 MAIN ST STURBRIDGE, Massachusetts 1566",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-347-3057",
    "address": "178 MAIN ST STURBRIDGE, Massachusetts 1566,  ",
    "city": "Massachusetts 1566",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.0979131,
    "lng": -72.071074
  },
  {
    "Store Location": "Tractor Supply 2 COLLEGE HWY SOUTHAMPTON, Massachusetts 1073",
    "Store Type": "Tractor Supply",
    "Phone Number": "413-527-5566",
    "address": "2 COLLEGE HWY SOUTHAMPTON, Massachusetts 1073,  ",
    "city": "Massachusetts 1073",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.2541282,
    "lng": -72.69743129999999
  },
  {
    "Store Location": "Tractor Supply 207 SWANSEA MALL DR STE 15 SWANSEA, Massachusetts 2777",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-673-5000",
    "address": "207 SWANSEA MALL DR STE 15 SWANSEA, Massachusetts 2777,  ",
    "city": "Massachusetts 2777",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.75559,
    "lng": -71.2128942
  },
  {
    "Store Location": "Tractor Supply 2101 BAY ST STE A TAUNTON, Massachusetts 2780",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-822-6500",
    "address": "2101 BAY ST STE A TAUNTON, Massachusetts 2780,  ",
    "city": "Massachusetts 2780",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.9610937,
    "lng": -71.1172785
  },
  {
    "Store Location": "Tractor Supply 235 NEW LANCASTER RD LEOMINSTER, Massachusetts 1453",
    "Store Type": "Tractor Supply",
    "Phone Number": "978-534-9620",
    "address": "235 NEW LANCASTER RD LEOMINSTER, Massachusetts 1453,  ",
    "city": "Massachusetts 1453",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.4931608,
    "lng": -71.7302496
  },
  {
    "Store Location": "Tractor Supply 30 TURKEY HILL RD BELCHERTOWN, Massachusetts 1007",
    "Store Type": "Tractor Supply",
    "Phone Number": "413-323-1117",
    "address": "30 TURKEY HILL RD BELCHERTOWN, Massachusetts 1007,  ",
    "city": "Massachusetts 1007",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.266777,
    "lng": -72.41926579999999
  },
  {
    "Store Location": "Tractor Supply 3017 CRANBERRY HWY EAST WAREHAM, Massachusetts 2538",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-295-9100",
    "address": "3017 CRANBERRY HWY EAST WAREHAM, Massachusetts 2538,  ",
    "city": "Massachusetts 2538",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.7571332,
    "lng": -70.6607496
  },
  {
    "Store Location": "Tractor Supply 356 STOCKBRIDGE ROAD GREAT BARRINGTON, Massachusetts 1230",
    "Store Type": "Tractor Supply",
    "Phone Number": "413-528-2211",
    "address": "356 STOCKBRIDGE ROAD GREAT BARRINGTON, Massachusetts 1230,  ",
    "city": "Massachusetts 1230",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.2105269,
    "lng": -73.3424081
  },
  {
    "Store Location": "Tractor Supply 384 Timpany Blvd GARDNER, Massachusetts 1440",
    "Store Type": "Tractor Supply",
    "Phone Number": "978-632-6666",
    "address": "384 Timpany Blvd GARDNER, Massachusetts 1440,  ",
    "city": "Massachusetts 1440",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.5577796,
    "lng": -71.9894929
  },
  {
    "Store Location": "Tractor Supply 389 COLUMBIA RD STE 10 HANOVER, Massachusetts 2339",
    "Store Type": "Tractor Supply",
    "Phone Number": "781-826-8080",
    "address": "389 COLUMBIA RD STE 10 HANOVER, Massachusetts 2339,  ",
    "city": "Massachusetts 2339",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.1083268,
    "lng": -70.8129261
  },
  {
    "Store Location": "Tractor Supply 406 MAIN ST PLYMPTON, Massachusetts 2367",
    "Store Type": "Tractor Supply",
    "Phone Number": "781-422-2216",
    "address": "406 MAIN ST PLYMPTON, Massachusetts 2367,  ",
    "city": "Massachusetts 2367",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.93354739999999,
    "lng": -70.8121587
  },
  {
    "Store Location": "Tractor Supply 5 PLAZA WAY FAIRHAVEN, Massachusetts 2719",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-999-1177",
    "address": "5 PLAZA WAY FAIRHAVEN, Massachusetts 2719,  ",
    "city": "Massachusetts 2719",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.6396953,
    "lng": -70.8872603
  },
  {
    "Store Location": "Tractor Supply 673 COLLEGE HWY SOUTHWICK, Massachusetts 1077",
    "Store Type": "Tractor Supply",
    "Phone Number": "413-569-0090",
    "address": "673 COLLEGE HWY SOUTHWICK, Massachusetts 1077,  ",
    "city": "Massachusetts 1077",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.0716399,
    "lng": -72.7663276
  },
  {
    "Store Location": "Tractor Supply 72 NEWTON ST GREENFIELD, Massachusetts 1301",
    "Store Type": "Tractor Supply",
    "Phone Number": "413-772-2100",
    "address": "72 NEWTON ST GREENFIELD, Massachusetts 1301,  ",
    "city": "Massachusetts 1301",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.5830304,
    "lng": -72.6179812
  },
  {
    "Store Location": "Tractor Supply 800 S FRANKLIN ST STE 4 HOLBROOK, Massachusetts 2343",
    "Store Type": "Tractor Supply",
    "Phone Number": "781-986-1491",
    "address": "800 S FRANKLIN ST STE 4 HOLBROOK, Massachusetts 2343,  ",
    "city": "Massachusetts 2343",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.1288893,
    "lng": -71.01058909999999
  },
  {
    "Store Location": "Tractor Supply 82 TURNPIKE RD IPSWICH, Massachusetts 1938",
    "Store Type": "Tractor Supply",
    "Phone Number": "978-356-4396",
    "address": "82 TURNPIKE RD IPSWICH, Massachusetts 1938,  ",
    "city": "Massachusetts 1938",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.6886157,
    "lng": -70.9175781
  },
  {
    "Store Location": "Tractor Supply 826 CURRAN MEMORIAL HWY NORTH ADAMS, Massachusetts 1247",
    "Store Type": "Tractor Supply",
    "Phone Number": "413-664-6950",
    "address": "826 CURRAN MEMORIAL HWY NORTH ADAMS, Massachusetts 1247,  ",
    "city": "Massachusetts 1247",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.6711993,
    "lng": -73.1006492
  },
  {
    "Store Location": "Tractor Supply 83 NEW ATHOL RD ORANGE, Massachusetts 1364",
    "Store Type": "Tractor Supply",
    "Phone Number": "978-544-3750",
    "address": "83 NEW ATHOL RD ORANGE, Massachusetts 1364,  ",
    "city": "Massachusetts 1364",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.58634,
    "lng": -72.2711866
  },
  {
    "Store Location": "Tractor Supply 898 CRANE AVE STE 201 PITTSFIELD, Massachusetts 1201",
    "Store Type": "Tractor Supply",
    "Phone Number": "413-236-5871",
    "address": "898 CRANE AVE STE 201 PITTSFIELD, Massachusetts 1201,  ",
    "city": "Massachusetts 1201",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.4675752,
    "lng": -73.206589
  },
  {
    "Store Location": "Tractor Supply 99 WORCESTER PROVIDENCE TPKE MILLBURY, Massachusetts 1527",
    "Store Type": "Tractor Supply",
    "Phone Number": "508-865-5350",
    "address": "99 WORCESTER PROVIDENCE TPKE MILLBURY, Massachusetts 1527,  ",
    "city": "Massachusetts 1527",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.1920983,
    "lng": -71.7691081
  },
  {
    "Store Location": "Tractor Supply 1040 BEARDS HILL RD ABERDEEN, Maryland 21001",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-297-6607",
    "address": "1040 BEARDS HILL RD, ABERDEEN, Maryland 21001",
    "city": "ABERDEEN",
    "state": "Maryland",
    "zip": "21001",
    "lat": 39.5202928,
    "lng": -76.1844488
  },
  {
    "Store Location": "Tractor Supply 10452 OLD OCEAN CITY BLVD UNIT 2 BERLIN, Maryland 21811",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-641-0310",
    "address": "10452 OLD OCEAN CITY BLVD UNIT 2, BERLIN, Maryland 21811",
    "city": "BERLIN",
    "state": "Maryland",
    "zip": "21811",
    "lat": 38.3398553,
    "lng": -75.197673
  },
  {
    "Store Location": "Tractor Supply 10795 WAWA LN WHITE PLAINS, Maryland 20695",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-632-2266",
    "address": "10795 WAWA LN WHITE, PLAINS, Maryland 20695",
    "city": "PLAINS",
    "state": "Maryland",
    "zip": "20695",
    "lat": 38.5940775,
    "lng": -76.9374521
  },
  {
    "Store Location": "Tractor Supply 1111 EAST PULASKI HWY ELKTON, Maryland 21921",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-392-2227",
    "address": "1111 EAST PULASKI HWY, ELKTON, Maryland 21921",
    "city": "ELKTON",
    "state": "Maryland",
    "zip": "21921",
    "lat": 39.6047624,
    "lng": -75.7952555
  },
  {
    "Store Location": "Tractor Supply 112 EAST NORTH POINT DR SALISBURY, Maryland 21804",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-219-2601",
    "address": "112 EAST NORTH POINT DR, SALISBURY, Maryland 21804",
    "city": "SALISBURY",
    "state": "Maryland",
    "zip": "21804",
    "lat": 38.414568,
    "lng": -75.5624682
  },
  {
    "Store Location": "Tractor Supply 1151 BALTIMORE BLVD WESTMINSTER, Maryland 21157",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-848-2060",
    "address": "1151 BALTIMORE BLVD, WESTMINSTER, Maryland 21157",
    "city": "WESTMINSTER",
    "state": "Maryland",
    "zip": "21157",
    "lat": 39.55178100000001,
    "lng": -76.9549778
  },
  {
    "Store Location": "Tractor Supply 12101 WINCHESTER RD SOUTHWEST STE 2B LAVALE, Maryland 21502",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-729-8525",
    "address": "12101 WINCHESTER RD SOUTHWEST STE 2B, LAVALE, Maryland 21502",
    "city": "LAVALE",
    "state": "Maryland",
    "zip": "21502",
    "lat": 39.6311773,
    "lng": -78.83923759999999
  },
  {
    "Store Location": "Tractor Supply 13631 GARRETT HWY OAKLAND, Maryland 21550",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-334-3463",
    "address": "13631 GARRETT HWY, OAKLAND, Maryland 21550",
    "city": "OAKLAND",
    "state": "Maryland",
    "zip": "21550",
    "lat": 39.4314138,
    "lng": -79.3867949
  },
  {
    "Store Location": "Tractor Supply 1701 MARKET ST UNIT 109 POCOMOKE CITY, Maryland 21851",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-957-3491",
    "address": "1701 MARKET ST UNIT 109 POCOMOKE, CITY, Maryland 21851",
    "city": "CITY",
    "state": "Maryland",
    "zip": "21851",
    "lat": 38.0622438,
    "lng": -75.548277
  },
  {
    "Store Location": "Tractor Supply 1701 MASSEY BLVD HAGERSTOWN, Maryland 21740",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-665-1004",
    "address": "1701 MASSEY BLVD, HAGERSTOWN, Maryland 21740",
    "city": "HAGERSTOWN",
    "state": "Maryland",
    "zip": "21740",
    "lat": 39.6282562,
    "lng": -77.76291030000002
  },
  {
    "Store Location": "Tractor Supply 19610 FISHER AVE POOLESVILLE, Maryland 20837",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-407-0307",
    "address": "19610 FISHER AVE, POOLESVILLE, Maryland 20837",
    "city": "POOLESVILLE",
    "state": "Maryland",
    "zip": "20837",
    "lat": 39.1429527,
    "lng": -77.410771
  },
  {
    "Store Location": "Tractor Supply 222 MOUNTAIN ROAD FALLSTON, Maryland 21047",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-420-1212",
    "address": "222 MOUNTAIN ROAD, FALLSTON, Maryland 21047",
    "city": "FALLSTON",
    "state": "Maryland",
    "zip": "21047",
    "lat": 39.4924618,
    "lng": -76.3963898
  },
  {
    "Store Location": "Tractor Supply 23788 MERVELL DEAN RD HOLLYWOOD, Maryland 20636",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-373-5261",
    "address": "23788 MERVELL DEAN RD, HOLLYWOOD, Maryland 20636",
    "city": "HOLLYWOOD",
    "state": "Maryland",
    "zip": "20636",
    "lat": 38.3213868,
    "lng": -76.5430696
  },
  {
    "Store Location": "Tractor Supply 29328 CECIL DR EASTON, Maryland 21601",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-770-6413",
    "address": "29328 CECIL DR, EASTON, Maryland 21601",
    "city": "EASTON",
    "state": "Maryland",
    "zip": "21601",
    "lat": 38.7903854,
    "lng": -76.0579709
  },
  {
    "Store Location": "Tractor Supply 301 CENTURY DR MOUNT AIRY, Maryland 21771",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-831-7877",
    "address": "301 CENTURY DR MOUNT, AIRY, Maryland 21771",
    "city": "AIRY",
    "state": "Maryland",
    "zip": "21771",
    "lat": 39.3675773,
    "lng": -77.1416059
  },
  {
    "Store Location": "Tractor Supply 3150 NORTH SOLOMONS ISLAND RD HUNTINGTOWN, Maryland 20639",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-414-5111",
    "address": "3150 NORTH SOLOMONS ISLAND RD, HUNTINGTOWN, Maryland 20639",
    "city": "HUNTINGTOWN",
    "state": "Maryland",
    "zip": "20639",
    "lat": 38.6001367,
    "lng": -76.61550609999999
  },
  {
    "Store Location": "Tractor Supply 37662 MOUNT WOLF ROAD CHARLOTTE HALL, Maryland 20622",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-884-3333",
    "address": "37662 MOUNT WOLF ROAD CHARLOTTE, HALL, Maryland 20622",
    "city": "HALL",
    "state": "Maryland",
    "zip": "20622",
    "lat": 38.5019046,
    "lng": -76.7731858
  },
  {
    "Store Location": "Tractor Supply 5431 SOUTHERN MARYLAND BLVD LOTHIAN, Maryland 20711",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-741-9021",
    "address": "5431 SOUTHERN MARYLAND BLVD, LOTHIAN, Maryland 20711",
    "city": "LOTHIAN",
    "state": "Maryland",
    "zip": "20711",
    "lat": 38.8106228,
    "lng": -76.69911979999999
  },
  {
    "Store Location": "Tractor Supply 5450 MOUNT ZION RD FREDERICK, Maryland 21703",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-473-5751",
    "address": "5450 MOUNT ZION RD, FREDERICK, Maryland 21703",
    "city": "FREDERICK",
    "state": "Maryland",
    "zip": "21703",
    "lat": 39.3807232,
    "lng": -77.47828609999999
  },
  {
    "Store Location": "Tractor Supply 711 WASHINGTON AVE STE 1B CHESTERTOWN, Maryland 21620",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-778-2047",
    "address": "711 WASHINGTON AVE STE 1B, CHESTERTOWN, Maryland 21620",
    "city": "CHESTERTOWN",
    "state": "Maryland",
    "zip": "21620",
    "lat": 39.2242566,
    "lng": -76.06822460000001
  },
  {
    "Store Location": "Tractor Supply 7631 DEVILBISS BRIDGE RD FREDERICK, Maryland 21701",
    "Store Type": "Tractor Supply",
    "Phone Number": "301-898-7594",
    "address": "7631 DEVILBISS BRIDGE RD, FREDERICK, Maryland 21701",
    "city": "FREDERICK",
    "state": "Maryland",
    "zip": "21701",
    "lat": 39.5060799,
    "lng": -77.4016094
  },
  {
    "Store Location": "Tractor Supply 7994 CRAIN HWY SOUTH GLEN BURNIE, Maryland 21061",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-969-8900",
    "address": "7994 CRAIN HWY SOUTH GLEN, BURNIE, Maryland 21061",
    "city": "BURNIE",
    "state": "Maryland",
    "zip": "21061",
    "lat": 39.132607,
    "lng": -76.64121999999999
  },
  {
    "Store Location": "Tractor Supply 9910 LIBERTY RD RANDALLSTOWN, Maryland 21133",
    "Store Type": "Tractor Supply",
    "Phone Number": "410-521-1515",
    "address": "9910 LIBERTY RD, RANDALLSTOWN, Maryland 21133",
    "city": "RANDALLSTOWN",
    "state": "Maryland",
    "zip": "21133",
    "lat": 39.382764,
    "lng": -76.8235321
  },
  {
    "Store Location": "Tractor Supply 10 JFK PLZ WATERVILLE, Maine 4901",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-877-7775",
    "address": "10 JFK PLZ WATERVILLE, Maine 4901,  ",
    "city": "Maine 4901",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.53975,
    "lng": -69.65381
  },
  {
    "Store Location": "Tractor Supply 1073 WEST MAIN ST STE 1 DOVER FOXCROFT, Maine 4426",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-564-6590",
    "address": "1073 WEST MAIN ST STE 1 DOVER FOXCROFT, Maine 4426,  ",
    "city": "Maine 4426",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 45.1832816,
    "lng": -69.25621439999999
  },
  {
    "Store Location": "Tractor Supply 1161 BROADWAY BANGOR, Maine 4401",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-947-9604",
    "address": "1161 BROADWAY BANGOR, Maine 4401,  ",
    "city": "Maine 4401",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.83738899999999,
    "lng": -68.7913533
  },
  {
    "Store Location": "Tractor Supply 1272 MAIN ST OXFORD, Maine 4270",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-743-7200",
    "address": "1272 MAIN ST OXFORD, Maine 4270,  ",
    "city": "Maine 4270",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.1752051,
    "lng": -70.5139817
  },
  {
    "Store Location": "Tractor Supply 142 VALLEY CIR RUMFORD, Maine 4276",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-364-4444",
    "address": "142 VALLEY CIR RUMFORD, Maine 4276,  ",
    "city": "Maine 4276",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.5223251,
    "lng": -70.5395048
  },
  {
    "Store Location": "Tractor Supply 1560 MAIN ST PALMYRA, Maine 4965",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-368-2299",
    "address": "1560 MAIN ST PALMYRA, Maine 4965,  ",
    "city": "Maine 4965",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.8396183,
    "lng": -69.2947181
  },
  {
    "Store Location": "Tractor Supply 1619 LISBON ST LEWISTON, Maine 4240",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-795-8828",
    "address": "1619 LISBON ST LEWISTON, Maine 4240,  ",
    "city": "Maine 4240",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.0695306,
    "lng": -70.1712321
  },
  {
    "Store Location": "Tractor Supply 1770 MAIN ST SANFORD, Maine 4073",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-490-0034",
    "address": "1770 MAIN ST SANFORD, Maine 4073,  ",
    "city": "Maine 4073",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.403633,
    "lng": -70.7154693
  },
  {
    "Store Location": "Tractor Supply 23 HOULTON RD PRESQUE ISLE, Maine 4769",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-764-9900",
    "address": "23 HOULTON RD PRESQUE ISLE, Maine 4769,  ",
    "city": "Maine 4769",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 46.6607249,
    "lng": -68.0099199
  },
  {
    "Store Location": "Tractor Supply 24 FARLEY RD BRUNSWICK, Maine 4011",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-721-8335",
    "address": "24 FARLEY RD BRUNSWICK, Maine 4011,  ",
    "city": "Maine 4011",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.9097508,
    "lng": -69.910612
  },
  {
    "Store Location": "Tractor Supply 289 SOUTH ST CALAIS, Maine 4619",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-454-0671",
    "address": "289 SOUTH ST CALAIS, Maine 4619,  ",
    "city": "Maine 4619",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 45.1777768,
    "lng": -67.2747143
  },
  {
    "Store Location": "Tractor Supply 33 MARDENS WAY STE B ELLSWORTH, Maine 4605",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-664-2203",
    "address": "33 MARDENS WAY STE B ELLSWORTH, Maine 4605,  ",
    "city": "Maine 4605",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.515473,
    "lng": -68.396214
  },
  {
    "Store Location": "Tractor Supply 337 NORTH ST HOULTON, Maine 4730",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-532-3625",
    "address": "337 NORTH ST HOULTON, Maine 4730,  ",
    "city": "Maine 4730",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 46.1487182,
    "lng": -67.8393432
  },
  {
    "Store Location": "Tractor Supply 38 THOMASTON COMMONS WAY THOMASTON, Maine 4861",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-594-7200",
    "address": "38 THOMASTON COMMONS WAY THOMASTON, Maine 4861,  ",
    "city": "Maine 4861",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.09289769999999,
    "lng": -69.1355107
  },
  {
    "Store Location": "Tractor Supply 381 MADISON AVE STE 11 SKOWHEGAN, Maine 4976",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-474-5835",
    "address": "381 MADISON AVE STE 11 SKOWHEGAN, Maine 4976,  ",
    "city": "Maine 4976",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.7870414,
    "lng": -69.7306531
  },
  {
    "Store Location": "Tractor Supply 420 CIVIC CENTER DR AUGUSTA, Maine 4330",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-621-2800",
    "address": "420 CIVIC CENTER DR AUGUSTA, Maine 4330,  ",
    "city": "Maine 4330",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.3586607,
    "lng": -69.79866690000001
  },
  {
    "Store Location": "Tractor Supply 442 US RTE 1 STE 2 SCARBOROUGH, Maine 4074",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-396-5100",
    "address": "442 US RTE 1 STE 2 SCARBOROUGH, Maine 4074,  ",
    "city": "Maine 4074",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.5810074,
    "lng": -70.3663387
  },
  {
    "Store Location": "Tractor Supply 496 ROOSEVELT TRL WINDHAM, Maine 4062",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-892-8379",
    "address": "496 ROOSEVELT TRL WINDHAM, Maine 4062,  ",
    "city": "Maine 4062",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.8094554,
    "lng": -70.41864439999999
  },
  {
    "Store Location": "Tractor Supply 800 CENTRAL ST MILLINOCKET, Maine 4462",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-723-6582",
    "address": "800 CENTRAL ST MILLINOCKET, Maine 4462,  ",
    "city": "Maine 4462",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 45.6562721,
    "lng": -68.6897048
  },
  {
    "Store Location": "Tractor Supply 81 FOX ST STE 105 MADAWASKA, Maine 4756",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-728-1113",
    "address": "81 FOX ST STE 105 MADAWASKA, Maine 4756,  ",
    "city": "Maine 4756",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 47.3508854,
    "lng": -68.3457784
  },
  {
    "Store Location": "Tractor Supply 979 US RTE 2 EAST WILTON, Maine 4294",
    "Store Type": "Tractor Supply",
    "Phone Number": "207-778-5900",
    "address": "979 US RTE 2 EAST WILTON, Maine 4294,  ",
    "city": "Maine 4294",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 47.3957098,
    "lng": -94.7798301
  },
  {
    "Store Location": "Tractor Supply 01200 M-75 SOUTH BOYNE CITY, Michigan 49712",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-582-2882",
    "address": "01200 M-75 SOUTH BOYNE, CITY, Michigan 49712",
    "city": "CITY",
    "state": "Michigan",
    "zip": "49712",
    "lat": 45.2023069,
    "lng": -84.98410710000002
  },
  {
    "Store Location": "Tractor Supply 1000 SOUTH KALAMAZOO ST PAW PAW, Michigan 49079",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-657-2107",
    "address": "1000 SOUTH KALAMAZOO ST PAW, PAW, Michigan 49079",
    "city": "PAW",
    "state": "Michigan",
    "zip": "49079",
    "lat": 42.20369729999999,
    "lng": -85.8849999
  },
  {
    "Store Location": "Tractor Supply 10150 HIGHLAND RD WHITE LAKE, Michigan 48386",
    "Store Type": "Tractor Supply",
    "Phone Number": "248-698-3075",
    "address": "10150 HIGHLAND RD WHITE, LAKE, Michigan 48386",
    "city": "LAKE",
    "state": "Michigan",
    "zip": "48386",
    "lat": 42.6533053,
    "lng": -83.48663429999999
  },
  {
    "Store Location": "Tractor Supply 1070 WEST RANDALL ST COOPERSVILLE, Michigan 49404",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-837-8500",
    "address": "1070 WEST RANDALL ST, COOPERSVILLE, Michigan 49404",
    "city": "COOPERSVILLE",
    "state": "Michigan",
    "zip": "49404",
    "lat": 43.0588971,
    "lng": -85.95361
  },
  {
    "Store Location": "Tractor Supply 111 SAGE CT SALINE, Michigan 48176",
    "Store Type": "Tractor Supply",
    "Phone Number": "734-944-2676",
    "address": "111 SAGE CT, SALINE, Michigan 48176",
    "city": "SALINE",
    "state": "Michigan",
    "zip": "48176",
    "lat": 42.1772254,
    "lng": -83.7614919
  },
  {
    "Store Location": "Tractor Supply 1125 EAST STATE ST CHEBOYGAN, Michigan 49721",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-627-1146",
    "address": "1125 EAST STATE ST, CHEBOYGAN, Michigan 49721",
    "city": "CHEBOYGAN",
    "state": "Michigan",
    "zip": "49721",
    "lat": 45.641926,
    "lng": -84.46001
  },
  {
    "Store Location": "Tractor Supply 1203 EAST IMLAY CITY RD LAPEER, Michigan 48446",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-664-1831",
    "address": "1203 EAST IMLAY CITY RD, LAPEER, Michigan 48446",
    "city": "LAPEER",
    "state": "Michigan",
    "zip": "48446",
    "lat": 43.0305374,
    "lng": -83.0654546
  },
  {
    "Store Location": "Tractor Supply 1221 M 89 PLAINWELL, Michigan 49080",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-685-1001",
    "address": "1221 M 89, PLAINWELL, Michigan 49080",
    "city": "PLAINWELL",
    "state": "Michigan",
    "zip": "49080",
    "lat": 42.4515957,
    "lng": -85.6654811
  },
  {
    "Store Location": "Tractor Supply 1255 CAMERON ROAD CARO, Michigan 48723",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-673-2947",
    "address": "1255 CAMERON ROAD, CARO, Michigan 48723",
    "city": "CARO",
    "state": "Michigan",
    "zip": "48723",
    "lat": 43.5038387,
    "lng": -83.37919269999999
  },
  {
    "Store Location": "Tractor Supply 1260 WEST US HWY 223 ADRIAN, Michigan 49221",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-263-2831",
    "address": "1260 WEST US HWY 223, ADRIAN, Michigan 49221",
    "city": "ADRIAN",
    "state": "Michigan",
    "zip": "49221",
    "lat": 41.8975471,
    "lng": -84.03716589999999
  },
  {
    "Store Location": "Tractor Supply 1286 SOUTH OTSEGO AVE SOUTH OLD 27 GAYLORD, Michigan 49735",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-705-1256",
    "address": "1286 SOUTH OTSEGO AVE SOUTH OLD 27, GAYLORD, Michigan 49735",
    "city": "GAYLORD",
    "state": "Michigan",
    "zip": "49735",
    "lat": 45.0129895,
    "lng": -84.6788533
  },
  {
    "Store Location": "Tractor Supply 12891 QUINCY ST HOLLAND, Michigan 49424",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-786-0338",
    "address": "12891 QUINCY ST, HOLLAND, Michigan 49424",
    "city": "HOLLAND",
    "state": "Michigan",
    "zip": "49424",
    "lat": 42.8417465,
    "lng": -86.1006604
  },
  {
    "Store Location": "Tractor Supply 1328 WEST MAIN FREMONT, Michigan 49412",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-924-6764",
    "address": "1328 WEST MAIN, FREMONT, Michigan 49412",
    "city": "FREMONT",
    "state": "Michigan",
    "zip": "49412",
    "lat": 43.466237,
    "lng": -85.9680455
  },
  {
    "Store Location": "Tractor Supply 1352 MICHIGAN AVE BENZONIA, Michigan 49616",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-882-7705",
    "address": "1352 MICHIGAN AVE, BENZONIA, Michigan 49616",
    "city": "BENZONIA",
    "state": "Michigan",
    "zip": "49616",
    "lat": 44.61258910000001,
    "lng": -86.10041
  },
  {
    "Store Location": "Tractor Supply 1420 EAST CLOVERLAND DR IRONWOOD, Michigan 49938",
    "Store Type": "Tractor Supply",
    "Phone Number": "906-932-6464",
    "address": "1420 EAST CLOVERLAND DR, IRONWOOD, Michigan 49938",
    "city": "IRONWOOD",
    "state": "Michigan",
    "zip": "49938",
    "lat": 46.4658076,
    "lng": -90.1447235
  },
  {
    "Store Location": "Tractor Supply 1437 E M 21 OWOSSO, Michigan 48867",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-725-5178",
    "address": "1437 E M 21, OWOSSO, Michigan 48867",
    "city": "OWOSSO",
    "state": "Michigan",
    "zip": "48867",
    "lat": 42.9998809,
    "lng": -84.1440083
  },
  {
    "Store Location": "Tractor Supply 1448 NORTH EATON ST ALBION, Michigan 49224",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-630-0013",
    "address": "1448 NORTH EATON ST, ALBION, Michigan 49224",
    "city": "ALBION",
    "state": "Michigan",
    "zip": "49224",
    "lat": 42.2608057,
    "lng": -84.7541433
  },
  {
    "Store Location": "Tractor Supply 1501 EAST WASHINGTON RD ITHACA, Michigan 48847",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-875-4229",
    "address": "1501 EAST WASHINGTON RD, ITHACA, Michigan 48847",
    "city": "ITHACA",
    "state": "Michigan",
    "zip": "48847",
    "lat": 43.2925182,
    "lng": -84.5780096
  },
  {
    "Store Location": "Tractor Supply 1550 WHITEHALL RD MUSKEGON, Michigan 49445",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-719-9473",
    "address": "1550 WHITEHALL RD, MUSKEGON, Michigan 49445",
    "city": "MUSKEGON",
    "state": "Michigan",
    "zip": "49445",
    "lat": 43.2810688,
    "lng": -86.2605368
  },
  {
    "Store Location": "Tractor Supply 157 73RD ST SOUTH HAVEN, Michigan 49090",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-639-9664",
    "address": "157 73RD ST SOUTH, HAVEN, Michigan 49090",
    "city": "HAVEN",
    "state": "Michigan",
    "zip": "49090",
    "lat": 42.4074442,
    "lng": -86.2489928
  },
  {
    "Store Location": "Tractor Supply 16497 TECUMSEH RD DUNDEE, Michigan 48131",
    "Store Type": "Tractor Supply",
    "Phone Number": "734-529-5535",
    "address": "16497 TECUMSEH RD, DUNDEE, Michigan 48131",
    "city": "DUNDEE",
    "state": "Michigan",
    "zip": "48131",
    "lat": 41.9598406,
    "lng": -83.680639
  },
  {
    "Store Location": "Tractor Supply 1650 PACKARD HWY CHARLOTTE, Michigan 48813",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-543-5858",
    "address": "1650 PACKARD HWY, CHARLOTTE, Michigan 48813",
    "city": "CHARLOTTE",
    "state": "Michigan",
    "zip": "48813",
    "lat": 42.5792014,
    "lng": -84.8057043
  },
  {
    "Store Location": "Tractor Supply 1685 WRIGHT AVENUE ALMA, Michigan 48801",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-463-9464",
    "address": "1685 WRIGHT AVENUE, ALMA, Michigan 48801",
    "city": "ALMA",
    "state": "Michigan",
    "zip": "48801",
    "lat": 43.3957546,
    "lng": -84.668553
  },
  {
    "Store Location": "Tractor Supply 1698 EAST HURON RD STE 2 EAST TAWAS, Michigan 48730",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-362-3220",
    "address": "1698 EAST HURON RD STE 2 EAST, TAWAS, Michigan 48730",
    "city": "TAWAS",
    "state": "Michigan",
    "zip": "48730",
    "lat": 44.0482036,
    "lng": -83.74481209999999
  },
  {
    "Store Location": "Tractor Supply 1701 MEMORIAL RD HOUGHTON, Michigan 49931",
    "Store Type": "Tractor Supply",
    "Phone Number": "906-483-3826",
    "address": "1701 MEMORIAL RD, HOUGHTON, Michigan 49931",
    "city": "HOUGHTON",
    "state": "Michigan",
    "zip": "49931",
    "lat": 47.1032096,
    "lng": -88.59084209999999
  },
  {
    "Store Location": "Tractor Supply 1860 SOUTH STEPHENSON AVE IRON MOUNTAIN, Michigan 49801",
    "Store Type": "Tractor Supply",
    "Phone Number": "906-776-1540",
    "address": "1860 SOUTH STEPHENSON AVE IRON, MOUNTAIN, Michigan 49801",
    "city": "MOUNTAIN",
    "state": "Michigan",
    "zip": "49801",
    "lat": 45.80829,
    "lng": -88.04061999999999
  },
  {
    "Store Location": "Tractor Supply 2050 SOUTH M 76 WEST BRANCH, Michigan 48661",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-343-1511",
    "address": "2050 SOUTH M 76 WEST, BRANCH, Michigan 48661",
    "city": "BRANCH",
    "state": "Michigan",
    "zip": "48661",
    "lat": 44.2640159,
    "lng": -84.2166562
  },
  {
    "Store Location": "Tractor Supply 2070 CEDAR SOUTH M-53 IMLAY CITY, Michigan 48444",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-721-1613",
    "address": "2070 CEDAR SOUTH M-53 IMLAY, CITY, Michigan 48444",
    "city": "CITY",
    "state": "Michigan",
    "zip": "48444",
    "lat": 43.0193022,
    "lng": -83.072087
  },
  {
    "Store Location": "Tractor Supply 2111 WEST MAIN ST LOWELL, Michigan 49331",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-987-9338",
    "address": "2111 WEST MAIN ST, LOWELL, Michigan 49331",
    "city": "LOWELL",
    "state": "Michigan",
    "zip": "49331",
    "lat": 42.9325226,
    "lng": -85.3621484
  },
  {
    "Store Location": "Tractor Supply 2125 SOUTH 11 ST NILES, Michigan 49120",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-684-5734",
    "address": "2125 SOUTH 11 ST, NILES, Michigan 49120",
    "city": "NILES",
    "state": "Michigan",
    "zip": "49120",
    "lat": 41.7883247,
    "lng": -86.2482869
  },
  {
    "Store Location": "Tractor Supply 2150 SOUTH US HWY 27 SAINT JOHNS, Michigan 48879",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-224-8978",
    "address": "2150 SOUTH US HWY 27 SAINT, JOHNS, Michigan 48879",
    "city": "JOHNS",
    "state": "Michigan",
    "zip": "48879",
    "lat": 42.9818844,
    "lng": -84.5445513
  },
  {
    "Store Location": "Tractor Supply 2201 NORTH US HWY 31 PETOSKEY, Michigan 49770",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-348-0712",
    "address": "2201 NORTH US HWY 31, PETOSKEY, Michigan 49770",
    "city": "PETOSKEY",
    "state": "Michigan",
    "zip": "49770",
    "lat": 45.4013683,
    "lng": -84.88005419999999
  },
  {
    "Store Location": "Tractor Supply 2278 N COMFORT DR HART, Michigan 49420",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-873-0043",
    "address": "2278 N COMFORT DR, HART, Michigan 49420",
    "city": "HART",
    "state": "Michigan",
    "zip": "49420",
    "lat": 43.6983407,
    "lng": -86.3639652
  },
  {
    "Store Location": "Tractor Supply 2480 CHICAGO DR HUDSONVILLE, Michigan 49426",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-662-6450",
    "address": "2480 CHICAGO DR, HUDSONVILLE, Michigan 49426",
    "city": "HUDSONVILLE",
    "state": "Michigan",
    "zip": "49426",
    "lat": 42.87776969999999,
    "lng": -85.8466526
  },
  {
    "Store Location": "Tractor Supply 2490 WEST M 43 HWY HASTINGS, Michigan 49058",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-945-1477",
    "address": "2490 WEST M 43 HWY, HASTINGS, Michigan 49058",
    "city": "HASTINGS",
    "state": "Michigan",
    "zip": "49058",
    "lat": 42.6457329,
    "lng": -85.3359912
  },
  {
    "Store Location": "Tractor Supply 2492 NORTH TELEGRAPH RD MONROE, Michigan 48162",
    "Store Type": "Tractor Supply",
    "Phone Number": "734-241-6633",
    "address": "2492 NORTH TELEGRAPH RD, MONROE, Michigan 48162",
    "city": "MONROE",
    "state": "Michigan",
    "zip": "48162",
    "lat": 41.9564483,
    "lng": -83.3947128
  },
  {
    "Store Location": "Tractor Supply 2501 NORTH LINCOLN RD ESCANABA, Michigan 49829",
    "Store Type": "Tractor Supply",
    "Phone Number": "906-233-0355",
    "address": "2501 NORTH LINCOLN RD, ESCANABA, Michigan 49829",
    "city": "ESCANABA",
    "state": "Michigan",
    "zip": "49829",
    "lat": 45.7784543,
    "lng": -87.0849755
  },
  {
    "Store Location": "Tractor Supply 2805 SPRINGPORT RD JACKSON, Michigan 49202",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-796-1719",
    "address": "2805 SPRINGPORT RD, JACKSON, Michigan 49202",
    "city": "JACKSON",
    "state": "Michigan",
    "zip": "49202",
    "lat": 42.27591959999999,
    "lng": -84.45127889999999
  },
  {
    "Store Location": "Tractor Supply 2886 WILDER RD BAY CITY, Michigan 48706",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-686-2195",
    "address": "2886 WILDER RD BAY, CITY, Michigan 48706",
    "city": "CITY",
    "state": "Michigan",
    "zip": "48706",
    "lat": 43.6231822,
    "lng": -83.93600819999999
  },
  {
    "Store Location": "Tractor Supply 3000 VAN HORN RD TRENTON, Michigan 48183",
    "Store Type": "Tractor Supply",
    "Phone Number": "734-675-1398",
    "address": "3000 VAN HORN RD, TRENTON, Michigan 48183",
    "city": "TRENTON",
    "state": "Michigan",
    "zip": "48183",
    "lat": 42.1278691,
    "lng": -83.2048353
  },
  {
    "Store Location": "Tractor Supply 3001 NORTH WILLIAMSTON RD WILLIAMSTON, Michigan 48895",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-655-2707",
    "address": "3001 NORTH WILLIAMSTON RD, WILLIAMSTON, Michigan 48895",
    "city": "WILLIAMSTON",
    "state": "Michigan",
    "zip": "48895",
    "lat": 42.6740654,
    "lng": -84.2836038
  },
  {
    "Store Location": "Tractor Supply 301 NORTH US HWY 131 THREE RIVERS, Michigan 49093",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-279-5296",
    "address": "301 NORTH US HWY 131 THREE, RIVERS, Michigan 49093",
    "city": "RIVERS",
    "state": "Michigan",
    "zip": "49093",
    "lat": 41.9460297,
    "lng": -85.6509746
  },
  {
    "Store Location": "Tractor Supply 310 RIPLEY BLVD ALPENA, Michigan 49707",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-358-8933",
    "address": "310 RIPLEY BLVD, ALPENA, Michigan 49707",
    "city": "ALPENA",
    "state": "Michigan",
    "zip": "49707",
    "lat": 45.05588119999999,
    "lng": -83.45238549999999
  },
  {
    "Store Location": "Tractor Supply 3200 GRATIOT BLVD MARYSVILLE, Michigan 48040",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-388-0564",
    "address": "3200 GRATIOT BLVD, MARYSVILLE, Michigan 48040",
    "city": "MARYSVILLE",
    "state": "Michigan",
    "zip": "48040",
    "lat": 42.9131134,
    "lng": -82.497779
  },
  {
    "Store Location": "Tractor Supply 3265 OWEN RD FENTON, Michigan 48430",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-629-9972",
    "address": "3265 OWEN RD, FENTON, Michigan 48430",
    "city": "FENTON",
    "state": "Michigan",
    "zip": "48430",
    "lat": 42.787064,
    "lng": -83.73924
  },
  {
    "Store Location": "Tractor Supply 3350 EAST MICHIGAN AVE JACKSON, Michigan 49202",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-788-6884",
    "address": "3350 EAST MICHIGAN AVE, JACKSON, Michigan 49202",
    "city": "JACKSON",
    "state": "Michigan",
    "zip": "49202",
    "lat": 42.2591056,
    "lng": -84.3587853
  },
  {
    "Store Location": "Tractor Supply 3451 WEST HOUGHTON LAKE DR STE B HOUGHTON LAKE, Michigan 48629",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-366-9450",
    "address": "3451 WEST HOUGHTON LAKE DR STE B HOUGHTON, LAKE, Michigan 48629",
    "city": "LAKE",
    "state": "Michigan",
    "zip": "48629",
    "lat": 44.2968666,
    "lng": -84.7078804
  },
  {
    "Store Location": "Tractor Supply 367 US HWY 41 EAST NEGAUNEE, Michigan 49866",
    "Store Type": "Tractor Supply",
    "Phone Number": "906-226-5240",
    "address": "367 US HWY 41 EAST, NEGAUNEE, Michigan 49866",
    "city": "NEGAUNEE",
    "state": "Michigan",
    "zip": "49866",
    "lat": 46.5365311,
    "lng": -87.51084209999999
  },
  {
    "Store Location": "Tractor Supply 3931 SOUTH HURON RD STANDISH, Michigan 48658",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-846-0980",
    "address": "3931 SOUTH HURON RD, STANDISH, Michigan 48658",
    "city": "STANDISH",
    "state": "Michigan",
    "zip": "48658",
    "lat": 43.9704696,
    "lng": -83.9585927
  },
  {
    "Store Location": "Tractor Supply 4011 17 MILE RD CEDAR SPRINGS, Michigan 49319",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-696-3652",
    "address": "4011 17 MILE RD CEDAR, SPRINGS, Michigan 49319",
    "city": "SPRINGS",
    "state": "Michigan",
    "zip": "49319",
    "lat": 43.2213626,
    "lng": -85.5704564
  },
  {
    "Store Location": "Tractor Supply 4058 WEST VIENNA RD CLIO, Michigan 48420",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-686-9238",
    "address": "4058 WEST VIENNA RD, CLIO, Michigan 48420",
    "city": "CLIO",
    "state": "Michigan",
    "zip": "48420",
    "lat": 43.178692,
    "lng": -83.75626489999999
  },
  {
    "Store Location": "Tractor Supply 44005 MICHIGAN AVENUE CANTON, Michigan 48188",
    "Store Type": "Tractor Supply",
    "Phone Number": "734-398-0426",
    "address": "44005 MICHIGAN AVENUE, CANTON, Michigan 48188",
    "city": "CANTON",
    "state": "Michigan",
    "zip": "48188",
    "lat": 42.2742728,
    "lng": -83.4730809
  },
  {
    "Store Location": "Tractor Supply 45 FARM LN IONIA, Michigan 48846",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-523-1069",
    "address": "45 FARM LN, IONIA, Michigan 48846",
    "city": "IONIA",
    "state": "Michigan",
    "zip": "48846",
    "lat": 42.9397087,
    "lng": -85.0762366
  },
  {
    "Store Location": "Tractor Supply 4572 WEST US 10 LUDINGTON, Michigan 49431",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-843-1932",
    "address": "4572 WEST US 10, LUDINGTON, Michigan 49431",
    "city": "LUDINGTON",
    "state": "Michigan",
    "zip": "49431",
    "lat": 43.9557199,
    "lng": -86.3939055
  },
  {
    "Store Location": "Tractor Supply 4601 EAST GRAND RIV HOWELL, Michigan 48843",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-548-7600",
    "address": "4601 EAST GRAND RIV, HOWELL, Michigan 48843",
    "city": "HOWELL",
    "state": "Michigan",
    "zip": "48843",
    "lat": 42.5834375,
    "lng": -83.8603291
  },
  {
    "Store Location": "Tractor Supply 4646 75 BUSINESS SPUR SAULT STE MARIE, Michigan 49783",
    "Store Type": "Tractor Supply",
    "Phone Number": "906-635-1132",
    "address": "4646 75 BUSINESS SPUR SAULT STE, MARIE, Michigan 49783",
    "city": "MARIE",
    "state": "Michigan",
    "zip": "49783",
    "lat": 46.4656444,
    "lng": -84.3813902
  },
  {
    "Store Location": "Tractor Supply 47 DAWSON SANDUSKY, Michigan 48471",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-648-3014",
    "address": "47 DAWSON, SANDUSKY, Michigan 48471",
    "city": "SANDUSKY",
    "state": "Michigan",
    "zip": "48471",
    "lat": 43.4224621,
    "lng": -82.8410068
  },
  {
    "Store Location": "Tractor Supply 4800 24TH AVE FORT GRATIOT, Michigan 48059",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-385-5855",
    "address": "4800 24TH AVE FORT, GRATIOT, Michigan 48059",
    "city": "GRATIOT",
    "state": "Michigan",
    "zip": "48059",
    "lat": 43.048208,
    "lng": -82.4559221
  },
  {
    "Store Location": "Tractor Supply 510 NORTH MARKETPLACE BLVD LANSING, Michigan 48917",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-627-2179",
    "address": "510 NORTH MARKETPLACE BLVD, LANSING, Michigan 48917",
    "city": "LANSING",
    "state": "Michigan",
    "zip": "48917",
    "lat": 42.7391403,
    "lng": -84.6711366
  },
  {
    "Store Location": "Tractor Supply 5180 RED ARROW HWY STEVENSVILLE, Michigan 49127",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-429-5313",
    "address": "5180 RED ARROW HWY, STEVENSVILLE, Michigan 49127",
    "city": "STEVENSVILLE",
    "state": "Michigan",
    "zip": "49127",
    "lat": 42.0255288,
    "lng": -86.5226079
  },
  {
    "Store Location": "Tractor Supply 5241 WEST GRAND RIV LANSING, Michigan 48906",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-323-7341",
    "address": "5241 WEST GRAND RIV, LANSING, Michigan 48906",
    "city": "LANSING",
    "state": "Michigan",
    "zip": "48906",
    "lat": 42.7756933,
    "lng": -84.6271797
  },
  {
    "Store Location": "Tractor Supply 5460 WEST PIERSON RD FLUSHING, Michigan 48433",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-732-0679",
    "address": "5460 WEST PIERSON RD, FLUSHING, Michigan 48433",
    "city": "FLUSHING",
    "state": "Michigan",
    "zip": "48433",
    "lat": 43.0612732,
    "lng": -83.7906002
  },
  {
    "Store Location": "Tractor Supply 5555 BAY RD RTE 84 SAGINAW CHARTER TOWNSHIP, Michigan 48604",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-799-3724",
    "address": "5555 BAY RD RTE 84 SAGINAW CHARTER, TOWNSHIP, Michigan 48604",
    "city": "TOWNSHIP",
    "state": "Michigan",
    "zip": "48604",
    "lat": 43.4880025,
    "lng": -83.97521979999999
  },
  {
    "Store Location": "Tractor Supply 56418 POKAGON ST DOWAGIAC, Michigan 49047",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-782-9920",
    "address": "56418 POKAGON ST, DOWAGIAC, Michigan 49047",
    "city": "DOWAGIAC",
    "state": "Michigan",
    "zip": "49047",
    "lat": 41.9783608,
    "lng": -86.1351305
  },
  {
    "Store Location": "Tractor Supply 5688 EAST PICKARD MOUNT PLEASANT, Michigan 48858",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-772-6343",
    "address": "5688 EAST PICKARD MOUNT, PLEASANT, Michigan 48858",
    "city": "PLEASANT",
    "state": "Michigan",
    "zip": "48858",
    "lat": 43.6107319,
    "lng": -84.7345819
  },
  {
    "Store Location": "Tractor Supply 57155 GRATIOT AVE NEW HAVEN, Michigan 48048",
    "Store Type": "Tractor Supply",
    "Phone Number": "586-749-6162",
    "address": "57155 GRATIOT AVE NEW, HAVEN, Michigan 48048",
    "city": "HAVEN",
    "state": "Michigan",
    "zip": "48048",
    "lat": 42.7205626,
    "lng": -82.7977141
  },
  {
    "Store Location": "Tractor Supply 57184 LYON CENTER DR WEST NEW HUDSON, Michigan 48165",
    "Store Type": "Tractor Supply",
    "Phone Number": "248-486-5389",
    "address": "57184 LYON CENTER DR WEST NEW, HUDSON, Michigan 48165",
    "city": "HUDSON",
    "state": "Michigan",
    "zip": "48165",
    "lat": 42.515769,
    "lng": -83.6186113
  },
  {
    "Store Location": "Tractor Supply 575 NORTH LAPEER ROAD OXFORD, Michigan 48371",
    "Store Type": "Tractor Supply",
    "Phone Number": "248-236-2001",
    "address": "575 NORTH LAPEER ROAD, OXFORD, Michigan 48371",
    "city": "OXFORD",
    "state": "Michigan",
    "zip": "48371",
    "lat": 42.8327411,
    "lng": -83.2720083
  },
  {
    "Store Location": "Tractor Supply 5869 ALPINE AVE NORTHWEST COMSTOCK PARK, Michigan 49321",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-647-9949",
    "address": "5869 ALPINE AVE NORTHWEST COMSTOCK, PARK, Michigan 49321",
    "city": "PARK",
    "state": "Michigan",
    "zip": "49321",
    "lat": 43.0697678,
    "lng": -85.6909489
  },
  {
    "Store Location": "Tractor Supply 6030 GREENVILLE RD GREENVILLE, Michigan 48838",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-754-4639",
    "address": "6030 GREENVILLE RD, GREENVILLE, Michigan 48838",
    "city": "GREENVILLE",
    "state": "Michigan",
    "zip": "48838",
    "lat": 43.205939,
    "lng": -85.2537873
  },
  {
    "Store Location": "Tractor Supply 613 LOTT RD COLDWATER, Michigan 49036",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-278-0996",
    "address": "613 LOTT RD, COLDWATER, Michigan 49036",
    "city": "COLDWATER",
    "state": "Michigan",
    "zip": "49036",
    "lat": 41.9337123,
    "lng": -84.95908
  },
  {
    "Store Location": "Tractor Supply 6285 GULL RD KALAMAZOO, Michigan 49048",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-381-0904",
    "address": "6285 GULL RD, KALAMAZOO, Michigan 49048",
    "city": "KALAMAZOO",
    "state": "Michigan",
    "zip": "49048",
    "lat": 42.3318415,
    "lng": -85.50751029999999
  },
  {
    "Store Location": "Tractor Supply 6360 B DR NORTH BATTLE CREEK, Michigan 49014",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-979-8372",
    "address": "6360 B DR NORTH BATTLE, CREEK, Michigan 49014",
    "city": "CREEK",
    "state": "Michigan",
    "zip": "49014",
    "lat": 42.2598594,
    "lng": -85.1720153
  },
  {
    "Store Location": "Tractor Supply 6435 AIRLINE RD FRUITPORT, Michigan 49415",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-681-0181",
    "address": "6435 AIRLINE RD, FRUITPORT, Michigan 49415",
    "city": "FRUITPORT",
    "state": "Michigan",
    "zip": "49415",
    "lat": 43.1346021,
    "lng": -86.1557739
  },
  {
    "Store Location": "Tractor Supply 66143 VAN DYKE RD WASHINGTON, Michigan 48095",
    "Store Type": "Tractor Supply",
    "Phone Number": "586-752-4356",
    "address": "66143 VAN DYKE RD, WASHINGTON, Michigan 48095",
    "city": "WASHINGTON",
    "state": "Michigan",
    "zip": "48095",
    "lat": 42.7803755,
    "lng": -83.0167426
  },
  {
    "Store Location": "Tractor Supply 67500 SOUTH MAIN ST RICHMOND, Michigan 48062",
    "Store Type": "Tractor Supply",
    "Phone Number": "586-727-4990",
    "address": "67500 SOUTH MAIN ST, RICHMOND, Michigan 48062",
    "city": "RICHMOND",
    "state": "Michigan",
    "zip": "48062",
    "lat": 42.7995351,
    "lng": -82.73901289999999
  },
  {
    "Store Location": "Tractor Supply 6850 WHITMORE LAKE RD WHITMORE LAKE, Michigan 48189",
    "Store Type": "Tractor Supply",
    "Phone Number": "734-302-4037",
    "address": "6850 WHITMORE LAKE RD WHITMORE, LAKE, Michigan 48189",
    "city": "LAKE",
    "state": "Michigan",
    "zip": "48189",
    "lat": 42.3772703,
    "lng": -83.75972759999999
  },
  {
    "Store Location": "Tractor Supply 69080 M 66 STURGIS, Michigan 49091",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-651-9916",
    "address": "69080 M 66, STURGIS, Michigan 49091",
    "city": "STURGIS",
    "state": "Michigan",
    "zip": "49091",
    "lat": 41.7947261,
    "lng": -85.4306258
  },
  {
    "Store Location": "Tractor Supply 700 SOUTH ORTONVILLE RD ORTONVILLE, Michigan 48462",
    "Store Type": "Tractor Supply",
    "Phone Number": "248-627-3708",
    "address": "700 SOUTH ORTONVILLE RD, ORTONVILLE, Michigan 48462",
    "city": "ORTONVILLE",
    "state": "Michigan",
    "zip": "48462",
    "lat": 42.8400391,
    "lng": -83.4488793
  },
  {
    "Store Location": "Tractor Supply 7007 EAST M 72 WILLIAMSBURG, Michigan 49690",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-267-5270",
    "address": "7007 EAST M 72, WILLIAMSBURG, Michigan 49690",
    "city": "WILLIAMSBURG",
    "state": "Michigan",
    "zip": "49690",
    "lat": 44.7738083,
    "lng": -85.4336156
  },
  {
    "Store Location": "Tractor Supply 701 68TH SOUTHWEST STE 115 BYRON CENTER, Michigan 49315",
    "Store Type": "Tractor Supply",
    "Phone Number": "616-455-6868",
    "address": "701 68TH SOUTHWEST STE 115 BYRON, CENTER, Michigan 49315",
    "city": "CENTER",
    "state": "Michigan",
    "zip": "49315",
    "lat": 42.844186,
    "lng": -85.6812084
  },
  {
    "Store Location": "Tractor Supply 710 OLDS ST JONESVILLE, Michigan 49250",
    "Store Type": "Tractor Supply",
    "Phone Number": "517-849-9254",
    "address": "710 OLDS ST, JONESVILLE, Michigan 49250",
    "city": "JONESVILLE",
    "state": "Michigan",
    "zip": "49250",
    "lat": 41.96504729999999,
    "lng": -84.6720326
  },
  {
    "Store Location": "Tractor Supply 7130 GRATIOT RD SAGINAW, Michigan 48609",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-781-3568",
    "address": "7130 GRATIOT RD, SAGINAW, Michigan 48609",
    "city": "SAGINAW",
    "state": "Michigan",
    "zip": "48609",
    "lat": 43.41687779999999,
    "lng": -84.0549219
  },
  {
    "Store Location": "Tractor Supply 7251 JACKSON RD ANN ARBOR, Michigan 48103",
    "Store Type": "Tractor Supply",
    "Phone Number": "734-913-2691",
    "address": "7251 JACKSON RD ANN, ARBOR, Michigan 48103",
    "city": "ARBOR",
    "state": "Michigan",
    "zip": "48103",
    "lat": 42.2925536,
    "lng": -83.87358309999999
  },
  {
    "Store Location": "Tractor Supply 736 NORTH VAN DYKE RD BAD AXE, Michigan 48413",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-269-8139",
    "address": "736 NORTH VAN DYKE RD BAD, AXE, Michigan 48413",
    "city": "AXE",
    "state": "Michigan",
    "zip": "48413",
    "lat": 43.8104878,
    "lng": -82.99858979999999
  },
  {
    "Store Location": "Tractor Supply 754 PERRY AVE BIG RAPIDS, Michigan 49307",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-796-4642",
    "address": "754 PERRY AVE BIG, RAPIDS, Michigan 49307",
    "city": "RAPIDS",
    "state": "Michigan",
    "zip": "49307",
    "lat": 43.6891277,
    "lng": -85.4939849
  },
  {
    "Store Location": "Tractor Supply 7614 EASTMAN AVE MIDLAND, Michigan 48642",
    "Store Type": "Tractor Supply",
    "Phone Number": "989-832-1860",
    "address": "7614 EASTMAN AVE, MIDLAND, Michigan 48642",
    "city": "MIDLAND",
    "state": "Michigan",
    "zip": "48642",
    "lat": 43.6668306,
    "lng": -84.2459413
  },
  {
    "Store Location": "Tractor Supply 8171 LAPEER RD DAVISON, Michigan 48423",
    "Store Type": "Tractor Supply",
    "Phone Number": "810-652-0707",
    "address": "8171 LAPEER RD, DAVISON, Michigan 48423",
    "city": "DAVISON",
    "state": "Michigan",
    "zip": "48423",
    "lat": 43.0127919,
    "lng": -83.54927359999999
  },
  {
    "Store Location": "Tractor Supply 825 US 31 SOUTH TRAVERSE CITY, Michigan 49685",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-943-4062",
    "address": "825 US 31 SOUTH TRAVERSE, CITY, Michigan 49685",
    "city": "CITY",
    "state": "Michigan",
    "zip": "49685",
    "lat": 44.6991806,
    "lng": -85.65626429999999
  },
  {
    "Store Location": "Tractor Supply 8610 SHAVER RD PORTAGE, Michigan 49024",
    "Store Type": "Tractor Supply",
    "Phone Number": "269-323-3199",
    "address": "8610 SHAVER RD, PORTAGE, Michigan 49024",
    "city": "PORTAGE",
    "state": "Michigan",
    "zip": "49024",
    "lat": 42.192005,
    "lng": -85.5993733
  },
  {
    "Store Location": "Tractor Supply 9040 EAST 34 RD CADILLAC, Michigan 49601",
    "Store Type": "Tractor Supply",
    "Phone Number": "231-775-9478",
    "address": "9040 EAST 34 RD, CADILLAC, Michigan 49601",
    "city": "CADILLAC",
    "state": "Michigan",
    "zip": "49601",
    "lat": 44.28020129999999,
    "lng": -85.3960755
  },
  {
    "Store Location": "Tractor Supply 11150 179TH AVE NORTHWEST ELK RIVER, Minnesota 55330",
    "Store Type": "Tractor Supply",
    "Phone Number": "763-441-6400",
    "address": "11150 179TH AVE NORTHWEST ELK, RIVER, Minnesota 55330",
    "city": "RIVER",
    "state": "Minnesota",
    "zip": "55330",
    "lat": 45.2959302,
    "lng": -93.5501724
  },
  {
    "Store Location": "Tractor Supply 1160 RYANS RD WORTHINGTON, Minnesota 56187",
    "Store Type": "Tractor Supply",
    "Phone Number": "507-376-9733",
    "address": "1160 RYANS RD, WORTHINGTON, Minnesota 56187",
    "city": "WORTHINGTON",
    "state": "Minnesota",
    "zip": "56187",
    "lat": 43.63414299999999,
    "lng": -95.5991286
  },
  {
    "Store Location": "Tractor Supply 1215 NORTH STATE ST STE 1 FAIRMONT, Minnesota 56031",
    "Store Type": "Tractor Supply",
    "Phone Number": "507-235-6002",
    "address": "1215 NORTH STATE ST STE 1, FAIRMONT, Minnesota 56031",
    "city": "FAIRMONT",
    "state": "Minnesota",
    "zip": "56031",
    "lat": 43.6659316,
    "lng": -94.44969929999999
  },
  {
    "Store Location": "Tractor Supply 1414 S 12TH AVE W STE A VIRGINIA, Minnesota 55792",
    "Store Type": "Tractor Supply",
    "Phone Number": "218-741-2000",
    "address": "1414 S 12TH AVE W STE A, VIRGINIA, Minnesota 55792",
    "city": "VIRGINIA",
    "state": "Minnesota",
    "zip": "55792",
    "lat": 47.5113494,
    "lng": -92.5514901
  },
  {
    "Store Location": "Tractor Supply 1465 1ST AVE EAST CAMBRIDGE, Minnesota 55008",
    "Store Type": "Tractor Supply",
    "Phone Number": "763-689-5176",
    "address": "1465 1ST AVE EAST, CAMBRIDGE, Minnesota 55008",
    "city": "CAMBRIDGE",
    "state": "Minnesota",
    "zip": "55008",
    "lat": 45.57207469999999,
    "lng": -93.20711879999999
  },
  {
    "Store Location": "Tractor Supply 1525 HWY 59 SOUTH THIEF RIVER FALLS, Minnesota 56701",
    "Store Type": "Tractor Supply",
    "Phone Number": "218-681-7777",
    "address": "1525 HWY 59 SOUTH THIEF RIVER, FALLS, Minnesota 56701",
    "city": "FALLS",
    "state": "Minnesota",
    "zip": "56701",
    "lat": 48.115919,
    "lng": -96.15774549999999
  },
  {
    "Store Location": "Tractor Supply 16907 HWY 13 SOUTH PRIOR LAKE, Minnesota 55372",
    "Store Type": "Tractor Supply",
    "Phone Number": "952-440-2755",
    "address": "16907 HWY 13 SOUTH PRIOR, LAKE, Minnesota 55372",
    "city": "LAKE",
    "state": "Minnesota",
    "zip": "55372",
    "lat": 44.7040373,
    "lng": -93.4358011
  },
  {
    "Store Location": "Tractor Supply 1771 NORTH VICTORY DR MANKATO, Minnesota 56001",
    "Store Type": "Tractor Supply",
    "Phone Number": "507-625-6151",
    "address": "1771 NORTH VICTORY DR, MANKATO, Minnesota 56001",
    "city": "MANKATO",
    "state": "Minnesota",
    "zip": "56001",
    "lat": 44.1820619,
    "lng": -93.9536985
  },
  {
    "Store Location": "Tractor Supply 1800 1ST AVE NORTHEAST STE 101 LITTLE FALLS, Minnesota 56345",
    "Store Type": "Tractor Supply",
    "Phone Number": "320-632-0742",
    "address": "1800 1ST AVE NORTHEAST STE 101 LITTLE, FALLS, Minnesota 56345",
    "city": "FALLS",
    "state": "Minnesota",
    "zip": "56345",
    "lat": 45.9732182,
    "lng": -94.3335556
  },
  {
    "Store Location": "Tractor Supply 3330 HWY 10 EAST MOORHEAD, Minnesota 56560",
    "Store Type": "Tractor Supply",
    "Phone Number": "218-236-8219",
    "address": "3330 HWY 10 EAST, MOORHEAD, Minnesota 56560",
    "city": "MOORHEAD",
    "state": "Minnesota",
    "zip": "56560",
    "lat": 46.8772913,
    "lng": -96.7266581
  },
  {
    "Store Location": "Tractor Supply 4205 MAINE AVE SOUTHEAST ROCHESTER, Minnesota 55904",
    "Store Type": "Tractor Supply",
    "Phone Number": "507-289-1704",
    "address": "4205 MAINE AVE SOUTHEAST, ROCHESTER, Minnesota 55904",
    "city": "ROCHESTER",
    "state": "Minnesota",
    "zip": "55904",
    "lat": 43.9617763,
    "lng": -92.4595049
  },
  {
    "Store Location": "Tractor Supply 6910 69TH LN NORTH GREENFIELD, Minnesota 55373",
    "Store Type": "Tractor Supply",
    "Phone Number": "763-477-6009",
    "address": "6910 69TH LN NORTH, GREENFIELD, Minnesota 55373",
    "city": "GREENFIELD",
    "state": "Minnesota",
    "zip": "55373",
    "lat": 45.0807845,
    "lng": -93.7188951
  },
  {
    "Store Location": "Tractor Supply 9273 CAFFERTY CT INVER GROVE HEIGHTS, Minnesota 55076",
    "Store Type": "Tractor Supply",
    "Phone Number": "651-451-1897",
    "address": "9273 CAFFERTY CT INVER GROVE, HEIGHTS, Minnesota 55076",
    "city": "HEIGHTS",
    "state": "Minnesota",
    "zip": "55076",
    "lat": 44.838595,
    "lng": -93.0275802
  },
  {
    "Store Location": "Tractor Supply 1011 OLD EXETER RD CASSVILLE, Missouri 65625",
    "Store Type": "Tractor Supply",
    "Phone Number": "417-846-1844",
    "address": "1011 OLD EXETER RD, CASSVILLE, Missouri 65625",
    "city": "CASSVILLE",
    "state": "Missouri",
    "zip": "65625",
    "lat": 36.6772403,
    "lng": -93.88629329999999
  },
  {
    "Store Location": "Tractor Supply 1100 SOUTH MAIN ST STE 102 SIKESTON, Missouri 63801",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-471-2638",
    "address": "1100 SOUTH MAIN ST STE 102, SIKESTON, Missouri 63801",
    "city": "SIKESTON",
    "state": "Missouri",
    "zip": "63801",
    "lat": 36.8654059,
    "lng": -89.5797496
  },
  {
    "Store Location": "Tractor Supply 115 LEROUX ST DONIPHAN, Missouri 63935",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-351-1239",
    "address": "115 LEROUX ST, DONIPHAN, Missouri 63935",
    "city": "DONIPHAN",
    "state": "Missouri",
    "zip": "63935",
    "lat": 36.6318846,
    "lng": -90.8271101
  },
  {
    "Store Location": "Tractor Supply 1253 SOUTHEAST OLDHAM PKWY LEES SUMMIT, Missouri 64081",
    "Store Type": "Tractor Supply",
    "Phone Number": "816-525-3757",
    "address": "1253 SOUTHEAST OLDHAM PKWY LEES, SUMMIT, Missouri 64081",
    "city": "SUMMIT",
    "state": "Missouri",
    "zip": "64081",
    "lat": 38.9007432,
    "lng": -94.3438292
  },
  {
    "Store Location": "Tractor Supply 1316 NORTH RANGE LINE RD JOPLIN, Missouri 64801",
    "Store Type": "Tractor Supply",
    "Phone Number": "417-781-7111",
    "address": "1316 NORTH RANGE LINE RD, JOPLIN, Missouri 64801",
    "city": "JOPLIN",
    "state": "Missouri",
    "zip": "64801",
    "lat": 37.10234519999999,
    "lng": -94.47764629999999
  },
  {
    "Store Location": "Tractor Supply 1650 DENMARK RD UNION, Missouri 63084",
    "Store Type": "Tractor Supply",
    "Phone Number": "636-583-0615",
    "address": "1650 DENMARK RD, UNION, Missouri 63084",
    "city": "UNION",
    "state": "Missouri",
    "zip": "63084",
    "lat": 38.4308902,
    "lng": -90.9672621
  },
  {
    "Store Location": "Tractor Supply 170 MARKET PLACE DR TROY, Missouri 63379",
    "Store Type": "Tractor Supply",
    "Phone Number": "636-528-3711",
    "address": "170 MARKET PLACE DR, TROY, Missouri 63379",
    "city": "TROY",
    "state": "Missouri",
    "zip": "63379",
    "lat": 38.9885981,
    "lng": -90.972014
  },
  {
    "Store Location": "Tractor Supply 1700 NORTH BALTIMORE ST KIRKSVILLE, Missouri 63501",
    "Store Type": "Tractor Supply",
    "Phone Number": "660-627-6333",
    "address": "1700 NORTH BALTIMORE ST, KIRKSVILLE, Missouri 63501",
    "city": "KIRKSVILLE",
    "state": "Missouri",
    "zip": "63501",
    "lat": 40.209488,
    "lng": -92.5803327
  },
  {
    "Store Location": "Tractor Supply 1722 EAST OHIO ST STE A CLINTON, Missouri 64735",
    "Store Type": "Tractor Supply",
    "Phone Number": "660-885-2545",
    "address": "1722 EAST OHIO ST STE A, CLINTON, Missouri 64735",
    "city": "CLINTON",
    "state": "Missouri",
    "zip": "64735",
    "lat": 38.3635228,
    "lng": -93.74859510000002
  },
  {
    "Store Location": "Tractor Supply 1722A EAST OHIO ST CLINTON, Missouri 64735",
    "Store Type": "Tractor Supply",
    "Phone Number": "660-885-2545",
    "address": "1722A EAST OHIO ST, CLINTON, Missouri 64735",
    "city": "CLINTON",
    "state": "Missouri",
    "zip": "64735",
    "lat": 38.3661815,
    "lng": -93.7484964
  },
  {
    "Store Location": "Tractor Supply 1751 SOUTH WOMMACK AVE BOLIVAR, Missouri 65613",
    "Store Type": "Tractor Supply",
    "Phone Number": "417-326-8820",
    "address": "1751 SOUTH WOMMACK AVE, BOLIVAR, Missouri 65613",
    "city": "BOLIVAR",
    "state": "Missouri",
    "zip": "65613",
    "lat": 37.59956870000001,
    "lng": -93.439043
  },
  {
    "Store Location": "Tractor Supply 1780 FIRST ST KENNETT, Missouri 63857",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-888-8866",
    "address": "1780 FIRST ST, KENNETT, Missouri 63857",
    "city": "KENNETT",
    "state": "Missouri",
    "zip": "63857",
    "lat": 36.238448,
    "lng": -90.03392629999999
  },
  {
    "Store Location": "Tractor Supply 1920 NORTH BLUFF ST FULTON, Missouri 65251",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-592-4884",
    "address": "1920 NORTH BLUFF ST, FULTON, Missouri 65251",
    "city": "FULTON",
    "state": "Missouri",
    "zip": "65251",
    "lat": 38.8673743,
    "lng": -91.9426223
  },
  {
    "Store Location": "Tractor Supply 20 PLAZA DR STE GENEVIEVE, Missouri 63670",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-883-2189",
    "address": "20 PLAZA DR STE, GENEVIEVE, Missouri 63670",
    "city": "GENEVIEVE",
    "state": "Missouri",
    "zip": "63670",
    "lat": 37.9671088,
    "lng": -90.05212709999999
  },
  {
    "Store Location": "Tractor Supply 200 HUCK FINN SHOPPING CTR HANNIBAL, Missouri 63401",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-231-0500",
    "address": "200 HUCK FINN SHOPPING CTR, HANNIBAL, Missouri 63401",
    "city": "HANNIBAL",
    "state": "Missouri",
    "zip": "63401",
    "lat": 39.7238764,
    "lng": -91.3947925
  },
  {
    "Store Location": "Tractor Supply 2210 SOUTH STATE RTE 291 HWY INDEPENDENCE, Missouri 64057",
    "Store Type": "Tractor Supply",
    "Phone Number": "816-461-7333",
    "address": "2210 SOUTH STATE RTE 291 HWY, INDEPENDENCE, Missouri 64057",
    "city": "INDEPENDENCE",
    "state": "Missouri",
    "zip": "64057",
    "lat": 39.0789855,
    "lng": -94.380444
  },
  {
    "Store Location": "Tractor Supply 2949 SOUTH BUSINESS 65 HOLLISTER, Missouri 65672",
    "Store Type": "Tractor Supply",
    "Phone Number": "417-334-4428",
    "address": "2949 SOUTH BUSINESS 65, HOLLISTER, Missouri 65672",
    "city": "HOLLISTER",
    "state": "Missouri",
    "zip": "65672",
    "lat": 36.6098089,
    "lng": -93.2326297
  },
  {
    "Store Location": "Tractor Supply 3027 SOUTH BELT HWY SAINT JOSEPH, Missouri 64503",
    "Store Type": "Tractor Supply",
    "Phone Number": "816-279-2741",
    "address": "3027 SOUTH BELT HWY SAINT, JOSEPH, Missouri 64503",
    "city": "JOSEPH",
    "state": "Missouri",
    "zip": "64503",
    "lat": 39.7375361,
    "lng": -94.7997999
  },
  {
    "Store Location": "Tractor Supply 3714 CODY DR JEFFERSON CITY, Missouri 65109",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-635-0206",
    "address": "3714 CODY DR JEFFERSON, CITY, Missouri 65109",
    "city": "CITY",
    "state": "Missouri",
    "zip": "65109",
    "lat": 38.5289903,
    "lng": -92.22263079999999
  },
  {
    "Store Location": "Tractor Supply 3901 WEST BROADWAY BLVD SEDALIA, Missouri 65301",
    "Store Type": "Tractor Supply",
    "Phone Number": "660-827-0600",
    "address": "3901 WEST BROADWAY BLVD, SEDALIA, Missouri 65301",
    "city": "SEDALIA",
    "state": "Missouri",
    "zip": "65301",
    "lat": 38.7119154,
    "lng": -93.2789288
  },
  {
    "Store Location": "Tractor Supply 40 DILLON PLAZA DR HIGH RIDGE, Missouri 63049",
    "Store Type": "Tractor Supply",
    "Phone Number": "636-376-8668",
    "address": "40 DILLON PLAZA DR HIGH, RIDGE, Missouri 63049",
    "city": "RIDGE",
    "state": "Missouri",
    "zip": "63049",
    "lat": 38.4773419,
    "lng": -90.5227548
  },
  {
    "Store Location": "Tractor Supply 4151 PARIS RD COLUMBIA, Missouri 65202",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-814-2929",
    "address": "4151 PARIS RD, COLUMBIA, Missouri 65202",
    "city": "COLUMBIA",
    "state": "Missouri",
    "zip": "65202",
    "lat": 38.9914636,
    "lng": -92.2855316
  },
  {
    "Store Location": "Tractor Supply 501 SOUTH KINGSHIGHWAY CAPE GIRARDEAU, Missouri 63703",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-334-5971",
    "address": "501 SOUTH KINGSHIGHWAY CAPE, GIRARDEAU, Missouri 63703",
    "city": "GIRARDEAU",
    "state": "Missouri",
    "zip": "63703",
    "lat": 37.2948606,
    "lng": -89.5557638
  },
  {
    "Store Location": "Tractor Supply 525 WEST NORTHVIEW RD NIXA, Missouri 65714",
    "Store Type": "Tractor Supply",
    "Phone Number": "417-724-0745",
    "address": "525 WEST NORTHVIEW RD, NIXA, Missouri 65714",
    "city": "NIXA",
    "state": "Missouri",
    "zip": "65714",
    "lat": 37.05542459999999,
    "lng": -93.3052987
  },
  {
    "Store Location": "Tractor Supply 604 WALMART DR FARMINGTON, Missouri 63640",
    "Store Type": "Tractor Supply",
    "Phone Number": "573-756-9300",
    "address": "604 WALMART DR, FARMINGTON, Missouri 63640",
    "city": "FARMINGTON",
    "state": "Missouri",
    "zip": "63640",
    "lat": 37.78848260000001,
    "lng": -90.432036
  },
  {
    "Store Location": "Tractor Supply 8016 171ST ST BELTON, Missouri 64012",
    "Store Type": "Tractor Supply",
    "Phone Number": "816-318-8203",
    "address": "8016 171ST ST, BELTON, Missouri 64012",
    "city": "BELTON",
    "state": "Missouri",
    "zip": "64012",
    "lat": 38.8149911,
    "lng": -94.49828649999999
  },
  {
    "Store Location": "Tractor Supply 915 EAST MAIN ST WILLOW SPRINGS, Missouri 65793",
    "Store Type": "Tractor Supply",
    "Phone Number": "417-469-3900",
    "address": "915 EAST MAIN ST WILLOW, SPRINGS, Missouri 65793",
    "city": "SPRINGS",
    "state": "Missouri",
    "zip": "65793",
    "lat": 36.9837035,
    "lng": -91.9544088
  },
  {
    "Store Location": "Tractor Supply 102 BAPTIST DR RICHLAND, Mississippi 39218",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-420-2082",
    "address": "102 BAPTIST DR, RICHLAND, Mississippi 39218",
    "city": "RICHLAND",
    "state": "Mississippi",
    "zip": "39218",
    "lat": 32.2095232,
    "lng": -90.14786409999999
  },
  {
    "Store Location": "Tractor Supply 110D MARKET PL HAZLEHURST, Mississippi 39083",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-894-9920",
    "address": "110D MARKET PL, HAZLEHURST, Mississippi 39083",
    "city": "HAZLEHURST",
    "state": "Mississippi",
    "zip": "39083",
    "lat": 31.8604382,
    "lng": -90.39592549999999
  },
  {
    "Store Location": "Tractor Supply 112 VIRGINIA WAY NEW ALBANY, Mississippi 38652",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-534-3844",
    "address": "112 VIRGINIA WAY NEW, ALBANY, Mississippi 38652",
    "city": "ALBANY",
    "state": "Mississippi",
    "zip": "38652",
    "lat": 34.4870469,
    "lng": -89.029046
  },
  {
    "Store Location": "Tractor Supply 12120B OLD 63 SOUTH LUCEDALE, Mississippi 39452",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-947-2017",
    "address": "12120B OLD 63 SOUTH, LUCEDALE, Mississippi 39452",
    "city": "LUCEDALE",
    "state": "Mississippi",
    "zip": "39452",
    "lat": 31.0821804,
    "lng": -88.5033287
  },
  {
    "Store Location": "Tractor Supply 1216 HWY 6 EAST BATESVILLE, Mississippi 38606",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-578-4844",
    "address": "1216 HWY 6 EAST, BATESVILLE, Mississippi 38606",
    "city": "BATESVILLE",
    "state": "Mississippi",
    "zip": "38606",
    "lat": 34.3098655,
    "lng": -89.90535829999999
  },
  {
    "Store Location": "Tractor Supply 1220 HWY 90 BAY ST LOUIS, Mississippi 39520",
    "Store Type": "Tractor Supply",
    "Phone Number": "228-466-4446",
    "address": "1220 HWY 90 BAY ST, LOUIS, Mississippi 39520",
    "city": "LOUIS",
    "state": "Mississippi",
    "zip": "39520",
    "lat": 30.310237,
    "lng": -89.3642043
  },
  {
    "Store Location": "Tractor Supply 1301 GRETA LN STARKVILLE, Mississippi 39759",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-324-9721",
    "address": "1301 GRETA LN, STARKVILLE, Mississippi 39759",
    "city": "STARKVILLE",
    "state": "Mississippi",
    "zip": "39759",
    "lat": 33.4408004,
    "lng": -88.8506041
  },
  {
    "Store Location": "Tractor Supply 133 NORTHWEST PLZ DRIVE SENATOBIA, Mississippi 38668",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-301-4681",
    "address": "133 NORTHWEST PLZ DRIVE, SENATOBIA, Mississippi 38668",
    "city": "SENATOBIA",
    "state": "Mississippi",
    "zip": "38668",
    "lat": 34.63078,
    "lng": -89.97175999999999
  },
  {
    "Store Location": "Tractor Supply 13440 HWY 49 GULFPORT, Mississippi 39503",
    "Store Type": "Tractor Supply",
    "Phone Number": "228-832-9624",
    "address": "13440 HWY 49, GULFPORT, Mississippi 39503",
    "city": "GULFPORT",
    "state": "Mississippi",
    "zip": "39503",
    "lat": 30.483422,
    "lng": -89.1014969
  },
  {
    "Store Location": "Tractor Supply 14841 HWY 16 WEST PHILADELPHIA, Mississippi 39350",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-656-3967",
    "address": "14841 HWY 16 WEST, PHILADELPHIA, Mississippi 39350",
    "city": "PHILADELPHIA",
    "state": "Mississippi",
    "zip": "39350",
    "lat": 32.7735892,
    "lng": -89.2085567
  },
  {
    "Store Location": "Tractor Supply 1501 NORTHWEST DR LAUREL, Mississippi 39440",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-425-3207",
    "address": "1501 NORTHWEST DR, LAUREL, Mississippi 39440",
    "city": "LAUREL",
    "state": "Mississippi",
    "zip": "39440",
    "lat": 31.6995406,
    "lng": -89.13725269999999
  },
  {
    "Store Location": "Tractor Supply 176 FEATHER LN CANTON, Mississippi 39046",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-859-8400",
    "address": "176 FEATHER LN, CANTON, Mississippi 39046",
    "city": "CANTON",
    "state": "Mississippi",
    "zip": "39046",
    "lat": 32.600983,
    "lng": -90.07092139999999
  },
  {
    "Store Location": "Tractor Supply 180 HIGHWAY 12 WEST KOSCIUSKO, Mississippi 39090",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-289-2262",
    "address": "180 HIGHWAY 12 WEST, KOSCIUSKO, Mississippi 39090",
    "city": "KOSCIUSKO",
    "state": "Mississippi",
    "zip": "39090",
    "lat": 33.0669819,
    "lng": -89.5930367
  },
  {
    "Store Location": "Tractor Supply 1800 SIMPSON HWY 49 MAGEE, Mississippi 39111",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-867-3739",
    "address": "1800 SIMPSON HWY 49, MAGEE, Mississippi 39111",
    "city": "MAGEE",
    "state": "Mississippi",
    "zip": "39111",
    "lat": 31.875468,
    "lng": -89.75703100000001
  },
  {
    "Store Location": "Tractor Supply 1800 SOUTH FRONTAGE RD STE G VICKSBURG, Mississippi 39180",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-619-4448",
    "address": "1800 SOUTH FRONTAGE RD STE G, VICKSBURG, Mississippi 39180",
    "city": "VICKSBURG",
    "state": "Mississippi",
    "zip": "39180",
    "lat": 32.3197241,
    "lng": -90.8710182
  },
  {
    "Store Location": "Tractor Supply 1983 HWY 72 EAST CORINTH, Mississippi 38834",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-286-8117",
    "address": "1983 HWY 72 EAST, CORINTH, Mississippi 38834",
    "city": "CORINTH",
    "state": "Mississippi",
    "zip": "38834",
    "lat": 34.9115667,
    "lng": -88.4940891
  },
  {
    "Store Location": "Tractor Supply 2075 SUNSET DR GRENADA, Mississippi 38901",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-226-6066",
    "address": "2075 SUNSET DR, GRENADA, Mississippi 38901",
    "city": "GRENADA",
    "state": "Mississippi",
    "zip": "38901",
    "lat": 33.7855822,
    "lng": -89.85135009999999
  },
  {
    "Store Location": "Tractor Supply 2110 HWY 19 NORTH MERIDIAN, Mississippi 39307",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-693-8144",
    "address": "2110 HWY 19 NORTH, MERIDIAN, Mississippi 39307",
    "city": "MERIDIAN",
    "state": "Mississippi",
    "zip": "39307",
    "lat": 32.3656541,
    "lng": -88.73128969999999
  },
  {
    "Store Location": "Tractor Supply 2115 S CHURCH AVE LOUISVILLE, Mississippi 39339",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-773-5465",
    "address": "2115 S CHURCH AVE, LOUISVILLE, Mississippi 39339",
    "city": "LOUISVILLE",
    "state": "Mississippi",
    "zip": "39339",
    "lat": 33.1179509,
    "lng": -89.0563542
  },
  {
    "Store Location": "Tractor Supply 214 WALMART CIR BOONEVILLE, Mississippi 38829",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-728-2200",
    "address": "214 WALMART CIR, BOONEVILLE, Mississippi 38829",
    "city": "BOONEVILLE",
    "state": "Mississippi",
    "zip": "38829",
    "lat": 34.676327,
    "lng": -88.563644
  },
  {
    "Store Location": "Tractor Supply 2211 HWY 82 WEST GREENWOOD, Mississippi 38930",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-453-1357",
    "address": "2211 HWY 82 WEST, GREENWOOD, Mississippi 38930",
    "city": "GREENWOOD",
    "state": "Mississippi",
    "zip": "38930",
    "lat": 33.5273893,
    "lng": -90.22225929999999
  },
  {
    "Store Location": "Tractor Supply 2320 HWY 43 SOUTH PICAYUNE, Mississippi 39466",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-798-1263",
    "address": "2320 HWY 43 SOUTH, PICAYUNE, Mississippi 39466",
    "city": "PICAYUNE",
    "state": "Mississippi",
    "zip": "39466",
    "lat": 30.5179459,
    "lng": -89.6509004
  },
  {
    "Store Location": "Tractor Supply 3001-A HIGHWAY 82 E GREENVILLE, Mississippi 38703",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-379-4000",
    "address": "3001-A HIGHWAY 82 E, GREENVILLE, Mississippi 38703",
    "city": "GREENVILLE",
    "state": "Mississippi",
    "zip": "38703",
    "lat": 33.3982984,
    "lng": -91.01093949999999
  },
  {
    "Store Location": "Tractor Supply 306 E SUNFLOWER RD CLEVELAND, Mississippi 38732",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-843-8343",
    "address": "306 E SUNFLOWER RD, CLEVELAND, Mississippi 38732",
    "city": "CLEVELAND",
    "state": "Mississippi",
    "zip": "38732",
    "lat": 33.7468052,
    "lng": -90.7193559
  },
  {
    "Store Location": "Tractor Supply 4010 HWY 45 NORTH COLUMBUS, Mississippi 39705",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-241-9812",
    "address": "4010 HWY 45 NORTH, COLUMBUS, Mississippi 39705",
    "city": "COLUMBUS",
    "state": "Mississippi",
    "zip": "39705",
    "lat": 33.5519534,
    "lng": -88.43203919999999
  },
  {
    "Store Location": "Tractor Supply 464 SPRINGRIDGE RD CLINTON, Mississippi 39056",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-924-7342",
    "address": "464 SPRINGRIDGE RD, CLINTON, Mississippi 39056",
    "city": "CLINTON",
    "state": "Mississippi",
    "zip": "39056",
    "lat": 32.3296364,
    "lng": -90.32792979999999
  },
  {
    "Store Location": "Tractor Supply 476 WEST THIRD ST FOREST, Mississippi 39074",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-469-9241",
    "address": "476 WEST THIRD ST, FOREST, Mississippi 39074",
    "city": "FOREST",
    "state": "Mississippi",
    "zip": "39074",
    "lat": 32.3652276,
    "lng": -89.47811829999999
  },
  {
    "Store Location": "Tractor Supply 5001 BIENVILLE BLVD OCEAN SPRINGS, Mississippi 39564",
    "Store Type": "Tractor Supply",
    "Phone Number": "228-872-8077",
    "address": "5001 BIENVILLE BLVD OCEAN, SPRINGS, Mississippi 39564",
    "city": "SPRINGS",
    "state": "Mississippi",
    "zip": "39564",
    "lat": 30.406829,
    "lng": -88.7427469
  },
  {
    "Store Location": "Tractor Supply 602 WEST PRESLEY BLVD MCCOMB, Mississippi 39648",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-684-2388",
    "address": "602 WEST PRESLEY BLVD, MCCOMB, Mississippi 39648",
    "city": "MCCOMB",
    "state": "Mississippi",
    "zip": "39648",
    "lat": 31.2270356,
    "lng": -90.464598
  },
  {
    "Store Location": "Tractor Supply 6915 WINDCHASE DR HORN LAKE, Mississippi 38637",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-536-3650",
    "address": "6915 WINDCHASE DR HORN, LAKE, Mississippi 38637",
    "city": "LAKE",
    "state": "Mississippi",
    "zip": "38637",
    "lat": 34.9611417,
    "lng": -90.01019219999999
  },
  {
    "Store Location": "Tractor Supply 7168 US HWY 49 HATTIESBURG, Mississippi 39402",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-264-6331",
    "address": "7168 US HWY 49, HATTIESBURG, Mississippi 39402",
    "city": "HATTIESBURG",
    "state": "Mississippi",
    "zip": "39402",
    "lat": 31.3859115,
    "lng": -89.3710141
  },
  {
    "Store Location": "Tractor Supply 780 HWY 61 NORTH NATCHEZ, Mississippi 39120",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-442-0354",
    "address": "780 HWY 61 NORTH, NATCHEZ, Mississippi 39120",
    "city": "NATCHEZ",
    "state": "Mississippi",
    "zip": "39120",
    "lat": 31.5769294,
    "lng": -91.308954
  },
  {
    "Store Location": "Tractor Supply 850 SYMPHONY LN TUPELO, Mississippi 38804",
    "Store Type": "Tractor Supply",
    "Phone Number": "662-844-7081",
    "address": "850 SYMPHONY LN, TUPELO, Mississippi 38804",
    "city": "TUPELO",
    "state": "Mississippi",
    "zip": "38804",
    "lat": 34.3091489,
    "lng": -88.7046969
  },
  {
    "Store Location": "Tractor Supply 940 HWY 13 SOUTH COLUMBIA, Mississippi 39429",
    "Store Type": "Tractor Supply",
    "Phone Number": "601-444-4420",
    "address": "940 HWY 13 SOUTH, COLUMBIA, Mississippi 39429",
    "city": "COLUMBIA",
    "state": "Mississippi",
    "zip": "39429",
    "lat": 31.2341673,
    "lng": -89.8232105
  },
  {
    "Store Location": "Tractor Supply 12150 HWY 93 SOUTH LOLO, Montana 59847",
    "Store Type": "Tractor Supply",
    "Phone Number": "406-273-4777",
    "address": "12150 HWY 93 SOUTH, LOLO, Montana 59847",
    "city": "LOLO",
    "state": "Montana",
    "zip": "59847",
    "lat": 46.7543209,
    "lng": -114.0817359
  },
  {
    "Store Location": "Tractor Supply 1814 WEST MAIN ST LEWISTOWN, Montana 59457",
    "Store Type": "Tractor Supply",
    "Phone Number": "406-538-3800",
    "address": "1814 WEST MAIN ST, LEWISTOWN, Montana 59457",
    "city": "LEWISTOWN",
    "state": "Montana",
    "zip": "59457",
    "lat": 47.0566915,
    "lng": -109.4399007
  },
  {
    "Store Location": "Tractor Supply 2808 WEST TOWNE ST GLENDIVE, Montana 59330",
    "Store Type": "Tractor Supply",
    "Phone Number": "406-365-9665",
    "address": "2808 WEST TOWNE ST, GLENDIVE, Montana 59330",
    "city": "GLENDIVE",
    "state": "Montana",
    "zip": "59330",
    "lat": 47.0915577,
    "lng": -104.772229
  },
  {
    "Store Location": "Tractor Supply 302 EAST HOLLY ST SIDNEY, Montana 59270",
    "Store Type": "Tractor Supply",
    "Phone Number": "406-482-9756",
    "address": "302 EAST HOLLY ST, SIDNEY, Montana 59270",
    "city": "SIDNEY",
    "state": "Montana",
    "zip": "59270",
    "lat": 47.7183983,
    "lng": -104.1513066
  },
  {
    "Store Location": "Tractor Supply 400 SOUTHEAST 4TH ST LAUREL, Montana 59044",
    "Store Type": "Tractor Supply",
    "Phone Number": "406-628-2292",
    "address": "400 SOUTHEAST 4TH ST, LAUREL, Montana 59044",
    "city": "LAUREL",
    "state": "Montana",
    "zip": "59044",
    "lat": 45.6644988,
    "lng": -108.7669805
  },
  {
    "Store Location": "Tractor Supply 496 MAIN ST BILLINGS, Montana 59105",
    "Store Type": "Tractor Supply",
    "Phone Number": "406-252-8626",
    "address": "496 MAIN ST, BILLINGS, Montana 59105",
    "city": "BILLINGS",
    "state": "Montana",
    "zip": "59105",
    "lat": 45.8078028,
    "lng": -108.4749725
  },
  {
    "Store Location": "Tractor Supply 100 SILER XING SILER CITY, North Carolina 27344",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-663-1380",
    "address": "100 SILER XING SILER, CITY, North Carolina 27344",
    "city": "CITY",
    "state": "North Carolina",
    "zip": "27344",
    "lat": 35.7354937,
    "lng": -79.439358
  },
  {
    "Store Location": "Tractor Supply 1010 WEST ROOSEVELT BLVD MONROE, North Carolina 28110",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-296-9524",
    "address": "1010 WEST ROOSEVELT BLVD, MONROE, North Carolina 28110",
    "city": "MONROE",
    "state": "North Carolina",
    "zip": "28110",
    "lat": 34.9942601,
    "lng": -80.5380285
  },
  {
    "Store Location": "Tractor Supply 1011 BETHANIA RURAL HALL RD RURAL HALL, North Carolina 27045",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-969-0482",
    "address": "1011 BETHANIA RURAL HALL RD RURAL, HALL, North Carolina 27045",
    "city": "HALL",
    "state": "North Carolina",
    "zip": "27045",
    "lat": 36.2136596,
    "lng": -80.2998082
  },
  {
    "Store Location": "Tractor Supply 1029 YADKINVILLE RD STE 101 MOCKSVILLE, North Carolina 27028",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-751-0555",
    "address": "1029 YADKINVILLE RD STE 101, MOCKSVILLE, North Carolina 27028",
    "city": "MOCKSVILLE",
    "state": "North Carolina",
    "zip": "27028",
    "lat": 35.91006,
    "lng": -80.57704
  },
  {
    "Store Location": "Tractor Supply 1030 WEST NEW BERN RD STE G KINSTON, North Carolina 28504",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-208-0146",
    "address": "1030 WEST NEW BERN RD STE G, KINSTON, North Carolina 28504",
    "city": "KINSTON",
    "state": "North Carolina",
    "zip": "28504",
    "lat": 35.2522861,
    "lng": -77.6021465
  },
  {
    "Store Location": "Tractor Supply 104 COMMERCIAL PARKS DR CONCORD, North Carolina 28027",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-782-2462",
    "address": "104 COMMERCIAL PARKS DR, CONCORD, North Carolina 28027",
    "city": "CONCORD",
    "state": "North Carolina",
    "zip": "28027",
    "lat": 35.3925217,
    "lng": -80.6195972
  },
  {
    "Store Location": "Tractor Supply 1051 EAST CASWELL ST WADESBORO, North Carolina 28170",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-994-9058",
    "address": "1051 EAST CASWELL ST, WADESBORO, North Carolina 28170",
    "city": "WADESBORO",
    "state": "North Carolina",
    "zip": "28170",
    "lat": 34.9667857,
    "lng": -80.0589058
  },
  {
    "Store Location": "Tractor Supply 111 INDEPENDENCE BLVD STE E MORGANTON, North Carolina 28655",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-433-1945",
    "address": "111 INDEPENDENCE BLVD STE E, MORGANTON, North Carolina 28655",
    "city": "MORGANTON",
    "state": "North Carolina",
    "zip": "28655",
    "lat": 35.7512017,
    "lng": -81.7146645
  },
  {
    "Store Location": "Tractor Supply 1111 HALSTEAD BLVD ELIZABETH CITY, North Carolina 27909",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-331-1001",
    "address": "1111 HALSTEAD BLVD ELIZABETH, CITY, North Carolina 27909",
    "city": "CITY",
    "state": "North Carolina",
    "zip": "27909",
    "lat": 36.2818713,
    "lng": -76.23069919999999
  },
  {
    "Store Location": "Tractor Supply 1122 RANDOLPH STREET SUITE 100 THOMASVILLE, North Carolina 27360",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-474-6646",
    "address": "1122 RANDOLPH STREET SUITE 100, THOMASVILLE, North Carolina 27360",
    "city": "THOMASVILLE",
    "state": "North Carolina",
    "zip": "27360",
    "lat": 35.8589342,
    "lng": -80.0747595
  },
  {
    "Store Location": "Tractor Supply 1134 CROSSROADS DR STATESVILLE, North Carolina 28625",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-838-0220",
    "address": "1134 CROSSROADS DR, STATESVILLE, North Carolina 28625",
    "city": "STATESVILLE",
    "state": "North Carolina",
    "zip": "28625",
    "lat": 35.8105049,
    "lng": -80.8671579
  },
  {
    "Store Location": "Tractor Supply 115 FOUR SEASONS MALL STE A HENDERSONVILLE, North Carolina 28792",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-698-7848",
    "address": "115 FOUR SEASONS MALL STE A, HENDERSONVILLE, North Carolina 28792",
    "city": "HENDERSONVILLE",
    "state": "North Carolina",
    "zip": "28792",
    "lat": 35.334572,
    "lng": -82.44996499999999
  },
  {
    "Store Location": "Tractor Supply 11855 US HWY 601 SOUTH MIDLAND, North Carolina 28107",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-888-4244",
    "address": "11855 US HWY 601 SOUTH, MIDLAND, North Carolina 28107",
    "city": "MIDLAND",
    "state": "North Carolina",
    "zip": "28107",
    "lat": 35.2593215,
    "lng": -80.5216184
  },
  {
    "Store Location": "Tractor Supply 1200 EAST DIXIE DR ASHEBORO, North Carolina 27203",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-625-0019",
    "address": "1200 EAST DIXIE DR, ASHEBORO, North Carolina 27203",
    "city": "ASHEBORO",
    "state": "North Carolina",
    "zip": "27203",
    "lat": 35.694313,
    "lng": -79.792211
  },
  {
    "Store Location": "Tractor Supply 1201 MAMMOTH DR KNIGHTDALE, North Carolina 27545",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-266-5628",
    "address": "1201 MAMMOTH DR, KNIGHTDALE, North Carolina 27545",
    "city": "KNIGHTDALE",
    "state": "North Carolina",
    "zip": "27545",
    "lat": 35.7999316,
    "lng": -78.4967013
  },
  {
    "Store Location": "Tractor Supply 1206 A ROCKINGHAM RD ROCKINGHAM, North Carolina 28379",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-997-7077",
    "address": "1206 A ROCKINGHAM RD, ROCKINGHAM, North Carolina 28379",
    "city": "ROCKINGHAM",
    "state": "North Carolina",
    "zip": "28379",
    "lat": 34.9253426,
    "lng": -79.7517166
  },
  {
    "Store Location": "Tractor Supply 121 PARAGON PKWY CLYDE, North Carolina 28721",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-454-1054",
    "address": "121 PARAGON PKWY, CLYDE, North Carolina 28721",
    "city": "CLYDE",
    "state": "North Carolina",
    "zip": "28721",
    "lat": 35.52574,
    "lng": -82.95676999999999
  },
  {
    "Store Location": "Tractor Supply 1232 ASHEVILLE HWY BREVARD, North Carolina 28712",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-877-5200",
    "address": "1232 ASHEVILLE HWY, BREVARD, North Carolina 28712",
    "city": "BREVARD",
    "state": "North Carolina",
    "zip": "28712",
    "lat": 35.258416,
    "lng": -82.7152399
  },
  {
    "Store Location": "Tractor Supply 124 NEW MARKET MADISON, North Carolina 27025",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-445-9900",
    "address": "124 NEW MARKET, MADISON, North Carolina 27025",
    "city": "MADISON",
    "state": "North Carolina",
    "zip": "27025",
    "lat": 36.3969627,
    "lng": -79.96736779999999
  },
  {
    "Store Location": "Tractor Supply 125 OLD US HWY 70 EAST BLACK MOUNTAIN, North Carolina 28711",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-669-0725",
    "address": "125 OLD US HWY 70 EAST BLACK, MOUNTAIN, North Carolina 28711",
    "city": "MOUNTAIN",
    "state": "North Carolina",
    "zip": "28711",
    "lat": 35.6090913,
    "lng": -82.3600404
  },
  {
    "Store Location": "Tractor Supply 1305 WEST BROAD ST ELIZABETHTOWN, North Carolina 28337",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-862-3011",
    "address": "1305 WEST BROAD ST, ELIZABETHTOWN, North Carolina 28337",
    "city": "ELIZABETHTOWN",
    "state": "North Carolina",
    "zip": "28337",
    "lat": 34.6320281,
    "lng": -78.6204563
  },
  {
    "Store Location": "Tractor Supply 1308 WEST GRANTHAM ST GOLDSBORO, North Carolina 27530",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-580-7030",
    "address": "1308 WEST GRANTHAM ST, GOLDSBORO, North Carolina 27530",
    "city": "GOLDSBORO",
    "state": "North Carolina",
    "zip": "27530",
    "lat": 35.3992654,
    "lng": -78.0165955
  },
  {
    "Store Location": "Tractor Supply 1348 NORTH MAIN ST FUQUAY VARINA, North Carolina 27526",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-567-7580",
    "address": "1348 NORTH MAIN ST FUQUAY, VARINA, North Carolina 27526",
    "city": "VARINA",
    "state": "North Carolina",
    "zip": "27526",
    "lat": 35.5904381,
    "lng": -78.7755132
  },
  {
    "Store Location": "Tractor Supply 1350 JULIAN ALLSBROOK HWY ROANOKE RAPIDS, North Carolina 27870",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-537-7522",
    "address": "1350 JULIAN ALLSBROOK HWY ROANOKE, RAPIDS, North Carolina 27870",
    "city": "RAPIDS",
    "state": "North Carolina",
    "zip": "27870",
    "lat": 36.436343,
    "lng": -77.6376829
  },
  {
    "Store Location": "Tractor Supply 14 MONTICELLO RD WEAVERVILLE, North Carolina 28787",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-658-9250",
    "address": "14 MONTICELLO RD, WEAVERVILLE, North Carolina 28787",
    "city": "WEAVERVILLE",
    "state": "North Carolina",
    "zip": "28787",
    "lat": 35.7108447,
    "lng": -82.5625393
  },
  {
    "Store Location": "Tractor Supply 14 OLD BREVARD RD ASHEVILLE, North Carolina 28806",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-670-9170",
    "address": "14 OLD BREVARD RD, ASHEVILLE, North Carolina 28806",
    "city": "ASHEVILLE",
    "state": "North Carolina",
    "zip": "28806",
    "lat": 35.5228561,
    "lng": -82.6051996
  },
  {
    "Store Location": "Tractor Supply 1401 SOUTH POLLOCK SELMA, North Carolina 27576",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-965-6762",
    "address": "1401 SOUTH POLLOCK, SELMA, North Carolina 27576",
    "city": "SELMA",
    "state": "North Carolina",
    "zip": "27576",
    "lat": 35.5235982,
    "lng": -78.299086
  },
  {
    "Store Location": "Tractor Supply 1416 PORTERS LANE RD ROCKY POINT, North Carolina 28457",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-602-1574",
    "address": "1416 PORTERS LANE RD ROCKY, POINT, North Carolina 28457",
    "city": "POINT",
    "state": "North Carolina",
    "zip": "28457",
    "lat": 34.4423657,
    "lng": -77.8826008
  },
  {
    "Store Location": "Tractor Supply 148 TOWN AND COUNTRY SHOPPING CTR WALLACE, North Carolina 28466",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-285-0726",
    "address": "148 TOWN AND COUNTRY SHOPPING CTR, WALLACE, North Carolina 28466",
    "city": "WALLACE",
    "state": "North Carolina",
    "zip": "28466",
    "lat": 34.7509235,
    "lng": -77.99616910000002
  },
  {
    "Store Location": "Tractor Supply 15 PLAZA PKWY LEXINGTON, North Carolina 27292",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-243-5980",
    "address": "15 PLAZA PKWY, LEXINGTON, North Carolina 27292",
    "city": "LEXINGTON",
    "state": "North Carolina",
    "zip": "27292",
    "lat": 35.7847342,
    "lng": -80.25783229999999
  },
  {
    "Store Location": "Tractor Supply 1516 SUNSET AVE CLINTON, North Carolina 28328",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-592-3344",
    "address": "1516 SUNSET AVE, CLINTON, North Carolina 28328",
    "city": "CLINTON",
    "state": "North Carolina",
    "zip": "28328",
    "lat": 34.9929424,
    "lng": -78.35444179999999
  },
  {
    "Store Location": "Tractor Supply 1532 MEMORIAL DR EAST STE A AHOSKIE, North Carolina 27910",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-332-3301",
    "address": "1532 MEMORIAL DR EAST STE A, AHOSKIE, North Carolina 27910",
    "city": "AHOSKIE",
    "state": "North Carolina",
    "zip": "27910",
    "lat": 36.2706543,
    "lng": -76.971749
  },
  {
    "Store Location": "Tractor Supply 1630 EDGEWOOD RD BESSEMER CITY, North Carolina 28016",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-865-5589",
    "address": "1630 EDGEWOOD RD BESSEMER, CITY, North Carolina 28016",
    "city": "CITY",
    "state": "North Carolina",
    "zip": "28016",
    "lat": 35.2579091,
    "lng": -81.2574984
  },
  {
    "Store Location": "Tractor Supply 1639 US HWY 74A BYP STE 200 SPINDALE, North Carolina 28160",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-286-0760",
    "address": "1639 US HWY 74A BYP STE 200, SPINDALE, North Carolina 28160",
    "city": "SPINDALE",
    "state": "North Carolina",
    "zip": "28160",
    "lat": 35.3561546,
    "lng": -81.9261999
  },
  {
    "Store Location": "Tractor Supply 1665 EAST DIXON BLVD SHELBY, North Carolina 28152",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-482-1808",
    "address": "1665 EAST DIXON BLVD, SHELBY, North Carolina 28152",
    "city": "SHELBY",
    "state": "North Carolina",
    "zip": "28152",
    "lat": 35.2748551,
    "lng": -81.50872199999999
  },
  {
    "Store Location": "Tractor Supply 1690 SOUTH MAIN ST LAURINBURG, North Carolina 28352",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-291-0255",
    "address": "1690 SOUTH MAIN ST, LAURINBURG, North Carolina 28352",
    "city": "LAURINBURG",
    "state": "North Carolina",
    "zip": "28352",
    "lat": 34.7518296,
    "lng": -79.4773755
  },
  {
    "Store Location": "Tractor Supply 1701 NC HWY 86 SOUTH HILLSBOROUGH, North Carolina 27278",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-245-0522",
    "address": "1701 NC HWY 86 SOUTH, HILLSBOROUGH, North Carolina 27278",
    "city": "HILLSBOROUGH",
    "state": "North Carolina",
    "zip": "27278",
    "lat": 36.0617815,
    "lng": -79.08542369999999
  },
  {
    "Store Location": "Tractor Supply 1733 DABNEY DR HENDERSON, North Carolina 27536",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-431-1011",
    "address": "1733 DABNEY DR, HENDERSON, North Carolina 27536",
    "city": "HENDERSON",
    "state": "North Carolina",
    "zip": "27536",
    "lat": 36.3343836,
    "lng": -78.43952879999999
  },
  {
    "Store Location": "Tractor Supply 1826 W US HIGHWAY 421 STE A WILKESBORO, North Carolina 28697",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-667-1025",
    "address": "1826 W US HIGHWAY 421 STE A, WILKESBORO, North Carolina 28697",
    "city": "WILKESBORO",
    "state": "North Carolina",
    "zip": "28697",
    "lat": 36.1517552,
    "lng": -81.19416540000002
  },
  {
    "Store Location": "Tractor Supply 1925 NORTH BRIDGE ST STE 100 ELKIN, North Carolina 28621",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-835-6004",
    "address": "1925 NORTH BRIDGE ST STE 100, ELKIN, North Carolina 28621",
    "city": "ELKIN",
    "state": "North Carolina",
    "zip": "28621",
    "lat": 36.2834389,
    "lng": -80.8535199
  },
  {
    "Store Location": "Tractor Supply 196 WESTWOOD VILLAGE DR CLEMMONS, North Carolina 27012",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-766-6326",
    "address": "196 WESTWOOD VILLAGE DR, CLEMMONS, North Carolina 27012",
    "city": "CLEMMONS",
    "state": "North Carolina",
    "zip": "27012",
    "lat": 36.0308254,
    "lng": -80.3859068
  },
  {
    "Store Location": "Tractor Supply 2149 ROCKFORD ST STE C MOUNT AIRY, North Carolina 27030",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-786-1211",
    "address": "2149 ROCKFORD ST STE C MOUNT, AIRY, North Carolina 27030",
    "city": "AIRY",
    "state": "North Carolina",
    "zip": "27030",
    "lat": 36.4750272,
    "lng": -80.61751819999999
  },
  {
    "Store Location": "Tractor Supply 219 EAST PLAZA DR STE A MOORESVILLE, North Carolina 28115",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-658-1157",
    "address": "219 EAST PLAZA DR STE A, MOORESVILLE, North Carolina 28115",
    "city": "MOORESVILLE",
    "state": "North Carolina",
    "zip": "28115",
    "lat": 35.5899948,
    "lng": -80.8293016
  },
  {
    "Store Location": "Tractor Supply 2221 OLD 421 SOUTH BOONE, North Carolina 28607",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-264-9999",
    "address": "2221 OLD 421 SOUTH, BOONE, North Carolina 28607",
    "city": "BOONE",
    "state": "North Carolina",
    "zip": "28607",
    "lat": 36.2204701,
    "lng": -81.6466887
  },
  {
    "Store Location": "Tractor Supply 2380 FOREST HILLS RD WEST WILSON, North Carolina 27893",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-237-4392",
    "address": "2380 FOREST HILLS RD WEST, WILSON, North Carolina 27893",
    "city": "WILSON",
    "state": "North Carolina",
    "zip": "27893",
    "lat": 35.7318416,
    "lng": -77.9489682
  },
  {
    "Store Location": "Tractor Supply 2380 WEST CUMBERLAND ST DUNN, North Carolina 28334",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-980-0463",
    "address": "2380 WEST CUMBERLAND ST, DUNN, North Carolina 28334",
    "city": "DUNN",
    "state": "North Carolina",
    "zip": "28334",
    "lat": 35.3234148,
    "lng": -78.6380119
  },
  {
    "Store Location": "Tractor Supply 26 WHITE CROSSING PLZ WHITEVILLE, North Carolina 28472",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-641-0500",
    "address": "26 WHITE CROSSING PLZ, WHITEVILLE, North Carolina 28472",
    "city": "WHITEVILLE",
    "state": "North Carolina",
    "zip": "28472",
    "lat": 34.4140087,
    "lng": -78.7533311
  },
  {
    "Store Location": "Tractor Supply 2627 S SCALES ST REIDSVILLE, North Carolina 27320",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-348-6903",
    "address": "2627 S SCALES ST, REIDSVILLE, North Carolina 27320",
    "city": "REIDSVILLE",
    "state": "North Carolina",
    "zip": "27320",
    "lat": 36.3157122,
    "lng": -79.6709982
  },
  {
    "Store Location": "Tractor Supply 271 SOUTH BICKETT BLVD LOUISBURG, North Carolina 27549",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-497-0190",
    "address": "271 SOUTH BICKETT BLVD, LOUISBURG, North Carolina 27549",
    "city": "LOUISBURG",
    "state": "North Carolina",
    "zip": "27549",
    "lat": 36.0906445,
    "lng": -78.2978852
  },
  {
    "Store Location": "Tractor Supply 2748 RICHLANDS HWY JACKSONVILLE, North Carolina 28540",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-937-9787",
    "address": "2748 RICHLANDS HWY, JACKSONVILLE, North Carolina 28540",
    "city": "JACKSONVILLE",
    "state": "North Carolina",
    "zip": "28540",
    "lat": 34.7561375,
    "lng": -77.4604664
  },
  {
    "Store Location": "Tractor Supply 285 GILLMAN RD DENVER, North Carolina 28037",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-827-2870",
    "address": "285 GILLMAN RD, DENVER, North Carolina 28037",
    "city": "DENVER",
    "state": "North Carolina",
    "zip": "28037",
    "lat": 35.4421522,
    "lng": -81.0009686
  },
  {
    "Store Location": "Tractor Supply 2900 ARENDELL ST UNIT 24 MOREHEAD CITY, North Carolina 28557",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-222-3321",
    "address": "2900 ARENDELL ST UNIT 24 MOREHEAD, CITY, North Carolina 28557",
    "city": "CITY",
    "state": "North Carolina",
    "zip": "28557",
    "lat": 34.7249679,
    "lng": -76.7440227
  },
  {
    "Store Location": "Tractor Supply 3004 SOUTH HORNER BLVD SANFORD, North Carolina 27332",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-708-9057",
    "address": "3004 SOUTH HORNER BLVD, SANFORD, North Carolina 27332",
    "city": "SANFORD",
    "state": "North Carolina",
    "zip": "27332",
    "lat": 35.4505544,
    "lng": -79.138537
  },
  {
    "Store Location": "Tractor Supply 3077 GEORGIA RD FRANKLIN, North Carolina 28734",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-524-0640",
    "address": "3077 GEORGIA RD, FRANKLIN, North Carolina 28734",
    "city": "FRANKLIN",
    "state": "North Carolina",
    "zip": "28734",
    "lat": 35.1321705,
    "lng": -83.3983014
  },
  {
    "Store Location": "Tractor Supply 3129 GARDEN RD BURLINGTON, North Carolina 27215",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-586-9222",
    "address": "3129 GARDEN RD, BURLINGTON, North Carolina 27215",
    "city": "BURLINGTON",
    "state": "North Carolina",
    "zip": "27215",
    "lat": 36.0721521,
    "lng": -79.4973443
  },
  {
    "Store Location": "Tractor Supply 3250 HWY 70 SOUTHEAST NEWTON, North Carolina 28658",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-466-3666",
    "address": "3250 HWY 70 SOUTHEAST, NEWTON, North Carolina 28658",
    "city": "NEWTON",
    "state": "North Carolina",
    "zip": "28658",
    "lat": 35.6957385,
    "lng": -81.26547699999999
  },
  {
    "Store Location": "Tractor Supply 3340 WEST US 64 MURPHY, North Carolina 28906",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-837-1596",
    "address": "3340 WEST US 64, MURPHY, North Carolina 28906",
    "city": "MURPHY",
    "state": "North Carolina",
    "zip": "28906",
    "lat": 35.054649,
    "lng": -84.07033899999999
  },
  {
    "Store Location": "Tractor Supply 3357 LACKEY ST LUMBERTON, North Carolina 28360",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-738-3402",
    "address": "3357 LACKEY ST, LUMBERTON, North Carolina 28360",
    "city": "LUMBERTON",
    "state": "North Carolina",
    "zip": "28360",
    "lat": 34.6406164,
    "lng": -79.0185466
  },
  {
    "Store Location": "Tractor Supply 360 BLOWING ROCK BLVD LENOIR, North Carolina 28645",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-758-7078",
    "address": "360 BLOWING ROCK BLVD, LENOIR, North Carolina 28645",
    "city": "LENOIR",
    "state": "North Carolina",
    "zip": "28645",
    "lat": 35.9211724,
    "lng": -81.5218412
  },
  {
    "Store Location": "Tractor Supply 3821 DR ML KING JR BLVD NEW BERN, North Carolina 28562",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-638-0131",
    "address": "3821 DR ML KING JR BLVD NEW, BERN, North Carolina 28562",
    "city": "BERN",
    "state": "North Carolina",
    "zip": "28562",
    "lat": 35.108493,
    "lng": -77.04411429999999
  },
  {
    "Store Location": "Tractor Supply 3985 SOUTH MEMORIAL DR WINTERVILLE, North Carolina 28590",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-353-7400",
    "address": "3985 SOUTH MEMORIAL DR, WINTERVILLE, North Carolina 28590",
    "city": "WINTERVILLE",
    "state": "North Carolina",
    "zip": "28590",
    "lat": 35.5580721,
    "lng": -77.4042999
  },
  {
    "Store Location": "Tractor Supply 401 NORTH GENERALS BLVD LINCOLNTON, North Carolina 28092",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-735-5029",
    "address": "401 NORTH GENERALS BLVD, LINCOLNTON, North Carolina 28092",
    "city": "LINCOLNTON",
    "state": "North Carolina",
    "zip": "28092",
    "lat": 35.4895084,
    "lng": -81.2472368
  },
  {
    "Store Location": "Tractor Supply 405 JAKE ALEXANDER BLVD SOUTH SALISBURY, North Carolina 28147",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-797-9511",
    "address": "405 JAKE ALEXANDER BLVD SOUTH, SALISBURY, North Carolina 28147",
    "city": "SALISBURY",
    "state": "North Carolina",
    "zip": "28147",
    "lat": 35.6469523,
    "lng": -80.4937398
  },
  {
    "Store Location": "Tractor Supply 4104 SOUTH ELM EUGENE ST GREENSBORO, North Carolina 27406",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-333-3033",
    "address": "4104 SOUTH ELM EUGENE ST, GREENSBORO, North Carolina 27406",
    "city": "GREENSBORO",
    "state": "North Carolina",
    "zip": "27406",
    "lat": 35.9959429,
    "lng": -79.7934097
  },
  {
    "Store Location": "Tractor Supply 417 NORTH MAIN ST STE A MARION, North Carolina 28752",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-652-1080",
    "address": "417 NORTH MAIN ST STE A, MARION, North Carolina 28752",
    "city": "MARION",
    "state": "North Carolina",
    "zip": "28752",
    "lat": 35.6875344,
    "lng": -82.01435769999999
  },
  {
    "Store Location": "Tractor Supply 4740 NC HWY 87 SOUTH FAYETTEVILLE, North Carolina 28306",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-223-1308",
    "address": "4740 NC HWY 87 SOUTH, FAYETTEVILLE, North Carolina 28306",
    "city": "FAYETTEVILLE",
    "state": "North Carolina",
    "zip": "28306",
    "lat": 34.9355811,
    "lng": -78.84950049999999
  },
  {
    "Store Location": "Tractor Supply 506 SUTTERS CREEK RD ROCKY MOUNT, North Carolina 27804",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-407-8400",
    "address": "506 SUTTERS CREEK RD ROCKY, MOUNT, North Carolina 27804",
    "city": "MOUNT",
    "state": "North Carolina",
    "zip": "27804",
    "lat": 35.9686357,
    "lng": -77.8082257
  },
  {
    "Store Location": "Tractor Supply 5100 MAIN ST SHALLOTTE, North Carolina 28470",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-754-7535",
    "address": "5100 MAIN ST, SHALLOTTE, North Carolina 28470",
    "city": "SHALLOTTE",
    "state": "North Carolina",
    "zip": "28470",
    "lat": 33.9645151,
    "lng": -78.3978322
  },
  {
    "Store Location": "Tractor Supply 527 EAST MAIN ST BISCOE, North Carolina 27209",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-428-2900",
    "address": "527 EAST MAIN ST, BISCOE, North Carolina 27209",
    "city": "BISCOE",
    "state": "North Carolina",
    "zip": "27209",
    "lat": 35.3627856,
    "lng": -79.7684623
  },
  {
    "Store Location": "Tractor Supply 55 GATEKEEPER DR YOUNGSVILLE, North Carolina 27596",
    "Store Type": "Tractor Supply",
    "Phone Number": "919-556-2726",
    "address": "55 GATEKEEPER DR, YOUNGSVILLE, North Carolina 27596",
    "city": "YOUNGSVILLE",
    "state": "North Carolina",
    "zip": "27596",
    "lat": 36.0328973,
    "lng": -78.50264709999999
  },
  {
    "Store Location": "Tractor Supply 5601 US HWY 1 VASS, North Carolina 28394",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-246-0809",
    "address": "5601 US HWY 1, VASS, North Carolina 28394",
    "city": "VASS",
    "state": "North Carolina",
    "zip": "28394",
    "lat": 35.2127753,
    "lng": -79.3283007
  },
  {
    "Store Location": "Tractor Supply 608 WEST 15TH ST WASHINGTON, North Carolina 27889",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-946-1549",
    "address": "608 WEST 15TH ST, WASHINGTON, North Carolina 27889",
    "city": "WASHINGTON",
    "state": "North Carolina",
    "zip": "27889",
    "lat": 35.5602586,
    "lng": -77.0529384
  },
  {
    "Store Location": "Tractor Supply 630 SOUTH MAIN ST JEFFERSON, North Carolina 28640",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-219-0246",
    "address": "630 SOUTH MAIN ST, JEFFERSON, North Carolina 28640",
    "city": "JEFFERSON",
    "state": "North Carolina",
    "zip": "28640",
    "lat": 36.4116232,
    "lng": -81.4803708
  },
  {
    "Store Location": "Tractor Supply 636 NC 24 27 BYPASS EAST STE 24 ALBEMARLE, North Carolina 28001",
    "Store Type": "Tractor Supply",
    "Phone Number": "704-983-8731",
    "address": "636 NC 24 27 BYPASS EAST STE 24, ALBEMARLE, North Carolina 28001",
    "city": "ALBEMARLE",
    "state": "North Carolina",
    "zip": "28001",
    "lat": 35.3424158,
    "lng": -80.1740796
  },
  {
    "Store Location": "Tractor Supply 651 WEST MILLS ST COLUMBUS, North Carolina 28722",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-894-0560",
    "address": "651 WEST MILLS ST, COLUMBUS, North Carolina 28722",
    "city": "COLUMBUS",
    "state": "North Carolina",
    "zip": "28722",
    "lat": 35.242992,
    "lng": -82.2064173
  },
  {
    "Store Location": "Tractor Supply 754 NORTH MADISON BLVD ROXBORO, North Carolina 27573",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-599-0405",
    "address": "754 NORTH MADISON BLVD, ROXBORO, North Carolina 27573",
    "city": "ROXBORO",
    "state": "North Carolina",
    "zip": "27573",
    "lat": 36.4053393,
    "lng": -78.9766348
  },
  {
    "Store Location": "Tractor Supply 8000 RAEFORD RD FAYETTEVILLE, North Carolina 28304",
    "Store Type": "Tractor Supply",
    "Phone Number": "910-868-6222",
    "address": "8000 RAEFORD RD, FAYETTEVILLE, North Carolina 28304",
    "city": "FAYETTEVILLE",
    "state": "North Carolina",
    "zip": "28304",
    "lat": 35.0329948,
    "lng": -79.064799
  },
  {
    "Store Location": "Tractor Supply 8005 MARKET PLACE DR OAK RIDGE, North Carolina 27310",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-644-6632",
    "address": "8005 MARKET PLACE DR OAK, RIDGE, North Carolina 27310",
    "city": "RIDGE",
    "state": "North Carolina",
    "zip": "27310",
    "lat": 36.17181910000001,
    "lng": -79.9897629
  },
  {
    "Store Location": "Tractor Supply 813 EAST BLVD STE A WILLIAMSTON, North Carolina 27892",
    "Store Type": "Tractor Supply",
    "Phone Number": "252-792-0134",
    "address": "813 EAST BLVD STE A, WILLIAMSTON, North Carolina 27892",
    "city": "WILLIAMSTON",
    "state": "North Carolina",
    "zip": "27892",
    "lat": 35.84882899999999,
    "lng": -77.04592219999999
  },
  {
    "Store Location": "Tractor Supply 837 NC HWY 16 SOUTH TAYLORSVILLE, North Carolina 28681",
    "Store Type": "Tractor Supply",
    "Phone Number": "828-635-8946",
    "address": "837 NC HWY 16 SOUTH, TAYLORSVILLE, North Carolina 28681",
    "city": "TAYLORSVILLE",
    "state": "North Carolina",
    "zip": "28681",
    "lat": 35.9098982,
    "lng": -81.1761609
  },
  {
    "Store Location": "Tractor Supply 842A S VAN BUREN RD EDEN, North Carolina 27288",
    "Store Type": "Tractor Supply",
    "Phone Number": "336-623-1353",
    "address": "842A S VAN BUREN RD, EDEN, North Carolina 27288",
    "city": "EDEN",
    "state": "North Carolina",
    "zip": "27288",
    "lat": 36.484683,
    "lng": -79.73722699999999
  },
  {
    "Store Location": "Tractor Supply 101 12TH AVE NORTHWEST HAZEN, North Dakota 58545",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-748-2041",
    "address": "101 12TH AVE NORTHWEST, HAZEN, North Dakota 58545",
    "city": "HAZEN",
    "state": "North Dakota",
    "zip": "58545",
    "lat": 47.2951983,
    "lng": -101.6452784
  },
  {
    "Store Location": "Tractor Supply 105 6TH AVE SOUTHEAST WATFORD CITY, North Dakota 58854",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-842-2521",
    "address": "105 6TH AVE SOUTHEAST WATFORD, CITY, North Dakota 58854",
    "city": "CITY",
    "state": "North Dakota",
    "zip": "58854",
    "lat": 47.7954866,
    "lng": -103.2803003
  },
  {
    "Store Location": "Tractor Supply 1101 BROOKSIDE LN BISMARCK, North Dakota 58503",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-223-8931",
    "address": "1101 BROOKSIDE LN, BISMARCK, North Dakota 58503",
    "city": "BISMARCK",
    "state": "North Dakota",
    "zip": "58503",
    "lat": 46.8632578,
    "lng": -100.7743212
  },
  {
    "Store Location": "Tractor Supply 1102 WEST 12TH ST GRAFTON, North Dakota 58237",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-352-0077",
    "address": "1102 WEST 12TH ST, GRAFTON, North Dakota 58237",
    "city": "GRAFTON",
    "state": "North Dakota",
    "zip": "58237",
    "lat": 48.4110585,
    "lng": -97.42827009999999
  },
  {
    "Store Location": "Tractor Supply 120 26TH ST EAST STE 101 WILLISTON, North Dakota 58801",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-572-8341",
    "address": "120 26TH ST EAST STE 101, WILLISTON, North Dakota 58801",
    "city": "WILLISTON",
    "state": "North Dakota",
    "zip": "58801",
    "lat": 48.1669628,
    "lng": -103.6202134
  },
  {
    "Store Location": "Tractor Supply 1202 4TH AVE SOUTH WAHPETON, North Dakota 58075",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-642-1144",
    "address": "1202 4TH AVE SOUTH, WAHPETON, North Dakota 58075",
    "city": "WAHPETON",
    "state": "North Dakota",
    "zip": "58075",
    "lat": 46.2624137,
    "lng": -96.6187708
  },
  {
    "Store Location": "Tractor Supply 1325 SOUTH BROADWAY MINOT, North Dakota 58701",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-852-6662",
    "address": "1325 SOUTH BROADWAY, MINOT, North Dakota 58701",
    "city": "MINOT",
    "state": "North Dakota",
    "zip": "58701",
    "lat": 48.2225517,
    "lng": -101.2951146
  },
  {
    "Store Location": "Tractor Supply 223 4TH ST SOUTHWEST DEVILS LAKE, North Dakota 58301",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-662-8105",
    "address": "223 4TH ST SOUTHWEST DEVILS, LAKE, North Dakota 58301",
    "city": "LAKE",
    "state": "North Dakota",
    "zip": "58301",
    "lat": 48.1063,
    "lng": -98.86772200000001
  },
  {
    "Store Location": "Tractor Supply 2319 10TH AVE SOUTHWEST JAMESTOWN, North Dakota 58401",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-252-4111",
    "address": "2319 10TH AVE SOUTHWEST, JAMESTOWN, North Dakota 58401",
    "city": "JAMESTOWN",
    "state": "North Dakota",
    "zip": "58401",
    "lat": 46.8841755,
    "lng": -98.7226927
  },
  {
    "Store Location": "Tractor Supply 2959 25TH ST NORTHEAST HARVEY, North Dakota 58341",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-324-4854",
    "address": "2959 25TH ST NORTHEAST, HARVEY, North Dakota 58341",
    "city": "HARVEY",
    "state": "North Dakota",
    "zip": "58341",
    "lat": 47.77584160000001,
    "lng": -99.94990729999999
  },
  {
    "Store Location": "Tractor Supply 4460 32ND AVE SOUTH GRAND FORKS, North Dakota 58201",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-746-0391",
    "address": "4460 32ND AVE SOUTH GRAND, FORKS, North Dakota 58201",
    "city": "FORKS",
    "state": "North Dakota",
    "zip": "58201",
    "lat": 47.8905651,
    "lng": -97.0937761
  },
  {
    "Store Location": "Tractor Supply 4544 WEST RIDGE DR DICKINSON, North Dakota 58601",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-483-9760",
    "address": "4544 WEST RIDGE DR, DICKINSON, North Dakota 58601",
    "city": "DICKINSON",
    "state": "North Dakota",
    "zip": "58601",
    "lat": 46.89456879999999,
    "lng": -102.8454185
  },
  {
    "Store Location": "Tractor Supply 506 WESTVIEW LN STANLEY, North Dakota 58784",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-628-4890",
    "address": "506 WESTVIEW LN, STANLEY, North Dakota 58784",
    "city": "STANLEY",
    "state": "North Dakota",
    "zip": "58784",
    "lat": 48.3062933,
    "lng": -102.4026332
  },
  {
    "Store Location": "Tractor Supply 810 11TH ST EAST BOTTINEAU, North Dakota 58318",
    "Store Type": "Tractor Supply",
    "Phone Number": "701-228-2961",
    "address": "810 11TH ST EAST, BOTTINEAU, North Dakota 58318",
    "city": "BOTTINEAU",
    "state": "North Dakota",
    "zip": "58318",
    "lat": 48.81909839999999,
    "lng": -100.4346859
  },
  {
    "Store Location": "Tractor Supply 110 SOUTH MERIDIAN AVE COZAD, Nebraska 69130",
    "Store Type": "Tractor Supply",
    "Phone Number": "308-784-4700",
    "address": "110 SOUTH MERIDIAN AVE, COZAD, Nebraska 69130",
    "city": "COZAD",
    "state": "Nebraska",
    "zip": "69130",
    "lat": 40.8527348,
    "lng": -99.9847082
  },
  {
    "Store Location": "Tractor Supply 1308 NORTH DIERS AVE GRAND ISLAND, Nebraska 68803",
    "Store Type": "Tractor Supply",
    "Phone Number": "308-384-6411",
    "address": "1308 NORTH DIERS AVE GRAND, ISLAND, Nebraska 68803",
    "city": "ISLAND",
    "state": "Nebraska",
    "zip": "68803",
    "lat": 40.9320787,
    "lng": -98.38596009999999
  },
  {
    "Store Location": "Tractor Supply 1319 EAST 23RD ST COLUMBUS, Nebraska 68601",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-564-8102",
    "address": "1319 EAST 23RD ST, COLUMBUS, Nebraska 68601",
    "city": "COLUMBUS",
    "state": "Nebraska",
    "zip": "68601",
    "lat": 41.43737900000001,
    "lng": -97.3109741
  },
  {
    "Store Location": "Tractor Supply 1556 SOUTH 11TH ST STE A NEBRASKA CITY, Nebraska 68410",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7530",
    "address": "1556 SOUTH 11TH ST STE A NEBRASKA, CITY, Nebraska 68410",
    "city": "CITY",
    "state": "Nebraska",
    "zip": "68410",
    "lat": 40.6620226,
    "lng": -95.8604638
  },
  {
    "Store Location": "Tractor Supply 208 WESTVIEW PLAZA MCCOOK, Nebraska 69001",
    "Store Type": "Tractor Supply",
    "Phone Number": "308-345-4141",
    "address": "208 WESTVIEW PLAZA, MCCOOK, Nebraska 69001",
    "city": "MCCOOK",
    "state": "Nebraska",
    "zip": "69001",
    "lat": 40.201134,
    "lng": -100.646095
  },
  {
    "Store Location": "Tractor Supply 2201 KRENZIEN DR NORFOLK, Nebraska 68701",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-371-5118",
    "address": "2201 KRENZIEN DR, NORFOLK, Nebraska 68701",
    "city": "NORFOLK",
    "state": "Nebraska",
    "zip": "68701",
    "lat": 42.0225115,
    "lng": -97.44007599999999
  },
  {
    "Store Location": "Tractor Supply 2850 EAST 23RD AVE NORTH FREMONT, Nebraska 68025",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-721-6175",
    "address": "2850 EAST 23RD AVE NORTH, FREMONT, Nebraska 68025",
    "city": "FREMONT",
    "state": "Nebraska",
    "zip": "68025",
    "lat": 41.4529013,
    "lng": -96.46050020000001
  },
  {
    "Store Location": "Tractor Supply 3000 OSBORN DR EAST STE 100 HASTINGS, Nebraska 68901",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-461-3440",
    "address": "3000 OSBORN DR EAST STE 100, HASTINGS, Nebraska 68901",
    "city": "HASTINGS",
    "state": "Nebraska",
    "zip": "68901",
    "lat": 40.6161635,
    "lng": -98.38022289999999
  },
  {
    "Store Location": "Tractor Supply 3417 SOUTH HOLEN AVENUE YORK, Nebraska 68467",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-362-2223",
    "address": "3417 SOUTH HOLEN AVENUE, YORK, Nebraska 68467",
    "city": "YORK",
    "state": "Nebraska",
    "zip": "68467",
    "lat": 40.8304113,
    "lng": -97.5949077
  },
  {
    "Store Location": "Tractor Supply 3620 AIR PARK RD BEATRICE, Nebraska 68310",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-223-2381",
    "address": "3620 AIR PARK RD, BEATRICE, Nebraska 68310",
    "city": "BEATRICE",
    "state": "Nebraska",
    "zip": "68310",
    "lat": 40.3027916,
    "lng": -96.74757799999999
  },
  {
    "Store Location": "Tractor Supply 3728 SOUTH JEFFERS ST NORTH PLATTE, Nebraska 69101",
    "Store Type": "Tractor Supply",
    "Phone Number": "308-532-2135",
    "address": "3728 SOUTH JEFFERS ST NORTH, PLATTE, Nebraska 69101",
    "city": "PLATTE",
    "state": "Nebraska",
    "zip": "69101",
    "lat": 41.1003509,
    "lng": -100.7656382
  },
  {
    "Store Location": "Tractor Supply 514 THIRD AVE KEARNEY, Nebraska 68845",
    "Store Type": "Tractor Supply",
    "Phone Number": "308-234-1861",
    "address": "514 THIRD AVE, KEARNEY, Nebraska 68845",
    "city": "KEARNEY",
    "state": "Nebraska",
    "zip": "68845",
    "lat": 40.679305,
    "lng": -99.086604
  },
  {
    "Store Location": "Tractor Supply 7300 HUSKER CIR LINCOLN, Nebraska 68504",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-476-2292",
    "address": "7300 HUSKER CIR, LINCOLN, Nebraska 68504",
    "city": "LINCOLN",
    "state": "Nebraska",
    "zip": "68504",
    "lat": 40.8850628,
    "lng": -96.6789502
  },
  {
    "Store Location": "Tractor Supply 7910 L ST OMAHA, Nebraska 68127",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-339-2800",
    "address": "7910 L ST, OMAHA, Nebraska 68127",
    "city": "OMAHA",
    "state": "Nebraska",
    "zip": "68127",
    "lat": 41.2134303,
    "lng": -96.0387672
  },
  {
    "Store Location": "Tractor Supply 9000 AMBER HILL CT LINCOLN, Nebraska 68526",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-420-0011",
    "address": "9000 AMBER HILL CT, LINCOLN, Nebraska 68526",
    "city": "LINCOLN",
    "state": "Nebraska",
    "zip": "68526",
    "lat": 40.7296886,
    "lng": -96.5977132
  },
  {
    "Store Location": "Tractor Supply 9531 NORTH 130TH ST WAVERLY, Nebraska 68462",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-786-3041",
    "address": "9531 NORTH 130TH ST, WAVERLY, Nebraska 68462",
    "city": "WAVERLY",
    "state": "Nebraska",
    "zip": "68462",
    "lat": 40.9049647,
    "lng": -96.5479847
  },
  {
    "Store Location": "Tractor Supply 9630 IDA ST OMAHA, Nebraska 68122",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-571-2575",
    "address": "9630 IDA ST, OMAHA, Nebraska 68122",
    "city": "OMAHA",
    "state": "Nebraska",
    "zip": "68122",
    "lat": 41.320491,
    "lng": -96.06469220000001
  },
  {
    "Store Location": "Tractor Supply 12 TWO ROD RD ROCHESTER, New Hampshire 3867",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-335-1200",
    "address": "12 TWO ROD RD ROCHESTER, New Hampshire 3867,  ",
    "city": "New Hampshire 3867",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.3372484,
    "lng": -71.0152174
  },
  {
    "Store Location": "Tractor Supply 1328 HOOKSETT RD UNIT 13C HOOKSETT, New Hampshire 3106",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-621-9837",
    "address": "1328 HOOKSETT RD UNIT 13C HOOKSETT, New Hampshire 3106,  ",
    "city": "New Hampshire 3106",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.055651,
    "lng": -71.4430169
  },
  {
    "Store Location": "Tractor Supply 134 BRIDGE ST PELHAM, New Hampshire 3076",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-635-5001",
    "address": "134 BRIDGE ST PELHAM, New Hampshire 3076,  ",
    "city": "New Hampshire 3076",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.7216034,
    "lng": -71.3182497
  },
  {
    "Store Location": "Tractor Supply 191 ELM ST UNIT 1 MILFORD, New Hampshire 3055",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-249-8910",
    "address": "191 ELM ST UNIT 1 MILFORD, New Hampshire 3055,  ",
    "city": "New Hampshire 3055",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.8392606,
    "lng": -71.6675206
  },
  {
    "Store Location": "Tractor Supply 21 COMMERCIAL LN UNIT 1 RINDGE, New Hampshire 3461",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-899-6863",
    "address": "21 COMMERCIAL LN UNIT 1 RINDGE, New Hampshire 3461,  ",
    "city": "New Hampshire 3461",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.74176310000001,
    "lng": -72.0356129
  },
  {
    "Store Location": "Tractor Supply 307 DOVER RD CHICHESTER, New Hampshire 3258",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-798-4424",
    "address": "307 DOVER RD CHICHESTER, New Hampshire 3258,  ",
    "city": "New Hampshire 3258",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.245097,
    "lng": -71.432476
  },
  {
    "Store Location": "Tractor Supply 360 MIRACLE MILE LEBANON, New Hampshire 3766",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-448-4411",
    "address": "360 MIRACLE MILE LEBANON, New Hampshire 3766,  ",
    "city": "New Hampshire 3766",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.63789209999999,
    "lng": -72.28790169999999
  },
  {
    "Store Location": "Tractor Supply 419 MAIN ST CLAREMONT, New Hampshire 3743",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-543-3303",
    "address": "419 MAIN ST CLAREMONT, New Hampshire 3743,  ",
    "city": "New Hampshire 3743",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.3870477,
    "lng": -72.35290700000002
  },
  {
    "Store Location": "Tractor Supply 437 RTE 125 BRENTWOOD, New Hampshire 3833",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-679-3270",
    "address": "437 RTE 125 BRENTWOOD, New Hampshire 3833,  ",
    "city": "New Hampshire 3833",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.014849,
    "lng": -71.0734547
  },
  {
    "Store Location": "Tractor Supply 467 WEST MAIN ST HILLSBOROUGH, New Hampshire 3244",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-478-5000",
    "address": "467 WEST MAIN ST HILLSBOROUGH, New Hampshire 3244,  ",
    "city": "New Hampshire 3244",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.1163138,
    "lng": -71.93404579999999
  },
  {
    "Store Location": "Tractor Supply 491 MAIN ST STE 8 GORHAM, New Hampshire 3581",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-752-5300",
    "address": "491 MAIN ST STE 8 GORHAM, New Hampshire 3581,  ",
    "city": "New Hampshire 3581",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.4156415,
    "lng": -71.1954061
  },
  {
    "Store Location": "Tractor Supply 515 DANIEL WEBSTER HWY STE A MERRIMACK, New Hampshire 3054",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-424-3300",
    "address": "515 DANIEL WEBSTER HWY STE A MERRIMACK, New Hampshire 3054,  ",
    "city": "New Hampshire 3054",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.87244,
    "lng": -71.48855999999999
  },
  {
    "Store Location": "Tractor Supply 55 CRYSTAL AVE UNIT 17A DERRY, New Hampshire 3038",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-421-9306",
    "address": "55 CRYSTAL AVE UNIT 17A DERRY, New Hampshire 3038,  ",
    "city": "New Hampshire 3038",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.8932501,
    "lng": -71.323844
  },
  {
    "Store Location": "Tractor Supply 630 WEST MAIN ST STE 900 TILTON, New Hampshire 3276",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-286-7800",
    "address": "630 WEST MAIN ST STE 900 TILTON, New Hampshire 3276,  ",
    "city": "New Hampshire 3276",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.4468842,
    "lng": -71.6199609
  },
  {
    "Store Location": "Tractor Supply 670 BRATTLEBORO RD HINSDALE, New Hampshire 3451",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-336-5274",
    "address": "670 BRATTLEBORO RD HINSDALE, New Hampshire 3451,  ",
    "city": "New Hampshire 3451",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.8084149,
    "lng": -72.5299126
  },
  {
    "Store Location": "Tractor Supply 685 MEADOW ST STE 2 LITTLETON, New Hampshire 3561",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-444-2093",
    "address": "685 MEADOW ST STE 2 LITTLETON, New Hampshire 3561,  ",
    "city": "New Hampshire 3561",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.3039535,
    "lng": -71.8032925
  },
  {
    "Store Location": "Tractor Supply 8 MARCH FARM WAY GREENLAND, New Hampshire 3840",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-334-9645",
    "address": "8 MARCH FARM WAY GREENLAND, New Hampshire 3840,  ",
    "city": "New Hampshire 3840",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.0413815,
    "lng": -70.820523
  },
  {
    "Store Location": "Tractor Supply 8 RED BARN LN WALPOLE, New Hampshire 3608",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-445-2615",
    "address": "8 RED BARN LN WALPOLE, New Hampshire 3608,  ",
    "city": "New Hampshire 3608",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.1112772,
    "lng": -72.42633579999999
  },
  {
    "Store Location": "Tractor Supply 85 BOULDER POINT DR PLYMOUTH, New Hampshire 3264",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-536-5009",
    "address": "85 BOULDER POINT DR PLYMOUTH, New Hampshire 3264,  ",
    "city": "New Hampshire 3264",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.7684698,
    "lng": -71.73831
  },
  {
    "Store Location": "Tractor Supply 901 RTE 16 OSSIPEE, New Hampshire 3864",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-539-2736",
    "address": "901 RTE 16 OSSIPEE, New Hampshire 3864,  ",
    "city": "New Hampshire 3864",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.7027896,
    "lng": -71.112428
  },
  {
    "Store Location": "Tractor Supply 96 PLAISTOW RD PLAISTOW, New Hampshire 3865",
    "Store Type": "Tractor Supply",
    "Phone Number": "603-382-2371",
    "address": "96 PLAISTOW RD PLAISTOW, New Hampshire 3865,  ",
    "city": "New Hampshire 3865",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.8349833,
    "lng": -71.1091083
  },
  {
    "Store Location": "Tractor Supply 113 WHEAT RD BUENA, New Jersey 8310",
    "Store Type": "Tractor Supply",
    "Phone Number": "856-697-1846",
    "address": "113 WHEAT RD BUENA, New Jersey 8310,  ",
    "city": "New Jersey 8310",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.511811,
    "lng": -74.92681499999999
  },
  {
    "Store Location": "Tractor Supply 128 STATE RTE 94 STE 9 BLAIRSTOWN, New Jersey 7825",
    "Store Type": "Tractor Supply",
    "Phone Number": "908-362-0082",
    "address": "128 STATE RTE 94 STE 9 BLAIRSTOWN, New Jersey 7825,  ",
    "city": "New Jersey 7825",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.9872863,
    "lng": -74.9828852
  },
  {
    "Store Location": "Tractor Supply 135 HAMPTON HOUSE RD NEWTON, New Jersey 7860",
    "Store Type": "Tractor Supply",
    "Phone Number": "973-940-0749",
    "address": "135 HAMPTON HOUSE RD NEWTON, New Jersey 7860,  ",
    "city": "New Jersey 7860",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.088367,
    "lng": -74.730986
  },
  {
    "Store Location": "Tractor Supply 144 HWY 202/31 NORTH RINGOES, New Jersey 8551",
    "Store Type": "Tractor Supply",
    "Phone Number": "908-284-2021",
    "address": "144 HWY 202/31 NORTH RINGOES, New Jersey 8551,  ",
    "city": "New Jersey 8551",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.4725706,
    "lng": -74.8608575
  },
  {
    "Store Location": "Tractor Supply 1515 SR 35 MIDDLETOWN, New Jersey 7748",
    "Store Type": "Tractor Supply",
    "Phone Number": "732-671-7770",
    "address": "1515 SR 35 MIDDLETOWN, New Jersey 7748,  ",
    "city": "New Jersey 7748",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.4050521,
    "lng": -74.12592289999999
  },
  {
    "Store Location": "Tractor Supply 1535 WEST PARK AVE TINTON FALLS, New Jersey 7712",
    "Store Type": "Tractor Supply",
    "Phone Number": "732-493-3377",
    "address": "1535 WEST PARK AVE TINTON FALLS, New Jersey 7712,  ",
    "city": "New Jersey 7712",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.2583698,
    "lng": -74.0894011
  },
  {
    "Store Location": "Tractor Supply 1586 CENTER SQUARE ROAD LOGAN TOWNSHIP, New Jersey 8085",
    "Store Type": "Tractor Supply",
    "Phone Number": "856-467-8484",
    "address": "1586 CENTER SQUARE ROAD LOGAN TOWNSHIP, New Jersey 8085,  ",
    "city": "New Jersey 8085",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.7530735,
    "lng": -75.35491809999999
  },
  {
    "Store Location": "Tractor Supply 1869 RTE 38 SOUTHAMPTON, New Jersey 8088",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-702-9953",
    "address": "1869 RTE 38 SOUTHAMPTON, New Jersey 8088,  ",
    "city": "New Jersey 8088",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.9755281,
    "lng": -74.7500744
  },
  {
    "Store Location": "Tractor Supply 1926 UNION VALLEY RD HEWITT, New Jersey 7421",
    "Store Type": "Tractor Supply",
    "Phone Number": "973-728-2020",
    "address": "1926 UNION VALLEY RD HEWITT, New Jersey 7421,  ",
    "city": "New Jersey 7421",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.1530301,
    "lng": -74.3537987
  },
  {
    "Store Location": "Tractor Supply 256 US HWY 206 STE 13 HILLSBOROUGH, New Jersey 8844",
    "Store Type": "Tractor Supply",
    "Phone Number": "908-431-0539",
    "address": "256 US HWY 206 STE 13 HILLSBOROUGH, New Jersey 8844,  ",
    "city": "New Jersey 8844",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.5242861,
    "lng": -74.6286519
  },
  {
    "Store Location": "Tractor Supply 293 US HWY 206 UNIT 15A FLANDERS, New Jersey 7836",
    "Store Type": "Tractor Supply",
    "Phone Number": "973-252-2925",
    "address": "293 US HWY 206 UNIT 15A FLANDERS, New Jersey 7836,  ",
    "city": "New Jersey 7836",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.8311411,
    "lng": -74.7070948
  },
  {
    "Store Location": "Tractor Supply 3 GATEWAY BLVD MONROE TOWNSHIP, New Jersey 8831",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-448-4444",
    "address": "3 GATEWAY BLVD MONROE TOWNSHIP, New Jersey 8831,  ",
    "city": "New Jersey 8831",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.2689612,
    "lng": -74.4728902
  },
  {
    "Store Location": "Tractor Supply 3095 SOUTH DELSEA DR VINELAND, New Jersey 8360",
    "Store Type": "Tractor Supply",
    "Phone Number": "856-691-3101",
    "address": "3095 SOUTH DELSEA DR VINELAND, New Jersey 8360,  ",
    "city": "New Jersey 8360",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.4418521,
    "lng": -75.0402952
  },
  {
    "Store Location": "Tractor Supply 3801 ROUTE 9 S STE 1 RIO GRANDE, New Jersey 8242",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-886-1101",
    "address": "3801 ROUTE 9 S STE 1 RIO GRANDE, New Jersey 8242,  ",
    "city": "New Jersey 8242",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.014687,
    "lng": -74.875496
  },
  {
    "Store Location": "Tractor Supply 398 RTE 57 WEST 4 WASHINGTON, New Jersey 7882",
    "Store Type": "Tractor Supply",
    "Phone Number": "908-689-3202",
    "address": "398 RTE 57 WEST 4 WASHINGTON, New Jersey 7882,  ",
    "city": "New Jersey 7882",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.7524476,
    "lng": -75.00616629999999
  },
  {
    "Store Location": "Tractor Supply 48 CORNWELL DR BRIDGETON, New Jersey 8302",
    "Store Type": "Tractor Supply",
    "Phone Number": "856-455-3944",
    "address": "48 CORNWELL DR BRIDGETON, New Jersey 8302,  ",
    "city": "New Jersey 8302",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.4625593,
    "lng": -75.2113497
  },
  {
    "Store Location": "Tractor Supply 599 RTE 9 WARETOWN, New Jersey 8758",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-693-3030",
    "address": "599 RTE 9 WARETOWN, New Jersey 8758,  ",
    "city": "New Jersey 8758",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.807929,
    "lng": -74.2003134
  },
  {
    "Store Location": "Tractor Supply 630 RTE 9 SOUTH LITTLE EGG HARBOR, New Jersey 8087",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-296-0645",
    "address": "630 RTE 9 SOUTH LITTLE EGG HARBOR, New Jersey 8087,  ",
    "city": "New Jersey 8087",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.6008404,
    "lng": -74.3635247
  },
  {
    "Store Location": "Tractor Supply 643 CROSS KEYS RD SICKLERVILLE, New Jersey 8081",
    "Store Type": "Tractor Supply",
    "Phone Number": "856-728-3434",
    "address": "643 CROSS KEYS RD SICKLERVILLE, New Jersey 8081,  ",
    "city": "New Jersey 8081",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.7311136,
    "lng": -75.01233789999999
  },
  {
    "Store Location": "Tractor Supply 6501 BLACK HORSE PIKE EGG HARBOR TOWNSHIP, New Jersey 8234",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-646-2222",
    "address": "6501 BLACK HORSE PIKE EGG HARBOR TOWNSHIP, New Jersey 8234,  ",
    "city": "New Jersey 8234",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.4209923,
    "lng": -74.5881127
  },
  {
    "Store Location": "Tractor Supply 70 RTE 206 HAMMONTON, New Jersey 8037",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-561-1122",
    "address": "70 RTE 206 HAMMONTON, New Jersey 8037,  ",
    "city": "New Jersey 8037",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.6526894,
    "lng": -74.78463289999999
  },
  {
    "Store Location": "Tractor Supply 701 RTE 524 ALLENTOWN, New Jersey 8501",
    "Store Type": "Tractor Supply",
    "Phone Number": "609-259-4970",
    "address": "701 RTE 524 ALLENTOWN, New Jersey 8501,  ",
    "city": "New Jersey 8501",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.1807719,
    "lng": -74.5129117
  },
  {
    "Store Location": "Tractor Supply 775 RTE 23 SUSSEX, New Jersey 7461",
    "Store Type": "Tractor Supply",
    "Phone Number": "973-875-7087",
    "address": "775 RTE 23 SUSSEX, New Jersey 7461,  ",
    "city": "New Jersey 7461",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.2256207,
    "lng": -74.6135537
  },
  {
    "Store Location": "Tractor Supply 862 RTE 45 PILESGROVE, New Jersey 8098",
    "Store Type": "Tractor Supply",
    "Phone Number": "856-769-7284",
    "address": "862 RTE 45 PILESGROVE, New Jersey 8098,  ",
    "city": "New Jersey 8098",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.644093,
    "lng": -75.3391803
  },
  {
    "Store Location": "Tractor Supply 101 YORK CANYON RD RATON, New Mexico 87740",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-445-2018",
    "address": "101 YORK CANYON RD, RATON, New Mexico 87740",
    "city": "RATON",
    "state": "New Mexico",
    "zip": "87740",
    "lat": 36.8666116,
    "lng": -104.4415483
  },
  {
    "Store Location": "Tractor Supply 1100 STATE ROAD 1 SOCORRO, New Mexico 87801",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-838-0000",
    "address": "1100 STATE ROAD 1, SOCORRO, New Mexico 87801",
    "city": "SOCORRO",
    "state": "New Mexico",
    "zip": "87801",
    "lat": 34.0435246,
    "lng": -106.8923778
  },
  {
    "Store Location": "Tractor Supply 1308A METRO AVE GALLUP, New Mexico 87301",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-863-4190",
    "address": "1308A METRO AVE, GALLUP, New Mexico 87301",
    "city": "GALLUP",
    "state": "New Mexico",
    "zip": "87301",
    "lat": 35.5351954,
    "lng": -108.7613029
  },
  {
    "Store Location": "Tractor Supply 1401 EAST RTE 66 BLVD TUCUMCARI, New Mexico 88401",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-461-4883",
    "address": "1401 EAST RTE 66 BLVD, TUCUMCARI, New Mexico 88401",
    "city": "TUCUMCARI",
    "state": "New Mexico",
    "zip": "88401",
    "lat": 35.1725,
    "lng": -103.7092785
  },
  {
    "Store Location": "Tractor Supply 141 SOUTH BROWNING PKWY FARMINGTON, New Mexico 87401",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-327-4726",
    "address": "141 SOUTH BROWNING PKWY, FARMINGTON, New Mexico 87401",
    "city": "FARMINGTON",
    "state": "New Mexico",
    "zip": "87401",
    "lat": 36.7261575,
    "lng": -108.1605904
  },
  {
    "Store Location": "Tractor Supply 1440 WEST PICACHO AVE LAS CRUCES, New Mexico 88005",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-526-4200",
    "address": "1440 WEST PICACHO AVE LAS, CRUCES, New Mexico 88005",
    "city": "CRUCES",
    "state": "New Mexico",
    "zip": "88005",
    "lat": 32.3129993,
    "lng": -106.7982242
  },
  {
    "Store Location": "Tractor Supply 201 EAST NAVAJO DR HOBBS, New Mexico 88240",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-392-8910",
    "address": "201 EAST NAVAJO DR, HOBBS, New Mexico 88240",
    "city": "HOBBS",
    "state": "New Mexico",
    "zip": "88240",
    "lat": 32.7394153,
    "lng": -103.1352768
  },
  {
    "Store Location": "Tractor Supply 2707 HWY 180 EAST SILVER CITY, New Mexico 88061",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-534-9634",
    "address": "2707 HWY 180 EAST SILVER, CITY, New Mexico 88061",
    "city": "CITY",
    "state": "New Mexico",
    "zip": "88061",
    "lat": 32.7881832,
    "lng": -108.2449284
  },
  {
    "Store Location": "Tractor Supply 2793 NORTH 1ST STREET ARTESIA, New Mexico 88210",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-748-8811",
    "address": "2793 NORTH 1ST STREET, ARTESIA, New Mexico 88210",
    "city": "ARTESIA",
    "state": "New Mexico",
    "zip": "88210",
    "lat": 32.8709147,
    "lng": -104.4014602
  },
  {
    "Store Location": "Tractor Supply 29 NM HWY 518 LAS VEGAS, New Mexico 87701",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-454-1560",
    "address": "29 NM HWY 518 LAS, VEGAS, New Mexico 87701",
    "city": "VEGAS",
    "state": "New Mexico",
    "zip": "87701",
    "lat": 35.6302353,
    "lng": -105.2273911
  },
  {
    "Store Location": "Tractor Supply 2900 NORTH WHITE SANDS BLVD ALAMOGORDO, New Mexico 88310",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-434-5766",
    "address": "2900 NORTH WHITE SANDS BLVD, ALAMOGORDO, New Mexico 88310",
    "city": "ALAMOGORDO",
    "state": "New Mexico",
    "zip": "88310",
    "lat": 32.9253865,
    "lng": -105.959548
  },
  {
    "Store Location": "Tractor Supply 300 WEST HWY 550 BERNALILLO, New Mexico 87004",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-771-0168",
    "address": "300 WEST HWY 550, BERNALILLO, New Mexico 87004",
    "city": "BERNALILLO",
    "state": "New Mexico",
    "zip": "87004",
    "lat": 35.32079,
    "lng": -106.5491295
  },
  {
    "Store Location": "Tractor Supply 3127 NATIONAL PARKS HWY STE A CARLSBAD, New Mexico 88220",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-628-0002",
    "address": "3127 NATIONAL PARKS HWY STE A, CARLSBAD, New Mexico 88220",
    "city": "CARLSBAD",
    "state": "New Mexico",
    "zip": "88220",
    "lat": 32.386006,
    "lng": -104.2233348
  },
  {
    "Store Location": "Tractor Supply 3901 OLIVER RD SANTA FE, New Mexico 87507",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-471-9160",
    "address": "3901 OLIVER RD SANTA, FE, New Mexico 87507",
    "city": "FE",
    "state": "New Mexico",
    "zip": "87507",
    "lat": 35.6335029,
    "lng": -106.0669196
  },
  {
    "Store Location": "Tractor Supply 414 EAST PINE ST DEMING, New Mexico 88030",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-546-4016",
    "address": "414 EAST PINE ST, DEMING, New Mexico 88030",
    "city": "DEMING",
    "state": "New Mexico",
    "zip": "88030",
    "lat": 32.2684748,
    "lng": -107.7540439
  },
  {
    "Store Location": "Tractor Supply 4724 NORTH PRINCE ST CLOVIS, New Mexico 88101",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-763-3100",
    "address": "4724 NORTH PRINCE ST, CLOVIS, New Mexico 88101",
    "city": "CLOVIS",
    "state": "New Mexico",
    "zip": "88101",
    "lat": 34.445869,
    "lng": -103.1975573
  },
  {
    "Store Location": "Tractor Supply 49 I-25 BYPASS BELEN, New Mexico 87002",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-864-6449",
    "address": "49 I-25 BYPASS, BELEN, New Mexico 87002",
    "city": "BELEN",
    "state": "New Mexico",
    "zip": "87002",
    "lat": 34.6980679,
    "lng": -106.7735003
  },
  {
    "Store Location": "Tractor Supply 499 S BROADWAY ST TRUTH OR CONSEQUENCES, New Mexico 87901",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-894-2621",
    "address": "499 S BROADWAY ST TRUTH OR, CONSEQUENCES, New Mexico 87901",
    "city": "CONSEQUENCES",
    "state": "New Mexico",
    "zip": "87901",
    "lat": 33.1280393,
    "lng": -107.2610599
  },
  {
    "Store Location": "Tractor Supply 5 MARIETTA CT EDGEWOOD, New Mexico 87015",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-281-8845",
    "address": "5 MARIETTA CT, EDGEWOOD, New Mexico 87015",
    "city": "EDGEWOOD",
    "state": "New Mexico",
    "zip": "87015",
    "lat": 35.0661423,
    "lng": -106.2005146
  },
  {
    "Store Location": "Tractor Supply 5000 NORTH MAIN ST ROSWELL, New Mexico 88201",
    "Store Type": "Tractor Supply",
    "Phone Number": "575-622-1960",
    "address": "5000 NORTH MAIN ST, ROSWELL, New Mexico 88201",
    "city": "ROSWELL",
    "state": "New Mexico",
    "zip": "88201",
    "lat": 33.4568595,
    "lng": -104.5244896
  },
  {
    "Store Location": "Tractor Supply 8100 2ND ST NORTHWEST ALBUQUERQUE, New Mexico 87114",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-897-6800",
    "address": "8100 2ND ST NORTHWEST, ALBUQUERQUE, New Mexico 87114",
    "city": "ALBUQUERQUE",
    "state": "New Mexico",
    "zip": "87114",
    "lat": 35.1719573,
    "lng": -106.6256092
  },
  {
    "Store Location": "Tractor Supply 890 BOSQUE FARMS BLVD BOSQUE FARMS, New Mexico 87068",
    "Store Type": "Tractor Supply",
    "Phone Number": "505-869-9430",
    "address": "890 BOSQUE FARMS BLVD BOSQUE, FARMS, New Mexico 87068",
    "city": "FARMS",
    "state": "New Mexico",
    "zip": "87068",
    "lat": 34.8614949,
    "lng": -106.6897352
  },
  {
    "Store Location": "Tractor Supply 1645 HWY 88 MINDEN, Nevada 89423",
    "Store Type": "Tractor Supply",
    "Phone Number": "775-783-8675",
    "address": "1645 HWY 88, MINDEN, Nevada 89423",
    "city": "MINDEN",
    "state": "Nevada",
    "zip": "89423",
    "lat": 38.957509,
    "lng": -119.7779096
  },
  {
    "Store Location": "Tractor Supply 2035 EAST WILLIAM ST CARSON CITY, Nevada 89701",
    "Store Type": "Tractor Supply",
    "Phone Number": "775-841-6421",
    "address": "2035 EAST WILLIAM ST CARSON, CITY, Nevada 89701",
    "city": "CITY",
    "state": "Nevada",
    "zip": "89701",
    "lat": 39.1722851,
    "lng": -119.7454732
  },
  {
    "Store Location": "Tractor Supply 451 EAST PRATER WAY SPARKS, Nevada 89431",
    "Store Type": "Tractor Supply",
    "Phone Number": "775-356-3595",
    "address": "451 EAST PRATER WAY, SPARKS, Nevada 89431",
    "city": "SPARKS",
    "state": "Nevada",
    "zip": "89431",
    "lat": 39.540623,
    "lng": -119.738075
  },
  {
    "Store Location": "Tractor Supply 900 EAST NEVADA HWY 372 PAHRUMP, Nevada 89048",
    "Store Type": "Tractor Supply",
    "Phone Number": "775-727-1500",
    "address": "900 EAST NEVADA HWY 372, PAHRUMP, Nevada 89048",
    "city": "PAHRUMP",
    "state": "Nevada",
    "zip": "89048",
    "lat": 36.1948228,
    "lng": -116.0521009
  },
  {
    "Store Location": "Tractor Supply 1010 MADISON MARKETPLACE HAMILTON, New York 13346",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-824-0146",
    "address": "1010 MADISON MARKETPLACE, HAMILTON, New York 13346",
    "city": "HAMILTON",
    "state": "New York",
    "zip": "13346",
    "lat": 42.841953,
    "lng": -75.5525335
  },
  {
    "Store Location": "Tractor Supply 1020 CENTER ST HORSEHEADS, New York 14845",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-739-6380",
    "address": "1020 CENTER ST, HORSEHEADS, New York 14845",
    "city": "HORSEHEADS",
    "state": "New York",
    "zip": "14845",
    "lat": 42.1576949,
    "lng": -76.8280379
  },
  {
    "Store Location": "Tractor Supply 105 HARTE HAVEN PLZ MASSENA, New York 13662",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-764-4071",
    "address": "105 HARTE HAVEN PLZ, MASSENA, New York 13662",
    "city": "MASSENA",
    "state": "New York",
    "zip": "13662",
    "lat": 44.92072049999999,
    "lng": -74.8851011
  },
  {
    "Store Location": "Tractor Supply 1051 PARK ST OGDENSBURG, New York 13669",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-393-8323",
    "address": "1051 PARK ST, OGDENSBURG, New York 13669",
    "city": "OGDENSBURG",
    "state": "New York",
    "zip": "13669",
    "lat": 44.6938701,
    "lng": -75.47425849999999
  },
  {
    "Store Location": "Tractor Supply 1073 NYS ROUTE 86 RAY BROOK, New York 12977",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-891-2637",
    "address": "1073 NYS ROUTE 86 RAY, BROOK, New York 12977",
    "city": "BROOK",
    "state": "New York",
    "zip": "12977",
    "lat": 44.30050300000001,
    "lng": -74.083565
  },
  {
    "Store Location": "Tractor Supply 10838 Main St NORTH COLLINS, New York 14111",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-337-3377",
    "address": "10838 Main St NORTH, COLLINS, New York 14111",
    "city": "COLLINS",
    "state": "New York",
    "zip": "14111",
    "lat": 42.58688,
    "lng": -78.94167
  },
  {
    "Store Location": "Tractor Supply 11181 MAPLE RIDGE RD MEDINA, New York 14103",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-798-9932",
    "address": "11181 MAPLE RIDGE RD, MEDINA, New York 14103",
    "city": "MEDINA",
    "state": "New York",
    "zip": "14103",
    "lat": 43.2082041,
    "lng": -78.40173039999999
  },
  {
    "Store Location": "Tractor Supply 1125 ARSENAL ST WATERTOWN, New York 13601",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-779-1309",
    "address": "1125 ARSENAL ST, WATERTOWN, New York 13601",
    "city": "WATERTOWN",
    "state": "New York",
    "zip": "13601",
    "lat": 43.9754608,
    "lng": -75.9399734
  },
  {
    "Store Location": "Tractor Supply 11605 ROUTE 32 GREENVILLE, New York 12083",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-966-5559",
    "address": "11605 ROUTE 32, GREENVILLE, New York 12083",
    "city": "GREENVILLE",
    "state": "New York",
    "zip": "12083",
    "lat": 42.4301009,
    "lng": -74.0189913
  },
  {
    "Store Location": "Tractor Supply 1169 UPPER FRONT ST BINGHAMTON, New York 13905",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-722-2002",
    "address": "1169 UPPER FRONT ST, BINGHAMTON, New York 13905",
    "city": "BINGHAMTON",
    "state": "New York",
    "zip": "13905",
    "lat": 42.1525498,
    "lng": -75.8989682
  },
  {
    "Store Location": "Tractor Supply 1175 STATE RTE 29 GREENWICH, New York 12834",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-692-2317",
    "address": "1175 STATE RTE 29, GREENWICH, New York 12834",
    "city": "GREENWICH",
    "state": "New York",
    "zip": "12834",
    "lat": 43.1020014,
    "lng": -73.5129371
  },
  {
    "Store Location": "Tractor Supply 1183 ERIE BLVD WEST ROME, New York 13440",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-337-2710",
    "address": "1183 ERIE BLVD WEST, ROME, New York 13440",
    "city": "ROME",
    "state": "New York",
    "zip": "13440",
    "lat": 43.2251447,
    "lng": -75.4881908
  },
  {
    "Store Location": "Tractor Supply 125 PLAZA LN STE 2 COBLESKILL, New York 12043",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-234-1967",
    "address": "125 PLAZA LN STE 2, COBLESKILL, New York 12043",
    "city": "COBLESKILL",
    "state": "New York",
    "zip": "12043",
    "lat": 42.6826335,
    "lng": -74.4698392
  },
  {
    "Store Location": "Tractor Supply 1253 RTE 311 PATTERSON, New York 12563",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-878-7215",
    "address": "1253 RTE 311, PATTERSON, New York 12563",
    "city": "PATTERSON",
    "state": "New York",
    "zip": "12563",
    "lat": 41.5132139,
    "lng": -73.5937266
  },
  {
    "Store Location": "Tractor Supply 127 TEMPLE HILL ROAD NEW WINDSOR, New York 12553",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-565-4690",
    "address": "127 TEMPLE HILL ROAD NEW, WINDSOR, New York 12553",
    "city": "WINDSOR",
    "state": "New York",
    "zip": "12553",
    "lat": 41.4561808,
    "lng": -74.06009279999999
  },
  {
    "Store Location": "Tractor Supply 13059 BROADWAY ST ALDEN, New York 14004",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-937-6106",
    "address": "13059 BROADWAY ST, ALDEN, New York 14004",
    "city": "ALDEN",
    "state": "New York",
    "zip": "14004",
    "lat": 42.8977266,
    "lng": -78.4999826
  },
  {
    "Store Location": "Tractor Supply 154 VESTAL PKWY WEST VESTAL, New York 13850",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-658-9164",
    "address": "154 VESTAL PKWY WEST, VESTAL, New York 13850",
    "city": "VESTAL",
    "state": "New York",
    "zip": "13850",
    "lat": 42.0864978,
    "lng": -76.056626
  },
  {
    "Store Location": "Tractor Supply 158 MAIN STREET BOONVILLE, New York 13309",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-942-4050",
    "address": "158 MAIN STREET, BOONVILLE, New York 13309",
    "city": "BOONVILLE",
    "state": "New York",
    "zip": "13309",
    "lat": 43.4838049,
    "lng": -75.3325634
  },
  {
    "Store Location": "Tractor Supply 158 SOUTH LIBERTY DR STONY POINT, New York 10980",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-429-2478",
    "address": "158 SOUTH LIBERTY DR STONY, POINT, New York 10980",
    "city": "POINT",
    "state": "New York",
    "zip": "10980",
    "lat": 41.2177887,
    "lng": -73.9849313
  },
  {
    "Store Location": "Tractor Supply 1611 ULSTER AVE LAKE KATRINE, New York 12449",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-336-5038",
    "address": "1611 ULSTER AVE LAKE, KATRINE, New York 12449",
    "city": "KATRINE",
    "state": "New York",
    "zip": "12449",
    "lat": 41.9787267,
    "lng": -73.9904407
  },
  {
    "Store Location": "Tractor Supply 1649 COLUMBIA TPKE CASTLETON, New York 12033",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-477-6293",
    "address": "1649 COLUMBIA TPKE, CASTLETON, New York 12033",
    "city": "CASTLETON",
    "state": "New York",
    "zip": "12033",
    "lat": 42.5659699,
    "lng": -73.6815518
  },
  {
    "Store Location": "Tractor Supply 174 DELAWARE AVE SIDNEY, New York 13838",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-563-1009",
    "address": "174 DELAWARE AVE, SIDNEY, New York 13838",
    "city": "SIDNEY",
    "state": "New York",
    "zip": "13838",
    "lat": 42.2981776,
    "lng": -75.413237
  },
  {
    "Store Location": "Tractor Supply 1746 RTE 9 CLIFTON PARK, New York 12065",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-348-1925",
    "address": "1746 RTE 9 CLIFTON, PARK, New York 12065",
    "city": "PARK",
    "state": "New York",
    "zip": "12065",
    "lat": 42.8709664,
    "lng": -73.7755971
  },
  {
    "Store Location": "Tractor Supply 18 PARK DR HORNELL, New York 14843",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-324-9434",
    "address": "18 PARK DR, HORNELL, New York 14843",
    "city": "HORNELL",
    "state": "New York",
    "zip": "14843",
    "lat": 42.3197096,
    "lng": -77.658242
  },
  {
    "Store Location": "Tractor Supply 1900 CONSTITUTION AVE OLEAN, New York 14760",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-372-1052",
    "address": "1900 CONSTITUTION AVE, OLEAN, New York 14760",
    "city": "OLEAN",
    "state": "New York",
    "zip": "14760",
    "lat": 42.0839181,
    "lng": -78.45349379999999
  },
  {
    "Store Location": "Tractor Supply 1939 STATE RTE 52 STE 1 LIBERTY, New York 12754",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-292-0712",
    "address": "1939 STATE RTE 52 STE 1, LIBERTY, New York 12754",
    "city": "LIBERTY",
    "state": "New York",
    "zip": "12754",
    "lat": 41.782623,
    "lng": -74.71911229999999
  },
  {
    "Store Location": "Tractor Supply 201 EAST FAIRMOUNT LAKEWOOD, New York 14750",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-763-0495",
    "address": "201 EAST FAIRMOUNT, LAKEWOOD, New York 14750",
    "city": "LAKEWOOD",
    "state": "New York",
    "zip": "14750",
    "lat": 42.0990143,
    "lng": -79.3121381
  },
  {
    "Store Location": "Tractor Supply 2019 UPPER LENOX AVE ONEIDA, New York 13421",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-363-0860",
    "address": "2019 UPPER LENOX AVE, ONEIDA, New York 13421",
    "city": "ONEIDA",
    "state": "New York",
    "zip": "13421",
    "lat": 43.0754475,
    "lng": -75.69062799999999
  },
  {
    "Store Location": "Tractor Supply 205 SOUTH CASCADE DR SPRINGVILLE, New York 14141",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-592-7171",
    "address": "205 SOUTH CASCADE DR, SPRINGVILLE, New York 14141",
    "city": "SPRINGVILLE",
    "state": "New York",
    "zip": "14141",
    "lat": 42.5039014,
    "lng": -78.6913694
  },
  {
    "Store Location": "Tractor Supply 21 Nichols Ave WESTFIELD, New York 14787",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-326-2024",
    "address": "21 Nichols Ave, WESTFIELD, New York 14787",
    "city": "WESTFIELD",
    "state": "New York",
    "zip": "14787",
    "lat": 42.3344779,
    "lng": -79.5862052
  },
  {
    "Store Location": "Tractor Supply 2109 RTE 5 AND 20 UNIT 16 SENECA FALLS, New York 13148",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-568-4615",
    "address": "2109 RTE 5 AND 20 UNIT 16 SENECA, FALLS, New York 13148",
    "city": "FALLS",
    "state": "New York",
    "zip": "13148",
    "lat": 42.9059731,
    "lng": -76.8255781
  },
  {
    "Store Location": "Tractor Supply 2327 WESTERN AVE GUILDERLAND, New York 12084",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-456-0404",
    "address": "2327 WESTERN AVE, GUILDERLAND, New York 12084",
    "city": "GUILDERLAND",
    "state": "New York",
    "zip": "12084",
    "lat": 42.7071688,
    "lng": -73.91768569999999
  },
  {
    "Store Location": "Tractor Supply 2380 ROCHESTER RD RTE 332 NORTH CANANDAIGUA, New York 14424",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-394-2080",
    "address": "2380 ROCHESTER RD RTE 332 NORTH, CANANDAIGUA, New York 14424",
    "city": "CANANDAIGUA",
    "state": "New York",
    "zip": "14424",
    "lat": 42.91567,
    "lng": -77.30399229999999
  },
  {
    "Store Location": "Tractor Supply 2391 STATE ROUTE 14 A PENN YAN, New York 14527",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-536-5656",
    "address": "2391 STATE ROUTE 14 A PENN, YAN, New York 14527",
    "city": "YAN",
    "state": "New York",
    "zip": "14527",
    "lat": 42.6469,
    "lng": -76.94261139999999
  },
  {
    "Store Location": "Tractor Supply 2401 STATE RTE 52 PINE BUSH, New York 12566",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-744-8109",
    "address": "2401 STATE RTE 52 PINE, BUSH, New York 12566",
    "city": "BUSH",
    "state": "New York",
    "zip": "12566",
    "lat": 41.6013266,
    "lng": -74.2925269
  },
  {
    "Store Location": "Tractor Supply 27 ARTERIAL PLZ GLOVERSVILLE, New York 12078",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-725-0036",
    "address": "27 ARTERIAL PLZ, GLOVERSVILLE, New York 12078",
    "city": "GLOVERSVILLE",
    "state": "New York",
    "zip": "12078",
    "lat": 43.0574992,
    "lng": -74.3252954
  },
  {
    "Store Location": "Tractor Supply 280 STATE RTE 31 MACEDON, New York 14502",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-986-1041",
    "address": "280 STATE RTE 31, MACEDON, New York 14502",
    "city": "MACEDON",
    "state": "New York",
    "zip": "14502",
    "lat": 43.0635559,
    "lng": -77.36279909999999
  },
  {
    "Store Location": "Tractor Supply 29 DELLA DR PLATTSBURGH, New York 12901",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-562-2913",
    "address": "29 DELLA DR, PLATTSBURGH, New York 12901",
    "city": "PLATTSBURGH",
    "state": "New York",
    "zip": "12901",
    "lat": 44.6968362,
    "lng": -73.5172104
  },
  {
    "Store Location": "Tractor Supply 293 STATE RTE 104 OSWEGO, New York 13126",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-342-7100",
    "address": "293 STATE RTE 104, OSWEGO, New York 13126",
    "city": "OSWEGO",
    "state": "New York",
    "zip": "13126",
    "lat": 43.46335000000001,
    "lng": -76.4826463
  },
  {
    "Store Location": "Tractor Supply 295 OLD RT 209 NAPANOCH, New York 12458",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-647-7744",
    "address": "295 OLD RT 209, NAPANOCH, New York 12458",
    "city": "NAPANOCH",
    "state": "New York",
    "zip": "12458",
    "lat": 41.7469604,
    "lng": -74.3665366
  },
  {
    "Store Location": "Tractor Supply 3060 EAST AVE CENTRAL SQUARE, New York 13036",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-676-2142",
    "address": "3060 EAST AVE CENTRAL, SQUARE, New York 13036",
    "city": "SQUARE",
    "state": "New York",
    "zip": "13036",
    "lat": 43.2880273,
    "lng": -76.1321454
  },
  {
    "Store Location": "Tractor Supply 3148 SILVERBACK LN PAINTED POST, New York 14870",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-962-2606",
    "address": "3148 SILVERBACK LN PAINTED, POST, New York 14870",
    "city": "POST",
    "state": "New York",
    "zip": "14870",
    "lat": 42.1551724,
    "lng": -77.1027902
  },
  {
    "Store Location": "Tractor Supply 3170 ROUTE 112 MEDFORD, New York 11763",
    "Store Type": "Tractor Supply",
    "Phone Number": "631-732-2121",
    "address": "3170 ROUTE 112, MEDFORD, New York 11763",
    "city": "MEDFORD",
    "state": "New York",
    "zip": "11763",
    "lat": 40.8381908,
    "lng": -72.99698219999999
  },
  {
    "Store Location": "Tractor Supply 3184 STATE RTE 11 MALONE, New York 12953",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-483-6280",
    "address": "3184 STATE RTE 11, MALONE, New York 12953",
    "city": "MALONE",
    "state": "New York",
    "zip": "12953",
    "lat": 44.8461171,
    "lng": -74.3319507
  },
  {
    "Store Location": "Tractor Supply 329 GLENMONT RD SUITE 14 GLENMONT, New York 12077",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-434-0205",
    "address": "329 GLENMONT RD SUITE 14, GLENMONT, New York 12077",
    "city": "GLENMONT",
    "state": "New York",
    "zip": "12077",
    "lat": 42.6011674,
    "lng": -73.7890086
  },
  {
    "Store Location": "Tractor Supply 3356 CALEDONIA AVON ROAD CALEDONIA, New York 14423",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-538-6568",
    "address": "3356 CALEDONIA AVON ROAD, CALEDONIA, New York 14423",
    "city": "CALEDONIA",
    "state": "New York",
    "zip": "14423",
    "lat": 42.9644099,
    "lng": -77.84525400000001
  },
  {
    "Store Location": "Tractor Supply 345 WEST MAIN ST HONEOYE FALLS, New York 14472",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-624-8308",
    "address": "345 WEST MAIN ST HONEOYE, FALLS, New York 14472",
    "city": "FALLS",
    "state": "New York",
    "zip": "14472",
    "lat": 42.9491065,
    "lng": -77.605505
  },
  {
    "Store Location": "Tractor Supply 350 FAIRVIEW AVE STE 140 HUDSON, New York 12534",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-828-5710",
    "address": "350 FAIRVIEW AVE STE 140, HUDSON, New York 12534",
    "city": "HUDSON",
    "state": "New York",
    "zip": "12534",
    "lat": 42.2711868,
    "lng": -73.75935729999999
  },
  {
    "Store Location": "Tractor Supply 3580 RTE 31 BALDWINSVILLE, New York 13027",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-652-5885",
    "address": "3580 RTE 31, BALDWINSVILLE, New York 13027",
    "city": "BALDWINSVILLE",
    "state": "New York",
    "zip": "13027",
    "lat": 43.1780048,
    "lng": -76.262816
  },
  {
    "Store Location": "Tractor Supply 360 GRANT AVE GRANT AUBURN PLZ AUBURN, New York 13021",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-252-9059",
    "address": "360 GRANT AVE GRANT AUBURN PLZ, AUBURN, New York 13021",
    "city": "AUBURN",
    "state": "New York",
    "zip": "13021",
    "lat": 42.96304140000001,
    "lng": -76.5384253
  },
  {
    "Store Location": "Tractor Supply 3650 US HWY 9 WEST HIGHLAND, New York 12528",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-691-4950",
    "address": "3650 US HWY 9 WEST, HIGHLAND, New York 12528",
    "city": "HIGHLAND",
    "state": "New York",
    "zip": "12528",
    "lat": 41.7384717,
    "lng": -73.9296493
  },
  {
    "Store Location": "Tractor Supply 3779 ROME RD PULASKI, New York 13142",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-298-1189",
    "address": "3779 ROME RD, PULASKI, New York 13142",
    "city": "PULASKI",
    "state": "New York",
    "zip": "13142",
    "lat": 43.5549279,
    "lng": -76.1154706
  },
  {
    "Store Location": "Tractor Supply 378 ELMIRA RD ITHACA, New York 14850",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-277-0168",
    "address": "378 ELMIRA RD, ITHACA, New York 14850",
    "city": "ITHACA",
    "state": "New York",
    "zip": "14850",
    "lat": 42.4212441,
    "lng": -76.51965849999999
  },
  {
    "Store Location": "Tractor Supply 378 MAIN ST STE 1 ARCADE, New York 14009",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-492-1317",
    "address": "378 MAIN ST STE 1, ARCADE, New York 14009",
    "city": "ARCADE",
    "state": "New York",
    "zip": "14009",
    "lat": 42.53064,
    "lng": -78.45818
  },
  {
    "Store Location": "Tractor Supply 3978 VINEYARD DR DUNKIRK, New York 14048",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-363-7697",
    "address": "3978 VINEYARD DR, DUNKIRK, New York 14048",
    "city": "DUNKIRK",
    "state": "New York",
    "zip": "14048",
    "lat": 42.4595421,
    "lng": -79.3204135
  },
  {
    "Store Location": "Tractor Supply 404 WEST MORRIS ST BATH, New York 14810",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-664-1222",
    "address": "404 WEST MORRIS ST, BATH, New York 14810",
    "city": "BATH",
    "state": "New York",
    "zip": "14810",
    "lat": 42.3431557,
    "lng": -77.33576269999999
  },
  {
    "Store Location": "Tractor Supply 4331 MIDDLE COUNTRY ROAD CALVERTON, New York 11933",
    "Store Type": "Tractor Supply",
    "Phone Number": "631-727-7772",
    "address": "4331 MIDDLE COUNTRY ROAD, CALVERTON, New York 11933",
    "city": "CALVERTON",
    "state": "New York",
    "zip": "11933",
    "lat": 40.924496,
    "lng": -72.77414499999999
  },
  {
    "Store Location": "Tractor Supply 4377 GENESEE VALLY PLZ GENESEO, New York 14454",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-243-2120",
    "address": "4377 GENESEE VALLY PLZ, GENESEO, New York 14454",
    "city": "GENESEO",
    "state": "New York",
    "zip": "14454",
    "lat": 42.7985718,
    "lng": -77.78141409999999
  },
  {
    "Store Location": "Tractor Supply 4484 SOUTHWESTERN BLVD HAMBURG, New York 14075",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-648-5140",
    "address": "4484 SOUTHWESTERN BLVD, HAMBURG, New York 14075",
    "city": "HAMBURG",
    "state": "New York",
    "zip": "14075",
    "lat": 42.7635073,
    "lng": -78.8272535
  },
  {
    "Store Location": "Tractor Supply 461 NORTH MAIN ST STE 2 WARSAW, New York 14569",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-786-0870",
    "address": "461 NORTH MAIN ST STE 2, WARSAW, New York 14569",
    "city": "WARSAW",
    "state": "New York",
    "zip": "14569",
    "lat": 42.75992129999999,
    "lng": -78.1304389
  },
  {
    "Store Location": "Tractor Supply 471 EAST MAIN ST STE 3 GOUVERNEUR, New York 13642",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-287-0006",
    "address": "471 EAST MAIN ST STE 3, GOUVERNEUR, New York 13642",
    "city": "GOUVERNEUR",
    "state": "New York",
    "zip": "13642",
    "lat": 44.3452215,
    "lng": -75.4522465
  },
  {
    "Store Location": "Tractor Supply 480 BOLIVAR RD WELLSVILLE, New York 14895",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-593-7987",
    "address": "480 BOLIVAR RD, WELLSVILLE, New York 14895",
    "city": "WELLSVILLE",
    "state": "New York",
    "zip": "14895",
    "lat": 42.1278333,
    "lng": -77.9673514
  },
  {
    "Store Location": "Tractor Supply 4854 STATE HWY 30 AMSTERDAM, New York 12010",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-627-0269",
    "address": "4854 STATE HWY 30, AMSTERDAM, New York 12010",
    "city": "AMSTERDAM",
    "state": "New York",
    "zip": "12010",
    "lat": 42.9702866,
    "lng": -74.1899584
  },
  {
    "Store Location": "Tractor Supply 4974 EAST MAIN BATAVIA, New York 14020",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-343-0078",
    "address": "4974 EAST MAIN, BATAVIA, New York 14020",
    "city": "BATAVIA",
    "state": "New York",
    "zip": "14020",
    "lat": 42.9923748,
    "lng": -78.1529331
  },
  {
    "Store Location": "Tractor Supply 5094 RTE 22 AMENIA, New York 12501",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-373-8645",
    "address": "5094 RTE 22, AMENIA, New York 12501",
    "city": "AMENIA",
    "state": "New York",
    "zip": "12501",
    "lat": 41.858814,
    "lng": -73.5519
  },
  {
    "Store Location": "Tractor Supply 5640 STATE HWY 12 NORWICH, New York 13815",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-336-8811",
    "address": "5640 STATE HWY 12, NORWICH, New York 13815",
    "city": "NORWICH",
    "state": "New York",
    "zip": "13815",
    "lat": 42.51578310000001,
    "lng": -75.5211048
  },
  {
    "Store Location": "Tractor Supply 5710 NUMBER FOUR RD LOWVILLE, New York 13367",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-376-3380",
    "address": "5710 NUMBER FOUR RD, LOWVILLE, New York 13367",
    "city": "LOWVILLE",
    "state": "New York",
    "zip": "13367",
    "lat": 43.7811454,
    "lng": -75.4765422
  },
  {
    "Store Location": "Tractor Supply 6015 SOUTH TRANSIT RD LOCKPORT, New York 14094",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-434-1083",
    "address": "6015 SOUTH TRANSIT RD, LOCKPORT, New York 14094",
    "city": "LOCKPORT",
    "state": "New York",
    "zip": "14094",
    "lat": 43.1309011,
    "lng": -78.6942049
  },
  {
    "Store Location": "Tractor Supply 61 TOWER DR MIDDLETOWN, New York 10941",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-692-2447",
    "address": "61 TOWER DR, MIDDLETOWN, New York 10941",
    "city": "MIDDLETOWN",
    "state": "New York",
    "zip": "10941",
    "lat": 41.4661738,
    "lng": -74.37263039999999
  },
  {
    "Store Location": "Tractor Supply 6365 BROCKPORT SPENCERPORT RD BROCKPORT, New York 14420",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-637-3620",
    "address": "6365 BROCKPORT SPENCERPORT RD, BROCKPORT, New York 14420",
    "city": "BROCKPORT",
    "state": "New York",
    "zip": "14420",
    "lat": 43.1974924,
    "lng": -77.93638059999999
  },
  {
    "Store Location": "Tractor Supply 6396 STATE HWY 23 ONEONTA, New York 13820",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-431-9791",
    "address": "6396 STATE HWY 23, ONEONTA, New York 13820",
    "city": "ONEONTA",
    "state": "New York",
    "zip": "13820",
    "lat": 42.44531620000001,
    "lng": -75.0106396
  },
  {
    "Store Location": "Tractor Supply 662 RTE 104 ONTARIO, New York 14519",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-524-5080",
    "address": "662 RTE 104, ONTARIO, New York 14519",
    "city": "ONTARIO",
    "state": "New York",
    "zip": "14519",
    "lat": 43.2251206,
    "lng": -77.34747209999999
  },
  {
    "Store Location": "Tractor Supply 6641 MANLIUS CENTER RD EAST SYRACUSE, New York 13057",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-432-1640",
    "address": "6641 MANLIUS CENTER RD EAST, SYRACUSE, New York 13057",
    "city": "SYRACUSE",
    "state": "New York",
    "zip": "13057",
    "lat": 43.0642958,
    "lng": -76.0588719
  },
  {
    "Store Location": "Tractor Supply 6700 RTE 31 EAST NEWARK, New York 14513",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-331-0852",
    "address": "6700 RTE 31 EAST, NEWARK, New York 14513",
    "city": "NEWARK",
    "state": "New York",
    "zip": "14513",
    "lat": 43.0508099,
    "lng": -77.06121340000001
  },
  {
    "Store Location": "Tractor Supply 68 DUTCHTOWN PLAZA PALATINE BRIDGE, New York 13428",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-673-2565",
    "address": "68 DUTCHTOWN PLAZA PALATINE, BRIDGE, New York 13428",
    "city": "BRIDGE",
    "state": "New York",
    "zip": "13428",
    "lat": 42.9133982,
    "lng": -74.5725645
  },
  {
    "Store Location": "Tractor Supply 69 MAIN ST DELHI, New York 13753",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-746-9222",
    "address": "69 MAIN ST, DELHI, New York 13753",
    "city": "DELHI",
    "state": "New York",
    "zip": "13753",
    "lat": 42.2756542,
    "lng": -74.918353
  },
  {
    "Store Location": "Tractor Supply 70 VILLAGE PLZ DANSVILLE, New York 14437",
    "Store Type": "Tractor Supply",
    "Phone Number": "585-335-3010",
    "address": "70 VILLAGE PLZ, DANSVILLE, New York 14437",
    "city": "DANSVILLE",
    "state": "New York",
    "zip": "14437",
    "lat": 42.5036571,
    "lng": -77.8796942
  },
  {
    "Store Location": "Tractor Supply 706 NEW YORK STATE RTE 13 CORTLAND, New York 13045",
    "Store Type": "Tractor Supply",
    "Phone Number": "607-753-0518",
    "address": "706 NEW YORK STATE RTE 13, CORTLAND, New York 13045",
    "city": "CORTLAND",
    "state": "New York",
    "zip": "13045",
    "lat": 42.5997409,
    "lng": -76.1779087
  },
  {
    "Store Location": "Tractor Supply 716 MOHAWK ST HERKIMER, New York 13350",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-866-9770",
    "address": "716 MOHAWK ST, HERKIMER, New York 13350",
    "city": "HERKIMER",
    "state": "New York",
    "zip": "13350",
    "lat": 43.0186986,
    "lng": -74.9934762
  },
  {
    "Store Location": "Tractor Supply 7485 US HWY 11 POTSDAM, New York 13676",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-265-3101",
    "address": "7485 US HWY 11, POTSDAM, New York 13676",
    "city": "POTSDAM",
    "state": "New York",
    "zip": "13676",
    "lat": 44.6697805,
    "lng": -74.9813084
  },
  {
    "Store Location": "Tractor Supply 751 UPPER GLEN ST STE 1 QUEENSBURY, New York 12804",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-792-7777",
    "address": "751 UPPER GLEN ST STE 1, QUEENSBURY, New York 12804",
    "city": "QUEENSBURY",
    "state": "New York",
    "zip": "12804",
    "lat": 43.3192115,
    "lng": -73.657596
  },
  {
    "Store Location": "Tractor Supply 7600 FOURTH AVE NIAGARA FALLS, New York 14304",
    "Store Type": "Tractor Supply",
    "Phone Number": "716-297-1221",
    "address": "7600 FOURTH AVE NIAGARA, FALLS, New York 14304",
    "city": "FALLS",
    "state": "New York",
    "zip": "14304",
    "lat": 43.10206900000001,
    "lng": -78.9781928
  },
  {
    "Store Location": "Tractor Supply 78 BROOKSIDE AVE STE 152 CHESTER, New York 10918",
    "Store Type": "Tractor Supply",
    "Phone Number": "845-469-1732",
    "address": "78 BROOKSIDE AVE STE 152, CHESTER, New York 10918",
    "city": "CHESTER",
    "state": "New York",
    "zip": "10918",
    "lat": 41.3593215,
    "lng": -74.28430039999999
  },
  {
    "Store Location": "Tractor Supply 79 WEIBEL AVE SARATOGA SPRINGS, New York 12866",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-587-4006",
    "address": "79 WEIBEL AVE SARATOGA, SPRINGS, New York 12866",
    "city": "SPRINGS",
    "state": "New York",
    "zip": "12866",
    "lat": 43.0952882,
    "lng": -73.74576309999999
  },
  {
    "Store Location": "Tractor Supply 790 HORATIO ST UTICA, New York 13502",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-735-5745",
    "address": "790 HORATIO ST, UTICA, New York 13502",
    "city": "UTICA",
    "state": "New York",
    "zip": "13502",
    "lat": 43.1280677,
    "lng": -75.2226548
  },
  {
    "Store Location": "Tractor Supply 806 WEST BROADWAY ST STE 11 FULTON, New York 13069",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-593-2289",
    "address": "806 WEST BROADWAY ST STE 11, FULTON, New York 13069",
    "city": "FULTON",
    "state": "New York",
    "zip": "13069",
    "lat": 43.3228462,
    "lng": -76.4171585
  },
  {
    "Store Location": "Tractor Supply 864 HOOSICK RD TROY, New York 12180",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-279-1091",
    "address": "864 HOOSICK RD, TROY, New York 12180",
    "city": "TROY",
    "state": "New York",
    "zip": "12180",
    "lat": 42.7513361,
    "lng": -73.6284842
  },
  {
    "Store Location": "Tractor Supply 87 QUAKER ST STE 5 GRANVILLE, New York 12832",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-642-2016",
    "address": "87 QUAKER ST STE 5, GRANVILLE, New York 12832",
    "city": "GRANVILLE",
    "state": "New York",
    "zip": "12832",
    "lat": 43.3982061,
    "lng": -73.2670452
  },
  {
    "Store Location": "Tractor Supply 885 PRE EMPTION RD GENEVA, New York 14456",
    "Store Type": "Tractor Supply",
    "Phone Number": "315-789-4361",
    "address": "885 PRE EMPTION RD, GENEVA, New York 14456",
    "city": "GENEVA",
    "state": "New York",
    "zip": "14456",
    "lat": 42.857544,
    "lng": -77.010115
  },
  {
    "Store Location": "Tractor Supply 9 COMMERCE DR TICONDEROGA, New York 12883",
    "Store Type": "Tractor Supply",
    "Phone Number": "518-585-6450",
    "address": "9 COMMERCE DR, TICONDEROGA, New York 12883",
    "city": "TICONDEROGA",
    "state": "New York",
    "zip": "12883",
    "lat": 43.8605996,
    "lng": -73.4464608
  },
  {
    "Store Location": "Tractor Supply 100 CHERRY TREE LN MARIETTA, Ohio 45750",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-373-1289",
    "address": "100 CHERRY TREE LN, MARIETTA, Ohio 45750",
    "city": "MARIETTA",
    "state": "Ohio",
    "zip": "45750",
    "lat": 39.40498789999999,
    "lng": -81.4102979
  },
  {
    "Store Location": "Tractor Supply 1000 EAST STATE ST ATHENS, Ohio 45701",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-594-1892",
    "address": "1000 EAST STATE ST, ATHENS, Ohio 45701",
    "city": "ATHENS",
    "state": "Ohio",
    "zip": "45701",
    "lat": 39.3373432,
    "lng": -82.057824
  },
  {
    "Store Location": "Tractor Supply 1120 SOUTH MAIN ST BRYAN, Ohio 43506",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-633-0409",
    "address": "1120 SOUTH MAIN ST, BRYAN, Ohio 43506",
    "city": "BRYAN",
    "state": "Ohio",
    "zip": "43506",
    "lat": 41.4613982,
    "lng": -84.552759
  },
  {
    "Store Location": "Tractor Supply 1122 SOUTH SHANNON ST VAN WERT, Ohio 45891",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-232-4862",
    "address": "1122 SOUTH SHANNON ST VAN, WERT, Ohio 45891",
    "city": "WERT",
    "state": "Ohio",
    "zip": "45891",
    "lat": 40.8570505,
    "lng": -84.5959823
  },
  {
    "Store Location": "Tractor Supply 11395 STATE RTE 41 WEST UNION, Ohio 45693",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-544-1624",
    "address": "11395 STATE RTE 41 WEST, UNION, Ohio 45693",
    "city": "UNION",
    "state": "Ohio",
    "zip": "45693",
    "lat": 38.7842542,
    "lng": -83.5622255
  },
  {
    "Store Location": "Tractor Supply 1149 MAIN ST RAVENNA, Ohio 44266",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-297-0180",
    "address": "1149 MAIN ST, RAVENNA, Ohio 44266",
    "city": "RAVENNA",
    "state": "Ohio",
    "zip": "44266",
    "lat": 41.1583804,
    "lng": -81.223828
  },
  {
    "Store Location": "Tractor Supply 1159 STATE RTE 32 BATAVIA, Ohio 45103",
    "Store Type": "Tractor Supply",
    "Phone Number": "513-753-3883",
    "address": "1159 STATE RTE 32, BATAVIA, Ohio 45103",
    "city": "BATAVIA",
    "state": "Ohio",
    "zip": "45103",
    "lat": 39.088892,
    "lng": -84.2479031
  },
  {
    "Store Location": "Tractor Supply 1220 INDIANA AVE ST MARYS, Ohio 45885",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-394-1080",
    "address": "1220 INDIANA AVE ST, MARYS, Ohio 45885",
    "city": "MARYS",
    "state": "Ohio",
    "zip": "45885",
    "lat": 40.5529117,
    "lng": -84.4049551
  },
  {
    "Store Location": "Tractor Supply 12985 STONECREEK DR PICKERINGTON, Ohio 43147",
    "Store Type": "Tractor Supply",
    "Phone Number": "614-501-7044",
    "address": "12985 STONECREEK DR, PICKERINGTON, Ohio 43147",
    "city": "PICKERINGTON",
    "state": "Ohio",
    "zip": "43147",
    "lat": 39.9231709,
    "lng": -82.7830326
  },
  {
    "Store Location": "Tractor Supply 1325 STATE RTE 28 LOVELAND, Ohio 45140",
    "Store Type": "Tractor Supply",
    "Phone Number": "513-575-0508",
    "address": "1325 STATE RTE 28, LOVELAND, Ohio 45140",
    "city": "LOVELAND",
    "state": "Ohio",
    "zip": "45140",
    "lat": 39.2047892,
    "lng": -84.21640169999999
  },
  {
    "Store Location": "Tractor Supply 1335 CANTON RD NORTHWEST CARROLLTON, Ohio 44615",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-627-3738",
    "address": "1335 CANTON RD NORTHWEST, CARROLLTON, Ohio 44615",
    "city": "CARROLLTON",
    "state": "Ohio",
    "zip": "44615",
    "lat": 40.5939365,
    "lng": -81.09568759999999
  },
  {
    "Store Location": "Tractor Supply 1372 MAIN ST HAMILTON, Ohio 45013",
    "Store Type": "Tractor Supply",
    "Phone Number": "513-887-7477",
    "address": "1372 MAIN ST, HAMILTON, Ohio 45013",
    "city": "HAMILTON",
    "state": "Ohio",
    "zip": "45013",
    "lat": 39.4233882,
    "lng": -84.5909092
  },
  {
    "Store Location": "Tractor Supply 1401 COSHOCTON AVE MOUNT VERNON, Ohio 43050",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-397-9012",
    "address": "1401 COSHOCTON AVE MOUNT, VERNON, Ohio 43050",
    "city": "VERNON",
    "state": "Ohio",
    "zip": "43050",
    "lat": 40.4032623,
    "lng": -82.4487023
  },
  {
    "Store Location": "Tractor Supply 1415 WAGNER AVE GREENVILLE, Ohio 45331",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-548-1462",
    "address": "1415 WAGNER AVE, GREENVILLE, Ohio 45331",
    "city": "GREENVILLE",
    "state": "Ohio",
    "zip": "45331",
    "lat": 40.1238227,
    "lng": -84.6186851
  },
  {
    "Store Location": "Tractor Supply 14400 US HWY 20A WAUSEON, Ohio 43567",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-335-0356",
    "address": "14400 US HWY 20A, WAUSEON, Ohio 43567",
    "city": "WAUSEON",
    "state": "Ohio",
    "zip": "43567",
    "lat": 41.5742694,
    "lng": -84.1420691
  },
  {
    "Store Location": "Tractor Supply 1457 NORTH HIGH ST HILLSBORO, Ohio 45133",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-393-9976",
    "address": "1457 NORTH HIGH ST, HILLSBORO, Ohio 45133",
    "city": "HILLSBORO",
    "state": "Ohio",
    "zip": "45133",
    "lat": 39.2278575,
    "lng": -83.6112156
  },
  {
    "Store Location": "Tractor Supply 1488 MARION WALDO RD RTE 423 MARION, Ohio 43302",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-725-9169",
    "address": "1488 MARION WALDO RD RTE 423, MARION, Ohio 43302",
    "city": "MARION",
    "state": "Ohio",
    "zip": "43302",
    "lat": 40.5614743,
    "lng": -83.1180476
  },
  {
    "Store Location": "Tractor Supply 150 COMMERCE DR CADIZ, Ohio 43907",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-942-2271",
    "address": "150 COMMERCE DR, CADIZ, Ohio 43907",
    "city": "CADIZ",
    "state": "Ohio",
    "zip": "43907",
    "lat": 40.2728452,
    "lng": -80.9967628
  },
  {
    "Store Location": "Tractor Supply 1500 CANTON RD STE 370 AKRON, Ohio 44312",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-733-1152",
    "address": "1500 CANTON RD STE 370, AKRON, Ohio 44312",
    "city": "AKRON",
    "state": "Ohio",
    "zip": "44312",
    "lat": 41.0250075,
    "lng": -81.4260956
  },
  {
    "Store Location": "Tractor Supply 15212 US RTE 224 FINDLAY, Ohio 45840",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-422-1586",
    "address": "15212 US RTE 224, FINDLAY, Ohio 45840",
    "city": "FINDLAY",
    "state": "Ohio",
    "zip": "45840",
    "lat": 41.0444573,
    "lng": -83.8424033
  },
  {
    "Store Location": "Tractor Supply 15424 WEST HIGH ST MIDDLEFIELD, Ohio 44062",
    "Store Type": "Tractor Supply",
    "Phone Number": "440-632-0240",
    "address": "15424 WEST HIGH ST, MIDDLEFIELD, Ohio 44062",
    "city": "MIDDLEFIELD",
    "state": "Ohio",
    "zip": "44062",
    "lat": 41.4646033,
    "lng": -81.0911596
  },
  {
    "Store Location": "Tractor Supply 15600 US 36 MARYSVILLE, Ohio 43040",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-642-7069",
    "address": "15600 US 36, MARYSVILLE, Ohio 43040",
    "city": "MARYSVILLE",
    "state": "Ohio",
    "zip": "43040",
    "lat": 40.2426253,
    "lng": -83.3385224
  },
  {
    "Store Location": "Tractor Supply 15981 STATE RTE 170 EAST LIVERPOOL, Ohio 43920",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-385-7487",
    "address": "15981 STATE RTE 170 EAST, LIVERPOOL, Ohio 43920",
    "city": "LIVERPOOL",
    "state": "Ohio",
    "zip": "43920",
    "lat": 40.6695699,
    "lng": -80.58811659999999
  },
  {
    "Store Location": "Tractor Supply 1627 ROMBACH AVE STE B WILMINGTON, Ohio 45177",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-382-2595",
    "address": "1627 ROMBACH AVE STE B, WILMINGTON, Ohio 45177",
    "city": "WILMINGTON",
    "state": "Ohio",
    "zip": "45177",
    "lat": 39.452427,
    "lng": -83.80093
  },
  {
    "Store Location": "Tractor Supply 1637 EAST US HWY 36 UNIT 1A URBANA, Ohio 43078",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-653-3012",
    "address": "1637 EAST US HWY 36 UNIT 1A, URBANA, Ohio 43078",
    "city": "URBANA",
    "state": "Ohio",
    "zip": "43078",
    "lat": 40.1057,
    "lng": -83.72019
  },
  {
    "Store Location": "Tractor Supply 1637 NORTH BARRON ST EATON, Ohio 45320",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-456-1258",
    "address": "1637 NORTH BARRON ST, EATON, Ohio 45320",
    "city": "EATON",
    "state": "Ohio",
    "zip": "45320",
    "lat": 39.764988,
    "lng": -84.63839
  },
  {
    "Store Location": "Tractor Supply 1650 COLUMBUS AVE WASHINGTON COURT HOUSE, Ohio 43160",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-335-0651",
    "address": "1650 COLUMBUS AVE WASHINGTON COURT, HOUSE, Ohio 43160",
    "city": "HOUSE",
    "state": "Ohio",
    "zip": "43160",
    "lat": 39.5501353,
    "lng": -83.4262455
  },
  {
    "Store Location": "Tractor Supply 1650 MICHIGAN ST SIDNEY, Ohio 45365",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-492-4010",
    "address": "1650 MICHIGAN ST, SIDNEY, Ohio 45365",
    "city": "SIDNEY",
    "state": "Ohio",
    "zip": "45365",
    "lat": 40.2887601,
    "lng": -84.1806855
  },
  {
    "Store Location": "Tractor Supply 1651 SOUTH MAIN ST BELLEFONTAINE, Ohio 43311",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-593-4245",
    "address": "1651 SOUTH MAIN ST, BELLEFONTAINE, Ohio 43311",
    "city": "BELLEFONTAINE",
    "state": "Ohio",
    "zip": "43311",
    "lat": 40.3360378,
    "lng": -83.76084970000001
  },
  {
    "Store Location": "Tractor Supply 1690 EAST MAIN ST LANCASTER, Ohio 43130",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-681-1323",
    "address": "1690 EAST MAIN ST, LANCASTER, Ohio 43130",
    "city": "LANCASTER",
    "state": "Ohio",
    "zip": "43130",
    "lat": 39.71267539999999,
    "lng": -82.5657244
  },
  {
    "Store Location": "Tractor Supply 1720 SOUTH WASHINGTON ST MILLERSBURG, Ohio 44654",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-674-1039",
    "address": "1720 SOUTH WASHINGTON ST, MILLERSBURG, Ohio 44654",
    "city": "MILLERSBURG",
    "state": "Ohio",
    "zip": "44654",
    "lat": 40.53117659999999,
    "lng": -81.91963369999999
  },
  {
    "Store Location": "Tractor Supply 180 GREAT OAKS TRL STE A WADSWORTH, Ohio 44281",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-334-0500",
    "address": "180 GREAT OAKS TRL STE A, WADSWORTH, Ohio 44281",
    "city": "WADSWORTH",
    "state": "Ohio",
    "zip": "44281",
    "lat": 41.0507287,
    "lng": -81.7321206
  },
  {
    "Store Location": "Tractor Supply 18201 NORTH DIXIE HWY BOWLING GREEN, Ohio 43402",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-354-3991",
    "address": "18201 NORTH DIXIE HWY BOWLING, GREEN, Ohio 43402",
    "city": "GREEN",
    "state": "Ohio",
    "zip": "43402",
    "lat": 41.4178611,
    "lng": -83.6517772
  },
  {
    "Store Location": "Tractor Supply 1850 NORTH BRIDGE ST CHILLICOTHE, Ohio 45601",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-773-2228",
    "address": "1850 NORTH BRIDGE ST, CHILLICOTHE, Ohio 45601",
    "city": "CHILLICOTHE",
    "state": "Ohio",
    "zip": "45601",
    "lat": 39.3735677,
    "lng": -82.9773779
  },
  {
    "Store Location": "Tractor Supply 1971 COOPER FOSTER PARK RD AMHERST, Ohio 44001",
    "Store Type": "Tractor Supply",
    "Phone Number": "440-960-5366",
    "address": "1971 COOPER FOSTER PARK RD, AMHERST, Ohio 44001",
    "city": "AMHERST",
    "state": "Ohio",
    "zip": "44001",
    "lat": 41.4162778,
    "lng": -82.20305379999999
  },
  {
    "Store Location": "Tractor Supply 20 STANFIELD RD TROY, Ohio 45373",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-335-6600",
    "address": "20 STANFIELD RD, TROY, Ohio 45373",
    "city": "TROY",
    "state": "Ohio",
    "zip": "45373",
    "lat": 40.0525724,
    "lng": -84.2414637
  },
  {
    "Store Location": "Tractor Supply 2011 ALEXANDRIA WAY MACEDONIA, Ohio 44056",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-468-3440",
    "address": "2011 ALEXANDRIA WAY, MACEDONIA, Ohio 44056",
    "city": "MACEDONIA",
    "state": "Ohio",
    "zip": "44056",
    "lat": 41.3150917,
    "lng": -81.50207560000001
  },
  {
    "Store Location": "Tractor Supply 203 MEADOW GLEN DR OTTAWA, Ohio 45875",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-523-1114",
    "address": "203 MEADOW GLEN DR, OTTAWA, Ohio 45875",
    "city": "OTTAWA",
    "state": "Ohio",
    "zip": "45875",
    "lat": 41.03437539999999,
    "lng": -84.0412403
  },
  {
    "Store Location": "Tractor Supply 2035 HEBRON RD RTE 79 SOUTH HEATH, Ohio 43056",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-928-1300",
    "address": "2035 HEBRON RD RTE 79 SOUTH, HEATH, Ohio 43056",
    "city": "HEATH",
    "state": "Ohio",
    "zip": "43056",
    "lat": 39.9984971,
    "lng": -82.4690785
  },
  {
    "Store Location": "Tractor Supply 2135 SOUTHGATE PKWY CAMBRIDGE, Ohio 43725",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-432-2956",
    "address": "2135 SOUTHGATE PKWY, CAMBRIDGE, Ohio 43725",
    "city": "CAMBRIDGE",
    "state": "Ohio",
    "zip": "43725",
    "lat": 40.0028837,
    "lng": -81.5742096
  },
  {
    "Store Location": "Tractor Supply 2141 EAST MANSFIELD RD BUCYRUS, Ohio 44820",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-562-0344",
    "address": "2141 EAST MANSFIELD RD, BUCYRUS, Ohio 44820",
    "city": "BUCYRUS",
    "state": "Ohio",
    "zip": "44820",
    "lat": 40.8117106,
    "lng": -82.94276070000001
  },
  {
    "Store Location": "Tractor Supply 2310 CLAREMONT AVE ASHLAND, Ohio 44805",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-207-8132",
    "address": "2310 CLAREMONT AVE, ASHLAND, Ohio 44805",
    "city": "ASHLAND",
    "state": "Ohio",
    "zip": "44805",
    "lat": 40.8460139,
    "lng": -82.353157
  },
  {
    "Store Location": "Tractor Supply 2366 EAST STATE ST SALEM, Ohio 44460",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-332-0635",
    "address": "2366 EAST STATE ST, SALEM, Ohio 44460",
    "city": "SALEM",
    "state": "Ohio",
    "zip": "44460",
    "lat": 40.9030682,
    "lng": -80.8266199
  },
  {
    "Store Location": "Tractor Supply 23735 US 23 CIRCLEVILLE, Ohio 43113",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-420-7877",
    "address": "23735 US 23, CIRCLEVILLE, Ohio 43113",
    "city": "CIRCLEVILLE",
    "state": "Ohio",
    "zip": "43113",
    "lat": 39.5850671,
    "lng": -82.9548679
  },
  {
    "Store Location": "Tractor Supply 240 BLUEBELL DR NORTHWEST NEW PHILADELPHIA, Ohio 44663",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-339-9500",
    "address": "240 BLUEBELL DR NORTHWEST NEW, PHILADELPHIA, Ohio 44663",
    "city": "PHILADELPHIA",
    "state": "Ohio",
    "zip": "44663",
    "lat": 40.4954486,
    "lng": -81.47432669999999
  },
  {
    "Store Location": "Tractor Supply 24100 ROYALTON RD COLUMBIA STATION, Ohio 44028",
    "Store Type": "Tractor Supply",
    "Phone Number": "440-236-3003",
    "address": "24100 ROYALTON RD COLUMBIA, STATION, Ohio 44028",
    "city": "STATION",
    "state": "Ohio",
    "zip": "44028",
    "lat": 41.3133455,
    "lng": -81.89952339999999
  },
  {
    "Store Location": "Tractor Supply 2501 WEST MARKET ST TIFFIN, Ohio 44883",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-447-4109",
    "address": "2501 WEST MARKET ST, TIFFIN, Ohio 44883",
    "city": "TIFFIN",
    "state": "Ohio",
    "zip": "44883",
    "lat": 41.1101688,
    "lng": -83.218209
  },
  {
    "Store Location": "Tractor Supply 2520 WEST STATE ST ALLIANCE, Ohio 44601",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-823-2808",
    "address": "2520 WEST STATE ST, ALLIANCE, Ohio 44601",
    "city": "ALLIANCE",
    "state": "Ohio",
    "zip": "44601",
    "lat": 40.90117790000001,
    "lng": -81.15683849999999
  },
  {
    "Store Location": "Tractor Supply 2621 US HIGHWAY 23 N DELAWARE, Ohio 43015",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-369-3024",
    "address": "2621 US HIGHWAY 23 N, DELAWARE, Ohio 43015",
    "city": "DELAWARE",
    "state": "Ohio",
    "zip": "43015",
    "lat": 40.3378554,
    "lng": -83.0751537
  },
  {
    "Store Location": "Tractor Supply 2727 WEST FOURTH ST MANSFIELD, Ohio 44906",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-529-8590",
    "address": "2727 WEST FOURTH ST, MANSFIELD, Ohio 44906",
    "city": "MANSFIELD",
    "state": "Ohio",
    "zip": "44906",
    "lat": 40.77534139999999,
    "lng": -82.6126432
  },
  {
    "Store Location": "Tractor Supply 2785 HARDING HWY LIMA, Ohio 45804",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-223-1921",
    "address": "2785 HARDING HWY, LIMA, Ohio 45804",
    "city": "LIMA",
    "state": "Ohio",
    "zip": "45804",
    "lat": 40.731776,
    "lng": -84.0535696
  },
  {
    "Store Location": "Tractor Supply 28 HOCKING MALL LOGAN, Ohio 43138",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-385-0636",
    "address": "28 HOCKING MALL, LOGAN, Ohio 43138",
    "city": "LOGAN",
    "state": "Ohio",
    "zip": "43138",
    "lat": 39.54537819999999,
    "lng": -82.4307129
  },
  {
    "Store Location": "Tractor Supply 2915 NORTH RIDGE EAST ASHTABULA, Ohio 44004",
    "Store Type": "Tractor Supply",
    "Phone Number": "440-992-6616",
    "address": "2915 NORTH RIDGE EAST, ASHTABULA, Ohio 44004",
    "city": "ASHTABULA",
    "state": "Ohio",
    "zip": "44004",
    "lat": 41.8797582,
    "lng": -80.7589246
  },
  {
    "Store Location": "Tractor Supply 300 LAFAYETTE ST LONDON, Ohio 43140",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-845-1139",
    "address": "300 LAFAYETTE ST, LONDON, Ohio 43140",
    "city": "LONDON",
    "state": "Ohio",
    "zip": "43140",
    "lat": 39.90319239999999,
    "lng": -83.4282507
  },
  {
    "Store Location": "Tractor Supply 3101 ELIDA RD LIMA, Ohio 45805",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-331-6022",
    "address": "3101 ELIDA RD, LIMA, Ohio 45805",
    "city": "LIMA",
    "state": "Ohio",
    "zip": "45805",
    "lat": 40.76724859999999,
    "lng": -84.16041039999999
  },
  {
    "Store Location": "Tractor Supply 315 DEO DR NEWARK, Ohio 43055",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-366-2316",
    "address": "315 DEO DR, NEWARK, Ohio 43055",
    "city": "NEWARK",
    "state": "Ohio",
    "zip": "43055",
    "lat": 40.0849073,
    "lng": -82.4267757
  },
  {
    "Store Location": "Tractor Supply 3333 W STATE RTE 22 3 LOVELAND, Ohio 45140",
    "Store Type": "Tractor Supply",
    "Phone Number": "513-697-1100",
    "address": "3333 W STATE RTE 22 3, LOVELAND, Ohio 45140",
    "city": "LOVELAND",
    "state": "Ohio",
    "zip": "45140",
    "lat": 39.2689476,
    "lng": -84.26382600000001
  },
  {
    "Store Location": "Tractor Supply 3660 MAPLE AVE ZANESVILLE, Ohio 43701",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-455-3441",
    "address": "3660 MAPLE AVE, ZANESVILLE, Ohio 43701",
    "city": "ZANESVILLE",
    "state": "Ohio",
    "zip": "43701",
    "lat": 39.9925772,
    "lng": -82.02497609999999
  },
  {
    "Store Location": "Tractor Supply 367 COUNTY RD 406 STE A SOUTH POINT, Ohio 45680",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-894-1809",
    "address": "367 COUNTY RD 406 STE A SOUTH, POINT, Ohio 45680",
    "city": "POINT",
    "state": "Ohio",
    "zip": "45680",
    "lat": 38.4213954,
    "lng": -82.5055521
  },
  {
    "Store Location": "Tractor Supply 3700 CLAYPOOL ST NORTHWEST CARROLL, Ohio 43112",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-654-1496",
    "address": "3700 CLAYPOOL ST NORTHWEST, CARROLL, Ohio 43112",
    "city": "CARROLL",
    "state": "Ohio",
    "zip": "43112",
    "lat": 39.7602434,
    "lng": -82.6691127
  },
  {
    "Store Location": "Tractor Supply 3768 PEARL RD MEDINA, Ohio 44256",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-722-0200",
    "address": "3768 PEARL RD, MEDINA, Ohio 44256",
    "city": "MEDINA",
    "state": "Ohio",
    "zip": "44256",
    "lat": 41.1731601,
    "lng": -81.8603366
  },
  {
    "Store Location": "Tractor Supply 3800 ELM RD WARREN, Ohio 44483",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-372-6428",
    "address": "3800 ELM RD, WARREN, Ohio 44483",
    "city": "WARREN",
    "state": "Ohio",
    "zip": "44483",
    "lat": 41.2694001,
    "lng": -80.77919849999999
  },
  {
    "Store Location": "Tractor Supply 3801 WEST STATE ST RTE 20 WEST FREMONT, Ohio 43420",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-332-2065",
    "address": "3801 WEST STATE ST RTE 20 WEST, FREMONT, Ohio 43420",
    "city": "FREMONT",
    "state": "Ohio",
    "zip": "43420",
    "lat": 41.3776461,
    "lng": -83.1881634
  },
  {
    "Store Location": "Tractor Supply 389 COMFORT DR HARRISON, Ohio 45030",
    "Store Type": "Tractor Supply",
    "Phone Number": "513-202-1183",
    "address": "389 COMFORT DR, HARRISON, Ohio 45030",
    "city": "HARRISON",
    "state": "Ohio",
    "zip": "45030",
    "lat": 39.25927770000001,
    "lng": -84.79101610000001
  },
  {
    "Store Location": "Tractor Supply 3942 NAVARRE AVE OREGON, Ohio 43616",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-691-2715",
    "address": "3942 NAVARRE AVE, OREGON, Ohio 43616",
    "city": "OREGON",
    "state": "Ohio",
    "zip": "43616",
    "lat": 41.6365355,
    "lng": -83.4532675
  },
  {
    "Store Location": "Tractor Supply 4000 RHODES AVE NEW BOSTON, Ohio 45662",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-456-0000",
    "address": "4000 RHODES AVE NEW, BOSTON, Ohio 45662",
    "city": "BOSTON",
    "state": "Ohio",
    "zip": "45662",
    "lat": 38.7512508,
    "lng": -82.9335175
  },
  {
    "Store Location": "Tractor Supply 4020 ERIE AVE SOUTHWEST MASSILLON, Ohio 44646",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-834-9349",
    "address": "4020 ERIE AVE SOUTHWEST, MASSILLON, Ohio 44646",
    "city": "MASSILLON",
    "state": "Ohio",
    "zip": "44646",
    "lat": 40.7497706,
    "lng": -81.5157244
  },
  {
    "Store Location": "Tractor Supply 4166 BURBANK RD WOOSTER, Ohio 44691",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-345-7702",
    "address": "4166 BURBANK RD, WOOSTER, Ohio 44691",
    "city": "WOOSTER",
    "state": "Ohio",
    "zip": "44691",
    "lat": 40.8498148,
    "lng": -81.9493047
  },
  {
    "Store Location": "Tractor Supply 4525 HAMILTON MIDDLETON RD HAMILTON, Ohio 45011",
    "Store Type": "Tractor Supply",
    "Phone Number": "513-895-8500",
    "address": "4525 HAMILTON MIDDLETON RD, HAMILTON, Ohio 45011",
    "city": "HAMILTON",
    "state": "Ohio",
    "zip": "45011",
    "lat": 39.4199175,
    "lng": -84.465137
  },
  {
    "Store Location": "Tractor Supply 4581 US RTE 127 CELINA, Ohio 45822",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-268-2550",
    "address": "4581 US RTE 127, CELINA, Ohio 45822",
    "city": "CELINA",
    "state": "Ohio",
    "zip": "45822",
    "lat": 40.5489358,
    "lng": -84.5702338
  },
  {
    "Store Location": "Tractor Supply 4655 ROOSEVELT BLVD MIDDLETOWN, Ohio 45044",
    "Store Type": "Tractor Supply",
    "Phone Number": "513-422-3019",
    "address": "4655 ROOSEVELT BLVD, MIDDLETOWN, Ohio 45044",
    "city": "MIDDLETOWN",
    "state": "Ohio",
    "zip": "45044",
    "lat": 39.5013218,
    "lng": -84.34812509999999
  },
  {
    "Store Location": "Tractor Supply 4768 US HWY 250 NORTH NORWALK, Ohio 44857",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-668-8266",
    "address": "4768 US HWY 250 NORTH, NORWALK, Ohio 44857",
    "city": "NORWALK",
    "state": "Ohio",
    "zip": "44857",
    "lat": 41.2709814,
    "lng": -82.6084889
  },
  {
    "Store Location": "Tractor Supply 499 DOWNTOWNER PLZ COSHOCTON, Ohio 43812",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-623-8423",
    "address": "499 DOWNTOWNER PLZ, COSHOCTON, Ohio 43812",
    "city": "COSHOCTON",
    "state": "Ohio",
    "zip": "43812",
    "lat": 40.2687935,
    "lng": -81.8738245
  },
  {
    "Store Location": "Tractor Supply 505 WEST CENTRAL AVE SPRINGBORO, Ohio 45066",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-743-8200",
    "address": "505 WEST CENTRAL AVE, SPRINGBORO, Ohio 45066",
    "city": "SPRINGBORO",
    "state": "Ohio",
    "zip": "45066",
    "lat": 39.5607367,
    "lng": -84.25328999999999
  },
  {
    "Store Location": "Tractor Supply 535 WEST WALTON ST WILLARD, Ohio 44890",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-933-2005",
    "address": "535 WEST WALTON ST, WILLARD, Ohio 44890",
    "city": "WILLARD",
    "state": "Ohio",
    "zip": "44890",
    "lat": 41.0417487,
    "lng": -82.73387129999999
  },
  {
    "Store Location": "Tractor Supply 540 WATER ST STE 100 CHARDON, Ohio 44024",
    "Store Type": "Tractor Supply",
    "Phone Number": "440-286-8283",
    "address": "540 WATER ST STE 100, CHARDON, Ohio 44024",
    "city": "CHARDON",
    "state": "Ohio",
    "zip": "44024",
    "lat": 41.5825207,
    "lng": -81.216167
  },
  {
    "Store Location": "Tractor Supply 5451 URBANA RD RTE 68 NORTH SPRINGFIELD, Ohio 45502",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-399-8664",
    "address": "5451 URBANA RD RTE 68 NORTH, SPRINGFIELD, Ohio 45502",
    "city": "SPRINGFIELD",
    "state": "Ohio",
    "zip": "45502",
    "lat": 40.0037666,
    "lng": -83.7985231
  },
  {
    "Store Location": "Tractor Supply 5525 WEST BROAD ST COLUMBUS, Ohio 43228",
    "Store Type": "Tractor Supply",
    "Phone Number": "614-878-7170",
    "address": "5525 WEST BROAD ST, COLUMBUS, Ohio 43228",
    "city": "COLUMBUS",
    "state": "Ohio",
    "zip": "43228",
    "lat": 39.950378,
    "lng": -83.14810539999999
  },
  {
    "Store Location": "Tractor Supply 5840 WHIPPLE AVE NORTHWEST NORTH CANTON, Ohio 44720",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-966-4867",
    "address": "5840 WHIPPLE AVE NORTHWEST NORTH, CANTON, Ohio 44720",
    "city": "CANTON",
    "state": "Ohio",
    "zip": "44720",
    "lat": 40.8655857,
    "lng": -81.4205858
  },
  {
    "Store Location": "Tractor Supply 600 SILVER BRIDGE PLZ RTE 7 GALLIPOLIS, Ohio 45631",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-441-8949",
    "address": "600 SILVER BRIDGE PLZ RTE 7, GALLIPOLIS, Ohio 45631",
    "city": "GALLIPOLIS",
    "state": "Ohio",
    "zip": "45631",
    "lat": 38.8362336,
    "lng": -82.1565751
  },
  {
    "Store Location": "Tractor Supply 610 ORCHARD LN BEAVER CREEK, Ohio 45434",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-320-1855",
    "address": "610 ORCHARD LN BEAVER, CREEK, Ohio 45434",
    "city": "CREEK",
    "state": "Ohio",
    "zip": "45434",
    "lat": 39.70504409999999,
    "lng": -84.0184506
  },
  {
    "Store Location": "Tractor Supply 6225 MAHONING AVE AUSTINTOWN, Ohio 44515",
    "Store Type": "Tractor Supply",
    "Phone Number": "330-792-8235",
    "address": "6225 MAHONING AVE, AUSTINTOWN, Ohio 44515",
    "city": "AUSTINTOWN",
    "state": "Ohio",
    "zip": "44515",
    "lat": 41.098583,
    "lng": -80.77970289999999
  },
  {
    "Store Location": "Tractor Supply 659 WEST COSHOCTON ST JOHNSTOWN, Ohio 43031",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-966-5415",
    "address": "659 WEST COSHOCTON ST, JOHNSTOWN, Ohio 43031",
    "city": "JOHNSTOWN",
    "state": "Ohio",
    "zip": "43031",
    "lat": 40.1457663,
    "lng": -82.70083009999999
  },
  {
    "Store Location": "Tractor Supply 6603 NORTH RIDGE RD MADISON, Ohio 44057",
    "Store Type": "Tractor Supply",
    "Phone Number": "440-417-1935",
    "address": "6603 NORTH RIDGE RD, MADISON, Ohio 44057",
    "city": "MADISON",
    "state": "Ohio",
    "zip": "44057",
    "lat": 41.8044559,
    "lng": -81.0499779
  },
  {
    "Store Location": "Tractor Supply 709 WEST PERKINS AVE SANDUSKY, Ohio 44870",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-624-0170",
    "address": "709 WEST PERKINS AVE, SANDUSKY, Ohio 44870",
    "city": "SANDUSKY",
    "state": "Ohio",
    "zip": "44870",
    "lat": 41.4341156,
    "lng": -82.7102429
  },
  {
    "Store Location": "Tractor Supply 7110 BACHMAN RD UNIT 1 SARDINIA, Ohio 45171",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-446-9425",
    "address": "7110 BACHMAN RD UNIT 1, SARDINIA, Ohio 45171",
    "city": "SARDINIA",
    "state": "Ohio",
    "zip": "45171",
    "lat": 39.0078448,
    "lng": -83.8085377
  },
  {
    "Store Location": "Tractor Supply 7355 SALEM AVE CLAYTON, Ohio 45315",
    "Store Type": "Tractor Supply",
    "Phone Number": "937-832-3441",
    "address": "7355 SALEM AVE, CLAYTON, Ohio 45315",
    "city": "CLAYTON",
    "state": "Ohio",
    "zip": "45315",
    "lat": 39.8504924,
    "lng": -84.3291423
  },
  {
    "Store Location": "Tractor Supply 736 SOUTH MAIN ST WELLINGTON, Ohio 44090",
    "Store Type": "Tractor Supply",
    "Phone Number": "440-647-4669",
    "address": "736 SOUTH MAIN ST, WELLINGTON, Ohio 44090",
    "city": "WELLINGTON",
    "state": "Ohio",
    "zip": "44090",
    "lat": 41.149893,
    "lng": -82.218993
  },
  {
    "Store Location": "Tractor Supply 7718 WEST CENTRAL AVE TOLEDO, Ohio 43617",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-841-5113",
    "address": "7718 WEST CENTRAL AVE, TOLEDO, Ohio 43617",
    "city": "TOLEDO",
    "state": "Ohio",
    "zip": "43617",
    "lat": 41.6745689,
    "lng": -83.728212
  },
  {
    "Store Location": "Tractor Supply 780 EAST MAIN ST JACKSON, Ohio 45640",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-288-1079",
    "address": "780 EAST MAIN ST, JACKSON, Ohio 45640",
    "city": "JACKSON",
    "state": "Ohio",
    "zip": "45640",
    "lat": 39.0416609,
    "lng": -82.62614359999999
  },
  {
    "Store Location": "Tractor Supply 8718 STATE RTE 66 NORTH DEFIANCE, Ohio 43512",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-784-5099",
    "address": "8718 STATE RTE 66 NORTH, DEFIANCE, Ohio 43512",
    "city": "DEFIANCE",
    "state": "Ohio",
    "zip": "43512",
    "lat": 41.3161082,
    "lng": -84.3621239
  },
  {
    "Store Location": "Tractor Supply 948 EAST COLUMBUS ST KENTON, Ohio 43326",
    "Store Type": "Tractor Supply",
    "Phone Number": "419-673-8900",
    "address": "948 EAST COLUMBUS ST, KENTON, Ohio 43326",
    "city": "KENTON",
    "state": "Ohio",
    "zip": "43326",
    "lat": 40.6512662,
    "lng": -83.5920115
  },
  {
    "Store Location": "Tractor Supply 9945 US 36 AND EAST SR 37 SUNBURY, Ohio 43074",
    "Store Type": "Tractor Supply",
    "Phone Number": "740-965-1618",
    "address": "9945 US 36 AND EAST SR 37, SUNBURY, Ohio 43074",
    "city": "SUNBURY",
    "state": "Ohio",
    "zip": "43074",
    "lat": 40.2591871,
    "lng": -82.8849966
  },
  {
    "Store Location": "Tractor Supply 1000 NORTH BROADWAY ST CLEVELAND, Oklahoma 74020",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-358-5800",
    "address": "1000 NORTH BROADWAY ST, CLEVELAND, Oklahoma 74020",
    "city": "CLEVELAND",
    "state": "Oklahoma",
    "zip": "74020",
    "lat": 36.3178258,
    "lng": -96.4642264
  },
  {
    "Store Location": "Tractor Supply 106 NORTH INDIAN MERIDIAN RD PAULS VALLEY, Oklahoma 73075",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-238-4648",
    "address": "106 NORTH INDIAN MERIDIAN RD PAULS, VALLEY, Oklahoma 73075",
    "city": "VALLEY",
    "state": "Oklahoma",
    "zip": "73075",
    "lat": 34.7408893,
    "lng": -97.2467951
  },
  {
    "Store Location": "Tractor Supply 1105 NORTHWEST HWY 270 WOODWARD, Oklahoma 73801",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-254-2704",
    "address": "1105 NORTHWEST HWY 270, WOODWARD, Oklahoma 73801",
    "city": "WOODWARD",
    "state": "Oklahoma",
    "zip": "73801",
    "lat": 36.435424,
    "lng": -99.430368
  },
  {
    "Store Location": "Tractor Supply 1129 EAST WRANGLER BLVD SEMINOLE, Oklahoma 74868",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-382-9922",
    "address": "1129 EAST WRANGLER BLVD, SEMINOLE, Oklahoma 74868",
    "city": "SEMINOLE",
    "state": "Oklahoma",
    "zip": "74868",
    "lat": 35.2456055,
    "lng": -96.6573264
  },
  {
    "Store Location": "Tractor Supply 1140 WEST SHAWNEE ST MUSKOGEE, Oklahoma 74401",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-686-0419",
    "address": "1140 WEST SHAWNEE ST, MUSKOGEE, Oklahoma 74401",
    "city": "MUSKOGEE",
    "state": "Oklahoma",
    "zip": "74401",
    "lat": 35.7707516,
    "lng": -95.3780092
  },
  {
    "Store Location": "Tractor Supply 1200 EAST EAGLE RD WEATHERFORD, Oklahoma 73096",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-772-2168",
    "address": "1200 EAST EAGLE RD, WEATHERFORD, Oklahoma 73096",
    "city": "WEATHERFORD",
    "state": "Oklahoma",
    "zip": "73096",
    "lat": 35.5224516,
    "lng": -98.6403726
  },
  {
    "Store Location": "Tractor Supply 1301 EAST MAIN STREET CORDELL, Oklahoma 73632",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-832-5585",
    "address": "1301 EAST MAIN STREET, CORDELL, Oklahoma 73632",
    "city": "CORDELL",
    "state": "Oklahoma",
    "zip": "73632",
    "lat": 35.2923027,
    "lng": -98.975652
  },
  {
    "Store Location": "Tractor Supply 13125 COLONY POINTE BLVD PIEDMONT, Oklahoma 73078",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-373-1391",
    "address": "13125 COLONY POINTE BLVD, PIEDMONT, Oklahoma 73078",
    "city": "PIEDMONT",
    "state": "Oklahoma",
    "zip": "73078",
    "lat": 35.6047114,
    "lng": -97.7422836
  },
  {
    "Store Location": "Tractor Supply 1320 NORTH HILLS CENTER ADA, Oklahoma 74820",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-421-9777",
    "address": "1320 NORTH HILLS CENTER, ADA, Oklahoma 74820",
    "city": "ADA",
    "state": "Oklahoma",
    "zip": "74820",
    "lat": 34.7915675,
    "lng": -96.66274709999999
  },
  {
    "Store Location": "Tractor Supply 13325 EAST 136TH ST NORTH COLLINSVILLE, Oklahoma 74021",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-371-4400",
    "address": "13325 EAST 136TH ST NORTH, COLLINSVILLE, Oklahoma 74021",
    "city": "COLLINSVILLE",
    "state": "Oklahoma",
    "zip": "74021",
    "lat": 36.3521878,
    "lng": -95.82458989999999
  },
  {
    "Store Location": "Tractor Supply 140 WEST 161ST ST GLENPOOL, Oklahoma 74033",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-322-3377",
    "address": "140 WEST 161ST ST, GLENPOOL, Oklahoma 74033",
    "city": "GLENPOOL",
    "state": "Oklahoma",
    "zip": "74033",
    "lat": 35.9293441,
    "lng": -96.01112739999999
  },
  {
    "Store Location": "Tractor Supply 1504 SOUTHWEST 27TH ST EL RENO, Oklahoma 73036",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-262-2037",
    "address": "1504 SOUTHWEST 27TH ST EL, RENO, Oklahoma 73036",
    "city": "RENO",
    "state": "Oklahoma",
    "zip": "73036",
    "lat": 35.5086555,
    "lng": -97.9697588
  },
  {
    "Store Location": "Tractor Supply 1506 FIR STREET PERRY, Oklahoma 73077",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-572-2061",
    "address": "1506 FIR STREET, PERRY, Oklahoma 73077",
    "city": "PERRY",
    "state": "Oklahoma",
    "zip": "73077",
    "lat": 36.2883792,
    "lng": -97.3019628
  },
  {
    "Store Location": "Tractor Supply 1520 WEST PLATO RD DUNCAN, Oklahoma 73533",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-252-1903",
    "address": "1520 WEST PLATO RD, DUNCAN, Oklahoma 73533",
    "city": "DUNCAN",
    "state": "Oklahoma",
    "zip": "73533",
    "lat": 34.5344045,
    "lng": -97.96558669999999
  },
  {
    "Store Location": "Tractor Supply 1620 NORTH GREEN AVE PURCELL, Oklahoma 73080",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-527-3525",
    "address": "1620 NORTH GREEN AVE, PURCELL, Oklahoma 73080",
    "city": "PURCELL",
    "state": "Oklahoma",
    "zip": "73080",
    "lat": 35.0313547,
    "lng": -97.364739
  },
  {
    "Store Location": "Tractor Supply 16960 NORTHEAST 23RD ST CHOCTAW, Oklahoma 73020",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-390-0368",
    "address": "16960 NORTHEAST 23RD ST, CHOCTAW, Oklahoma 73020",
    "city": "CHOCTAW",
    "state": "Oklahoma",
    "zip": "73020",
    "lat": 35.4922806,
    "lng": -97.23084360000001
  },
  {
    "Store Location": "Tractor Supply 2000 EAST CHEROKEE AVE STE S SALLISAW, Oklahoma 74955",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-774-0668",
    "address": "2000 EAST CHEROKEE AVE STE S, SALLISAW, Oklahoma 74955",
    "city": "SALLISAW",
    "state": "Oklahoma",
    "zip": "74955",
    "lat": 35.4562004,
    "lng": -94.7689159
  },
  {
    "Store Location": "Tractor Supply 201 NORTH MUSTANG RD MUSTANG, Oklahoma 73064",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-376-7252",
    "address": "201 NORTH MUSTANG RD, MUSTANG, Oklahoma 73064",
    "city": "MUSTANG",
    "state": "Oklahoma",
    "zip": "73064",
    "lat": 35.392967,
    "lng": -97.72630939999999
  },
  {
    "Store Location": "Tractor Supply 2030 SOUTH TELEPHONE RD MOORE, Oklahoma 73160",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-912-2666",
    "address": "2030 SOUTH TELEPHONE RD, MOORE, Oklahoma 73160",
    "city": "MOORE",
    "state": "Oklahoma",
    "zip": "73160",
    "lat": 35.3174255,
    "lng": -97.4938858
  },
  {
    "Store Location": "Tractor Supply 2100 EVERGREEN ST DURANT, Oklahoma 74701",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-924-3334",
    "address": "2100 EVERGREEN ST, DURANT, Oklahoma 74701",
    "city": "DURANT",
    "state": "Oklahoma",
    "zip": "74701",
    "lat": 33.9995082,
    "lng": -96.4008314
  },
  {
    "Store Location": "Tractor Supply 2121 US HWY 59 GROVE, Oklahoma 74344",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-786-9035",
    "address": "2121 US HWY 59, GROVE, Oklahoma 74344",
    "city": "GROVE",
    "state": "Oklahoma",
    "zip": "74344",
    "lat": 36.6029007,
    "lng": -94.789315
  },
  {
    "Store Location": "Tractor Supply 2171 SOUTH MISSISSIPPI AVE ATOKA, Oklahoma 74525",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-364-0153",
    "address": "2171 SOUTH MISSISSIPPI AVE, ATOKA, Oklahoma 74525",
    "city": "ATOKA",
    "state": "Oklahoma",
    "zip": "74525",
    "lat": 34.3636772,
    "lng": -96.1437838
  },
  {
    "Store Location": "Tractor Supply 220 SOUTH CLARENCE NASH BLVD WATONGA, Oklahoma 73772",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-623-2201",
    "address": "220 SOUTH CLARENCE NASH BLVD, WATONGA, Oklahoma 73772",
    "city": "WATONGA",
    "state": "Oklahoma",
    "zip": "73772",
    "lat": 35.8427101,
    "lng": -98.4199527
  },
  {
    "Store Location": "Tractor Supply 2501 NORTH HWY 64 GUYMON, Oklahoma 73942",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-338-7170",
    "address": "2501 NORTH HWY 64, GUYMON, Oklahoma 73942",
    "city": "GUYMON",
    "state": "Oklahoma",
    "zip": "73942",
    "lat": 36.70477220000001,
    "lng": -101.4832588
  },
  {
    "Store Location": "Tractor Supply 2520 NORTH COMMERCE ST ARDMORE, Oklahoma 73401",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-223-3003",
    "address": "2520 NORTH COMMERCE ST, ARDMORE, Oklahoma 73401",
    "city": "ARDMORE",
    "state": "Oklahoma",
    "zip": "73401",
    "lat": 34.2013621,
    "lng": -97.1411112
  },
  {
    "Store Location": "Tractor Supply 2630 NORTH MAIN ST MIAMI, Oklahoma 74354",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-542-2637",
    "address": "2630 NORTH MAIN ST, MIAMI, Oklahoma 74354",
    "city": "MIAMI",
    "state": "Oklahoma",
    "zip": "74354",
    "lat": 36.9076732,
    "lng": -94.8763757
  },
  {
    "Store Location": "Tractor Supply 2760 NORTH WOOD DR OKMULGEE, Oklahoma 74447",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-758-1167",
    "address": "2760 NORTH WOOD DR, OKMULGEE, Oklahoma 74447",
    "city": "OKMULGEE",
    "state": "Oklahoma",
    "zip": "74447",
    "lat": 35.6430639,
    "lng": -95.96315779999999
  },
  {
    "Store Location": "Tractor Supply 3008 NORTH 14TH ST PONCA CITY, Oklahoma 74601",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-762-0005",
    "address": "3008 NORTH 14TH ST PONCA, CITY, Oklahoma 74601",
    "city": "CITY",
    "state": "Oklahoma",
    "zip": "74601",
    "lat": 36.739502,
    "lng": -97.06821000000001
  },
  {
    "Store Location": "Tractor Supply 3105 WEST 3RD ST STE 100 ELK CITY, Oklahoma 73644",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-225-0150",
    "address": "3105 WEST 3RD ST STE 100 ELK, CITY, Oklahoma 73644",
    "city": "CITY",
    "state": "Oklahoma",
    "zip": "73644",
    "lat": 35.4124416,
    "lng": -99.44314209999999
  },
  {
    "Store Location": "Tractor Supply 330 EAST GRAND AVE CHICKASHA, Oklahoma 73018",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-224-0839",
    "address": "330 EAST GRAND AVE, CHICKASHA, Oklahoma 73018",
    "city": "CHICKASHA",
    "state": "Oklahoma",
    "zip": "73018",
    "lat": 35.0289722,
    "lng": -97.9301065
  },
  {
    "Store Location": "Tractor Supply 3403 SOUTHEAST WASHINGTON BLVD BARTLESVILLE, Oklahoma 74006",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-331-0367",
    "address": "3403 SOUTHEAST WASHINGTON BLVD, BARTLESVILLE, Oklahoma 74006",
    "city": "BARTLESVILLE",
    "state": "Oklahoma",
    "zip": "74006",
    "lat": 36.6984774,
    "lng": -95.93629829999999
  },
  {
    "Store Location": "Tractor Supply 3624 SOUTH PERKINS RD STILLWATER, Oklahoma 74074",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-707-0113",
    "address": "3624 SOUTH PERKINS RD, STILLWATER, Oklahoma 74074",
    "city": "STILLWATER",
    "state": "Oklahoma",
    "zip": "74074",
    "lat": 36.0810004,
    "lng": -97.05254
  },
  {
    "Store Location": "Tractor Supply 3829 SOUTH HIGHWAY 97 SAND SPRINGS, Oklahoma 74063",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-245-1370",
    "address": "3829 SOUTH HIGHWAY 97 SAND, SPRINGS, Oklahoma 74063",
    "city": "SPRINGS",
    "state": "Oklahoma",
    "zip": "74063",
    "lat": 36.1322771,
    "lng": -96.1159281
  },
  {
    "Store Location": "Tractor Supply 401 DAISY DR TAHLEQUAH, Oklahoma 74464",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-458-0451",
    "address": "401 DAISY DR, TAHLEQUAH, Oklahoma 74464",
    "city": "TAHLEQUAH",
    "state": "Oklahoma",
    "zip": "74464",
    "lat": 35.88946,
    "lng": -94.9815645
  },
  {
    "Store Location": "Tractor Supply 4010 W OWEN K GARRIOTT RD STE 100 ENID, Oklahoma 73703",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-234-5017",
    "address": "4010 W OWEN K GARRIOTT RD STE 100, ENID, Oklahoma 73703",
    "city": "ENID",
    "state": "Oklahoma",
    "zip": "73703",
    "lat": 36.3925911,
    "lng": -97.9270755
  },
  {
    "Store Location": "Tractor Supply 410 SOUTH GEORGE NIGH EXPY STE B MCALESTER, Oklahoma 74501",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-429-0963",
    "address": "410 SOUTH GEORGE NIGH EXPY STE B, MCALESTER, Oklahoma 74501",
    "city": "MCALESTER",
    "state": "Oklahoma",
    "zip": "74501",
    "lat": 34.9206921,
    "lng": -95.74284229999999
  },
  {
    "Store Location": "Tractor Supply 4777 EAST KENOSHA ST BROKEN ARROW, Oklahoma 74014",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-355-9077",
    "address": "4777 EAST KENOSHA ST BROKEN, ARROW, Oklahoma 74014",
    "city": "ARROW",
    "state": "Oklahoma",
    "zip": "74014",
    "lat": 36.0600396,
    "lng": -95.7333554
  },
  {
    "Store Location": "Tractor Supply 4850 SHAWNEE MISSION DR SHAWNEE, Oklahoma 74804",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-275-7894",
    "address": "4850 SHAWNEE MISSION DR, SHAWNEE, Oklahoma 74804",
    "city": "SHAWNEE",
    "state": "Oklahoma",
    "zip": "74804",
    "lat": 35.382185,
    "lng": -96.92390239999999
  },
  {
    "Store Location": "Tractor Supply 601 COMFORT DR EDMOND, Oklahoma 73013",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-478-0333",
    "address": "601 COMFORT DR, EDMOND, Oklahoma 73013",
    "city": "EDMOND",
    "state": "Oklahoma",
    "zip": "73013",
    "lat": 35.6167526,
    "lng": -97.4935093
  },
  {
    "Store Location": "Tractor Supply 700 NORTH MAIN ST BRISTOW, Oklahoma 74010",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-367-9907",
    "address": "700 NORTH MAIN ST, BRISTOW, Oklahoma 74010",
    "city": "BRISTOW",
    "state": "Oklahoma",
    "zip": "74010",
    "lat": 35.8403448,
    "lng": -96.3935881
  },
  {
    "Store Location": "Tractor Supply 722 HEATHER RD GUTHRIE, Oklahoma 73044",
    "Store Type": "Tractor Supply",
    "Phone Number": "405-282-2444",
    "address": "722 HEATHER RD, GUTHRIE, Oklahoma 73044",
    "city": "GUTHRIE",
    "state": "Oklahoma",
    "zip": "73044",
    "lat": 35.8848718,
    "lng": -97.3963429
  },
  {
    "Store Location": "Tractor Supply 7402 NORTHWEST SUN BLVD LAWTON, Oklahoma 73505",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-510-0407",
    "address": "7402 NORTHWEST SUN BLVD, LAWTON, Oklahoma 73505",
    "city": "LAWTON",
    "state": "Oklahoma",
    "zip": "73505",
    "lat": 34.6297772,
    "lng": -98.48313180000001
  },
  {
    "Store Location": "Tractor Supply 810 WEST ROGERS BLVD SKIATOOK, Oklahoma 74070",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-396-5110",
    "address": "810 WEST ROGERS BLVD, SKIATOOK, Oklahoma 74070",
    "city": "SKIATOOK",
    "state": "Oklahoma",
    "zip": "74070",
    "lat": 36.367389,
    "lng": -96.0139174
  },
  {
    "Store Location": "Tractor Supply 8975 E 530 Road CLAREMORE, Oklahoma 74017",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-342-2223",
    "address": "8975 E 530 Road, CLAREMORE, Oklahoma 74017",
    "city": "CLAREMORE",
    "state": "Oklahoma",
    "zip": "74017",
    "lat": 36.2504643,
    "lng": -95.67006429999999
  },
  {
    "Store Location": "Tractor Supply 901 SOUTHEAST WASHINGTON ST IDABEL, Oklahoma 74745",
    "Store Type": "Tractor Supply",
    "Phone Number": "580-208-2310",
    "address": "901 SOUTHEAST WASHINGTON ST, IDABEL, Oklahoma 74745",
    "city": "IDABEL",
    "state": "Oklahoma",
    "zip": "74745",
    "lat": 33.8958898,
    "lng": -94.8122314
  },
  {
    "Store Location": "Tractor Supply 920 HWY 2 NORTH WILBURTON, Oklahoma 74578",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-465-5695",
    "address": "920 HWY 2 NORTH, WILBURTON, Oklahoma 74578",
    "city": "WILBURTON",
    "state": "Oklahoma",
    "zip": "74578",
    "lat": 34.905513,
    "lng": -95.3232776
  },
  {
    "Store Location": "Tractor Supply 935 SOUTH MILL ST PRYOR, Oklahoma 74361",
    "Store Type": "Tractor Supply",
    "Phone Number": "918-825-3364",
    "address": "935 SOUTH MILL ST, PRYOR, Oklahoma 74361",
    "city": "PRYOR",
    "state": "Oklahoma",
    "zip": "74361",
    "lat": 36.2914387,
    "lng": -95.32258600000002
  },
  {
    "Store Location": "Tractor Supply 110 PETITE STREET MYRTLE CREEK, Oregon 97457",
    "Store Type": "Tractor Supply",
    "Phone Number": "541-863-3111",
    "address": "110 PETITE STREET MYRTLE, CREEK, Oregon 97457",
    "city": "CREEK",
    "state": "Oregon",
    "zip": "97457",
    "lat": 42.971985,
    "lng": -123.34004
  },
  {
    "Store Location": "Tractor Supply 1427 NORTHEAST 7TH ST GRANTS PASS, Oregon 97526",
    "Store Type": "Tractor Supply",
    "Phone Number": "541-474-4321",
    "address": "1427 NORTHEAST 7TH ST GRANTS, PASS, Oregon 97526",
    "city": "PASS",
    "state": "Oregon",
    "zip": "97526",
    "lat": 42.45431869999999,
    "lng": -123.3200772
  },
  {
    "Store Location": "Tractor Supply 1494 SOUTHWEST 4TH AVE ONTARIO, Oregon 97914",
    "Store Type": "Tractor Supply",
    "Phone Number": "541-889-5768",
    "address": "1494 SOUTHWEST 4TH AVE, ONTARIO, Oregon 97914",
    "city": "ONTARIO",
    "state": "Oregon",
    "zip": "97914",
    "lat": 44.023857,
    "lng": -116.98717
  },
  {
    "Store Location": "Tractor Supply 16325 CHAMPION WAY SANDY, Oregon 97055",
    "Store Type": "Tractor Supply",
    "Phone Number": "503-668-2868",
    "address": "16325 CHAMPION WAY, SANDY, Oregon 97055",
    "city": "SANDY",
    "state": "Oregon",
    "zip": "97055",
    "lat": 45.4061031,
    "lng": -122.2965633
  },
  {
    "Store Location": "Tractor Supply 190 EMERALD PKWY CRESWELL, Oregon 97426",
    "Store Type": "Tractor Supply",
    "Phone Number": "541-895-2545",
    "address": "190 EMERALD PKWY, CRESWELL, Oregon 97426",
    "city": "CRESWELL",
    "state": "Oregon",
    "zip": "97426",
    "lat": 43.9188996,
    "lng": -123.0066328
  },
  {
    "Store Location": "Tractor Supply 328 DAKOTA ST SUTHERLIN, Oregon 97479",
    "Store Type": "Tractor Supply",
    "Phone Number": "541-459-3040",
    "address": "328 DAKOTA ST, SUTHERLIN, Oregon 97479",
    "city": "SUTHERLIN",
    "state": "Oregon",
    "zip": "97479",
    "lat": 43.38815,
    "lng": -123.34162
  },
  {
    "Store Location": "Tractor Supply 94622 HIGHWAY 99 EAST JUNCTION CITY, Oregon 97448",
    "Store Type": "Tractor Supply",
    "Phone Number": "458-217-0470",
    "address": "94622 HIGHWAY 99 EAST JUNCTION, CITY, Oregon 97448",
    "city": "CITY",
    "state": "Oregon",
    "zip": "97448",
    "lat": 44.2322973,
    "lng": -123.2028301
  },
  {
    "Store Location": "Tractor Supply 100 NOBLE BLVD STE 30 CARLISLE, Pennsylvania 17013",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-240-0632",
    "address": "100 NOBLE BLVD STE 30, CARLISLE, Pennsylvania 17013",
    "city": "CARLISLE",
    "state": "Pennsylvania",
    "zip": "17013",
    "lat": 40.1885589,
    "lng": -77.1964114
  },
  {
    "Store Location": "Tractor Supply 100 TRACTOR LN GIBSONIA, Pennsylvania 15044",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-449-5700",
    "address": "100 TRACTOR LN, GIBSONIA, Pennsylvania 15044",
    "city": "GIBSONIA",
    "state": "Pennsylvania",
    "zip": "15044",
    "lat": 40.6630398,
    "lng": -79.9316468
  },
  {
    "Store Location": "Tractor Supply 1001 EAST MAIN ST STE 1 BRADFORD, Pennsylvania 16701",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-368-3845",
    "address": "1001 EAST MAIN ST STE 1, BRADFORD, Pennsylvania 16701",
    "city": "BRADFORD",
    "state": "Pennsylvania",
    "zip": "16701",
    "lat": 41.9774178,
    "lng": -78.6183724
  },
  {
    "Store Location": "Tractor Supply 1005 SOUTH SAINT MARYS ST SAINT MARYS, Pennsylvania 15857",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-781-1030",
    "address": "1005 SOUTH SAINT MARYS ST SAINT, MARYS, Pennsylvania 15857",
    "city": "MARYS",
    "state": "Pennsylvania",
    "zip": "15857",
    "lat": 41.3995871,
    "lng": -78.55702289999999
  },
  {
    "Store Location": "Tractor Supply 1008 LANCASTER PIKE QUARRYVILLE, Pennsylvania 17566",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-284-2255",
    "address": "1008 LANCASTER PIKE, QUARRYVILLE, Pennsylvania 17566",
    "city": "QUARRYVILLE",
    "state": "Pennsylvania",
    "zip": "17566",
    "lat": 39.8707714,
    "lng": -76.22914039999999
  },
  {
    "Store Location": "Tractor Supply 1038 RTE 30 WEST STE 310 LATROBE, Pennsylvania 15650",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-537-7822",
    "address": "1038 RTE 30 WEST STE 310, LATROBE, Pennsylvania 15650",
    "city": "LATROBE",
    "state": "Pennsylvania",
    "zip": "15650",
    "lat": 40.3779453,
    "lng": -79.8039598
  },
  {
    "Store Location": "Tractor Supply 10410 US HIGHWAY 522 S STE B LEWISTOWN, Pennsylvania 17044",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-248-5590",
    "address": "10410 US HIGHWAY 522 S STE B, LEWISTOWN, Pennsylvania 17044",
    "city": "LEWISTOWN",
    "state": "Pennsylvania",
    "zip": "17044",
    "lat": 40.5552406,
    "lng": -77.6656098
  },
  {
    "Store Location": "Tractor Supply 1150 CARLISLE ST STE 12 HANOVER, Pennsylvania 17331",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-630-0555",
    "address": "1150 CARLISLE ST STE 12, HANOVER, Pennsylvania 17331",
    "city": "HANOVER",
    "state": "Pennsylvania",
    "zip": "17331",
    "lat": 39.821697,
    "lng": -76.99902
  },
  {
    "Store Location": "Tractor Supply 11512 HYDETOWN RD TITUSVILLE, Pennsylvania 16354",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-827-1111",
    "address": "11512 HYDETOWN RD, TITUSVILLE, Pennsylvania 16354",
    "city": "TITUSVILLE",
    "state": "Pennsylvania",
    "zip": "16354",
    "lat": 41.635169,
    "lng": -79.69796760000001
  },
  {
    "Store Location": "Tractor Supply 12 RTE 6 PLZ TUNKHANNOCK, Pennsylvania 18657",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-836-8376",
    "address": "12 RTE 6 PLZ, TUNKHANNOCK, Pennsylvania 18657",
    "city": "TUNKHANNOCK",
    "state": "Pennsylvania",
    "zip": "18657",
    "lat": 41.5386878,
    "lng": -75.94658799999999
  },
  {
    "Store Location": "Tractor Supply 121 WEST STEUBEN ST OAKDALE, Pennsylvania 15071",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-695-3626",
    "address": "121 WEST STEUBEN ST, OAKDALE, Pennsylvania 15071",
    "city": "OAKDALE",
    "state": "Pennsylvania",
    "zip": "15071",
    "lat": 40.4404228,
    "lng": -80.2428638
  },
  {
    "Store Location": "Tractor Supply 122 MOSSIDE BLVD N VERSAILLES, Pennsylvania 15137",
    "Store Type": "Tractor Supply",
    "Phone Number": "412-824-8555",
    "address": "122 MOSSIDE BLVD N, VERSAILLES, Pennsylvania 15137",
    "city": "VERSAILLES",
    "state": "Pennsylvania",
    "zip": "15137",
    "lat": 40.3702875,
    "lng": -79.777368
  },
  {
    "Store Location": "Tractor Supply 124 HOGAN BLVD MILL HALL, Pennsylvania 17751",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-748-6172",
    "address": "124 HOGAN BLVD MILL, HALL, Pennsylvania 17751",
    "city": "HALL",
    "state": "Pennsylvania",
    "zip": "17751",
    "lat": 41.1183912,
    "lng": -77.47364429999999
  },
  {
    "Store Location": "Tractor Supply 1341 S MAIN AVE STE 380 SCRANTON, Pennsylvania 18504",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-344-3714",
    "address": "1341 S MAIN AVE STE 380, SCRANTON, Pennsylvania 18504",
    "city": "SCRANTON",
    "state": "Pennsylvania",
    "zip": "18504",
    "lat": 41.39297200000001,
    "lng": -75.68745349999999
  },
  {
    "Store Location": "Tractor Supply 1360 STRICKLER RD MOUNT JOY, Pennsylvania 17552",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-492-0070",
    "address": "1360 STRICKLER RD MOUNT, JOY, Pennsylvania 17552",
    "city": "JOY",
    "state": "Pennsylvania",
    "zip": "17552",
    "lat": 40.1136407,
    "lng": -76.45741439999999
  },
  {
    "Store Location": "Tractor Supply 1399 COLUMBIA RD BLOOMSBURG, Pennsylvania 17815",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-784-4604",
    "address": "1399 COLUMBIA RD, BLOOMSBURG, Pennsylvania 17815",
    "city": "BLOOMSBURG",
    "state": "Pennsylvania",
    "zip": "17815",
    "lat": 41.0548621,
    "lng": -76.5654081
  },
  {
    "Store Location": "Tractor Supply 142 MCKINLEY RD BEAVER FALLS, Pennsylvania 15010",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-843-1096",
    "address": "142 MCKINLEY RD BEAVER, FALLS, Pennsylvania 15010",
    "city": "FALLS",
    "state": "Pennsylvania",
    "zip": "15010",
    "lat": 40.781968,
    "lng": -80.38811919999999
  },
  {
    "Store Location": "Tractor Supply 1424 WEST MAIN ST EXT STE 1 GROVE CITY, Pennsylvania 16127",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-458-0224",
    "address": "1424 WEST MAIN ST EXT STE 1 GROVE, CITY, Pennsylvania 16127",
    "city": "CITY",
    "state": "Pennsylvania",
    "zip": "16127",
    "lat": 41.1667875,
    "lng": -80.10807160000002
  },
  {
    "Store Location": "Tractor Supply 1430 SOUTH MAIN ST MANSFIELD, Pennsylvania 16933",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-662-1136",
    "address": "1430 SOUTH MAIN ST, MANSFIELD, Pennsylvania 16933",
    "city": "MANSFIELD",
    "state": "Pennsylvania",
    "zip": "16933",
    "lat": 41.78026930000001,
    "lng": -77.0712478
  },
  {
    "Store Location": "Tractor Supply 148 ALAMEDA PLZ BUTLER, Pennsylvania 16001",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-287-0050",
    "address": "148 ALAMEDA PLZ, BUTLER, Pennsylvania 16001",
    "city": "BUTLER",
    "state": "Pennsylvania",
    "zip": "16001",
    "lat": 40.8722772,
    "lng": -79.9323869
  },
  {
    "Store Location": "Tractor Supply 1503 EAST MAIN ST WAYNESBORO, Pennsylvania 17268",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-765-4141",
    "address": "1503 EAST MAIN ST, WAYNESBORO, Pennsylvania 17268",
    "city": "WAYNESBORO",
    "state": "Pennsylvania",
    "zip": "17268",
    "lat": 39.74595739999999,
    "lng": -77.5539905
  },
  {
    "Store Location": "Tractor Supply 151 TOWER RD NEW HOLLAND, Pennsylvania 17557",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-354-0608",
    "address": "151 TOWER RD NEW, HOLLAND, Pennsylvania 17557",
    "city": "HOLLAND",
    "state": "Pennsylvania",
    "zip": "17557",
    "lat": 40.1123631,
    "lng": -76.06770949999999
  },
  {
    "Store Location": "Tractor Supply 1534 NORTH CENTER AVE STE 100 SOMERSET, Pennsylvania 15501",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-443-9913",
    "address": "1534 NORTH CENTER AVE STE 100, SOMERSET, Pennsylvania 15501",
    "city": "SOMERSET",
    "state": "Pennsylvania",
    "zip": "15501",
    "lat": 40.0335618,
    "lng": -79.07342059999999
  },
  {
    "Store Location": "Tractor Supply 1580 RTE 209 BRODHEADSVILLE, Pennsylvania 18322",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-992-1824",
    "address": "1580 RTE 209, BRODHEADSVILLE, Pennsylvania 18322",
    "city": "BRODHEADSVILLE",
    "state": "Pennsylvania",
    "zip": "18322",
    "lat": 40.9169158,
    "lng": -75.410527
  },
  {
    "Store Location": "Tractor Supply 16083 CONNEAUT LAKE RD MEADVILLE, Pennsylvania 16335",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-337-7249",
    "address": "16083 CONNEAUT LAKE RD, MEADVILLE, Pennsylvania 16335",
    "city": "MEADVILLE",
    "state": "Pennsylvania",
    "zip": "16335",
    "lat": 41.6193349,
    "lng": -80.21409249999999
  },
  {
    "Store Location": "Tractor Supply 1701 ELMIRA ST SAYRE, Pennsylvania 18840",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-888-3800",
    "address": "1701 ELMIRA ST, SAYRE, Pennsylvania 18840",
    "city": "SAYRE",
    "state": "Pennsylvania",
    "zip": "18840",
    "lat": 41.9729886,
    "lng": -76.5414748
  },
  {
    "Store Location": "Tractor Supply 1720 RIVER RD CLEARFIELD, Pennsylvania 16830",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-762-2226",
    "address": "1720 RIVER RD, CLEARFIELD, Pennsylvania 16830",
    "city": "CLEARFIELD",
    "state": "Pennsylvania",
    "zip": "16830",
    "lat": 41.0295028,
    "lng": -78.4127489
  },
  {
    "Store Location": "Tractor Supply 1733 LINCOLN WAY EAST CHAMBERSBURG, Pennsylvania 17201",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-263-5729",
    "address": "1733 LINCOLN WAY EAST, CHAMBERSBURG, Pennsylvania 17201",
    "city": "CHAMBERSBURG",
    "state": "Pennsylvania",
    "zip": "17201",
    "lat": 39.9251097,
    "lng": -77.60561489999999
  },
  {
    "Store Location": "Tractor Supply 176 FINLEY RD ROSTRAVER TOWNSHIP, Pennsylvania 15012",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-929-5200",
    "address": "176 FINLEY RD ROSTRAVER, TOWNSHIP, Pennsylvania 15012",
    "city": "TOWNSHIP",
    "state": "Pennsylvania",
    "zip": "15012",
    "lat": 40.137579,
    "lng": -79.8366984
  },
  {
    "Store Location": "Tractor Supply 17856 STATE RTE 706 MONTROSE, Pennsylvania 18801",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-278-7466",
    "address": "17856 STATE RTE 706, MONTROSE, Pennsylvania 18801",
    "city": "MONTROSE",
    "state": "Pennsylvania",
    "zip": "18801",
    "lat": 41.8368816,
    "lng": -75.8319966
  },
  {
    "Store Location": "Tractor Supply 1980 QUENTIN RD LEBANON, Pennsylvania 17042",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-274-2106",
    "address": "1980 QUENTIN RD, LEBANON, Pennsylvania 17042",
    "city": "LEBANON",
    "state": "Pennsylvania",
    "zip": "17042",
    "lat": 40.3084012,
    "lng": -76.42285559999999
  },
  {
    "Store Location": "Tractor Supply 2000 SHELLY DR INDIANA, Pennsylvania 15701",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-465-4190",
    "address": "2000 SHELLY DR, INDIANA, Pennsylvania 15701",
    "city": "INDIANA",
    "state": "Pennsylvania",
    "zip": "15701",
    "lat": 40.62196489999999,
    "lng": -79.18738909999999
  },
  {
    "Store Location": "Tractor Supply 2002 OLD RTE 220 NORTH DUNCANSVILLE, Pennsylvania 16635",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-696-9099",
    "address": "2002 OLD RTE 220 NORTH, DUNCANSVILLE, Pennsylvania 16635",
    "city": "DUNCANSVILLE",
    "state": "Pennsylvania",
    "zip": "16635",
    "lat": 40.4472282,
    "lng": -78.40883330000001
  },
  {
    "Store Location": "Tractor Supply 20860 RTE 19 CRANBERRY TOWNSHIP, Pennsylvania 16066",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-453-1870",
    "address": "20860 RTE 19 CRANBERRY, TOWNSHIP, Pennsylvania 16066",
    "city": "TOWNSHIP",
    "state": "Pennsylvania",
    "zip": "16066",
    "lat": 40.7190744,
    "lng": -80.1040846
  },
  {
    "Store Location": "Tractor Supply 216 SUSQUEHANNA BLVD WEST HAZLETON, Pennsylvania 18202",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-455-4262",
    "address": "216 SUSQUEHANNA BLVD WEST, HAZLETON, Pennsylvania 18202",
    "city": "HAZLETON",
    "state": "Pennsylvania",
    "zip": "18202",
    "lat": 40.9682379,
    "lng": -76.0110239
  },
  {
    "Store Location": "Tractor Supply 218 HARTMAN BRIDGE RD RONKS, Pennsylvania 17572",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-687-7642",
    "address": "218 HARTMAN BRIDGE RD, RONKS, Pennsylvania 17572",
    "city": "RONKS",
    "state": "Pennsylvania",
    "zip": "17572",
    "lat": 40.0024289,
    "lng": -76.1857603
  },
  {
    "Store Location": "Tractor Supply 22725 RTE 187 WYSOX, Pennsylvania 18854",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-265-1900",
    "address": "22725 RTE 187, WYSOX, Pennsylvania 18854",
    "city": "WYSOX",
    "state": "Pennsylvania",
    "zip": "18854",
    "lat": 41.7581395,
    "lng": -76.3842387
  },
  {
    "Store Location": "Tractor Supply 2275 DOWNS DR ERIE, Pennsylvania 16509",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-866-1324",
    "address": "2275 DOWNS DR, ERIE, Pennsylvania 16509",
    "city": "ERIE",
    "state": "Pennsylvania",
    "zip": "16509",
    "lat": 42.0483046,
    "lng": -80.0890927
  },
  {
    "Store Location": "Tractor Supply 240 CROSS ROADS PLZ MOUNT PLEASANT, Pennsylvania 15666",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-547-5610",
    "address": "240 CROSS ROADS PLZ MOUNT, PLEASANT, Pennsylvania 15666",
    "city": "PLEASANT",
    "state": "Pennsylvania",
    "zip": "15666",
    "lat": 40.123151,
    "lng": -79.553097
  },
  {
    "Store Location": "Tractor Supply 240 WILLOW AVE HONESDALE, Pennsylvania 18431",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-253-2300",
    "address": "240 WILLOW AVE, HONESDALE, Pennsylvania 18431",
    "city": "HONESDALE",
    "state": "Pennsylvania",
    "zip": "18431",
    "lat": 41.5648117,
    "lng": -75.2499886
  },
  {
    "Store Location": "Tractor Supply 2456 SANS SOUCI PKWY WILKES BARRE, Pennsylvania 18706",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-735-5080",
    "address": "2456 SANS SOUCI PKWY WILKES, BARRE, Pennsylvania 18706",
    "city": "BARRE",
    "state": "Pennsylvania",
    "zip": "18706",
    "lat": 41.20812950000001,
    "lng": -75.9772716
  },
  {
    "Store Location": "Tractor Supply 25 WILLIAMSON RD STE 110 GREENVILLE, Pennsylvania 16125",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-588-0824",
    "address": "25 WILLIAMSON RD STE 110, GREENVILLE, Pennsylvania 16125",
    "city": "GREENVILLE",
    "state": "Pennsylvania",
    "zip": "16125",
    "lat": 41.4108651,
    "lng": -80.35716479999999
  },
  {
    "Store Location": "Tractor Supply 26 COMMERCE RD CLARION, Pennsylvania 16214",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-227-2580",
    "address": "26 COMMERCE RD, CLARION, Pennsylvania 16214",
    "city": "CLARION",
    "state": "Pennsylvania",
    "zip": "16214",
    "lat": 41.1817169,
    "lng": -79.3962687
  },
  {
    "Store Location": "Tractor Supply 265 HARLEYSVILLE PIKE HARLEYSVILLE, Pennsylvania 19438",
    "Store Type": "Tractor Supply",
    "Phone Number": "215-256-6555",
    "address": "265 HARLEYSVILLE PIKE, HARLEYSVILLE, Pennsylvania 19438",
    "city": "HARLEYSVILLE",
    "state": "Pennsylvania",
    "zip": "19438",
    "lat": 40.2841792,
    "lng": -75.39154959999999
  },
  {
    "Store Location": "Tractor Supply 271 SUEDBERG ROAD PINE GROVE, Pennsylvania 17963",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-345-4477",
    "address": "271 SUEDBERG ROAD PINE, GROVE, Pennsylvania 17963",
    "city": "GROVE",
    "state": "Pennsylvania",
    "zip": "17963",
    "lat": 40.5349038,
    "lng": -76.4108783
  },
  {
    "Store Location": "Tractor Supply 2970 RTE 940 POCONO SUMMIT, Pennsylvania 18346",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-839-9460",
    "address": "2970 RTE 940 POCONO, SUMMIT, Pennsylvania 18346",
    "city": "SUMMIT",
    "state": "Pennsylvania",
    "zip": "18346",
    "lat": 41.1152157,
    "lng": -75.38095969999999
  },
  {
    "Store Location": "Tractor Supply 2998 EAST STATE ST HERMITAGE, Pennsylvania 16148",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-982-4440",
    "address": "2998 EAST STATE ST, HERMITAGE, Pennsylvania 16148",
    "city": "HERMITAGE",
    "state": "Pennsylvania",
    "zip": "16148",
    "lat": 41.229276,
    "lng": -80.4546419
  },
  {
    "Store Location": "Tractor Supply 30 BALDWIN BLVD STE 30 SHAMOKIN DAM, Pennsylvania 17876",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-743-4423",
    "address": "30 BALDWIN BLVD STE 30 SHAMOKIN, DAM, Pennsylvania 17876",
    "city": "DAM",
    "state": "Pennsylvania",
    "zip": "17876",
    "lat": 40.8544862,
    "lng": -76.816007
  },
  {
    "Store Location": "Tractor Supply 31 FRANKLIN VILLAGE MALL KITTANNING, Pennsylvania 16201",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-545-1783",
    "address": "31 FRANKLIN VILLAGE MALL, KITTANNING, Pennsylvania 16201",
    "city": "KITTANNING",
    "state": "Pennsylvania",
    "zip": "16201",
    "lat": 40.81352,
    "lng": -79.54858399999999
  },
  {
    "Store Location": "Tractor Supply 321 NORTH THIRD ST OXFORD, Pennsylvania 19363",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-932-6049",
    "address": "321 NORTH THIRD ST, OXFORD, Pennsylvania 19363",
    "city": "OXFORD",
    "state": "Pennsylvania",
    "zip": "19363",
    "lat": 39.7941371,
    "lng": -75.9757144
  },
  {
    "Store Location": "Tractor Supply 3218 CAPE HORN RD RED LION, Pennsylvania 17356",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-244-7474",
    "address": "3218 CAPE HORN RD RED, LION, Pennsylvania 17356",
    "city": "LION",
    "state": "Pennsylvania",
    "zip": "17356",
    "lat": 39.9140058,
    "lng": -76.6295461
  },
  {
    "Store Location": "Tractor Supply 366 SOUTH 2ND ST MCCONNELLSBURG, Pennsylvania 17233",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7532",
    "address": "366 SOUTH 2ND ST, MCCONNELLSBURG, Pennsylvania 17233",
    "city": "MCCONNELLSBURG",
    "state": "Pennsylvania",
    "zip": "17233",
    "lat": 39.92626,
    "lng": -78.000649
  },
  {
    "Store Location": "Tractor Supply 376 DWORMAN LN NEW CASTLE, Pennsylvania 16101",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-657-2856",
    "address": "376 DWORMAN LN NEW, CASTLE, Pennsylvania 16101",
    "city": "CASTLE",
    "state": "Pennsylvania",
    "zip": "16101",
    "lat": 41.016923,
    "lng": -80.3937989
  },
  {
    "Store Location": "Tractor Supply 390 WEST COLUMBUS AVE US RTE 6 CORRY, Pennsylvania 16407",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-664-5853",
    "address": "390 WEST COLUMBUS AVE US RTE 6, CORRY, Pennsylvania 16407",
    "city": "CORRY",
    "state": "Pennsylvania",
    "zip": "16407",
    "lat": 41.933867,
    "lng": -79.655298
  },
  {
    "Store Location": "Tractor Supply 40 SHIPPENSBURG SHOPPING CTR SHIPPENSBURG, Pennsylvania 17257",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-477-0932",
    "address": "40 SHIPPENSBURG SHOPPING CTR, SHIPPENSBURG, Pennsylvania 17257",
    "city": "SHIPPENSBURG",
    "state": "Pennsylvania",
    "zip": "17257",
    "lat": 40.0577466,
    "lng": -77.4991409
  },
  {
    "Store Location": "Tractor Supply 4015 FREEPORT RD NATRONA HEIGHTS, Pennsylvania 15065",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-224-1292",
    "address": "4015 FREEPORT RD NATRONA, HEIGHTS, Pennsylvania 15065",
    "city": "HEIGHTS",
    "state": "Pennsylvania",
    "zip": "15065",
    "lat": 40.6469288,
    "lng": -79.71014439999999
  },
  {
    "Store Location": "Tractor Supply 4037 JANDY BLVD NAZARETH, Pennsylvania 18064",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-746-9562",
    "address": "4037 JANDY BLVD, NAZARETH, Pennsylvania 18064",
    "city": "NAZARETH",
    "state": "Pennsylvania",
    "zip": "18064",
    "lat": 40.7300508,
    "lng": -75.3077189
  },
  {
    "Store Location": "Tractor Supply 42 EASTERN MALL DR MUNCY, Pennsylvania 17756",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-546-0700",
    "address": "42 EASTERN MALL DR, MUNCY, Pennsylvania 17756",
    "city": "MUNCY",
    "state": "Pennsylvania",
    "zip": "17756",
    "lat": 41.2361576,
    "lng": -76.8233994
  },
  {
    "Store Location": "Tractor Supply 4210 MARKET ST WARREN, Pennsylvania 16365",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-726-0906",
    "address": "4210 MARKET ST, WARREN, Pennsylvania 16365",
    "city": "WARREN",
    "state": "Pennsylvania",
    "zip": "16365",
    "lat": 41.89962750000001,
    "lng": -79.14867989999999
  },
  {
    "Store Location": "Tractor Supply 425 BEAVER DR DUBOIS, Pennsylvania 15801",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-375-7190",
    "address": "425 BEAVER DR, DUBOIS, Pennsylvania 15801",
    "city": "DUBOIS",
    "state": "Pennsylvania",
    "zip": "15801",
    "lat": 41.1228478,
    "lng": -78.74261419999999
  },
  {
    "Store Location": "Tractor Supply 435 EAST UWCHLAN AVE CHESTER SPRINGS, Pennsylvania 19425",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-363-3633",
    "address": "435 EAST UWCHLAN AVE CHESTER, SPRINGS, Pennsylvania 19425",
    "city": "SPRINGS",
    "state": "Pennsylvania",
    "zip": "19425",
    "lat": 40.0653641,
    "lng": -75.6495249
  },
  {
    "Store Location": "Tractor Supply 454 HAMLIN HWY STE 100A LAKE ARIEL, Pennsylvania 18436",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-689-7990",
    "address": "454 HAMLIN HWY STE 100A LAKE, ARIEL, Pennsylvania 18436",
    "city": "ARIEL",
    "state": "Pennsylvania",
    "zip": "18436",
    "lat": 41.4029607,
    "lng": -75.4178113
  },
  {
    "Store Location": "Tractor Supply 460 WASHINGTON RD STE 15 WASHINGTON, Pennsylvania 15301",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-223-4934",
    "address": "460 WASHINGTON RD STE 15, WASHINGTON, Pennsylvania 15301",
    "city": "WASHINGTON",
    "state": "Pennsylvania",
    "zip": "15301",
    "lat": 40.1876325,
    "lng": -80.2172844
  },
  {
    "Store Location": "Tractor Supply 4724 PENN AVE SUITE A READING, Pennsylvania 19608",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-678-6677",
    "address": "4724 PENN AVE SUITE A, READING, Pennsylvania 19608",
    "city": "READING",
    "state": "Pennsylvania",
    "zip": "19608",
    "lat": 40.3257163,
    "lng": -76.04653410000002
  },
  {
    "Store Location": "Tractor Supply 475 RTE 6 AND 209 MILFORD, Pennsylvania 18337",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-296-6719",
    "address": "475 RTE 6 AND 209, MILFORD, Pennsylvania 18337",
    "city": "MILFORD",
    "state": "Pennsylvania",
    "zip": "18337",
    "lat": 41.322316,
    "lng": -74.8023882
  },
  {
    "Store Location": "Tractor Supply 486 BLAKESLEE BLVD DR WEST LEHIGHTON, Pennsylvania 18235",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-386-3584",
    "address": "486 BLAKESLEE BLVD DR WEST, LEHIGHTON, Pennsylvania 18235",
    "city": "LEHIGHTON",
    "state": "Pennsylvania",
    "zip": "18235",
    "lat": 40.7991663,
    "lng": -75.7755059
  },
  {
    "Store Location": "Tractor Supply 4955 STATE RTE 209 ELIZABETHVILLE, Pennsylvania 17023",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-362-4027",
    "address": "4955 STATE RTE 209, ELIZABETHVILLE, Pennsylvania 17023",
    "city": "ELIZABETHVILLE",
    "state": "Pennsylvania",
    "zip": "17023",
    "lat": 40.5484688,
    "lng": -76.8146609
  },
  {
    "Store Location": "Tractor Supply 510 RENAISSANCE DR NEW FREEDOM, Pennsylvania 17349",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-235-8791",
    "address": "510 RENAISSANCE DR NEW, FREEDOM, Pennsylvania 17349",
    "city": "FREEDOM",
    "state": "Pennsylvania",
    "zip": "17349",
    "lat": 39.771801,
    "lng": -76.6614263
  },
  {
    "Store Location": "Tractor Supply 5370 ALLENTOWN PIKE STE A TEMPLE, Pennsylvania 19560",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-929-2134",
    "address": "5370 ALLENTOWN PIKE STE A, TEMPLE, Pennsylvania 19560",
    "city": "TEMPLE",
    "state": "Pennsylvania",
    "zip": "19560",
    "lat": 40.4155244,
    "lng": -75.9229064
  },
  {
    "Store Location": "Tractor Supply 55 SUGAR RUN RD STE 101 WAYNESBURG, Pennsylvania 15370",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-627-0975",
    "address": "55 SUGAR RUN RD STE 101, WAYNESBURG, Pennsylvania 15370",
    "city": "WAYNESBURG",
    "state": "Pennsylvania",
    "zip": "15370",
    "lat": 39.8947593,
    "lng": -80.17083339999999
  },
  {
    "Store Location": "Tractor Supply 550 TERRY RICH BLVD SAINT CLAIR, Pennsylvania 17970",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-429-2700",
    "address": "550 TERRY RICH BLVD SAINT, CLAIR, Pennsylvania 17970",
    "city": "CLAIR",
    "state": "Pennsylvania",
    "zip": "17970",
    "lat": 40.7281992,
    "lng": -76.187767
  },
  {
    "Store Location": "Tractor Supply 557 WEST MAHONING ST PUNXSUTAWNEY, Pennsylvania 15767",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-938-8012",
    "address": "557 WEST MAHONING ST, PUNXSUTAWNEY, Pennsylvania 15767",
    "city": "PUNXSUTAWNEY",
    "state": "Pennsylvania",
    "zip": "15767",
    "lat": 40.9409661,
    "lng": -78.9823775
  },
  {
    "Store Location": "Tractor Supply 575 MORGANTOWN RD STE 900 UNIONTOWN, Pennsylvania 15401",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-430-0870",
    "address": "575 MORGANTOWN RD STE 900, UNIONTOWN, Pennsylvania 15401",
    "city": "UNIONTOWN",
    "state": "Pennsylvania",
    "zip": "15401",
    "lat": 39.8846824,
    "lng": -79.7342038
  },
  {
    "Store Location": "Tractor Supply 60 SMITH RD GETTYSBURG, Pennsylvania 17325",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-337-1333",
    "address": "60 SMITH RD, GETTYSBURG, Pennsylvania 17325",
    "city": "GETTYSBURG",
    "state": "Pennsylvania",
    "zip": "17325",
    "lat": 39.8495359,
    "lng": -77.18819309999999
  },
  {
    "Store Location": "Tractor Supply 600 SCRANTON CARBONDALE HWY STE 100 EYNON, Pennsylvania 18403",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-876-3030",
    "address": "600 SCRANTON CARBONDALE HWY STE 100, EYNON, Pennsylvania 18403",
    "city": "EYNON",
    "state": "Pennsylvania",
    "zip": "18403",
    "lat": 41.50524,
    "lng": -75.57804999999999
  },
  {
    "Store Location": "Tractor Supply 640 GALLERIA DR JOHNSTOWN, Pennsylvania 15904",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-269-9515",
    "address": "640 GALLERIA DR, JOHNSTOWN, Pennsylvania 15904",
    "city": "JOHNSTOWN",
    "state": "Pennsylvania",
    "zip": "15904",
    "lat": 40.2977521,
    "lng": -78.8296652
  },
  {
    "Store Location": "Tractor Supply 6719 EASTON RD BEDMINSTER, Pennsylvania 18947",
    "Store Type": "Tractor Supply",
    "Phone Number": "215-766-2171",
    "address": "6719 EASTON RD, BEDMINSTER, Pennsylvania 18947",
    "city": "BEDMINSTER",
    "state": "Pennsylvania",
    "zip": "18947",
    "lat": 40.4127428,
    "lng": -75.149705
  },
  {
    "Store Location": "Tractor Supply 6885 US 322 FRANKLIN, Pennsylvania 16323",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-676-1535",
    "address": "6885 US 322, FRANKLIN, Pennsylvania 16323",
    "city": "FRANKLIN",
    "state": "Pennsylvania",
    "zip": "16323",
    "lat": 41.35317970000001,
    "lng": -79.7207947
  },
  {
    "Store Location": "Tractor Supply 70 W 28TH DIVISION HWY LITITZ, Pennsylvania 17543",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-624-0180",
    "address": "70 W 28TH DIVISION HWY, LITITZ, Pennsylvania 17543",
    "city": "LITITZ",
    "state": "Pennsylvania",
    "zip": "17543",
    "lat": 40.2263838,
    "lng": -76.305838
  },
  {
    "Store Location": "Tractor Supply 7150 ALLENTOWN BLVD HARRISBURG, Pennsylvania 17112",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-657-3945",
    "address": "7150 ALLENTOWN BLVD, HARRISBURG, Pennsylvania 17112",
    "city": "HARRISBURG",
    "state": "Pennsylvania",
    "zip": "17112",
    "lat": 40.331596,
    "lng": -76.7500297
  },
  {
    "Store Location": "Tractor Supply 725 MANOR RD DELMONT, Pennsylvania 15626",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-387-1768",
    "address": "725 MANOR RD, DELMONT, Pennsylvania 15626",
    "city": "DELMONT",
    "state": "Pennsylvania",
    "zip": "15626",
    "lat": 40.4045551,
    "lng": -79.5955599
  },
  {
    "Store Location": "Tractor Supply 735 NORTH WEST END BLVD QUAKERTOWN, Pennsylvania 18951",
    "Store Type": "Tractor Supply",
    "Phone Number": "215-536-2040",
    "address": "735 NORTH WEST END BLVD, QUAKERTOWN, Pennsylvania 18951",
    "city": "QUAKERTOWN",
    "state": "Pennsylvania",
    "zip": "18951",
    "lat": 40.4628542,
    "lng": -75.3676963
  },
  {
    "Store Location": "Tractor Supply 7450 HAMILTON BLVD TREXLERTOWN, Pennsylvania 18087",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-366-9461",
    "address": "7450 HAMILTON BLVD, TREXLERTOWN, Pennsylvania 18087",
    "city": "TREXLERTOWN",
    "state": "Pennsylvania",
    "zip": "18087",
    "lat": 40.549053,
    "lng": -75.6019164
  },
  {
    "Store Location": "Tractor Supply 75 NORTH MORROW ST BLAIRSVILLE, Pennsylvania 15717",
    "Store Type": "Tractor Supply",
    "Phone Number": "724-459-0500",
    "address": "75 NORTH MORROW ST, BLAIRSVILLE, Pennsylvania 15717",
    "city": "BLAIRSVILLE",
    "state": "Pennsylvania",
    "zip": "15717",
    "lat": 40.4317303,
    "lng": -79.2600033
  },
  {
    "Store Location": "Tractor Supply 750 FARMSTEAD DR EDINBORO, Pennsylvania 16412",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-734-1975",
    "address": "750 FARMSTEAD DR, EDINBORO, Pennsylvania 16412",
    "city": "EDINBORO",
    "state": "Pennsylvania",
    "zip": "16412",
    "lat": 41.8797032,
    "lng": -80.1674754
  },
  {
    "Store Location": "Tractor Supply 7625 LAKE RAYSTOWN SHOP CTR HUNTINGDON, Pennsylvania 16652",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-643-2902",
    "address": "7625 LAKE RAYSTOWN SHOP CTR, HUNTINGDON, Pennsylvania 16652",
    "city": "HUNTINGDON",
    "state": "Pennsylvania",
    "zip": "16652",
    "lat": 40.47902029999999,
    "lng": -78.010029
  },
  {
    "Store Location": "Tractor Supply 79 RED HILL RD NEWPORT, Pennsylvania 17074",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-567-2194",
    "address": "79 RED HILL RD, NEWPORT, Pennsylvania 17074",
    "city": "NEWPORT",
    "state": "Pennsylvania",
    "zip": "17074",
    "lat": 40.4876671,
    "lng": -77.1199768
  },
  {
    "Store Location": "Tractor Supply 799 STATE ST STE 40 POTTSTOWN, Pennsylvania 19464",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-327-4465",
    "address": "799 STATE ST STE 40, POTTSTOWN, Pennsylvania 19464",
    "city": "POTTSTOWN",
    "state": "Pennsylvania",
    "zip": "19464",
    "lat": 40.262047,
    "lng": -75.65095
  },
  {
    "Store Location": "Tractor Supply 801 EAST PHILADELPHIA AVE STE 6 BOYERTOWN, Pennsylvania 19512",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-473-0243",
    "address": "801 EAST PHILADELPHIA AVE STE 6, BOYERTOWN, Pennsylvania 19512",
    "city": "BOYERTOWN",
    "state": "Pennsylvania",
    "zip": "19512",
    "lat": 40.3285205,
    "lng": -75.62326379999999
  },
  {
    "Store Location": "Tractor Supply 815 NEWARK RD TOUGHKENAMON, Pennsylvania 19374",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-268-3333",
    "address": "815 NEWARK RD, TOUGHKENAMON, Pennsylvania 19374",
    "city": "TOUGHKENAMON",
    "state": "Pennsylvania",
    "zip": "19374",
    "lat": 39.81127499999999,
    "lng": -75.75258
  },
  {
    "Store Location": "Tractor Supply 84 NELSON RD MIFFLINTOWN, Pennsylvania 17059",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-436-6400",
    "address": "84 NELSON RD, MIFFLINTOWN, Pennsylvania 17059",
    "city": "MIFFLINTOWN",
    "state": "Pennsylvania",
    "zip": "17059",
    "lat": 40.5624715,
    "lng": -77.39084679999999
  },
  {
    "Store Location": "Tractor Supply 875 HILLS PLZ DR EBENSBURG, Pennsylvania 15931",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-472-0824",
    "address": "875 HILLS PLZ DR, EBENSBURG, Pennsylvania 15931",
    "city": "EBENSBURG",
    "state": "Pennsylvania",
    "zip": "15931",
    "lat": 40.468828,
    "lng": -78.760537
  },
  {
    "Store Location": "Tractor Supply 88 BEDFORD SQ EVERETT, Pennsylvania 15537",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-623-7153",
    "address": "88 BEDFORD SQ, EVERETT, Pennsylvania 15537",
    "city": "EVERETT",
    "state": "Pennsylvania",
    "zip": "15537",
    "lat": 40.0251457,
    "lng": -78.4456197
  },
  {
    "Store Location": "Tractor Supply 880 NORTH US RTE 15 DILLSBURG, Pennsylvania 17019",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-432-9271",
    "address": "880 NORTH US RTE 15, DILLSBURG, Pennsylvania 17019",
    "city": "DILLSBURG",
    "state": "Pennsylvania",
    "zip": "17019",
    "lat": 40.1148644,
    "lng": -77.0385476
  },
  {
    "Store Location": "Tractor Supply 901 LOUCKS RD YORK, Pennsylvania 17404",
    "Store Type": "Tractor Supply",
    "Phone Number": "717-845-8200",
    "address": "901 LOUCKS RD, YORK, Pennsylvania 17404",
    "city": "YORK",
    "state": "Pennsylvania",
    "zip": "17404",
    "lat": 39.9814689,
    "lng": -76.7528596
  },
  {
    "Store Location": "Tractor Supply 925 CARPENTER RD MILTON, Pennsylvania 17847",
    "Store Type": "Tractor Supply",
    "Phone Number": "570-742-0102",
    "address": "925 CARPENTER RD, MILTON, Pennsylvania 17847",
    "city": "MILTON",
    "state": "Pennsylvania",
    "zip": "17847",
    "lat": 41.00579,
    "lng": -76.82896
  },
  {
    "Store Location": "Tractor Supply 965 BENNER PIKE STATE COLLEGE, Pennsylvania 16801",
    "Store Type": "Tractor Supply",
    "Phone Number": "814-867-3337",
    "address": "965 BENNER PIKE STATE, COLLEGE, Pennsylvania 16801",
    "city": "COLLEGE",
    "state": "Pennsylvania",
    "zip": "16801",
    "lat": 40.8395453,
    "lng": -77.7997266
  },
  {
    "Store Location": "Tractor Supply 985 OCTORARA TRL PARKESBURG, Pennsylvania 19365",
    "Store Type": "Tractor Supply",
    "Phone Number": "610-857-3233",
    "address": "985 OCTORARA TRL, PARKESBURG, Pennsylvania 19365",
    "city": "PARKESBURG",
    "state": "Pennsylvania",
    "zip": "19365",
    "lat": 39.9773798,
    "lng": -75.930881
  },
  {
    "Store Location": "Tractor Supply 1175 TIOGUE AVE COVENTRY, Rhode Island 2816",
    "Store Type": "Tractor Supply",
    "Phone Number": "401-826-2510",
    "address": "1175 TIOGUE AVE COVENTRY, Rhode Island 2816,  ",
    "city": "Rhode Island 2816",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.6810766,
    "lng": -71.5837079
  },
  {
    "Store Location": "Tractor Supply 1913 DIAMOND HILL RD WOONSOCKET, Rhode Island 2895",
    "Store Type": "Tractor Supply",
    "Phone Number": "401-767-8777",
    "address": "1913 DIAMOND HILL RD WOONSOCKET, Rhode Island 2895,  ",
    "city": "Rhode Island 2895",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.0132501,
    "lng": -71.4715382
  },
  {
    "Store Location": "Tractor Supply 2750 A HARTFORD AVE JOHNSTON, Rhode Island 2919",
    "Store Type": "Tractor Supply",
    "Phone Number": "401-934-1606",
    "address": "2750 A HARTFORD AVE JOHNSTON, Rhode Island 2919,  ",
    "city": "Rhode Island 2919",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.83239409999999,
    "lng": -71.5568937
  },
  {
    "Store Location": "Tractor Supply 6625 POST RD NORTH KINGSTOWN, Rhode Island 2852",
    "Store Type": "Tractor Supply",
    "Phone Number": "401-885-2089",
    "address": "6625 POST RD NORTH KINGSTOWN, Rhode Island 2852,  ",
    "city": "Rhode Island 2852",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.6172794,
    "lng": -71.4584125
  },
  {
    "Store Location": "Tractor Supply 1003 DUTCH FORK RD IRMO, South Carolina 29063",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-749-2778",
    "address": "1003 DUTCH FORK RD, IRMO, South Carolina 29063",
    "city": "IRMO",
    "state": "South Carolina",
    "zip": "29063",
    "lat": 34.1224356,
    "lng": -81.21513709999999
  },
  {
    "Store Location": "Tractor Supply 10499 DUNBARTON BLVD BARNWELL, South Carolina 29812",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-259-5964",
    "address": "10499 DUNBARTON BLVD, BARNWELL, South Carolina 29812",
    "city": "BARNWELL",
    "state": "South Carolina",
    "zip": "29812",
    "lat": 33.2428835,
    "lng": -81.37577209999999
  },
  {
    "Store Location": "Tractor Supply 109 TOWERS DR GREENWOOD, South Carolina 29649",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-942-0880",
    "address": "109 TOWERS DR, GREENWOOD, South Carolina 29649",
    "city": "GREENWOOD",
    "state": "South Carolina",
    "zip": "29649",
    "lat": 34.2101845,
    "lng": -82.18537049999999
  },
  {
    "Store Location": "Tractor Supply 125 THRIFT AVE SENECA, South Carolina 29678",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-882-6599",
    "address": "125 THRIFT AVE, SENECA, South Carolina 29678",
    "city": "SENECA",
    "state": "South Carolina",
    "zip": "29678",
    "lat": 34.6842501,
    "lng": -82.9988628
  },
  {
    "Store Location": "Tractor Supply 1295 NORTH FRASER ST GEORGETOWN, South Carolina 29440",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-546-5056",
    "address": "1295 NORTH FRASER ST, GEORGETOWN, South Carolina 29440",
    "city": "GEORGETOWN",
    "state": "South Carolina",
    "zip": "29440",
    "lat": 33.3922085,
    "lng": -79.2908297
  },
  {
    "Store Location": "Tractor Supply 1326 WEST WADE HAMPTON BLVD GREER, South Carolina 29650",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-989-0800",
    "address": "1326 WEST WADE HAMPTON BLVD, GREER, South Carolina 29650",
    "city": "GREER",
    "state": "South Carolina",
    "zip": "29650",
    "lat": 34.942191,
    "lng": -82.2632524
  },
  {
    "Store Location": "Tractor Supply 1333 WEST FLOYD BAKER BLVD GAFFNEY, South Carolina 29341",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-487-5683",
    "address": "1333 WEST FLOYD BAKER BLVD, GAFFNEY, South Carolina 29341",
    "city": "GAFFNEY",
    "state": "South Carolina",
    "zip": "29341",
    "lat": 35.0859404,
    "lng": -81.6612361
  },
  {
    "Store Location": "Tractor Supply 1527 SOUTH MAIN ST DARLINGTON, South Carolina 29532",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-393-0200",
    "address": "1527 SOUTH MAIN ST, DARLINGTON, South Carolina 29532",
    "city": "DARLINGTON",
    "state": "South Carolina",
    "zip": "29532",
    "lat": 34.2802488,
    "lng": -79.8543866
  },
  {
    "Store Location": "Tractor Supply 1635 EAST SPRINGDALE DR CAMDEN, South Carolina 29020",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-424-1901",
    "address": "1635 EAST SPRINGDALE DR, CAMDEN, South Carolina 29020",
    "city": "CAMDEN",
    "state": "South Carolina",
    "zip": "29020",
    "lat": 34.2521366,
    "lng": -80.6488032
  },
  {
    "Store Location": "Tractor Supply 1672 NORTH MAIN ST STE 5 SUMMERVILLE, South Carolina 29486",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-821-5386",
    "address": "1672 NORTH MAIN ST STE 5, SUMMERVILLE, South Carolina 29486",
    "city": "SUMMERVILLE",
    "state": "South Carolina",
    "zip": "29486",
    "lat": 33.0417322,
    "lng": -80.1360588
  },
  {
    "Store Location": "Tractor Supply 1839 J A COCHRAN BYP CHESTER, South Carolina 29706",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-581-7800",
    "address": "1839 J A COCHRAN BYP, CHESTER, South Carolina 29706",
    "city": "CHESTER",
    "state": "South Carolina",
    "zip": "29706",
    "lat": 34.707672,
    "lng": -81.19296
  },
  {
    "Store Location": "Tractor Supply 1920 PAXVILLE HWY MANNING, South Carolina 29102",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-433-5565",
    "address": "1920 PAXVILLE HWY, MANNING, South Carolina 29102",
    "city": "MANNING",
    "state": "South Carolina",
    "zip": "29102",
    "lat": 33.6986483,
    "lng": -80.224387
  },
  {
    "Store Location": "Tractor Supply 195 EDGEWOOD DR NORTH AUGUSTA, South Carolina 29841",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-202-9099",
    "address": "195 EDGEWOOD DR NORTH, AUGUSTA, South Carolina 29841",
    "city": "AUGUSTA",
    "state": "South Carolina",
    "zip": "29841",
    "lat": 33.5268378,
    "lng": -81.9539212
  },
  {
    "Store Location": "Tractor Supply 206 SOUTH MAIN ST STE F MAULDIN, South Carolina 29662",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-281-7756",
    "address": "206 SOUTH MAIN ST STE F, MAULDIN, South Carolina 29662",
    "city": "MAULDIN",
    "state": "South Carolina",
    "zip": "29662",
    "lat": 34.7749979,
    "lng": -82.3086531
  },
  {
    "Store Location": "Tractor Supply 2091 EAST MAIN ST SPARTANBURG, South Carolina 29307",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-577-9288",
    "address": "2091 EAST MAIN ST, SPARTANBURG, South Carolina 29307",
    "city": "SPARTANBURG",
    "state": "South Carolina",
    "zip": "29307",
    "lat": 34.9724794,
    "lng": -81.8814168
  },
  {
    "Store Location": "Tractor Supply 2374 CROSS POINTE DR ROCK HILL, South Carolina 29730",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-980-6115",
    "address": "2374 CROSS POINTE DR ROCK, HILL, South Carolina 29730",
    "city": "HILL",
    "state": "South Carolina",
    "zip": "29730",
    "lat": 34.9398479,
    "lng": -80.9605959
  },
  {
    "Store Location": "Tractor Supply 256 KILLIAN RD COLUMBIA, South Carolina 29203",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-754-2857",
    "address": "256 KILLIAN RD, COLUMBIA, South Carolina 29203",
    "city": "COLUMBIA",
    "state": "South Carolina",
    "zip": "29203",
    "lat": 34.13225,
    "lng": -80.9717191
  },
  {
    "Store Location": "Tractor Supply 2565 EAST HWY 76 MARION, South Carolina 29571",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-423-3424",
    "address": "2565 EAST HWY 76, MARION, South Carolina 29571",
    "city": "MARION",
    "state": "South Carolina",
    "zip": "29571",
    "lat": 34.178216,
    "lng": -79.4006069
  },
  {
    "Store Location": "Tractor Supply 2590 SOUTH IRBY ST FLORENCE, South Carolina 29505",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-676-9950",
    "address": "2590 SOUTH IRBY ST, FLORENCE, South Carolina 29505",
    "city": "FLORENCE",
    "state": "South Carolina",
    "zip": "29505",
    "lat": 34.14631,
    "lng": -79.76907039999999
  },
  {
    "Store Location": "Tractor Supply 2655 WHISKEY RD AIKEN, South Carolina 29803",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-648-4449",
    "address": "2655 WHISKEY RD, AIKEN, South Carolina 29803",
    "city": "AIKEN",
    "state": "South Carolina",
    "zip": "29803",
    "lat": 33.5020792,
    "lng": -81.7076593
  },
  {
    "Store Location": "Tractor Supply 269 NORTH RON MCNAIR BLVD LAKE CITY, South Carolina 29560",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-394-5666",
    "address": "269 NORTH RON MCNAIR BLVD LAKE, CITY, South Carolina 29560",
    "city": "CITY",
    "state": "South Carolina",
    "zip": "29560",
    "lat": 33.8810254,
    "lng": -79.75823580000001
  },
  {
    "Store Location": "Tractor Supply 2705 BROAD ST SUMTER, South Carolina 29150",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-905-2656",
    "address": "2705 BROAD ST, SUMTER, South Carolina 29150",
    "city": "SUMTER",
    "state": "South Carolina",
    "zip": "29150",
    "lat": 33.963319,
    "lng": -80.4011707
  },
  {
    "Store Location": "Tractor Supply 2808 MAIN ST NEWBERRY, South Carolina 29108",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-405-9666",
    "address": "2808 MAIN ST, NEWBERRY, South Carolina 29108",
    "city": "NEWBERRY",
    "state": "South Carolina",
    "zip": "29108",
    "lat": 34.2811375,
    "lng": -81.5941702
  },
  {
    "Store Location": "Tractor Supply 297 BELLS HWY WALTERBORO, South Carolina 29488",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-542-2730",
    "address": "297 BELLS HWY, WALTERBORO, South Carolina 29488",
    "city": "WALTERBORO",
    "state": "South Carolina",
    "zip": "29488",
    "lat": 32.914162,
    "lng": -80.6744786
  },
  {
    "Store Location": "Tractor Supply 2994 NORTH RD ORANGEBURG, South Carolina 29118",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-531-7600",
    "address": "2994 NORTH RD, ORANGEBURG, South Carolina 29118",
    "city": "ORANGEBURG",
    "state": "South Carolina",
    "zip": "29118",
    "lat": 33.531326,
    "lng": -80.89440499999999
  },
  {
    "Store Location": "Tractor Supply 330 WEST CHURCH ST BATESBURG LEESVILLE, South Carolina 29006",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-532-2225",
    "address": "330 WEST CHURCH ST BATESBURG, LEESVILLE, South Carolina 29006",
    "city": "LEESVILLE",
    "state": "South Carolina",
    "zip": "29006",
    "lat": 33.9098665,
    "lng": -81.5387185
  },
  {
    "Store Location": "Tractor Supply 3353 CHURCH ST CONWAY, South Carolina 29526",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-369-4890",
    "address": "3353 CHURCH ST, CONWAY, South Carolina 29526",
    "city": "CONWAY",
    "state": "South Carolina",
    "zip": "29526",
    "lat": 33.8724748,
    "lng": -79.1054024
  },
  {
    "Store Location": "Tractor Supply 339 ROLLING HILLS CIR EASLEY, South Carolina 29640",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-850-6391",
    "address": "339 ROLLING HILLS CIR, EASLEY, South Carolina 29640",
    "city": "EASLEY",
    "state": "South Carolina",
    "zip": "29640",
    "lat": 34.8292942,
    "lng": -82.54015199999999
  },
  {
    "Store Location": "Tractor Supply 36 PARRIS ISLAND GTWY BEAUFORT, South Carolina 29906",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-322-0250",
    "address": "36 PARRIS ISLAND GTWY, BEAUFORT, South Carolina 29906",
    "city": "BEAUFORT",
    "state": "South Carolina",
    "zip": "29906",
    "lat": 32.4383515,
    "lng": -80.72309609999999
  },
  {
    "Store Location": "Tractor Supply 3719 CLEMSON BLVD ANDERSON, South Carolina 29621",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-222-1000",
    "address": "3719 CLEMSON BLVD, ANDERSON, South Carolina 29621",
    "city": "ANDERSON",
    "state": "South Carolina",
    "zip": "29621",
    "lat": 34.5521628,
    "lng": -82.68120530000002
  },
  {
    "Store Location": "Tractor Supply 40 CECIL REYNOLDS DR BLUFFTON, South Carolina 29910",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-706-9911",
    "address": "40 CECIL REYNOLDS DR, BLUFFTON, South Carolina 29910",
    "city": "BLUFFTON",
    "state": "South Carolina",
    "zip": "29910",
    "lat": 32.28955860000001,
    "lng": -80.9344176
  },
  {
    "Store Location": "Tractor Supply 4405 SAVANNAH HWY RAVENEL, South Carolina 29470",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-766-8062",
    "address": "4405 SAVANNAH HWY, RAVENEL, South Carolina 29470",
    "city": "RAVENEL",
    "state": "South Carolina",
    "zip": "29470",
    "lat": 32.7802362,
    "lng": -80.1558541
  },
  {
    "Store Location": "Tractor Supply 455 NORTH HIGHWAY 52 MONCKS CORNER, South Carolina 29461",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-761-5875",
    "address": "455 NORTH HIGHWAY 52 MONCKS, CORNER, South Carolina 29461",
    "city": "CORNER",
    "state": "South Carolina",
    "zip": "29461",
    "lat": 33.186819,
    "lng": -80.0009851
  },
  {
    "Store Location": "Tractor Supply 4765 NORTH HWY 17 AWENDAW, South Carolina 29429",
    "Store Type": "Tractor Supply",
    "Phone Number": "843-881-0899",
    "address": "4765 NORTH HWY 17, AWENDAW, South Carolina 29429",
    "city": "AWENDAW",
    "state": "South Carolina",
    "zip": "29429",
    "lat": 32.9243707,
    "lng": -79.71375809999999
  },
  {
    "Store Location": "Tractor Supply 550 ROE CENTER CT TRAVELERS REST, South Carolina 29690",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-834-7333",
    "address": "550 ROE CENTER CT TRAVELERS, REST, South Carolina 29690",
    "city": "REST",
    "state": "South Carolina",
    "zip": "29690",
    "lat": 34.9599621,
    "lng": -82.4377822
  },
  {
    "Store Location": "Tractor Supply 5589 SUNSET BLVD LEXINGTON, South Carolina 29072",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-996-6596",
    "address": "5589 SUNSET BLVD, LEXINGTON, South Carolina 29072",
    "city": "LEXINGTON",
    "state": "South Carolina",
    "zip": "29072",
    "lat": 33.9934609,
    "lng": -81.22533609999999
  },
  {
    "Store Location": "Tractor Supply 593 LANCASTER BYP EAST LANCASTER, South Carolina 29720",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-285-5145",
    "address": "593 LANCASTER BYP EAST, LANCASTER, South Carolina 29720",
    "city": "LANCASTER",
    "state": "South Carolina",
    "zip": "29720",
    "lat": 34.730782,
    "lng": -80.758248
  },
  {
    "Store Location": "Tractor Supply 7831 GARNERS FERRY RD COLUMBIA, South Carolina 29209",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-776-6626",
    "address": "7831 GARNERS FERRY RD, COLUMBIA, South Carolina 29209",
    "city": "COLUMBIA",
    "state": "South Carolina",
    "zip": "29209",
    "lat": 33.9545176,
    "lng": -80.92852239999999
  },
  {
    "Store Location": "Tractor Supply 802 EAST LIBERTY ST YORK, South Carolina 29745",
    "Store Type": "Tractor Supply",
    "Phone Number": "803-684-2919",
    "address": "802 EAST LIBERTY ST, YORK, South Carolina 29745",
    "city": "YORK",
    "state": "South Carolina",
    "zip": "29745",
    "lat": 34.9841261,
    "lng": -81.2221065
  },
  {
    "Store Location": "Tractor Supply 917 EAST MAIN ST STE H LAURENS, South Carolina 29360",
    "Store Type": "Tractor Supply",
    "Phone Number": "864-683-1571",
    "address": "917 EAST MAIN ST STE H, LAURENS, South Carolina 29360",
    "city": "LAURENS",
    "state": "South Carolina",
    "zip": "29360",
    "lat": 34.4936063,
    "lng": -81.97887829999999
  },
  {
    "Store Location": "Tractor Supply 1006 WEST PIPESTONE FLANDREAU, South Dakota 57028",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-573-1201",
    "address": "1006 WEST PIPESTONE, FLANDREAU, South Dakota 57028",
    "city": "FLANDREAU",
    "state": "South Dakota",
    "zip": "57028",
    "lat": 44.0491324,
    "lng": -96.61147109999999
  },
  {
    "Store Location": "Tractor Supply 2200 9TH AVE SOUTHEAST WATERTOWN, South Dakota 57201",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-886-2735",
    "address": "2200 9TH AVE SOUTHEAST, WATERTOWN, South Dakota 57201",
    "city": "WATERTOWN",
    "state": "South Dakota",
    "zip": "57201",
    "lat": 44.8890587,
    "lng": -97.0788104
  },
  {
    "Store Location": "Tractor Supply 2201 SOUTHEAST 6TH AVE STE 22 ABERDEEN, South Dakota 57401",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-225-5888",
    "address": "2201 SOUTHEAST 6TH AVE STE 22, ABERDEEN, South Dakota 57401",
    "city": "ABERDEEN",
    "state": "South Dakota",
    "zip": "57401",
    "lat": 45.4646985,
    "lng": -98.4864829
  },
  {
    "Store Location": "Tractor Supply 2400 SOUTH MENTZER AVE MITCHELL, South Dakota 57301",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-996-7942",
    "address": "2400 SOUTH MENTZER AVE, MITCHELL, South Dakota 57301",
    "city": "MITCHELL",
    "state": "South Dakota",
    "zip": "57301",
    "lat": 43.6852155,
    "lng": -98.01208749999999
  },
  {
    "Store Location": "Tractor Supply 250 HERITAGE DR SPEARFISH, South Dakota 57783",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-642-2552",
    "address": "250 HERITAGE DR, SPEARFISH, South Dakota 57783",
    "city": "SPEARFISH",
    "state": "South Dakota",
    "zip": "57783",
    "lat": 44.4755776,
    "lng": -103.808787
  },
  {
    "Store Location": "Tractor Supply 2908 BROADWAY AVE YANKTON, South Dakota 57078",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-665-9353",
    "address": "2908 BROADWAY AVE, YANKTON, South Dakota 57078",
    "city": "YANKTON",
    "state": "South Dakota",
    "zip": "57078",
    "lat": 42.9060159,
    "lng": -97.3962947
  },
  {
    "Store Location": "Tractor Supply 3440 EAST MALL DR RAPID CITY, South Dakota 57701",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-348-4641",
    "address": "3440 EAST MALL DR RAPID, CITY, South Dakota 57701",
    "city": "CITY",
    "state": "South Dakota",
    "zip": "57701",
    "lat": 44.1037569,
    "lng": -103.1587529
  },
  {
    "Store Location": "Tractor Supply 3520 NORTH CLIFF AVE SIOUX FALLS, South Dakota 57104",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-336-3031",
    "address": "3520 NORTH CLIFF AVE SIOUX, FALLS, South Dakota 57104",
    "city": "FALLS",
    "state": "South Dakota",
    "zip": "57104",
    "lat": 43.5849336,
    "lng": -96.7101677
  },
  {
    "Store Location": "Tractor Supply 509 WEST CHERRY ST VERMILLION, South Dakota 57069",
    "Store Type": "Tractor Supply",
    "Phone Number": "605-624-4000",
    "address": "509 WEST CHERRY ST, VERMILLION, South Dakota 57069",
    "city": "VERMILLION",
    "state": "South Dakota",
    "zip": "57069",
    "lat": 42.7881771,
    "lng": -96.9396103
  },
  {
    "Store Location": "Tractor Supply 110 INDUSTRIAL DR WAYNESBORO, Tennessee 38485",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-722-5670",
    "address": "110 INDUSTRIAL DR, WAYNESBORO, Tennessee 38485",
    "city": "WAYNESBORO",
    "state": "Tennessee",
    "zip": "38485",
    "lat": 35.3269491,
    "lng": -87.76092109999999
  },
  {
    "Store Location": "Tractor Supply 1101 HILLVIEW LN FRANKLIN, Tennessee 37064",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-791-0791",
    "address": "1101 HILLVIEW LN, FRANKLIN, Tennessee 37064",
    "city": "FRANKLIN",
    "state": "Tennessee",
    "zip": "37064",
    "lat": 35.8907222,
    "lng": -86.8778437
  },
  {
    "Store Location": "Tractor Supply 111 BROWN TOWN ROAD WAVERLY, Tennessee 37185",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-296-2220",
    "address": "111 BROWN TOWN ROAD, WAVERLY, Tennessee 37185",
    "city": "WAVERLY",
    "state": "Tennessee",
    "zip": "37185",
    "lat": 36.0816875,
    "lng": -87.8358923
  },
  {
    "Store Location": "Tractor Supply 11638 CHAPMAN HWY SEYMOUR, Tennessee 37865",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-573-0255",
    "address": "11638 CHAPMAN HWY, SEYMOUR, Tennessee 37865",
    "city": "SEYMOUR",
    "state": "Tennessee",
    "zip": "37865",
    "lat": 35.8659304,
    "lng": -83.7474994
  },
  {
    "Store Location": "Tractor Supply 1258 NORTH MAIN AVE ERWIN, Tennessee 37650",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-735-0429",
    "address": "1258 NORTH MAIN AVE, ERWIN, Tennessee 37650",
    "city": "ERWIN",
    "state": "Tennessee",
    "zip": "37650",
    "lat": 36.1589551,
    "lng": -82.3974266
  },
  {
    "Store Location": "Tractor Supply 1266 HWY 641 SOUTH PARIS, Tennessee 38242",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-641-8879",
    "address": "1266 HWY 641 SOUTH, PARIS, Tennessee 38242",
    "city": "PARIS",
    "state": "Tennessee",
    "zip": "38242",
    "lat": 36.27952,
    "lng": -88.2941496
  },
  {
    "Store Location": "Tractor Supply 127 WEST BROADWAY BLVD JEFFERSON CITY, Tennessee 37760",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-471-7807",
    "address": "127 WEST BROADWAY BLVD JEFFERSON, CITY, Tennessee 37760",
    "city": "CITY",
    "state": "Tennessee",
    "zip": "37760",
    "lat": 36.1133518,
    "lng": -83.4948986
  },
  {
    "Store Location": "Tractor Supply 130 ASHWOOD DRIVE COLUMBIA, Tennessee 38401",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-380-1234",
    "address": "130 ASHWOOD DRIVE, COLUMBIA, Tennessee 38401",
    "city": "COLUMBIA",
    "state": "Tennessee",
    "zip": "38401",
    "lat": 35.5870246,
    "lng": -87.0443253
  },
  {
    "Store Location": "Tractor Supply 1323 EAST MAIN ST ROGERSVILLE, Tennessee 37857",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-272-4613",
    "address": "1323 EAST MAIN ST, ROGERSVILLE, Tennessee 37857",
    "city": "ROGERSVILLE",
    "state": "Tennessee",
    "zip": "37857",
    "lat": 36.4170314,
    "lng": -82.9893288
  },
  {
    "Store Location": "Tractor Supply 1332 HUNTSVILLE HWY FAYETTEVILLE, Tennessee 37334",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-433-4399",
    "address": "1332 HUNTSVILLE HWY, FAYETTEVILLE, Tennessee 37334",
    "city": "FAYETTEVILLE",
    "state": "Tennessee",
    "zip": "37334",
    "lat": 35.1311945,
    "lng": -86.5641258
  },
  {
    "Store Location": "Tractor Supply 135 HIGHLAND SQ CROSSVILLE, Tennessee 38555",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-484-6484",
    "address": "135 HIGHLAND SQ, CROSSVILLE, Tennessee 38555",
    "city": "CROSSVILLE",
    "state": "Tennessee",
    "zip": "38555",
    "lat": 35.9580944,
    "lng": -85.0428087
  },
  {
    "Store Location": "Tractor Supply 135 JOHN R RICE BOULEVARD MURFREESBORO, Tennessee 37129",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-896-1561",
    "address": "135 JOHN R RICE BOULEVARD, MURFREESBORO, Tennessee 37129",
    "city": "MURFREESBORO",
    "state": "Tennessee",
    "zip": "37129",
    "lat": 35.8504047,
    "lng": -86.4411468
  },
  {
    "Store Location": "Tractor Supply 1361 WEST MARKET ST STE B BOLIVAR, Tennessee 38008",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-658-2880",
    "address": "1361 WEST MARKET ST STE B, BOLIVAR, Tennessee 38008",
    "city": "BOLIVAR",
    "state": "Tennessee",
    "zip": "38008",
    "lat": 35.2592029,
    "lng": -89.0089079
  },
  {
    "Store Location": "Tractor Supply 1425 DINAH SHORE BLVD WINCHESTER, Tennessee 37398",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-962-2988",
    "address": "1425 DINAH SHORE BLVD, WINCHESTER, Tennessee 37398",
    "city": "WINCHESTER",
    "state": "Tennessee",
    "zip": "37398",
    "lat": 35.198783,
    "lng": -86.0974722
  },
  {
    "Store Location": "Tractor Supply 1455-B WEST MAIN ST LEBANON, Tennessee 37087",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-449-4466",
    "address": "1455-B WEST MAIN ST, LEBANON, Tennessee 37087",
    "city": "LEBANON",
    "state": "Tennessee",
    "zip": "37087",
    "lat": 36.2188592,
    "lng": -86.33268509999999
  },
  {
    "Store Location": "Tractor Supply 14925 LEBANON RD OLD HICKORY, Tennessee 37138",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-754-4700",
    "address": "14925 LEBANON RD OLD, HICKORY, Tennessee 37138",
    "city": "HICKORY",
    "state": "Tennessee",
    "zip": "37138",
    "lat": 36.2189314,
    "lng": -86.5759535
  },
  {
    "Store Location": "Tractor Supply 1494 NORTH GATEWAY AVE ROCKWOOD, Tennessee 37854",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-354-0446",
    "address": "1494 NORTH GATEWAY AVE, ROCKWOOD, Tennessee 37854",
    "city": "ROCKWOOD",
    "state": "Tennessee",
    "zip": "37854",
    "lat": 35.886757,
    "lng": -84.64197999999999
  },
  {
    "Store Location": "Tractor Supply 15 CARRIAGE HOUSE DR JACKSON, Tennessee 38305",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-660-8484",
    "address": "15 CARRIAGE HOUSE DR, JACKSON, Tennessee 38305",
    "city": "JACKSON",
    "state": "Tennessee",
    "zip": "38305",
    "lat": 35.6687194,
    "lng": -88.8302769
  },
  {
    "Store Location": "Tractor Supply 150 THE ACRES LEWISBURG, Tennessee 37091",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-359-6131",
    "address": "150 THE ACRES, LEWISBURG, Tennessee 37091",
    "city": "LEWISBURG",
    "state": "Tennessee",
    "zip": "37091",
    "lat": 35.4484504,
    "lng": -86.778005
  },
  {
    "Store Location": "Tractor Supply 1640 WEST COLLEGE ST PULASKI, Tennessee 38478",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-424-9199",
    "address": "1640 WEST COLLEGE ST, PULASKI, Tennessee 38478",
    "city": "PULASKI",
    "state": "Tennessee",
    "zip": "38478",
    "lat": 35.2063409,
    "lng": -87.0603185
  },
  {
    "Store Location": "Tractor Supply 165 WESTERN PLAZA WAY NEWPORT, Tennessee 37821",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-613-5774",
    "address": "165 WESTERN PLAZA WAY, NEWPORT, Tennessee 37821",
    "city": "NEWPORT",
    "state": "Tennessee",
    "zip": "37821",
    "lat": 35.972444,
    "lng": -83.2073879
  },
  {
    "Store Location": "Tractor Supply 1665 EAST ANDREW JOHNSON HWY STE 2 GREENEVILLE, Tennessee 37745",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-787-0100",
    "address": "1665 EAST ANDREW JOHNSON HWY STE 2, GREENEVILLE, Tennessee 37745",
    "city": "GREENEVILLE",
    "state": "Tennessee",
    "zip": "37745",
    "lat": 36.1781648,
    "lng": -82.7939454
  },
  {
    "Store Location": "Tractor Supply 1678 ROSES DR LIVINGSTON, Tennessee 38570",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-823-9904",
    "address": "1678 ROSES DR, LIVINGSTON, Tennessee 38570",
    "city": "LIVINGSTON",
    "state": "Tennessee",
    "zip": "38570",
    "lat": 36.363551,
    "lng": -85.343383
  },
  {
    "Store Location": "Tractor Supply 1714 NORTH MAIN ST SHELBYVILLE, Tennessee 37160",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-680-9644",
    "address": "1714 NORTH MAIN ST, SHELBYVILLE, Tennessee 37160",
    "city": "SHELBYVILLE",
    "state": "Tennessee",
    "zip": "37160",
    "lat": 35.5082634,
    "lng": -86.455744
  },
  {
    "Store Location": "Tractor Supply 1800 WEST LAMAR ALEXANDER PKWY MARYVILLE, Tennessee 37801",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-681-3336",
    "address": "1800 WEST LAMAR ALEXANDER PKWY, MARYVILLE, Tennessee 37801",
    "city": "MARYVILLE",
    "state": "Tennessee",
    "zip": "37801",
    "lat": 35.7545266,
    "lng": -84.0217648
  },
  {
    "Store Location": "Tractor Supply 1905 NORTH JACKSON STREET TULLAHOMA, Tennessee 37388",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-455-3030",
    "address": "1905 NORTH JACKSON STREET, TULLAHOMA, Tennessee 37388",
    "city": "TULLAHOMA",
    "state": "Tennessee",
    "zip": "37388",
    "lat": 35.3866821,
    "lng": -86.2361548
  },
  {
    "Store Location": "Tractor Supply 195 WATER ST STE A SAVANNAH, Tennessee 38372",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-925-3773",
    "address": "195 WATER ST STE A, SAVANNAH, Tennessee 38372",
    "city": "SAVANNAH",
    "state": "Tennessee",
    "zip": "38372",
    "lat": 35.2220612,
    "lng": -88.2444364
  },
  {
    "Store Location": "Tractor Supply 19965 ALBERTA ST ONEIDA, Tennessee 37841",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-569-3620",
    "address": "19965 ALBERTA ST, ONEIDA, Tennessee 37841",
    "city": "ONEIDA",
    "state": "Tennessee",
    "zip": "37841",
    "lat": 36.5179051,
    "lng": -84.50581849999999
  },
  {
    "Store Location": "Tractor Supply 200 ABLE DR STE 10 DAYTON, Tennessee 37321",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-570-1803",
    "address": "200 ABLE DR STE 10, DAYTON, Tennessee 37321",
    "city": "DAYTON",
    "state": "Tennessee",
    "zip": "37321",
    "lat": 35.4757199,
    "lng": -85.02734819999999
  },
  {
    "Store Location": "Tractor Supply 200 HOBSON ST PLAZA SHOP CTR MCMINNVILLE, Tennessee 37110",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-473-2411",
    "address": "200 HOBSON ST PLAZA SHOP CTR, MCMINNVILLE, Tennessee 37110",
    "city": "MCMINNVILLE",
    "state": "Tennessee",
    "zip": "37110",
    "lat": 35.6995061,
    "lng": -85.7769965
  },
  {
    "Store Location": "Tractor Supply 2028 NORTH LOCUST AVE LAWRENCEBURG, Tennessee 38464",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-766-2900",
    "address": "2028 NORTH LOCUST AVE, LAWRENCEBURG, Tennessee 38464",
    "city": "LAWRENCEBURG",
    "state": "Tennessee",
    "zip": "38464",
    "lat": 35.267867,
    "lng": -87.3204399
  },
  {
    "Store Location": "Tractor Supply 20940 MAIN ST EAST HUNTINGDON, Tennessee 38344",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-986-0425",
    "address": "20940 MAIN ST EAST, HUNTINGDON, Tennessee 38344",
    "city": "HUNTINGDON",
    "state": "Tennessee",
    "zip": "38344",
    "lat": 36.0058313,
    "lng": -88.4063062
  },
  {
    "Store Location": "Tractor Supply 210 CHEROKEE PARK DR ELIZABETHTON, Tennessee 37643",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-547-2756",
    "address": "210 CHEROKEE PARK DR, ELIZABETHTON, Tennessee 37643",
    "city": "ELIZABETHTON",
    "state": "Tennessee",
    "zip": "37643",
    "lat": 36.35318609999999,
    "lng": -82.2336141
  },
  {
    "Store Location": "Tractor Supply 2161 HILLSBORO BLVD STE 13 MANCHESTER, Tennessee 37355",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-723-4195",
    "address": "2161 HILLSBORO BLVD STE 13, MANCHESTER, Tennessee 37355",
    "city": "MANCHESTER",
    "state": "Tennessee",
    "zip": "37355",
    "lat": 35.46139429999999,
    "lng": -86.05793899999999
  },
  {
    "Store Location": "Tractor Supply 2176 HILLSBORO RD STE 122 FRANKLIN, Tennessee 37069",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-595-5700",
    "address": "2176 HILLSBORO RD STE 122, FRANKLIN, Tennessee 37069",
    "city": "FRANKLIN",
    "state": "Tennessee",
    "zip": "37069",
    "lat": 35.995601,
    "lng": -86.88568939999999
  },
  {
    "Store Location": "Tractor Supply 222 SEQUOYAH RD STE J SODDY DAISY, Tennessee 37379",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-332-5434",
    "address": "222 SEQUOYAH RD STE J SODDY, DAISY, Tennessee 37379",
    "city": "DAISY",
    "state": "Tennessee",
    "zip": "37379",
    "lat": 35.2489783,
    "lng": -85.1812267
  },
  {
    "Store Location": "Tractor Supply 225 WILSON CARTER DR KIMBALL, Tennessee 37347",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-837-8088",
    "address": "225 WILSON CARTER DR, KIMBALL, Tennessee 37347",
    "city": "KIMBALL",
    "state": "Tennessee",
    "zip": "37347",
    "lat": 35.0425304,
    "lng": -85.67548959999999
  },
  {
    "Store Location": "Tractor Supply 2310 MERCURY BLVD MURFREESBORO, Tennessee 37130",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-849-1974",
    "address": "2310 MERCURY BLVD, MURFREESBORO, Tennessee 37130",
    "city": "MURFREESBORO",
    "state": "Tennessee",
    "zip": "37130",
    "lat": 35.8807375,
    "lng": -86.317392
  },
  {
    "Store Location": "Tractor Supply 2320 FAIRVIEW BLVD FAIRVIEW, Tennessee 37062",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-799-1935",
    "address": "2320 FAIRVIEW BLVD, FAIRVIEW, Tennessee 37062",
    "city": "FAIRVIEW",
    "state": "Tennessee",
    "zip": "37062",
    "lat": 35.9677683,
    "lng": -87.1335266
  },
  {
    "Store Location": "Tractor Supply 240 US HWY 72 WEST COLLIERVILLE, Tennessee 38017",
    "Store Type": "Tractor Supply",
    "Phone Number": "901-853-0783",
    "address": "240 US HWY 72 WEST, COLLIERVILLE, Tennessee 38017",
    "city": "COLLIERVILLE",
    "state": "Tennessee",
    "zip": "38017",
    "lat": 35.0337179,
    "lng": -89.66977949999999
  },
  {
    "Store Location": "Tractor Supply 2520 JACKSBORO PIKE JACKSBORO, Tennessee 37757",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-566-6955",
    "address": "2520 JACKSBORO PIKE, JACKSBORO, Tennessee 37757",
    "city": "JACKSBORO",
    "state": "Tennessee",
    "zip": "37757",
    "lat": 36.3408622,
    "lng": -84.1708797
  },
  {
    "Store Location": "Tractor Supply 2520 JACKSBORO PIKE JACKSBORO, Tennessee 37757",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-566-6955",
    "address": "2520 JACKSBORO PIKE, JACKSBORO, Tennessee 37757",
    "city": "JACKSBORO",
    "state": "Tennessee",
    "zip": "37757",
    "lat": 36.3408622,
    "lng": -84.1708797
  },
  {
    "Store Location": "Tractor Supply 2606 MINNICH TRL KINGSPORT, Tennessee 37660",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-245-6660",
    "address": "2606 MINNICH TRL, KINGSPORT, Tennessee 37660",
    "city": "KINGSPORT",
    "state": "Tennessee",
    "zip": "37660",
    "lat": 36.5571299,
    "lng": -82.60653529999999
  },
  {
    "Store Location": "Tractor Supply 2705 LAKE RD DYERSBURG, Tennessee 38024",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-287-1990",
    "address": "2705 LAKE RD, DYERSBURG, Tennessee 38024",
    "city": "DYERSBURG",
    "state": "Tennessee",
    "zip": "38024",
    "lat": 36.0663842,
    "lng": -89.3977329
  },
  {
    "Store Location": "Tractor Supply 2750 KEITH ST NORTHWEST CLEVELAND, Tennessee 37312",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-559-0088",
    "address": "2750 KEITH ST NORTHWEST, CLEVELAND, Tennessee 37312",
    "city": "CLEVELAND",
    "state": "Tennessee",
    "zip": "37312",
    "lat": 35.1859279,
    "lng": -84.86966
  },
  {
    "Store Location": "Tractor Supply 330 WEST MAIN ST SEVIERVILLE, Tennessee 37862",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-453-0777",
    "address": "330 WEST MAIN ST, SEVIERVILLE, Tennessee 37862",
    "city": "SEVIERVILLE",
    "state": "Tennessee",
    "zip": "37862",
    "lat": 35.8721658,
    "lng": -83.5723787
  },
  {
    "Store Location": "Tractor Supply 3355 GUTHRIE HWY CLARKSVILLE, Tennessee 37040",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-648-8895",
    "address": "3355 GUTHRIE HWY, CLARKSVILLE, Tennessee 37040",
    "city": "CLARKSVILLE",
    "state": "Tennessee",
    "zip": "37040",
    "lat": 36.6048842,
    "lng": -87.27597589999999
  },
  {
    "Store Location": "Tractor Supply 3480 WEST ANDREW JOHNSON HWY MORRISTOWN, Tennessee 37814",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-581-6000",
    "address": "3480 WEST ANDREW JOHNSON HWY, MORRISTOWN, Tennessee 37814",
    "city": "MORRISTOWN",
    "state": "Tennessee",
    "zip": "37814",
    "lat": 36.1989743,
    "lng": -83.343684
  },
  {
    "Store Location": "Tractor Supply 3556 TOM AUSTIN HWY STE 3 SPRINGFIELD, Tennessee 37172",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-384-2367",
    "address": "3556 TOM AUSTIN HWY STE 3, SPRINGFIELD, Tennessee 37172",
    "city": "SPRINGFIELD",
    "state": "Tennessee",
    "zip": "37172",
    "lat": 36.4919675,
    "lng": -86.8795516
  },
  {
    "Store Location": "Tractor Supply 356 FREY ST ASHLAND CITY, Tennessee 37015",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-792-1903",
    "address": "356 FREY ST ASHLAND, CITY, Tennessee 37015",
    "city": "CITY",
    "state": "Tennessee",
    "zip": "37015",
    "lat": 36.2974773,
    "lng": -87.04689019999999
  },
  {
    "Store Location": "Tractor Supply 404 HWY 52 W PORTLAND, Tennessee 37148",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-323-7277",
    "address": "404 HWY 52 W, PORTLAND, Tennessee 37148",
    "city": "PORTLAND",
    "state": "Tennessee",
    "zip": "37148",
    "lat": 36.5794832,
    "lng": -86.41848189999999
  },
  {
    "Store Location": "Tractor Supply 421 NORTH MAIN ST JAMESTOWN, Tennessee 38556",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-752-2881",
    "address": "421 NORTH MAIN ST, JAMESTOWN, Tennessee 38556",
    "city": "JAMESTOWN",
    "state": "Tennessee",
    "zip": "38556",
    "lat": 36.4326256,
    "lng": -84.9356581
  },
  {
    "Store Location": "Tractor Supply 425 WEST REELFOOT AVE UNION CITY, Tennessee 38261",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-885-5844",
    "address": "425 WEST REELFOOT AVE UNION, CITY, Tennessee 38261",
    "city": "CITY",
    "state": "Tennessee",
    "zip": "38261",
    "lat": 36.415901,
    "lng": -89.0630881
  },
  {
    "Store Location": "Tractor Supply 449 HWY 52 BYP WEST LAFAYETTE, Tennessee 37083",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-688-4541",
    "address": "449 HWY 52 BYP WEST, LAFAYETTE, Tennessee 37083",
    "city": "LAFAYETTE",
    "state": "Tennessee",
    "zip": "37083",
    "lat": 36.52132599999999,
    "lng": -86.03949569999999
  },
  {
    "Store Location": "Tractor Supply 4534 BRISTOL HWY JOHNSON CITY, Tennessee 37601",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-854-9057",
    "address": "4534 BRISTOL HWY JOHNSON, CITY, Tennessee 37601",
    "city": "CITY",
    "state": "Tennessee",
    "zip": "37601",
    "lat": 36.4024647,
    "lng": -82.3456228
  },
  {
    "Store Location": "Tractor Supply 465 OAK RIDGE TPKE OAK RIDGE, Tennessee 37830",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-425-7518",
    "address": "465 OAK RIDGE TPKE OAK, RIDGE, Tennessee 37830",
    "city": "RIDGE",
    "state": "Tennessee",
    "zip": "37830",
    "lat": 36.0368564,
    "lng": -84.22121039999999
  },
  {
    "Store Location": "Tractor Supply 4709 TRADERS WAY THOMPSONS STATION, Tennessee 37179",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-790-9709",
    "address": "4709 TRADERS WAY THOMPSONS, STATION, Tennessee 37179",
    "city": "STATION",
    "state": "Tennessee",
    "zip": "37179",
    "lat": 35.7835066,
    "lng": -86.91516879999999
  },
  {
    "Store Location": "Tractor Supply 50 TEAGUE STORE RD SOMERVILLE, Tennessee 38068",
    "Store Type": "Tractor Supply",
    "Phone Number": "901-465-0141",
    "address": "50 TEAGUE STORE RD, SOMERVILLE, Tennessee 38068",
    "city": "SOMERVILLE",
    "state": "Tennessee",
    "zip": "38068",
    "lat": 35.2339612,
    "lng": -89.4157987
  },
  {
    "Store Location": "Tractor Supply 507 BOONES CREEK RD JONESBOROUGH, Tennessee 37659",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-753-3232",
    "address": "507 BOONES CREEK RD, JONESBOROUGH, Tennessee 37659",
    "city": "JONESBOROUGH",
    "state": "Tennessee",
    "zip": "37659",
    "lat": 36.3014124,
    "lng": -82.46842180000002
  },
  {
    "Store Location": "Tractor Supply 5111 MURFREESBORO RD COLLEGE GROVE, Tennessee 37046",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-395-4241",
    "address": "5111 MURFREESBORO RD COLLEGE, GROVE, Tennessee 37046",
    "city": "GROVE",
    "state": "Tennessee",
    "zip": "37046",
    "lat": 35.853099,
    "lng": -86.6572132
  },
  {
    "Store Location": "Tractor Supply 513 NOLAN DR SMYRNA, Tennessee 37167",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-459-0225",
    "address": "513 NOLAN DR, SMYRNA, Tennessee 37167",
    "city": "SMYRNA",
    "state": "Tennessee",
    "zip": "37167",
    "lat": 35.9944707,
    "lng": -86.5268895
  },
  {
    "Store Location": "Tractor Supply 575-A SOUTH JEFFERSON AVE COOKEVILLE, Tennessee 38501",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-528-4213",
    "address": "575-A SOUTH JEFFERSON AVE, COOKEVILLE, Tennessee 38501",
    "city": "COOKEVILLE",
    "state": "Tennessee",
    "zip": "38501",
    "lat": 36.1497969,
    "lng": -85.5022535
  },
  {
    "Store Location": "Tractor Supply 59 DIXON SPRINGS HWY CARTHAGE, Tennessee 37030",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-735-2684",
    "address": "59 DIXON SPRINGS HWY, CARTHAGE, Tennessee 37030",
    "city": "CARTHAGE",
    "state": "Tennessee",
    "zip": "37030",
    "lat": 36.264284,
    "lng": -85.95795199999999
  },
  {
    "Store Location": "Tractor Supply 6025 SOUTH 1ST ST MILAN, Tennessee 38358",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-686-7231",
    "address": "6025 SOUTH 1ST ST, MILAN, Tennessee 38358",
    "city": "MILAN",
    "state": "Tennessee",
    "zip": "38358",
    "lat": 35.9072304,
    "lng": -88.7541603
  },
  {
    "Store Location": "Tractor Supply 608 EAST MAIN ST HOHENWALD, Tennessee 38462",
    "Store Type": "Tractor Supply",
    "Phone Number": "931-796-2528",
    "address": "608 EAST MAIN ST, HOHENWALD, Tennessee 38462",
    "city": "HOHENWALD",
    "state": "Tennessee",
    "zip": "38462",
    "lat": 35.5586136,
    "lng": -87.530126
  },
  {
    "Store Location": "Tractor Supply 620 WEST BROAD ST SMITHVILLE, Tennessee 37166",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-215-6200",
    "address": "620 WEST BROAD ST, SMITHVILLE, Tennessee 37166",
    "city": "SMITHVILLE",
    "state": "Tennessee",
    "zip": "37166",
    "lat": 35.9595801,
    "lng": -85.834306
  },
  {
    "Store Location": "Tractor Supply 622 SOUTH CONGRESS PKWY ATHENS, Tennessee 37303",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-746-1657",
    "address": "622 SOUTH CONGRESS PKWY, ATHENS, Tennessee 37303",
    "city": "ATHENS",
    "state": "Tennessee",
    "zip": "37303",
    "lat": 35.421434,
    "lng": -84.6592653
  },
  {
    "Store Location": "Tractor Supply 635 US HIGHWAY 45 N HENDERSON, Tennessee 38340",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-989-5556",
    "address": "635 US HIGHWAY 45 N, HENDERSON, Tennessee 38340",
    "city": "HENDERSON",
    "state": "Tennessee",
    "zip": "38340",
    "lat": 35.4431681,
    "lng": -88.66206749999999
  },
  {
    "Store Location": "Tractor Supply 670-A NASHVILLE PIKE GALLATIN, Tennessee 37066",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-451-4700",
    "address": "670-A NASHVILLE PIKE, GALLATIN, Tennessee 37066",
    "city": "GALLATIN",
    "state": "Tennessee",
    "zip": "37066",
    "lat": 36.3831438,
    "lng": -86.4626682
  },
  {
    "Store Location": "Tractor Supply 677 WEST CHURCH ST LEXINGTON, Tennessee 38351",
    "Store Type": "Tractor Supply",
    "Phone Number": "731-968-6944",
    "address": "677 WEST CHURCH ST, LEXINGTON, Tennessee 38351",
    "city": "LEXINGTON",
    "state": "Tennessee",
    "zip": "38351",
    "lat": 35.6571557,
    "lng": -88.415325
  },
  {
    "Store Location": "Tractor Supply 684 SIGNAL MOUNTAIN RD CHATTANOOGA, Tennessee 37405",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-870-7011",
    "address": "684 SIGNAL MOUNTAIN RD, CHATTANOOGA, Tennessee 37405",
    "city": "CHATTANOOGA",
    "state": "Tennessee",
    "zip": "37405",
    "lat": 35.0983395,
    "lng": -85.32526600000001
  },
  {
    "Store Location": "Tractor Supply 715 HWY 46 SOUTH DICKSON, Tennessee 37055",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-446-6282",
    "address": "715 HWY 46 SOUTH, DICKSON, Tennessee 37055",
    "city": "DICKSON",
    "state": "Tennessee",
    "zip": "37055",
    "lat": 36.0533764,
    "lng": -87.3664052
  },
  {
    "Store Location": "Tractor Supply 7342 STATE RTE 28 STE B DUNLAP, Tennessee 37327",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-949-2426",
    "address": "7342 STATE RTE 28 STE B, DUNLAP, Tennessee 37327",
    "city": "DUNLAP",
    "state": "Tennessee",
    "zip": "37327",
    "lat": 35.358738,
    "lng": -85.39647
  },
  {
    "Store Location": "Tractor Supply 7580 MAYNARDVILLE PIKE KNOXVILLE, Tennessee 37938",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-922-1689",
    "address": "7580 MAYNARDVILLE PIKE, KNOXVILLE, Tennessee 37938",
    "city": "KNOXVILLE",
    "state": "Tennessee",
    "zip": "37938",
    "lat": 36.0927928,
    "lng": -83.9175528
  },
  {
    "Store Location": "Tractor Supply 785 HWY 321 NORTH STE 32 LENOIR CITY, Tennessee 37771",
    "Store Type": "Tractor Supply",
    "Phone Number": "865-988-7336",
    "address": "785 HWY 321 NORTH STE 32 LENOIR, CITY, Tennessee 37771",
    "city": "CITY",
    "state": "Tennessee",
    "zip": "37771",
    "lat": 35.8160349,
    "lng": -84.2626063
  },
  {
    "Store Location": "Tractor Supply 8247 US HWY 51 NORTH MILLINGTON, Tennessee 38053",
    "Store Type": "Tractor Supply",
    "Phone Number": "901-873-0233",
    "address": "8247 US HWY 51 NORTH, MILLINGTON, Tennessee 38053",
    "city": "MILLINGTON",
    "state": "Tennessee",
    "zip": "38053",
    "lat": 35.3520802,
    "lng": -89.90095439999999
  },
  {
    "Store Location": "Tractor Supply 911 CENTER POINT RD HENDERSONVILLE, Tennessee 37075",
    "Store Type": "Tractor Supply",
    "Phone Number": "615-822-8555",
    "address": "911 CENTER POINT RD, HENDERSONVILLE, Tennessee 37075",
    "city": "HENDERSONVILLE",
    "state": "Tennessee",
    "zip": "37075",
    "lat": 36.3101603,
    "lng": -86.6670078
  },
  {
    "Store Location": "Tractor Supply 9408 APISON PIKE STE 122 OOLTEWAH, Tennessee 37363",
    "Store Type": "Tractor Supply",
    "Phone Number": "423-396-4224",
    "address": "9408 APISON PIKE STE 122, OOLTEWAH, Tennessee 37363",
    "city": "OOLTEWAH",
    "state": "Tennessee",
    "zip": "37363",
    "lat": 35.0592179,
    "lng": -85.0684361
  },
  {
    "Store Location": "Tractor Supply 9715 US HWY 64 ARLINGTON, Tennessee 38002",
    "Store Type": "Tractor Supply",
    "Phone Number": "901-386-6637",
    "address": "9715 US HWY 64, ARLINGTON, Tennessee 38002",
    "city": "ARLINGTON",
    "state": "Tennessee",
    "zip": "38002",
    "lat": 35.2038532,
    "lng": -89.7391541
  },
  {
    "Store Location": "Tractor Supply 975 HWY 51 NORTH STE F COVINGTON, Tennessee 38019",
    "Store Type": "Tractor Supply",
    "Phone Number": "901-475-1066",
    "address": "975 HWY 51 NORTH STE F, COVINGTON, Tennessee 38019",
    "city": "COVINGTON",
    "state": "Tennessee",
    "zip": "38019",
    "lat": 35.74172009999999,
    "lng": -89.5562931
  },
  {
    "Store Location": "Tractor Supply 100 STATE HWY 205 STE 100 TERRELL, Texas 75160",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-551-2600",
    "address": "100 STATE HWY 205 STE 100, TERRELL, Texas 75160",
    "city": "TERRELL",
    "state": "Texas",
    "zip": "75160",
    "lat": 32.7392952,
    "lng": -96.30150929999999
  },
  {
    "Store Location": "Tractor Supply 1001 NORTH INTERSTATE 27 STE 1 PLAINVIEW, Texas 79072",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-293-5310",
    "address": "1001 NORTH INTERSTATE 27 STE 1, PLAINVIEW, Texas 79072",
    "city": "PLAINVIEW",
    "state": "Texas",
    "zip": "79072",
    "lat": 34.1894809,
    "lng": -101.7533381
  },
  {
    "Store Location": "Tractor Supply 1002 WEST EXPY 83 WESLACO, Texas 78596",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-968-7033",
    "address": "1002 WEST EXPY 83, WESLACO, Texas 78596",
    "city": "WESLACO",
    "state": "Texas",
    "zip": "78596",
    "lat": 26.1740144,
    "lng": -98.00038479999999
  },
  {
    "Store Location": "Tractor Supply 1011 EAST MILAM ST MEXIA, Texas 76667",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-562-7501",
    "address": "1011 EAST MILAM ST, MEXIA, Texas 76667",
    "city": "MEXIA",
    "state": "Texas",
    "zip": "76667",
    "lat": 31.6863078,
    "lng": -96.4690765
  },
  {
    "Store Location": "Tractor Supply 1011 WAL ST STE 300 LONGVIEW, Texas 75605",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-663-0016",
    "address": "1011 WAL ST STE 300, LONGVIEW, Texas 75605",
    "city": "LONGVIEW",
    "state": "Texas",
    "zip": "75605",
    "lat": 32.5460736,
    "lng": -94.72873229999999
  },
  {
    "Store Location": "Tractor Supply 105 EAST END BLVD MARSHALL, Texas 75670",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-927-1088",
    "address": "105 EAST END BLVD, MARSHALL, Texas 75670",
    "city": "MARSHALL",
    "state": "Texas",
    "zip": "75670",
    "lat": 32.5456331,
    "lng": -94.3522253
  },
  {
    "Store Location": "Tractor Supply 106 SOUTH RED RIVER EXPY BURKBURNETT, Texas 76354",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-569-9257",
    "address": "106 SOUTH RED RIVER EXPY, BURKBURNETT, Texas 76354",
    "city": "BURKBURNETT",
    "state": "Texas",
    "zip": "76354",
    "lat": 34.0922001,
    "lng": -98.55939990000002
  },
  {
    "Store Location": "Tractor Supply 10800 HWY 242 CONROE, Texas 77385",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-271-4000",
    "address": "10800 HWY 242, CONROE, Texas 77385",
    "city": "CONROE",
    "state": "Texas",
    "zip": "77385",
    "lat": 30.2079924,
    "lng": -95.41757469999999
  },
  {
    "Store Location": "Tractor Supply 1087 EAST HWY 199 SPRINGTOWN, Texas 76082",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-220-0760",
    "address": "1087 EAST HWY 199, SPRINGTOWN, Texas 76082",
    "city": "SPRINGTOWN",
    "state": "Texas",
    "zip": "76082",
    "lat": 32.9536377,
    "lng": -97.66146739999999
  },
  {
    "Store Location": "Tractor Supply 1104 WEST INTERSTATE 20 BIG SPRING, Texas 79720",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-264-6162",
    "address": "1104 WEST INTERSTATE 20 BIG, SPRING, Texas 79720",
    "city": "SPRING",
    "state": "Texas",
    "zip": "79720",
    "lat": 32.2634257,
    "lng": -101.4931024
  },
  {
    "Store Location": "Tractor Supply 1111 SOUTH MAGNOLIA ST WOODVILLE, Texas 75979",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-331-9988",
    "address": "1111 SOUTH MAGNOLIA ST, WOODVILLE, Texas 75979",
    "city": "WOODVILLE",
    "state": "Texas",
    "zip": "75979",
    "lat": 30.7634915,
    "lng": -94.41519509999999
  },
  {
    "Store Location": "Tractor Supply 115 EAST BOLING HWY WHARTON, Texas 77488",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-282-2782",
    "address": "115 EAST BOLING HWY, WHARTON, Texas 77488",
    "city": "WHARTON",
    "state": "Texas",
    "zip": "77488",
    "lat": 29.325941,
    "lng": -96.09366
  },
  {
    "Store Location": "Tractor Supply 1155 TENAHA ST STE 2 CENTER, Texas 75935",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-591-9683",
    "address": "1155 TENAHA ST STE 2, CENTER, Texas 75935",
    "city": "CENTER",
    "state": "Texas",
    "zip": "75935",
    "lat": 31.810547,
    "lng": -94.19097
  },
  {
    "Store Location": "Tractor Supply 11946 LESLIE RD HELOTES, Texas 78023",
    "Store Type": "Tractor Supply",
    "Phone Number": "210-695-8023",
    "address": "11946 LESLIE RD, HELOTES, Texas 78023",
    "city": "HELOTES",
    "state": "Texas",
    "zip": "78023",
    "lat": 29.5536284,
    "lng": -98.6835694
  },
  {
    "Store Location": "Tractor Supply 1200 FM 1462 ALVIN, Texas 77511",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-824-9609",
    "address": "1200 FM 1462, ALVIN, Texas 77511",
    "city": "ALVIN",
    "state": "Texas",
    "zip": "77511",
    "lat": 29.4016568,
    "lng": -95.2466135
  },
  {
    "Store Location": "Tractor Supply 1200 SOUTH FM 51 STE A DECATUR, Texas 76234",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-627-6167",
    "address": "1200 SOUTH FM 51 STE A, DECATUR, Texas 76234",
    "city": "DECATUR",
    "state": "Texas",
    "zip": "76234",
    "lat": 33.225912,
    "lng": -97.5942315
  },
  {
    "Store Location": "Tractor Supply 1200 SOUTH LOOP 288 DENTON, Texas 76205",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-387-5600",
    "address": "1200 SOUTH LOOP 288, DENTON, Texas 76205",
    "city": "DENTON",
    "state": "Texas",
    "zip": "76205",
    "lat": 33.1984285,
    "lng": -97.0931293
  },
  {
    "Store Location": "Tractor Supply 1200 SOUTH US HWY 281 BLANCO, Texas 78606",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-833-0722",
    "address": "1200 SOUTH US HWY 281, BLANCO, Texas 78606",
    "city": "BLANCO",
    "state": "Texas",
    "zip": "78606",
    "lat": 30.0836323,
    "lng": -98.41604869999999
  },
  {
    "Store Location": "Tractor Supply 1201 NORTH HWY 77 WAXAHACHIE, Texas 75165",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-923-1988",
    "address": "1201 NORTH HWY 77, WAXAHACHIE, Texas 75165",
    "city": "WAXAHACHIE",
    "state": "Texas",
    "zip": "75165",
    "lat": 32.4182677,
    "lng": -96.8429903
  },
  {
    "Store Location": "Tractor Supply 12016 US HWY 87 DALHART, Texas 79022",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-249-4014",
    "address": "12016 US HWY 87, DALHART, Texas 79022",
    "city": "DALHART",
    "state": "Texas",
    "zip": "79022",
    "lat": 36.0594772,
    "lng": -102.5132497
  },
  {
    "Store Location": "Tractor Supply 1207 NORTH AVE G CLIFTON, Texas 76634",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-675-2626",
    "address": "1207 NORTH AVE G, CLIFTON, Texas 76634",
    "city": "CLIFTON",
    "state": "Texas",
    "zip": "76634",
    "lat": 31.7946806,
    "lng": -97.58656219999999
  },
  {
    "Store Location": "Tractor Supply 1221 NUECES ST GEORGE WEST, Texas 78022",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-449-1583",
    "address": "1221 NUECES ST GEORGE, WEST, Texas 78022",
    "city": "WEST",
    "state": "Texas",
    "zip": "78022",
    "lat": 28.337744,
    "lng": -98.12295499999999
  },
  {
    "Store Location": "Tractor Supply 12466 INTERSTATE 45 NORTH STE B WILLIS, Texas 77378",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-856-1549",
    "address": "12466 INTERSTATE 45 NORTH STE B, WILLIS, Texas 77378",
    "city": "WILLIS",
    "state": "Texas",
    "zip": "77378",
    "lat": 30.4227951,
    "lng": -95.4899592
  },
  {
    "Store Location": "Tractor Supply 125 WESTERN TRL JACKSBORO, Texas 76458",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-567-2785",
    "address": "125 WESTERN TRL, JACKSBORO, Texas 76458",
    "city": "JACKSBORO",
    "state": "Texas",
    "zip": "76458",
    "lat": 33.2309007,
    "lng": -98.1648335
  },
  {
    "Store Location": "Tractor Supply 1305 SIDNEY BAKER STE K KERRVILLE, Texas 78028",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-257-0400",
    "address": "1305 SIDNEY BAKER STE K, KERRVILLE, Texas 78028",
    "city": "KERRVILLE",
    "state": "Texas",
    "zip": "78028",
    "lat": 30.05615079999999,
    "lng": -99.12840759999999
  },
  {
    "Store Location": "Tractor Supply 1320 WEST INTERSTATE 20 MONAHANS, Texas 79756",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-943-2466",
    "address": "1320 WEST INTERSTATE 20, MONAHANS, Texas 79756",
    "city": "MONAHANS",
    "state": "Texas",
    "zip": "79756",
    "lat": 31.5714243,
    "lng": -102.907793
  },
  {
    "Store Location": "Tractor Supply 13410 FM 1764 ROAD SANTA FE, Texas 77510",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7539",
    "address": "13410 FM 1764 ROAD SANTA, FE, Texas 77510",
    "city": "FE",
    "state": "Texas",
    "zip": "77510",
    "lat": 29.3907886,
    "lng": -95.107058
  },
  {
    "Store Location": "Tractor Supply 13641 HWY 110 SOUTH TYLER, Texas 75707",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-534-3635",
    "address": "13641 HWY 110 SOUTH, TYLER, Texas 75707",
    "city": "TYLER",
    "state": "Texas",
    "zip": "75707",
    "lat": 32.2796395,
    "lng": -95.24539089999999
  },
  {
    "Store Location": "Tractor Supply 1400 EAST TYLER ST ATHENS, Texas 75751",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-677-1809",
    "address": "1400 EAST TYLER ST, ATHENS, Texas 75751",
    "city": "ATHENS",
    "state": "Texas",
    "zip": "75751",
    "lat": 32.2106883,
    "lng": -95.8290162
  },
  {
    "Store Location": "Tractor Supply 1401 EAST MAIN ST EASTLAND, Texas 76448",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-629-2088",
    "address": "1401 EAST MAIN ST, EASTLAND, Texas 76448",
    "city": "EASTLAND",
    "state": "Texas",
    "zip": "76448",
    "lat": 32.4007101,
    "lng": -98.79492409999999
  },
  {
    "Store Location": "Tractor Supply 1407 INTERSTATE 45 NORTH CONROE, Texas 77304",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-756-3831",
    "address": "1407 INTERSTATE 45 NORTH, CONROE, Texas 77304",
    "city": "CONROE",
    "state": "Texas",
    "zip": "77304",
    "lat": 30.3190702,
    "lng": -95.4742586
  },
  {
    "Store Location": "Tractor Supply 1408 EAST LOOP 304 CROCKETT, Texas 75835",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-544-3909",
    "address": "1408 EAST LOOP 304, CROCKETT, Texas 75835",
    "city": "CROCKETT",
    "state": "Texas",
    "zip": "75835",
    "lat": 31.3076724,
    "lng": -95.43989669999999
  },
  {
    "Store Location": "Tractor Supply 143 TOWN CENTER BLVD JARRELL, Texas 76537",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-746-2199",
    "address": "143 TOWN CENTER BLVD, JARRELL, Texas 76537",
    "city": "JARRELL",
    "state": "Texas",
    "zip": "76537",
    "lat": 30.8161125,
    "lng": -97.6148953
  },
  {
    "Store Location": "Tractor Supply 1451 SOUTH PACIFIC ST MINEOLA, Texas 75773",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-569-9658",
    "address": "1451 SOUTH PACIFIC ST, MINEOLA, Texas 75773",
    "city": "MINEOLA",
    "state": "Texas",
    "zip": "75773",
    "lat": 32.6508168,
    "lng": -95.4892464
  },
  {
    "Store Location": "Tractor Supply 1500 EAST CT ST STE 900 SEGUIN, Texas 78155",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-372-1222",
    "address": "1500 EAST CT ST STE 900, SEGUIN, Texas 78155",
    "city": "SEGUIN",
    "state": "Texas",
    "zip": "78155",
    "lat": 29.5701985,
    "lng": -97.9379962
  },
  {
    "Store Location": "Tractor Supply 1500 WEST CAMERON STE C ROCKDALE, Texas 76567",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-446-2327",
    "address": "1500 WEST CAMERON STE C, ROCKDALE, Texas 76567",
    "city": "ROCKDALE",
    "state": "Texas",
    "zip": "76567",
    "lat": 30.6486687,
    "lng": -97.02005919999999
  },
  {
    "Store Location": "Tractor Supply 1501 WEST EXPY 83 MISSION, Texas 78572",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-583-2156",
    "address": "1501 WEST EXPY 83, MISSION, Texas 78572",
    "city": "MISSION",
    "state": "Texas",
    "zip": "78572",
    "lat": 26.2098873,
    "lng": -98.3445122
  },
  {
    "Store Location": "Tractor Supply 1507 US HWY 281 MARBLE FALLS, Texas 78654",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-798-2642",
    "address": "1507 US HWY 281 MARBLE, FALLS, Texas 78654",
    "city": "FALLS",
    "state": "Texas",
    "zip": "78654",
    "lat": 30.58476719999999,
    "lng": -98.27255199999999
  },
  {
    "Store Location": "Tractor Supply 1509 EAST CENTRAL AVE COMANCHE, Texas 76442",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-356-2480",
    "address": "1509 EAST CENTRAL AVE, COMANCHE, Texas 76442",
    "city": "COMANCHE",
    "state": "Texas",
    "zip": "76442",
    "lat": 31.8991831,
    "lng": -98.5833483
  },
  {
    "Store Location": "Tractor Supply 1511 WEST INTERSTATE 20 ODESSA, Texas 79766",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-332-8464",
    "address": "1511 WEST INTERSTATE 20, ODESSA, Texas 79766",
    "city": "ODESSA",
    "state": "Texas",
    "zip": "79766",
    "lat": 31.8919058,
    "lng": -102.2532279
  },
  {
    "Store Location": "Tractor Supply 152 FM 1030 SAN SABA, Texas 76877",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-372-6190",
    "address": "152 FM 1030 SAN, SABA, Texas 76877",
    "city": "SABA",
    "state": "Texas",
    "zip": "76877",
    "lat": 31.2011309,
    "lng": -98.7593165
  },
  {
    "Store Location": "Tractor Supply 1530 SOUTH MAIN ST BOERNE, Texas 78006",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-249-0739",
    "address": "1530 SOUTH MAIN ST, BOERNE, Texas 78006",
    "city": "BOERNE",
    "state": "Texas",
    "zip": "78006",
    "lat": 29.7702109,
    "lng": -98.72105309999999
  },
  {
    "Store Location": "Tractor Supply 1532 HWY 59 NORTH BOWIE, Texas 76230",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-872-1702",
    "address": "1532 HWY 59 NORTH, BOWIE, Texas 76230",
    "city": "BOWIE",
    "state": "Texas",
    "zip": "76230",
    "lat": 33.5686355,
    "lng": -97.83656260000001
  },
  {
    "Store Location": "Tractor Supply 1550 HIGHWAY 157 N MANSFIELD, Texas 76063",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-477-3950",
    "address": "1550 HIGHWAY 157 N, MANSFIELD, Texas 76063",
    "city": "MANSFIELD",
    "state": "Texas",
    "zip": "76063",
    "lat": 32.5892315,
    "lng": -97.15032939999999
  },
  {
    "Store Location": "Tractor Supply 1551 FOURTH ST GRAHAM, Texas 76450",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-521-0389",
    "address": "1551 FOURTH ST, GRAHAM, Texas 76450",
    "city": "GRAHAM",
    "state": "Texas",
    "zip": "76450",
    "lat": 33.1117445,
    "lng": -98.5642901
  },
  {
    "Store Location": "Tractor Supply 15555 INTERSTATE HWY 35 BUDA, Texas 78610",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-295-5169",
    "address": "15555 INTERSTATE HWY 35, BUDA, Texas 78610",
    "city": "BUDA",
    "state": "Texas",
    "zip": "78610",
    "lat": 30.082252,
    "lng": -97.819552
  },
  {
    "Store Location": "Tractor Supply 1600 EAST BROADWAY CUERO, Texas 77954",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-275-8880",
    "address": "1600 EAST BROADWAY, CUERO, Texas 77954",
    "city": "CUERO",
    "state": "Texas",
    "zip": "77954",
    "lat": 29.0886117,
    "lng": -97.2642757
  },
  {
    "Store Location": "Tractor Supply 1600 NORTH SWENSON ST STAMFORD, Texas 79553",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-773-2516",
    "address": "1600 NORTH SWENSON ST, STAMFORD, Texas 79553",
    "city": "STAMFORD",
    "state": "Texas",
    "zip": "79553",
    "lat": 32.9615951,
    "lng": -99.8010736
  },
  {
    "Store Location": "Tractor Supply 1606 EAST MAIN ST MADISONVILLE, Texas 77864",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-348-2879",
    "address": "1606 EAST MAIN ST, MADISONVILLE, Texas 77864",
    "city": "MADISONVILLE",
    "state": "Texas",
    "zip": "77864",
    "lat": 30.9557038,
    "lng": -95.8958711
  },
  {
    "Store Location": "Tractor Supply 1615 A WEST HENDERSON ST CLEBURNE, Texas 76033",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-641-0066",
    "address": "1615 A WEST HENDERSON ST, CLEBURNE, Texas 76033",
    "city": "CLEBURNE",
    "state": "Texas",
    "zip": "76033",
    "lat": 32.3374614,
    "lng": -97.4119436
  },
  {
    "Store Location": "Tractor Supply 1619 EAST SARAH DEWITT DR GONZALES, Texas 78629",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-672-5707",
    "address": "1619 EAST SARAH DEWITT DR, GONZALES, Texas 78629",
    "city": "GONZALES",
    "state": "Texas",
    "zip": "78629",
    "lat": 29.5228693,
    "lng": -97.4446428
  },
  {
    "Store Location": "Tractor Supply 1626 SOUTH JACKSON STE 128 JACKSONVILLE, Texas 75766",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-586-6343",
    "address": "1626 SOUTH JACKSON STE 128, JACKSONVILLE, Texas 75766",
    "city": "JACKSONVILLE",
    "state": "Texas",
    "zip": "75766",
    "lat": 31.9486475,
    "lng": -95.2594658
  },
  {
    "Store Location": "Tractor Supply 1650 HIGHWAY 365 PORT ARTHUR, Texas 77640",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-721-6800",
    "address": "1650 HIGHWAY 365 PORT, ARTHUR, Texas 77640",
    "city": "ARTHUR",
    "state": "Texas",
    "zip": "77640",
    "lat": 29.9342628,
    "lng": -94.00403899999999
  },
  {
    "Store Location": "Tractor Supply 1650 WEST PRINCETON PRINCETON, Texas 75407",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-736-2555",
    "address": "1650 WEST PRINCETON, PRINCETON, Texas 75407",
    "city": "PRINCETON",
    "state": "Texas",
    "zip": "75407",
    "lat": 33.1836029,
    "lng": -96.53169729999999
  },
  {
    "Store Location": "Tractor Supply 1700 NORTH GRAND AVE GAINESVILLE, Texas 76240",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-668-4088",
    "address": "1700 NORTH GRAND AVE, GAINESVILLE, Texas 76240",
    "city": "GAINESVILLE",
    "state": "Texas",
    "zip": "76240",
    "lat": 33.6445994,
    "lng": -97.1327402
  },
  {
    "Store Location": "Tractor Supply 1700 WEST DICKINSON BLVD STE A FORT STOCKTON, Texas 79735",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-336-3373",
    "address": "1700 WEST DICKINSON BLVD STE A FORT, STOCKTON, Texas 79735",
    "city": "STOCKTON",
    "state": "Texas",
    "zip": "79735",
    "lat": 30.8959289,
    "lng": -102.896341
  },
  {
    "Store Location": "Tractor Supply 1701 NORTH HWY 377 ROANOKE, Texas 76262",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-491-8203",
    "address": "1701 NORTH HWY 377, ROANOKE, Texas 76262",
    "city": "ROANOKE",
    "state": "Texas",
    "zip": "76262",
    "lat": 33.0223501,
    "lng": -97.2149405
  },
  {
    "Store Location": "Tractor Supply 1701 SOUTH 3RD ST MABANK, Texas 75147",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-887-2390",
    "address": "1701 SOUTH 3RD ST, MABANK, Texas 75147",
    "city": "MABANK",
    "state": "Texas",
    "zip": "75147",
    "lat": 32.3433265,
    "lng": -96.1074003
  },
  {
    "Store Location": "Tractor Supply 1711B WEST HWY 290 DRIPPING SPRINGS, Texas 78620",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-858-7229",
    "address": "1711B WEST HWY 290 DRIPPING, SPRINGS, Texas 78620",
    "city": "SPRINGS",
    "state": "Texas",
    "zip": "78620",
    "lat": 30.2010956,
    "lng": -98.11197489999999
  },
  {
    "Store Location": "Tractor Supply 1715 WEST OAKLAWN ST STE A PLEASANTON, Texas 78064",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-569-5480",
    "address": "1715 WEST OAKLAWN ST STE A, PLEASANTON, Texas 78064",
    "city": "PLEASANTON",
    "state": "Texas",
    "zip": "78064",
    "lat": 28.944012,
    "lng": -98.50428509999999
  },
  {
    "Store Location": "Tractor Supply 1725 EAST HOUSTON ST CLEVELAND, Texas 77327",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-592-0246",
    "address": "1725 EAST HOUSTON ST, CLEVELAND, Texas 77327",
    "city": "CLEVELAND",
    "state": "Texas",
    "zip": "77327",
    "lat": 30.3392604,
    "lng": -95.0681415
  },
  {
    "Store Location": "Tractor Supply 1737 SOUTH BROADWAY SULPHUR SPRINGS, Texas 75482",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-439-4908",
    "address": "1737 SOUTH BROADWAY SULPHUR, SPRINGS, Texas 75482",
    "city": "SPRINGS",
    "state": "Texas",
    "zip": "75482",
    "lat": 33.1058854,
    "lng": -95.5979179
  },
  {
    "Store Location": "Tractor Supply 1740 NORTH BELT LINE RD MESQUITE, Texas 75149",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-285-0411",
    "address": "1740 NORTH BELT LINE RD, MESQUITE, Texas 75149",
    "city": "MESQUITE",
    "state": "Texas",
    "zip": "75149",
    "lat": 32.7881537,
    "lng": -96.5947882
  },
  {
    "Store Location": "Tractor Supply 1817 SOUTH MAIN ST WEATHERFORD, Texas 76086",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-594-2488",
    "address": "1817 SOUTH MAIN ST, WEATHERFORD, Texas 76086",
    "city": "WEATHERFORD",
    "state": "Texas",
    "zip": "76086",
    "lat": 32.7357521,
    "lng": -97.7925293
  },
  {
    "Store Location": "Tractor Supply 1820 US HWY 190 WEST LIVINGSTON, Texas 77351",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-327-4334",
    "address": "1820 US HWY 190 WEST, LIVINGSTON, Texas 77351",
    "city": "LIVINGSTON",
    "state": "Texas",
    "zip": "77351",
    "lat": 30.7187537,
    "lng": -94.95996099999999
  },
  {
    "Store Location": "Tractor Supply 18517 HWY 290 EAST ELGIN, Texas 78621",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-387-3960",
    "address": "18517 HWY 290 EAST, ELGIN, Texas 78621",
    "city": "ELGIN",
    "state": "Texas",
    "zip": "78621",
    "lat": 30.351381,
    "lng": -97.41874999999999
  },
  {
    "Store Location": "Tractor Supply 18567 BUDDY RILEY BLVD MAGNOLIA, Texas 77354",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-259-7158",
    "address": "18567 BUDDY RILEY BLVD, MAGNOLIA, Texas 77354",
    "city": "MAGNOLIA",
    "state": "Texas",
    "zip": "77354",
    "lat": 30.2103111,
    "lng": -95.74849619999999
  },
  {
    "Store Location": "Tractor Supply 190 SOUTH CRESTVIEW DR SEAGOVILLE, Texas 75159",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-287-4949",
    "address": "190 SOUTH CRESTVIEW DR, SEAGOVILLE, Texas 75159",
    "city": "SEAGOVILLE",
    "state": "Texas",
    "zip": "75159",
    "lat": 32.6482905,
    "lng": -96.5300323
  },
  {
    "Store Location": "Tractor Supply 1901 MCCOWEN ST SNYDER, Texas 79549",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-573-0868",
    "address": "1901 MCCOWEN ST, SNYDER, Texas 79549",
    "city": "SNYDER",
    "state": "Texas",
    "zip": "79549",
    "lat": 32.7055825,
    "lng": -100.8649497
  },
  {
    "Store Location": "Tractor Supply 1919 LOOP 332 LIBERTY HILL, Texas 78642",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-778-9041",
    "address": "1919 LOOP 332 LIBERTY, HILL, Texas 78642",
    "city": "HILL",
    "state": "Texas",
    "zip": "78642",
    "lat": 30.673043,
    "lng": -97.9308672
  },
  {
    "Store Location": "Tractor Supply 1920 WEST WHEELER AVE ARANSAS PASS, Texas 78336",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-758-8761",
    "address": "1920 WEST WHEELER AVE ARANSAS, PASS, Texas 78336",
    "city": "PASS",
    "state": "Texas",
    "zip": "78336",
    "lat": 27.9185306,
    "lng": -97.1638586
  },
  {
    "Store Location": "Tractor Supply 200 GARRETT MORRIS PKWY MINERAL WELLS, Texas 76067",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-325-6312",
    "address": "200 GARRETT MORRIS PKWY MINERAL, WELLS, Texas 76067",
    "city": "WELLS",
    "state": "Texas",
    "zip": "76067",
    "lat": 32.8080651,
    "lng": -98.0834364
  },
  {
    "Store Location": "Tractor Supply 200 WEST GIBBS BLVD GLEN ROSE, Texas 76043",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-897-7365",
    "address": "200 WEST GIBBS BLVD GLEN, ROSE, Texas 76043",
    "city": "ROSE",
    "state": "Texas",
    "zip": "76043",
    "lat": 32.2407635,
    "lng": -97.75667460000001
  },
  {
    "Store Location": "Tractor Supply 2000 NORTH BELL BLVD CEDAR PARK, Texas 78613",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-260-9215",
    "address": "2000 NORTH BELL BLVD CEDAR, PARK, Texas 78613",
    "city": "PARK",
    "state": "Texas",
    "zip": "78613",
    "lat": 30.5339455,
    "lng": -97.8346983
  },
  {
    "Store Location": "Tractor Supply 2001 WEST PANOLA ST CARTHAGE, Texas 75633",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-690-9912",
    "address": "2001 WEST PANOLA ST, CARTHAGE, Texas 75633",
    "city": "CARTHAGE",
    "state": "Texas",
    "zip": "75633",
    "lat": 32.1595425,
    "lng": -94.36818679999999
  },
  {
    "Store Location": "Tractor Supply 2002 EAST CENTRAL TEXAS EXPY STE C KILLEEN, Texas 76541",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-200-0654",
    "address": "2002 EAST CENTRAL TEXAS EXPY STE C, KILLEEN, Texas 76541",
    "city": "KILLEEN",
    "state": "Texas",
    "zip": "76541",
    "lat": 31.09014669999999,
    "lng": -97.72335439999999
  },
  {
    "Store Location": "Tractor Supply 2005 WEST STATE HWY 71 LAGRANGE, Texas 78945",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-968-2031",
    "address": "2005 WEST STATE HWY 71, LAGRANGE, Texas 78945",
    "city": "LAGRANGE",
    "state": "Texas",
    "zip": "78945",
    "lat": 29.9024427,
    "lng": -96.906633
  },
  {
    "Store Location": "Tractor Supply 201 SPUR 5 WINNIE, Texas 77665",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-296-2077",
    "address": "201 SPUR 5, WINNIE, Texas 77665",
    "city": "WINNIE",
    "state": "Texas",
    "zip": "77665",
    "lat": 29.8289829,
    "lng": -94.3855133
  },
  {
    "Store Location": "Tractor Supply 2015 NORTH US HWY 385 ANDREWS, Texas 79714",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-523-5500",
    "address": "2015 NORTH US HWY 385, ANDREWS, Texas 79714",
    "city": "ANDREWS",
    "state": "Texas",
    "zip": "79714",
    "lat": 32.3451257,
    "lng": -102.5553135
  },
  {
    "Store Location": "Tractor Supply 202 MENEFEE STREET HONDO, Texas 78861",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-426-2909",
    "address": "202 MENEFEE STREET, HONDO, Texas 78861",
    "city": "HONDO",
    "state": "Texas",
    "zip": "78861",
    "lat": 29.3436917,
    "lng": -99.1295842
  },
  {
    "Store Location": "Tractor Supply 2020 INTERSTATE HWY 10 WEST ORANGE, Texas 77632",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-883-9410",
    "address": "2020 INTERSTATE HWY 10 WEST, ORANGE, Texas 77632",
    "city": "ORANGE",
    "state": "Texas",
    "zip": "77632",
    "lat": 30.0821548,
    "lng": -93.7582223
  },
  {
    "Store Location": "Tractor Supply 2021 HUTCHINS AVE BALLINGER, Texas 76821",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-365-3004",
    "address": "2021 HUTCHINS AVE, BALLINGER, Texas 76821",
    "city": "BALLINGER",
    "state": "Texas",
    "zip": "76821",
    "lat": 31.7179116,
    "lng": -99.9632182
  },
  {
    "Store Location": "Tractor Supply 203 HWY 332 WEST LAKE JACKSON, Texas 77566",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-297-7226",
    "address": "203 HWY 332 WEST LAKE, JACKSON, Texas 77566",
    "city": "JACKSON",
    "state": "Texas",
    "zip": "77566",
    "lat": 29.0468902,
    "lng": -95.4654059
  },
  {
    "Store Location": "Tractor Supply 2035 SPUR 139 PARIS, Texas 75462",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-784-1401",
    "address": "2035 SPUR 139, PARIS, Texas 75462",
    "city": "PARIS",
    "state": "Texas",
    "zip": "75462",
    "lat": 33.6801901,
    "lng": -95.5354203
  },
  {
    "Store Location": "Tractor Supply 20903 CROSBY FWY CROSBY, Texas 77532",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-328-0680",
    "address": "20903 CROSBY FWY, CROSBY, Texas 77532",
    "city": "CROSBY",
    "state": "Texas",
    "zip": "77532",
    "lat": 29.8819435,
    "lng": -95.0681468
  },
  {
    "Store Location": "Tractor Supply 2101 WEST HWY 377 GRANBURY, Texas 76048",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-573-1621",
    "address": "2101 WEST HWY 377, GRANBURY, Texas 76048",
    "city": "GRANBURY",
    "state": "Texas",
    "zip": "76048",
    "lat": 32.4344018,
    "lng": -97.8098586
  },
  {
    "Store Location": "Tractor Supply 2110 RANKIN HWY MIDLAND, Texas 79701",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-685-9225",
    "address": "2110 RANKIN HWY, MIDLAND, Texas 79701",
    "city": "MIDLAND",
    "state": "Texas",
    "zip": "79701",
    "lat": 31.9754087,
    "lng": -102.0767884
  },
  {
    "Store Location": "Tractor Supply 2116 TOWN SQUARE BLVD EAGLE PASS, Texas 78852",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-758-0635",
    "address": "2116 TOWN SQUARE BLVD EAGLE, PASS, Texas 78852",
    "city": "PASS",
    "state": "Texas",
    "zip": "78852",
    "lat": 28.720831,
    "lng": -100.4727829
  },
  {
    "Store Location": "Tractor Supply 2140 SW WILSHIRE BLVD BURLESON, Texas 76028",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-295-5555",
    "address": "2140 SW WILSHIRE BLVD, BURLESON, Texas 76028",
    "city": "BURLESON",
    "state": "Texas",
    "zip": "76028",
    "lat": 32.5097563,
    "lng": -97.35933659999999
  },
  {
    "Store Location": "Tractor Supply 220 STATE HIGHWAY 173 SOUTH BANDERA, Texas 78003",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-796-3993",
    "address": "220 STATE HIGHWAY 173 SOUTH, BANDERA, Texas 78003",
    "city": "BANDERA",
    "state": "Texas",
    "zip": "78003",
    "lat": 29.7211181,
    "lng": -99.0674248
  },
  {
    "Store Location": "Tractor Supply 2200 SOUTH LOOP 256 PALESTINE, Texas 75801",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-723-8381",
    "address": "2200 SOUTH LOOP 256, PALESTINE, Texas 75801",
    "city": "PALESTINE",
    "state": "Texas",
    "zip": "75801",
    "lat": 31.7325331,
    "lng": -95.6122031
  },
  {
    "Store Location": "Tractor Supply 2201 EAST FM 407 BARTONVILLE, Texas 76226",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-241-1050",
    "address": "2201 EAST FM 407, BARTONVILLE, Texas 76226",
    "city": "BARTONVILLE",
    "state": "Texas",
    "zip": "76226",
    "lat": 33.1026971,
    "lng": -97.1319846
  },
  {
    "Store Location": "Tractor Supply 2205 STATE HWY 121 NORTH BONHAM, Texas 75418",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-640-8085",
    "address": "2205 STATE HWY 121 NORTH, BONHAM, Texas 75418",
    "city": "BONHAM",
    "state": "Texas",
    "zip": "75418",
    "lat": 33.5996648,
    "lng": -96.193438
  },
  {
    "Store Location": "Tractor Supply 2208 WEST CANNON ST PECOS, Texas 79772",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-445-1306",
    "address": "2208 WEST CANNON ST, PECOS, Texas 79772",
    "city": "PECOS",
    "state": "Texas",
    "zip": "79772",
    "lat": 31.3961595,
    "lng": -103.516543
  },
  {
    "Store Location": "Tractor Supply 2211 AVE F NORTHWEST CHILDRESS, Texas 79201",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-937-8517",
    "address": "2211 AVE F NORTHWEST, CHILDRESS, Texas 79201",
    "city": "CHILDRESS",
    "state": "Texas",
    "zip": "79201",
    "lat": 34.434245,
    "lng": -100.2293477
  },
  {
    "Store Location": "Tractor Supply 2249 STATE HWY 351 ABILENE, Texas 79601",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-672-2179",
    "address": "2249 STATE HWY 351, ABILENE, Texas 79601",
    "city": "ABILENE",
    "state": "Texas",
    "zip": "79601",
    "lat": 32.4834567,
    "lng": -99.6851475
  },
  {
    "Store Location": "Tractor Supply 22515 SOUTHEAST H K DODGEN LOOP TEMPLE, Texas 76502",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-771-0118",
    "address": "22515 SOUTHEAST H K DODGEN LOOP, TEMPLE, Texas 76502",
    "city": "TEMPLE",
    "state": "Texas",
    "zip": "76502",
    "lat": 31.0599729,
    "lng": -97.338507
  },
  {
    "Store Location": "Tractor Supply 2303 SOUTH COMMERCIAL COLEMAN, Texas 76834",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-625-1109",
    "address": "2303 SOUTH COMMERCIAL, COLEMAN, Texas 76834",
    "city": "COLEMAN",
    "state": "Texas",
    "zip": "76834",
    "lat": 31.810775,
    "lng": -99.42206949999999
  },
  {
    "Store Location": "Tractor Supply 2307 HWY 79 SOUTH HENDERSON, Texas 75654",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-657-7012",
    "address": "2307 HWY 79 SOUTH, HENDERSON, Texas 75654",
    "city": "HENDERSON",
    "state": "Texas",
    "zip": "75654",
    "lat": 32.1532156,
    "lng": -94.7993802
  },
  {
    "Store Location": "Tractor Supply 2309 SOUTH BRIDGE ST BRADY, Texas 76825",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-597-9303",
    "address": "2309 SOUTH BRIDGE ST, BRADY, Texas 76825",
    "city": "BRADY",
    "state": "Texas",
    "zip": "76825",
    "lat": 31.1075359,
    "lng": -99.3309867
  },
  {
    "Store Location": "Tractor Supply 2313 SOUTH COLORADO ST LOCKHART, Texas 78644",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-398-5007",
    "address": "2313 SOUTH COLORADO ST, LOCKHART, Texas 78644",
    "city": "LOCKHART",
    "state": "Texas",
    "zip": "78644",
    "lat": 29.8451084,
    "lng": -97.6699866
  },
  {
    "Store Location": "Tractor Supply 2337 NORTH MAIN ST LIBERTY, Texas 77575",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-334-1100",
    "address": "2337 NORTH MAIN ST, LIBERTY, Texas 77575",
    "city": "LIBERTY",
    "state": "Texas",
    "zip": "77575",
    "lat": 30.0756422,
    "lng": -94.78329099999999
  },
  {
    "Store Location": "Tractor Supply 2340 HWY 36 SOUTH SEALY, Texas 77474",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-627-7766",
    "address": "2340 HWY 36 SOUTH, SEALY, Texas 77474",
    "city": "SEALY",
    "state": "Texas",
    "zip": "77474",
    "lat": 29.7599476,
    "lng": -96.15228429999999
  },
  {
    "Store Location": "Tractor Supply 23741 US HWY 59 #41 PORTER, Texas 77365",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-354-8887",
    "address": "23741 US HWY 59 #41, PORTER, Texas 77365",
    "city": "PORTER",
    "state": "Texas",
    "zip": "77365",
    "lat": 30.10133709999999,
    "lng": -95.2355587
  },
  {
    "Store Location": "Tractor Supply 2401 SOUTH HWY 36 STE 102 GATESVILLE, Texas 76528",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-404-2055",
    "address": "2401 SOUTH HWY 36 STE 102, GATESVILLE, Texas 76528",
    "city": "GATESVILLE",
    "state": "Texas",
    "zip": "76528",
    "lat": 31.4340199,
    "lng": -97.72949159999999
  },
  {
    "Store Location": "Tractor Supply 2405 SOUTH BRAHMA BLVD KINGSVILLE, Texas 78363",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-592-0831",
    "address": "2405 SOUTH BRAHMA BLVD, KINGSVILLE, Texas 78363",
    "city": "KINGSVILLE",
    "state": "Texas",
    "zip": "78363",
    "lat": 27.493565,
    "lng": -97.8580461
  },
  {
    "Store Location": "Tractor Supply 2500 EAST US HIGHWAY 90 ALPINE, Texas 79830",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-837-4890",
    "address": "2500 EAST US HIGHWAY 90, ALPINE, Texas 79830",
    "city": "ALPINE",
    "state": "Texas",
    "zip": "79830",
    "lat": 30.3514268,
    "lng": -103.6893511
  },
  {
    "Store Location": "Tractor Supply 2500 NORTH ST MARYS BEEVILLE, Texas 78102",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-362-2226",
    "address": "2500 NORTH ST MARYS, BEEVILLE, Texas 78102",
    "city": "BEEVILLE",
    "state": "Texas",
    "zip": "78102",
    "lat": 28.4242896,
    "lng": -97.7557611
  },
  {
    "Store Location": "Tractor Supply 2525 SOUTH JEFFERSON AVE MOUNT PLEASANT, Texas 75455",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-575-0707",
    "address": "2525 SOUTH JEFFERSON AVE MOUNT, PLEASANT, Texas 75455",
    "city": "PLEASANT",
    "state": "Texas",
    "zip": "75455",
    "lat": 33.1304374,
    "lng": -94.9677706
  },
  {
    "Store Location": "Tractor Supply 2545 PERRYTON PKWY STE D PAMPA, Texas 79065",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-669-1111",
    "address": "2545 PERRYTON PKWY STE D, PAMPA, Texas 79065",
    "city": "PAMPA",
    "state": "Texas",
    "zip": "79065",
    "lat": 35.5660836,
    "lng": -100.9694162
  },
  {
    "Store Location": "Tractor Supply 2618 SOUTHWEST PKWY WICHITA FALLS, Texas 76308",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-696-8850",
    "address": "2618 SOUTHWEST PKWY WICHITA, FALLS, Texas 76308",
    "city": "FALLS",
    "state": "Texas",
    "zip": "76308",
    "lat": 33.8591671,
    "lng": -98.52991229999999
  },
  {
    "Store Location": "Tractor Supply 2701 SOUTHWEST BLVD SAN ANGELO, Texas 76904",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-942-8330",
    "address": "2701 SOUTHWEST BLVD SAN, ANGELO, Texas 76904",
    "city": "ANGELO",
    "state": "Texas",
    "zip": "76904",
    "lat": 31.4350109,
    "lng": -100.4946378
  },
  {
    "Store Location": "Tractor Supply 2703 TRADERS RD GREENVILLE, Texas 75402",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-454-1400",
    "address": "2703 TRADERS RD, GREENVILLE, Texas 75402",
    "city": "GREENVILLE",
    "state": "Texas",
    "zip": "75402",
    "lat": 33.0910369,
    "lng": -96.1086456
  },
  {
    "Store Location": "Tractor Supply 2704 TEXAS AVE STE 1 COLLEGE STATION, Texas 77840",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-764-4757",
    "address": "2704 TEXAS AVE STE 1 COLLEGE, STATION, Texas 77840",
    "city": "STATION",
    "state": "Texas",
    "zip": "77840",
    "lat": 30.5994834,
    "lng": -96.3040839
  },
  {
    "Store Location": "Tractor Supply 27127 SOUTHWEST FWY ROSENBERG, Texas 77471",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-232-7878",
    "address": "27127 SOUTHWEST FWY, ROSENBERG, Texas 77471",
    "city": "ROSENBERG",
    "state": "Texas",
    "zip": "77471",
    "lat": 29.5318431,
    "lng": -95.7925732
  },
  {
    "Store Location": "Tractor Supply 2718 SOUTH MARKET ST BRENHAM, Texas 77833",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-836-9797",
    "address": "2718 SOUTH MARKET ST, BRENHAM, Texas 77833",
    "city": "BRENHAM",
    "state": "Texas",
    "zip": "77833",
    "lat": 30.14442429999999,
    "lng": -96.37039469999999
  },
  {
    "Store Location": "Tractor Supply 272 FM 1103 CIBOLO, Texas 78108",
    "Store Type": "Tractor Supply",
    "Phone Number": "210-566-1151",
    "address": "272 FM 1103, CIBOLO, Texas 78108",
    "city": "CIBOLO",
    "state": "Texas",
    "zip": "78108",
    "lat": 29.5615488,
    "lng": -98.23715430000001
  },
  {
    "Store Location": "Tractor Supply 27400 TOMBALL PKWY TOMBALL, Texas 77375",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-357-0000",
    "address": "27400 TOMBALL PKWY, TOMBALL, Texas 77375",
    "city": "TOMBALL",
    "state": "Texas",
    "zip": "77375",
    "lat": 30.0728676,
    "lng": -95.62484909999999
  },
  {
    "Store Location": "Tractor Supply 2754 SARATOGA BLVD CORPUS CHRISTI, Texas 78415",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-850-1804",
    "address": "2754 SARATOGA BLVD CORPUS, CHRISTI, Texas 78415",
    "city": "CHRISTI",
    "state": "Texas",
    "zip": "78415",
    "lat": 27.7112372,
    "lng": -97.4339543
  },
  {
    "Store Location": "Tractor Supply 2834 WEST COMMERCE ST BUFFALO, Texas 75831",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-322-2955",
    "address": "2834 WEST COMMERCE ST, BUFFALO, Texas 75831",
    "city": "BUFFALO",
    "state": "Texas",
    "zip": "75831",
    "lat": 31.4461108,
    "lng": -96.07861369999999
  },
  {
    "Store Location": "Tractor Supply 2900 WEST WASHINGTON #35 STEPHENVILLE, Texas 76401",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-965-8900",
    "address": "2900 WEST WASHINGTON #35, STEPHENVILLE, Texas 76401",
    "city": "STEPHENVILLE",
    "state": "Texas",
    "zip": "76401",
    "lat": 32.200817,
    "lng": -98.245735
  },
  {
    "Store Location": "Tractor Supply 2911 EAST AUSTIN ST GIDDINGS, Texas 78942",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-542-1325",
    "address": "2911 EAST AUSTIN ST, GIDDINGS, Texas 78942",
    "city": "GIDDINGS",
    "state": "Texas",
    "zip": "78942",
    "lat": 30.1792411,
    "lng": -96.90819739999999
  },
  {
    "Store Location": "Tractor Supply 2916 NORTH VELASCO ST ANGLETON, Texas 77515",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-848-8855",
    "address": "2916 NORTH VELASCO ST, ANGLETON, Texas 77515",
    "city": "ANGLETON",
    "state": "Texas",
    "zip": "77515",
    "lat": 29.1972559,
    "lng": -95.4328386
  },
  {
    "Store Location": "Tractor Supply 2917 IH 69 ACCESS RD ROBSTOWN, Texas 78380",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-767-3576",
    "address": "2917 IH 69 ACCESS RD, ROBSTOWN, Texas 78380",
    "city": "ROBSTOWN",
    "state": "Texas",
    "zip": "78380",
    "lat": 27.838383,
    "lng": -97.634596
  },
  {
    "Store Location": "Tractor Supply 300 NORTH VALLEY MILLS RD STE A WACO, Texas 76710",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-776-1070",
    "address": "300 NORTH VALLEY MILLS RD STE A, WACO, Texas 76710",
    "city": "WACO",
    "state": "Texas",
    "zip": "76710",
    "lat": 31.526597,
    "lng": -97.1666077
  },
  {
    "Store Location": "Tractor Supply 300 SOUTH INTERSTATE 45 ENNIS, Texas 75119",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-872-9154",
    "address": "300 SOUTH INTERSTATE 45, ENNIS, Texas 75119",
    "city": "ENNIS",
    "state": "Texas",
    "zip": "75119",
    "lat": 32.3324544,
    "lng": -96.61279809999999
  },
  {
    "Store Location": "Tractor Supply 300 STATE HWY 132 NORTH DEVINE, Texas 78016",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-663-9777",
    "address": "300 STATE HWY 132 NORTH, DEVINE, Texas 78016",
    "city": "DEVINE",
    "state": "Texas",
    "zip": "78016",
    "lat": 29.1422671,
    "lng": -98.9039743
  },
  {
    "Store Location": "Tractor Supply 301 EAST HWY 243 STE 145 CANTON, Texas 75103",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-567-4033",
    "address": "301 EAST HWY 243 STE 145, CANTON, Texas 75103",
    "city": "CANTON",
    "state": "Texas",
    "zip": "75103",
    "lat": 32.5434901,
    "lng": -95.85953699999999
  },
  {
    "Store Location": "Tractor Supply 307 COKE ST HILLSBORO, Texas 76645",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-580-0300",
    "address": "307 COKE ST, HILLSBORO, Texas 76645",
    "city": "HILLSBORO",
    "state": "Texas",
    "zip": "76645",
    "lat": 32.0058511,
    "lng": -97.09834219999999
  },
  {
    "Store Location": "Tractor Supply 31360 FM 2920 RD WALLER, Texas 77484",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-372-3073",
    "address": "31360 FM 2920 RD, WALLER, Texas 77484",
    "city": "WALLER",
    "state": "Texas",
    "zip": "77484",
    "lat": 30.0572244,
    "lng": -95.9121636
  },
  {
    "Store Location": "Tractor Supply 315 LOOP 59 ATLANTA, Texas 75551",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-796-3784",
    "address": "315 LOOP 59, ATLANTA, Texas 75551",
    "city": "ATLANTA",
    "state": "Texas",
    "zip": "75551",
    "lat": 33.1193969,
    "lng": -94.1814788
  },
  {
    "Store Location": "Tractor Supply 315-A EAST COMMERCE ST BROWNWOOD, Texas 76801",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-643-2256",
    "address": "315-A EAST COMMERCE ST, BROWNWOOD, Texas 76801",
    "city": "BROWNWOOD",
    "state": "Texas",
    "zip": "76801",
    "lat": 31.7277557,
    "lng": -98.97361959999999
  },
  {
    "Store Location": "Tractor Supply 3162 WEST US HWY 83 RIO GRANDE CITY, Texas 78582",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-488-1464",
    "address": "3162 WEST US HWY 83 RIO GRANDE, CITY, Texas 78582",
    "city": "CITY",
    "state": "Texas",
    "zip": "78582",
    "lat": 26.5898125,
    "lng": -99.0894256
  },
  {
    "Store Location": "Tractor Supply 3201 NORTH 75 HWY STE 101 SHERMAN, Texas 75091",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-868-1116",
    "address": "3201 NORTH 75 HWY STE 101, SHERMAN, Texas 75091",
    "city": "SHERMAN",
    "state": "Texas",
    "zip": "75091",
    "lat": 33.6715753,
    "lng": -96.6072001
  },
  {
    "Store Location": "Tractor Supply 324 SOUTHWEST WILSHIRE BURLESON, Texas 76028",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-295-0429",
    "address": "324 SOUTHWEST WILSHIRE, BURLESON, Texas 76028",
    "city": "BURLESON",
    "state": "Texas",
    "zip": "76028",
    "lat": 32.5411028,
    "lng": -97.33227289999999
  },
  {
    "Store Location": "Tractor Supply 3325 EAST US HWY 290 FREDERICKSBURG, Texas 78624",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-997-5028",
    "address": "3325 EAST US HWY 290, FREDERICKSBURG, Texas 78624",
    "city": "FREDERICKSBURG",
    "state": "Texas",
    "zip": "78624",
    "lat": 30.2374656,
    "lng": -98.8384693
  },
  {
    "Store Location": "Tractor Supply 334 EAST JIM SHARP BLVD KERMIT, Texas 79745",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-586-2684",
    "address": "334 EAST JIM SHARP BLVD, KERMIT, Texas 79745",
    "city": "KERMIT",
    "state": "Texas",
    "zip": "79745",
    "lat": 31.849958,
    "lng": -103.08132
  },
  {
    "Store Location": "Tractor Supply 3350 NORTH CENTRAL EXPY US 75 MCKINNEY, Texas 75071",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-547-4900",
    "address": "3350 NORTH CENTRAL EXPY US 75, MCKINNEY, Texas 75071",
    "city": "MCKINNEY",
    "state": "Texas",
    "zip": "75071",
    "lat": 33.2325517,
    "lng": -96.6302077
  },
  {
    "Store Location": "Tractor Supply 33701 HWY 281 NORTH BULVERDE, Texas 78163",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-438-4744",
    "address": "33701 HWY 281 NORTH, BULVERDE, Texas 78163",
    "city": "BULVERDE",
    "state": "Texas",
    "zip": "78163",
    "lat": 29.7961179,
    "lng": -98.42128699999999
  },
  {
    "Store Location": "Tractor Supply 3440 IH 20 STANTON, Texas 79782",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-756-2162",
    "address": "3440 IH 20, STANTON, Texas 79782",
    "city": "STANTON",
    "state": "Texas",
    "zip": "79782",
    "lat": 32.1292891,
    "lng": -101.7884642
  },
  {
    "Store Location": "Tractor Supply 3506 WEST LOOP EL CAMPO, Texas 77437",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-543-9351",
    "address": "3506 WEST LOOP EL, CAMPO, Texas 77437",
    "city": "CAMPO",
    "state": "Texas",
    "zip": "77437",
    "lat": 29.2164671,
    "lng": -96.28788860000002
  },
  {
    "Store Location": "Tractor Supply 3509 ROBERTSON RD TYLER, Texas 75701",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-533-9122",
    "address": "3509 ROBERTSON RD, TYLER, Texas 75701",
    "city": "TYLER",
    "state": "Texas",
    "zip": "75701",
    "lat": 32.3336927,
    "lng": -95.338719
  },
  {
    "Store Location": "Tractor Supply 35580 US HWY 96 SOUTH BUNA, Texas 77612",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-994-9398",
    "address": "35580 US HWY 96 SOUTH, BUNA, Texas 77612",
    "city": "BUNA",
    "state": "Texas",
    "zip": "77612",
    "lat": 30.4398413,
    "lng": -93.9705162
  },
  {
    "Store Location": "Tractor Supply 3600 NORTH MAIN ST TAYLOR, Texas 76574",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-352-2006",
    "address": "3600 NORTH MAIN ST, TAYLOR, Texas 76574",
    "city": "TAYLOR",
    "state": "Texas",
    "zip": "76574",
    "lat": 30.5994957,
    "lng": -97.414952
  },
  {
    "Store Location": "Tractor Supply 3732 WEST WALKER ST STE 100 BRECKENRIDGE, Texas 76424",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-559-2438",
    "address": "3732 WEST WALKER ST STE 100, BRECKENRIDGE, Texas 76424",
    "city": "BRECKENRIDGE",
    "state": "Texas",
    "zip": "76424",
    "lat": 32.7603392,
    "lng": -98.94477409999999
  },
  {
    "Store Location": "Tractor Supply 3736 EAST HWY 44 ALICE, Texas 78332",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-664-2284",
    "address": "3736 EAST HWY 44, ALICE, Texas 78332",
    "city": "ALICE",
    "state": "Texas",
    "zip": "78332",
    "lat": 27.7747083,
    "lng": -98.0281996
  },
  {
    "Store Location": "Tractor Supply 3751 WEST HWY 31 CORSICANA, Texas 75110",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-872-0503",
    "address": "3751 WEST HWY 31, CORSICANA, Texas 75110",
    "city": "CORSICANA",
    "state": "Texas",
    "zip": "75110",
    "lat": 32.1085029,
    "lng": -96.3718494
  },
  {
    "Store Location": "Tractor Supply 3919 TELEPHONE RD LAKE WORTH, Texas 76135",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-237-5222",
    "address": "3919 TELEPHONE RD LAKE, WORTH, Texas 76135",
    "city": "WORTH",
    "state": "Texas",
    "zip": "76135",
    "lat": 32.814384,
    "lng": -97.4333329
  },
  {
    "Store Location": "Tractor Supply 400 US HIGHWAY 59 SOUTH EDNA, Texas 77957",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-782-5050",
    "address": "400 US HIGHWAY 59 SOUTH, EDNA, Texas 77957",
    "city": "EDNA",
    "state": "Texas",
    "zip": "77957",
    "lat": 28.97360919999999,
    "lng": -96.66571139999999
  },
  {
    "Store Location": "Tractor Supply 401 EAST HWY 71 LLANO, Texas 78643",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-247-3723",
    "address": "401 EAST HWY 71, LLANO, Texas 78643",
    "city": "LLANO",
    "state": "Texas",
    "zip": "78643",
    "lat": 30.7379903,
    "lng": -98.6717431
  },
  {
    "Store Location": "Tractor Supply 401 SOUTHEAST 8TH ST SEMINOLE, Texas 79360",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-758-6336",
    "address": "401 SOUTHEAST 8TH ST, SEMINOLE, Texas 79360",
    "city": "SEMINOLE",
    "state": "Texas",
    "zip": "79360",
    "lat": 32.7136675,
    "lng": -102.6353953
  },
  {
    "Store Location": "Tractor Supply 407 NORTH SUNSET STRIP KENEDY, Texas 78119",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-583-9287",
    "address": "407 NORTH SUNSET STRIP, KENEDY, Texas 78119",
    "city": "KENEDY",
    "state": "Texas",
    "zip": "78119",
    "lat": 28.825315,
    "lng": -97.860725
  },
  {
    "Store Location": "Tractor Supply 409 NORTHEAST GEORGIA AVE SWEETWATER, Texas 79556",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-236-9275",
    "address": "409 NORTHEAST GEORGIA AVE, SWEETWATER, Texas 79556",
    "city": "SWEETWATER",
    "state": "Texas",
    "zip": "79556",
    "lat": 32.4541346,
    "lng": -100.3919367
  },
  {
    "Store Location": "Tractor Supply 4101 HILLCREST PLZ VERNON, Texas 76384",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-552-2875",
    "address": "4101 HILLCREST PLZ, VERNON, Texas 76384",
    "city": "VERNON",
    "state": "Texas",
    "zip": "76384",
    "lat": 34.1610469,
    "lng": -99.31195819999999
  },
  {
    "Store Location": "Tractor Supply 4102 STATE HWY 359 LAREDO, Texas 78043",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-725-0468",
    "address": "4102 STATE HWY 359, LAREDO, Texas 78043",
    "city": "LAREDO",
    "state": "Texas",
    "zip": "78043",
    "lat": 27.4992597,
    "lng": -99.4543127
  },
  {
    "Store Location": "Tractor Supply 421 EAST MAIN UVALDE, Texas 78801",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-278-3435",
    "address": "421 EAST MAIN, UVALDE, Texas 78801",
    "city": "UVALDE",
    "state": "Texas",
    "zip": "78801",
    "lat": 29.2110838,
    "lng": -99.7778898
  },
  {
    "Store Location": "Tractor Supply 4301A NORTH ST NACOGDOCHES, Texas 75965",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-568-9800",
    "address": "4301A NORTH ST, NACOGDOCHES, Texas 75965",
    "city": "NACOGDOCHES",
    "state": "Texas",
    "zip": "75965",
    "lat": 31.6440335,
    "lng": -94.65573119999999
  },
  {
    "Store Location": "Tractor Supply 441-B HWY 71 WEST BASTROP, Texas 78602",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-321-3660",
    "address": "441-B HWY 71 WEST, BASTROP, Texas 78602",
    "city": "BASTROP",
    "state": "Texas",
    "zip": "78602",
    "lat": 30.1078842,
    "lng": -97.3314046
  },
  {
    "Store Location": "Tractor Supply 444 FM 1463 RD KATY, Texas 77494",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-574-1391",
    "address": "444 FM 1463 RD, KATY, Texas 77494",
    "city": "KATY",
    "state": "Texas",
    "zip": "77494",
    "lat": 29.7781789,
    "lng": -95.8327317
  },
  {
    "Store Location": "Tractor Supply 4450 SOUTHWEST DR ABILENE, Texas 79606",
    "Store Type": "Tractor Supply",
    "Phone Number": "325-691-8901",
    "address": "4450 SOUTHWEST DR, ABILENE, Texas 79606",
    "city": "ABILENE",
    "state": "Texas",
    "zip": "79606",
    "lat": 32.4092361,
    "lng": -99.7820254
  },
  {
    "Store Location": "Tractor Supply 455 SABINE ST HEMPHILL, Texas 75948",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-787-0031",
    "address": "455 SABINE ST, HEMPHILL, Texas 75948",
    "city": "HEMPHILL",
    "state": "Texas",
    "zip": "75948",
    "lat": 31.34710519999999,
    "lng": -93.8439528
  },
  {
    "Store Location": "Tractor Supply 4605 INTERSTATE 27 LUBBOCK, Texas 79404",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-744-6168",
    "address": "4605 INTERSTATE 27, LUBBOCK, Texas 79404",
    "city": "LUBBOCK",
    "state": "Texas",
    "zip": "79404",
    "lat": 33.551938,
    "lng": -101.8434678
  },
  {
    "Store Location": "Tractor Supply 469 CENTRAL TEXAS EXPY LAMPASAS, Texas 76550",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-556-8189",
    "address": "469 CENTRAL TEXAS EXPY, LAMPASAS, Texas 76550",
    "city": "LAMPASAS",
    "state": "Texas",
    "zip": "76550",
    "lat": 31.0576974,
    "lng": -98.17440429999999
  },
  {
    "Store Location": "Tractor Supply 4715 7TH ST BAY CITY, Texas 77414",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-244-8951",
    "address": "4715 7TH ST BAY, CITY, Texas 77414",
    "city": "CITY",
    "state": "Texas",
    "zip": "77414",
    "lat": 28.9881858,
    "lng": -95.93453149999999
  },
  {
    "Store Location": "Tractor Supply 4880 IH 10 RD COLUMBUS, Texas 78934",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-732-2029",
    "address": "4880 IH 10 RD, COLUMBUS, Texas 78934",
    "city": "COLUMBUS",
    "state": "Texas",
    "zip": "78934",
    "lat": 29.7107781,
    "lng": -96.4952289
  },
  {
    "Store Location": "Tractor Supply 5001 NORTH STATELINE AVE TEXARKANA, Texas 75503",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-791-8293",
    "address": "5001 NORTH STATELINE AVE, TEXARKANA, Texas 75503",
    "city": "TEXARKANA",
    "state": "Texas",
    "zip": "75503",
    "lat": 33.4660896,
    "lng": -94.04575469999999
  },
  {
    "Store Location": "Tractor Supply 510 CLUBVIEW DR LEVELLAND, Texas 79336",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-894-2485",
    "address": "510 CLUBVIEW DR, LEVELLAND, Texas 79336",
    "city": "LEVELLAND",
    "state": "Texas",
    "zip": "79336",
    "lat": 33.5735226,
    "lng": -102.3739078
  },
  {
    "Store Location": "Tractor Supply 511 NORTH BRENTWOOD DR LUFKIN, Texas 75904",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-699-7555",
    "address": "511 NORTH BRENTWOOD DR, LUFKIN, Texas 75904",
    "city": "LUFKIN",
    "state": "Texas",
    "zip": "75904",
    "lat": 31.3032279,
    "lng": -94.72990539999999
  },
  {
    "Store Location": "Tractor Supply 539 NORTH 25 MILE AVE HEREFORD, Texas 79045",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-364-1875",
    "address": "539 NORTH 25 MILE AVE, HEREFORD, Texas 79045",
    "city": "HEREFORD",
    "state": "Texas",
    "zip": "79045",
    "lat": 34.8344876,
    "lng": -102.4070751
  },
  {
    "Store Location": "Tractor Supply 540 10TH ST STE 150 FLORESVILLE, Texas 78114",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-393-2950",
    "address": "540 10TH ST STE 150, FLORESVILLE, Texas 78114",
    "city": "FLORESVILLE",
    "state": "Texas",
    "zip": "78114",
    "lat": 29.1542981,
    "lng": -98.16518289999999
  },
  {
    "Store Location": "Tractor Supply 550 SOUTH IH 35 PEARSALL, Texas 78061",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-334-8300",
    "address": "550 SOUTH IH 35, PEARSALL, Texas 78061",
    "city": "PEARSALL",
    "state": "Texas",
    "zip": "78061",
    "lat": 28.8900656,
    "lng": -99.1182932
  },
  {
    "Store Location": "Tractor Supply 5705 MOUNT OLIVE RD ADKINS, Texas 78101",
    "Store Type": "Tractor Supply",
    "Phone Number": "210-649-1631",
    "address": "5705 MOUNT OLIVE RD, ADKINS, Texas 78101",
    "city": "ADKINS",
    "state": "Texas",
    "zip": "78101",
    "lat": 29.3681251,
    "lng": -98.250012
  },
  {
    "Store Location": "Tractor Supply 584 EAST GIBSON ST JASPER, Texas 75951",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-384-5181",
    "address": "584 EAST GIBSON ST, JASPER, Texas 75951",
    "city": "JASPER",
    "state": "Texas",
    "zip": "75951",
    "lat": 30.9130665,
    "lng": -93.99362819999999
  },
  {
    "Store Location": "Tractor Supply 600 SOUTH OKLAHOMA DR CELINA, Texas 75009",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-382-8585",
    "address": "600 SOUTH OKLAHOMA DR, CELINA, Texas 75009",
    "city": "CELINA",
    "state": "Texas",
    "zip": "75009",
    "lat": 33.3173875,
    "lng": -96.78294629999999
  },
  {
    "Store Location": "Tractor Supply 6001 US HWY 377 SOUTH CROSSROADS, Texas 76227",
    "Store Type": "Tractor Supply",
    "Phone Number": "940-365-9494",
    "address": "6001 US HWY 377 SOUTH, CROSSROADS, Texas 76227",
    "city": "CROSSROADS",
    "state": "Texas",
    "zip": "76227",
    "lat": 33.2318281,
    "lng": -97.0022908
  },
  {
    "Store Location": "Tractor Supply 6080 PLUM CREEK DRIVE AMARILLO, Texas 79124",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-355-7686",
    "address": "6080 PLUM CREEK DRIVE, AMARILLO, Texas 79124",
    "city": "AMARILLO",
    "state": "Texas",
    "zip": "79124",
    "lat": 35.2175852,
    "lng": -101.9066232
  },
  {
    "Store Location": "Tractor Supply 620 WEST US HIGHWAY 190 SVC ROAD BELTON, Texas 76513",
    "Store Type": "Tractor Supply",
    "Phone Number": "254-933-7907",
    "address": "620 WEST US HIGHWAY 190 SVC ROAD, BELTON, Texas 76513",
    "city": "BELTON",
    "state": "Texas",
    "zip": "76513",
    "lat": 31.0492981,
    "lng": -97.4755668
  },
  {
    "Store Location": "Tractor Supply 6202 GARTH RD BAYTOWN, Texas 77521",
    "Store Type": "Tractor Supply",
    "Phone Number": "281-421-0649",
    "address": "6202 GARTH RD, BAYTOWN, Texas 77521",
    "city": "BAYTOWN",
    "state": "Texas",
    "zip": "77521",
    "lat": 29.7932898,
    "lng": -94.97921529999999
  },
  {
    "Store Location": "Tractor Supply 6869 SOUTH DESERT BLVD STE 500 EL PASO, Texas 79932",
    "Store Type": "Tractor Supply",
    "Phone Number": "915-877-5397",
    "address": "6869 SOUTH DESERT BLVD STE 500 EL, PASO, Texas 79932",
    "city": "PASO",
    "state": "Texas",
    "zip": "79932",
    "lat": 31.9052198,
    "lng": -106.5845327
  },
  {
    "Store Location": "Tractor Supply 7135 NORTH EXPY 281 EDINBURG, Texas 78542",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-380-1199",
    "address": "7135 NORTH EXPY 281, EDINBURG, Texas 78542",
    "city": "EDINBURG",
    "state": "Texas",
    "zip": "78542",
    "lat": 26.3746547,
    "lng": -98.1457193
  },
  {
    "Store Location": "Tractor Supply 715 STATE HWY 35 SOUTH PORT LAVACA, Texas 77979",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-552-2400",
    "address": "715 STATE HWY 35 SOUTH PORT, LAVACA, Texas 77979",
    "city": "LAVACA",
    "state": "Texas",
    "zip": "77979",
    "lat": 28.6184078,
    "lng": -96.6416548
  },
  {
    "Store Location": "Tractor Supply 723 US HWY 77 NORTH HALLETTSVILLE, Texas 77964",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-798-9118",
    "address": "723 US HWY 77 NORTH, HALLETTSVILLE, Texas 77964",
    "city": "HALLETTSVILLE",
    "state": "Texas",
    "zip": "77964",
    "lat": 29.4670368,
    "lng": -96.93832289999999
  },
  {
    "Store Location": "Tractor Supply 7531 82ND ST LUBBOCK, Texas 79424",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-866-2535",
    "address": "7531 82ND ST, LUBBOCK, Texas 79424",
    "city": "LUBBOCK",
    "state": "Texas",
    "zip": "79424",
    "lat": 33.5187746,
    "lng": -101.9859383
  },
  {
    "Store Location": "Tractor Supply 772 WEST INTERSTATE 30 ROYSE CITY, Texas 75189",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-635-2737",
    "address": "772 WEST INTERSTATE 30 ROYSE, CITY, Texas 75189",
    "city": "CITY",
    "state": "Texas",
    "zip": "75189",
    "lat": 32.961445,
    "lng": -96.34780800000001
  },
  {
    "Store Location": "Tractor Supply 7800 EAST HWY 191 ODESSA, Texas 79765",
    "Store Type": "Tractor Supply",
    "Phone Number": "432-563-1579",
    "address": "7800 EAST HWY 191, ODESSA, Texas 79765",
    "city": "ODESSA",
    "state": "Texas",
    "zip": "79765",
    "lat": 31.8457722,
    "lng": -102.3673976
  },
  {
    "Store Location": "Tractor Supply 801 EAST COKE RD WINNSBORO, Texas 75494",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-342-0009",
    "address": "801 EAST COKE RD, WINNSBORO, Texas 75494",
    "city": "WINNSBORO",
    "state": "Texas",
    "zip": "75494",
    "lat": 32.9497188,
    "lng": -95.2790112
  },
  {
    "Store Location": "Tractor Supply 801 SOUTH INTERSTATE 35 GEORGETOWN, Texas 78626",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-863-6969",
    "address": "801 SOUTH INTERSTATE 35, GEORGETOWN, Texas 78626",
    "city": "GEORGETOWN",
    "state": "Texas",
    "zip": "78626",
    "lat": 30.5009809,
    "lng": -97.6825447
  },
  {
    "Store Location": "Tractor Supply 803 TEXAS SPUR 239 DEL RIO, Texas 78840",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-775-1281",
    "address": "803 TEXAS SPUR 239 DEL, RIO, Texas 78840",
    "city": "RIO",
    "state": "Texas",
    "zip": "78840",
    "lat": 29.3619354,
    "lng": -100.9107982
  },
  {
    "Store Location": "Tractor Supply 804 STATE HWY 16 ZAPATA, Texas 78076",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-765-9393",
    "address": "804 STATE HWY 16, ZAPATA, Texas 78076",
    "city": "ZAPATA",
    "state": "Texas",
    "zip": "78076",
    "lat": 26.9157553,
    "lng": -99.2569926
  },
  {
    "Store Location": "Tractor Supply 805 STATE HWY 21 EAST CALDWELL, Texas 77836",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-567-0918",
    "address": "805 STATE HWY 21 EAST, CALDWELL, Texas 77836",
    "city": "CALDWELL",
    "state": "Texas",
    "zip": "77836",
    "lat": 30.54152969999999,
    "lng": -96.69011569999999
  },
  {
    "Store Location": "Tractor Supply 8055 EASTEX FWY BEAUMONT, Texas 77708",
    "Store Type": "Tractor Supply",
    "Phone Number": "409-892-1949",
    "address": "8055 EASTEX FWY, BEAUMONT, Texas 77708",
    "city": "BEAUMONT",
    "state": "Texas",
    "zip": "77708",
    "lat": 30.146944,
    "lng": -94.1802815
  },
  {
    "Store Location": "Tractor Supply 840 LOOP 337 NEW BRAUNFELS, Texas 78130",
    "Store Type": "Tractor Supply",
    "Phone Number": "830-626-3026",
    "address": "840 LOOP 337 NEW, BRAUNFELS, Texas 78130",
    "city": "BRAUNFELS",
    "state": "Texas",
    "zip": "78130",
    "lat": 29.7165825,
    "lng": -98.1019925
  },
  {
    "Store Location": "Tractor Supply 8511 CANYON DR AMARILLO, Texas 79110",
    "Store Type": "Tractor Supply",
    "Phone Number": "806-355-7959",
    "address": "8511 CANYON DR, AMARILLO, Texas 79110",
    "city": "AMARILLO",
    "state": "Texas",
    "zip": "79110",
    "lat": 35.1202331,
    "lng": -101.9060228
  },
  {
    "Store Location": "Tractor Supply 876 FM 3168 RAYMONDVILLE, Texas 78580",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-398-0033",
    "address": "876 FM 3168, RAYMONDVILLE, Texas 78580",
    "city": "RAYMONDVILLE",
    "state": "Texas",
    "zip": "78580",
    "lat": 26.4662681,
    "lng": -97.7742099
  },
  {
    "Store Location": "Tractor Supply 890 NORTH US HWY 67 MIDLOTHIAN, Texas 76065",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-775-5700",
    "address": "890 NORTH US HWY 67, MIDLOTHIAN, Texas 76065",
    "city": "MIDLOTHIAN",
    "state": "Texas",
    "zip": "76065",
    "lat": 32.489226,
    "lng": -97.00412349999999
  },
  {
    "Store Location": "Tractor Supply 900 WESTGATE WAY WYLIE, Texas 75098",
    "Store Type": "Tractor Supply",
    "Phone Number": "972-429-3777",
    "address": "900 WESTGATE WAY, WYLIE, Texas 75098",
    "city": "WYLIE",
    "state": "Texas",
    "zip": "75098",
    "lat": 33.0059897,
    "lng": -96.5559083
  },
  {
    "Store Location": "Tractor Supply 901 FM 509 SAN BENITO, Texas 78586",
    "Store Type": "Tractor Supply",
    "Phone Number": "956-276-0328",
    "address": "901 FM 509 SAN, BENITO, Texas 78586",
    "city": "BENITO",
    "state": "Texas",
    "zip": "78586",
    "lat": 26.1466527,
    "lng": -97.6693083
  },
  {
    "Store Location": "Tractor Supply 907 NORTH CENTER ST NEW BOSTON, Texas 75570",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-628-0052",
    "address": "907 NORTH CENTER ST NEW, BOSTON, Texas 75570",
    "city": "BOSTON",
    "state": "Texas",
    "zip": "75570",
    "lat": 33.4732228,
    "lng": -94.41437820000002
  },
  {
    "Store Location": "Tractor Supply 9249 BENBROOK BLVD BENBROOK, Texas 76126",
    "Store Type": "Tractor Supply",
    "Phone Number": "817-249-5505",
    "address": "9249 BENBROOK BLVD, BENBROOK, Texas 76126",
    "city": "BENBROOK",
    "state": "Texas",
    "zip": "76126",
    "lat": 32.6713712,
    "lng": -97.46983259999999
  },
  {
    "Store Location": "Tractor Supply 925 NORTH MARKET ST HEARNE, Texas 77859",
    "Store Type": "Tractor Supply",
    "Phone Number": "979-279-9777",
    "address": "925 NORTH MARKET ST, HEARNE, Texas 77859",
    "city": "HEARNE",
    "state": "Texas",
    "zip": "77859",
    "lat": 30.8907141,
    "lng": -96.6009933
  },
  {
    "Store Location": "Tractor Supply 9304 NORTH NAVARRO ST VICTORIA, Texas 77904",
    "Store Type": "Tractor Supply",
    "Phone Number": "361-576-3273",
    "address": "9304 NORTH NAVARRO ST, VICTORIA, Texas 77904",
    "city": "VICTORIA",
    "state": "Texas",
    "zip": "77904",
    "lat": 28.8817272,
    "lng": -96.99491809999999
  },
  {
    "Store Location": "Tractor Supply 9320 HWY 6 NAVASOTA, Texas 77868",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-825-7758",
    "address": "9320 HWY 6, NAVASOTA, Texas 77868",
    "city": "NAVASOTA",
    "state": "Texas",
    "zip": "77868",
    "lat": 30.3900751,
    "lng": -96.0708152
  },
  {
    "Store Location": "Tractor Supply 935 HWY 80 EAST SAN MARCOS, Texas 78666",
    "Store Type": "Tractor Supply",
    "Phone Number": "512-754-6222",
    "address": "935 HWY 80 EAST SAN, MARCOS, Texas 78666",
    "city": "MARCOS",
    "state": "Texas",
    "zip": "78666",
    "lat": 29.8835229,
    "lng": -97.916816
  },
  {
    "Store Location": "Tractor Supply 9541 ALAMEDA AVE EL PASO, Texas 79927",
    "Store Type": "Tractor Supply",
    "Phone Number": "915-858-0856",
    "address": "9541 ALAMEDA AVE EL, PASO, Texas 79927",
    "city": "PASO",
    "state": "Texas",
    "zip": "79927",
    "lat": 31.6787909,
    "lng": -106.3098264
  },
  {
    "Store Location": "Tractor Supply 960 VETERANS MEMORIAL PKWY HUNTSVILLE, Texas 77320",
    "Store Type": "Tractor Supply",
    "Phone Number": "936-291-8000",
    "address": "960 VETERANS MEMORIAL PKWY, HUNTSVILLE, Texas 77320",
    "city": "HUNTSVILLE",
    "state": "Texas",
    "zip": "77320",
    "lat": 30.7224909,
    "lng": -95.5765392
  },
  {
    "Store Location": "Tractor Supply 968 US HWY 271 SOUTH GILMER, Texas 75644",
    "Store Type": "Tractor Supply",
    "Phone Number": "903-843-4444",
    "address": "968 US HWY 271 SOUTH, GILMER, Texas 75644",
    "city": "GILMER",
    "state": "Texas",
    "zip": "75644",
    "lat": 32.7172888,
    "lng": -94.94384649999999
  },
  {
    "Store Location": "Tractor Supply 1277 EAST MAIN ST PRICE, Utah 84501",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-637-1790",
    "address": "1277 EAST MAIN ST, PRICE, Utah 84501",
    "city": "PRICE",
    "state": "Utah",
    "zip": "84501",
    "lat": 39.5987663,
    "lng": -110.791335
  },
  {
    "Store Location": "Tractor Supply 1303 NORTH EXCHANGE DR SARATOGA SPRINGS, Utah 84045",
    "Store Type": "Tractor Supply",
    "Phone Number": "801-766-5556",
    "address": "1303 NORTH EXCHANGE DR SARATOGA, SPRINGS, Utah 84045",
    "city": "SPRINGS",
    "state": "Utah",
    "zip": "84045",
    "lat": 40.3799281,
    "lng": -111.9193728
  },
  {
    "Store Location": "Tractor Supply 1533 SOUTH 1800 WEST WOODS CROSS, Utah 84087",
    "Store Type": "Tractor Supply",
    "Phone Number": "801-298-1012",
    "address": "1533 SOUTH 1800 WEST WOODS, CROSS, Utah 84087",
    "city": "CROSS",
    "state": "Utah",
    "zip": "84087",
    "lat": 40.8736215,
    "lng": -111.9287347
  },
  {
    "Store Location": "Tractor Supply 1620 WEST STATE ST HURRICANE, Utah 84737",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-635-4077",
    "address": "1620 WEST STATE ST, HURRICANE, Utah 84737",
    "city": "HURRICANE",
    "state": "Utah",
    "zip": "84737",
    "lat": 37.1770886,
    "lng": -113.3186209
  },
  {
    "Store Location": "Tractor Supply 1635 WEST 1100 SOUTH PERRY, Utah 84302",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-723-7855",
    "address": "1635 WEST 1100 SOUTH, PERRY, Utah 84302",
    "city": "PERRY",
    "state": "Utah",
    "zip": "84302",
    "lat": 41.4844107,
    "lng": -112.0569167
  },
  {
    "Store Location": "Tractor Supply 1821 EAST HWY 40 BALLARD, Utah 84066",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-722-3036",
    "address": "1821 EAST HWY 40, BALLARD, Utah 84066",
    "city": "BALLARD",
    "state": "Utah",
    "zip": "84066",
    "lat": 40.3034699,
    "lng": -109.9669091
  },
  {
    "Store Location": "Tractor Supply 1985 WEST 2550 SOUTH WEST HAVEN, Utah 84401",
    "Store Type": "Tractor Supply",
    "Phone Number": "801-731-8183",
    "address": "1985 WEST 2550 SOUTH WEST, HAVEN, Utah 84401",
    "city": "HAVEN",
    "state": "Utah",
    "zip": "84401",
    "lat": 41.2188132,
    "lng": -112.0275657
  },
  {
    "Store Location": "Tractor Supply 281 NORTH STATE ST MORGAN, Utah 84050",
    "Store Type": "Tractor Supply",
    "Phone Number": "801-829-4401",
    "address": "281 NORTH STATE ST, MORGAN, Utah 84050",
    "city": "MORGAN",
    "state": "Utah",
    "zip": "84050",
    "lat": 41.0414377,
    "lng": -111.6808882
  },
  {
    "Store Location": "Tractor Supply 326 NORTH STATE RD 198 SALEM, Utah 84653",
    "Store Type": "Tractor Supply",
    "Phone Number": "801-423-7978",
    "address": "326 NORTH STATE RD 198, SALEM, Utah 84653",
    "city": "SALEM",
    "state": "Utah",
    "zip": "84653",
    "lat": 40.0596232,
    "lng": -111.6682151
  },
  {
    "Store Location": "Tractor Supply 356 EAST 1200 SOUTH HEBER CITY, Utah 84032",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-657-9785",
    "address": "356 EAST 1200 SOUTH HEBER, CITY, Utah 84032",
    "city": "CITY",
    "state": "Utah",
    "zip": "84032",
    "lat": 40.4924289,
    "lng": -111.4069931
  },
  {
    "Store Location": "Tractor Supply 6880 NORTH BEAMAN WAY STANSBURY PARK, Utah 84074",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-843-4306",
    "address": "6880 NORTH BEAMAN WAY STANSBURY, PARK, Utah 84074",
    "city": "PARK",
    "state": "Utah",
    "zip": "84074",
    "lat": 40.6540512,
    "lng": -112.2903057
  },
  {
    "Store Location": "Tractor Supply 70 WEST 1300 SOUTH RICHFIELD, Utah 84701",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-896-2899",
    "address": "70 WEST 1300 SOUTH, RICHFIELD, Utah 84701",
    "city": "RICHFIELD",
    "state": "Utah",
    "zip": "84701",
    "lat": 38.7502596,
    "lng": -112.0850833
  },
  {
    "Store Location": "Tractor Supply 78 SOUTH HWY 165 PROVIDENCE, Utah 84332",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-752-0072",
    "address": "78 SOUTH HWY 165, PROVIDENCE, Utah 84332",
    "city": "PROVIDENCE",
    "state": "Utah",
    "zip": "84332",
    "lat": 41.666805,
    "lng": -111.8334387
  },
  {
    "Store Location": "Tractor Supply 828 NORTH MAIN ST EPHRAIM, Utah 84627",
    "Store Type": "Tractor Supply",
    "Phone Number": "435-283-3550",
    "address": "828 NORTH MAIN ST, EPHRAIM, Utah 84627",
    "city": "EPHRAIM",
    "state": "Utah",
    "zip": "84627",
    "lat": 39.3750903,
    "lng": -111.5854482
  },
  {
    "Store Location": "Tractor Supply 1043 EAST STUART DR GALAX, Virginia 24333",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-236-2521",
    "address": "1043 EAST STUART DR, GALAX, Virginia 24333",
    "city": "GALAX",
    "state": "Virginia",
    "zip": "24333",
    "lat": 36.683707,
    "lng": -80.88800160000001
  },
  {
    "Store Location": "Tractor Supply 105 MALL RD COVINGTON, Virginia 24426",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-965-6546",
    "address": "105 MALL RD, COVINGTON, Virginia 24426",
    "city": "COVINGTON",
    "state": "Virginia",
    "zip": "24426",
    "lat": 37.7724508,
    "lng": -79.9686663
  },
  {
    "Store Location": "Tractor Supply 1050 EAST MAIN ST PULASKI, Virginia 24301",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-980-1173",
    "address": "1050 EAST MAIN ST, PULASKI, Virginia 24301",
    "city": "PULASKI",
    "state": "Virginia",
    "zip": "24301",
    "lat": 37.0473326,
    "lng": -80.7589722
  },
  {
    "Store Location": "Tractor Supply 10870 BALLS FORD RD MANASSAS, Virginia 20109",
    "Store Type": "Tractor Supply",
    "Phone Number": "703-257-7247",
    "address": "10870 BALLS FORD RD, MANASSAS, Virginia 20109",
    "city": "MANASSAS",
    "state": "Virginia",
    "zip": "20109",
    "lat": 38.79879,
    "lng": -77.52519459999999
  },
  {
    "Store Location": "Tractor Supply 1106 LOVERS GAP RD VANSANT, Virginia 24656",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-935-2324",
    "address": "1106 LOVERS GAP RD, VANSANT, Virginia 24656",
    "city": "VANSANT",
    "state": "Virginia",
    "zip": "24656",
    "lat": 37.2307222,
    "lng": -82.1003692
  },
  {
    "Store Location": "Tractor Supply 1128 EAST LYNCHBURG SALEM TPKE BEDFORD, Virginia 24523",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-587-6600",
    "address": "1128 EAST LYNCHBURG SALEM TPKE, BEDFORD, Virginia 24523",
    "city": "BEDFORD",
    "state": "Virginia",
    "zip": "24523",
    "lat": 37.324923,
    "lng": -79.4961972
  },
  {
    "Store Location": "Tractor Supply 11481 KINGS HWY KING GEORGE, Virginia 22485",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-775-5554",
    "address": "11481 KINGS HWY KING, GEORGE, Virginia 22485",
    "city": "GEORGE",
    "state": "Virginia",
    "zip": "22485",
    "lat": 38.2388982,
    "lng": -77.1476828
  },
  {
    "Store Location": "Tractor Supply 119 NORGE LN WILLIAMSBURG, Virginia 23188",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-565-2786",
    "address": "119 NORGE LN, WILLIAMSBURG, Virginia 23188",
    "city": "WILLIAMSBURG",
    "state": "Virginia",
    "zip": "23188",
    "lat": 37.3734109,
    "lng": -76.7739919
  },
  {
    "Store Location": "Tractor Supply 119 PINEY FOREST RD DANVILLE, Virginia 24540",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-791-3911",
    "address": "119 PINEY FOREST RD, DANVILLE, Virginia 24540",
    "city": "DANVILLE",
    "state": "Virginia",
    "zip": "24540",
    "lat": 36.5948169,
    "lng": -79.4152647
  },
  {
    "Store Location": "Tractor Supply 12285 KING WILLIAM ROAD KING WILLIAM, Virginia 23086",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-769-1111",
    "address": "12285 KING WILLIAM ROAD KING, WILLIAM, Virginia 23086",
    "city": "WILLIAM",
    "state": "Virginia",
    "zip": "23086",
    "lat": 37.744056,
    "lng": -77.1295258
  },
  {
    "Store Location": "Tractor Supply 1275 EAST ATLANTIC ST LA CROSSE, Virginia 23950",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-757-1050",
    "address": "1275 EAST ATLANTIC ST LA, CROSSE, Virginia 23950",
    "city": "CROSSE",
    "state": "Virginia",
    "zip": "23950",
    "lat": 36.7066805,
    "lng": -78.1037182
  },
  {
    "Store Location": "Tractor Supply 12966 GOVERNOR GC PERRY HWY POUNDING MILL, Virginia 24637",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-596-9307",
    "address": "12966 GOVERNOR GC PERRY HWY POUNDING, MILL, Virginia 24637",
    "city": "MILL",
    "state": "Virginia",
    "zip": "24637",
    "lat": 37.0753922,
    "lng": -81.70872469999999
  },
  {
    "Store Location": "Tractor Supply 1301 MAIN ST STE O ALTA VISTA, Virginia 24517",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-369-1209",
    "address": "1301 MAIN ST STE O ALTA, VISTA, Virginia 24517",
    "city": "VISTA",
    "state": "Virginia",
    "zip": "24517",
    "lat": 37.1118094,
    "lng": -79.285579
  },
  {
    "Store Location": "Tractor Supply 13118 BOYDTON PLANK RD DINWIDDIE, Virginia 23841",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-469-3354",
    "address": "13118 BOYDTON PLANK RD, DINWIDDIE, Virginia 23841",
    "city": "DINWIDDIE",
    "state": "Virginia",
    "zip": "23841",
    "lat": 37.0919961,
    "lng": -77.5740441
  },
  {
    "Store Location": "Tractor Supply 13226 JAMES MADISON HWY ORANGE, Virginia 22960",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-661-3525",
    "address": "13226 JAMES MADISON HWY, ORANGE, Virginia 22960",
    "city": "ORANGE",
    "state": "Virginia",
    "zip": "22960",
    "lat": 38.2254964,
    "lng": -78.1237483
  },
  {
    "Store Location": "Tractor Supply 13500 BENNS CHURCH BLVD SMITHFIELD, Virginia 23430",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-365-0235",
    "address": "13500 BENNS CHURCH BLVD, SMITHFIELD, Virginia 23430",
    "city": "SMITHFIELD",
    "state": "Virginia",
    "zip": "23430",
    "lat": 36.9521682,
    "lng": -76.6007746
  },
  {
    "Store Location": "Tractor Supply 1363 WEST MAIN STREET SALEM, Virginia 24153",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-375-2772",
    "address": "1363 WEST MAIN STREET, SALEM, Virginia 24153",
    "city": "SALEM",
    "state": "Virginia",
    "zip": "24153",
    "lat": 37.29121000000001,
    "lng": -80.07974999999999
  },
  {
    "Store Location": "Tractor Supply 1380 EAST MAIN ST STE 400 WYTHEVILLE, Virginia 24382",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-227-0559",
    "address": "1380 EAST MAIN ST STE 400, WYTHEVILLE, Virginia 24382",
    "city": "WYTHEVILLE",
    "state": "Virginia",
    "zip": "24382",
    "lat": 36.9521818,
    "lng": -81.0667337
  },
  {
    "Store Location": "Tractor Supply 1462 US HWY 211 WEST LURAY, Virginia 22835",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-843-2023",
    "address": "1462 US HWY 211 WEST, LURAY, Virginia 22835",
    "city": "LURAY",
    "state": "Virginia",
    "zip": "22835",
    "lat": 38.665397,
    "lng": -78.4594522
  },
  {
    "Store Location": "Tractor Supply 1465 ARMORY DR FRANKLIN, Virginia 23851",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-562-4242",
    "address": "1465 ARMORY DR, FRANKLIN, Virginia 23851",
    "city": "FRANKLIN",
    "state": "Virginia",
    "zip": "23851",
    "lat": 36.6656124,
    "lng": -76.9524864
  },
  {
    "Store Location": "Tractor Supply 150 GETTY LN WINCHESTER, Virginia 22603",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-535-0058",
    "address": "150 GETTY LN, WINCHESTER, Virginia 22603",
    "city": "WINCHESTER",
    "state": "Virginia",
    "zip": "22603",
    "lat": 39.1875381,
    "lng": -78.1298961
  },
  {
    "Store Location": "Tractor Supply 1507 SOUTH MAIN STREET FARMVILLE, Virginia 23901",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-392-1594",
    "address": "1507 SOUTH MAIN STREET, FARMVILLE, Virginia 23901",
    "city": "FARMVILLE",
    "state": "Virginia",
    "zip": "23901",
    "lat": 37.2831835,
    "lng": -78.39782029999999
  },
  {
    "Store Location": "Tractor Supply 1542 ROANOKE ST CHRISTIANSBURG, Virginia 24073",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-381-7630",
    "address": "1542 ROANOKE ST, CHRISTIANSBURG, Virginia 24073",
    "city": "CHRISTIANSBURG",
    "state": "Virginia",
    "zip": "24073",
    "lat": 37.1350108,
    "lng": -80.3786385
  },
  {
    "Store Location": "Tractor Supply 1591 NORTH MAIN ST MARION, Virginia 24354",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-781-0880",
    "address": "1591 NORTH MAIN ST, MARION, Virginia 24354",
    "city": "MARION",
    "state": "Virginia",
    "zip": "24354",
    "lat": 36.8475447,
    "lng": -81.49362769999999
  },
  {
    "Store Location": "Tractor Supply 181 PLAZA RD SOUTHWEST WISE, Virginia 24293",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-679-6801",
    "address": "181 PLAZA RD SOUTHWEST, WISE, Virginia 24293",
    "city": "WISE",
    "state": "Virginia",
    "zip": "24293",
    "lat": 36.97115050000001,
    "lng": -82.5966722
  },
  {
    "Store Location": "Tractor Supply 2000 FISHER ARCH VIRGINIA BEACH, Virginia 23456",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-426-8000",
    "address": "2000 FISHER ARCH VIRGINIA, BEACH, Virginia 23456",
    "city": "BEACH",
    "state": "Virginia",
    "zip": "23456",
    "lat": 36.749485,
    "lng": -76.0097396
  },
  {
    "Store Location": "Tractor Supply 201 JUNCTION DR ASHLAND, Virginia 23005",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-798-0500",
    "address": "201 JUNCTION DR, ASHLAND, Virginia 23005",
    "city": "ASHLAND",
    "state": "Virginia",
    "zip": "23005",
    "lat": 37.7554281,
    "lng": -77.4660074
  },
  {
    "Store Location": "Tractor Supply 20442 JEB STUART HWY STUART, Virginia 24171",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-694-3797",
    "address": "20442 JEB STUART HWY, STUART, Virginia 24171",
    "city": "STUART",
    "state": "Virginia",
    "zip": "24171",
    "lat": 36.6402816,
    "lng": -80.2268462
  },
  {
    "Store Location": "Tractor Supply 21486 MARKET CENTER BRISTOL, Virginia 24202",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-466-0212",
    "address": "21486 MARKET CENTER, BRISTOL, Virginia 24202",
    "city": "BRISTOL",
    "state": "Virginia",
    "zip": "24202",
    "lat": 36.6343839,
    "lng": -82.12804450000002
  },
  {
    "Store Location": "Tractor Supply 2300 COMMERCE CENTER DR ROCKVILLE, Virginia 23146",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-749-4444",
    "address": "2300 COMMERCE CENTER DR, ROCKVILLE, Virginia 23146",
    "city": "ROCKVILLE",
    "state": "Virginia",
    "zip": "23146",
    "lat": 37.6965611,
    "lng": -77.6622194
  },
  {
    "Store Location": "Tractor Supply 2385 EAST MARKET ST HARRISONBURG, Virginia 22801",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-434-1492",
    "address": "2385 EAST MARKET ST, HARRISONBURG, Virginia 22801",
    "city": "HARRISONBURG",
    "state": "Virginia",
    "zip": "22801",
    "lat": 38.42030210000001,
    "lng": -78.838959
  },
  {
    "Store Location": "Tractor Supply 2470 ANDERSON HWY STE G POWHATAN, Virginia 23139",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-598-7765",
    "address": "2470 ANDERSON HWY STE G, POWHATAN, Virginia 23139",
    "city": "POWHATAN",
    "state": "Virginia",
    "zip": "23139",
    "lat": 37.5221988,
    "lng": -77.8175188
  },
  {
    "Store Location": "Tractor Supply 248 AMELON SQUARE PLZ MADISON HEIGHTS, Virginia 24572",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-929-6730",
    "address": "248 AMELON SQUARE PLZ MADISON, HEIGHTS, Virginia 24572",
    "city": "HEIGHTS",
    "state": "Virginia",
    "zip": "24572",
    "lat": 37.4690799,
    "lng": -79.11714529999999
  },
  {
    "Store Location": "Tractor Supply 25044 LANKFORD HWY ONLEY, Virginia 23418",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-787-7755",
    "address": "25044 LANKFORD HWY, ONLEY, Virginia 23418",
    "city": "ONLEY",
    "state": "Virginia",
    "zip": "23418",
    "lat": 37.7020531,
    "lng": -75.71366979999999
  },
  {
    "Store Location": "Tractor Supply 29 PAYNE LN STAUNTON, Virginia 24401",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-887-2569",
    "address": "29 PAYNE LN, STAUNTON, Virginia 24401",
    "city": "STAUNTON",
    "state": "Virginia",
    "zip": "24401",
    "lat": 38.1247209,
    "lng": -79.06676499999999
  },
  {
    "Store Location": "Tractor Supply 3000 PRUDEN BLVD SUFFOLK, Virginia 23434",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-539-5192",
    "address": "3000 PRUDEN BLVD, SUFFOLK, Virginia 23434",
    "city": "SUFFOLK",
    "state": "Virginia",
    "zip": "23434",
    "lat": 36.7724172,
    "lng": -76.60975719999999
  },
  {
    "Store Location": "Tractor Supply 3130 HALIFAX RD SUITE N SOUTH BOSTON, Virginia 24592",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-575-8321",
    "address": "3130 HALIFAX RD SUITE N SOUTH, BOSTON, Virginia 24592",
    "city": "BOSTON",
    "state": "Virginia",
    "zip": "24592",
    "lat": 36.7318349,
    "lng": -78.92051459999999
  },
  {
    "Store Location": "Tractor Supply 322 NORTH MAIN ST PEARISBURG, Virginia 24134",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-921-1900",
    "address": "322 NORTH MAIN ST, PEARISBURG, Virginia 24134",
    "city": "PEARISBURG",
    "state": "Virginia",
    "zip": "24134",
    "lat": 37.3318289,
    "lng": -80.7367725
  },
  {
    "Store Location": "Tractor Supply 41 WEST LEE HWY STE 65 WARRENTON, Virginia 20186",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-347-3134",
    "address": "41 WEST LEE HWY STE 65, WARRENTON, Virginia 20186",
    "city": "WARRENTON",
    "state": "Virginia",
    "zip": "20186",
    "lat": 38.7284861,
    "lng": -77.792977
  },
  {
    "Store Location": "Tractor Supply 4179 PLANK ROAD FREDERICKSBURG, Virginia 22407",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-785-5775",
    "address": "4179 PLANK ROAD, FREDERICKSBURG, Virginia 22407",
    "city": "FREDERICKSBURG",
    "state": "Virginia",
    "zip": "22407",
    "lat": 38.2909652,
    "lng": -77.53533999999999
  },
  {
    "Store Location": "Tractor Supply 42 CARMEN PL RUCKERSVILLE, Virginia 22968",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-985-2162",
    "address": "42 CARMEN PL, RUCKERSVILLE, Virginia 22968",
    "city": "RUCKERSVILLE",
    "state": "Virginia",
    "zip": "22968",
    "lat": 38.2335465,
    "lng": -78.3843551
  },
  {
    "Store Location": "Tractor Supply 4203 OLD STOCKYARD RD MARSHALL, Virginia 20115",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-364-1583",
    "address": "4203 OLD STOCKYARD RD, MARSHALL, Virginia 20115",
    "city": "MARSHALL",
    "state": "Virginia",
    "zip": "20115",
    "lat": 38.8647324,
    "lng": -77.8484345
  },
  {
    "Store Location": "Tractor Supply 4238 RICHMOND RD WARSAW, Virginia 22572",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-313-2090",
    "address": "4238 RICHMOND RD, WARSAW, Virginia 22572",
    "city": "WARSAW",
    "state": "Virginia",
    "zip": "22572",
    "lat": 37.9632685,
    "lng": -76.7858002
  },
  {
    "Store Location": "Tractor Supply 433 CENTERVILLE TPKE SOUTH CHESAPEAKE, Virginia 23322",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-482-0100",
    "address": "433 CENTERVILLE TPKE SOUTH, CHESAPEAKE, Virginia 23322",
    "city": "CHESAPEAKE",
    "state": "Virginia",
    "zip": "23322",
    "lat": 36.7118024,
    "lng": -76.18432059999999
  },
  {
    "Store Location": "Tractor Supply 4920 GREENSBORO RD RIDGEWAY, Virginia 24148",
    "Store Type": "Tractor Supply",
    "Phone Number": "276-956-5610",
    "address": "4920 GREENSBORO RD, RIDGEWAY, Virginia 24148",
    "city": "RIDGEWAY",
    "state": "Virginia",
    "zip": "24148",
    "lat": 36.6266965,
    "lng": -79.8614721
  },
  {
    "Store Location": "Tractor Supply 541 WEST RESERVIOR RD WOODSTOCK, Virginia 22664",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-459-7127",
    "address": "541 WEST RESERVIOR RD, WOODSTOCK, Virginia 22664",
    "city": "WOODSTOCK",
    "state": "Virginia",
    "zip": "22664",
    "lat": 38.8718383,
    "lng": -78.53251379999999
  },
  {
    "Store Location": "Tractor Supply 58 VIRGINIA MARKET PLACE DR ROCKY MOUNT, Virginia 24151",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-334-1109",
    "address": "58 VIRGINIA MARKET PLACE DR ROCKY, MOUNT, Virginia 24151",
    "city": "MOUNT",
    "state": "Virginia",
    "zip": "24151",
    "lat": 37.0711072,
    "lng": -79.8987954
  },
  {
    "Store Location": "Tractor Supply 588 CULPEPER TOWN SQ CULPEPER, Virginia 22701",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-829-2532",
    "address": "588 CULPEPER TOWN SQ, CULPEPER, Virginia 22701",
    "city": "CULPEPER",
    "state": "Virginia",
    "zip": "22701",
    "lat": 38.479984,
    "lng": -77.9901052
  },
  {
    "Store Location": "Tractor Supply 6499 MARKET DR GLOUCESTER, Virginia 23061",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-695-2712",
    "address": "6499 MARKET DR, GLOUCESTER, Virginia 23061",
    "city": "GLOUCESTER",
    "state": "Virginia",
    "zip": "23061",
    "lat": 37.3909973,
    "lng": -76.52705569999999
  },
  {
    "Store Location": "Tractor Supply 6801 LAKE HARBOUR DR MIDLOTHIAN, Virginia 23112",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-639-0027",
    "address": "6801 LAKE HARBOUR DR, MIDLOTHIAN, Virginia 23112",
    "city": "MIDLOTHIAN",
    "state": "Virginia",
    "zip": "23112",
    "lat": 37.4061824,
    "lng": -77.67253699999999
  },
  {
    "Store Location": "Tractor Supply 7047 MECHANICSVILLE TPKE MECHANICSVILLE, Virginia 23111",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-559-3380",
    "address": "7047 MECHANICSVILLE TPKE, MECHANICSVILLE, Virginia 23111",
    "city": "MECHANICSVILLE",
    "state": "Virginia",
    "zip": "23111",
    "lat": 37.6106475,
    "lng": -77.3377369
  },
  {
    "Store Location": "Tractor Supply 7295 MARKET PLACE DRIVE QUINTON, Virginia 23141",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-932-3399",
    "address": "7295 MARKET PLACE DRIVE, QUINTON, Virginia 23141",
    "city": "QUINTON",
    "state": "Virginia",
    "zip": "23141",
    "lat": 37.5074741,
    "lng": -77.1854797
  },
  {
    "Store Location": "Tractor Supply 7437 GEORGE WASHINGTON MEM HWY YORKTOWN, Virginia 23692",
    "Store Type": "Tractor Supply",
    "Phone Number": "757-877-6666",
    "address": "7437 GEORGE WASHINGTON MEM HWY, YORKTOWN, Virginia 23692",
    "city": "YORKTOWN",
    "state": "Virginia",
    "zip": "23692",
    "lat": 37.248113,
    "lng": -76.5026803
  },
  {
    "Store Location": "Tractor Supply 7645 RICHMOND HWY APPOMATTOX, Virginia 24522",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-352-5206",
    "address": "7645 RICHMOND HWY, APPOMATTOX, Virginia 24522",
    "city": "APPOMATTOX",
    "state": "Virginia",
    "zip": "24522",
    "lat": 37.3655404,
    "lng": -78.8472003
  },
  {
    "Store Location": "Tractor Supply 800 NORTH LEE HWY LEXINGTON, Virginia 24450",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-464-6666",
    "address": "800 NORTH LEE HWY, LEXINGTON, Virginia 24450",
    "city": "LEXINGTON",
    "state": "Virginia",
    "zip": "24450",
    "lat": 37.7969859,
    "lng": -79.4208855
  },
  {
    "Store Location": "Tractor Supply 8110 GANDER WAY ROANOKE, Virginia 24019",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-265-8467",
    "address": "8110 GANDER WAY, ROANOKE, Virginia 24019",
    "city": "ROANOKE",
    "state": "Virginia",
    "zip": "24019",
    "lat": 37.35643,
    "lng": -79.95967019999999
  },
  {
    "Store Location": "Tractor Supply 8175 WAGNER WAY PRINCE GEORGE, Virginia 23875",
    "Store Type": "Tractor Supply",
    "Phone Number": "804-732-0011",
    "address": "8175 WAGNER WAY PRINCE, GEORGE, Virginia 23875",
    "city": "GEORGE",
    "state": "Virginia",
    "zip": "23875",
    "lat": 37.2011808,
    "lng": -77.3312637
  },
  {
    "Store Location": "Tractor Supply 8986 COURTHOUSE RD LOUISA, Virginia 23093",
    "Store Type": "Tractor Supply",
    "Phone Number": "540-967-2365",
    "address": "8986 COURTHOUSE RD, LOUISA, Virginia 23093",
    "city": "LOUISA",
    "state": "Virginia",
    "zip": "23093",
    "lat": 38.0194575,
    "lng": -78.0021983
  },
  {
    "Store Location": "Tractor Supply 921 RIVER RD CHARLOTTESVILLE, Virginia 22901",
    "Store Type": "Tractor Supply",
    "Phone Number": "434-984-2190",
    "address": "921 RIVER RD, CHARLOTTESVILLE, Virginia 22901",
    "city": "CHARLOTTESVILLE",
    "state": "Virginia",
    "zip": "22901",
    "lat": 38.036459,
    "lng": -78.45965319999999
  },
  {
    "Store Location": "Tractor Supply 935 EDWARDS FERRY RD NORTHEAST LEESBURG, Virginia 20176",
    "Store Type": "Tractor Supply",
    "Phone Number": "703-443-2611",
    "address": "935 EDWARDS FERRY RD NORTHEAST, LEESBURG, Virginia 20176",
    "city": "LEESBURG",
    "state": "Virginia",
    "zip": "20176",
    "lat": 39.1120372,
    "lng": -77.53907939999999
  },
  {
    "Store Location": "Tractor Supply 1177 US RTE 7 SOUTH NORTH CLARENDON, Vermont 5759",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-747-4759",
    "address": "1177 US RTE 7 SOUTH NORTH CLARENDON, Vermont 5759,  ",
    "city": "Vermont 5759",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.5655235,
    "lng": -72.9661208
  },
  {
    "Store Location": "Tractor Supply 124 COMMERCE WAY NEWPORT, Vermont 5855",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-334-2944",
    "address": "124 COMMERCE WAY NEWPORT, Vermont 5855,  ",
    "city": "Vermont 5855",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.9538265,
    "lng": -72.1556509
  },
  {
    "Store Location": "Tractor Supply 2636 HIGHGATE RD SAINT ALBANS, Vermont 5478",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-524-0705",
    "address": "2636 HIGHGATE RD SAINT ALBANS, Vermont 5478,  ",
    "city": "Vermont 5478",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.8462675,
    "lng": -73.0787888
  },
  {
    "Store Location": "Tractor Supply 300 DEPOT ST BENNINGTON, Vermont 5201",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-440-9937",
    "address": "300 DEPOT ST BENNINGTON, Vermont 5201,  ",
    "city": "Vermont 5201",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.8848719,
    "lng": -73.19917219999999
  },
  {
    "Store Location": "Tractor Supply 352 RIVER ST MONTPELIER, Vermont 5602",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-223-2246",
    "address": "352 RIVER ST MONTPELIER, Vermont 5602,  ",
    "city": "Vermont 5602",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.2401239,
    "lng": -72.55177119999999
  },
  {
    "Store Location": "Tractor Supply 3708 SHELBURNE RD SHELBURNE, Vermont 5482",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-985-4092",
    "address": "3708 SHELBURNE RD SHELBURNE, Vermont 5482,  ",
    "city": "Vermont 5482",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.402652,
    "lng": -73.2187047
  },
  {
    "Store Location": "Tractor Supply 476 FOOTE ST MIDDLEBURY, Vermont 5753",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-382-9292",
    "address": "476 FOOTE ST MIDDLEBURY, Vermont 5753,  ",
    "city": "Vermont 5753",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.9913633,
    "lng": -73.1354968
  },
  {
    "Store Location": "Tractor Supply 88 CENTER RD MORRISVILLE, Vermont 5661",
    "Store Type": "Tractor Supply",
    "Phone Number": "802-888-2010",
    "address": "88 CENTER RD MORRISVILLE, Vermont 5661,  ",
    "city": "Vermont 5661",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.5811907,
    "lng": -72.5852325
  },
  {
    "Store Location": "Tractor Supply 1050 NORTHWEST MARYLAND AVE STE B CHEHALIS, Washington 98532",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-748-4327",
    "address": "1050 NORTHWEST MARYLAND AVE STE B, CHEHALIS, Washington 98532",
    "city": "CHEHALIS",
    "state": "Washington",
    "zip": "98532",
    "lat": 46.6706497,
    "lng": -122.9780627
  },
  {
    "Store Location": "Tractor Supply 10616 BALD HILL RD SOUTHEAST YELM, Washington 98597",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-400-3800",
    "address": "10616 BALD HILL RD SOUTHEAST, YELM, Washington 98597",
    "city": "YELM",
    "state": "Washington",
    "zip": "98597",
    "lat": 46.9324238,
    "lng": -122.5878419
  },
  {
    "Store Location": "Tractor Supply 12001 N US HWY 101 SHELTON, Washington 98584",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-432-5900",
    "address": "12001 N US HWY 101, SHELTON, Washington 98584",
    "city": "SHELTON",
    "state": "Washington",
    "zip": "98584",
    "lat": 47.2455253,
    "lng": -123.1418912
  },
  {
    "Store Location": "Tractor Supply 1213 EAST WISHKAH ST ABERDEEN, Washington 98520",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-533-8888",
    "address": "1213 EAST WISHKAH ST, ABERDEEN, Washington 98520",
    "city": "ABERDEEN",
    "state": "Washington",
    "zip": "98520",
    "lat": 46.9764315,
    "lng": -123.8018542
  },
  {
    "Store Location": "Tractor Supply 13650 ROOSEVELT RD SOUTHEAST MONROE, Washington 98272",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-794-0561",
    "address": "13650 ROOSEVELT RD SOUTHEAST, MONROE, Washington 98272",
    "city": "MONROE",
    "state": "Washington",
    "zip": "98272",
    "lat": 47.8733914,
    "lng": -122.0090826
  },
  {
    "Store Location": "Tractor Supply 1415 OLNEY AVE SOUTHEAST PORT ORCHARD, Washington 98366",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-874-7486",
    "address": "1415 OLNEY AVE SOUTHEAST PORT, ORCHARD, Washington 98366",
    "city": "ORCHARD",
    "state": "Washington",
    "zip": "98366",
    "lat": 47.5351242,
    "lng": -122.6076417
  },
  {
    "Store Location": "Tractor Supply 1425 WEST ROSE STREET WALLA WALLA, Washington 99362",
    "Store Type": "Tractor Supply",
    "Phone Number": "509-529-5599",
    "address": "1425 WEST ROSE STREET WALLA, WALLA, Washington 99362",
    "city": "WALLA",
    "state": "Washington",
    "zip": "99362",
    "lat": 46.0583421,
    "lng": -118.3648029
  },
  {
    "Store Location": "Tractor Supply 15615 PACIFIC AVE SOUTH TACOMA, Washington 98444",
    "Store Type": "Tractor Supply",
    "Phone Number": "253-536-6336",
    "address": "15615 PACIFIC AVE SOUTH, TACOMA, Washington 98444",
    "city": "TACOMA",
    "state": "Washington",
    "zip": "98444",
    "lat": 47.1153257,
    "lng": -122.4332491
  },
  {
    "Store Location": "Tractor Supply 17020 SMOKEY POINT BLVD STE A ARLINGTON, Washington 98223",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-653-2123",
    "address": "17020 SMOKEY POINT BLVD STE A, ARLINGTON, Washington 98223",
    "city": "ARLINGTON",
    "state": "Washington",
    "zip": "98223",
    "lat": 48.1512156,
    "lng": -122.1851972
  },
  {
    "Store Location": "Tractor Supply 1750 LABOUNTY DRIVE SUITE 103 FERNDALE, Washington 98248",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-312-0212",
    "address": "1750 LABOUNTY DRIVE SUITE 103, FERNDALE, Washington 98248",
    "city": "FERNDALE",
    "state": "Washington",
    "zip": "98248",
    "lat": 48.8455086,
    "lng": -122.5773864
  },
  {
    "Store Location": "Tractor Supply 1898 FRONT ST LYNDEN, Washington 98264",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-318-0134",
    "address": "1898 FRONT ST, LYNDEN, Washington 98264",
    "city": "LYNDEN",
    "state": "Washington",
    "zip": "98264",
    "lat": 48.9406731,
    "lng": -122.4797872
  },
  {
    "Store Location": "Tractor Supply 2222 NW BUCKLIN HILL RD UNIT 110 SILVERDALE, Washington 98383",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-692-3600",
    "address": "2222 NW BUCKLIN HILL RD UNIT 110, SILVERDALE, Washington 98383",
    "city": "SILVERDALE",
    "state": "Washington",
    "zip": "98383",
    "lat": 47.6513205,
    "lng": -122.6795804
  },
  {
    "Store Location": "Tractor Supply 2600 E YAKIMA VALLEY HWY STE 1 SUNNYSIDE, Washington 98944",
    "Store Type": "Tractor Supply",
    "Phone Number": "509-839-0000",
    "address": "2600 E YAKIMA VALLEY HWY STE 1, SUNNYSIDE, Washington 98944",
    "city": "SUNNYSIDE",
    "state": "Washington",
    "zip": "98944",
    "lat": 46.3196484,
    "lng": -119.9849495
  },
  {
    "Store Location": "Tractor Supply 2600 YAKIMA VALLEY HWY STE 1 SUNNYSIDE, Washington 98944",
    "Store Type": "Tractor Supply",
    "Phone Number": "402-873-7562",
    "address": "2600 YAKIMA VALLEY HWY STE 1, SUNNYSIDE, Washington 98944",
    "city": "SUNNYSIDE",
    "state": "Washington",
    "zip": "98944",
    "lat": 46.3196484,
    "lng": -119.9849495
  },
  {
    "Store Location": "Tractor Supply 2648 COWEEMAN PARK DR KELSO, Washington 98626",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-636-7333",
    "address": "2648 COWEEMAN PARK DR, KELSO, Washington 98626",
    "city": "KELSO",
    "state": "Washington",
    "zip": "98626",
    "lat": 46.109097,
    "lng": -122.8825873
  },
  {
    "Store Location": "Tractor Supply 310 EAST COLLEGE WAY MOUNT VERNON, Washington 98273",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-336-1021",
    "address": "310 EAST COLLEGE WAY MOUNT, VERNON, Washington 98273",
    "city": "VERNON",
    "state": "Washington",
    "zip": "98273",
    "lat": 48.4340385,
    "lng": -122.3368727
  },
  {
    "Store Location": "Tractor Supply 32165 STATE ROUTE 20 UNIT 1 OAK HARBOR, Washington 98277",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-240-1400",
    "address": "32165 STATE ROUTE 20 UNIT 1 OAK, HARBOR, Washington 98277",
    "city": "HARBOR",
    "state": "Washington",
    "zip": "98277",
    "lat": 48.2968945,
    "lng": -122.6557726
  },
  {
    "Store Location": "Tractor Supply 4141 MARTIN WAY EAST STE 105 OLYMPIA, Washington 98516",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-491-4046",
    "address": "4141 MARTIN WAY EAST STE 105, OLYMPIA, Washington 98516",
    "city": "OLYMPIA",
    "state": "Washington",
    "zip": "98516",
    "lat": 47.0474621,
    "lng": -122.8313789
  },
  {
    "Store Location": "Tractor Supply 621 RIVER RD PUYALLUP, Washington 98371",
    "Store Type": "Tractor Supply",
    "Phone Number": "253-845-0397",
    "address": "621 RIVER RD, PUYALLUP, Washington 98371",
    "city": "PUYALLUP",
    "state": "Washington",
    "zip": "98371",
    "lat": 47.2020195,
    "lng": -122.3007257
  },
  {
    "Store Location": "Tractor Supply 800 NORTH PARK CENTER SUITE A SELAH, Washington 98942",
    "Store Type": "Tractor Supply",
    "Phone Number": "509-697-2000",
    "address": "800 NORTH PARK CENTER SUITE A, SELAH, Washington 98942",
    "city": "SELAH",
    "state": "Washington",
    "zip": "98942",
    "lat": 46.6628239,
    "lng": -120.5194831
  },
  {
    "Store Location": "Tractor Supply 8420 SOUTH 228TH ST KENT, Washington 98031",
    "Store Type": "Tractor Supply",
    "Phone Number": "253-520-2333",
    "address": "8420 SOUTH 228TH ST, KENT, Washington 98031",
    "city": "KENT",
    "state": "Washington",
    "zip": "98031",
    "lat": 47.3981443,
    "lng": -122.2266934
  },
  {
    "Store Location": "Tractor Supply 911 GRIFFIN AVE ENUMCLAW, Washington 98022",
    "Store Type": "Tractor Supply",
    "Phone Number": "360-825-2002",
    "address": "911 GRIFFIN AVE, ENUMCLAW, Washington 98022",
    "city": "ENUMCLAW",
    "state": "Washington",
    "zip": "98022",
    "lat": 47.2027215,
    "lng": -121.9871258
  },
  {
    "Store Location": "Tractor Supply 1120 WEST MAIN ST WAUPUN, Wisconsin 53963",
    "Store Type": "Tractor Supply",
    "Phone Number": "920-324-9060",
    "address": "1120 WEST MAIN ST, WAUPUN, Wisconsin 53963",
    "city": "WAUPUN",
    "state": "Wisconsin",
    "zip": "53963",
    "lat": 43.63398189999999,
    "lng": -88.7617727
  },
  {
    "Store Location": "Tractor Supply 1202 NORTH MAIN ST VIROQUA, Wisconsin 54665",
    "Store Type": "Tractor Supply",
    "Phone Number": "608-637-8844",
    "address": "1202 NORTH MAIN ST, VIROQUA, Wisconsin 54665",
    "city": "VIROQUA",
    "state": "Wisconsin",
    "zip": "54665",
    "lat": 43.5720968,
    "lng": -90.8909656
  },
  {
    "Store Location": "Tractor Supply 1310 NORTH SUPERIOR AVE TOMAH, Wisconsin 54660",
    "Store Type": "Tractor Supply",
    "Phone Number": "608-374-5001",
    "address": "1310 NORTH SUPERIOR AVE, TOMAH, Wisconsin 54660",
    "city": "TOMAH",
    "state": "Wisconsin",
    "zip": "54660",
    "lat": 44.0067387,
    "lng": -90.5076205
  },
  {
    "Store Location": "Tractor Supply 1313 EAST GREEN BAY ST SHAWANO, Wisconsin 54166",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-526-2938",
    "address": "1313 EAST GREEN BAY ST, SHAWANO, Wisconsin 54166",
    "city": "SHAWANO",
    "state": "Wisconsin",
    "zip": "54166",
    "lat": 44.7827784,
    "lng": -88.5752267
  },
  {
    "Store Location": "Tractor Supply 1445 NORTH ACRES RD PRESCOTT, Wisconsin 54021",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-262-4500",
    "address": "1445 NORTH ACRES RD, PRESCOTT, Wisconsin 54021",
    "city": "PRESCOTT",
    "state": "Wisconsin",
    "zip": "54021",
    "lat": 44.7626577,
    "lng": -92.793039
  },
  {
    "Store Location": "Tractor Supply 1651 N SHAWANO ST NEW LONDON, Wisconsin 54961",
    "Store Type": "Tractor Supply",
    "Phone Number": "920-982-6222",
    "address": "1651 N SHAWANO ST NEW, LONDON, Wisconsin 54961",
    "city": "LONDON",
    "state": "Wisconsin",
    "zip": "54961",
    "lat": 44.410459,
    "lng": -88.7432127
  },
  {
    "Store Location": "Tractor Supply 1700 LAKE SHORE DR EAST ASHLAND, Wisconsin 54806",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-682-2539",
    "address": "1700 LAKE SHORE DR EAST, ASHLAND, Wisconsin 54806",
    "city": "ASHLAND",
    "state": "Wisconsin",
    "zip": "54806",
    "lat": 46.600898,
    "lng": -90.86298579999999
  },
  {
    "Store Location": "Tractor Supply 1800 US HWY 51 AND 138 STOUGHTON, Wisconsin 53589",
    "Store Type": "Tractor Supply",
    "Phone Number": "608-873-0323",
    "address": "1800 US HWY 51 AND 138, STOUGHTON, Wisconsin 53589",
    "city": "STOUGHTON",
    "state": "Wisconsin",
    "zip": "53589",
    "lat": 42.9195856,
    "lng": -89.24300559999999
  },
  {
    "Store Location": "Tractor Supply 1801 MILWAUKEE AVE BURLINGTON, Wisconsin 53105",
    "Store Type": "Tractor Supply",
    "Phone Number": "262-763-2425",
    "address": "1801 MILWAUKEE AVE, BURLINGTON, Wisconsin 53105",
    "city": "BURLINGTON",
    "state": "Wisconsin",
    "zip": "53105",
    "lat": 42.7017698,
    "lng": -88.25624409999999
  },
  {
    "Store Location": "Tractor Supply 1833 EGG HARBOR ROAD UNIT A STURGEON BAY, Wisconsin 54235",
    "Store Type": "Tractor Supply",
    "Phone Number": "920-743-2444",
    "address": "1833 EGG HARBOR ROAD UNIT A STURGEON, BAY, Wisconsin 54235",
    "city": "BAY",
    "state": "Wisconsin",
    "zip": "54235",
    "lat": 44.8521679,
    "lng": -87.35039619999999
  },
  {
    "Store Location": "Tractor Supply 1903 LINCOLN STREET RHINELANDER, Wisconsin 54501",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-369-4981",
    "address": "1903 LINCOLN STREET, RHINELANDER, Wisconsin 54501",
    "city": "RHINELANDER",
    "state": "Wisconsin",
    "zip": "54501",
    "lat": 45.6339173,
    "lng": -89.3839124
  },
  {
    "Store Location": "Tractor Supply 1911 MARKET WAY WATERTOWN, Wisconsin 53094",
    "Store Type": "Tractor Supply",
    "Phone Number": "920-261-3953",
    "address": "1911 MARKET WAY, WATERTOWN, Wisconsin 53094",
    "city": "WATERTOWN",
    "state": "Wisconsin",
    "zip": "53094",
    "lat": 43.159453,
    "lng": -88.7300077
  },
  {
    "Store Location": "Tractor Supply 195 RICHLAND SQ RICHLAND CENTER, Wisconsin 53581",
    "Store Type": "Tractor Supply",
    "Phone Number": "608-383-0979",
    "address": "195 RICHLAND SQ RICHLAND, CENTER, Wisconsin 53581",
    "city": "CENTER",
    "state": "Wisconsin",
    "zip": "53581",
    "lat": 43.3347053,
    "lng": -90.3867928
  },
  {
    "Store Location": "Tractor Supply 20 RIVERSIDE SQ STE 1 PRAIRIE DU CHIEN, Wisconsin 53821",
    "Store Type": "Tractor Supply",
    "Phone Number": "608-326-1080",
    "address": "20 RIVERSIDE SQ STE 1 PRAIRIE DU, CHIEN, Wisconsin 53821",
    "city": "CHIEN",
    "state": "Wisconsin",
    "zip": "53821",
    "lat": 43.0266243,
    "lng": -91.1281814
  },
  {
    "Store Location": "Tractor Supply 2179 US HWY 8 STE 1 SAINT CROIX FALLS, Wisconsin 54024",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-483-2640",
    "address": "2179 US HWY 8 STE 1 SAINT CROIX, FALLS, Wisconsin 54024",
    "city": "FALLS",
    "state": "Wisconsin",
    "zip": "54024",
    "lat": 45.4099615,
    "lng": -92.63965089999999
  },
  {
    "Store Location": "Tractor Supply 2881 ROOSEVELT RD MARINETTE, Wisconsin 54143",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-732-2093",
    "address": "2881 ROOSEVELT RD, MARINETTE, Wisconsin 54143",
    "city": "MARINETTE",
    "state": "Wisconsin",
    "zip": "54143",
    "lat": 45.0742725,
    "lng": -87.66137619999999
  },
  {
    "Store Location": "Tractor Supply 3033 CTH CX PORTAGE, Wisconsin 53901",
    "Store Type": "Tractor Supply",
    "Phone Number": "608-745-0750",
    "address": "3033 CTH CX, PORTAGE, Wisconsin 53901",
    "city": "PORTAGE",
    "state": "Wisconsin",
    "zip": "53901",
    "lat": 43.5391486,
    "lng": -89.46262019999999
  },
  {
    "Store Location": "Tractor Supply 3650 COUNTY HWY A SHEBOYGAN, Wisconsin 53081",
    "Store Type": "Tractor Supply",
    "Phone Number": "920-803-0120",
    "address": "3650 COUNTY HWY A, SHEBOYGAN, Wisconsin 53081",
    "city": "SHEBOYGAN",
    "state": "Wisconsin",
    "zip": "53081",
    "lat": 43.6901237,
    "lng": -87.87879629999999
  },
  {
    "Store Location": "Tractor Supply 433 SOUTH WRIGHT ST DELAVAN, Wisconsin 53115",
    "Store Type": "Tractor Supply",
    "Phone Number": "262-728-2183",
    "address": "433 SOUTH WRIGHT ST, DELAVAN, Wisconsin 53115",
    "city": "DELAVAN",
    "state": "Wisconsin",
    "zip": "53115",
    "lat": 42.6286778,
    "lng": -88.62360729999999
  },
  {
    "Store Location": "Tractor Supply 4841 8TH ST SOUTH WISCONSIN RAPIDS, Wisconsin 54494",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-424-0690",
    "address": "4841 8TH ST SOUTH WISCONSIN, RAPIDS, Wisconsin 54494",
    "city": "RAPIDS",
    "state": "Wisconsin",
    "zip": "54494",
    "lat": 44.3498182,
    "lng": -89.8157653
  },
  {
    "Store Location": "Tractor Supply 650 W BEAVERBROOK AVE SPOONER, Wisconsin 54801",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-635-2322",
    "address": "650 W BEAVERBROOK AVE, SPOONER, Wisconsin 54801",
    "city": "SPOONER",
    "state": "Wisconsin",
    "zip": "54801",
    "lat": 45.8148409,
    "lng": -91.8943123
  },
  {
    "Store Location": "Tractor Supply 709 NORTH RAILROAD STREET EAGLE RIVER, Wisconsin 54521",
    "Store Type": "Tractor Supply",
    "Phone Number": "715-337-0112",
    "address": "709 NORTH RAILROAD STREET EAGLE, RIVER, Wisconsin 54521",
    "city": "RIVER",
    "state": "Wisconsin",
    "zip": "54521",
    "lat": 45.924965,
    "lng": -89.2543
  },
  {
    "Store Location": "Tractor Supply 824 BROADWAY ST BERLIN, Wisconsin 54923",
    "Store Type": "Tractor Supply",
    "Phone Number": "920-361-0351",
    "address": "824 BROADWAY ST, BERLIN, Wisconsin 54923",
    "city": "BERLIN",
    "state": "Wisconsin",
    "zip": "54923",
    "lat": 43.9670986,
    "lng": -88.97740480000002
  },
  {
    "Store Location": "Tractor Supply 857 SOUTH ROCHESTER ST STE 500 MUKWONAGO, Wisconsin 53149",
    "Store Type": "Tractor Supply",
    "Phone Number": "262-363-8868",
    "address": "857 SOUTH ROCHESTER ST STE 500, MUKWONAGO, Wisconsin 53149",
    "city": "MUKWONAGO",
    "state": "Wisconsin",
    "zip": "53149",
    "lat": 42.8540755,
    "lng": -88.3272582
  },
  {
    "Store Location": "Tractor Supply W3098 COUNTY RD KK APPLETON, Wisconsin 54915",
    "Store Type": "Tractor Supply",
    "Phone Number": "920-739-1635",
    "address": "W3098 COUNTY RD KK, APPLETON, Wisconsin 54915",
    "city": "APPLETON",
    "state": "Wisconsin",
    "zip": "54915",
    "lat": 44.2448135,
    "lng": -88.3451054
  },
  {
    "Store Location": "Tractor Supply 101 TARA LN PARKERSBURG, West Virginia 26101",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-489-1028",
    "address": "101 TARA LN, PARKERSBURG, West Virginia 26101",
    "city": "PARKERSBURG",
    "state": "West Virginia",
    "zip": "26101",
    "lat": 39.2174283,
    "lng": -81.54381169999999
  },
  {
    "Store Location": "Tractor Supply 104 SHAMROCK DR KEYSER, West Virginia 26726",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-788-7916",
    "address": "104 SHAMROCK DR, KEYSER, West Virginia 26726",
    "city": "KEYSER",
    "state": "West Virginia",
    "zip": "26726",
    "lat": 39.41673189999999,
    "lng": -79.0016155
  },
  {
    "Store Location": "Tractor Supply 1040 SOMERSET BLVD CHARLES TOWN, West Virginia 25414",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-728-2011",
    "address": "1040 SOMERSET BLVD CHARLES, TOWN, West Virginia 25414",
    "city": "TOWN",
    "state": "West Virginia",
    "zip": "25414",
    "lat": 39.3017432,
    "lng": -77.8147472
  },
  {
    "Store Location": "Tractor Supply 120 GARDEN FRESH PLAZA DR BUCKHANNON, West Virginia 26201",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-472-5110",
    "address": "120 GARDEN FRESH PLAZA DR, BUCKHANNON, West Virginia 26201",
    "city": "BUCKHANNON",
    "state": "West Virginia",
    "zip": "26201",
    "lat": 38.9939872,
    "lng": -80.2320276
  },
  {
    "Store Location": "Tractor Supply 1212 NORTH QUEEN ST MARTINSBURG, West Virginia 25403",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-263-5072",
    "address": "1212 NORTH QUEEN ST, MARTINSBURG, West Virginia 25403",
    "city": "MARTINSBURG",
    "state": "West Virginia",
    "zip": "25403",
    "lat": 39.471589,
    "lng": -77.9558572
  },
  {
    "Store Location": "Tractor Supply 130 MCGRAW ST RIPLEY, West Virginia 25271",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-372-3406",
    "address": "130 MCGRAW ST, RIPLEY, West Virginia 25271",
    "city": "RIPLEY",
    "state": "West Virginia",
    "zip": "25271",
    "lat": 38.8195162,
    "lng": -81.7235704
  },
  {
    "Store Location": "Tractor Supply 150 JOHN WES EVANS DR LOGAN, West Virginia 25601",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-752-0013",
    "address": "150 JOHN WES EVANS DR, LOGAN, West Virginia 25601",
    "city": "LOGAN",
    "state": "West Virginia",
    "zip": "25601",
    "lat": 37.85185999999999,
    "lng": -82.0372895
  },
  {
    "Store Location": "Tractor Supply 1500 MAIN ST BROOK PLZ RTE 2 FOLLANSBEE, West Virginia 26037",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-527-0050",
    "address": "1500 MAIN ST BROOK PLZ RTE 2, FOLLANSBEE, West Virginia 26037",
    "city": "FOLLANSBEE",
    "state": "West Virginia",
    "zip": "26037",
    "lat": 40.3408045,
    "lng": -80.6003516
  },
  {
    "Store Location": "Tractor Supply 1556 EAST MAIN ST STE A OAK HILL, West Virginia 25901",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-465-4201",
    "address": "1556 EAST MAIN ST STE A OAK, HILL, West Virginia 25901",
    "city": "HILL",
    "state": "West Virginia",
    "zip": "25901",
    "lat": 37.973873,
    "lng": -81.1459196
  },
  {
    "Store Location": "Tractor Supply 1607 WHEELING AVE GLEN DALE, West Virginia 26038",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-843-5126",
    "address": "1607 WHEELING AVE GLEN, DALE, West Virginia 26038",
    "city": "DALE",
    "state": "West Virginia",
    "zip": "26038",
    "lat": 39.935634,
    "lng": -80.75533399999999
  },
  {
    "Store Location": "Tractor Supply 181 SOLID OAK DR ROMNEY, West Virginia 26757",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-822-2656",
    "address": "181 SOLID OAK DR, ROMNEY, West Virginia 26757",
    "city": "ROMNEY",
    "state": "West Virginia",
    "zip": "26757",
    "lat": 39.3308931,
    "lng": -78.7145141
  },
  {
    "Store Location": "Tractor Supply 210 EMILY DR CLARKSBURG, West Virginia 26301",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-622-6902",
    "address": "210 EMILY DR, CLARKSBURG, West Virginia 26301",
    "city": "CLARKSBURG",
    "state": "West Virginia",
    "zip": "26301",
    "lat": 39.274215,
    "lng": -80.2810871
  },
  {
    "Store Location": "Tractor Supply 245 NORTH STATE RTE 2 NEW MARTINSVILLE, West Virginia 26155",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-455-2738",
    "address": "245 NORTH STATE RTE 2 NEW, MARTINSVILLE, West Virginia 26155",
    "city": "MARTINSVILLE",
    "state": "West Virginia",
    "zip": "26155",
    "lat": 39.675003,
    "lng": -80.855125
  },
  {
    "Store Location": "Tractor Supply 2700 EAST DUPONT AVE STE 4 BELLE, West Virginia 25015",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-949-3162",
    "address": "2700 EAST DUPONT AVE STE 4, BELLE, West Virginia 25015",
    "city": "BELLE",
    "state": "West Virginia",
    "zip": "25015",
    "lat": 38.2098594,
    "lng": -81.5103003
  },
  {
    "Store Location": "Tractor Supply 3720 VALLEY RD BERKELEY SPRINGS, West Virginia 25411",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-258-6636",
    "address": "3720 VALLEY RD BERKELEY, SPRINGS, West Virginia 25411",
    "city": "SPRINGS",
    "state": "West Virginia",
    "zip": "25411",
    "lat": 39.5780894,
    "lng": -78.2562315
  },
  {
    "Store Location": "Tractor Supply 3790 TEAYS VALLEY RD HURRICANE, West Virginia 25526",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-760-0901",
    "address": "3790 TEAYS VALLEY RD, HURRICANE, West Virginia 25526",
    "city": "HURRICANE",
    "state": "West Virginia",
    "zip": "25526",
    "lat": 38.4476948,
    "lng": -81.95953329999999
  },
  {
    "Store Location": "Tractor Supply 384 MARKET PLACE MALL WESTON, West Virginia 26452",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-269-7975",
    "address": "384 MARKET PLACE MALL, WESTON, West Virginia 26452",
    "city": "WESTON",
    "state": "West Virginia",
    "zip": "26452",
    "lat": 39.0171335,
    "lng": -80.42004659999999
  },
  {
    "Store Location": "Tractor Supply 3955 EAST CUMBERLAND RD BLUEFIELD, West Virginia 24701",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-325-6400",
    "address": "3955 EAST CUMBERLAND RD, BLUEFIELD, West Virginia 24701",
    "city": "BLUEFIELD",
    "state": "West Virginia",
    "zip": "24701",
    "lat": 37.2628885,
    "lng": -81.1889599
  },
  {
    "Store Location": "Tractor Supply 425 EAST MAIN ST STE 403 KINGWOOD, West Virginia 26537",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-329-3793",
    "address": "425 EAST MAIN ST STE 403, KINGWOOD, West Virginia 26537",
    "city": "KINGWOOD",
    "state": "West Virginia",
    "zip": "26537",
    "lat": 39.4685953,
    "lng": -79.668103
  },
  {
    "Store Location": "Tractor Supply 4303 ROBERT C BYRD DR BECKLEY, West Virginia 25801",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-250-0156",
    "address": "4303 ROBERT C BYRD DR, BECKLEY, West Virginia 25801",
    "city": "BECKLEY",
    "state": "West Virginia",
    "zip": "25801",
    "lat": 37.8157185,
    "lng": -81.187964
  },
  {
    "Store Location": "Tractor Supply 4942 RTE 152 LAVALETTE, West Virginia 25535",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-523-2077",
    "address": "4942 RTE 152, LAVALETTE, West Virginia 25535",
    "city": "LAVALETTE",
    "state": "West Virginia",
    "zip": "25535",
    "lat": 38.3233415,
    "lng": -82.4477461
  },
  {
    "Store Location": "Tractor Supply 58 WILLIAMS DR SPENCER, West Virginia 25276",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-927-0470",
    "address": "58 WILLIAMS DR, SPENCER, West Virginia 25276",
    "city": "SPENCER",
    "state": "West Virginia",
    "zip": "25276",
    "lat": 38.7991594,
    "lng": -81.3503698
  },
  {
    "Store Location": "Tractor Supply 6 ELM GROVE XING WHEELING, West Virginia 26003",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-238-0050",
    "address": "6 ELM GROVE XING, WHEELING, West Virginia 26003",
    "city": "WHEELING",
    "state": "West Virginia",
    "zip": "26003",
    "lat": 40.0467732,
    "lng": -80.65312399999999
  },
  {
    "Store Location": "Tractor Supply 7 VISTA DEL RIO DR MORGANTOWN, West Virginia 26508",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-284-9574",
    "address": "7 VISTA DEL RIO DR, MORGANTOWN, West Virginia 26508",
    "city": "MORGANTOWN",
    "state": "West Virginia",
    "zip": "26508",
    "lat": 39.5862995,
    "lng": -79.9560964
  },
  {
    "Store Location": "Tractor Supply 747 NORTH MAIN ST STE E MOOREFIELD, West Virginia 26836",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-538-5900",
    "address": "747 NORTH MAIN ST STE E, MOOREFIELD, West Virginia 26836",
    "city": "MOOREFIELD",
    "state": "West Virginia",
    "zip": "26836",
    "lat": 39.0758386,
    "lng": -78.9642782
  },
  {
    "Store Location": "Tractor Supply 800 BEVERLY PIKE ELKINS, West Virginia 26241",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-637-2346",
    "address": "800 BEVERLY PIKE, ELKINS, West Virginia 26241",
    "city": "ELKINS",
    "state": "West Virginia",
    "zip": "26241",
    "lat": 38.890343,
    "lng": -79.8483184
  },
  {
    "Store Location": "Tractor Supply 810 NORTHSIDE DR STE 100 SUMMERSVILLE, West Virginia 26651",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-872-3741",
    "address": "810 NORTHSIDE DR STE 100, SUMMERSVILLE, West Virginia 26651",
    "city": "SUMMERSVILLE",
    "state": "West Virginia",
    "zip": "26651",
    "lat": 38.30390269999999,
    "lng": -80.83046949999999
  },
  {
    "Store Location": "Tractor Supply 8444 SENECA TRL SOUTH RONCEVERTE, West Virginia 24970",
    "Store Type": "Tractor Supply",
    "Phone Number": "304-645-2383",
    "address": "8444 SENECA TRL SOUTH, RONCEVERTE, West Virginia 24970",
    "city": "RONCEVERTE",
    "state": "West Virginia",
    "zip": "24970",
    "lat": 37.7650327,
    "lng": -80.4646247
  },
  {
    "Store Location": "Tractor Supply 10643 HYNDS BLVD CHEYENNE, Wyoming 82009",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-635-9945",
    "address": "10643 HYNDS BLVD, CHEYENNE, Wyoming 82009",
    "city": "CHEYENNE",
    "state": "Wyoming",
    "zip": "82009",
    "lat": 41.2160065,
    "lng": -104.8366924
  },
  {
    "Store Location": "Tractor Supply 1140 EAST BRUNDAGE LN SHERIDAN, Wyoming 82801",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-672-1709",
    "address": "1140 EAST BRUNDAGE LN, SHERIDAN, Wyoming 82801",
    "city": "SHERIDAN",
    "state": "Wyoming",
    "zip": "82801",
    "lat": 44.772861,
    "lng": -106.939095
  },
  {
    "Store Location": "Tractor Supply 2140 EAST RICHARDS ST DOUGLAS, Wyoming 82633",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-358-8301",
    "address": "2140 EAST RICHARDS ST, DOUGLAS, Wyoming 82633",
    "city": "DOUGLAS",
    "state": "Wyoming",
    "zip": "82633",
    "lat": 42.74095,
    "lng": -105.3534631
  },
  {
    "Store Location": "Tractor Supply 2201 PLAZA ST STE A RAWLINS, Wyoming 82301",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-324-0076",
    "address": "2201 PLAZA ST STE A, RAWLINS, Wyoming 82301",
    "city": "RAWLINS",
    "state": "Wyoming",
    "zip": "82301",
    "lat": 41.79478779999999,
    "lng": -107.2129971
  },
  {
    "Store Location": "Tractor Supply 324 YELLOWSTONE AVE CODY, Wyoming 82414",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-587-5233",
    "address": "324 YELLOWSTONE AVE, CODY, Wyoming 82414",
    "city": "CODY",
    "state": "Wyoming",
    "zip": "82414",
    "lat": 44.5163619,
    "lng": -109.0878134
  },
  {
    "Store Location": "Tractor Supply 4005 SOUTH DOUGLAS HWY GILLETTE, Wyoming 82718",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-682-1165",
    "address": "4005 SOUTH DOUGLAS HWY, GILLETTE, Wyoming 82718",
    "city": "GILLETTE",
    "state": "Wyoming",
    "zip": "82718",
    "lat": 44.2576347,
    "lng": -105.4891043
  },
  {
    "Store Location": "Tractor Supply 5300 CY AVE CASPER, Wyoming 82604",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-234-6743",
    "address": "5300 CY AVE, CASPER, Wyoming 82604",
    "city": "CASPER",
    "state": "Wyoming",
    "zip": "82604",
    "lat": 42.8145928,
    "lng": -106.3908997
  },
  {
    "Store Location": "Tractor Supply 855 SOUTH WASHINGTON ST AFTON, Wyoming 83110",
    "Store Type": "Tractor Supply",
    "Phone Number": "307-886-5600",
    "address": "855 SOUTH WASHINGTON ST, AFTON, Wyoming 83110",
    "city": "AFTON",
    "state": "Wyoming",
    "zip": "83110",
    "lat": 42.71578840000001,
    "lng": -110.9335656
  },
  {
    "Store Location": "RJ's Outdoor Power 460 New Ludlow Rd Chicopee, Massachusetts 1020",
    "Store Type": "RJ's Outdoor Power",
    "Phone Number": "413-467-2933",
    "address": "RJ's Outdoor Power 460 New Ludlow Rd Chicopee, Massachusetts 1020,  ",
    "city": "Massachusetts 1020",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.213676,
    "lng": -72.5632316
  },
  {
    "Store Location": "Irrigation Pipe Lighting & Equipment 19 Blanding Ave Framingham, Massachusetts 1702",
    "Store Type": "Irrigation Pipe Lighting & Equipment",
    "Phone Number": "508-820-4444",
    "address": "Irrigation Pipe Lighting & Equipment 19 Blanding Ave Framingham, Massachusetts 1702,  ",
    "city": "Massachusetts 1702",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.279286,
    "lng": -71.4161565
  },
  {
    "Store Location": "Metro West Lawn & Power Equipment 418 Maple St Marlborough, Massachusetts 1752",
    "Store Type": "Metro West Lawn & Power Equipment",
    "Phone Number": "508-485-0090",
    "address": "Metro West Lawn & Power Equipment 418 Maple St Marlborough, Massachusetts 1752,  ",
    "city": "Massachusetts 1752",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.332622,
    "lng": -71.5410634
  },
  {
    "Store Location": "Roger's Power Tool Repair 683 American Legion Hwy Westport, Massachusetts 2790",
    "Store Type": "Roger's Power Tool Repair",
    "Phone Number": "508-636-3484",
    "address": "Roger's Power Tool Repair 683 American Legion Hwy Westport, Massachusetts 2790,  ",
    "city": "Massachusetts 2790",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.6314515,
    "lng": -71.0879102
  },
  {
    "Store Location": "Dags Bait & Tackle 559 Minot Ave Auburn, Maine 4210",
    "Store Type": "Dags Bait & Tackle",
    "Phone Number": "207-783-0388",
    "address": "Dags Bait & Tackle 559 Minot Ave Auburn, Maine 4210,  ",
    "city": "Maine 4210",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.082763,
    "lng": -70.248674
  },
  {
    "Store Location": "POULIN'S ELECTRIC MOTORS 195 CHURCH HILL ROAD AUGUSTA, Maine 4330",
    "Store Type": "POULIN'S ELECTRIC MOTORS",
    "Phone Number": "207-622-1689",
    "address": "POULIN'S ELECTRIC MOTORS 195 CHURCH HILL ROAD AUGUSTA, Maine 4330,  ",
    "city": "Maine 4330",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.3308571,
    "lng": -69.7310719
  },
  {
    "Store Location": "ROGER AYOTTE ELECTRIC, INC. 41 MAIN ST. MADAWASKA, Maine 4756",
    "Store Type": "ROGER AYOTTE ELECTRIC, INC.",
    "Phone Number": "207-728-4253",
    "address": "ROGER AYOTTE ELECTRIC, INC. 41 MAIN ST. MADAWASKA, Maine 4756,  ",
    "city": "Maine 4756",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 47.3537808,
    "lng": -68.349332
  },
  {
    "Store Location": "Union Rental 244 Front St Farmington, Maine 4938",
    "Store Type": "Union Rental",
    "Phone Number": "207-778-5674",
    "address": "Union Rental 244 Front St Farmington, Maine 4938,  ",
    "city": "Maine 4938",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.6680387,
    "lng": -70.15117420000001
  },
  {
    "Store Location": "PARSONS SMALL ENGINE 991 WATERVILLE RD. UNITY, Maine 4988",
    "Store Type": "PARSONS SMALL ENGINE",
    "Phone Number": "207-948-2377",
    "address": "PARSONS SMALL ENGINE 991 WATERVILLE RD. UNITY, Maine 4988,  ",
    "city": "Maine 4988",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.61694689999999,
    "lng": -69.4058082
  },
  {
    "Store Location": "Lakeshore Ace Hardware 713 W. Lakeshore Dr. Colchester, Vermont 5446",
    "Store Type": "Lakeshore Ace Hardware",
    "Phone Number": "802-863-4910",
    "address": "Lakeshore Ace Hardware 713 W. Lakeshore Dr. Colchester, Vermont 5446,  ",
    "city": "Vermont 5446",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.5497069,
    "lng": -73.228369
  },
  {
    "Store Location": "TOOL & EQUIPMENT SERVICE SOLUTIONS 5 MANILA AVE. HAMDEN, Connecticut 6514",
    "Store Type": "TOOL & EQUIPMENT SERVICE SOLUTIONS",
    "Phone Number": "800-397-7553",
    "address": "TOOL & EQUIPMENT SERVICE SOLUTIONS 5 MANILA AVE. HAMDEN, Connecticut 6514,  ",
    "city": "Connecticut 6514",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.351474,
    "lng": -72.92892650000002
  },
  {
    "Store Location": "Back to Basics LLC 31 Main St. Terryville, Connecticut 6786",
    "Store Type": "Back to Basics LLC",
    "Phone Number": "860-589-8858",
    "address": "Back to Basics LLC 31 Main St. Terryville, Connecticut 6786,  ",
    "city": "Connecticut 6786",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 41.6791952,
    "lng": -72.994423
  },
  {
    "Store Location": "Cougar Electronics & Tool 241 CHELSEA AVE BUILDING 7 Long Branch, New Jersey 7740",
    "Store Type": "Cougar Electronics & Tool",
    "Phone Number": "800-850-3302",
    "address": "Cougar Electronics & Tool 241 CHELSEA AVE BUILDING 7 Long Branch, New Jersey 7740,  ",
    "city": "New Jersey 7740",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.3009169,
    "lng": -73.9898224
  },
  {
    "Store Location": "Aqua Tech Hotsy, Inc 200 W. Stiger St. Hackettstown, New Jersey 7840",
    "Store Type": "Aqua Tech Hotsy, Inc",
    "Phone Number": "908-852-6110",
    "address": "Aqua Tech Hotsy, Inc 200 W. Stiger St. Hackettstown, New Jersey 7840,  ",
    "city": "New Jersey 7840",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.852731,
    "lng": -74.832809
  },
  {
    "Store Location": "JOHN'S SHARPENING AND MOWER REPAIR 332 SOUTH DELSEA DR CAPE MAY COURT HOUSE, New Jersey 8210",
    "Store Type": "JOHN'S SHARPENING AND MOWER REPAIR",
    "Phone Number": "609-849-1230",
    "address": "JOHN'S SHARPENING AND MOWER REPAIR 332 SOUTH DELSEA DR CAPE MAY COURT HOUSE, New Jersey 8210,  ",
    "city": "New Jersey 8210",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 39.05998570000001,
    "lng": -74.89791249999999
  },
  {
    "Store Location": "Five Boro Pneu-Tronics INC 801 E 42nd Brooklyn, New York 11210",
    "Store Type": "Five Boro Pneu-Tronics INC",
    "Phone Number": "718-338-8911",
    "address": "Five Boro Pneu-Tronics INC 801 E 42nd, Brooklyn, New York 11210",
    "city": "Brooklyn",
    "state": "New York",
    "zip": "11210",
    "lat": 40.6355769,
    "lng": -73.9362794
  },
  {
    "Store Location": "Pemco Supply 1991 Utica Ave Brooklyn, New York 11234",
    "Store Type": "Pemco Supply",
    "Phone Number": "718-629-0551",
    "address": "Pemco Supply 1991 Utica Ave, Brooklyn, New York 11234",
    "city": "Brooklyn",
    "state": "New York",
    "zip": "11234",
    "lat": 40.6232186,
    "lng": -73.927013
  },
  {
    "Store Location": "THE TOOL HOUSE RENTAL, INC 1700 UTICA AVE BROOKLYN, New York 11234",
    "Store Type": "THE TOOL HOUSE RENTAL, INC",
    "Phone Number": "718-743-6336",
    "address": "THE TOOL HOUSE RENTAL, INC 1700 UTICA AVE BROOKLYN, New York 11234",
    "city": "INC 1700 UTICA AVE BROOKLYN",
    "state": "New York",
    "zip": "11234",
    "lat": 40.6309381,
    "lng": -73.9283554
  },
  {
    "Store Location": "R P Rentals 1855 Stanhope St. Ridgewood, New York 11385",
    "Store Type": "R P Rentals",
    "Phone Number": "718-456-7397",
    "address": "R P Rentals 1855 Stanhope St., Ridgewood, New York 11385",
    "city": "Ridgewood",
    "state": "New York",
    "zip": "11385",
    "lat": 40.7079979,
    "lng": -73.91330339999999
  },
  {
    "Store Location": "LOPER'S EQUIPMENT 129 MEDFORD AVE. PATCHOGUE, New York 11772",
    "Store Type": "LOPER'S EQUIPMENT",
    "Phone Number": "631-475-2044",
    "address": "LOPER'S EQUIPMENT 129 MEDFORD AVE., PATCHOGUE, New York 11772",
    "city": "PATCHOGUE",
    "state": "New York",
    "zip": "11772",
    "lat": 40.7709398,
    "lng": -73.00682290000002
  },
  {
    "Store Location": "Abbey Tool and Party Rent All Inc. 301 South Broadway Hicksville, New York 11801",
    "Store Type": "Abbey Tool and Party Rent All Inc.",
    "Phone Number": "516-681-1323",
    "address": "Abbey Tool and Party Rent All Inc. 301 South Broadway, Hicksville, New York 11801",
    "city": "Hicksville",
    "state": "New York",
    "zip": "11801",
    "lat": 40.7616646,
    "lng": -73.5160221
  },
  {
    "Store Location": "Red Rock Enterprises 82 Tymeson Rd Averill Park, New York 12018",
    "Store Type": "Red Rock Enterprises",
    "Phone Number": "518-283-0145",
    "address": "Red Rock Enterprises 82 Tymeson Rd Averill, Park, New York 12018",
    "city": "Park",
    "state": "New York",
    "zip": "12018",
    "lat": 42.66497100000001,
    "lng": -73.504307
  },
  {
    "Store Location": "J.J. Sommers, INC 365 Broadway Monticello, New York 12071",
    "Store Type": "J.J. Sommers, INC",
    "Phone Number": "845-794-7740",
    "address": "J.J. Sommers, INC 365 Broadway Monticello, New York 12071",
    "city": "INC 365 Broadway Monticello",
    "state": "New York",
    "zip": "12071",
    "lat": 41.6531248,
    "lng": -74.6802479
  },
  {
    "Store Location": "Kingston Lawn & Power Equipment 9 S. Sterling St. Kingston, New York 12401",
    "Store Type": "Kingston Lawn & Power Equipment",
    "Phone Number": "845-338-4227",
    "address": "Kingston Lawn & Power Equipment 9 S. Sterling St., Kingston, New York 12401",
    "city": "Kingston",
    "state": "New York",
    "zip": "12401",
    "lat": 41.9250986,
    "lng": -74.0038325
  },
  {
    "Store Location": "Eldred Power Equipment & Auto Parts 550 Route 55 Eldred, New York 12732",
    "Store Type": "Eldred Power Equipment & Auto Parts",
    "Phone Number": "845-557-6168",
    "address": "Eldred Power Equipment & Auto Parts 550 Route 55, Eldred, New York 12732",
    "city": "Eldred",
    "state": "New York",
    "zip": "12732",
    "lat": 41.525529,
    "lng": -74.88533989999999
  },
  {
    "Store Location": "Fort Edward Agway True Value 344 Broadway Fort Edward, New York 12828",
    "Store Type": "Fort Edward Agway True Value",
    "Phone Number": "518-747-4133",
    "address": "Fort Edward Agway True Value 344 Broadway Fort, Edward, New York 12828",
    "city": "Edward",
    "state": "New York",
    "zip": "12828",
    "lat": 43.2830404,
    "lng": -73.5850598
  },
  {
    "Store Location": "Taylor Rental NY 550 Route 3 Suite 100 Plattsburg, New York 12901",
    "Store Type": "Taylor Rental NY",
    "Phone Number": "518-324-5100",
    "address": "Taylor Rental NY 550 Route 3 Suite 100, Plattsburg, New York 12901",
    "city": "Plattsburg",
    "state": "New York",
    "zip": "12901",
    "lat": 44.6975099,
    "lng": -73.501637
  },
  {
    "Store Location": "Sturdy Supply 20 Bloomingdale Ave Saranac Lake, New York 12983",
    "Store Type": "Sturdy Supply",
    "Phone Number": "518-891-2504",
    "address": "Sturdy Supply 20 Bloomingdale Ave Saranac, Lake, New York 12983",
    "city": "Lake",
    "state": "New York",
    "zip": "12983",
    "lat": 44.32931079999999,
    "lng": -74.1318738
  },
  {
    "Store Location": "Moyer's Sales and Service 1686 Tallet Rd. DeRuyter, New York 13052",
    "Store Type": "Moyer's Sales and Service",
    "Phone Number": "315-852-3367",
    "address": "Moyer's Sales and Service 1686 Tallet Rd., DeRuyter, New York 13052",
    "city": "DeRuyter",
    "state": "New York",
    "zip": "13052",
    "lat": 42.7747831,
    "lng": -75.8831285
  },
  {
    "Store Location": "C.I. Horst Small Engine Repairs 2522 US Route 11 Mannsville, New York 13661",
    "Store Type": "C.I. Horst Small Engine Repairs",
    "Phone Number": "315-465-6671",
    "address": "C.I. Horst Small Engine Repairs 2522 US Route 11, Mannsville, New York 13661",
    "city": "Mannsville",
    "state": "New York",
    "zip": "13661",
    "lat": 43.7043303,
    "lng": -76.0615921
  },
  {
    "Store Location": "VALLEY MOWER SERVICE 2857 ELLIS CREEK RD. BARTON, New York 13734",
    "Store Type": "VALLEY MOWER SERVICE",
    "Phone Number": "607-589-4825",
    "address": "VALLEY MOWER SERVICE 2857 ELLIS CREEK RD., BARTON, New York 13734",
    "city": "BARTON",
    "state": "New York",
    "zip": "13734",
    "lat": 42.129703,
    "lng": -76.43548899999999
  },
  {
    "Store Location": "OTEGO SALES & REPAIR 226 COUNTY HWY. 7 OTEGO, New York 13825",
    "Store Type": "OTEGO SALES & REPAIR",
    "Phone Number": "607-988-7859",
    "address": "OTEGO SALES & REPAIR 226 COUNTY HWY. 7, OTEGO, New York 13825",
    "city": "OTEGO",
    "state": "New York",
    "zip": "13825",
    "lat": 42.4590003,
    "lng": -75.17788530000001
  },
  {
    "Store Location": "Bison Scaffold & Masons Supply INC 885 Bailey Ave Buffalo, New York 14206",
    "Store Type": "Bison Scaffold & Masons Supply INC",
    "Phone Number": "716-821-1995",
    "address": "Bison Scaffold & Masons Supply INC 885 Bailey Ave, Buffalo, New York 14206",
    "city": "Buffalo",
    "state": "New York",
    "zip": "14206",
    "lat": 42.87843,
    "lng": -78.81486
  },
  {
    "Store Location": "MEAD SUPPLY/VOLLAND ELECTRIC 75 INNSBRUCK BUFFALO, New York 14277",
    "Store Type": "MEAD SUPPLY/VOLLAND ELECTRIC",
    "Phone Number": "716-883-6200",
    "address": "MEAD SUPPLY/VOLLAND ELECTRIC 75 INNSBRUCK, BUFFALO, New York 14277",
    "city": "BUFFALO",
    "state": "New York",
    "zip": "14277",
    "lat": 42.8741352,
    "lng": -78.7494767
  },
  {
    "Store Location": "R&D Mower & Snowblower 507 West Commercial St Suite 6 East Rochester, New York 14445",
    "Store Type": "R&D Mower & Snowblower",
    "Phone Number": "585-383-8075",
    "address": "R&D Mower & Snowblower 507 West Commercial St Suite 6 East, Rochester, New York 14445",
    "city": "Rochester",
    "state": "New York",
    "zip": "14445",
    "lat": 43.1167107,
    "lng": -77.4974943
  },
  {
    "Store Location": "P & C REPAIR 12 EAST ST. NUNDA, New York 14517",
    "Store Type": "P & C REPAIR",
    "Phone Number": "585-468-5050",
    "address": "P & C REPAIR 12 EAST ST., NUNDA, New York 14517",
    "city": "NUNDA",
    "state": "New York",
    "zip": "14517",
    "lat": 42.580411,
    "lng": -77.94158
  },
  {
    "Store Location": "A-1 RENTAL 436 S.UNION ST. OLEAN, New York 14760",
    "Store Type": "A-1 RENTAL",
    "Phone Number": "716-373-7368",
    "address": "A-1 RENTAL 436 S.UNION ST., OLEAN, New York 14760",
    "city": "OLEAN",
    "state": "New York",
    "zip": "14760",
    "lat": 42.0717934,
    "lng": -78.4304205
  },
  {
    "Store Location": "Ambridge Do it Best Home Center 500 Ohio River Blvd. Ambridge, Pennsylvania 15003",
    "Store Type": "Ambridge Do it Best Home Center",
    "Phone Number": "724-266-9595",
    "address": "Ambridge Do it Best Home Center 500 Ohio River Blvd., Ambridge, Pennsylvania 15003",
    "city": "Ambridge",
    "state": "Pennsylvania",
    "zip": "15003",
    "lat": 40.5838726,
    "lng": -80.22840750000002
  },
  {
    "Store Location": "EQUIPMENT CONNECTION 1006 TYROL BLVD BELLE VERNON, Pennsylvania 15012",
    "Store Type": "EQUIPMENT CONNECTION",
    "Phone Number": "724-929-2400",
    "address": "EQUIPMENT CONNECTION 1006 TYROL BLVD BELLE, VERNON, Pennsylvania 15012",
    "city": "VERNON",
    "state": "Pennsylvania",
    "zip": "15012",
    "lat": 40.1410865,
    "lng": -79.8565368
  },
  {
    "Store Location": "FAYCO RENTALS MONESSEN HWY. PRICEDALE, Pennsylvania 15072",
    "Store Type": "FAYCO RENTALS",
    "Phone Number": "724-929-2400",
    "address": "FAYCO RENTALS MONESSEN HWY., PRICEDALE, Pennsylvania 15072",
    "city": "PRICEDALE",
    "state": "Pennsylvania",
    "zip": "15072",
    "lat": 40.1199857,
    "lng": -79.836024
  },
  {
    "Store Location": "LATROBE TOOL SERVICE INC 4339 ROUTE 30 LATROBE, Pennsylvania 15650",
    "Store Type": "LATROBE TOOL SERVICE INC",
    "Phone Number": "724-532-1411",
    "address": "LATROBE TOOL SERVICE INC 4339 ROUTE 30, LATROBE, Pennsylvania 15650",
    "city": "LATROBE",
    "state": "Pennsylvania",
    "zip": "15650",
    "lat": 40.2837228,
    "lng": -79.4256829
  },
  {
    "Store Location": "Fisher & Father 2449 State Route 257 Cranberry, Pennsylvania 16319",
    "Store Type": "Fisher & Father",
    "Phone Number": "814-678-6416",
    "address": "Fisher & Father 2449 State Route 257, Cranberry, Pennsylvania 16319",
    "city": "Cranberry",
    "state": "Pennsylvania",
    "zip": "16319",
    "lat": 41.3522299,
    "lng": -79.7122487
  },
  {
    "Store Location": "Knickerbocker Equipment 3001 West 17th St Erie, Pennsylvania 16505",
    "Store Type": "Knickerbocker Equipment",
    "Phone Number": "814-833-7761",
    "address": "Knickerbocker Equipment 3001 West 17th St, Erie, Pennsylvania 16505",
    "city": "Erie",
    "state": "Pennsylvania",
    "zip": "16505",
    "lat": 42.0943431,
    "lng": -80.14579429999999
  },
  {
    "Store Location": "BG's Engine Clinic 191 Main Street Roulette, Pennsylvania 16746",
    "Store Type": "BG's Engine Clinic",
    "Phone Number": "814-544-7558",
    "address": "BG's Engine Clinic 191 Main Street, Roulette, Pennsylvania 16746",
    "city": "Roulette",
    "state": "Pennsylvania",
    "zip": "16746",
    "lat": 41.78078319999999,
    "lng": -78.1626113
  },
  {
    "Store Location": "Clearfield Agway 7 West Second Ave Clearfield, Pennsylvania 16830",
    "Store Type": "Clearfield Agway",
    "Phone Number": "814-765-9044",
    "address": "Clearfield Agway 7 West Second Ave, Clearfield, Pennsylvania 16830",
    "city": "Clearfield",
    "state": "Pennsylvania",
    "zip": "16830",
    "lat": 41.0208609,
    "lng": -78.443833
  },
  {
    "Store Location": "MACKNIGHT'S AGWAY 120 NORTH ST. WESTFIELD, Pennsylvania 16950",
    "Store Type": "MACKNIGHT'S AGWAY",
    "Phone Number": "814-367-2715",
    "address": "MACKNIGHT'S AGWAY 120 NORTH ST., WESTFIELD, Pennsylvania 16950",
    "city": "WESTFIELD",
    "state": "Pennsylvania",
    "zip": "16950",
    "lat": 41.9212989,
    "lng": -77.5453414
  },
  {
    "Store Location": "CAL BOYER'S AUTO & MARINE 197 E. PINE ST. CLEONA, Pennsylvania 17042",
    "Store Type": "CAL BOYER'S AUTO & MARINE",
    "Phone Number": "717-273-6447",
    "address": "CAL BOYER'S AUTO & MARINE 197 E. PINE ST., CLEONA, Pennsylvania 17042",
    "city": "CLEONA",
    "state": "Pennsylvania",
    "zip": "17042",
    "lat": 40.3399926,
    "lng": -76.4726924
  },
  {
    "Store Location": "MCCOY'S HARDWARE SERVICE & REPAIR 151 MAPLE ST. MILROY, Pennsylvania 17063",
    "Store Type": "MCCOY'S HARDWARE SERVICE & REPAIR",
    "Phone Number": "717-667-2300",
    "address": "MCCOY'S HARDWARE SERVICE & REPAIR 151 MAPLE ST., MILROY, Pennsylvania 17063",
    "city": "MILROY",
    "state": "Pennsylvania",
    "zip": "17063",
    "lat": 40.71914,
    "lng": -77.57941799999999
  },
  {
    "Store Location": "KEYSTONE AIR POWER 60 ELCO DR MYERSTOWN, Pennsylvania 17067",
    "Store Type": "KEYSTONE AIR POWER",
    "Phone Number": "717-866-9224",
    "address": "KEYSTONE AIR POWER 60 ELCO DR, MYERSTOWN, Pennsylvania 17067",
    "city": "MYERSTOWN",
    "state": "Pennsylvania",
    "zip": "17067",
    "lat": 40.34742900000001,
    "lng": -76.2852652
  },
  {
    "Store Location": "STAHL'S RENTAL CENTER 7211 PAXTON ST. HARRISBURG, Pennsylvania 17111",
    "Store Type": "STAHL'S RENTAL CENTER",
    "Phone Number": "717-564-6809",
    "address": "STAHL'S RENTAL CENTER 7211 PAXTON ST., HARRISBURG, Pennsylvania 17111",
    "city": "HARRISBURG",
    "state": "Pennsylvania",
    "zip": "17111",
    "lat": 40.2603891,
    "lng": -76.7649711
  },
  {
    "Store Location": "Best Line Equipment 6700 ALLENTOWN BLVD Harrisburg, Pennsylvania 17112",
    "Store Type": "Best Line Equipment",
    "Phone Number": "717-540-7867",
    "address": "Best Line Equipment 6700 ALLENTOWN BLVD, Harrisburg, Pennsylvania 17112",
    "city": "Harrisburg",
    "state": "Pennsylvania",
    "zip": "17112",
    "lat": 40.327549,
    "lng": -76.77031099999999
  },
  {
    "Store Location": "R C Engine Repair 7202 Anthony Hwy Waynesboro, Pennsylvania 17268",
    "Store Type": "R C Engine Repair",
    "Phone Number": "717-762-5020",
    "address": "R C Engine Repair 7202 Anthony Hwy, Waynesboro, Pennsylvania 17268",
    "city": "Waynesboro",
    "state": "Pennsylvania",
    "zip": "17268",
    "lat": 39.8237637,
    "lng": -77.57172210000002
  },
  {
    "Store Location": "EQUIPMENT RENTAL 20 YOUNT DR. MIFFLINBURG, Pennsylvania 17844",
    "Store Type": "EQUIPMENT RENTAL",
    "Phone Number": "570-966-1993",
    "address": "EQUIPMENT RENTAL 20 YOUNT DR., MIFFLINBURG, Pennsylvania 17844",
    "city": "MIFFLINBURG",
    "state": "Pennsylvania",
    "zip": "17844",
    "lat": 40.917582,
    "lng": -77.0477501
  },
  {
    "Store Location": "EQUIPMENT RENTAL 20 FREEDOM ROAD MIFFLINBURG, Pennsylvania 17844",
    "Store Type": "EQUIPMENT RENTAL",
    "Phone Number": "570-966-1993",
    "address": "EQUIPMENT RENTAL 20 FREEDOM ROAD, MIFFLINBURG, Pennsylvania 17844",
    "city": "MIFFLINBURG",
    "state": "Pennsylvania",
    "zip": "17844",
    "lat": 40.9274657,
    "lng": -77.0203416
  },
  {
    "Store Location": "Albrights Hardware & Garden Center Inc 2119 Walbert Ave Allentown, Pennsylvania 18104",
    "Store Type": "Albrights Hardware & Garden Center Inc",
    "Phone Number": "610-433-3831",
    "address": "Albrights Hardware & Garden Center Inc 2119 Walbert Ave, Allentown, Pennsylvania 18104",
    "city": "Allentown",
    "state": "Pennsylvania",
    "zip": "18104",
    "lat": 40.6174306,
    "lng": -75.5123584
  },
  {
    "Store Location": "M & S TRUE VALUE HARDWARE 10 W. BROAD ST. TAMAQUA, Pennsylvania 18252",
    "Store Type": "M & S TRUE VALUE HARDWARE",
    "Phone Number": "570-668-3838",
    "address": "M & S TRUE VALUE HARDWARE 10 W. BROAD ST., TAMAQUA, Pennsylvania 18252",
    "city": "TAMAQUA",
    "state": "Pennsylvania",
    "zip": "18252",
    "lat": 40.7969443,
    "lng": -75.9702866
  },
  {
    "Store Location": "Stroudsburg Electric Motor Service 756 Phillips St Stroudsburg , Pennsylvania 18360",
    "Store Type": "Stroudsburg Electric Motor Service",
    "Phone Number": "570-421-8909",
    "address": "Stroudsburg Electric Motor Service 756 Phillips St, Stroudsburg, Pennsylvania 18360",
    "city": "Stroudsburg",
    "state": "Pennsylvania",
    "zip": "18360",
    "lat": 40.9910998,
    "lng": -75.2004433
  },
  {
    "Store Location": "Honesdale Agway 35 Brown St. Honesdale, Pennsylvania 18431",
    "Store Type": "Honesdale Agway",
    "Phone Number": "570-253-3890",
    "address": "Honesdale Agway 35 Brown St., Honesdale, Pennsylvania 18431",
    "city": "Honesdale",
    "state": "Pennsylvania",
    "zip": "18431",
    "lat": 41.5611682,
    "lng": -75.247587
  },
  {
    "Store Location": "Pro Tool Repair 1550 DICKSON AVE SCRANTON, Pennsylvania 18509",
    "Store Type": "Pro Tool Repair",
    "Phone Number": "570-961-5163",
    "address": "Pro Tool Repair 1550 DICKSON AVE, SCRANTON, Pennsylvania 18509",
    "city": "SCRANTON",
    "state": "Pennsylvania",
    "zip": "18509",
    "lat": 41.4292936,
    "lng": -75.65302199999999
  },
  {
    "Store Location": "Dushore Agway 112 Headley Ave Dushore, Pennsylvania 18614",
    "Store Type": "Dushore Agway",
    "Phone Number": "570-928-8228",
    "address": "Dushore Agway 112 Headley Ave, Dushore, Pennsylvania 18614",
    "city": "Dushore",
    "state": "Pennsylvania",
    "zip": "18614",
    "lat": 41.5247106,
    "lng": -76.3986646
  },
  {
    "Store Location": "Pro Fix Sales & Service 136 Narrows Road Route 11 Larksville, Pennsylvania 18651",
    "Store Type": "Pro Fix Sales & Service",
    "Phone Number": "570-288-0476",
    "address": "Pro Fix Sales & Service 136 Narrows Road Route 11, Larksville, Pennsylvania 18651",
    "city": "Larksville",
    "state": "Pennsylvania",
    "zip": "18651",
    "lat": 41.2521491,
    "lng": -75.91440879999999
  },
  {
    "Store Location": "Hydraulic Industrial Supplies Co. 300 E Madison Ave Clifton Heights, Pennsylvania 19018",
    "Store Type": "Hydraulic Industrial Supplies Co.",
    "Phone Number": "610-284-2100",
    "address": "Hydraulic Industrial Supplies Co. 300 E Madison Ave Clifton, Heights, Pennsylvania 19018",
    "city": "Heights",
    "state": "Pennsylvania",
    "zip": "19018",
    "lat": 39.9288363,
    "lng": -75.2881912
  },
  {
    "Store Location": "SOUTHERN MARYLAND OUTDOOR POWER EQUIPMENT INC 11822 Pika Dr. Waldorf, Maryland 20602",
    "Store Type": "SOUTHERN MARYLAND OUTDOOR POWER EQUIPMENT INC",
    "Phone Number": "301-396-3989",
    "address": "SOUTHERN MARYLAND OUTDOOR POWER EQUIPMENT INC 11822 Pika Dr., Waldorf, Maryland 20602",
    "city": "Waldorf",
    "state": "Maryland",
    "zip": "20602",
    "lat": 38.620967,
    "lng": -76.909105
  },
  {
    "Store Location": "Hemp's Power Tool Repair Inc 13407 Graceham Rd Thurmont, Maryland 21788",
    "Store Type": "Hemp's Power Tool Repair Inc",
    "Phone Number": "301-271-3610",
    "address": "Hemp's Power Tool Repair Inc 13407 Graceham Rd, Thurmont, Maryland 21788",
    "city": "Thurmont",
    "state": "Maryland",
    "zip": "21788",
    "lat": 39.6044921,
    "lng": -77.37393949999999
  },
  {
    "Store Location": "D & P Rental (kerosene only) 711 Belair Ave Front Royal, Virginia 22630",
    "Store Type": "D & P Rental (kerosene only)",
    "Phone Number": "540-635-3789",
    "address": "D & P Rental (kerosene only) 711 Belair Ave Front, Royal, Virginia 22630",
    "city": "Royal",
    "state": "Virginia",
    "zip": "22630",
    "lat": 38.929375,
    "lng": -78.18620899999999
  },
  {
    "Store Location": "Bottoms Bridge Tire & Auto 3025 Pochahontas Trail Quinton, Virginia 23141",
    "Store Type": "Bottoms Bridge Tire & Auto",
    "Phone Number": "804-932-9919",
    "address": "Bottoms Bridge Tire & Auto 3025 Pochahontas Trail, Quinton, Virginia 23141",
    "city": "Quinton",
    "state": "Virginia",
    "zip": "23141",
    "lat": 37.4972192,
    "lng": -77.1749243
  },
  {
    "Store Location": "Augusta Coop Farm Bureau Inc 1205 B Richmond Rd Stunton, Virginia 24401",
    "Store Type": "Augusta Coop Farm Bureau Inc",
    "Phone Number": "540-885-1265",
    "address": "Augusta Coop Farm Bureau Inc 1205 B Richmond Rd, Stunton, Virginia 24401",
    "city": "Stunton",
    "state": "Virginia",
    "zip": "24401",
    "lat": 38.1347367,
    "lng": -79.0425668
  },
  {
    "Store Location": "Larry's Pneumatic Service 100 Princeton Ave Blue Field, West Virginia 24701",
    "Store Type": "Larry's Pneumatic Service",
    "Phone Number": "304-325-9262",
    "address": "Larry's Pneumatic Service 100 Princeton Ave Blue, Field, West Virginia 24701",
    "city": "Field",
    "state": "West Virginia",
    "zip": "24701",
    "lat": 37.26831130000001,
    "lng": -81.22615689999999
  },
  {
    "Store Location": "FM Pile Hardware Co 1625 W Washington St Charleston, West Virginia 25312",
    "Store Type": "FM Pile Hardware Co",
    "Phone Number": "304-343-7578",
    "address": "FM Pile Hardware Co 1625 W Washington St, Charleston, West Virginia 25312",
    "city": "Charleston",
    "state": "West Virginia",
    "zip": "25312",
    "lat": 38.3723336,
    "lng": -81.6620037
  },
  {
    "Store Location": "Ace Hardware Arcadia 8201 N NC Hwy 150 Clemmons, North Carolina 27012",
    "Store Type": "Ace Hardware Arcadia",
    "Phone Number": "336-775-2775",
    "address": "Ace Hardware Arcadia 8201 N NC Hwy 150, Clemmons, North Carolina 27012",
    "city": "Clemmons",
    "state": "North Carolina",
    "zip": "27012",
    "lat": 35.9495443,
    "lng": -80.3064054
  },
  {
    "Store Location": "General Motor Repair & Service INC 2206 Westbrook St Greensboro, North Carolina 27407",
    "Store Type": "General Motor Repair & Service INC",
    "Phone Number": "336-292-1715",
    "address": "General Motor Repair & Service INC 2206 Westbrook St, Greensboro, North Carolina 27407",
    "city": "Greensboro",
    "state": "North Carolina",
    "zip": "27407",
    "lat": 36.0584443,
    "lng": -79.82960709999999
  },
  {
    "Store Location": "McLamb's LP Gas & Supply CO INC 3469 NC 242 South Benson, North Carolina 27504",
    "Store Type": "McLamb's LP Gas & Supply CO INC",
    "Phone Number": "919-894-3842",
    "address": "McLamb's LP Gas & Supply CO INC 3469 NC 242 South, Benson, North Carolina 27504",
    "city": "Benson",
    "state": "North Carolina",
    "zip": "27504",
    "lat": 35.3259164,
    "lng": -78.51974179999999
  },
  {
    "Store Location": "J & S Tool Repair 1309 Hodges St. Raleigh, North Carolina 27604",
    "Store Type": "J & S Tool Repair",
    "Phone Number": "919-856-0050",
    "address": "J & S Tool Repair 1309 Hodges St., Raleigh, North Carolina 27604",
    "city": "Raleigh",
    "state": "North Carolina",
    "zip": "27604",
    "lat": 35.8136383,
    "lng": -78.6151632
  },
  {
    "Store Location": "Thomas Outdoor Power 6191 Gum Branch Rd Jacksonville, North Carolina 28540",
    "Store Type": "Thomas Outdoor Power",
    "Phone Number": "910-324-7580",
    "address": "Thomas Outdoor Power 6191 Gum Branch Rd, Jacksonville, North Carolina 28540",
    "city": "Jacksonville",
    "state": "North Carolina",
    "zip": "28540",
    "lat": 34.8695775,
    "lng": -77.49611759999999
  },
  {
    "Store Location": "S & P RENTAL 259 GRAYSON HWY. LAWRENCEVILLE, Georgia 30045",
    "Store Type": "S & P RENTAL",
    "Phone Number": "770-963-0392",
    "address": "S & P RENTAL 259 GRAYSON HWY., LAWRENCEVILLE, Georgia 30045",
    "city": "LAWRENCEVILLE",
    "state": "Georgia",
    "zip": "30045",
    "lat": 33.9451182,
    "lng": -83.9855108
  },
  {
    "Store Location": "Total Tools 266 Sailors Dr. #1 Ellijay, Georgia 30540",
    "Store Type": "Total Tools",
    "Phone Number": "706-276-3141",
    "address": "Total Tools 266 Sailors Dr. #1, Ellijay, Georgia 30540",
    "city": "Ellijay",
    "state": "Georgia",
    "zip": "30540",
    "lat": 34.6917247,
    "lng": -84.4816337
  },
  {
    "Store Location": "Martin Tool Repair 141 COMMERCE COURT Pelham, Alabama 35124",
    "Store Type": "Martin Tool Repair",
    "Phone Number": "205-733-9292",
    "address": "Martin Tool Repair 141 COMMERCE COURT, Pelham, Alabama 35124",
    "city": "Pelham",
    "state": "Alabama",
    "zip": "35124",
    "lat": 33.3299062,
    "lng": -86.79468740000002
  },
  {
    "Store Location": "Boligee Electric 215 Boligee St Eutaw, Alabama 35462",
    "Store Type": "Boligee Electric",
    "Phone Number": "205-372-9733",
    "address": "Boligee Electric 215 Boligee St, Eutaw, Alabama 35462",
    "city": "Eutaw",
    "state": "Alabama",
    "zip": "35462",
    "lat": 32.8400476,
    "lng": -87.88878919999999
  },
  {
    "Store Location": "SCOTT MEDZI 28109 MITCHELL LOOP ARDMORE, Alabama 35739",
    "Store Type": "SCOTT MEDZI",
    "Phone Number": "256-423-2328",
    "address": "SCOTT MEDZI 28109 MITCHELL LOOP, ARDMORE, Alabama 35739",
    "city": "ARDMORE",
    "state": "Alabama",
    "zip": "35739",
    "lat": 34.9530109,
    "lng": -86.81743519999999
  },
  {
    "Store Location": "Buddy's Small Engine INC 2500 Triana Blvd SW Huntsville, Alabama 35805",
    "Store Type": "Buddy's Small Engine INC",
    "Phone Number": "256-536-9404",
    "address": "Buddy's Small Engine INC 2500 Triana Blvd SW, Huntsville, Alabama 35805",
    "city": "Huntsville",
    "state": "Alabama",
    "zip": "35805",
    "lat": 34.7143216,
    "lng": -86.6096336
  },
  {
    "Store Location": "A & O GENERAL REPAIR 1470 OPELIKA RD. AUBURN, Alabama 36830",
    "Store Type": "A & O GENERAL REPAIR",
    "Phone Number": "334-821-7022",
    "address": "A & O GENERAL REPAIR 1470 OPELIKA RD., AUBURN, Alabama 36830",
    "city": "AUBURN",
    "state": "Alabama",
    "zip": "36830",
    "lat": 32.6229375,
    "lng": -85.4496515
  },
  {
    "Store Location": "UNDERWOOD REPAIR SERVICE INC. 1706 ANTIOCH PIKE ANTIOCH, Tennessee 37013",
    "Store Type": "UNDERWOOD REPAIR SERVICE INC.",
    "Phone Number": "615-833-2022",
    "address": "UNDERWOOD REPAIR SERVICE INC. 1706 ANTIOCH PIKE, ANTIOCH, Tennessee 37013",
    "city": "ANTIOCH",
    "state": "Tennessee",
    "zip": "37013",
    "lat": 36.0716193,
    "lng": -86.6830359
  },
  {
    "Store Location": "Bruce's Small Engine 146 Rippy Ridge Rd Normandy, Tennessee 37360",
    "Store Type": "Bruce's Small Engine",
    "Phone Number": "931-857-3673",
    "address": "Bruce's Small Engine 146 Rippy Ridge Rd, Normandy, Tennessee 37360",
    "city": "Normandy",
    "state": "Tennessee",
    "zip": "37360",
    "lat": 35.4506482,
    "lng": -86.2765493
  },
  {
    "Store Location": "S & S Powersports 208 E Old Andrew Johnson HWY Jeffereson City, Tennessee 37760",
    "Store Type": "S & S Powersports",
    "Phone Number": "865-475-6294",
    "address": "S & S Powersports 208 E Old Andrew Johnson HWY Jeffereson, City, Tennessee 37760",
    "city": "City",
    "state": "Tennessee",
    "zip": "37760",
    "lat": 36.12888969999999,
    "lng": -83.4840586
  },
  {
    "Store Location": "FAIRDALE HARDWARE DO IT BEST 401 FAIRDALE RD LOUISVILLE, Kentucky 40118",
    "Store Type": "FAIRDALE HARDWARE DO IT BEST",
    "Phone Number": "502-366-7444",
    "address": "FAIRDALE HARDWARE DO IT BEST 401 FAIRDALE RD, LOUISVILLE, Kentucky 40118",
    "city": "LOUISVILLE",
    "state": "Kentucky",
    "zip": "40118",
    "lat": 38.1052798,
    "lng": -85.7587422
  },
  {
    "Store Location": "BULLOCK CYCLE & REPAIR 2385 5TH ST. CORBIN, Kentucky 40701",
    "Store Type": "BULLOCK CYCLE & REPAIR",
    "Phone Number": "606-528-1275",
    "address": "BULLOCK CYCLE & REPAIR 2385 5TH ST., CORBIN, Kentucky 40701",
    "city": "CORBIN",
    "state": "Kentucky",
    "zip": "40701",
    "lat": 36.9352346,
    "lng": -84.13020279999999
  },
  {
    "Store Location": "Roman's Repair Center 1521 Old Louisville Rd. Bowling Green, Kentucky 42101",
    "Store Type": "Roman's Repair Center",
    "Phone Number": "270-746-0857",
    "address": "Roman's Repair Center 1521 Old Louisville Rd. Bowling, Green, Kentucky 42101",
    "city": "Green",
    "state": "Kentucky",
    "zip": "42101",
    "lat": 37.00446670000001,
    "lng": -86.42290190000001
  },
  {
    "Store Location": "Fayette Power Equipment 1442 Meadow Dr Washington Courthouse, Ohio 43160",
    "Store Type": "Fayette Power Equipment",
    "Phone Number": "740-333-3063",
    "address": "Fayette Power Equipment 1442 Meadow Dr Washington, Courthouse, Ohio 43160",
    "city": "Courthouse",
    "state": "Ohio",
    "zip": "43160",
    "lat": 39.5547756,
    "lng": -83.4449552
  },
  {
    "Store Location": "Denny's Mower Repair &More 36466 Sugar Ridge Rd North Ridgeville, Ohio 44039",
    "Store Type": "Denny's Mower Repair &More",
    "Phone Number": "440-327-1412",
    "address": "Denny's Mower Repair &More 36466 Sugar Ridge Rd North, Ridgeville, Ohio 44039",
    "city": "Ridgeville",
    "state": "Ohio",
    "zip": "44039",
    "lat": 41.3728855,
    "lng": -82.0250827
  },
  {
    "Store Location": "Fox's Lawn Care & Small Engine 24034 Smith Rd Wellington, Ohio 44090",
    "Store Type": "Fox's Lawn Care & Small Engine",
    "Phone Number": "440-213-1372",
    "address": "Fox's Lawn Care & Small Engine 24034 Smith Rd, Wellington, Ohio 44090",
    "city": "Wellington",
    "state": "Ohio",
    "zip": "44090",
    "lat": 41.1466237,
    "lng": -82.1823722
  },
  {
    "Store Location": "Torpedo Heat 14841 Elderwood Suite 302 East Cleveland, Ohio 44112",
    "Store Type": "Torpedo Heat",
    "Phone Number": "877-736-6230",
    "address": "Torpedo Heat 14841 Elderwood Suite 302 East, Cleveland, Ohio 44112",
    "city": "Cleveland",
    "state": "Ohio",
    "zip": "44112",
    "lat": 41.5358577,
    "lng": -81.5795138
  },
  {
    "Store Location": "Canon's Lawn & Garden 7924 Warren Sharon Rd Brookfield, Ohio 44403",
    "Store Type": "Canon's Lawn & Garden",
    "Phone Number": "330-448-4222",
    "address": "Canon's Lawn & Garden 7924 Warren Sharon Rd, Brookfield, Ohio 44403",
    "city": "Brookfield",
    "state": "Ohio",
    "zip": "44403",
    "lat": 41.234677,
    "lng": -80.532038
  },
  {
    "Store Location": "Hilltop & Garden INC 39821 S.R. 14 Columbiana, Ohio 44408",
    "Store Type": "Hilltop & Garden INC",
    "Phone Number": "330-427-1220",
    "address": "Hilltop & Garden INC 39821 S.R. 14, Columbiana, Ohio 44408",
    "city": "Columbiana",
    "state": "Ohio",
    "zip": "44408",
    "lat": 40.888295,
    "lng": -80.6706768
  },
  {
    "Store Location": "Power Tool & Supply Co Inc 3699 Le Harps Rd Youngstown, Ohio 44515",
    "Store Type": "Power Tool & Supply Co Inc",
    "Phone Number": "330-792-1487",
    "address": "Power Tool & Supply Co Inc 3699 Le Harps Rd, Youngstown, Ohio 44515",
    "city": "Youngstown",
    "state": "Ohio",
    "zip": "44515",
    "lat": 41.1198098,
    "lng": -80.7154783
  },
  {
    "Store Location": "STOLLER LAWN & GARDEN 10355 BACK ORVILLE RD. ORVILLE, Ohio 44667",
    "Store Type": "STOLLER LAWN & GARDEN",
    "Phone Number": "330-682-7436",
    "address": "STOLLER LAWN & GARDEN 10355 BACK ORVILLE RD., ORVILLE, Ohio 44667",
    "city": "ORVILLE",
    "state": "Ohio",
    "zip": "44667",
    "lat": 40.82919529999999,
    "lng": -81.7914339
  },
  {
    "Store Location": "Garys Equipment LTD 9673 E State Route 162 Republic, Ohio 44867",
    "Store Type": "Garys Equipment LTD",
    "Phone Number": "419-585-5391",
    "address": "Garys Equipment LTD 9673 E State Route 162, Republic, Ohio 44867",
    "city": "Republic",
    "state": "Ohio",
    "zip": "44867",
    "lat": 41.1252431,
    "lng": -82.98277949999999
  },
  {
    "Store Location": "The Tool House 11949 Reading Rd Sharonville, Ohio 45241",
    "Store Type": "The Tool House",
    "Phone Number": "513-821-3000",
    "address": "The Tool House 11949 Reading Rd, Sharonville, Ohio 45241",
    "city": "Sharonville",
    "state": "Ohio",
    "zip": "45241",
    "lat": 39.29184,
    "lng": -84.4101088
  },
  {
    "Store Location": "Eskew Enterprises 1447 N Harding Street Indianapolis, Indiana 46202",
    "Store Type": "Eskew Enterprises",
    "Phone Number": "317-264-9028",
    "address": "Eskew Enterprises 1447 N Harding Street, Indianapolis, Indiana 46202",
    "city": "Indianapolis",
    "state": "Indiana",
    "zip": "46202",
    "lat": 39.7867957,
    "lng": -86.186976
  },
  {
    "Store Location": "Quality Supply & Tool Repair 5722 S Harding Street Indianapolis, Indiana 46217",
    "Store Type": "Quality Supply & Tool Repair",
    "Phone Number": "327-786-0042",
    "address": "Quality Supply & Tool Repair 5722 S Harding Street, Indianapolis, Indiana 46217",
    "city": "Indianapolis",
    "state": "Indiana",
    "zip": "46217",
    "lat": 39.6823673,
    "lng": -86.1877971
  },
  {
    "Store Location": "R & C SMALL ENGINE 13630 WICKER AVE. CEDAR LAKE, Indiana 46303",
    "Store Type": "R & C SMALL ENGINE",
    "Phone Number": "219-374-9660",
    "address": "R & C SMALL ENGINE 13630 WICKER AVE. CEDAR, LAKE, Indiana 46303",
    "city": "LAKE",
    "state": "Indiana",
    "zip": "46303",
    "lat": 41.3697467,
    "lng": -87.4707428
  },
  {
    "Store Location": "GRIFFITH RENTALS 130 S.BROAD ST. GRIFFITH, Indiana 46319",
    "Store Type": "GRIFFITH RENTALS",
    "Phone Number": "219-924-8720",
    "address": "GRIFFITH RENTALS 130 S.BROAD ST., GRIFFITH, Indiana 46319",
    "city": "GRIFFITH",
    "state": "Indiana",
    "zip": "46319",
    "lat": 41.5215507,
    "lng": -87.4281053
  },
  {
    "Store Location": "Big R Warsaw 3660 Commerce Dr Warsaw, Indiana 46580",
    "Store Type": "Big R Warsaw",
    "Phone Number": "574-269-9303",
    "address": "Big R Warsaw 3660 Commerce Dr, Warsaw, Indiana 46580",
    "city": "Warsaw",
    "state": "Indiana",
    "zip": "46580",
    "lat": 41.2291924,
    "lng": -85.8026974
  },
  {
    "Store Location": "Circle S Corp 1321 Goshen Ave Fort Wayne, Indiana 46808",
    "Store Type": "Circle S Corp",
    "Phone Number": "260-483-8141",
    "address": "Circle S Corp 1321 Goshen Ave Fort, Wayne, Indiana 46808",
    "city": "Wayne",
    "state": "Indiana",
    "zip": "46808",
    "lat": 41.1012528,
    "lng": -85.1595521
  },
  {
    "Store Location": "Big R Marion 1401 W 26th St Marion, Indiana 46953",
    "Store Type": "Big R Marion",
    "Phone Number": "765-662-9163",
    "address": "Big R Marion 1401 W 26th St, Marion, Indiana 46953",
    "city": "Marion",
    "state": "Indiana",
    "zip": "46953",
    "lat": 40.5373018,
    "lng": -85.67638439999999
  },
  {
    "Store Location": "Big R Wabash 1550 N Cass St Wabash, Indiana 46992",
    "Store Type": "Big R Wabash",
    "Phone Number": "260-569-6700",
    "address": "Big R Wabash 1550 N Cass St, Wabash, Indiana 46992",
    "city": "Wabash",
    "state": "Indiana",
    "zip": "46992",
    "lat": 40.815788,
    "lng": -85.8410913
  },
  {
    "Store Location": "Andersons Sales and Service 2914 Clifty Dr Madison, Indiana 47250",
    "Store Type": "Andersons Sales and Service",
    "Phone Number": "812-273-4262",
    "address": "Andersons Sales and Service 2914 Clifty Dr, Madison, Indiana 47250",
    "city": "Madison",
    "state": "Indiana",
    "zip": "47250",
    "lat": 38.7607878,
    "lng": -85.4513374
  },
  {
    "Store Location": "General Rental Center INC 6 Sullivan Dr Washington, Indiana 47501",
    "Store Type": "General Rental Center INC",
    "Phone Number": "812-254-2707",
    "address": "General Rental Center INC 6 Sullivan Dr, Washington, Indiana 47501",
    "city": "Washington",
    "state": "Indiana",
    "zip": "47501",
    "lat": 38.653678,
    "lng": -87.15199799999999
  },
  {
    "Store Location": "Industrial Tool Sales & Service 712 W 6th St. Jasper, Indiana 47546",
    "Store Type": "Industrial Tool Sales & Service",
    "Phone Number": "812-482-7895",
    "address": "Industrial Tool Sales & Service 712 W 6th St., Jasper, Indiana 47546",
    "city": "Jasper",
    "state": "Indiana",
    "zip": "47546",
    "lat": 38.392184,
    "lng": -86.9395909
  },
  {
    "Store Location": "Mattoon Rural King Supply 2500 Teal Road Lafayette, Indiana 47905",
    "Store Type": "Mattoon Rural King Supply",
    "Phone Number": "765-471-0804",
    "address": "Mattoon Rural King Supply 2500 Teal Road, Lafayette, Indiana 47905",
    "city": "Lafayette",
    "state": "Indiana",
    "zip": "47905",
    "lat": 40.397427,
    "lng": -86.8682961
  },
  {
    "Store Location": "K-1 Service and Solutions LLC - Kerosene Only 201 W. Chestnut St. Chalmers, Indiana 47929",
    "Store Type": "K-1 Service and Solutions LLC - Kerosene Only",
    "Phone Number": "765-714-7510",
    "address": "K-1 Service and Solutions LLC - Kerosene Only 201 W. Chestnut St., Chalmers, Indiana 47929",
    "city": "Chalmers",
    "state": "Indiana",
    "zip": "47929",
    "lat": 40.6599987,
    "lng": -86.8715509
  },
  {
    "Store Location": "Big R Crawfordsville 1601 US 231 South Crawfordsville, Indiana 47933",
    "Store Type": "Big R Crawfordsville",
    "Phone Number": "765-362-0802",
    "address": "Big R Crawfordsville 1601 US 231 South, Crawfordsville, Indiana 47933",
    "city": "Crawfordsville",
    "state": "Indiana",
    "zip": "47933",
    "lat": 40.0163536,
    "lng": -86.9072875
  },
  {
    "Store Location": "Bob's Service Shop 2537 West Drahner Rd Oxford, Michigan 48371",
    "Store Type": "Bob's Service Shop",
    "Phone Number": "248-628-2601",
    "address": "Bob's Service Shop 2537 West Drahner Rd, Oxford, Michigan 48371",
    "city": "Oxford",
    "state": "Michigan",
    "zip": "48371",
    "lat": 42.80697199999999,
    "lng": -83.30837799999999
  },
  {
    "Store Location": "Moe Sales & Service G-3228 Kleinpell St Burton, Michigan 48529",
    "Store Type": "Moe Sales & Service",
    "Phone Number": "810-744-3520",
    "address": "Moe Sales & Service G-3228 Kleinpell St, Burton, Michigan 48529",
    "city": "Burton",
    "state": "Michigan",
    "zip": "48529",
    "lat": 42.9826637,
    "lng": -83.64701869999999
  },
  {
    "Store Location": "Lange & Leaman Electric 2840 Universal Dr. Saginaw, Michigan 48603",
    "Store Type": "Lange & Leaman Electric",
    "Phone Number": "989-497-8620",
    "address": "Lange & Leaman Electric 2840 Universal Dr., Saginaw, Michigan 48603",
    "city": "Saginaw",
    "state": "Michigan",
    "zip": "48603",
    "lat": 43.4592885,
    "lng": -83.97211209999999
  },
  {
    "Store Location": "Joe's Motorcycle Lawn & Garden 2593 N. State Rd. Ionia, Michigan 48846",
    "Store Type": "Joe's Motorcycle Lawn & Garden",
    "Phone Number": "616-527-0985",
    "address": "Joe's Motorcycle Lawn & Garden 2593 N. State Rd., Ionia, Michigan 48846",
    "city": "Ionia",
    "state": "Michigan",
    "zip": "48846",
    "lat": 43.0253047,
    "lng": -85.0756167
  },
  {
    "Store Location": "Joe's Lawn & Garden (Kerosene Heaters only) 1141 26th St Allegan, Michigan 49010",
    "Store Type": "Joe's Lawn & Garden (Kerosene Heaters only)",
    "Phone Number": "269-686-2243",
    "address": "Joe's Lawn & Garden (Kerosene Heaters only) 1141 26th St, Allegan, Michigan 49010",
    "city": "Allegan",
    "state": "Michigan",
    "zip": "49010",
    "lat": 42.5033823,
    "lng": -85.798532
  },
  {
    "Store Location": "M & S Service Co Inc. 1083 Pine Ridge Rd Martin, Michigan 49070",
    "Store Type": "M & S Service Co Inc.",
    "Phone Number": "800-475-5660",
    "address": "M & S Service Co Inc. 1083 Pine Ridge Rd, Martin, Michigan 49070",
    "city": "Martin",
    "state": "Michigan",
    "zip": "49070",
    "lat": 42.5025426,
    "lng": -85.64638280000001
  },
  {
    "Store Location": "State Street Hardware 614 North State St Big Rapids, Michigan 49307",
    "Store Type": "State Street Hardware",
    "Phone Number": "231-796-8122",
    "address": "State Street Hardware 614 North State St Big, Rapids, Michigan 49307",
    "city": "Rapids",
    "state": "Michigan",
    "zip": "49307",
    "lat": 43.70531709999999,
    "lng": -85.4837591
  },
  {
    "Store Location": "WAYLAND OUTDOOR POWER 200 South Commerce St. WAYLAND, Michigan 49348",
    "Store Type": "WAYLAND OUTDOOR POWER",
    "Phone Number": "269-792-9377",
    "address": "WAYLAND OUTDOOR POWER 200 South Commerce St., WAYLAND, Michigan 49348",
    "city": "WAYLAND",
    "state": "Michigan",
    "zip": "49348",
    "lat": 42.67298599999999,
    "lng": -85.65219739999999
  },
  {
    "Store Location": "GEMMENS INC #0356 3488 KELLY ST HUDSONVILLE, Michigan 49426",
    "Store Type": "GEMMENS INC #0356",
    "Phone Number": "616-669-1118",
    "address": "GEMMENS INC #0356 3488 KELLY ST, HUDSONVILLE, Michigan 49426",
    "city": "HUDSONVILLE",
    "state": "Michigan",
    "zip": "49426",
    "lat": 42.8643693,
    "lng": -85.8677227
  },
  {
    "Store Location": "Rentals Unlimited 3100 N Highway 31 South Traverse, Michigan 49684",
    "Store Type": "Rentals Unlimited",
    "Phone Number": "231-941-0311",
    "address": "Rentals Unlimited 3100 N Highway 31 South, Traverse, Michigan 49684",
    "city": "Traverse",
    "state": "Michigan",
    "zip": "49684",
    "lat": 44.6682571,
    "lng": -85.67705880000001
  },
  {
    "Store Location": "McLean's Ace Hardware 209 S. James St. Grayling, Michigan 49738",
    "Store Type": "McLean's Ace Hardware",
    "Phone Number": "989-348-2931",
    "address": "McLean's Ace Hardware 209 S. James St., Grayling, Michigan 49738",
    "city": "Grayling",
    "state": "Michigan",
    "zip": "49738",
    "lat": 44.6582302,
    "lng": -84.7097227
  },
  {
    "Store Location": "Harold's Shop 1887 205th St. Boone, Iowa 50036",
    "Store Type": "Harold's Shop",
    "Phone Number": "515-432-9469",
    "address": "Harold's Shop 1887 205th St., Boone, Iowa 50036",
    "city": "Boone",
    "state": "Iowa",
    "zip": "50036",
    "lat": 42.0567948,
    "lng": -93.7974354
  },
  {
    "Store Location": "Star Equipment 1401 2nd Avenue Des Moines, Iowa 50314",
    "Store Type": "Star Equipment",
    "Phone Number": "515-283-2215",
    "address": "Star Equipment 1401 2nd Avenue Des, Moines, Iowa 50314",
    "city": "Moines",
    "state": "Iowa",
    "zip": "50314",
    "lat": 41.6039659,
    "lng": -93.61920780000001
  },
  {
    "Store Location": "BEALS MOTOR REWINDING 600 W.BEECH CHEROKEE, Iowa 51012",
    "Store Type": "BEALS MOTOR REWINDING",
    "Phone Number": "712-225-6173",
    "address": "BEALS MOTOR REWINDING 600 W.BEECH, CHEROKEE, Iowa 51012",
    "city": "CHEROKEE",
    "state": "Iowa",
    "zip": "51012",
    "lat": 42.7464368,
    "lng": -95.5569076
  },
  {
    "Store Location": "QUICK SERVICE 23830 HACKBERRY RD. COUNCIL BLUFFS, Iowa 51503",
    "Store Type": "QUICK SERVICE",
    "Phone Number": "712-322-2988",
    "address": "QUICK SERVICE 23830 HACKBERRY RD. COUNCIL, BLUFFS, Iowa 51503",
    "city": "BLUFFS",
    "state": "Iowa",
    "zip": "51503",
    "lat": 41.2899675,
    "lng": -95.7305327
  },
  {
    "Store Location": "Southside Repair 903 Franklin St Center Point, Iowa 52213",
    "Store Type": "Southside Repair",
    "Phone Number": "319-849-1373",
    "address": "Southside Repair 903 Franklin St Center, Point, Iowa 52213",
    "city": "Point",
    "state": "Iowa",
    "zip": "52213",
    "lat": 42.1928792,
    "lng": -91.7831709
  },
  {
    "Store Location": "Lockridge Inc 23602 Highway 5 Centerville, Iowa 52544",
    "Store Type": "Lockridge Inc",
    "Phone Number": "641-856-2175",
    "address": "Lockridge Inc 23602 Highway 5, Centerville, Iowa 52544",
    "city": "Centerville",
    "state": "Iowa",
    "zip": "52544",
    "lat": 40.7463237,
    "lng": -93.15288799999999
  },
  {
    "Store Location": "INDUSTRIAL MOTORS, INC. 1711 MT. PLEASANT ST BURLINGTON, 52601",
    "Store Type": "INDUSTRIAL MOTORS, INC.",
    "Phone Number": "319-752-4917",
    "address": "INDUSTRIAL MOTORS, INC. 1711 MT. PLEASANT ST BURLINGTON, ,  52601",
    "city": "Unknown",
    "state": "Unknown",
    "zip": "52601",
    "lat": 40.8246269,
    "lng": -91.1327972
  },
  {
    "Store Location": "Huffman Welding & Machine, Inc 6224 Avenue O Fort Madison , Iowa 52627",
    "Store Type": "Huffman Welding & Machine, Inc",
    "Phone Number": "319-372-7232",
    "address": "Huffman Welding & Machine, Inc 6224 Avenue O Fort Madison, Iowa 52627",
    "city": "Inc 6224 Avenue O Fort Madison",
    "state": "Iowa",
    "zip": "52627",
    "lat": 40.6234461,
    "lng": -91.3991106
  },
  {
    "Store Location": "Northwest Mechanical Inc 5885 Tremont Ave Davenport, Iowa 52807",
    "Store Type": "Northwest Mechanical Inc",
    "Phone Number": "563-391-1344",
    "address": "Northwest Mechanical Inc 5885 Tremont Ave, Davenport, Iowa 52807",
    "city": "Davenport",
    "state": "Iowa",
    "zip": "52807",
    "lat": 41.5803055,
    "lng": -90.55968779999999
  },
  {
    "Store Location": "Chris's Small Engine Repair LLC 1343 Sunnydale Circle West Bend, Wisconsin 53090",
    "Store Type": "Chris's Small Engine Repair LLC",
    "Phone Number": "262-707-4698",
    "address": "Chris's Small Engine Repair LLC 1343 Sunnydale Circle West, Bend, Wisconsin 53090",
    "city": "Bend",
    "state": "Wisconsin",
    "zip": "53090",
    "lat": 43.4381895,
    "lng": -88.1705326
  },
  {
    "Store Location": "Amps Inc 105 COUNTY ROAD 10 Albany, Minnesota 53607",
    "Store Type": "Amps Inc",
    "Phone Number": "320-845-4690",
    "address": "Amps Inc 105 COUNTY ROAD 10, Albany, Minnesota 53607",
    "city": "Albany",
    "state": "Minnesota",
    "zip": "53607",
    "lat": 45.6278419,
    "lng": -94.5825119
  },
  {
    "Store Location": "Staudt Small Engine Service 1923 14th St Two Rivers, Wisconsin 54241",
    "Store Type": "Staudt Small Engine Service",
    "Phone Number": "920-793-3161",
    "address": "Staudt Small Engine Service 1923 14th St Two, Rivers, Wisconsin 54241",
    "city": "Rivers",
    "state": "Wisconsin",
    "zip": "54241",
    "lat": 44.1459999,
    "lng": -87.5758644
  },
  {
    "Store Location": "D & J Farm and Home 201 E. Liberty Dr Thorp, Wisconsin 54771",
    "Store Type": "D & J Farm and Home",
    "Phone Number": "715-669-5349",
    "address": "D & J Farm and Home 201 E. Liberty Dr, Thorp, Wisconsin 54771",
    "city": "Thorp",
    "state": "Wisconsin",
    "zip": "54771",
    "lat": 44.9489194,
    "lng": -90.7977963
  },
  {
    "Store Location": "Braham Hardware & Rental 104 West Central Dr Braham, Minnesota 55006",
    "Store Type": "Braham Hardware & Rental",
    "Phone Number": "320-396-4155",
    "address": "Braham Hardware & Rental 104 West Central Dr, Braham, Minnesota 55006",
    "city": "Braham",
    "state": "Minnesota",
    "zip": "55006",
    "lat": 45.72492949999999,
    "lng": -93.1709611
  },
  {
    "Store Location": "REED'S SALES & SERVICE 1260 PAYNE AVE. ST.PAUL, Minnesota 55101",
    "Store Type": "REED'S SALES & SERVICE",
    "Phone Number": "651-774-9515",
    "address": "REED'S SALES & SERVICE 1260 PAYNE AVE., ST.PAUL, Minnesota 55101",
    "city": "ST.PAUL",
    "state": "Minnesota",
    "zip": "55101",
    "lat": 44.97912789999999,
    "lng": -93.073327
  },
  {
    "Store Location": "Gale Smiths Shop 330 East 2nd Street Litchfield, Minnesota 55355",
    "Store Type": "Gale Smiths Shop",
    "Phone Number": "320-593-8508",
    "address": "Gale Smiths Shop 330 East 2nd Street, Litchfield, Minnesota 55355",
    "city": "Litchfield",
    "state": "Minnesota",
    "zip": "55355",
    "lat": 45.1272524,
    "lng": -94.52232690000001
  },
  {
    "Store Location": "L & M Supply 1200 E. Hwy 169 Grand Rapids, Minnesota 55744",
    "Store Type": "L & M Supply",
    "Phone Number": "218-326-9783",
    "address": "L & M Supply 1200 E. Hwy 169 Grand, Rapids, Minnesota 55744",
    "city": "Rapids",
    "state": "Minnesota",
    "zip": "55744",
    "lat": 47.2360303,
    "lng": -93.5091903
  },
  {
    "Store Location": "C & S SUPPLY CO., INC. 1951 RIVERFRONT DR. MANKATO, Minnesota 56001",
    "Store Type": "C & S SUPPLY CO., INC.",
    "Phone Number": "507-387-1171",
    "address": "C & S SUPPLY CO., INC. 1951 RIVERFRONT DR. MANKATO, Minnesota 56001",
    "city": "INC. 1951 RIVERFRONT DR. MANKATO",
    "state": "Minnesota",
    "zip": "56001",
    "lat": 44.1855051,
    "lng": -93.9846816
  },
  {
    "Store Location": "RUNNING FARM & FLEET 2107 North Garden Street NEW ULM, Minnesota 56073",
    "Store Type": "RUNNING FARM & FLEET",
    "Phone Number": "507-359-2988",
    "address": "RUNNING FARM & FLEET 2107 North Garden Street NEW, ULM, Minnesota 56073",
    "city": "ULM",
    "state": "Minnesota",
    "zip": "56073",
    "lat": 44.33017299999999,
    "lng": -94.4909417
  },
  {
    "Store Location": "FLEET & FARM 1175 11TH ST. ST.JAMES, Minnesota 56081",
    "Store Type": "FLEET & FARM",
    "Phone Number": "507-375-4041",
    "address": "FLEET & FARM 1175 11TH ST., ST.JAMES, Minnesota 56081",
    "city": "ST.JAMES",
    "state": "Minnesota",
    "zip": "56081",
    "lat": 43.9718677,
    "lng": -94.61849459999999
  },
  {
    "Store Location": "Fastlane Repair 129 7th Street Freeport, Minnesota 56331",
    "Store Type": "Fastlane Repair",
    "Phone Number": "320-339-1417",
    "address": "Fastlane Repair 129 7th Street, Freeport, Minnesota 56331",
    "city": "Freeport",
    "state": "Minnesota",
    "zip": "56331",
    "lat": 45.6583614,
    "lng": -94.6928109
  },
  {
    "Store Location": "Thompson's Mechanical Inc. 320 3rd Ave. NW Watertown, South Dakota 57201",
    "Store Type": "Thompson's Mechanical Inc.",
    "Phone Number": "605-886-6162",
    "address": "Thompson's Mechanical Inc. 320 3rd Ave. NW, Watertown, South Dakota 57201",
    "city": "Watertown",
    "state": "South Dakota",
    "zip": "57201",
    "lat": 44.90427200000001,
    "lng": -97.119355
  },
  {
    "Store Location": "Rogers Electric Motor Service 205 East 22nd Ave Milbank, South Dakota 57252",
    "Store Type": "Rogers Electric Motor Service",
    "Phone Number": "605-432-4840",
    "address": "Rogers Electric Motor Service 205 East 22nd Ave, Milbank, South Dakota 57252",
    "city": "Milbank",
    "state": "South Dakota",
    "zip": "57252",
    "lat": 45.2189724,
    "lng": -96.6408445
  },
  {
    "Store Location": "HOME OF ECONOMY 1508 N. WASHINGTON GRAND FORKS , North Dakota 58203",
    "Store Type": "HOME OF ECONOMY",
    "Phone Number": "701-795-3564",
    "address": "HOME OF ECONOMY 1508 N. WASHINGTON GRAND, FORKS, North Dakota 58203",
    "city": "FORKS",
    "state": "North Dakota",
    "zip": "58203",
    "lat": 47.9350941,
    "lng": -97.053156
  },
  {
    "Store Location": "ALLEN'S TOOL REPAIR, INC. 115 5TH ST.WEST BILLINGS, Montana 59101",
    "Store Type": "ALLEN'S TOOL REPAIR, INC.",
    "Phone Number": "406-248-3865",
    "address": "ALLEN'S TOOL REPAIR, INC. 115 5TH ST.WEST BILLINGS, Montana 59101",
    "city": "INC. 115 5TH ST.WEST BILLINGS",
    "state": "Montana",
    "zip": "59101",
    "lat": 45.771789,
    "lng": -108.5260726
  },
  {
    "Store Location": "BIG SKY POWER 1301 3RD ST. NW GREAT FALLS, Montana 59404",
    "Store Type": "BIG SKY POWER",
    "Phone Number": "406-761-6688",
    "address": "BIG SKY POWER 1301 3RD ST. NW GREAT, FALLS, Montana 59404",
    "city": "FALLS",
    "state": "Montana",
    "zip": "59404",
    "lat": 47.5191964,
    "lng": -111.3089739
  },
  {
    "Store Location": "Western Trailer & Marine Sales 1865 Highway 2 East Havre, Montana 59501",
    "Store Type": "Western Trailer & Marine Sales",
    "Phone Number": "406-265-4572",
    "address": "Western Trailer & Marine Sales 1865 Highway 2 East, Havre, Montana 59501",
    "city": "Havre",
    "state": "Montana",
    "zip": "59501",
    "lat": 48.5560514,
    "lng": -109.6557378
  },
  {
    "Store Location": "Tri-City Mainenance & Repair Inc 40 W 165 Fadyan Pkwy Elburn, Illinois 60119",
    "Store Type": "Tri-City Mainenance & Repair Inc",
    "Phone Number": "630-262-8296",
    "address": "Tri-City Mainenance & Repair Inc 40 W 165 Fadyan Pkwy, Elburn, Illinois 60119",
    "city": "Elburn",
    "state": "Illinois",
    "zip": "60119",
    "lat": 41.85118019999999,
    "lng": -88.397582
  },
  {
    "Store Location": "Big R Morris 2655 Sycamore Dr Morris, Illinois 60450",
    "Store Type": "Big R Morris",
    "Phone Number": "815-942-2153",
    "address": "Big R Morris 2655 Sycamore Dr, Morris, Illinois 60450",
    "city": "Morris",
    "state": "Illinois",
    "zip": "60450",
    "lat": 41.3853626,
    "lng": -88.4241157
  },
  {
    "Store Location": "Farm King - Monmouth 2101 US Hwy 67 Monmouth, Illinois 61462",
    "Store Type": "Farm King - Monmouth",
    "Phone Number": "309-734-9421",
    "address": "Farm King - Monmouth 2101 US Hwy 67, Monmouth, Illinois 61462",
    "city": "Monmouth",
    "state": "Illinois",
    "zip": "61462",
    "lat": 40.9361961,
    "lng": -90.6470755
  },
  {
    "Store Location": "Big R Pontiac 1027 W Reynolds Pontiac, Illinois 61764",
    "Store Type": "Big R Pontiac",
    "Phone Number": "815-844-7000",
    "address": "Big R Pontiac 1027 W Reynolds, Pontiac, Illinois 61764",
    "city": "Pontiac",
    "state": "Illinois",
    "zip": "61764",
    "lat": 40.8749034,
    "lng": -88.6461044
  },
  {
    "Store Location": "Big R Rental - Danville 217 S Bowman Ave Danville, Illinois 61832",
    "Store Type": "Big R Rental - Danville",
    "Phone Number": "217-442-7353",
    "address": "Big R Rental - Danville 217 S Bowman Ave, Danville, Illinois 61832",
    "city": "Danville",
    "state": "Illinois",
    "zip": "61832",
    "lat": 40.1217293,
    "lng": -87.60999559999999
  },
  {
    "Store Location": "Big R Danville 3363 N Vermillion St Danville, Illinois 61832",
    "Store Type": "Big R Danville",
    "Phone Number": "217-442-5800",
    "address": "Big R Danville 3363 N Vermillion St, Danville, Illinois 61832",
    "city": "Danville",
    "state": "Illinois",
    "zip": "61832",
    "lat": 40.1771689,
    "lng": -87.62712180000001
  },
  {
    "Store Location": "Big R Tilton 1625 S Georgetown Rd Tilton, Illinois 61833",
    "Store Type": "Big R Tilton",
    "Phone Number": "217-446-0800",
    "address": "Big R Tilton 1625 S Georgetown Rd, Tilton, Illinois 61833",
    "city": "Tilton",
    "state": "Illinois",
    "zip": "61833",
    "lat": 40.021672,
    "lng": -87.63746239999999
  },
  {
    "Store Location": "Thompson's Gas Co. 1431 N. Illinois St. Swansea, Illinois 62226",
    "Store Type": "Thompson's Gas Co.",
    "Phone Number": "618-233-6541",
    "address": "Thompson's Gas Co. 1431 N. Illinois St., Swansea, Illinois 62226",
    "city": "Swansea",
    "state": "Illinois",
    "zip": "62226",
    "lat": 38.5287296,
    "lng": -89.9847408
  },
  {
    "Store Location": "D-Low 115 Church Street O'Fallon, Missouri 63366",
    "Store Type": "D-Low",
    "Phone Number": "636-978-7513",
    "address": "D-Low 115 Church Street, O'Fallon, Missouri 63366",
    "city": "O'Fallon",
    "state": "Missouri",
    "zip": "63366",
    "lat": 38.808909,
    "lng": -90.7013542
  },
  {
    "Store Location": "Orscheln Farm and Home 314 East Hwy 24 Mobley, Missouri 65270",
    "Store Type": "Orscheln Farm and Home",
    "Phone Number": "660-263-3987",
    "address": "Orscheln Farm and Home 314 East Hwy 24, Mobley, Missouri 65270",
    "city": "Mobley",
    "state": "Missouri",
    "zip": "65270",
    "lat": 39.443372,
    "lng": -92.4319051
  },
  {
    "Store Location": "ABILENE RENT ALL & SALES 1701 W. FIRST ABILENE, Kansas 67410",
    "Store Type": "ABILENE RENT ALL & SALES",
    "Phone Number": "785-263-7668",
    "address": "ABILENE RENT ALL & SALES 1701 W. FIRST, ABILENE, Kansas 67410",
    "city": "ABILENE",
    "state": "Kansas",
    "zip": "67410",
    "lat": 38.9149202,
    "lng": -97.2423613
  },
  {
    "Store Location": "Morris Electric & Repair 2423 5th Street Great Bend, Kansas 67530",
    "Store Type": "Morris Electric & Repair",
    "Phone Number": "620-792-2919",
    "address": "Morris Electric & Repair 2423 5th Street Great, Bend, Kansas 67530",
    "city": "Bend",
    "state": "Kansas",
    "zip": "67530",
    "lat": 38.3558206,
    "lng": -98.77076720000001
  },
  {
    "Store Location": "PLATTE VALLEY EQUIPMENT 2263 BUSINESS PARK DR FREMONT, Nebraska 68026",
    "Store Type": "PLATTE VALLEY EQUIPMENT",
    "Phone Number": "402-721-9111",
    "address": "PLATTE VALLEY EQUIPMENT 2263 BUSINESS PARK DR, FREMONT, Nebraska 68026",
    "city": "FREMONT",
    "state": "Nebraska",
    "zip": "68026",
    "lat": 41.4505923,
    "lng": -96.53736459999999
  },
  {
    "Store Location": "TIGHTON FASTENER AND SUPPLY CORPORATION 7820 L STREET OMAHA, Nebraska 68127",
    "Store Type": "TIGHTON FASTENER AND SUPPLY CORPORATION",
    "Phone Number": "402-331-5550",
    "address": "TIGHTON FASTENER AND SUPPLY CORPORATION 7820 L STREET, OMAHA, Nebraska 68127",
    "city": "OMAHA",
    "state": "Nebraska",
    "zip": "68127",
    "lat": 41.21342509999999,
    "lng": -96.0362401
  },
  {
    "Store Location": "Powerhouse Distributing, LLC 11011 I Street Omaha, Nebraska 68137",
    "Store Type": "Powerhouse Distributing, LLC",
    "Phone Number": "402-715-5999",
    "address": "Powerhouse Distributing, LLC 11011 I Street Omaha, Nebraska 68137",
    "city": "LLC 11011 I Street Omaha",
    "state": "Nebraska",
    "zip": "68137",
    "lat": 41.2158419,
    "lng": -96.0847587
  },
  {
    "Store Location": "J & J REPAIR 66025 705 Trail RULO, Nebraska 68431",
    "Store Type": "J & J REPAIR",
    "Phone Number": "402-245-4734",
    "address": "J & J REPAIR 66025 705 Trail, RULO, Nebraska 68431",
    "city": "RULO",
    "state": "Nebraska",
    "zip": "68431",
    "lat": 40.0471771,
    "lng": -95.4401086
  },
  {
    "Store Location": "HASS REPAIR 1238 1ST RD. WISNER, Nebraska 68791",
    "Store Type": "HASS REPAIR",
    "Phone Number": "402-529-6846",
    "address": "HASS REPAIR 1238 1ST RD., WISNER, Nebraska 68791",
    "city": "WISNER",
    "state": "Nebraska",
    "zip": "68791",
    "lat": 41.9083254,
    "lng": -97.01906559999999
  },
  {
    "Store Location": "Southwest Rentals, Inc. 416 S Landry Dr New Iberia, Louisiana 70560",
    "Store Type": "Southwest Rentals, Inc.",
    "Phone Number": "337-367-2501",
    "address": "Southwest Rentals, Inc. 416 S Landry Dr New Iberia, Louisiana 70560",
    "city": "Inc. 416 S Landry Dr New Iberia",
    "state": "Louisiana",
    "zip": "70560",
    "lat": 30.0190288,
    "lng": -91.8365264
  },
  {
    "Store Location": "Wayne's Heating and A/C - Kerosene and NG only 1605 W Vine St Opelousas, Louisiana 70570",
    "Store Type": "Wayne's Heating and A/C - Kerosene and NG only",
    "Phone Number": "337-948-4246",
    "address": "Wayne's Heating and A/C - Kerosene and NG only 1605 W Vine St, Opelousas, Louisiana 70570",
    "city": "Opelousas",
    "state": "Louisiana",
    "zip": "70570",
    "lat": 30.5345768,
    "lng": -92.1012419
  },
  {
    "Store Location": "Joe's Electrical Power Tools 808 E Carlton St. Sulphur, Louisiana 70663",
    "Store Type": "Joe's Electrical Power Tools",
    "Phone Number": "337-527-3020",
    "address": "Joe's Electrical Power Tools 808 E Carlton St., Sulphur, Louisiana 70663",
    "city": "Sulphur",
    "state": "Louisiana",
    "zip": "70663",
    "lat": 30.2458913,
    "lng": -93.37000780000001
  },
  {
    "Store Location": "The Tool Room 508 Marsh Ave El Dorado, Arkansas 71730",
    "Store Type": "The Tool Room",
    "Phone Number": "870-863-3036",
    "address": "The Tool Room 508 Marsh Ave El, Dorado, Arkansas 71730",
    "city": "Dorado",
    "state": "Arkansas",
    "zip": "71730",
    "lat": 33.2070808,
    "lng": -92.6713943
  },
  {
    "Store Location": "ARKANSAS ONSITE SERVICE,INC. 17186 Highway 70 Lonsdale, Arkansas 72087",
    "Store Type": "ARKANSAS ONSITE SERVICE,INC.",
    "Phone Number": "501-939-1000",
    "address": "ARKANSAS ONSITE SERVICE, INC. 17186 Highway 70 Lonsdale, Arkansas 72087",
    "city": "INC. 17186 Highway 70 Lonsdale",
    "state": "Arkansas",
    "zip": "72087",
    "lat": 34.5487643,
    "lng": -92.7711776
  },
  {
    "Store Location": "Darragh Company 1401 E. 6th Street Little Rock , Arkansas 72202",
    "Store Type": "Darragh Company",
    "Phone Number": "501-372-2112",
    "address": "Darragh Company 1401 E. 6th Street Little, Rock, Arkansas 72202",
    "city": "Rock",
    "state": "Arkansas",
    "zip": "72202",
    "lat": 34.7408994,
    "lng": -92.2561561
  },
  {
    "Store Location": "Gilles Bros INC 541 W Main St Yukon, Oklahoma 73099",
    "Store Type": "Gilles Bros INC",
    "Phone Number": "405-354-3565",
    "address": "Gilles Bros INC 541 W Main St, Yukon, Oklahoma 73099",
    "city": "Yukon",
    "state": "Oklahoma",
    "zip": "73099",
    "lat": 35.5082146,
    "lng": -97.7517816
  },
  {
    "Store Location": "Mike's Sales & Repair 215 N. 4th St Clinton , Oklahoma 73601",
    "Store Type": "Mike's Sales & Repair",
    "Phone Number": "580-323-3995",
    "address": "Mike's Sales & Repair 215 N. 4th St, Clinton, Oklahoma 73601",
    "city": "Clinton",
    "state": "Oklahoma",
    "zip": "73601",
    "lat": 35.5160286,
    "lng": -98.96452970000001
  },
  {
    "Store Location": "ROYSE CITY LAWNMOWER 6723 W I-30 ROYSE CITY, Texas 75189",
    "Store Type": "ROYSE CITY LAWNMOWER",
    "Phone Number": "972-635-6565",
    "address": "ROYSE CITY LAWNMOWER 6723 W I-30 ROYSE, CITY, Texas 75189",
    "city": "CITY",
    "state": "Texas",
    "zip": "75189",
    "lat": 32.9798155,
    "lng": -96.280783
  },
  {
    "Store Location": "Ludwig Saw & Tool 1701 Maple Ave Waco, Texas 76707",
    "Store Type": "Ludwig Saw & Tool",
    "Phone Number": "254-754-6951",
    "address": "Ludwig Saw & Tool 1701 Maple Ave, Waco, Texas 76707",
    "city": "Waco",
    "state": "Texas",
    "zip": "76707",
    "lat": 31.5615759,
    "lng": -97.15684549999999
  },
  {
    "Store Location": "Bay Gas Inc 2694 Calder Drive South League City, Texas 77573",
    "Store Type": "Bay Gas Inc",
    "Phone Number": "281-332-2630",
    "address": "Bay Gas Inc 2694 Calder Drive South League, City, Texas 77573",
    "city": "City",
    "state": "Texas",
    "zip": "77573",
    "lat": 29.4790135,
    "lng": -95.1049611
  },
  {
    "Store Location": "GOPHER INDUSTRIAL, INC. 19312 HWY 62 S ORANGE, Texas 77630",
    "Store Type": "GOPHER INDUSTRIAL, INC.",
    "Phone Number": "409-735-3300",
    "address": "GOPHER INDUSTRIAL, INC. 19312 HWY 62 S ORANGE, Texas 77630",
    "city": "INC. 19312 HWY 62 S ORANGE",
    "state": "Texas",
    "zip": "77630",
    "lat": 30.0686999,
    "lng": -93.8222598
  },
  {
    "Store Location": "Danny Payton Electric LLC 27484 S Bass Blvd Harlingen, Texas 78552",
    "Store Type": "Danny Payton Electric LLC",
    "Phone Number": "956-425-4091",
    "address": "Danny Payton Electric LLC 27484 S Bass Blvd, Harlingen, Texas 78552",
    "city": "Harlingen",
    "state": "Texas",
    "zip": "78552",
    "lat": 26.1597731,
    "lng": -97.7826667
  },
  {
    "Store Location": "Valley Outdoor Power Equipment (Kerosene Only) 1012 E.495TH PHARR, Texas 78577",
    "Store Type": "Valley Outdoor Power Equipment (Kerosene Only)",
    "Phone Number": "956-787-0469",
    "address": "Valley Outdoor Power Equipment (Kerosene Only) 1012 E.495TH, PHARR, Texas 78577",
    "city": "PHARR",
    "state": "Texas",
    "zip": "78577",
    "lat": 26.2098619,
    "lng": -98.1698615
  },
  {
    "Store Location": "Howard's Lawn Equipment 1710 AVENUE J LUBBOCK, Texas 79401",
    "Store Type": "Howard's Lawn Equipment",
    "Phone Number": "806-744-3946",
    "address": "Howard's Lawn Equipment 1710 AVENUE J, LUBBOCK, Texas 79401",
    "city": "LUBBOCK",
    "state": "Texas",
    "zip": "79401",
    "lat": 33.5795447,
    "lng": -101.8472576
  },
  {
    "Store Location": "SMALL ENGINE TECH INC 7302 82ND STREET STE #9 LUBBOCK, Texas 79424",
    "Store Type": "SMALL ENGINE TECH INC",
    "Phone Number": "806-787-7974",
    "address": "SMALL ENGINE TECH INC 7302 82ND STREET STE #9, LUBBOCK, Texas 79424",
    "city": "LUBBOCK",
    "state": "Texas",
    "zip": "79424",
    "lat": 33.5204083,
    "lng": -101.97472
  },
  {
    "Store Location": "Dale's Electric Motor Repair INC 218 Johnson St Frederick, Colorado 80530",
    "Store Type": "Dale's Electric Motor Repair INC",
    "Phone Number": "303-833-4194",
    "address": "Dale's Electric Motor Repair INC 218 Johnson St, Frederick, Colorado 80530",
    "city": "Frederick",
    "state": "Colorado",
    "zip": "80530",
    "lat": 40.1048484,
    "lng": -104.9381208
  },
  {
    "Store Location": "RENTAL CENTER OF PUEBLO WEST 130 E. INDUSTRIAL BL PUEBLO WEST, Colorado 81007",
    "Store Type": "RENTAL CENTER OF PUEBLO WEST",
    "Phone Number": "719-647-2071",
    "address": "RENTAL CENTER OF PUEBLO WEST 130 E. INDUSTRIAL BL PUEBLO, WEST, Colorado 81007",
    "city": "WEST",
    "state": "Colorado",
    "zip": "81007",
    "lat": 38.3382783,
    "lng": -104.7372022
  },
  {
    "Store Location": "RANCHER'S SUPPLY (No Kerosene Repairs) 30534 E.HWY.50 LA JUNTA, Colorado 81050",
    "Store Type": "RANCHER'S SUPPLY (No Kerosene Repairs)",
    "Phone Number": "719-384-2507",
    "address": "RANCHER'S SUPPLY (No Kerosene Repairs) 30534 E.HWY.50 LA, JUNTA, Colorado 81050",
    "city": "JUNTA",
    "state": "Colorado",
    "zip": "81050",
    "lat": 37.9858358,
    "lng": -103.5180941
  },
  {
    "Store Location": "A-1 Rental & Sales 7215 Highway 50 Lamar, Colorado 81052",
    "Store Type": "A-1 Rental & Sales",
    "Phone Number": "719-336-2771",
    "address": "A-1 Rental & Sales 7215 Highway 50, Lamar, Colorado 81052",
    "city": "Lamar",
    "state": "Colorado",
    "zip": "81052",
    "lat": 38.1157021,
    "lng": -102.6258627
  },
  {
    "Store Location": "MONTE VISTA CO-OP 1901 E.HWY 160 MONTE VISTA, Colorado 81144",
    "Store Type": "MONTE VISTA CO-OP",
    "Phone Number": "719-852-5181",
    "address": "MONTE VISTA CO-OP 1901 E.HWY 160 MONTE, VISTA, Colorado 81144",
    "city": "VISTA",
    "state": "Colorado",
    "zip": "81144",
    "lat": 37.5691909,
    "lng": -106.114479
  },
  {
    "Store Location": "NORTHWEST TOOL REPAIR CORP. 2000 COUNTY RD 204 CRAIG, 81625",
    "Store Type": "NORTHWEST TOOL REPAIR CORP.",
    "Phone Number": "970-824-9335",
    "address": "NORTHWEST TOOL REPAIR CORP. 2000 COUNTY RD 204 CRAIG, ,  81625",
    "city": "Unknown",
    "state": "Unknown",
    "zip": "81625",
    "lat": 40.56123300000001,
    "lng": -107.628253
  },
  {
    "Store Location": "Action Shop Service INc 2412 Access Rd Rifle, Colorado 81650",
    "Store Type": "Action Shop Service INc",
    "Phone Number": "970-625-0943",
    "address": "Action Shop Service INc 2412 Access Rd, Rifle, Colorado 81650",
    "city": "Rifle",
    "state": "Colorado",
    "zip": "81650",
    "lat": 39.5287095,
    "lng": -107.8107394
  },
  {
    "Store Location": "Big R-Linton 455 South Absaroka Powell, Wyoming 82435",
    "Store Type": "Big R-Linton",
    "Phone Number": "307-754-5881",
    "address": "Big R-Linton 455 South Absaroka, Powell, Wyoming 82435",
    "city": "Powell",
    "state": "Wyoming",
    "zip": "82435",
    "lat": 44.74813080000001,
    "lng": -108.7585785
  },
  {
    "Store Location": "Hansen Equipment 2202 West Main St New Castle, Wyoming 82701",
    "Store Type": "Hansen Equipment",
    "Phone Number": "307-746-4278",
    "address": "Hansen Equipment 2202 West Main St New, Castle, Wyoming 82701",
    "city": "Castle",
    "state": "Wyoming",
    "zip": "82701",
    "lat": 43.8509478,
    "lng": -104.2301716
  },
  {
    "Store Location": "State Trailer Supply 1900 Flandro Rd Pocatello, Idaho 83202",
    "Store Type": "State Trailer Supply",
    "Phone Number": "208-637-0400",
    "address": "State Trailer Supply 1900 Flandro Rd, Pocatello, Idaho 83202",
    "city": "Pocatello",
    "state": "Idaho",
    "zip": "83202",
    "lat": 42.9099074,
    "lng": -112.4504099
  },
  {
    "Store Location": "Upper Valley Electric INC 1010 North 2nd East Rexburg, Idaho 83440",
    "Store Type": "Upper Valley Electric INC",
    "Phone Number": "208-356-4424",
    "address": "Upper Valley Electric INC 1010 North 2nd East, Rexburg, Idaho 83440",
    "city": "Rexburg",
    "state": "Idaho",
    "zip": "83440",
    "lat": 43.84690459999999,
    "lng": -111.7773076
  },
  {
    "Store Location": "ALBENI FALLS BUILDING SUPPLY 520 HIGHWAY 2 OLDTOWN, Idaho 83822",
    "Store Type": "ALBENI FALLS BUILDING SUPPLY",
    "Phone Number": "208-437-3153",
    "address": "ALBENI FALLS BUILDING SUPPLY 520 HIGHWAY 2, OLDTOWN, Idaho 83822",
    "city": "OLDTOWN",
    "state": "Idaho",
    "zip": "83822",
    "lat": 48.1859683,
    "lng": -117.0279191
  },
  {
    "Store Location": "Rasmussen Equipment 3333 W 2100 S Salt Lake City, Utah 84119",
    "Store Type": "Rasmussen Equipment",
    "Phone Number": "801-972-5588",
    "address": "Rasmussen Equipment 3333 W 2100 S Salt Lake, City, Utah 84119",
    "city": "City",
    "state": "Utah",
    "zip": "84119",
    "lat": 40.7250103,
    "lng": -111.9708707
  },
  {
    "Store Location": "Casual Barbeque & Fireplace 555 W 3900 S Building A Salt Lake City, Utah 84123",
    "Store Type": "Casual Barbeque & Fireplace",
    "Phone Number": "801-263-9646",
    "address": "Casual Barbeque & Fireplace 555 W 3900 S Building A Salt Lake, City, Utah 84123",
    "city": "City",
    "state": "Utah",
    "zip": "84123",
    "lat": 40.6867117,
    "lng": -111.9071497
  },
  {
    "Store Location": "Tractor and Equipment 20030 N 5200 W Plymouth, Utah 84330",
    "Store Type": "Tractor and Equipment",
    "Phone Number": "435-230-0161",
    "address": "Tractor and Equipment 20030 N 5200 W, Plymouth, Utah 84330",
    "city": "Plymouth",
    "state": "Utah",
    "zip": "84330",
    "lat": 41.8728419,
    "lng": -112.1464731
  },
  {
    "Store Location": "Merlin's 475 N. Main St. Smithfield, Utah 84335",
    "Store Type": "Merlin's",
    "Phone Number": "435-563-4118",
    "address": "Merlin's 475 N. Main St., Smithfield, Utah 84335",
    "city": "Smithfield",
    "state": "Utah",
    "zip": "84335",
    "lat": 41.8463644,
    "lng": -111.8328254
  },
  {
    "Store Location": "State Trailer Supply 3088 S Washington Blvd Ogden, Utah 84401",
    "Store Type": "State Trailer Supply",
    "Phone Number": "801-334-0700",
    "address": "State Trailer Supply 3088 S Washington Blvd, Ogden, Utah 84401",
    "city": "Ogden",
    "state": "Utah",
    "zip": "84401",
    "lat": 41.2085399,
    "lng": -111.9702374
  },
  {
    "Store Location": "Unicoa Industrial Supply 3232 E 36th St Tuscon, Arizona 85713",
    "Store Type": "Unicoa Industrial Supply",
    "Phone Number": "520-620-1000",
    "address": "Unicoa Industrial Supply 3232 E 36th St, Tuscon, Arizona 85713",
    "city": "Tuscon",
    "state": "Arizona",
    "zip": "85713",
    "lat": 32.1903901,
    "lng": -110.9234174
  },
  {
    "Store Location": "Super CC Engines 1010 W Cleveland Saint Johns, Arizona 85936",
    "Store Type": "Super CC Engines",
    "Phone Number": "928-200-3119",
    "address": "Super CC Engines 1010 W Cleveland Saint, Johns, Arizona 85936",
    "city": "Johns",
    "state": "Arizona",
    "zip": "85936",
    "lat": 34.5060551,
    "lng": -109.3802493
  },
  {
    "Store Location": "ALERT-O-LITE 2436 FOUNDRY PARK AVE FRESNO, California 93706",
    "Store Type": "ALERT-O-LITE",
    "Phone Number": "559-486-4570",
    "address": "ALERT-O-LITE 2436 FOUNDRY PARK AVE, FRESNO, California 93706",
    "city": "FRESNO",
    "state": "California",
    "zip": "93706",
    "lat": 36.7125449,
    "lng": -119.7776175
  },
  {
    "Store Location": "Tozier's True Value / MCT Repair 2384 Durham Dayton Hwy Durham, California 95938",
    "Store Type": "Tozier's True Value / MCT Repair",
    "Phone Number": "530-345-5292",
    "address": "Tozier's True Value / MCT Repair 2384 Durham Dayton Hwy, Durham, California 95938",
    "city": "Durham",
    "state": "California",
    "zip": "95938",
    "lat": 39.64626,
    "lng": -121.8007852
  },
  {
    "Store Location": "INDUSTRIAL PRODUCTS 17380 S.W. BASELINE RD. BEAVERTON, Oregon 97006",
    "Store Type": "INDUSTRIAL PRODUCTS",
    "Phone Number": "503-645-0544",
    "address": "INDUSTRIAL PRODUCTS 17380 S.W. BASELINE RD., BEAVERTON, Oregon 97006",
    "city": "BEAVERTON",
    "state": "Oregon",
    "zip": "97006",
    "lat": 45.5122533,
    "lng": -122.855634
  },
  {
    "Store Location": "Ollie Damon's 236 S.E. Grand Ave. Portland, Oregon 97214",
    "Store Type": "Ollie Damon's",
    "Phone Number": "503-232-3193",
    "address": "Ollie Damon's 236 S.E. Grand Ave., Portland, Oregon 97214",
    "city": "Portland",
    "state": "Oregon",
    "zip": "97214",
    "lat": 45.521021,
    "lng": -122.660447
  },
  {
    "Store Location": "Ollie Damon's 10240 NE Halsey St Portland, Oregon 97220",
    "Store Type": "Ollie Damon's",
    "Phone Number": "503-232-3193",
    "address": "Ollie Damon's 10240 NE Halsey St, Portland, Oregon 97220",
    "city": "Portland",
    "state": "Oregon",
    "zip": "97220",
    "lat": 45.53303469999999,
    "lng": -122.5573538
  },
  {
    "Store Location": "Eugene Power Tool Repair LLC 101 N Seneca Rd Eugene, Oregon 97402",
    "Store Type": "Eugene Power Tool Repair LLC",
    "Phone Number": "541-232-5081",
    "address": "Eugene Power Tool Repair LLC 101 N Seneca Rd, Eugene, Oregon 97402",
    "city": "Eugene",
    "state": "Oregon",
    "zip": "97402",
    "lat": 44.0617198,
    "lng": -123.1398685
  },
  {
    "Store Location": "OREGON TOOL & SUPPLY 276 E.STEPHENS ROSEBURG, Oregon 97470",
    "Store Type": "OREGON TOOL & SUPPLY",
    "Phone Number": "541-672-1935",
    "address": "OREGON TOOL & SUPPLY 276 E.STEPHENS, ROSEBURG, Oregon 97470",
    "city": "ROSEBURG",
    "state": "Oregon",
    "zip": "97470",
    "lat": 43.2119757,
    "lng": -123.3448729
  },
  {
    "Store Location": "C&H INDUSTRIAL TOOL & SUPPLY CO., INC. 1160 3RD AVE LONGVIEW, Washington 98632",
    "Store Type": "C&H INDUSTRIAL TOOL & SUPPLY CO., INC.",
    "Phone Number": "360-423-6496",
    "address": "C&H INDUSTRIAL TOOL & SUPPLY CO., INC. 1160 3RD AVE LONGVIEW, Washington 98632",
    "city": "INC. 1160 3RD AVE LONGVIEW",
    "state": "Washington",
    "zip": "98632",
    "lat": 46.1330118,
    "lng": -122.9230263
  },
  {
    "Store Location": "Edge Construction Supply 1503 East Riverside Ave Spokane, Washington 99202",
    "Store Type": "Edge Construction Supply",
    "Phone Number": "509-535-9841",
    "address": "Edge Construction Supply 1503 East Riverside Ave, Spokane, Washington 99202",
    "city": "Spokane",
    "state": "Washington",
    "zip": "99202",
    "lat": 47.6584775,
    "lng": -117.3886814
  },
  {
    "Store Location": "Graham Auto Parts 8856 Main St. Florenceville-Bristol, New Brunswick E7L 2A1",
    "Store Type": "Graham Auto Parts",
    "Phone Number": "506-392-5500",
    "address": "Graham Auto Parts 8856 Main St. Florenceville-Bristol, New Brunswick E7L 2A1,  ",
    "city": "New Brunswick E7L 2A1",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 46.4558791,
    "lng": -67.6025361
  },
  {
    "Store Location": "Alternatif Location Doutils Inc. 894 Boul De La Salette St. Jerome, Quebec J5I 2J3",
    "Store Type": "Alternatif Location Doutils Inc.",
    "Phone Number": "450-438-0288",
    "address": "Alternatif Location Doutils Inc. 894 Boul De La Salette St. Jerome, Quebec J5I 2J3,  ",
    "city": "Quebec J5I 2J3",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 45.7892826,
    "lng": -74.06473620000001
  },
  {
    "Store Location": "Kabam RV Repairs 3324 Highway 15 Kingston, Ontario K7L 4J3",
    "Store Type": "Kabam RV Repairs",
    "Phone Number": "613-546-9961",
    "address": "Kabam RV Repairs 3324 Highway 15 Kingston, Ontario K7L 4J3,  ",
    "city": "Ontario K7L 4J3",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.3401076,
    "lng": -76.3628114
  },
  {
    "Store Location": "Emergency Propane Services 91B Maplecrete Rd Vaughan, Ontario L4K 1A5",
    "Store Type": "Emergency Propane Services",
    "Phone Number": "905-669-0526",
    "address": "Emergency Propane Services 91B Maplecrete Rd Vaughan, Ontario L4K 1A5,  ",
    "city": "Ontario L4K 1A5",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.7911861,
    "lng": -79.51974969999999
  },
  {
    "Store Location": "Murrays Sharpening & Tool 1190 2nd Avenue E Owen Sound, Ontario N4R 2H9",
    "Store Type": "Murrays Sharpening & Tool",
    "Phone Number": "519-376-2495",
    "address": "Murrays Sharpening & Tool 1190 2nd Avenue E Owen Sound, Ontario N4R 2H9,  ",
    "city": "Ontario N4R 2H9",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.5716952,
    "lng": -80.9408339
  },
  {
    "Store Location": "Petes Paint and Parts Limited 157 Talbot St E Leamington, Ontario N8H 1L8",
    "Store Type": "Petes Paint and Parts Limited",
    "Phone Number": "519-322-2555",
    "address": "Petes Paint and Parts Limited 157 Talbot St E Leamington, Ontario N8H 1L8,  ",
    "city": "Ontario N8H 1L8",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.0550991,
    "lng": -82.5923066
  },
  {
    "Store Location": "D & T Auto Parts Ltd 24 Fraser Rd Leamington, Ontario N8H 4E5",
    "Store Type": "D & T Auto Parts Ltd",
    "Phone Number": "519-322-2551",
    "address": "D & T Auto Parts Ltd 24 Fraser Rd Leamington, Ontario N8H 4E5,  ",
    "city": "Ontario N8H 4E5",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.0458866,
    "lng": -82.6220786
  },
  {
    "Store Location": "Auto Barn Parts Supply 377 Talbot St N Essex, Ontario N8M 2W3",
    "Store Type": "Auto Barn Parts Supply",
    "Phone Number": "519-776-9885",
    "address": "Auto Barn Parts Supply 377 Talbot St N Essex, Ontario N8M 2W3,  ",
    "city": "Ontario N8M 2W3",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.1834564,
    "lng": -82.8321108
  },
  {
    "Store Location": "D & M Mechanical 80 Vaillancourt Crest Chelmsford, Ontario P0M 1I0",
    "Store Type": "D & M Mechanical",
    "Phone Number": "705-698-8182",
    "address": "D & M Mechanical 80 Vaillancourt Crest Chelmsford, Ontario P0M 1I0,  ",
    "city": "Ontario P0M 1I0",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 46.5761326,
    "lng": -81.20165589999999
  },
  {
    "Store Location": "Gord's Rentals 778 Riverside Dr Timmins, Ontario P4N 3W1",
    "Store Type": "Gord's Rentals",
    "Phone Number": "705-268-7029",
    "address": "Gord's Rentals 778 Riverside Dr Timmins, Ontario P4N 3W1,  ",
    "city": "Ontario P4N 3W1",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 48.4775984,
    "lng": -81.35885549999999
  },
  {
    "Store Location": "Rea's General Repair 149 Anton Rd. Dryden, Ontario P8N 2Y5",
    "Store Type": "Rea's General Repair",
    "Phone Number": "807-937-2424",
    "address": "Rea's General Repair 149 Anton Rd. Dryden, Ontario P8N 2Y5,  ",
    "city": "Ontario P8N 2Y5",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 49.8009294,
    "lng": -92.85804600000002
  },
  {
    "Store Location": "THE RENTAL HOUSE 260 PARK ROAD WEST STEINBACH, Manitoba R5G 1V5",
    "Store Type": "THE RENTAL HOUSE",
    "Phone Number": "204-326-2266",
    "address": "THE RENTAL HOUSE 260 PARK ROAD WEST STEINBACH, Manitoba R5G 1V5,  ",
    "city": "Manitoba R5G 1V5",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 49.54161269999999,
    "lng": -96.702743
  },
  {
    "Store Location": "Marks Mini Tune Limited 3430 Hill Ave Regina, Saskatchewan S4S 0W9",
    "Store Type": "Marks Mini Tune Limited",
    "Phone Number": "306-586-5777",
    "address": "Marks Mini Tune Limited 3430 Hill Ave Regina, Saskatchewan S4S 0W9,  ",
    "city": "Saskatchewan S4S 0W9",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 50.42836800000001,
    "lng": -104.6312579
  },
  {
    "Store Location": "LAWN SHOP SERVICES 774 16TH ST. SW MEDICINE HAT, Alberta T1A 4X2",
    "Store Type": "LAWN SHOP SERVICES",
    "Phone Number": "403-527-4555",
    "address": "LAWN SHOP SERVICES 774 16TH ST. SW MEDICINE HAT, Alberta T1A 4X2,  ",
    "city": "Alberta T1A 4X2",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 50.02453879999999,
    "lng": -110.7046048
  },
  {
    "Store Location": "DEMAND ELECTRIC 228 39TH AVE. NE CALGARY, Alberta T2E 2M5",
    "Store Type": "DEMAND ELECTRIC",
    "Phone Number": "403-230-2709",
    "address": "DEMAND ELECTRIC 228 39TH AVE. NE CALGARY, Alberta T2E 2M5,  ",
    "city": "Alberta T2E 2M5",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 51.0880406,
    "lng": -114.058377
  },
  {
    "Store Location": "Quality Tool Repair Ltd. 11216 156 St. Edmonton, Alberta T5M 1Y3",
    "Store Type": "Quality Tool Repair Ltd.",
    "Phone Number": "780-702-1686",
    "address": "Quality Tool Repair Ltd. 11216 156 St. Edmonton, Alberta T5M 1Y3,  ",
    "city": "Alberta T5M 1Y3",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 53.5616755,
    "lng": -113.591082
  },
  {
    "Store Location": "ABLE TOOL RENTALS 4311 BUCHANAN ST. BURNABY, British Columbia V5C 3X7",
    "Store Type": "ABLE TOOL RENTALS",
    "Phone Number": "604-299-8358",
    "address": "ABLE TOOL RENTALS 4311 BUCHANAN ST. BURNABY, British Columbia V5C 3X7,  ",
    "city": "British Columbia V5C 3X7",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 49.26775629999999,
    "lng": -123.0085336
  },
  {
    "Store Location": "PACIFIC NAIL & STAPLE 11332 120TH AVE NE KIRKLAND, Washington 98033",
    "Store Type": "PACIFIC NAIL & STAPLE",
    "Phone Number": "425-828-6694",
    "address": "PACIFIC NAIL & STAPLE 11332 120TH AVE NE, KIRKLAND, Washington 98033",
    "city": "KIRKLAND",
    "state": "Washington",
    "zip": "98033",
    "lat": 47.7019428,
    "lng": -122.1804749
  },
  {
    "Store Location": "T & A INDUSTRIAL DISTRIBUTORS 1180 ASHWAUBENON ST GREEN BAY, Wisconsin 54304",
    "Store Type": "T & A INDUSTRIAL DISTRIBUTORS",
    "Phone Number": "920-983-4480",
    "address": "T & A INDUSTRIAL DISTRIBUTORS 1180 ASHWAUBENON ST GREEN, BAY, Wisconsin 54304",
    "city": "BAY",
    "state": "Wisconsin",
    "zip": "54304",
    "lat": 44.4674878,
    "lng": -88.09640399999999
  },
  {
    "Store Location": "Hank's Mobile Mower Repair 4961 Cleveland St. Virginia Beach, Virginia 23462",
    "Store Type": "Hank's Mobile Mower Repair",
    "Phone Number": "757-497-7645",
    "address": "Hank's Mobile Mower Repair 4961 Cleveland St. Virginia, Beach, Virginia 23462",
    "city": "Beach",
    "state": "Virginia",
    "zip": "23462",
    "lat": 36.8416764,
    "lng": -76.14946619999999
  },
  {
    "Store Location": "Leonard Electric Motor Repair INC 531 North Fayeteville St. Asheboro, North Carolina 27203",
    "Store Type": "Leonard Electric Motor Repair INC",
    "Phone Number": "336-625-2375",
    "address": "Leonard Electric Motor Repair INC 531 North Fayeteville St., Asheboro, North Carolina 27203",
    "city": "Asheboro",
    "state": "North Carolina",
    "zip": "27203",
    "lat": 35.713944,
    "lng": -79.81218
  },
  {
    "Store Location": "LEXINGTON MOWER SERVICE 555 CENTRAL AVE. LEXINGTON, North Carolina 27292",
    "Store Type": "LEXINGTON MOWER SERVICE",
    "Phone Number": "336-248-2013",
    "address": "LEXINGTON MOWER SERVICE 555 CENTRAL AVE., LEXINGTON, North Carolina 27292",
    "city": "LEXINGTON",
    "state": "North Carolina",
    "zip": "27292",
    "lat": 35.8208015,
    "lng": -80.27938449999999
  },
  {
    "Store Location": "Clark Family Supply 4210 Summit Ave Greensboro, North Carolina 27405",
    "Store Type": "Clark Family Supply",
    "Phone Number": "336-621-4371",
    "address": "Clark Family Supply 4210 Summit Ave, Greensboro, North Carolina 27405",
    "city": "Greensboro",
    "state": "North Carolina",
    "zip": "27405",
    "lat": 36.1319861,
    "lng": -79.760244
  },
  {
    "Store Location": "Equipserv LLC 4420 Snapfinger Woods Dr Decatur, Georgia 30035",
    "Store Type": "Equipserv LLC",
    "Phone Number": "770-709-5101",
    "address": "Equipserv LLC 4420 Snapfinger Woods Dr, Decatur, Georgia 30035",
    "city": "Decatur",
    "state": "Georgia",
    "zip": "30035",
    "lat": 33.7096678,
    "lng": -84.2067673
  },
  {
    "Store Location": "Southeastern Jack Co 500 4th Ave North Birmingham, Alabama 35204",
    "Store Type": "Southeastern Jack Co",
    "Phone Number": "205-252-1511",
    "address": "Southeastern Jack Co 500 4th Ave North, Birmingham, Alabama 35204",
    "city": "Birmingham",
    "state": "Alabama",
    "zip": "35204",
    "lat": 33.5079819,
    "lng": -86.828206
  },
  {
    "Store Location": "Cox Power Supply 4678 Old Broadway Knoxville, Tennessee 37918",
    "Store Type": "Cox Power Supply",
    "Phone Number": "865-688-7314",
    "address": "Cox Power Supply 4678 Old Broadway, Knoxville, Tennessee 37918",
    "city": "Knoxville",
    "state": "Tennessee",
    "zip": "37918",
    "lat": 36.0194345,
    "lng": -83.92417890000002
  },
  {
    "Store Location": "Rector's Lawn & Garden 44 CC Camp Rd. Cookeville, Tennessee 38501",
    "Store Type": "Rector's Lawn & Garden",
    "Phone Number": "931-526-5516",
    "address": "Rector's Lawn & Garden 44 CC Camp Rd., Cookeville, Tennessee 38501",
    "city": "Cookeville",
    "state": "Tennessee",
    "zip": "38501",
    "lat": 36.1709766,
    "lng": -85.5405285
  },
  {
    "Store Location": "Kirby's Fix-It 409 E. Central Ave. Jamestown, Tennessee 38556",
    "Store Type": "Kirby's Fix-It",
    "Phone Number": "931-879-7414",
    "address": "Kirby's Fix-It 409 E. Central Ave., Jamestown, Tennessee 38556",
    "city": "Jamestown",
    "state": "Tennessee",
    "zip": "38556",
    "lat": 36.4270102,
    "lng": -84.9280328
  },
  {
    "Store Location": "TRUCKERS SUPPLY CO 519 HWY 19 SOUTH MERIDIAN, Mississippi 39301",
    "Store Type": "TRUCKERS SUPPLY CO",
    "Phone Number": "601-693-2316",
    "address": "TRUCKERS SUPPLY CO 519 HWY 19 SOUTH, MERIDIAN, Mississippi 39301",
    "city": "MERIDIAN",
    "state": "Mississippi",
    "zip": "39301",
    "lat": 32.3652307,
    "lng": -88.668131
  },
  {
    "Store Location": "WELDQUIP 531 S 4th St Danville, Kentucky 40422",
    "Store Type": "WELDQUIP",
    "Phone Number": "859-239-9353",
    "address": "WELDQUIP 531 S 4th St, Danville, Kentucky 40422",
    "city": "Danville",
    "state": "Kentucky",
    "zip": "40422",
    "lat": 37.63693689999999,
    "lng": -84.775268
  },
  {
    "Store Location": "Engle Sales 4412 Grove Church Rd Gambier, Ohio 43022",
    "Store Type": "Engle Sales",
    "Phone Number": "740-668-2751",
    "address": "Engle Sales 4412 Grove Church Rd, Gambier, Ohio 43022",
    "city": "Gambier",
    "state": "Ohio",
    "zip": "43022",
    "lat": 40.29273999999999,
    "lng": -82.355507
  },
  {
    "Store Location": "Country Hearth 5106 Dorr St. Toledo, Ohio 43615",
    "Store Type": "Country Hearth",
    "Phone Number": "419-531-6622",
    "address": "Country Hearth 5106 Dorr St., Toledo, Ohio 43615",
    "city": "Toledo",
    "state": "Ohio",
    "zip": "43615",
    "lat": 41.6535224,
    "lng": -83.6627273
  },
  {
    "Store Location": "Amshan Services 4622 French Creek Sheffield Village, Ohio 44054",
    "Store Type": "Amshan Services",
    "Phone Number": "440-240-5074",
    "address": "Amshan Services 4622 French Creek Sheffield, Village, Ohio 44054",
    "city": "Village",
    "state": "Ohio",
    "zip": "44054",
    "lat": 41.4494852,
    "lng": -82.0975191
  },
  {
    "Store Location": "Kay-Dee Tool Repair 5466 Lake Court Cleveland, Ohio 44114",
    "Store Type": "Kay-Dee Tool Repair",
    "Phone Number": "216-881-2565",
    "address": "Kay-Dee Tool Repair 5466 Lake Court, Cleveland, Ohio 44114",
    "city": "Cleveland",
    "state": "Ohio",
    "zip": "44114",
    "lat": 41.526943,
    "lng": -81.6531262
  },
  {
    "Store Location": "MIDDLETON ACE HARDWARE 44998 CRESTVIEW RD. COLUMBIANA, Ohio 44408",
    "Store Type": "MIDDLETON ACE HARDWARE",
    "Phone Number": "330-482-4803",
    "address": "MIDDLETON ACE HARDWARE 44998 CRESTVIEW RD., COLUMBIANA, Ohio 44408",
    "city": "COLUMBIANA",
    "state": "Ohio",
    "zip": "44408",
    "lat": 40.8425742,
    "lng": -80.651277
  },
  {
    "Store Location": "Kabelin Ace Hardware 512 Andrew Ave LaPorte, Indiana 46350",
    "Store Type": "Kabelin Ace Hardware",
    "Phone Number": "219-362-3310",
    "address": "Kabelin Ace Hardware 512 Andrew Ave, LaPorte, Indiana 46350",
    "city": "LaPorte",
    "state": "Indiana",
    "zip": "46350",
    "lat": 41.6018976,
    "lng": -86.734833
  },
  {
    "Store Location": "Big R Michigan City 4301 S Franklin St Michigan City, Indiana 46360",
    "Store Type": "Big R Michigan City",
    "Phone Number": "219-879-8317",
    "address": "Big R Michigan City 4301 S Franklin St Michigan, City, Indiana 46360",
    "city": "City",
    "state": "Indiana",
    "zip": "46360",
    "lat": 41.6747038,
    "lng": -86.8966588
  },
  {
    "Store Location": "Mark's Garden Shoppe 415 Oxford St. Fort Wayne, Indiana 46806",
    "Store Type": "Mark's Garden Shoppe",
    "Phone Number": "260-745-4976",
    "address": "Mark's Garden Shoppe 415 Oxford St. Fort, Wayne, Indiana 46806",
    "city": "Wayne",
    "state": "Indiana",
    "zip": "46806",
    "lat": 41.0536396,
    "lng": -85.1322017
  },
  {
    "Store Location": "Midway Sales 401 St. Joseph Street Sturgis, Michigan 49091",
    "Store Type": "Midway Sales",
    "Phone Number": "269-651-3267",
    "address": "Midway Sales 401 St. Joseph Street, Sturgis, Michigan 49091",
    "city": "Sturgis",
    "state": "Michigan",
    "zip": "49091",
    "lat": 41.80235709999999,
    "lng": -85.42340209999999
  },
  {
    "Store Location": "Master Tool Repair Inc 5210 West River Drive NE Comstock Park , Michigan 49321",
    "Store Type": "Master Tool Repair Inc",
    "Phone Number": "616-647-0654",
    "address": "Master Tool Repair Inc 5210 West River Drive NE Comstock, Park, Michigan 49321",
    "city": "Park",
    "state": "Michigan",
    "zip": "49321",
    "lat": 43.0577076,
    "lng": -85.642146
  },
  {
    "Store Location": "MB'S SALES & SERVICE, LLC 5433 SOUTH 12TH ST SHEBOYGAN, Wisconsin 53081",
    "Store Type": "MB'S SALES & SERVICE, LLC",
    "Phone Number": "920-912-7766",
    "address": "MB'S SALES & SERVICE, LLC 5433 SOUTH 12TH ST SHEBOYGAN, Wisconsin 53081",
    "city": "LLC 5433 SOUTH 12TH ST SHEBOYGAN",
    "state": "Wisconsin",
    "zip": "53081",
    "lat": 43.6922428,
    "lng": -87.7203572
  },
  {
    "Store Location": "Isenberg's Appliance Service 451 S Blvd Baraboo, Wisconsin 53913",
    "Store Type": "Isenberg's Appliance Service",
    "Phone Number": "608-356-8785",
    "address": "Isenberg's Appliance Service 451 S Blvd, Baraboo, Wisconsin 53913",
    "city": "Baraboo",
    "state": "Wisconsin",
    "zip": "53913",
    "lat": 43.46178099999999,
    "lng": -89.74816899999999
  },
  {
    "Store Location": "NORTHWOODS POWER EQUIPMENT 5290 HWY.141 SOUTH LENA, Wisconsin 54139",
    "Store Type": "NORTHWOODS POWER EQUIPMENT",
    "Phone Number": "920-834-5904",
    "address": "NORTHWOODS POWER EQUIPMENT 5290 HWY.141 SOUTH, LENA, Wisconsin 54139",
    "city": "LENA",
    "state": "Wisconsin",
    "zip": "54139",
    "lat": 44.8637772,
    "lng": -88.0475817
  },
  {
    "Store Location": "LadySmith Ace Home Center 503 Lake Ave Ladysmith, Wisconsin 54848",
    "Store Type": "LadySmith Ace Home Center",
    "Phone Number": "715-532-3351",
    "address": "LadySmith Ace Home Center 503 Lake Ave, Ladysmith, Wisconsin 54848",
    "city": "Ladysmith",
    "state": "Wisconsin",
    "zip": "54848",
    "lat": 45.4656946,
    "lng": -91.10682399999999
  },
  {
    "Store Location": "Appleton Power Equipment 421 N Munsterman Street Appleton, Minnesota 56208",
    "Store Type": "Appleton Power Equipment",
    "Phone Number": "320-289-2663",
    "address": "Appleton Power Equipment 421 N Munsterman Street, Appleton, Minnesota 56208",
    "city": "Appleton",
    "state": "Minnesota",
    "zip": "56208",
    "lat": 45.2040166,
    "lng": -96.02189
  },
  {
    "Store Location": "BEN'S RENTAL 51 E.PLAINFIELD RD. COUNTRYSIDE, Illinois 60525",
    "Store Type": "BEN'S RENTAL",
    "Phone Number": "708-352-7368",
    "address": "BEN'S RENTAL 51 E.PLAINFIELD RD., COUNTRYSIDE, Illinois 60525",
    "city": "COUNTRYSIDE",
    "state": "Illinois",
    "zip": "60525",
    "lat": 41.7942773,
    "lng": -87.86714020000001
  },
  {
    "Store Location": "Big R Watseka 433 W Walnut St Watseka, Illinois 60970",
    "Store Type": "Big R Watseka",
    "Phone Number": "815-432-4504",
    "address": "Big R Watseka 433 W Walnut St, Watseka, Illinois 60970",
    "city": "Watseka",
    "state": "Illinois",
    "zip": "60970",
    "lat": 40.7776251,
    "lng": -87.74260129999999
  },
  {
    "Store Location": "ORSCHELN FARM & HOME 5326 LAKE AVE. ST.JOSEPH, Missouri 64504",
    "Store Type": "ORSCHELN FARM & HOME",
    "Phone Number": "816-238-0711",
    "address": "ORSCHELN FARM & HOME 5326 LAKE AVE., ST.JOSEPH, Missouri 64504",
    "city": "ST.JOSEPH",
    "state": "Missouri",
    "zip": "64504",
    "lat": 39.7207721,
    "lng": -94.86494119999999
  },
  {
    "Store Location": "Pioneer Farm and Ranch 427 NE 14th Street Abilene, Kansas 67410",
    "Store Type": "Pioneer Farm and Ranch",
    "Phone Number": "785-263-7163",
    "address": "Pioneer Farm and Ranch 427 NE 14th Street, Abilene, Kansas 67410",
    "city": "Abilene",
    "state": "Kansas",
    "zip": "67410",
    "lat": 38.9306122,
    "lng": -97.2074002
  },
  {
    "Store Location": "NORTHLAND FEED 4807 N BRIGHTON KANSAS CITY, Missouri 64119",
    "Store Type": "NORTHLAND FEED",
    "Phone Number": "816-452-8393",
    "address": "NORTHLAND FEED 4807 N BRIGHTON KANSAS, CITY, Missouri 64119",
    "city": "CITY",
    "state": "Missouri",
    "zip": "64119",
    "lat": 39.1810874,
    "lng": -94.5207121
  },
  {
    "Store Location": "PORTABLE REPAIR SERVICE LLC 411 SOUTH AVE H CROWLEY, Louisiana 70526",
    "Store Type": "PORTABLE REPAIR SERVICE LLC",
    "Phone Number": "337-247-4545",
    "address": "PORTABLE REPAIR SERVICE LLC 411 SOUTH AVE H, CROWLEY, Louisiana 70526",
    "city": "CROWLEY",
    "state": "Louisiana",
    "zip": "70526",
    "lat": 30.2082325,
    "lng": -92.3678212
  },
  {
    "Store Location": "FOWLER SERVICES, INC. 52 Packing House Rd CASTLETON, Vermont 5735",
    "Store Type": "FOWLER SERVICES, INC.",
    "Phone Number": "802-468-3152",
    "address": "FOWLER SERVICES, INC. 52 Packing House Rd CASTLETON, Vermont 5735,  ",
    "city": "Vermont 5735",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.610906,
    "lng": -73.176337
  },
  {
    "Store Location": "HUMBOLDT FASTENERS AND TOOLS INC 5100 VALLEY EAST BLVD ARCATA, California 95521",
    "Store Type": "HUMBOLDT FASTENERS AND TOOLS INC",
    "Phone Number": "707-822-0209",
    "address": "HUMBOLDT FASTENERS AND TOOLS INC 5100 VALLEY EAST BLVD, ARCATA, California 95521",
    "city": "ARCATA",
    "state": "California",
    "zip": "95521",
    "lat": 40.9042998,
    "lng": -124.0806286
  },
  {
    "Store Location": "Air Tool Maintenance 420 RIVER ROAD Eugene, Oregon 97404",
    "Store Type": "Air Tool Maintenance",
    "Phone Number": "541-461-1714",
    "address": "Air Tool Maintenance 420 RIVER ROAD, Eugene, Oregon 97404",
    "city": "Eugene",
    "state": "Oregon",
    "zip": "97404",
    "lat": 44.0674991,
    "lng": -123.1181467
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - APPLETON 4675 ASSOCIATE COURT GRAND CHUTE, Wisconsin 54913",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - APPLETON",
    "Phone Number": "920-268-0481",
    "address": "NORTHERN TOOL & EQUIPMENT - APPLETON 4675 ASSOCIATE COURT GRAND, CHUTE, Wisconsin 54913",
    "city": "CHUTE",
    "state": "Wisconsin",
    "zip": "54913",
    "lat": 44.2740144,
    "lng": -88.4754762
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - BUFORD 4125 GA HWY 20, STE, J BUFORD, Georgia 30518",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - BUFORD",
    "Phone Number": "678-804-7200",
    "address": "NORTHERN TOOL & EQUIPMENT - BUFORD 4125 GA HWY 20, STE, J BUFORD, Georgia 30518",
    "city": "J BUFORD",
    "state": "Georgia",
    "zip": "30518",
    "lat": 34.0935845,
    "lng": -84.0006635
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - COLUMBIA 4040 FERNANDINA RD. COLUMBIA, South Carolina 29210",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - COLUMBIA",
    "Phone Number": "803-551-5808",
    "address": "NORTHERN TOOL & EQUIPMENT - COLUMBIA 4040 FERNANDINA RD., COLUMBIA, South Carolina 29210",
    "city": "COLUMBIA",
    "state": "South Carolina",
    "zip": "29210",
    "lat": 34.070015,
    "lng": -81.142726
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - CORPUS CHRISTI 4914 S. PADRE ISLAND DR CORPUS CHRISTI, Texas 78418",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - CORPUS CHRISTI",
    "Phone Number": "361-288-4994",
    "address": "NORTHERN TOOL & EQUIPMENT - CORPUS CHRISTI 4914 S. PADRE ISLAND DR CORPUS, CHRISTI, Texas 78418",
    "city": "CHRISTI",
    "state": "Texas",
    "zip": "78418",
    "lat": 27.7145547,
    "lng": -97.3814771
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - DES MOINES 4365 MERLE HAY RD. DES MOINES, Iowa 50310",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - DES MOINES",
    "Phone Number": "515-252-1516",
    "address": "NORTHERN TOOL & EQUIPMENT - DES MOINES 4365 MERLE HAY RD. DES, MOINES, Iowa 50310",
    "city": "MOINES",
    "state": "Iowa",
    "zip": "50310",
    "lat": 41.641061,
    "lng": -93.6950469
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - DULUTH 4969 MILLER TRUNK HWY DULUTH, Minnesota 55811",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - DULUTH",
    "Phone Number": "218-729-0700",
    "address": "NORTHERN TOOL & EQUIPMENT - DULUTH 4969 MILLER TRUNK HWY, DULUTH, Minnesota 55811",
    "city": "DULUTH",
    "state": "Minnesota",
    "zip": "55811",
    "lat": 46.8340371,
    "lng": -92.20443379999999
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - EAST RALEIGH 4927 NEW BERN AVE. RALEIGH, North Carolina 27610",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - EAST RALEIGH",
    "Phone Number": "919-861-6690",
    "address": "NORTHERN TOOL & EQUIPMENT - EAST RALEIGH 4927 NEW BERN AVE., RALEIGH, North Carolina 27610",
    "city": "RALEIGH",
    "state": "North Carolina",
    "zip": "27610",
    "lat": 35.7966441,
    "lng": -78.5522946
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - FARGO 4701 AGASSIZ CROSSING RD. FARGO, North Dakota 58104",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - FARGO",
    "Phone Number": "701-893-3088",
    "address": "NORTHERN TOOL & EQUIPMENT - FARGO 4701 AGASSIZ CROSSING RD., FARGO, North Dakota 58104",
    "city": "FARGO",
    "state": "North Dakota",
    "zip": "58104",
    "lat": 46.8460803,
    "lng": -96.8663591
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - HOOVER 495 SOUTHLAND DR HOOVER, Alabama 35226",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - HOOVER",
    "Phone Number": "205-202-8952",
    "address": "NORTHERN TOOL & EQUIPMENT - HOOVER 495 SOUTHLAND DR, HOOVER, Alabama 35226",
    "city": "HOOVER",
    "state": "Alabama",
    "zip": "35226",
    "lat": 33.4107032,
    "lng": -86.8077074
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - INDEPENDENCE 4023A S. NOLAND RD INDEPENDENCE, Missouri 64055",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - INDEPENDENCE",
    "Phone Number": "816-548-4013",
    "address": "NORTHERN TOOL & EQUIPMENT - INDEPENDENCE 4023A S. NOLAND RD, INDEPENDENCE, Missouri 64055",
    "city": "INDEPENDENCE",
    "state": "Missouri",
    "zip": "64055",
    "lat": 39.0481769,
    "lng": -94.4137088
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - JACKSON 5465 I-55 N, STE E JACKSON, Mississippi 39206",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - JACKSON",
    "Phone Number": "601-714-1240",
    "address": "NORTHERN TOOL & EQUIPMENT - JACKSON 5465 I-55 N, STE E JACKSON, Mississippi 39206",
    "city": "STE E JACKSON",
    "state": "Mississippi",
    "zip": "39206",
    "lat": 32.3770219,
    "lng": -90.14943559999999
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - KNOXVILLE 4315 CLINTON HWY KNOXVILLE, Tennessee 37912",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - KNOXVILLE",
    "Phone Number": "865-281-9200",
    "address": "NORTHERN TOOL & EQUIPMENT - KNOXVILLE 4315 CLINTON HWY, KNOXVILLE, Tennessee 37912",
    "city": "KNOXVILLE",
    "state": "Tennessee",
    "zip": "37912",
    "lat": 35.9986708,
    "lng": -83.96671119999999
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - MACON 4755 IVEY DR. MACON, Georgia 31206",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - MACON",
    "Phone Number": "478-476-8018",
    "address": "NORTHERN TOOL & EQUIPMENT - MACON 4755 IVEY DR., MACON, Georgia 31206",
    "city": "MACON",
    "state": "Georgia",
    "zip": "31206",
    "lat": 32.8022041,
    "lng": -83.7370376
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - MCALLEN 505 EXPRESSWAY 83 MCALLEN, Texas 78503",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - MCALLEN",
    "Phone Number": "956-467-4979",
    "address": "NORTHERN TOOL & EQUIPMENT - MCALLEN 505 EXPRESSWAY 83, MCALLEN, Texas 78503",
    "city": "MCALLEN",
    "state": "Texas",
    "zip": "78503",
    "lat": 26.1871737,
    "lng": -98.2274353
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - OCALA 3970 SW 3RD ST., UNIT 100 OCALA, Florida 34474",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - OCALA",
    "Phone Number": "352-484-1827",
    "address": "NORTHERN TOOL & EQUIPMENT - OCALA 3970 SW 3RD ST., UNIT 100 OCALA, Florida 34474",
    "city": "UNIT 100 OCALA",
    "state": "Florida",
    "zip": "34474",
    "lat": 29.1832666,
    "lng": -82.1873938
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - ST PETERS 4055 VETERANS MEMORIAL HWY ST PETERS, Missouri 63376",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - ST PETERS",
    "Phone Number": "636-486-4641",
    "address": "NORTHERN TOOL & EQUIPMENT - ST PETERS 4055 VETERANS MEMORIAL HWY ST, PETERS, Missouri 63376",
    "city": "PETERS",
    "state": "Missouri",
    "zip": "63376",
    "lat": 38.7937057,
    "lng": -90.56993639999999
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - STOCKBRIDGE 3879 HWY 138 STOCKBRIDGE, Georgia 30281",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - STOCKBRIDGE",
    "Phone Number": "770-506-9442",
    "address": "NORTHERN TOOL & EQUIPMENT - STOCKBRIDGE 3879 HWY 138, STOCKBRIDGE, Georgia 30281",
    "city": "STOCKBRIDGE",
    "state": "Georgia",
    "zip": "30281",
    "lat": 33.5561144,
    "lng": -84.26453819999999
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - TAMPA 3906A W. HILLSBOUROUGH AVE. TAMPA, Florida 33614",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - TAMPA",
    "Phone Number": "813-878-0120",
    "address": "NORTHERN TOOL & EQUIPMENT - TAMPA 3906A W. HILLSBOUROUGH AVE., TAMPA, Florida 33614",
    "city": "TAMPA",
    "state": "Florida",
    "zip": "33614",
    "lat": 27.9946166,
    "lng": -82.5083274
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - TARPON SPRINGS 44091 US HWY 19N, BLDG C, UNIT 21 TARPON SPRINGS, Florida 34689",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - TARPON SPRINGS",
    "Phone Number": "727-493-0400",
    "address": "NORTHERN TOOL & EQUIPMENT - TARPON SPRINGS 44091 US HWY 19N, BLDG C, UNIT 21 TARPON SPRINGS, Florida 34689",
    "city": "UNIT 21 TARPON SPRINGS",
    "state": "Florida",
    "zip": "34689",
    "lat": 28.1729198,
    "lng": -82.73915219999999
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - TYLER 4910 S. BROADWAY AVE. TYLER, Texas 75703",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - TYLER",
    "Phone Number": "903-705-4360",
    "address": "NORTHERN TOOL & EQUIPMENT - TYLER 4910 S. BROADWAY AVE., TYLER, Texas 75703",
    "city": "TYLER",
    "state": "Texas",
    "zip": "75703",
    "lat": 32.2957191,
    "lng": -95.2999545
  },
  {
    "Store Location": "MAVERICK'S 3950 DISCOVERY BAY DR WASILLA, Alaska 99654",
    "Store Type": "MAVERICK'S",
    "Phone Number": "907-782-7677",
    "address": "MAVERICK'S 3950 DISCOVERY BAY DR, WASILLA, Alaska 99654",
    "city": "WASILLA",
    "state": "Alaska",
    "zip": "99654",
    "lat": 61.5368311,
    "lng": -149.5296337
  },
  {
    "Store Location": "ANDY'S SMALL ENGINE 494 KRAFT ST Clarksville, Tennessee 37040",
    "Store Type": "ANDY'S SMALL ENGINE",
    "Phone Number": "931-647-4487",
    "address": "ANDY'S SMALL ENGINE 494 KRAFT ST, Clarksville, Tennessee 37040",
    "city": "Clarksville",
    "state": "Tennessee",
    "zip": "37040",
    "lat": 36.5411892,
    "lng": -87.3543253
  },
  {
    "Store Location": "RURAL KING - ELYRIA 430 OBERLIN RD ELYRIA, Ohio 44035",
    "Store Type": "RURAL KING - ELYRIA",
    "Phone Number": "440-322-0171",
    "address": "RURAL KING - ELYRIA 430 OBERLIN RD, ELYRIA, Ohio 44035",
    "city": "ELYRIA",
    "state": "Ohio",
    "zip": "44035",
    "lat": 41.3433248,
    "lng": -82.1137232
  },
  {
    "Store Location": "FLINT MOTORSPORTS 3918 EAST ORANGE RD WEST TOPSHAM, Vermont 5086",
    "Store Type": "FLINT MOTORSPORTS",
    "Phone Number": "802-439-3734",
    "address": "FLINT MOTORSPORTS 3918 EAST ORANGE RD WEST TOPSHAM, Vermont 5086,  ",
    "city": "Vermont 5086",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 44.0939327,
    "lng": -72.3491435
  },
  {
    "Store Location": "R. P. RABINE EQUIPMENT CO. INC. 46735 JEFFERSON AVE. CHESTERFIELD, Michigan 48047-5189",
    "Store Type": "R. P. RABINE EQUIPMENT CO. INC.",
    "Phone Number": "586-949-3320",
    "address": "R. P. RABINE EQUIPMENT CO. INC. 46735 JEFFERSON AVE. CHESTERFIELD, Michigan 48047-5189,  ",
    "city": "Michigan 48047-5189",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 42.6430745,
    "lng": -82.8155856
  },
  {
    "Store Location": "ACE PARTS & SERVICE DEPOT 495 OAKWOOD AVE TORONTO, Ontario M6E 2W4",
    "Store Type": "ACE PARTS & SERVICE DEPOT",
    "Phone Number": "Not found",
    "address": "ACE PARTS & SERVICE DEPOT 495 OAKWOOD AVE TORONTO, Ontario M6E 2W4,  ",
    "city": "Ontario M6E 2W4",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 43.6918452,
    "lng": -79.4402152
  },
  {
    "Store Location": "GERI KARE LLC 5007 GREAT OAKS PARKWAY INDEPENDENCE, Ohio 44131",
    "Store Type": "GERI KARE LLC",
    "Phone Number": "216-272-0220",
    "address": "GERI KARE LLC 5007 GREAT OAKS PARKWAY, INDEPENDENCE, Ohio 44131",
    "city": "INDEPENDENCE",
    "state": "Ohio",
    "zip": "44131",
    "lat": 41.3837108,
    "lng": -81.6555015
  },
  {
    "Store Location": "BLAINS FARM & FLEET 3913 EAST LINCOLN WAY STERLING, Illinois 61081",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "815-625-9028",
    "address": "BLAINS FARM & FLEET 3913 EAST LINCOLN WAY, STERLING, Illinois 61081",
    "city": "STERLING",
    "state": "Illinois",
    "zip": "61081",
    "lat": 41.8138127,
    "lng": -89.64921249999999
  },
  {
    "Store Location": "BLAINS FARM & FLEET 400 U.S. 30 MONTGOMERY, Illinois 60538",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "630-801-0232",
    "address": "BLAINS FARM & FLEET 400 U.S. 30, MONTGOMERY, Illinois 60538",
    "city": "MONTGOMERY",
    "state": "Illinois",
    "zip": "60538",
    "lat": 41.721512,
    "lng": -88.315055
  },
  {
    "Store Location": "BLAINS FARM & FLEET 4140 COLUMBUS STREET OTTAWA, Illinois 61350",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "815-433-4536",
    "address": "BLAINS FARM & FLEET 4140 COLUMBUS STREET, OTTAWA, Illinois 61350",
    "city": "OTTAWA",
    "state": "Illinois",
    "zip": "61350",
    "lat": 41.381375,
    "lng": -88.8336528
  },
  {
    "Store Location": "BLAINS FARM & FLEET 451 SOUTH WEBER ROAD ROMEOVILLE, Illinois 60446",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "815-905-3333",
    "address": "BLAINS FARM & FLEET 451 SOUTH WEBER ROAD, ROMEOVILLE, Illinois 60446",
    "city": "ROMEOVILLE",
    "state": "Illinois",
    "zip": "60446",
    "lat": 41.6089507,
    "lng": -88.1197076
  },
  {
    "Store Location": "BLAINS FARM & FLEET 4567 EAST ROCKTON ROAD ROCKTON, Illinois 61073",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "815-624-2679",
    "address": "BLAINS FARM & FLEET 4567 EAST ROCKTON ROAD, ROCKTON, Illinois 61073",
    "city": "ROCKTON",
    "state": "Illinois",
    "zip": "61073",
    "lat": 42.45408159999999,
    "lng": -89.02823819999999
  },
  {
    "Store Location": "BLAINS FARM & FLEET 4725 WEST STATE STREET ROCKFORD, Illinois 61102",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "815-964-8320",
    "address": "BLAINS FARM & FLEET 4725 WEST STATE STREET, ROCKFORD, Illinois 61102",
    "city": "ROCKFORD",
    "state": "Illinois",
    "zip": "61102",
    "lat": 42.2792392,
    "lng": -89.15943750000001
  },
  {
    "Store Location": "BLAINS FARM & FLEET 4894 COUNTY HWY YZ DODGEVILLE , Wisconsin 53533",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "608-935-2753",
    "address": "BLAINS FARM & FLEET 4894 COUNTY HWY YZ, DODGEVILLE, Wisconsin 53533",
    "city": "DODGEVILLE",
    "state": "Wisconsin",
    "zip": "53533",
    "lat": 42.9827844,
    "lng": -90.1053664
  },
  {
    "Store Location": "BLAINS FARM & FLEET 501 WEST RAWSON AVENUE OAK CREEK , Wisconsin 53154",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "414-764-6606",
    "address": "BLAINS FARM & FLEET 501 WEST RAWSON AVENUE OAK, CREEK, Wisconsin 53154",
    "city": "CREEK",
    "state": "Wisconsin",
    "zip": "53154",
    "lat": 42.914515,
    "lng": -87.91802799999999
  },
  {
    "Store Location": "Mike's Sports Outlet 65742 US Hwy 169 Hill City, Minnesota 55748",
    "Store Type": "Mike's Sports Outlet",
    "Phone Number": "218-697-2456",
    "address": "Mike's Sports Outlet 65742 US Hwy 169 Hill, City, Minnesota 55748",
    "city": "City",
    "state": "Minnesota",
    "zip": "55748",
    "lat": 46.9688734,
    "lng": -93.60197409999999
  },
  {
    "Store Location": "Roseau Ace Hardware Highway 11 W Roseau, Minnesota 56751",
    "Store Type": "Roseau Ace Hardware",
    "Phone Number": "218-463-2175",
    "address": "Roseau Ace Hardware Highway 11 W, Roseau, Minnesota 56751",
    "city": "Roseau",
    "state": "Minnesota",
    "zip": "56751",
    "lat": 48.8460926,
    "lng": -95.762766
  },
  {
    "Store Location": "Debeer Small Engine Repair 933 W Highway 14 Bypass Brookings, South Dakota 57006",
    "Store Type": "Debeer Small Engine Repair",
    "Phone Number": "605-692-9863",
    "address": "Debeer Small Engine Repair 933 W Highway 14 Bypass, Brookings, South Dakota 57006",
    "city": "Brookings",
    "state": "South Dakota",
    "zip": "57006",
    "lat": 44.32564989999999,
    "lng": -96.8184579
  },
  {
    "Store Location": "RUNNINGS FARM & FLEET 804 S.5TH ABERDEEN, South Dakota 57401",
    "Store Type": "RUNNINGS FARM & FLEET",
    "Phone Number": "605-226-2600",
    "address": "RUNNINGS FARM & FLEET 804 S.5TH, ABERDEEN, South Dakota 57401",
    "city": "ABERDEEN",
    "state": "South Dakota",
    "zip": "57401",
    "lat": 45.4568216,
    "lng": -98.4961697
  },
  {
    "Store Location": "Big R Gibson City 623 E First St Gibson City, Illinois 60936",
    "Store Type": "Big R Gibson City",
    "Phone Number": "217-784-7825",
    "address": "Big R Gibson City 623 E First St Gibson, City, Illinois 60936",
    "city": "City",
    "state": "Illinois",
    "zip": "60936",
    "lat": 40.4565637,
    "lng": -88.3662756
  },
  {
    "Store Location": "Nelsons Airtool Service 709 N FAIR Marion, Illinois 62959",
    "Store Type": "Nelsons Airtool Service",
    "Phone Number": "618-997-2101",
    "address": "Nelsons Airtool Service 709 N FAIR, Marion, Illinois 62959",
    "city": "Marion",
    "state": "Illinois",
    "zip": "62959",
    "lat": 37.735915,
    "lng": -88.9152838
  },
  {
    "Store Location": "ABC KEROSENE REPAIR SERVICES 650 A CLIFTON PARK CENTER ROAD CLIFTON PARK, New York 12065",
    "Store Type": "ABC KEROSENE REPAIR SERVICES",
    "Phone Number": "518-441-2855",
    "address": "ABC KEROSENE REPAIR SERVICES 650 A CLIFTON PARK CENTER ROAD CLIFTON, PARK, New York 12065",
    "city": "PARK",
    "state": "New York",
    "zip": "12065",
    "lat": 42.8582347,
    "lng": -73.8196839
  },
  {
    "Store Location": "Farm City Supply 702 Minnesota Ave Breckenridge, Minnesota 56520",
    "Store Type": "Farm City Supply",
    "Phone Number": "218-643-8401",
    "address": "Farm City Supply 702 Minnesota Ave, Breckenridge, Minnesota 56520",
    "city": "Breckenridge",
    "state": "Minnesota",
    "zip": "56520",
    "lat": 46.2637284,
    "lng": -96.584756
  },
  {
    "Store Location": "EBERLE SPECIALTY ELECTRIC 810 2ND AVE EDGEMONT, South Dakota 57735",
    "Store Type": "EBERLE SPECIALTY ELECTRIC",
    "Phone Number": "605-662-6276",
    "address": "EBERLE SPECIALTY ELECTRIC 810 2ND AVE, EDGEMONT, South Dakota 57735",
    "city": "EDGEMONT",
    "state": "South Dakota",
    "zip": "57735",
    "lat": 43.2961256,
    "lng": -103.8258135
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - AUSTIN 804 E. BRAKER LN., STE A AUSTIN, Texas 78753",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - AUSTIN",
    "Phone Number": "512-961-4171",
    "address": "NORTHERN TOOL & EQUIPMENT - AUSTIN 804 E. BRAKER LN., STE A AUSTIN, Texas 78753",
    "city": "STE A AUSTIN",
    "state": "Texas",
    "zip": "78753",
    "lat": 30.3774252,
    "lng": -97.6743958
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - BLAINE 9411 ULYSSES ST. NE BLAINE, Minnesota 55434",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - BLAINE",
    "Phone Number": "763-783-5746",
    "address": "NORTHERN TOOL & EQUIPMENT - BLAINE 9411 ULYSSES ST. NE, BLAINE, Minnesota 55434",
    "city": "BLAINE",
    "state": "Minnesota",
    "zip": "55434",
    "lat": 45.14115,
    "lng": -93.2364084
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - BURLESON 9621 S. FWY FORT WORTH, Texas 76140",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - BURLESON",
    "Phone Number": "817-293-5600",
    "address": "NORTHERN TOOL & EQUIPMENT - BURLESON 9621 S. FWY FORT, WORTH, Texas 76140",
    "city": "WORTH",
    "state": "Texas",
    "zip": "76140",
    "lat": 32.6154424,
    "lng": -97.3204664
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - CHATTANOOGA 7658 LEE HWY. CHATTANOOGA, Tennessee 37421",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - CHATTANOOGA",
    "Phone Number": "423-510-0646",
    "address": "NORTHERN TOOL & EQUIPMENT - CHATTANOOGA 7658 LEE HWY., CHATTANOOGA, Tennessee 37421",
    "city": "CHATTANOOGA",
    "state": "Tennessee",
    "zip": "37421",
    "lat": 35.0596982,
    "lng": -85.1337556
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - COLFAX 8521 TRIAD DR. COLFAX, North Carolina 27235",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - COLFAX",
    "Phone Number": "336-996-8655",
    "address": "NORTHERN TOOL & EQUIPMENT - COLFAX 8521 TRIAD DR., COLFAX, North Carolina 27235",
    "city": "COLFAX",
    "state": "North Carolina",
    "zip": "27235",
    "lat": 36.0938052,
    "lng": -79.99467650000001
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - EL PASO 6990 GATEWAY BLVD E. EL PASO, Texas 79915",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - EL PASO",
    "Phone Number": "915-613-1348",
    "address": "NORTHERN TOOL & EQUIPMENT - EL PASO 6990 GATEWAY BLVD E. EL, PASO, Texas 79915",
    "city": "PASO",
    "state": "Texas",
    "zip": "79915",
    "lat": 31.7715865,
    "lng": -106.3794106
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - FT WORTH 8080 W. FWY WHITE SETTLEMENT, Texas 76108",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - FT WORTH",
    "Phone Number": "817-367-2464",
    "address": "NORTHERN TOOL & EQUIPMENT - FT WORTH 8080 W. FWY WHITE, SETTLEMENT, Texas 76108",
    "city": "SETTLEMENT",
    "state": "Texas",
    "zip": "76108",
    "lat": 32.7389163,
    "lng": -97.45705269999999
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - GARLAND 584 W I-30 @ BELT LINE RD. GARLAND, Texas 75043",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - GARLAND",
    "Phone Number": "972-226-6906",
    "address": "NORTHERN TOOL & EQUIPMENT - GARLAND 584 W I-30 @ BELT LINE RD., GARLAND, Texas 75043",
    "city": "GARLAND",
    "state": "Texas",
    "zip": "75043",
    "lat": 32.8376598,
    "lng": -96.59822600000001
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - GULF FREEWAY 7994 BELLFORT AVE. HOUSTON, Texas 77061",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - GULF FREEWAY",
    "Phone Number": "713-643-2342",
    "address": "NORTHERN TOOL & EQUIPMENT - GULF FREEWAY 7994 BELLFORT AVE., HOUSTON, Texas 77061",
    "city": "HOUSTON",
    "state": "Texas",
    "zip": "77061",
    "lat": 29.6741794,
    "lng": -95.267772
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - MARIETTA N. 41 PLAZA, 119 COBB PKWY N. MARIETTA, Georgia 30062",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - MARIETTA",
    "Phone Number": "770-590-1114",
    "address": "NORTHERN TOOL & EQUIPMENT - MARIETTA N. 41 PLAZA, 119 COBB PKWY N. MARIETTA, Georgia 30062",
    "city": "119 COBB PKWY N. MARIETTA",
    "state": "Georgia",
    "zip": "30062",
    "lat": 33.9540441,
    "lng": -84.5239411
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - NORTH CHARLESTON 5900 RIVERS AVE., STE A CHARLESTON, South Carolina 29406",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - NORTH CHARLESTON",
    "Phone Number": "843-747-7578",
    "address": "NORTHERN TOOL & EQUIPMENT - NORTH CHARLESTON 5900 RIVERS AVE., STE A CHARLESTON, South Carolina 29406",
    "city": "STE A CHARLESTON",
    "state": "South Carolina",
    "zip": "29406",
    "lat": 32.9057547,
    "lng": -80.0183844
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - NORTH CHARLOTTE 9401 STATESVILLE RD CHARLOTTE, North Carolina 28269",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - NORTH CHARLOTTE",
    "Phone Number": "704-494-0980",
    "address": "NORTHERN TOOL & EQUIPMENT - NORTH CHARLOTTE 9401 STATESVILLE RD, CHARLOTTE, North Carolina 28269",
    "city": "CHARLOTTE",
    "state": "North Carolina",
    "zip": "28269",
    "lat": 35.349824,
    "lng": -80.842018
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - ODESSA 6151 E HWY 191 ODESSA, Texas 79762",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - ODESSA",
    "Phone Number": "432-614-5500",
    "address": "NORTHERN TOOL & EQUIPMENT - ODESSA 6151 E HWY 191, ODESSA, Texas 79762",
    "city": "ODESSA",
    "state": "Texas",
    "zip": "79762",
    "lat": 31.8984817,
    "lng": -102.3154177
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - OMAHA 7202 PACIFIC ST OMAHA, Nebraska 68114",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - OMAHA",
    "Phone Number": "402-255-6766",
    "address": "NORTHERN TOOL & EQUIPMENT - OMAHA 7202 PACIFIC ST, OMAHA, Nebraska 68114",
    "city": "OMAHA",
    "state": "Nebraska",
    "zip": "68114",
    "lat": 41.2493124,
    "lng": -96.0246873
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - ORLANDO CENTRAL 795 W. SAND LAKE RD. ORLANDO, Florida 32809",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - ORLANDO CENTRAL",
    "Phone Number": "407-856-5612",
    "address": "NORTHERN TOOL & EQUIPMENT - ORLANDO CENTRAL 795 W. SAND LAKE RD., ORLANDO, Florida 32809",
    "city": "ORLANDO",
    "state": "Florida",
    "zip": "32809",
    "lat": 28.4515772,
    "lng": -81.3867671
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - RICHMOND 8400 MIDLOTHIAN TPKE RICHMOND, Virginia 23235",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - RICHMOND",
    "Phone Number": "804-560-0187",
    "address": "NORTHERN TOOL & EQUIPMENT - RICHMOND 8400 MIDLOTHIAN TPKE, RICHMOND, Virginia 23235",
    "city": "RICHMOND",
    "state": "Virginia",
    "zip": "23235",
    "lat": 37.4966667,
    "lng": -77.5530556
  },
  {
    "Store Location": "NORTHERN TOOL & EQUIPMENT - WICHITA 6610 W. KELLOGG DR. WICHITA, Kansas 67209",
    "Store Type": "NORTHERN TOOL & EQUIPMENT - WICHITA",
    "Phone Number": "316-854-9422",
    "address": "NORTHERN TOOL & EQUIPMENT - WICHITA 6610 W. KELLOGG DR., WICHITA, Kansas 67209",
    "city": "WICHITA",
    "state": "Kansas",
    "zip": "67209",
    "lat": 37.6750041,
    "lng": -97.41914179999999
  },
  {
    "Store Location": "JENCIN REPAIR SERVICES Call for service. COLUMBUS, New Jersey 8022",
    "Store Type": "JENCIN REPAIR SERVICES",
    "Phone Number": "609-802-5554",
    "address": "JENCIN REPAIR SERVICES Call for service. COLUMBUS, New Jersey 8022,  ",
    "city": "New Jersey 8022",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.0727889,
    "lng": -74.7206894
  },
  {
    "Store Location": "RURAL KING - COSHOCTON 779 S. SECOND STREET COSCHOCTON, Ohio 43812",
    "Store Type": "RURAL KING - COSHOCTON",
    "Phone Number": "740-622-0772",
    "address": "RURAL KING - COSHOCTON 779 S. SECOND STREET, COSCHOCTON, Ohio 43812",
    "city": "COSCHOCTON",
    "state": "Ohio",
    "zip": "43812",
    "lat": 40.2638906,
    "lng": -81.8717765
  },
  {
    "Store Location": "RURAL KING - GALLIPOLIS 7 OHIO RIVER PLAZA GALLIPOLIS, Ohio 45631",
    "Store Type": "RURAL KING - GALLIPOLIS",
    "Phone Number": "740-446-7713",
    "address": "RURAL KING - GALLIPOLIS 7 OHIO RIVER PLAZA, GALLIPOLIS, Ohio 45631",
    "city": "GALLIPOLIS",
    "state": "Ohio",
    "zip": "45631",
    "lat": 38.8240741,
    "lng": -82.1684738
  },
  {
    "Store Location": "D & J SMALL ENGINE 7479 LEMHI ST BOISE, Idaho 83709",
    "Store Type": "D & J SMALL ENGINE",
    "Phone Number": "208-362-2122",
    "address": "D & J SMALL ENGINE 7479 LEMHI ST, BOISE, Idaho 83709",
    "city": "BOISE",
    "state": "Idaho",
    "zip": "83709",
    "lat": 43.5831299,
    "lng": -116.2751973
  },
  {
    "Store Location": "AREA RENT-ALLS INC 7900 N FEDERAL BLVD WESTMINSTER, 80030",
    "Store Type": "AREA RENT-ALLS INC",
    "Phone Number": "303-429-3589",
    "address": "AREA RENT-ALLS INC 7900 N FEDERAL BLVD WESTMINSTER, ,  80030",
    "city": "Unknown",
    "state": "Unknown",
    "zip": "80030",
    "lat": 39.8402349,
    "lng": -105.0244004
  },
  {
    "Store Location": "EARL'S REPAIR 7900 HWY 71 W. AUSTIN, Texas 78735",
    "Store Type": "EARL'S REPAIR",
    "Phone Number": "512-288-1334",
    "address": "EARL'S REPAIR 7900 HWY 71 W., AUSTIN, Texas 78735",
    "city": "AUSTIN",
    "state": "Texas",
    "zip": "78735",
    "lat": 30.2443644,
    "lng": -97.88385099999999
  },
  {
    "Store Location": "BLAINS FARM & FLEET 8535 NORTHWEST BOULEVARD DAVENPORT, Iowa 52806",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "563-391-4847",
    "address": "BLAINS FARM & FLEET 8535 NORTHWEST BOULEVARD, DAVENPORT, Iowa 52806",
    "city": "DAVENPORT",
    "state": "Iowa",
    "zip": "52806",
    "lat": 41.6074679,
    "lng": -90.62790269999999
  },
  {
    "Store Location": "BLAINS FARM & FLEET 5900 JOHN DEERE ROAD MOLINE, Illinois 61265",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "309-797-8183",
    "address": "BLAINS FARM & FLEET 5900 JOHN DEERE ROAD, MOLINE, Illinois 61265",
    "city": "MOLINE",
    "state": "Illinois",
    "zip": "61265",
    "lat": 41.4698552,
    "lng": -90.4585331
  },
  {
    "Store Location": "BLAINS FARM & FLEET 629 S. RANDALL ROAD ELGIN, Illinois 60123",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "847-289-8787",
    "address": "BLAINS FARM & FLEET 629 S. RANDALL ROAD, ELGIN, Illinois 60123",
    "city": "ELGIN",
    "state": "Illinois",
    "zip": "60123",
    "lat": 42.0180442,
    "lng": -88.3347103
  },
  {
    "Store Location": "BLAINS FARM & FLEET 6674 LOGAN AVENUE BELVIDERE, Illinois 61008",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "815-544-3282",
    "address": "BLAINS FARM & FLEET 6674 LOGAN AVENUE, BELVIDERE, Illinois 61008",
    "city": "BELVIDERE",
    "state": "Illinois",
    "zip": "61008",
    "lat": 42.25047989999999,
    "lng": -88.80701359999999
  },
  {
    "Store Location": "BLAINS FARM & FLEET 7300 EAST RIVERSIDE BOULEVARD LOVES PARK, Illinois 61111",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "815-633-0869",
    "address": "BLAINS FARM & FLEET 7300 EAST RIVERSIDE BOULEVARD LOVES, PARK, Illinois 61111",
    "city": "PARK",
    "state": "Illinois",
    "zip": "61111",
    "lat": 42.32173,
    "lng": -88.97500529999999
  },
  {
    "Store Location": "BLAINS FARM & FLEET 600 HOMETOWN CIRCLE VERONA, Wisconsin 53593",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "608-848-4968",
    "address": "BLAINS FARM & FLEET 600 HOMETOWN CIRCLE, VERONA, Wisconsin 53593",
    "city": "VERONA",
    "state": "Wisconsin",
    "zip": "53593",
    "lat": 42.9958684,
    "lng": -89.5218931
  },
  {
    "Store Location": "BLAINS FARM & FLEET 8401 DURAND AVENUE STURTEVANT , Wisconsin 53177",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "262-886-2757",
    "address": "BLAINS FARM & FLEET 8401 DURAND AVENUE, STURTEVANT, Wisconsin 53177",
    "city": "STURTEVANT",
    "state": "Wisconsin",
    "zip": "53177",
    "lat": 42.6968527,
    "lng": -87.8872754
  },
  {
    "Store Location": "BLAINS FARM & FLEET 9438 WISCONSIN 16 ONALASKA , Wisconsin 54650",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "608-781-3130",
    "address": "BLAINS FARM & FLEET 9438 WISCONSIN 16, ONALASKA, Wisconsin 54650",
    "city": "ONALASKA",
    "state": "Wisconsin",
    "zip": "54650",
    "lat": 43.8758406,
    "lng": -91.18849
  },
  {
    "Store Location": "BLAINS FARM & FLEET 879 MALL DRIVE PORTAGE, Michigan 49024",
    "Store Type": "BLAINS FARM & FLEET",
    "Phone Number": "269-324-6398",
    "address": "BLAINS FARM & FLEET 879 MALL DRIVE, PORTAGE, Michigan 49024",
    "city": "PORTAGE",
    "state": "Michigan",
    "zip": "49024",
    "lat": 42.2227597,
    "lng": -85.59881480000001
  },
  {
    "Store Location": "Suburban Propane 915 Delancy Street Newark, New Jersey 7105",
    "Store Type": "Suburban Propane",
    "Phone Number": "973-817-7241",
    "address": "Suburban Propane 915 Delancy Street Newark, New Jersey 7105,  ",
    "city": "New Jersey 7105",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 40.70682430000001,
    "lng": -74.1315315
  },
  {
    "Store Location": "SHANE'S A/C 606 RIVERSIDE DR ANGLETON, Texas 77515",
    "Store Type": "SHANE'S A/C",
    "Phone Number": "979-418-0505",
    "address": "SHANE'S A/C 606 RIVERSIDE DR, ANGLETON, Texas 77515",
    "city": "ANGLETON",
    "state": "Texas",
    "zip": "77515",
    "lat": 29.1116155,
    "lng": -95.3638802
  },
  {
    "Store Location": "LEHMAN'S FARM & HOME SUPPLY ROUTE 26 DENMARK, New York 13631",
    "Store Type": "LEHMAN'S FARM & HOME SUPPLY",
    "Phone Number": "315-493-1151",
    "address": "LEHMAN'S FARM & HOME SUPPLY ROUTE 26, DENMARK, New York 13631",
    "city": "DENMARK",
    "state": "New York",
    "zip": "13631",
    "lat": 43.9173063,
    "lng": -75.5975296
  },
  {
    "Store Location": "Hoover Technology Solutions R.R. 1 Kensinger Rd Martinsburg, Pennsylvania 16662",
    "Store Type": "Hoover Technology Solutions",
    "Phone Number": "814-937-3741",
    "address": "Hoover Technology Solutions R.R. 1 Kensinger Rd, Martinsburg, Pennsylvania 16662",
    "city": "Martinsburg",
    "state": "Pennsylvania",
    "zip": "16662",
    "lat": 40.2912937,
    "lng": -78.3687432
  },
  {
    "Store Location": "Tractor Supply 100 DEKALB PLAZA BLVD SOUTHWEST FORT PAYNE, Alabama 35967",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-845-4164",
    "address": "100 DEKALB PLAZA BLVD SOUTHWEST FORT, PAYNE, Alabama 35967",
    "city": "PAYNE",
    "state": "Alabama",
    "zip": "35967",
    "lat": 34.4307834,
    "lng": -85.73341239999999
  },
  {
    "Store Location": "Tractor Supply 1001 WOODFIN LN CLANTON, Alabama 35045",
    "Store Type": "Tractor Supply",
    "Phone Number": "205-280-8782",
    "address": "1001 WOODFIN LN, CLANTON, Alabama 35045",
    "city": "CLANTON",
    "state": "Alabama",
    "zip": "35045",
    "lat": 32.8157286,
    "lng": -86.6065211
  },
  {
    "Store Location": "Tractor Supply 1010 INDUSTRIAL PKWY SARALAND, Alabama 36571",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-675-6804",
    "address": "1010 INDUSTRIAL PKWY, SARALAND, Alabama 36571",
    "city": "SARALAND",
    "state": "Alabama",
    "zip": "36571",
    "lat": 30.8030585,
    "lng": -88.0947326
  },
  {
    "Store Location": "Tractor Supply 1021 SOUTH EUFAULA AVE EUFAULA, Alabama 36027",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-687-0310",
    "address": "1021 SOUTH EUFAULA AVE, EUFAULA, Alabama 36027",
    "city": "EUFAULA",
    "state": "Alabama",
    "zip": "36027",
    "lat": 31.8791998,
    "lng": -85.146559
  },
  {
    "Store Location": "Tractor Supply 1067 NORTH BRINDLEE MOUNTAIN PKWY ARAB, Alabama 35016",
    "Store Type": "Tractor Supply",
    "Phone Number": "256-586-5577",
    "address": "1067 NORTH BRINDLEE MOUNTAIN PKWY, ARAB, Alabama 35016",
    "city": "ARAB",
    "state": "Alabama",
    "zip": "35016",
    "lat": 34.3346801,
    "lng": -86.5051028
  },
  {
    "Store Location": "Tractor Supply 108B MCMEANS AVE BAY MINETTE, Alabama 36507",
    "Store Type": "Tractor Supply",
    "Phone Number": "251-937-5611",
    "address": "108B MCMEANS AVE BAY, MINETTE, Alabama 36507",
    "city": "MINETTE",
    "state": "Alabama",
    "zip": "36507",
    "lat": 30.880098,
    "lng": -87.783232
  },
  {
    "Store Location": "Tractor Supply 111 SOUTHLAND VILLAGE TROY, Alabama 36079",
    "Store Type": "Tractor Supply",
    "Phone Number": "334-808-9304",
    "address": "111 SOUTHLAND VILLAGE, TROY, Alabama 36079",
    "city": "TROY",
    "state": "Alabama",
    "zip": "36079",
    "lat": 31.784863,
    "lng": -85.9657944
  },
  {
    "Store Location": "Caplinger Sales & Service 644 W MAIN STREET Blanchester, Ohio 45107",
    "Store Type": "Caplinger Sales & Service",
    "Phone Number": "937-783-8330",
    "address": "Caplinger Sales & Service 644 W MAIN STREET, Blanchester, Ohio 45107",
    "city": "Blanchester",
    "state": "Ohio",
    "zip": "45107",
    "lat": 39.2911376,
    "lng": -83.9978788
  },
  {
    "Store Location": "Express Pump Repair 308 Old Dairy Road Wilmington, North Carolina 28405",
    "Store Type": "Express Pump Repair",
    "Phone Number": "910-791-7277",
    "address": "Express Pump Repair 308 Old Dairy Road, Wilmington, North Carolina 28405",
    "city": "Wilmington",
    "state": "North Carolina",
    "zip": "28405",
    "lat": 34.262115,
    "lng": -77.84001599999999
  },
  {
    "Store Location": "Gas Production Company 8512 E. Howard City-Edmore Rd. Vestaburg, 48891",
    "Store Type": "Gas Production Company",
    "Phone Number": "989-268-5079",
    "address": "Gas Production Company 8512 E. Howard City-Edmore Rd. Vestaburg, ,  48891",
    "city": "Unknown",
    "state": "Unknown",
    "zip": "48891",
    "lat": 43.40800489999999,
    "lng": -84.9149594
  },
  {
    "Store Location": "RIGHTWAY PLUMBING & PLUMBING 836 LUXSTONE SQUARE SW AIRDRIE, Alberta T4B 3L4",
    "Store Type": "RIGHTWAY PLUMBING & PLUMBING",
    "Phone Number": "403-968-6630",
    "address": "RIGHTWAY PLUMBING & PLUMBING 836 LUXSTONE SQUARE SW AIRDRIE, Alberta T4B 3L4,  ",
    "city": "Alberta T4B 3L4",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 51.2717323,
    "lng": -114.0230897
  },
  {
    "Store Location": "DSF Mechanical 9428 CLAY ST. MISSION, British Columbia V4S 1G2",
    "Store Type": "DSF Mechanical",
    "Phone Number": "604-803-2959",
    "address": "DSF Mechanical 9428 CLAY ST. MISSION, British Columbia V4S 1G2,  ",
    "city": "British Columbia V4S 1G2",
    "state": "Unknown",
    "zip": "Unknown",
    "lat": 49.1738381,
    "lng": -122.3379641
  },
  {
    "Store Location": "FAIRBANKS AERO SERVICES 1915 ADA ST. FAIRBANKS, Alaska 99709",
    "Store Type": "FAIRBANKS AERO SERVICES",
    "Phone Number": "907-479-6666",
    "address": "FAIRBANKS AERO SERVICES 1915 ADA ST., FAIRBANKS, Alaska 99709",
    "city": "FAIRBANKS",
    "state": "Alaska",
    "zip": "99709",
    "lat": 64.8304393,
    "lng": -147.7838742
  },
  {
    "Store Location": "Ricks Power Plus 1100 Duerer St. Egg Harbor City, New Jersey 08215",
    "Store Type": "Ricks Power Plus",
    "Phone Number": "609-965-4923",
    "address": "Ricks Power Plus 1100 Duerer St. Egg Harbor, City, New Jersey 08215",
    "city": "City",
    "state": "New Jersey",
    "zip": "08215",
    "lat": 39.5069516,
    "lng": -74.61597069999999
  },
  {
    "Store Location": "Belmont Hardware 131 Main St Belmont, 03220",
    "Store Type": "Belmont Hardware",
    "Phone Number": "603-267-8510",
    "address": "Belmont Hardware 131 Main St Belmont, ,  03220",
    "city": "Unknown",
    "state": "Unknown",
    "zip": "03220",
    "lat": 43.44368559999999,
    "lng": -71.4809842
  },
  {
    "Store Location": "Spears Furniture 641 Harrison Street Pawnee, Oklahoma 74058",
    "Store Type": "Spears Furniture",
    "Phone Number": "918-762-3174",
    "address": "Spears Furniture 641 Harrison Street, Pawnee, Oklahoma 74058",
    "city": "Pawnee",
    "state": "Oklahoma",
    "zip": "74058",
    "lat": 36.3377675,
    "lng": -96.8050403
  },
  {
    "Store Location": "Tools Plus 2096 CR 1800 E ARTHUR, Illinois 61911",
    "Store Type": "Tools Plus",
    "Phone Number": "217-543-2404",
    "address": "Tools Plus 2096 CR 1800 E, ARTHUR, Illinois 61911",
    "city": "ARTHUR",
    "state": "Illinois",
    "zip": "61911",
    "lat": 39.7076555,
    "lng": -88.4729164
  },
  {
    "Store Location": "Propane Lane 740 36th St SE Wyoming, Michigan 49548",
    "Store Type": "Propane Lane",
    "Phone Number": "616-600-1011",
    "address": "Propane Lane 740 36th St SE, Wyoming, Michigan 49548",
    "city": "Wyoming",
    "state": "Michigan",
    "zip": "49548",
    "lat": 42.8979223,
    "lng": -85.64826389999999
  },
  {
    "Store Location": "Propane Lane 4564 West River Dr. Comstock Park, Michigan 49321",
    "Store Type": "Propane Lane",
    "Phone Number": "616-724-4298",
    "address": "Propane Lane 4564 West River Dr. Comstock, Park, Michigan 49321",
    "city": "Park",
    "state": "Michigan",
    "zip": "49321",
    "lat": 43.0457196,
    "lng": -85.6567778
  },
  {
    "Store Location": "Hot Wash Atlanta 2125 Mountain 2nd Blvd. Tucker, Georgia 30084",
    "Store Type": "Hot Wash Atlanta",
    "Phone Number": "770-939-2210",
    "address": "Hot Wash Atlanta 2125 Mountain 2nd Blvd., Tucker, Georgia 30084",
    "city": "Tucker",
    "state": "Georgia",
    "zip": "30084",
    "lat": 33.8461232,
    "lng": -84.20036569999999
  },
  {
    "Store Location": "The Stove Center 1220 Rte. 28A Cataumet, Massachusetts 02534",
    "Store Type": "The Stove Center",
    "Phone Number": "503-392-9231",
    "address": "The Stove Center 1220 Rte. 28A, Cataumet, Massachusetts 02534",
    "city": "Cataumet",
    "state": "Massachusetts",
    "zip": "02534",
    "lat": 41.6671159,
    "lng": -70.6028511
  }
];